/******/ (() => { // webpackBootstrap
    /******/ 	var __webpack_modules__ = ({

        /***/ 1983:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";


            __webpack_require__(6266);

            __webpack_require__(990);

            __webpack_require__(911);

            __webpack_require__(4160);

            __webpack_require__(6197);

            __webpack_require__(6728);

            __webpack_require__(4039);

            __webpack_require__(3568);

            __webpack_require__(8051);

            __webpack_require__(8250);

            __webpack_require__(5434);

            __webpack_require__(4952);

            __webpack_require__(6337);

            __webpack_require__(5666);

            /***/ }),

        /***/ 3452:
        /***/ (() => {

            var main = document.querySelector('main');

            if (document.body.classList.contains('sufix-about-us')) {
                var openVideoPopup = function openVideoPopup() {
                    videoPopup.classList.add('is-open');
                    document.body.classList.add('overlay');
                };

                var closeVideoPopup = function closeVideoPopup() {
                    videoPopup.classList.remove('is-open');
                    document.body.classList.remove('overlay');
                };

                main.style.paddingTop = '0px';
                var playVideoButtons = document.querySelectorAll('.play-video-button'),
                    videoPopup = document.querySelector('.video-popup'),
                    closePopupButton = document.querySelectorAll('.close-popup');
                playVideoButtons.forEach(function (button) {
                    return button.addEventListener('click', openVideoPopup);
                });
                closePopupButton.forEach(function (button) {
                    return button.addEventListener('click', closeVideoPopup);
                });
            }

            /***/ }),

        /***/ 7736:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            /* provided dependency */ var $ = __webpack_require__(5825);
//Account Logic
            var accountContent = document.querySelector('#account .account-content');
            var accountMenuItem = document.querySelectorAll('#account [data-url]');
            var accountMenuNavItem = document.querySelectorAll('#account .account-menu-item');
            var accountContentBlock = document.querySelectorAll('#account .account-block');
            var accountPopup = document.querySelectorAll('.account.popup');
            var loginPopup = document.querySelector('.login-popup');
            var loginClose = document.querySelector('.login-close');
            var btnSignIt = document.querySelector('.button.form-submit.button-log.primary');
            var addAddressLink = document.querySelector('.btn.primary.add-address-link');
            var addressNewToggle = document.querySelector('.address-new-toggle');

            function clickButAcc(selects, button) {
                selects.forEach(function (item) {
                    item.classList.remove('same-as-selected');

                    if (item.dataset.handle == button.dataset.url) {
                        item.parentElement.previousElementSibling.innerHTML = item.firstElementChild.nextElementSibling.innerHTML;
                        item.classList.add('same-as-selected');
                        item.firstElementChild.checked = true;
                    }
                });
            }

            if (document.body.classList.contains('template-customers')) {
                var orderButton = document.querySelector('.orders-button'),
                    addressButton = document.querySelector('.address-button'),
                    selects = document.querySelectorAll('.account .select__item');
                orderButton.addEventListener('click', function () {
                    clickButAcc(selects, orderButton);
                });
                addressButton.addEventListener('click', function () {
                    clickButAcc(selects, addressButton);
                });
            }

            if (document.body.classList.contains('template-account')) {
                addressNewToggle.addEventListener('click', function () {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 0);
                });
                addAddressLink.addEventListener('click', function () {
                    $('html, body').animate({
                        scrollTop: 0
                    }, 0);
                });
            }

            var appendError = document.querySelector('#CustomerLoginForm');
            btnSignIt.addEventListener('click', function () {
                window.localStorage.clear();
            });
            document.addEventListener('DOMContentLoaded', function () {
                if (window.localStorage.error) {
                    var span = document.createElement('span');
                    span.classList.add('error-span');
                    span.innerHTML = 'Incorrect email or password.';
                    appendError.prepend(span);
                }
            });
            accountPopup.forEach(function (item) {
                item.addEventListener('click', function () {
                    loginPopup.classList.add('is-open');
                    document.body.classList.add('overlay');
                });
            });
            loginClose.addEventListener('click', function () {
                loginPopup.classList.remove('is-open');
                document.body.classList.remove('overlay');
            });

            function removeSiblingsClass() {
                var elements = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var nameClass = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'active';
                elements.forEach(function (el) {
                    el.classList.remove(nameClass);
                });
            }

            accountMenuItem.forEach(function (item) {
                item.addEventListener('click', function () {
                    changeAccountUrl(item);
                });
            });
            reloadAccount(window.location.href);

            function reloadAccount(url) {
                $.ajax({
                    type: 'GET',
                    url: url,
                    data: {},
                    complete: function complete(data) {
                        $('.preloader-element').css('display', 'none');
                        checkAccountUrl(url);
                        history.pushState({
                            page: url
                        }, url, url);
                    }
                });
            }

            function addActiveNavItem(url, items) {
                var urlString = window.location.search,
                    parseUrlS = new URLSearchParams(urlString);
                var parseUrl = '';

                if (parseUrlS.get('page')) {
                    parseUrl = url.split('?')[1].replace("&page=".concat(parseUrlS.get('page')), '');
                } else {
                    parseUrl = url.split('?')[1];
                }

                items.forEach(function (tab) {
                    var tabName = tab.getAttribute('data-url');
                    var blockName = tab.getAttribute('data-name');

                    if (parseUrl === tabName || parseUrl === blockName) {
                        removeSiblingsClass(items);
                        tab.classList.add('active');
                    }
                });
            }

            function checkAccountUrl(url) {
                addActiveNavItem(url, accountMenuNavItem);
                addActiveNavItem(url, accountContentBlock);
            }

            function changeAccountUrl(item) {
                var itemUrl = "?".concat(item.getAttribute('data-url'));
                addActiveNavItem(itemUrl, accountMenuNavItem);
                removeSiblingsClass(accountContentBlock);
                $('.preloader-element').css('display', 'block');
                reloadAccount(itemUrl);
            }

            var selectCustom = document.querySelectorAll('.select-items');
            var accountSidebarMobile = document.querySelector('.account-sidebar-mobile');
            var selectItem;
            document.addEventListener('DOMContentLoaded', function () {
                if (document.body.classList.contains('template-customers')) {
                    selectItem = document.querySelectorAll('.select__item');
                    selectCustom.forEach(function (element) {
                        element.addEventListener('click', function () {
                            var eventChange = new Event('change');
                            accountSidebarMobile.dispatchEvent(eventChange);
                        });
                    });
                    selectItem.forEach(function (item) {
                        item.addEventListener('click', function () {
                            removeActiveClass(selectItem);
                            item.classList.add('same-as-selected');
                            item.firstElementChild.checked = true;
                            item.parentElement.previousElementSibling.innerHTML = item.firstElementChild.nextElementSibling.innerHTML;
                        });
                    });
                }
            });

            function removeActiveClass(mass) {
                mass.forEach(function (element) {
                    element.classList.remove('same-as-selected');
                });
            }

            window.addEventListener('DOMContentLoaded', function () {
                if (!window.location.href.includes('?')) {
                    var checkedText = window.location.pathname.substr(1);
                    document.querySelectorAll('.select__item').forEach(function (item) {

                        if (item.dataset.handle == checkedText) {
                            item.firstElementChild.checked = true;
                            document.querySelector('.select-selected').innerHTML = item.firstElementChild.nextElementSibling.innerHTML;
                        }
                    });
                } else {
                    var _checkedText = window.location.href.substr(window.location.href.indexOf('?') + 1);

                    document.querySelectorAll('.select__item').forEach(function (item) {
                        if (item.dataset.handle == _checkedText) {
                            item.firstElementChild.checked = true;
                            item.classList.add('same-as-selected');
                            document.querySelector('.select-selected').innerHTML = item.firstElementChild.nextElementSibling.innerHTML;
                        }
                    });
                }
            });

            try {
                accountSidebarMobile.addEventListener('change', function () {
                    var n = this.value;
                    var temp = '?' + n;
                    $('.preloader-element').css('display', 'block');
                    reloadAccount(temp);
                });
            } catch (_unused) {}

            /***/ }),

        /***/ 8682:
        /***/ (() => {

            if (document.body.classList.contains('template-article')) {
                var allImages = document.querySelectorAll('.article-content .container img');
                allImages.forEach(function (item) {
                    var altAttributeValue = item.getAttribute('alt');
                    var imgContainer = item.parentElement;
                    console.log('img container:', imgContainer);
                    console.log('alt atribute:', altAttributeValue);

                    if (altAttributeValue === 'full') {
                        imgContainer.classList.add('img-wrapper');
                    } else if (altAttributeValue === 'half') {
                        imgContainer.classList.add('img-half-wrapper');
                    }
                });
            }

            /***/ }),

        /***/ 4128:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            /* provided dependency */ var $ = __webpack_require__(5825);
            var filterButton = document.querySelectorAll('.blog-category [data-url]');
            var saveCategory = window.location.pathname;


            function insertQueryParam(value) {
                const url = new URL(window.location);
                url.searchParams.set('tags', value);
                window.history.pushState(null, '', url.toString());
            }


            function blogPostsReload(url) {
                insertQueryParam(url);

                $('.filter-blocks .filter-button').length > 0 && $('.filter-blocks .filter-button').each(function () {
                    if (window.location.search.includes($(this).attr('data-url'))) {
                        $('.filter-blocks .filter-button').removeClass('active');
                        $(this).addClass('active');
                    }
                });

                if ($('.blog-list-item').length > 0) {
                    $('.blog-list-item').each(function () {
                        const tags = $(this).attr('data-tags').split(',').map(item => item.replaceAll(' ', '-'));
                        const param = window.location.search.replace('?tags=', '');

                        if (tags.includes(param) || !window.location.search) {
                            $(this).addClass('blog-list-item--visible');
                        } else {
                            $(this).removeClass('blog-list-item--visible');
                        }

                        if (!window.location.search || param === 'home') {
                            $('.blog-list-item').addClass('blog-list-item--visible');
                        }
                    });
                }

                // $.ajax({
                //     type: 'GET',
                //     url: `?${url}`,
                //     data: {},
                //     complete: function complete(data) {
                //         $('.blog-articles__content').html($('.blog-articles__content', data.responseText).html());
                //         $('.banner-blog-contaner').html($('.banner-blog-contaner', data.responseText).html());
                //         var filterButton = document.querySelectorAll('.blog-category [data-url]');
                //         filterButton.forEach(function (button) {
                //             checkUrl(saveCategory, button, "?".concat(url.split('?')[1]));
                //             button.addEventListener('click', checkArticleTag);
                //         });
                //         history.pushState({
                //             page: url
                //         }, url, url);
                //         clickButton();
                //     }
                // });
            }

            filterButton.forEach(function (button) {
                checkUrl(window.location.pathname, button, window.location.search);
                button.addEventListener('click', checkArticleTag);
            });

            function clickButton() {
                var buttonsPagination = document.querySelectorAll('.paginate-clickable');
                console.log('buttons', buttonsPagination);
                buttonsPagination.forEach(function (button) {
                    button.addEventListener('click', function () {
                        var url = button.dataset.href;
                        $.ajax({
                            type: 'GET',
                            url: url,
                            data: {},
                            complete: function complete(data) {
                                $('.blog-articles__content').html($('.blog-articles__content', data.responseText).html());
                                history.pushState({
                                    page: url
                                }, url, url);
                                clickButton();
                            }
                        });
                    });
                });
                var pointsClick = document.querySelector('.points_click');

                if (pointsClick) {
                    pointsClick.addEventListener('click', function () {
                        var url = window.location.pathname + '?page=' + pointsClick.dataset.href;
                        $.ajax({
                            type: 'GET',
                            url: url,
                            data: {},
                            complete: function complete(data) {
                                $('.blog-articles__content').html($('.blog-articles__content', data.responseText).html());
                                history.pushState({
                                    page: url
                                }, url, url);
                                clickButton();
                            }
                        });
                    });
                }
            }

            clickButton();

            function checkArticleTag() {
                this.classList.contains('filter-button') ? saveCategory = this.dataset.url : null;
                blogPostsReload(this.dataset.url);
            }

            function checkUrl(url, button, search) {
                url === button.dataset.url || search === button.dataset.url && search !== '' ? button.classList.add('active') : button.classList.remove('active');

                if (search === '') {
                    if (document.querySelector('[data-url="?page=1"]')) {
                        document.querySelector('[data-url="?page=1"]').classList.add('active');
                    }
                }

                if (search === '?undefined' && document.querySelector('[data-url="?page=1"]')) {
                    document.querySelector('[data-url="?page=1"]').classList.add('active');
                }
            }

            /***/ }),

        /***/ 9589:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            /* provided dependency */ var $ = __webpack_require__(5825);
            var CartJS = __webpack_require__(3184);

            CartJS.init(cartJson, cartCurrency);

            $('.sticky .button-cartt .button-cartt__overlay').on('click', function () {
                console.log(222);
                const id = $(this).attr('data-variant-id');
                const quantity = $('.sticky .quantity-block .input-quantity').val();

                CartJS.addItem(id, quantity);
            });

            $('body').on('click', '.product__cart .button__wrapper .quick-button, .variants-popup .add-to-bag', function () {

                console.log($(this));
                const isOneSelect = $('.js-custom-select').length === 1;
                const quantity = $('.product__cart .input-quantity').length > 0 ? $('.product__cart .input-quantity').val() : $('.sticky .quantity-block .input-quantity').val();

                if (isOneSelect) {
                    const optionName = $('.js-custom-select select option:selected').attr('data-handle').replace('Package:', '').replace('Size:', '').replace('Colour:', '').replace('Color:', '').replace('Type:', '').trim();

                    console.log('optionName', optionName);
                    console.log('element', $(`.variant-wrapper__ids div[data-option-name='${optionName}']`).text().trim());

                    CartJS.addItem(
                        $(`.variant-wrapper__ids div[data-option-name='${optionName}']`).text().trim(),
                        quantity
                    )
                } else {
                    const optionName1 = $('.js-custom-select:nth-child(1)').length > 0 && $('.js-custom-select:nth-child(1) option:selected').attr('data-handle').replace('Package:', '').replace('Size:', '').replace('Colour:', '').replace('Color:', '').replace('Type:', '').replace('Style:', '').replace('Shoe Size:', '').replace('Clothing', '').trim();
                    const optionName2 = $('.js-custom-select:nth-child(2)').length > 0 && $('.js-custom-select:nth-child(2) option:selected').attr('data-handle').replace('Package:', '').replace('Size:', '').replace('Colour:', '').replace('Color:', '').replace('Type:', '').replace('Style:', '').replace('Shoe Size:', '').replace('Clothing', '').trim();
                    const optionName3 = $('.js-custom-select:nth-child(3)').length > 0 && $('.js-custom-select:nth-child(3) option:selected').attr('data-handle').replace('Package:', '').replace('Size:', '').replace('Colour:', '').replace('Color:', '').replace('Type:', '').replace('Style:', '').replace('Shoe Size:', '').replace('Clothing', '').trim();
                    let currentId = '';

                    console.log('optionName2', optionName2);
                    console.log('optionName3', optionName3);

                    $('.variant-wrapper__ids div').each(function () {
                       let names = $(this).attr('data-variant-title').replace('Shoe Size:', '').replace('Clothing Size: ', '').trim().split(' / ');
                       console.log('names', names);
                        if (names.includes(optionName2) && names.includes(optionName3)) {
                            currentId = $(this).text().trim();
                            return false;
                        }
                    });

                    if (currentId) {
                        CartJS.addItem(
                            currentId,
                            quantity
                        )
                    }
                }

                // $.ajax({
                //     type: 'POST',
                //     url: '/cart/add.js',
                //     data: data,
                //     dataType: 'json',
                //     success: function () {
                //     	console.log('CartJS', CartJS);
                //     }
                // });
            });


            var shopCart = document.querySelector('.bag');
            var sideBar = document.querySelector('.ajax-cart');
            var closeAjax = document.querySelector('.close-cart');
            var variantsPopup = document.querySelector('.variants-popup');
            var animationMainDiv = document.querySelector('#scroll-container');

            if (shopCart) {
                closeAjax.addEventListener('click', function () {
                    sideBar.classList.remove('is-open');
                    document.body.classList.remove('overlay');
                    variantsPopup && variantsPopup.classList.remove('is-open');
                    animationMainDiv && animationMainDiv.classList.remove('transform-none');
                });
            }

            $(document).on('cart.requestComplete', function (cart) {
                $('.cart-count').text(cart.item_count);
            });

            /***/ }),

        /***/ 1266:
        /***/ (() => {

            if (document.body.className.includes('template-collection')) {
                var bannerImg = function bannerImg() {
                    if (window.innerWidth <= 425) {
                        document.querySelector('.collection-banner').classList.add('collection-banner-mobile');
                    } else {
                        document.querySelector('.collection-banner').classList.remove('collection-banner-mobile');
                    }
                };

                window.addEventListener('DOMContentLoaded', bannerImg);
                window.addEventListener('resize', bannerImg);
            }

            /***/ }),

        /***/ 6153:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            /* provided dependency */ var $ = __webpack_require__(5825);
            if (document.body.classList.contains('template-list-collections')) {
                var checkCountProduct = function checkCountProduct() {
                    var goodsCount = document.querySelector('.goods-count'),
                        generalCount = document.querySelectorAll('.list__item').length,
                        progressInner = document.querySelector('.progress__inner'); // length

                    goodsCount.innerHTML = generalCount; // width progress

                    var allProducts = document.querySelector('.goods-general').innerHTML;
                    progressInner.style.width = "".concat(100 / (allProducts / generalCount), "%");
                };

                var addContentOnPage = function addContentOnPage() {
                    // product wrapper class
                    var productsWrapper = document.querySelector('.list__product');
                    var tot, cur;
                    var dataTotalPages = document.querySelector('[data-total-pages]');
                    var dataCurrentPage = document.querySelector('[data-current-page]');
                    var listProduct = document.querySelector('.list__product');
                    if (dataTotalPages) tot = dataTotalPages.getAttribute('value');
                    if (dataCurrentPage) cur = dataCurrentPage.getAttribute('value') - 1;

                    if (cur >= tot) {
                        productsWrapper.classList.add('hideMore');
                    } else {
                        productsWrapper.classList.remove('hideMore');
                    }

                    if (!cur && !tot) productsWrapper.classList.add('hideMore');
                    $('.js-load-more').on('click', function () {
                        var $this = $(this),
                            totalPages = parseInt($('[data-total-pages]').val()),
                            currentPage = parseInt($('[data-current-page]').val());
                        $this.attr('disabled', true);
                        $this.find('[load-more-text]').addClass('hide');
                        $this.find('[loader]').removeClass('hide');
                        var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
                        $('[data-current-page]').val(currentPage);
                        $.ajax({
                            url: nextUrl,
                            type: 'GET',
                            dataType: 'html',
                            success: function success(responseHTML) {
                                listProduct.classList.add('list__product-preload');
                                $('.list__product').append($(responseHTML).find('.list__product').html());
                                setTimeout(function () {
                                    listProduct.classList.remove('list__product-preload');
                                }, 700);
                                history.pushState({
                                    page: nextUrl
                                }, nextUrl, nextUrl);
                                var hiddenBlocks = document.querySelectorAll('.hidden-block');
                                var buttons = document.querySelectorAll('.load-more_wrap');
                                var displayed = document.querySelectorAll('.displayed');
                                var filterCountProduct = document.querySelectorAll('.filter__count-goods');

                                for (var index = 0; index < hiddenBlocks.length - 1; index++) {
                                    hiddenBlocks[index].remove();
                                }

                                for (var _index = 0; _index < buttons.length - 1; _index++) {
                                    buttons[_index].remove();
                                }

                                for (var _index2 = 0; _index2 < displayed.length - 1; _index2++) {
                                    displayed[_index2].remove();
                                }

                                for (var _index3 = 0; _index3 < filterCountProduct.length - 1; _index3++) {
                                    filterCountProduct[_index3].remove();
                                }
                            },
                            complete: function complete() {
                                addContentOnPage();

                                if (currentPage >= totalPages) {
                                    $this.attr('disabled', false);
                                    $this.find('[load-more-text]').removeClass('hide');
                                    $this.find('[loader]').addClass('hide');
                                    var loadMore = document.querySelector('.load-more_wrap');
                                    loadMore.classList.add('load-more_wrap_hidden');
                                    document.querySelector('.hidden-block').classList.add('hidden-block_hidden');
                                }

                                checkCountProduct();
                            }
                        });
                    });
                };

                window.addEventListener('DOMContentLoaded', function () {
                    var totalPages = parseInt($('[data-total-pages]').val());
                    var currentPage = parseInt($('[data-current-page]').val());

                    if (currentPage > totalPages) {
                        var loadMore = document.querySelector('.load-more_wrap');
                        if (loadMore) loadMore.classList.add('load-more_wrap_hidden');
                    }
                });
                window.addEventListener('DOMContentLoaded', function () {
                    var url;
                    var wrapper = document.querySelector('.list__product');

                    if (window.location.href.includes('page=')) {
                        url = window.location.pathname;
                    }

                    if (url) {
                        $.ajax({
                            type: 'GET',
                            data: {},
                            url: url,
                            complete: function complete(data) {
                                var listProduct = document.querySelector('.list__product');
                                listProduct.classList.add('list__product-preload');
                                $('.list__product').html($('.list__product', data.responseText).html());
                                setTimeout(function () {
                                    listProduct.classList.remove('list__product-preload');
                                }, 1000);
                                history.pushState({
                                    page: url
                                }, url, url);
                                addContentOnPage();
                                checkCountProduct();
                            }
                        });
                    }
                });
                addContentOnPage();
                checkCountProduct();
            }

            /***/ }),

        /***/ 5405:
        /***/ (() => {

            var accordion = document.querySelectorAll('.accordion__inner');
            accordion.forEach(function (item) {
                item.addEventListener('click', function (e) {
                    e.preventDefault();
                    if (!item.classList.contains('active')) removSiblingsClass(accordion);
                    item.classList.toggle('active');
                    var accordionItem = item.nextElementSibling;

                    if (accordionItem.style.maxHeight) {
                        accordionItem.style.maxHeight = null;
                    } else {
                        accordionItem.style.maxHeight = accordionItem.scrollHeight + 'px';
                    }
                });
            });

            function removSiblingsClass() {
                var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
                var className = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'active';
                items.forEach(function (item) {
                    item.classList.remove(className);
                    var accordionElement = item.nextElementSibling;
                    accordionElement.style.maxHeight = null;
                });
            }

            /***/ }),

        /***/ 1523:
        /***/ (() => {

            if (document.querySelector('.default-page')) {
                var countMargin = function countMargin() {
                    if (window.innerWidth > 767) {
                        main.style.paddingTop = 84 + header.offsetHeight + 'px';
                    } else {
                        main.style.paddingTop = 47 + header.offsetHeight + 'px';
                    }
                };

                var checkImg = function checkImg() {
                    images.forEach(function (img) {
                        var attribute = img.getAttribute('alt');

                        if (attribute) {
                            if (attribute.includes('more_text_content')) {
                                var padding = window.getComputedStyle(container, null).getPropertyValue('padding-right').replace('px', '');
                                var width = window.innerWidth - padding;

                                if (window.innerWidth <= 767) {
                                    img.style.width = "".concat(window.outerWidth, "px");
                                    img.style.transform = "translateX(-".concat(padding, "px)");
                                } else {
                                    if (window.innerWidth >= 1920) {
                                        img.style.width = "".concat(1612, "px");
                                        img.style.transform = "translateX(-".concat(padding / 2, "px)");
                                    } else {
                                        img.style.width = "".concat(width, "px");
                                        img.style.transform = "translateX(-".concat(padding / 2, "px)");
                                    }
                                }
                            }

                            if (attribute.includes('full_content')) {
                                img.classList.add('full_content');
                            }

                            if (attribute.includes('half_content')) {
                                img.classList.add('half_content');
                            }
                        }
                    });
                };

                var header = document.querySelector('.header'),
                    main = document.querySelector('main'),
                    images = document.querySelectorAll('img'),
                    container = document.querySelector('.container');
                window.addEventListener('DOMContentLoaded', countMargin);
                window.addEventListener('resize', countMargin);
                checkImg();
                window.addEventListener('resize', checkImg);
            }

            /***/ }),

        /***/ 7334:
        /***/ (() => {

            var hamburger = document.querySelector('.hamburger'),
                hamburgerBlock = document.querySelector('.hamburger-block'),
                navNameMobile = document.querySelectorAll('.header-item.mobile'),
                ourRangeBlock = document.querySelectorAll('.our-range.mobile'),
                back = document.querySelectorAll('.our-range-back'),
                body = document.querySelector('body'),
                navItemMobile = document.querySelectorAll('.nav-name.mobile'),
                hamburgerClose = document.querySelector('.hamburger__close');
            hamburger.addEventListener('click', function () {
                body.classList.toggle('active');
                hamburger.classList.toggle('active');
                hamburgerBlock.classList.toggle('active');
            });
            navItemMobile.forEach(function (item, index) {
                item.addEventListener('click', function (event) {
                    if (navNameMobile[index].querySelector('.our-range')) {
                        removeActive(navNameMobile);
                        event.preventDefault();
                        navNameMobile[index].classList.add('active');
                    }
                });
            });
            back.forEach(function (item) {
                item.addEventListener('click', function (event) {
                    event.stopPropagation();
                    removeActive(navNameMobile);
                });
            });

            function removeActive(arrayNav) {
                arrayNav.forEach(function (item) {
                    if (item.classList.contains('active')) {
                        item.classList.remove('active');
                    }
                });
            }

            /***/ }),

        /***/ 9574:
        /***/ (() => {

            var main = document.querySelector('main'),
                templateIndex = document.querySelector('.template-index'),
                templateBlog = document.querySelector('.template-blog'),
                templateArticle = document.querySelector('.template-article'),
                headerInnerIcon = document.querySelector('.header__inner.icon'),
                header = document.querySelector('.header'),
                cartTemplate = document.querySelector('.cart-template__wrapper'),
                cartCheckout = document.querySelector('.cart-checkout'),
                headerItem = document.querySelectorAll('.header-item'),
                sliderBtn = document.querySelectorAll('.slider-btn');
            sliderBtn.forEach(function (item) {
                item.addEventListener('click', function () {
                    document.querySelector('.ajax-cart').classList.add('is-open');
                    document.querySelector('.ajax-cart').classList.add('is-open');
                    document.body.classList.add('overlay');
                });
            });

            if (templateBlog || templateArticle) {
                main.style.paddingTop = "".concat(document.querySelector('header').offsetHeight, "px");
            }

            window.addEventListener('resize', function () {
                if (templateBlog || templateArticle) {
                    main.style.paddingTop = "".concat(document.querySelector('header').offsetHeight, "px");
                } //activeMenu();

            }); //function activeMenu() {
//  if (window.innerWidth >= 1024) {
//    headerItem.forEach((item) => {
//      item.addEventListener('click', (e) => {
//        item.classList.toggle('active');
//      });
//      item.addEventListener(
//        'mouseover',
//        function (e) {
//          console.log(this);
//          console.log(e.target);
//          if (this.classList.contains('header-item')) {
//            console.log('test');
//          } else {
//            //item.classList.remove('active');
//            console.log('test ------ - -- -');
//          }
//        },
//        true
//      );
//    });
//  }
//}

            function removeActive(mass) {
                mass.forEach(function (item) {
                    item.classList.remove('active');
                });
            }

            if (templateIndex) {
                main.style.paddingTop = '0px';
            }

            document.addEventListener('scroll', function () {
                if (window.pageYOffset >= header.offsetHeight) {
                    header.classList.add('active');
                    headerInnerIcon.classList.add('active');
                } else {
                    header.classList.remove('active');
                    headerInnerIcon.classList.remove('active');
                }
            });

            if (cartTemplate) {
                cartTemplate.style.paddingTop = header.offsetHeight + 'px';
                cartCheckout.style.top = header.offsetHeight + 20 + 'px';
            }

            /***/ }),

        /***/ 7964:
        /***/ (() => {

            if (document.body.className.includes('template-page.our-stores')) {
                var checkBG = function checkBG() {
                    if (window.innerWidth <= 767) background.classList.add('mobile');else background.classList.remove('mobile');
                }; // check active section


                var checkActiveSection = function checkActiveSection() {
                    if (window.pageYOffset >= banner.offsetHeight - header.offsetHeight + 30) {
                        header.classList.add('header_stores-hide');
                        anchor.classList.add('anchors_fixed');
                        anchorFirst.style.display = 'none';
                        banner.classList.add('our-stores-banner_static');
                    } else {
                        header.classList.remove('header_stores-hide');
                        anchor.classList.remove('anchors_fixed');
                        anchorFirst.removeAttribute('style');
                        banner.classList.remove('our-stores-banner_static');
                    }
                };

                var actItem = function actItem() {
                    // active tabs
                    var itemTab = document.querySelectorAll('.stores-section');
                    var tabName = document.querySelectorAll('.anchors__wrapper-item');

                    function removeActivePopup(mass) {
                        mass.forEach(function (item) {
                            item.classList.remove('active');
                        });
                    } // const firstPosition = itemTab[0].offsetTop;


                    itemTab.forEach(function (item, index) {
                        var position = item.offsetTop;
                        document.addEventListener('scroll', function () {
                            if (window.pageYOffset >= position - 60) {
                                removeActivePopup(tabName);
                                tabName[index + 1].classList.add('active');
                            } else if (window.pageYOffset < window.innerHeight) {
                                removeActivePopup(tabName);
                                tabName[0].classList.add('active');
                            }
                        });
                    });
                };

                // exit ajax cart
                document.body.addEventListener('click', function (e) {
                    if (e.target.classList.contains('ajax-cart')) document.querySelector('.ajax-cart').classList.remove('is-open');
                });
                var scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight, document.body.offsetHeight, document.documentElement.offsetHeight, document.body.clientHeight, document.documentElement.clientHeight); // bg on mobile

                var background = document.querySelector('.background'),
                    header = document.querySelector('.header'),
                    banner = document.querySelector('.our-stores-banner'),
                    anchor = document.querySelector('.anchors'),
                    anchorFirst = document.querySelector('.anchors__wrapper-item');
                window.addEventListener('scroll', checkActiveSection);
                window.addEventListener('DOMContentLoaded', function () {
                    checkBG();
                    checkActiveSection();
                    actItem();
                });
                window.addEventListener('resize', function () {
                    checkBG();
                    actItem();
                });
            }

            /***/ }),

        /***/ 6042:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            /* provided dependency */ var $ = __webpack_require__(5825);
            var _require = __webpack_require__(3945),
                doc = _require.doc;

            var plusButton = document.querySelector('[data-plus-quantity]');
            var minusButton = document.querySelector('[data-minus-quantity]');
            var quantityInput = document.querySelector('[data-quantity-product]');
            var priceProduct = document.querySelectorAll('[data-price-product]');
            var ajaxCart = document.querySelector('.cart.ajax-cart');
            var quantitySubMain = document.querySelector('#Quantity');
            var descriptionPoptitle = document.querySelectorAll('.description__poptitle');
            var contentPoptitle = document.querySelectorAll('.content__poptitle');
            var descriptionClose = document.querySelectorAll('.description.close');
            var stickyElement = document.querySelector('.sticky__inner');
            var footer = document.querySelector('footer');
            var animationMainDiv = document.querySelector('#scroll-container');
            var btnOpenPopur = document.querySelector('.button-cart.popup');
            var variantsPopup = document.querySelector('.variants-popup');
            var variantsClose = document.querySelector('.variants.close');
            var variantPricePopup = document.querySelectorAll('.button-cart.popup-click .variant_price');
            var variantPrice = document.querySelectorAll('.button-cart.popup .variant_price');
            var buttonCart = document.querySelector('.button-cartt');
            var selectSubMain = document.querySelectorAll('.selectSubMain');
            var selectSMain = document.querySelector('#mainSelect');
            var buttonBuyClick = document.querySelector('.button-cart.popup-click .add-to-bag');
            var buttonCheckoutClick = document.querySelector('.variants-popup  .quick-add-checkout');
            var selectSelected = document.querySelectorAll('.select-selected');
            var itemTab = document.querySelectorAll('.tab-section');
            var tabName = document.querySelectorAll('.item-tab');
            var templateProduct = document.querySelector('.template-product');
            var templateIndex = document.querySelector('.template-index');

            if (templateIndex) {
                document.body.addEventListener('click', function (e) {
                    if (e.target.classList.contains('template-index')
                        || e.target.classList.contains('template-collection')
                        || e.target.classList.contains('template-search')) {
                        document.body.classList.remove('overlay');
                        console.log(11);
                        document.querySelector('.login-popup') && document.querySelector('.login-popup').classList.remove('is-open');
                        document.querySelector('.variants-popup') && document.querySelector('.variants-popup').classList.remove('is-open');
                        document.querySelector('#scroll-container') && document.querySelector('#scroll-container').classList.remove('transform-none');
                        document.querySelector('.cart') && document.querySelector('.cart').classList.remove('is-open');
                        removeActivePopup && removeActivePopup(contentPoptitle);
                        $('.product__cart').removeClass('product__cart_active');
                    }
                });
            }

            if (templateProduct) {
                var plusQuantity = function plusQuantity() {
                    quantityInput.value++;
                    calcTotalPrice(quantityInput.value);
                };

                var minusQuantity = function minusQuantity() {
                    quantityInput.value <= 1 ? quantityInput.value = 1 : quantityInput.value--;
                    calcTotalPrice(quantityInput.value);
                };

                var calcTotalPrice = function calcTotalPrice(quantity) {
                    quantitySubMain.value = quantity;
                    var eventChangee = new Event('change');
                    quantitySubMain.dispatchEvent(eventChangee);
                    priceProduct.forEach(function (element) {
                        element.textContent = Shopify.formatMoney(element.dataset.priceProduct * quantity || element.dataset.priceProduct);
                        element.textContent = Math.ceil(element.textContent.substr(1));
                        element.textContent = parseInt(element.textContent);
                        console.log(currency);
                    });
                };

                var openVideoPopup = function openVideoPopup() {
                    videoPopup.classList.add('is-open');
                    document.body.classList.add('overlay');
                };

                var closeVideoPopup = function closeVideoPopup() {
                    videoPopup.classList.remove('is-open');
                    document.body.classList.remove('overlay');
                };

                var removeActivePopup = function removeActivePopup(mass) {
                    mass.forEach(function (item) {
                        item.classList.remove('active');
                    });
                }; // select


                document.body.addEventListener('click', function (e) {
                    if (e.target.classList.contains('template-product')) {
                        document.body.classList.remove('overlay');
                        document.querySelector('.login-popup').classList.remove('is-open');
                        document.querySelector('.variants-popup').classList.remove('is-open');
                        document.querySelector('#scroll-container').classList.remove('transform-none');
                        document.querySelector('.cart').classList.remove('is-open');
                        removeActivePopup(contentPoptitle);
                        $('.product__cart').removeClass('product__cart_active');
                    }
                }); //const pagination = document.querySelector('.swiper-scrollbar-recomend');
                //const productItems = document.querySelectorAll('.product__item');
                //productItems.forEach(item=>{
                //  item.addEventListener('mouseover',()=>{
                //    pagination.classList.add('opacity');
                //  })
                //  item.addEventListener('mouseout',()=>{
                //    pagination.classList.remove('opacity');
                //  })
                //})

                var currency = document.querySelector('[data-price-product]').getAttribute('data-price-currency').substr(0, 1)
                itemTab.forEach(function (item, index) {
                    var position = item.offsetTop;
                    document.addEventListener('scroll', function () {
                        if (window.pageYOffset >= position - 120) {
                            removeActivePopup(tabName);
                            tabName[index].classList.add('active');
                        }
                    });
                });
                $(tabName).click(function () {
                    var link = $(this).attr('href');
                    if (link) {
                        $('html, body').animate({
                            scrollTop: $(link).offset().top - 50
                        }, 200);
                    }
                });

                if (buttonCart) {
                    buttonCart.addEventListener('click', function () {
                        buttonBuyClick.click();
                    });
                }

                if (btnOpenPopur) {
                    btnOpenPopur.addEventListener('click', function (event) {
                        variantsPopup.classList.add('is-open');
                        document.body.classList.add('overlay');
                        setTimeout(function () {animationMainDiv.classList.add('transform-none');}, 0);
                    });
                }

                if (variantsClose) {
                    variantsClose.addEventListener('click', function (e) {
                        variantsPopup.classList.remove('is-open');
                        animationMainDiv.classList.remove('transform-none');
                        document.body.classList.remove('overlay');
                    });
                }

                document.body.addEventListener('click', function (e) {
                    if (e.target.classList.contains('overlay')) {
                        variantsPopup.classList.remove('is-open');
                        animationMainDiv.classList.remove('transform-none');
                        document.body.classList.remove('overlay');
                        document.querySelector('.login-popup').classList.remove('is-open');
                        document.querySelector('.ajax-cart').classList.remove('is-open');
                        removeActivePopup(contentPoptitle);
                        $('.product__cart').removeClass('product__cart_active');
                    }
                });
                document.addEventListener('scroll', function () {
                    if ($('.js-recomend-section').length > 0) {
                        if ($('.footer').hasClass('is-inview')) {
                            stickyElement.classList.add('none');
                        } else {
                            stickyElement.classList.remove('none');
                        }
                    }
                });
                plusButton && plusButton.addEventListener('click', plusQuantity);
                minusButton && minusButton.addEventListener('click', minusQuantity);
                quantityInput && quantityInput.addEventListener('change', function () {
                    calcTotalPrice(quantityInput.value);
                });
                descriptionPoptitle.forEach(function (item, index) {
                    item.addEventListener('click', function (e) {
                        removeActivePopup(contentPoptitle);
                        contentPoptitle[index].classList.add('active');
                        document.body.classList.add('overlay');
                        setTimeout(function () {animationMainDiv.classList.add('transform-none');}, 0);
                    });
                });
                descriptionClose.forEach(function (item) {
                    item.addEventListener('click', function (e) {
                        e.stopPropagation();
                        removeActivePopup(contentPoptitle);
                        document.body.classList.remove('overlay');
                        animationMainDiv.classList.remove('transform-none');
                    });
                });
                var playVideoButtons = document.querySelectorAll('.play-video-button'),
                    videoPopup = document.querySelector('.video-popup'),
                    closePopupButton = document.querySelectorAll('.close-popup');
                playVideoButtons.forEach(function (button) {
                    return button.addEventListener('click', openVideoPopup);
                });
                closePopupButton.forEach(function (button) {
                    return button.addEventListener('click', closeVideoPopup);
                });
                var collabsSwiper = new Swiper('.gallery-container', {
                    freeMode: false,
                    spaceBetween: 30,
                    slidesPerView: 2.8,
                    autoHeight: true,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: '.swiper-button-next'
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1.2,
                            spaceBetween: 20
                        },
                        500: {
                            slidesPerView: 2.2
                        },
                        990: {
                            slidesPerView: 2.8
                        },
                        1440: {
                            slidesPerView: 3.3
                        }
                    }
                });
                var recomendSwiper = new Swiper('.recomend-container', {
                    freeMode: false,
                    spaceBetween: 30,
                    slidesPerView: 2.8,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: '.arrow-next-recomend',
                        prevEl: '.arrow-prev-recomend'
                    },
                    scrollbar: {
                        el: '.swiper-scrollbar',
                        draggable: true
                    },
                    breakpoints: {
                        320: {
                            slidesPerView: 1.1,
                            spaceBetween: 20
                        },
                        767: {
                            slidesPerView: 2.1
                        },
                        990: {
                            slidesPerView: 2.8
                        },
                        1440: {
                            slidesPerView: 3.3
                        }
                    }
                });
                var optionSizeSelect = [];
                var sentens;
                selectSelected.forEach(function (element, index) {
                    element.addEventListener('click', function () {
                        var eventChange = new Event('change');
                        selectSubMain[index].dispatchEvent(eventChange);
                    });
                });
                selectSubMain.forEach(function (select, index) {
                    optionSizeSelect[index] = select.value;
                    sentens = optionSizeSelect.join(' / ');
                    select.addEventListener('change', function (event) {
                        optionSizeSelect[index] = event.target.value;
                        sentens = optionSizeSelect.join(' / ');
                        Array.from(selectSMain.options).forEach(function (element, index) {
                            if (sentens === element.dataset.value) {
                                element.selected = true;
                                removeActivePopup(variantPrice);
                                removeActivePopup(variantPricePopup);
                                variantPrice[index].classList.add('active');
                                variantPricePopup[index].classList.add('active');

                                if (element.disabled) {
                                    buttonBuyClick.classList.add('disabled');
                                    buttonBuyClick.setAttribute('disabled', 'disabled');
                                    buttonCheckoutClick && buttonCheckoutClick.classList.add('disabled');
                                    buttonCheckoutClick && buttonCheckoutClick.setAttribute('disabled', 'disabled');
                                } else {
                                    buttonBuyClick.classList.remove('disabled');
                                    buttonBuyClick.removeAttribute('disabled', 'disabled');
                                    buttonCheckoutClick && buttonCheckoutClick.classList.remove('disabled');
                                    buttonCheckoutClick && buttonCheckoutClick.removeAttribute('disabled', 'disabled');
                                }
                            }
                        });
                    });
                });
                document.querySelectorAll('.select__item').forEach(function (item) {
                    item.addEventListener('click', function () {
                        item.firstElementChild.checked = true;
                        item.parentElement.previousElementSibling.innerHTML = item.firstElementChild.nextElementSibling.innerHTML;
                    });
                });
                buttonBuyClick.addEventListener('click', function () {
                    ajaxCart.classList.add('is-open');
                });


                if (buttonCheckoutClick) {
                    buttonCheckoutClick.addEventListener("click", function () {
                        location.pathname = "/checkout";
                    });
                } // ********** video click ************ //


                var video = document.querySelector('.video-popup__wrapper video');
                document.querySelector('.play-video-button') &&
                document.querySelector('.play-video-button').addEventListener('click', function () {
                    video.play();
                });
                document.querySelector('.video-popup__wrapper .close-popup') &&
                document.querySelector('.video-popup__wrapper .close-popup').addEventListener('click', function () {
                    video.pause();
                    video.currentTime = 0;
                });
            }

            /***/ }),

        /***/ 6540:
        /***/ (() => {

// ambassador section
            var videoShow = document.querySelector('.video-button-btn'),
                exitVideo = document.querySelector('.exit-ambassador'),
                video = document.querySelector('.ambassador-video');

            if (videoShow) {
                videoShow.addEventListener('click', function () {
                    video.classList.add('ambassador-video-show');
                    video.firstElementChild.play();
                });
            }

            if (exitVideo) {
                exitVideo.addEventListener('click', function () {
                    video.classList.remove('ambassador-video-show');
                    video.firstElementChild.pause();
                    video.firstElementChild.currentTime = 0;
                });
            }

            /***/ }),

        /***/ 2443:
        /***/ (() => {

            if (!document.body.classList.contains('template-customers')) {
                var x, i, j, l, ll, selElmnt, a, b, c;

                (function () {
                    var closeAllSelect = function closeAllSelect(elmnt) {
                        var x,
                            y,
                            i,
                            xl,
                            yl,
                            arrNo = [];
                        x = document.getElementsByClassName('select-items');
                        y = document.getElementsByClassName('select-selected');
                        xl = x.length;
                        yl = y.length;

                        for (i = 0; i < yl; i++) {
                            if (elmnt == y[i]) {
                                arrNo.push(i);
                            } else {
                                y[i].classList.remove('select-arrow-active');
                            }
                        }

                        for (i = 0; i < xl; i++) {
                            if (arrNo.indexOf(i)) {
                                x[i].classList.add('select-hide');
                            }
                        }
                    };

                    x = document.getElementsByClassName('custom-select');
                    l = x.length;

                    for (i = 0; i < l; i++) {
                        selElmnt = x[i].getElementsByTagName('select')[0];
                        var firstElem = selElmnt.firstElementChild;
                        var arrDataAttr = [];

                        while (firstElem) {
                            if (firstElem.getAttribute('value')) {
                                arrDataAttr.push(firstElem.getAttribute('value'));
                                firstElem = firstElem.nextElementSibling;
                            } else {
                                arrDataAttr.push(firstElem.dataset.tag);
                                firstElem = firstElem.nextElementSibling;
                            }
                        }

                        var attr = x[i].classList[1];
                        var innHTML = void 0;

                        if (document.body.classList.contains('template-collection')) {
                            if (attr.indexOf('-') && !attr.includes('sort-select')) {
                                innHTML = attr.substr(attr.indexOf('-') + 1);
                            } else if (!attr.indexOf('-') && !attr.includes('sort-select')) {
                                innHTML = attr;
                            } else {
                                innHTML = 'Sort by';
                            }
                        }

                        if (document.body.classList.contains('template-product')) {
                            innHTML = 'Variant';
                        }

                        ll = selElmnt.length;
                        a = document.createElement('DIV');
                        a.setAttribute('class', 'select-selected'); // a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

                        a.innerHTML = innHTML;
                        x[i].appendChild(a);
                        b = document.createElement('DIV');
                        b.setAttribute('class', 'select-items select-hide');

                        for (j = 0; j < ll; j++) {
                            var inputRadio = document.createElement('input');
                            inputRadio.setAttribute('class', 'custom-radio');
                            inputRadio.setAttribute('type', 'radio');
                            inputRadio.setAttribute('name', attr);
                            var label = document.createElement('label');
                            label.setAttribute('class', 'label-text');
                            c = document.createElement('DIV');
                            c.setAttribute('class', 'select__item');
                            c.setAttribute('data-handle', arrDataAttr[j]);
                            label.innerHTML = selElmnt.options[j].innerText;
                            c.appendChild(inputRadio);
                            c.appendChild(label);
                            c.addEventListener('click', function (e) {
                                var y, i, k, s, h, sl, yl;
                                var element = this.firstElementChild.nextElementSibling.innerHTML;
                                s = this.parentNode.parentNode.getElementsByTagName('select')[0];
                                sl = s.length;
                                h = this.parentNode.previousSibling;

                                for (i = 0; i < sl; i++) {
                                    if (s.options[i].innerHTML.replace('-', ' ') == element) {
                                        s.selectedIndex = i;
                                        y = this.parentNode.getElementsByClassName('same-as-selected');
                                        yl = y.length;

                                        for (k = 0; k < yl; k++) {
                                            y[k].classList.remove('same-as-selected');
                                        }

                                        this.setAttribute('class', 'select__item same-as-selected');
                                        break;
                                    }
                                }

                                h.click();
                            });
                            b.appendChild(c);
                        }

                        x[i].appendChild(b);
                        a.addEventListener('click', function (e) {
                            e.stopPropagation();
                            closeAllSelect(this);
                            this.nextSibling.classList.toggle('select-hide');
                            this.classList.toggle('select-arrow-active');
                        });
                    }

                    document.addEventListener('click', closeAllSelect);
                })();
            }

            /***/ }),

        /***/ 100:
        /***/ (() => {

            var tabsTrigger = document.querySelectorAll('.tabs-item-trigger');

            if (tabsTrigger) {
                var tabsItemContent = document.querySelectorAll('.tabs-item-content');
                tabsTrigger.forEach(function (trigger) {
                    trigger.addEventListener('click', function () {
                        var triggerSectionAttr = '.' + trigger.getAttribute('data-tab');
                        var activeSection = document.querySelector(triggerSectionAttr);
                        var activeTriggerAttr = '.' + trigger.getAttribute('data-tab-active');
                        var activeTrigger = document.querySelector(activeTriggerAttr);
                        var tabsWrapper = document.querySelectorAll('.tabs-wrapper');
                        tabsWrapper.forEach(function (item) {
                            item.classList.remove('active');
                        });
                        tabsTrigger.forEach(function (el) {
                            el.classList.remove('tabs-item-active');
                        });
                        tabsItemContent.forEach(function (section) {
                            section.classList.remove('active');
                        });
                        activeSection.closest('.tabs-wrapper').classList.add('active');
                        activeTrigger.classList.add('tabs-item-active');
                        activeSection.classList.add('active');
                    });
                });
            }

            /***/ }),

        /***/ 7502:
        /***/ (() => {

            var formSubmitButton = document.querySelectorAll('form .form-submit');
            var signForgot = document.querySelector('.sign-forgot.tabs-item-trigger');
            var main = document.querySelector('body');
            var cansel = document.querySelector('.button.secondary.tabs-item-trigger');
            var signTemplate = document.querySelector('.template-customers-login');
            var selectCountry = document.querySelector('.select-country.new');
            var selectCountryTwo = document.querySelector('.select-country'); //Array.from(selectCountryTwo.options).forEach( (element, index) => {
//  if(element.value == "---")
//  element.remove();
//});
//Array.from(selectCountry.options).forEach( (element, index) => {
//  if(index == 1){
//    element.selected = true;
//  }
//  if(element.value == "---")
//  element.remove();
//});

            if (formSubmitButton) {
                formSubmitButton.forEach(function (button) {
                    button.addEventListener('click', function (e) {
                        var inputItems = button.closest('form').querySelectorAll('.form-field-required');
                        var tabsItemRegister = document.querySelector('.tabs-item-register'),
                            tabsItemLogin = document.querySelector('.tabs-item-login');

                        if (tabsItemRegister.classList.contains('active')) {
                            inputItems.forEach(function (item) {
                                console.log('item----', item);

                                if (item.type == 'password') {
                                    var val = item.value;

                                    if (val.length < 6 && val.length > 0) {
                                        item.classList.remove('was-validate-2');
                                        item.classList.add('was-validate-1');
                                        setTimeout(function () {
                                            item.focus();
                                        }, 0);
                                    }

                                    if (val.length == 0) {
                                        item.classList.remove('was-validate-1');
                                        item.classList.add('was-validate-2');
                                        item.classList.add('was-validate-3');
                                        setTimeout(function () {
                                            item.focus();
                                        }, 0);
                                    }
                                }

                                if (item.type == 'email') {
                                    var _val = item.value;

                                    if (_val.length == 0) {
                                        item.classList.remove('was-validate-4');
                                        item.classList.add('was-validate-3'); //document.querySelector('.error').style.display = 'none';

                                        setTimeout(function () {
                                            item.focus();
                                        }, 0);
                                    } else if (_val.length > 0) {
                                        item.classList.remove('was-validate-3');
                                        item.classList.add('was-validate-4');
                                    }
                                }

                                item.classList.add('was-validate');
                                setTimeout(function () {
                                    item.focus();
                                }, 0);
                            });
                        } else if (tabsItemLogin.classList.contains('active')) {
                            inputItems.forEach(function (item) {
                                if (item.type == 'password') {
                                    var val = item.value;

                                    if (val.length == 0) {
                                        item.classList.add('was-validate-1');
                                        setTimeout(function () {
                                            item.focus();
                                        }, 0);
                                        document.querySelector('.login-error-pass-2').style.display = 'none';
                                    }
                                }

                                if (item.type == 'email') {
                                    var _val2 = item.value;

                                    if (_val2.length == 0) {
                                        item.classList.remove('was-validate-4');
                                        item.classList.add('was-validate-3');
                                        setTimeout(function () {
                                            item.focus();
                                        }, 0);
                                        document.querySelector('.login-error-email-1').style.display = 'none';
                                    } else {
                                        item.classList.add('was-validate-4');
                                        item.classList.remove('was-validate-3');
                                        document.querySelector('.login-error-email-1').style.display = 'block';
                                    }
                                }

                                item.classList.add('was-validate');
                                setTimeout(function () {
                                    item.focus();
                                }, 0);
                            });
                        }
                    });
                });
            }

            if (signTemplate) {
                signForgot.addEventListener('click', function () {
                    window.scrollTo(0, 0);
                });
                cansel.addEventListener('click', function () {
                    window.scrollTo(0, 0);
                });
            } //$("#address_form_new").submit(function() {
//  console.log("qwer",$("#address_form_new").serialize());
//  let url = "/account/addresses"; // the script where you handle the form input.
//  $.ajax({
//    type: "POST",
//    url: url,
//    data: $("#address_form_new").serialize(), // serializes the form's elements.
//    success: function(data)
//    {
//      //console.log(data); // show response
//    }
//  });
//  return false; // avoid to execute the actual submit o sf the form.
//});

            /***/ }),

        /***/ 6266:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(5767);
            __webpack_require__(8132);
            __webpack_require__(8388);
            __webpack_require__(7470);
            __webpack_require__(4882);
            __webpack_require__(1520);
            __webpack_require__(7476);
            __webpack_require__(9622);
            __webpack_require__(9375);
            __webpack_require__(3533);
            __webpack_require__(4672);
            __webpack_require__(4157);
            __webpack_require__(5095);
            __webpack_require__(9892);
            __webpack_require__(5115);
            __webpack_require__(9176);
            __webpack_require__(8838);
            __webpack_require__(6253);
            __webpack_require__(9730);
            __webpack_require__(6059);
            __webpack_require__(8377);
            __webpack_require__(1084);
            __webpack_require__(4299);
            __webpack_require__(1246);
            __webpack_require__(726);
            __webpack_require__(1901);
            __webpack_require__(5972);
            __webpack_require__(3403);
            __webpack_require__(2516);
            __webpack_require__(9371);
            __webpack_require__(6479);
            __webpack_require__(1736);
            __webpack_require__(1889);
            __webpack_require__(5177);
            __webpack_require__(6943);
            __webpack_require__(6503);
            __webpack_require__(6786);
            __webpack_require__(932);
            __webpack_require__(7526);
            __webpack_require__(1591);
            __webpack_require__(9073);
            __webpack_require__(347);
            __webpack_require__(579);
            __webpack_require__(4669);
            __webpack_require__(7710);
            __webpack_require__(5789);
            __webpack_require__(3514);
            __webpack_require__(9978);
            __webpack_require__(8472);
            __webpack_require__(6946);
            __webpack_require__(5068);
            __webpack_require__(413);
            __webpack_require__(191);
            __webpack_require__(8306);
            __webpack_require__(4564);
            __webpack_require__(9115);
            __webpack_require__(9539);
            __webpack_require__(6620);
            __webpack_require__(2850);
            __webpack_require__(823);
            __webpack_require__(7732);
            __webpack_require__(856);
            __webpack_require__(703);
            __webpack_require__(1539);
            __webpack_require__(5292);
            __webpack_require__(6629);
            __webpack_require__(3694);
            __webpack_require__(7648);
            __webpack_require__(7795);
            __webpack_require__(4531);
            __webpack_require__(3605);
            __webpack_require__(6780);
            __webpack_require__(9937);
            __webpack_require__(511);
            __webpack_require__(1822);
            __webpack_require__(9977);
            __webpack_require__(1031);
            __webpack_require__(6331);
            __webpack_require__(1560);
            __webpack_require__(774);
            __webpack_require__(522);
            __webpack_require__(8295);
            __webpack_require__(7842);
            __webpack_require__(110);
            __webpack_require__(75);
            __webpack_require__(4336);
            __webpack_require__(1802);
            __webpack_require__(8837);
            __webpack_require__(6773);
            __webpack_require__(5745);
            __webpack_require__(3057);
            __webpack_require__(3750);
            __webpack_require__(3369);
            __webpack_require__(9564);
            __webpack_require__(2000);
            __webpack_require__(8977);
            __webpack_require__(2310);
            __webpack_require__(4899);
            __webpack_require__(1842);
            __webpack_require__(6997);
            __webpack_require__(3946);
            __webpack_require__(8269);
            __webpack_require__(6108);
            __webpack_require__(6774);
            __webpack_require__(1466);
            __webpack_require__(9357);
            __webpack_require__(6142);
            __webpack_require__(1876);
            __webpack_require__(851);
            __webpack_require__(8416);
            __webpack_require__(8184);
            __webpack_require__(147);
            __webpack_require__(9192);
            __webpack_require__(142);
            __webpack_require__(1786);
            __webpack_require__(5368);
            __webpack_require__(6964);
            __webpack_require__(2152);
            __webpack_require__(4821);
            __webpack_require__(9103);
            __webpack_require__(1303);
            __webpack_require__(3318);
            __webpack_require__(162);
            __webpack_require__(3834);
            __webpack_require__(1572);
            __webpack_require__(2139);
            __webpack_require__(685);
            __webpack_require__(5535);
            __webpack_require__(7347);
            __webpack_require__(3049);
            __webpack_require__(6633);
            __webpack_require__(8989);
            __webpack_require__(8270);
            __webpack_require__(4510);
            __webpack_require__(3984);
            __webpack_require__(5769);
            __webpack_require__(55);
            __webpack_require__(6014);
            module.exports = __webpack_require__(5645);


            /***/ }),

        /***/ 911:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(1268);
            module.exports = __webpack_require__(5645).Array.flatMap;


            /***/ }),

        /***/ 990:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(2773);
            module.exports = __webpack_require__(5645).Array.includes;


            /***/ }),

        /***/ 5434:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(3276);
            module.exports = __webpack_require__(5645).Object.entries;


            /***/ }),

        /***/ 8051:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(8351);
            module.exports = __webpack_require__(5645).Object.getOwnPropertyDescriptors;


            /***/ }),

        /***/ 8250:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(6409);
            module.exports = __webpack_require__(5645).Object.values;


            /***/ }),

        /***/ 4952:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            __webpack_require__(851);
            __webpack_require__(9865);
            module.exports = __webpack_require__(5645).Promise["finally"];


            /***/ }),

        /***/ 6197:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(2770);
            module.exports = __webpack_require__(5645).String.padEnd;


            /***/ }),

        /***/ 4160:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(1784);
            module.exports = __webpack_require__(5645).String.padStart;


            /***/ }),

        /***/ 4039:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(4325);
            module.exports = __webpack_require__(5645).String.trimRight;


            /***/ }),

        /***/ 6728:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(5869);
            module.exports = __webpack_require__(5645).String.trimLeft;


            /***/ }),

        /***/ 3568:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(9665);
            module.exports = (__webpack_require__(8787).f)('asyncIterator');


            /***/ }),

        /***/ 115:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(4579);
            module.exports = __webpack_require__(1327).global;


            /***/ }),

        /***/ 5663:
        /***/ ((module) => {

            module.exports = function (it) {
                if (typeof it != 'function') throw TypeError(it + ' is not a function!');
                return it;
            };


            /***/ }),

        /***/ 2159:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var isObject = __webpack_require__(6727);
            module.exports = function (it) {
                if (!isObject(it)) throw TypeError(it + ' is not an object!');
                return it;
            };


            /***/ }),

        /***/ 1327:
        /***/ ((module) => {

            var core = module.exports = { version: '2.6.12' };
            if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


            /***/ }),

        /***/ 9216:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// optional / simple context binding
            var aFunction = __webpack_require__(5663);
            module.exports = function (fn, that, length) {
                aFunction(fn);
                if (that === undefined) return fn;
                switch (length) {
                    case 1: return function (a) {
                        return fn.call(that, a);
                    };
                    case 2: return function (a, b) {
                        return fn.call(that, a, b);
                    };
                    case 3: return function (a, b, c) {
                        return fn.call(that, a, b, c);
                    };
                }
                return function (/* ...args */) {
                    return fn.apply(that, arguments);
                };
            };


            /***/ }),

        /***/ 9666:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// Thank's IE8 for his funny defineProperty
            module.exports = !__webpack_require__(7929)(function () {
                return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
            });


            /***/ }),

        /***/ 7467:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var isObject = __webpack_require__(6727);
            var document = (__webpack_require__(3938).document);
// typeof document.createElement is 'object' in old IE
            var is = isObject(document) && isObject(document.createElement);
            module.exports = function (it) {
                return is ? document.createElement(it) : {};
            };


            /***/ }),

        /***/ 3856:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var global = __webpack_require__(3938);
            var core = __webpack_require__(1327);
            var ctx = __webpack_require__(9216);
            var hide = __webpack_require__(1818);
            var has = __webpack_require__(7069);
            var PROTOTYPE = 'prototype';

            var $export = function (type, name, source) {
                var IS_FORCED = type & $export.F;
                var IS_GLOBAL = type & $export.G;
                var IS_STATIC = type & $export.S;
                var IS_PROTO = type & $export.P;
                var IS_BIND = type & $export.B;
                var IS_WRAP = type & $export.W;
                var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
                var expProto = exports[PROTOTYPE];
                var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
                var key, own, out;
                if (IS_GLOBAL) source = name;
                for (key in source) {
                    // contains in native
                    own = !IS_FORCED && target && target[key] !== undefined;
                    if (own && has(exports, key)) continue;
                    // export native or passed
                    out = own ? target[key] : source[key];
                    // prevent global pollution for namespaces
                    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
                        // bind timers to global for call from export context
                        : IS_BIND && own ? ctx(out, global)
                            // wrap global constructors for prevent change them in library
                            : IS_WRAP && target[key] == out ? (function (C) {
                                var F = function (a, b, c) {
                                    if (this instanceof C) {
                                        switch (arguments.length) {
                                            case 0: return new C();
                                            case 1: return new C(a);
                                            case 2: return new C(a, b);
                                        } return new C(a, b, c);
                                    } return C.apply(this, arguments);
                                };
                                F[PROTOTYPE] = C[PROTOTYPE];
                                return F;
                                // make static versions for prototype methods
                            })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
                    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
                    if (IS_PROTO) {
                        (exports.virtual || (exports.virtual = {}))[key] = out;
                        // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
                        if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
                    }
                }
            };
// type bitmap
            $export.F = 1;   // forced
            $export.G = 2;   // global
            $export.S = 4;   // static
            $export.P = 8;   // proto
            $export.B = 16;  // bind
            $export.W = 32;  // wrap
            $export.U = 64;  // safe
            $export.R = 128; // real proto method for `library`
            module.exports = $export;


            /***/ }),

        /***/ 7929:
        /***/ ((module) => {

            module.exports = function (exec) {
                try {
                    return !!exec();
                } catch (e) {
                    return true;
                }
            };


            /***/ }),

        /***/ 3938:
        /***/ ((module) => {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
            var global = module.exports = typeof window != 'undefined' && window.Math == Math
                ? window : typeof self != 'undefined' && self.Math == Math ? self
                    // eslint-disable-next-line no-new-func
                    : Function('return this')();
            if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


            /***/ }),

        /***/ 7069:
        /***/ ((module) => {

            var hasOwnProperty = {}.hasOwnProperty;
            module.exports = function (it, key) {
                return hasOwnProperty.call(it, key);
            };


            /***/ }),

        /***/ 1818:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var dP = __webpack_require__(4743);
            var createDesc = __webpack_require__(3101);
            module.exports = __webpack_require__(9666) ? function (object, key, value) {
                return dP.f(object, key, createDesc(1, value));
            } : function (object, key, value) {
                object[key] = value;
                return object;
            };


            /***/ }),

        /***/ 3758:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            module.exports = !__webpack_require__(9666) && !__webpack_require__(7929)(function () {
                return Object.defineProperty(__webpack_require__(7467)('div'), 'a', { get: function () { return 7; } }).a != 7;
            });


            /***/ }),

        /***/ 6727:
        /***/ ((module) => {

            module.exports = function (it) {
                return typeof it === 'object' ? it !== null : typeof it === 'function';
            };


            /***/ }),

        /***/ 4743:
        /***/ ((__unused_webpack_module, exports, __webpack_require__) => {

            var anObject = __webpack_require__(2159);
            var IE8_DOM_DEFINE = __webpack_require__(3758);
            var toPrimitive = __webpack_require__(3206);
            var dP = Object.defineProperty;

            exports.f = __webpack_require__(9666) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPrimitive(P, true);
                anObject(Attributes);
                if (IE8_DOM_DEFINE) try {
                    return dP(O, P, Attributes);
                } catch (e) { /* empty */ }
                if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
                if ('value' in Attributes) O[P] = Attributes.value;
                return O;
            };


            /***/ }),

        /***/ 3101:
        /***/ ((module) => {

            module.exports = function (bitmap, value) {
                return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value
                };
            };


            /***/ }),

        /***/ 3206:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 7.1.1 ToPrimitive(input [, PreferredType])
            var isObject = __webpack_require__(6727);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
            module.exports = function (it, S) {
                if (!isObject(it)) return it;
                var fn, val;
                if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
                if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                throw TypeError("Can't convert object to primitive value");
            };


            /***/ }),

        /***/ 4579:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// https://github.com/tc39/proposal-global
            var $export = __webpack_require__(3856);

            $export($export.G, { global: __webpack_require__(3938) });


            /***/ }),

        /***/ 4963:
        /***/ ((module) => {

            module.exports = function (it) {
                if (typeof it != 'function') throw TypeError(it + ' is not a function!');
                return it;
            };


            /***/ }),

        /***/ 3365:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var cof = __webpack_require__(2032);
            module.exports = function (it, msg) {
                if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
                return +it;
            };


            /***/ }),

        /***/ 7722:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 22.1.3.31 Array.prototype[@@unscopables]
            var UNSCOPABLES = __webpack_require__(6314)('unscopables');
            var ArrayProto = Array.prototype;
            if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(7728)(ArrayProto, UNSCOPABLES, {});
            module.exports = function (key) {
                ArrayProto[UNSCOPABLES][key] = true;
            };


            /***/ }),

        /***/ 6793:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var at = __webpack_require__(4496)(true);

            // `AdvanceStringIndex` abstract operation
// https://tc39.github.io/ecma262/#sec-advancestringindex
            module.exports = function (S, index, unicode) {
                return index + (unicode ? at(S, index).length : 1);
            };


            /***/ }),

        /***/ 3328:
        /***/ ((module) => {

            module.exports = function (it, Constructor, name, forbiddenField) {
                if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
                    throw TypeError(name + ': incorrect invocation!');
                } return it;
            };


            /***/ }),

        /***/ 7007:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var isObject = __webpack_require__(5286);
            module.exports = function (it) {
                if (!isObject(it)) throw TypeError(it + ' is not an object!');
                return it;
            };


            /***/ }),

        /***/ 5216:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";
// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)

            var toObject = __webpack_require__(508);
            var toAbsoluteIndex = __webpack_require__(2337);
            var toLength = __webpack_require__(875);

            module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
                var O = toObject(this);
                var len = toLength(O.length);
                var to = toAbsoluteIndex(target, len);
                var from = toAbsoluteIndex(start, len);
                var end = arguments.length > 2 ? arguments[2] : undefined;
                var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
                var inc = 1;
                if (from < to && to < from + count) {
                    inc = -1;
                    from += count - 1;
                    to += count - 1;
                }
                while (count-- > 0) {
                    if (from in O) O[to] = O[from];
                    else delete O[to];
                    to += inc;
                    from += inc;
                } return O;
            };


            /***/ }),

        /***/ 6852:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";
// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)

            var toObject = __webpack_require__(508);
            var toAbsoluteIndex = __webpack_require__(2337);
            var toLength = __webpack_require__(875);
            module.exports = function fill(value /* , start = 0, end = @length */) {
                var O = toObject(this);
                var length = toLength(O.length);
                var aLen = arguments.length;
                var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
                var end = aLen > 2 ? arguments[2] : undefined;
                var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
                while (endPos > index) O[index++] = value;
                return O;
            };


            /***/ }),

        /***/ 9315:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// false -> Array#indexOf
// true  -> Array#includes
            var toIObject = __webpack_require__(2110);
            var toLength = __webpack_require__(875);
            var toAbsoluteIndex = __webpack_require__(2337);
            module.exports = function (IS_INCLUDES) {
                return function ($this, el, fromIndex) {
                    var O = toIObject($this);
                    var length = toLength(O.length);
                    var index = toAbsoluteIndex(fromIndex, length);
                    var value;
                    // Array#includes uses SameValueZero equality algorithm
                    // eslint-disable-next-line no-self-compare
                    if (IS_INCLUDES && el != el) while (length > index) {
                        value = O[index++];
                        // eslint-disable-next-line no-self-compare
                        if (value != value) return true;
                        // Array#indexOf ignores holes, Array#includes - not
                    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
                        if (O[index] === el) return IS_INCLUDES || index || 0;
                    } return !IS_INCLUDES && -1;
                };
            };


            /***/ }),

        /***/ 50:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 0 -> Array#forEach
// 1 -> Array#map
// 2 -> Array#filter
// 3 -> Array#some
// 4 -> Array#every
// 5 -> Array#find
// 6 -> Array#findIndex
            var ctx = __webpack_require__(741);
            var IObject = __webpack_require__(9797);
            var toObject = __webpack_require__(508);
            var toLength = __webpack_require__(875);
            var asc = __webpack_require__(6886);
            module.exports = function (TYPE, $create) {
                var IS_MAP = TYPE == 1;
                var IS_FILTER = TYPE == 2;
                var IS_SOME = TYPE == 3;
                var IS_EVERY = TYPE == 4;
                var IS_FIND_INDEX = TYPE == 6;
                var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
                var create = $create || asc;
                return function ($this, callbackfn, that) {
                    var O = toObject($this);
                    var self = IObject(O);
                    var f = ctx(callbackfn, that, 3);
                    var length = toLength(self.length);
                    var index = 0;
                    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
                    var val, res;
                    for (;length > index; index++) if (NO_HOLES || index in self) {
                        val = self[index];
                        res = f(val, index, O);
                        if (TYPE) {
                            if (IS_MAP) result[index] = res;   // map
                            else if (res) switch (TYPE) {
                                case 3: return true;             // some
                                case 5: return val;              // find
                                case 6: return index;            // findIndex
                                case 2: result.push(val);        // filter
                            } else if (IS_EVERY) return false; // every
                        }
                    }
                    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
                };
            };


            /***/ }),

        /***/ 7628:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var aFunction = __webpack_require__(4963);
            var toObject = __webpack_require__(508);
            var IObject = __webpack_require__(9797);
            var toLength = __webpack_require__(875);

            module.exports = function (that, callbackfn, aLen, memo, isRight) {
                aFunction(callbackfn);
                var O = toObject(that);
                var self = IObject(O);
                var length = toLength(O.length);
                var index = isRight ? length - 1 : 0;
                var i = isRight ? -1 : 1;
                if (aLen < 2) for (;;) {
                    if (index in self) {
                        memo = self[index];
                        index += i;
                        break;
                    }
                    index += i;
                    if (isRight ? index < 0 : length <= index) {
                        throw TypeError('Reduce of empty array with no initial value');
                    }
                }
                for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
                    memo = callbackfn(memo, self[index], index, O);
                }
                return memo;
            };


            /***/ }),

        /***/ 2736:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var isObject = __webpack_require__(5286);
            var isArray = __webpack_require__(4302);
            var SPECIES = __webpack_require__(6314)('species');

            module.exports = function (original) {
                var C;
                if (isArray(original)) {
                    C = original.constructor;
                    // cross-realm fallback
                    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
                    if (isObject(C)) {
                        C = C[SPECIES];
                        if (C === null) C = undefined;
                    }
                } return C === undefined ? Array : C;
            };


            /***/ }),

        /***/ 6886:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
            var speciesConstructor = __webpack_require__(2736);

            module.exports = function (original, length) {
                return new (speciesConstructor(original))(length);
            };


            /***/ }),

        /***/ 4398:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var aFunction = __webpack_require__(4963);
            var isObject = __webpack_require__(5286);
            var invoke = __webpack_require__(7242);
            var arraySlice = [].slice;
            var factories = {};

            var construct = function (F, len, args) {
                if (!(len in factories)) {
                    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
                    // eslint-disable-next-line no-new-func
                    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
                } return factories[len](F, args);
            };

            module.exports = Function.bind || function bind(that /* , ...args */) {
                var fn = aFunction(this);
                var partArgs = arraySlice.call(arguments, 1);
                var bound = function (/* args... */) {
                    var args = partArgs.concat(arraySlice.call(arguments));
                    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
                };
                if (isObject(fn.prototype)) bound.prototype = fn.prototype;
                return bound;
            };


            /***/ }),

        /***/ 1488:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// getting tag from 19.1.3.6 Object.prototype.toString()
            var cof = __webpack_require__(2032);
            var TAG = __webpack_require__(6314)('toStringTag');
// ES3 wrong here
            var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
            var tryGet = function (it, key) {
                try {
                    return it[key];
                } catch (e) { /* empty */ }
            };

            module.exports = function (it) {
                var O, T, B;
                return it === undefined ? 'Undefined' : it === null ? 'Null'
                    // @@toStringTag case
                    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
                        // builtinTag case
                        : ARG ? cof(O)
                            // ES3 arguments fallback
                            : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
            };


            /***/ }),

        /***/ 2032:
        /***/ ((module) => {

            var toString = {}.toString;

            module.exports = function (it) {
                return toString.call(it).slice(8, -1);
            };


            /***/ }),

        /***/ 9824:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var dP = (__webpack_require__(9275).f);
            var create = __webpack_require__(2503);
            var redefineAll = __webpack_require__(4408);
            var ctx = __webpack_require__(741);
            var anInstance = __webpack_require__(3328);
            var forOf = __webpack_require__(3531);
            var $iterDefine = __webpack_require__(2923);
            var step = __webpack_require__(5436);
            var setSpecies = __webpack_require__(2974);
            var DESCRIPTORS = __webpack_require__(7057);
            var fastKey = (__webpack_require__(4728).fastKey);
            var validate = __webpack_require__(1616);
            var SIZE = DESCRIPTORS ? '_s' : 'size';

            var getEntry = function (that, key) {
                // fast case
                var index = fastKey(key);
                var entry;
                if (index !== 'F') return that._i[index];
                // frozen object case
                for (entry = that._f; entry; entry = entry.n) {
                    if (entry.k == key) return entry;
                }
            };

            module.exports = {
                getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
                    var C = wrapper(function (that, iterable) {
                        anInstance(that, C, NAME, '_i');
                        that._t = NAME;         // collection type
                        that._i = create(null); // index
                        that._f = undefined;    // first entry
                        that._l = undefined;    // last entry
                        that[SIZE] = 0;         // size
                        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
                    });
                    redefineAll(C.prototype, {
                        // 23.1.3.1 Map.prototype.clear()
                        // 23.2.3.2 Set.prototype.clear()
                        clear: function clear() {
                            for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
                                entry.r = true;
                                if (entry.p) entry.p = entry.p.n = undefined;
                                delete data[entry.i];
                            }
                            that._f = that._l = undefined;
                            that[SIZE] = 0;
                        },
                        // 23.1.3.3 Map.prototype.delete(key)
                        // 23.2.3.4 Set.prototype.delete(value)
                        'delete': function (key) {
                            var that = validate(this, NAME);
                            var entry = getEntry(that, key);
                            if (entry) {
                                var next = entry.n;
                                var prev = entry.p;
                                delete that._i[entry.i];
                                entry.r = true;
                                if (prev) prev.n = next;
                                if (next) next.p = prev;
                                if (that._f == entry) that._f = next;
                                if (that._l == entry) that._l = prev;
                                that[SIZE]--;
                            } return !!entry;
                        },
                        // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
                        // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
                        forEach: function forEach(callbackfn /* , that = undefined */) {
                            validate(this, NAME);
                            var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
                            var entry;
                            while (entry = entry ? entry.n : this._f) {
                                f(entry.v, entry.k, this);
                                // revert to the last existing entry
                                while (entry && entry.r) entry = entry.p;
                            }
                        },
                        // 23.1.3.7 Map.prototype.has(key)
                        // 23.2.3.7 Set.prototype.has(value)
                        has: function has(key) {
                            return !!getEntry(validate(this, NAME), key);
                        }
                    });
                    if (DESCRIPTORS) dP(C.prototype, 'size', {
                        get: function () {
                            return validate(this, NAME)[SIZE];
                        }
                    });
                    return C;
                },
                def: function (that, key, value) {
                    var entry = getEntry(that, key);
                    var prev, index;
                    // change existing entry
                    if (entry) {
                        entry.v = value;
                        // create new entry
                    } else {
                        that._l = entry = {
                            i: index = fastKey(key, true), // <- index
                            k: key,                        // <- key
                            v: value,                      // <- value
                            p: prev = that._l,             // <- previous entry
                            n: undefined,                  // <- next entry
                            r: false                       // <- removed
                        };
                        if (!that._f) that._f = entry;
                        if (prev) prev.n = entry;
                        that[SIZE]++;
                        // add to index
                        if (index !== 'F') that._i[index] = entry;
                    } return that;
                },
                getEntry: getEntry,
                setStrong: function (C, NAME, IS_MAP) {
                    // add .keys, .values, .entries, [@@iterator]
                    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
                    $iterDefine(C, NAME, function (iterated, kind) {
                        this._t = validate(iterated, NAME); // target
                        this._k = kind;                     // kind
                        this._l = undefined;                // previous
                    }, function () {
                        var that = this;
                        var kind = that._k;
                        var entry = that._l;
                        // revert to the last existing entry
                        while (entry && entry.r) entry = entry.p;
                        // get next entry
                        if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
                            // or finish the iteration
                            that._t = undefined;
                            return step(1);
                        }
                        // return step by kind
                        if (kind == 'keys') return step(0, entry.k);
                        if (kind == 'values') return step(0, entry.v);
                        return step(0, [entry.k, entry.v]);
                    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

                    // add [@@species], 23.1.2.2, 23.2.2.2
                    setSpecies(NAME);
                }
            };


            /***/ }),

        /***/ 3657:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var redefineAll = __webpack_require__(4408);
            var getWeak = (__webpack_require__(4728).getWeak);
            var anObject = __webpack_require__(7007);
            var isObject = __webpack_require__(5286);
            var anInstance = __webpack_require__(3328);
            var forOf = __webpack_require__(3531);
            var createArrayMethod = __webpack_require__(50);
            var $has = __webpack_require__(9181);
            var validate = __webpack_require__(1616);
            var arrayFind = createArrayMethod(5);
            var arrayFindIndex = createArrayMethod(6);
            var id = 0;

// fallback for uncaught frozen keys
            var uncaughtFrozenStore = function (that) {
                return that._l || (that._l = new UncaughtFrozenStore());
            };
            var UncaughtFrozenStore = function () {
                this.a = [];
            };
            var findUncaughtFrozen = function (store, key) {
                return arrayFind(store.a, function (it) {
                    return it[0] === key;
                });
            };
            UncaughtFrozenStore.prototype = {
                get: function (key) {
                    var entry = findUncaughtFrozen(this, key);
                    if (entry) return entry[1];
                },
                has: function (key) {
                    return !!findUncaughtFrozen(this, key);
                },
                set: function (key, value) {
                    var entry = findUncaughtFrozen(this, key);
                    if (entry) entry[1] = value;
                    else this.a.push([key, value]);
                },
                'delete': function (key) {
                    var index = arrayFindIndex(this.a, function (it) {
                        return it[0] === key;
                    });
                    if (~index) this.a.splice(index, 1);
                    return !!~index;
                }
            };

            module.exports = {
                getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
                    var C = wrapper(function (that, iterable) {
                        anInstance(that, C, NAME, '_i');
                        that._t = NAME;      // collection type
                        that._i = id++;      // collection id
                        that._l = undefined; // leak store for uncaught frozen objects
                        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
                    });
                    redefineAll(C.prototype, {
                        // 23.3.3.2 WeakMap.prototype.delete(key)
                        // 23.4.3.3 WeakSet.prototype.delete(value)
                        'delete': function (key) {
                            if (!isObject(key)) return false;
                            var data = getWeak(key);
                            if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
                            return data && $has(data, this._i) && delete data[this._i];
                        },
                        // 23.3.3.4 WeakMap.prototype.has(key)
                        // 23.4.3.4 WeakSet.prototype.has(value)
                        has: function has(key) {
                            if (!isObject(key)) return false;
                            var data = getWeak(key);
                            if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
                            return data && $has(data, this._i);
                        }
                    });
                    return C;
                },
                def: function (that, key, value) {
                    var data = getWeak(anObject(key), true);
                    if (data === true) uncaughtFrozenStore(that).set(key, value);
                    else data[that._i] = value;
                    return that;
                },
                ufstore: uncaughtFrozenStore
            };


            /***/ }),

        /***/ 5795:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var global = __webpack_require__(3816);
            var $export = __webpack_require__(2985);
            var redefine = __webpack_require__(7234);
            var redefineAll = __webpack_require__(4408);
            var meta = __webpack_require__(4728);
            var forOf = __webpack_require__(3531);
            var anInstance = __webpack_require__(3328);
            var isObject = __webpack_require__(5286);
            var fails = __webpack_require__(4253);
            var $iterDetect = __webpack_require__(7462);
            var setToStringTag = __webpack_require__(2943);
            var inheritIfRequired = __webpack_require__(266);

            module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
                var Base = global[NAME];
                var C = Base;
                var ADDER = IS_MAP ? 'set' : 'add';
                var proto = C && C.prototype;
                var O = {};
                var fixMethod = function (KEY) {
                    var fn = proto[KEY];
                    redefine(proto, KEY,
                        KEY == 'delete' ? function (a) {
                            return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
                        } : KEY == 'has' ? function has(a) {
                            return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
                        } : KEY == 'get' ? function get(a) {
                            return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
                        } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
                            : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
                    );
                };
                if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
                    new C().entries().next();
                }))) {
                    // create collection constructor
                    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
                    redefineAll(C.prototype, methods);
                    meta.NEED = true;
                } else {
                    var instance = new C();
                    // early implementations not supports chaining
                    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
                    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
                    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
                    // most early implementations doesn't supports iterables, most modern - not close it correctly
                    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
                    // for early implementations -0 and +0 not the same
                    var BUGGY_ZERO = !IS_WEAK && fails(function () {
                        // V8 ~ Chromium 42- fails only with 5+ elements
                        var $instance = new C();
                        var index = 5;
                        while (index--) $instance[ADDER](index, index);
                        return !$instance.has(-0);
                    });
                    if (!ACCEPT_ITERABLES) {
                        C = wrapper(function (target, iterable) {
                            anInstance(target, C, NAME);
                            var that = inheritIfRequired(new Base(), target, C);
                            if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
                            return that;
                        });
                        C.prototype = proto;
                        proto.constructor = C;
                    }
                    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
                        fixMethod('delete');
                        fixMethod('has');
                        IS_MAP && fixMethod('get');
                    }
                    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
                    // weak collections should not contains .clear method
                    if (IS_WEAK && proto.clear) delete proto.clear;
                }

                setToStringTag(C, NAME);

                O[NAME] = C;
                $export($export.G + $export.W + $export.F * (C != Base), O);

                if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

                return C;
            };


            /***/ }),

        /***/ 5645:
        /***/ ((module) => {

            var core = module.exports = { version: '2.6.12' };
            if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


            /***/ }),

        /***/ 2811:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $defineProperty = __webpack_require__(9275);
            var createDesc = __webpack_require__(681);

            module.exports = function (object, index, value) {
                if (index in object) $defineProperty.f(object, index, createDesc(0, value));
                else object[index] = value;
            };


            /***/ }),

        /***/ 741:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// optional / simple context binding
            var aFunction = __webpack_require__(4963);
            module.exports = function (fn, that, length) {
                aFunction(fn);
                if (that === undefined) return fn;
                switch (length) {
                    case 1: return function (a) {
                        return fn.call(that, a);
                    };
                    case 2: return function (a, b) {
                        return fn.call(that, a, b);
                    };
                    case 3: return function (a, b, c) {
                        return fn.call(that, a, b, c);
                    };
                }
                return function (/* ...args */) {
                    return fn.apply(that, arguments);
                };
            };


            /***/ }),

        /***/ 3537:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
            var fails = __webpack_require__(4253);
            var getTime = Date.prototype.getTime;
            var $toISOString = Date.prototype.toISOString;

            var lz = function (num) {
                return num > 9 ? num : '0' + num;
            };

// PhantomJS / old WebKit has a broken implementations
            module.exports = (fails(function () {
                return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
            }) || !fails(function () {
                $toISOString.call(new Date(NaN));
            })) ? function toISOString() {
                if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
                var d = this;
                var y = d.getUTCFullYear();
                var m = d.getUTCMilliseconds();
                var s = y < 0 ? '-' : y > 9999 ? '+' : '';
                return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
                    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
                    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
                    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
            } : $toISOString;


            /***/ }),

        /***/ 870:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var anObject = __webpack_require__(7007);
            var toPrimitive = __webpack_require__(1689);
            var NUMBER = 'number';

            module.exports = function (hint) {
                if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
                return toPrimitive(anObject(this), hint != NUMBER);
            };


            /***/ }),

        /***/ 1355:
        /***/ ((module) => {

// 7.2.1 RequireObjectCoercible(argument)
            module.exports = function (it) {
                if (it == undefined) throw TypeError("Can't call method on  " + it);
                return it;
            };


            /***/ }),

        /***/ 7057:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// Thank's IE8 for his funny defineProperty
            module.exports = !__webpack_require__(4253)(function () {
                return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
            });


            /***/ }),

        /***/ 2457:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var isObject = __webpack_require__(5286);
            var document = (__webpack_require__(3816).document);
// typeof document.createElement is 'object' in old IE
            var is = isObject(document) && isObject(document.createElement);
            module.exports = function (it) {
                return is ? document.createElement(it) : {};
            };


            /***/ }),

        /***/ 4430:
        /***/ ((module) => {

// IE 8- don't enum bug keys
            module.exports = (
                'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
            ).split(',');


            /***/ }),

        /***/ 5541:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// all enumerable object keys, includes symbols
            var getKeys = __webpack_require__(7184);
            var gOPS = __webpack_require__(4548);
            var pIE = __webpack_require__(4682);
            module.exports = function (it) {
                var result = getKeys(it);
                var getSymbols = gOPS.f;
                if (getSymbols) {
                    var symbols = getSymbols(it);
                    var isEnum = pIE.f;
                    var i = 0;
                    var key;
                    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
                } return result;
            };


            /***/ }),

        /***/ 2985:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var global = __webpack_require__(3816);
            var core = __webpack_require__(5645);
            var hide = __webpack_require__(7728);
            var redefine = __webpack_require__(7234);
            var ctx = __webpack_require__(741);
            var PROTOTYPE = 'prototype';

            var $export = function (type, name, source) {
                var IS_FORCED = type & $export.F;
                var IS_GLOBAL = type & $export.G;
                var IS_STATIC = type & $export.S;
                var IS_PROTO = type & $export.P;
                var IS_BIND = type & $export.B;
                var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
                var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
                var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
                var key, own, out, exp;
                if (IS_GLOBAL) source = name;
                for (key in source) {
                    // contains in native
                    own = !IS_FORCED && target && target[key] !== undefined;
                    // export native or passed
                    out = (own ? target : source)[key];
                    // bind timers to global for call from export context
                    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
                    // extend global
                    if (target) redefine(target, key, out, type & $export.U);
                    // export
                    if (exports[key] != out) hide(exports, key, exp);
                    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
                }
            };
            global.core = core;
// type bitmap
            $export.F = 1;   // forced
            $export.G = 2;   // global
            $export.S = 4;   // static
            $export.P = 8;   // proto
            $export.B = 16;  // bind
            $export.W = 32;  // wrap
            $export.U = 64;  // safe
            $export.R = 128; // real proto method for `library`
            module.exports = $export;


            /***/ }),

        /***/ 8852:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var MATCH = __webpack_require__(6314)('match');
            module.exports = function (KEY) {
                var re = /./;
                try {
                    '/./'[KEY](re);
                } catch (e) {
                    try {
                        re[MATCH] = false;
                        return !'/./'[KEY](re);
                    } catch (f) { /* empty */ }
                } return true;
            };


            /***/ }),

        /***/ 4253:
        /***/ ((module) => {

            module.exports = function (exec) {
                try {
                    return !!exec();
                } catch (e) {
                    return true;
                }
            };


            /***/ }),

        /***/ 8082:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            __webpack_require__(8269);
            var redefine = __webpack_require__(7234);
            var hide = __webpack_require__(7728);
            var fails = __webpack_require__(4253);
            var defined = __webpack_require__(1355);
            var wks = __webpack_require__(6314);
            var regexpExec = __webpack_require__(1165);

            var SPECIES = wks('species');

            var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
                // #replace needs built-in support for named groups.
                // #match works fine because it just return the exec results, even if it has
                // a "grops" property.
                var re = /./;
                re.exec = function () {
                    var result = [];
                    result.groups = { a: '7' };
                    return result;
                };
                return ''.replace(re, '$<a>') !== '7';
            });

            var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
                // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
                var re = /(?:)/;
                var originalExec = re.exec;
                re.exec = function () { return originalExec.apply(this, arguments); };
                var result = 'ab'.split(re);
                return result.length === 2 && result[0] === 'a' && result[1] === 'b';
            })();

            module.exports = function (KEY, length, exec) {
                var SYMBOL = wks(KEY);

                var DELEGATES_TO_SYMBOL = !fails(function () {
                    // String methods call symbol-named RegEp methods
                    var O = {};
                    O[SYMBOL] = function () { return 7; };
                    return ''[KEY](O) != 7;
                });

                var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
                    // Symbol-named RegExp methods call .exec
                    var execCalled = false;
                    var re = /a/;
                    re.exec = function () { execCalled = true; return null; };
                    if (KEY === 'split') {
                        // RegExp[@@split] doesn't call the regex's exec method, but first creates
                        // a new one. We need to return the patched regex when creating the new one.
                        re.constructor = {};
                        re.constructor[SPECIES] = function () { return re; };
                    }
                    re[SYMBOL]('');
                    return !execCalled;
                }) : undefined;

                if (
                    !DELEGATES_TO_SYMBOL ||
                    !DELEGATES_TO_EXEC ||
                    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
                    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
                ) {
                    var nativeRegExpMethod = /./[SYMBOL];
                    var fns = exec(
                        defined,
                        SYMBOL,
                        ''[KEY],
                        function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
                            if (regexp.exec === regexpExec) {
                                if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
                                    // The native String method already delegates to @@method (this
                                    // polyfilled function), leasing to infinite recursion.
                                    // We avoid it by directly calling the native @@method method.
                                    return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
                                }
                                return { done: true, value: nativeMethod.call(str, regexp, arg2) };
                            }
                            return { done: false };
                        }
                    );
                    var strfn = fns[0];
                    var rxfn = fns[1];

                    redefine(String.prototype, KEY, strfn);
                    hide(RegExp.prototype, SYMBOL, length == 2
                        // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
                        // 21.2.5.11 RegExp.prototype[@@split](string, limit)
                        ? function (string, arg) { return rxfn.call(string, this, arg); }
                        // 21.2.5.6 RegExp.prototype[@@match](string)
                        // 21.2.5.9 RegExp.prototype[@@search](string)
                        : function (string) { return rxfn.call(string, this); }
                    );
                }
            };


            /***/ }),

        /***/ 3218:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// 21.2.5.3 get RegExp.prototype.flags
            var anObject = __webpack_require__(7007);
            module.exports = function () {
                var that = anObject(this);
                var result = '';
                if (that.global) result += 'g';
                if (that.ignoreCase) result += 'i';
                if (that.multiline) result += 'm';
                if (that.unicode) result += 'u';
                if (that.sticky) result += 'y';
                return result;
            };


            /***/ }),

        /***/ 3325:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
            var isArray = __webpack_require__(4302);
            var isObject = __webpack_require__(5286);
            var toLength = __webpack_require__(875);
            var ctx = __webpack_require__(741);
            var IS_CONCAT_SPREADABLE = __webpack_require__(6314)('isConcatSpreadable');

            function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
                var targetIndex = start;
                var sourceIndex = 0;
                var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
                var element, spreadable;

                while (sourceIndex < sourceLen) {
                    if (sourceIndex in source) {
                        element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

                        spreadable = false;
                        if (isObject(element)) {
                            spreadable = element[IS_CONCAT_SPREADABLE];
                            spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
                        }

                        if (spreadable && depth > 0) {
                            targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
                        } else {
                            if (targetIndex >= 0x1fffffffffffff) throw TypeError();
                            target[targetIndex] = element;
                        }

                        targetIndex++;
                    }
                    sourceIndex++;
                }
                return targetIndex;
            }

            module.exports = flattenIntoArray;


            /***/ }),

        /***/ 3531:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var ctx = __webpack_require__(741);
            var call = __webpack_require__(8851);
            var isArrayIter = __webpack_require__(6555);
            var anObject = __webpack_require__(7007);
            var toLength = __webpack_require__(875);
            var getIterFn = __webpack_require__(9002);
            var BREAK = {};
            var RETURN = {};
            var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
                var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
                var f = ctx(fn, that, entries ? 2 : 1);
                var index = 0;
                var length, step, iterator, result;
                if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
                // fast case for arrays with default iterator
                if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
                    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
                    if (result === BREAK || result === RETURN) return result;
                } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
                    result = call(iterator, f, step.value, entries);
                    if (result === BREAK || result === RETURN) return result;
                }
            };
            exports.BREAK = BREAK;
            exports.RETURN = RETURN;


            /***/ }),

        /***/ 18:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            module.exports = __webpack_require__(3825)('native-function-to-string', Function.toString);


            /***/ }),

        /***/ 3816:
        /***/ ((module) => {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
            var global = module.exports = typeof window != 'undefined' && window.Math == Math
                ? window : typeof self != 'undefined' && self.Math == Math ? self
                    // eslint-disable-next-line no-new-func
                    : Function('return this')();
            if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


            /***/ }),

        /***/ 9181:
        /***/ ((module) => {

            var hasOwnProperty = {}.hasOwnProperty;
            module.exports = function (it, key) {
                return hasOwnProperty.call(it, key);
            };


            /***/ }),

        /***/ 7728:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var dP = __webpack_require__(9275);
            var createDesc = __webpack_require__(681);
            module.exports = __webpack_require__(7057) ? function (object, key, value) {
                return dP.f(object, key, createDesc(1, value));
            } : function (object, key, value) {
                object[key] = value;
                return object;
            };


            /***/ }),

        /***/ 639:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var document = (__webpack_require__(3816).document);
            module.exports = document && document.documentElement;


            /***/ }),

        /***/ 1734:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            module.exports = !__webpack_require__(7057) && !__webpack_require__(4253)(function () {
                return Object.defineProperty(__webpack_require__(2457)('div'), 'a', { get: function () { return 7; } }).a != 7;
            });


            /***/ }),

        /***/ 266:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var isObject = __webpack_require__(5286);
            var setPrototypeOf = (__webpack_require__(7375).set);
            module.exports = function (that, target, C) {
                var S = target.constructor;
                var P;
                if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
                    setPrototypeOf(that, P);
                } return that;
            };


            /***/ }),

        /***/ 7242:
        /***/ ((module) => {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
            module.exports = function (fn, args, that) {
                var un = that === undefined;
                switch (args.length) {
                    case 0: return un ? fn()
                        : fn.call(that);
                    case 1: return un ? fn(args[0])
                        : fn.call(that, args[0]);
                    case 2: return un ? fn(args[0], args[1])
                        : fn.call(that, args[0], args[1]);
                    case 3: return un ? fn(args[0], args[1], args[2])
                        : fn.call(that, args[0], args[1], args[2]);
                    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                        : fn.call(that, args[0], args[1], args[2], args[3]);
                } return fn.apply(that, args);
            };


            /***/ }),

        /***/ 9797:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
            var cof = __webpack_require__(2032);
// eslint-disable-next-line no-prototype-builtins
            module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
                return cof(it) == 'String' ? it.split('') : Object(it);
            };


            /***/ }),

        /***/ 6555:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// check on default Array iterator
            var Iterators = __webpack_require__(2803);
            var ITERATOR = __webpack_require__(6314)('iterator');
            var ArrayProto = Array.prototype;

            module.exports = function (it) {
                return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
            };


            /***/ }),

        /***/ 4302:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 7.2.2 IsArray(argument)
            var cof = __webpack_require__(2032);
            module.exports = Array.isArray || function isArray(arg) {
                return cof(arg) == 'Array';
            };


            /***/ }),

        /***/ 8367:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 20.1.2.3 Number.isInteger(number)
            var isObject = __webpack_require__(5286);
            var floor = Math.floor;
            module.exports = function isInteger(it) {
                return !isObject(it) && isFinite(it) && floor(it) === it;
            };


            /***/ }),

        /***/ 5286:
        /***/ ((module) => {

            module.exports = function (it) {
                return typeof it === 'object' ? it !== null : typeof it === 'function';
            };


            /***/ }),

        /***/ 5364:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 7.2.8 IsRegExp(argument)
            var isObject = __webpack_require__(5286);
            var cof = __webpack_require__(2032);
            var MATCH = __webpack_require__(6314)('match');
            module.exports = function (it) {
                var isRegExp;
                return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
            };


            /***/ }),

        /***/ 8851:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// call something on iterator step with safe closing on error
            var anObject = __webpack_require__(7007);
            module.exports = function (iterator, fn, value, entries) {
                try {
                    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
                    // 7.4.6 IteratorClose(iterator, completion)
                } catch (e) {
                    var ret = iterator['return'];
                    if (ret !== undefined) anObject(ret.call(iterator));
                    throw e;
                }
            };


            /***/ }),

        /***/ 9988:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var create = __webpack_require__(2503);
            var descriptor = __webpack_require__(681);
            var setToStringTag = __webpack_require__(2943);
            var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
            __webpack_require__(7728)(IteratorPrototype, __webpack_require__(6314)('iterator'), function () { return this; });

            module.exports = function (Constructor, NAME, next) {
                Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
                setToStringTag(Constructor, NAME + ' Iterator');
            };


            /***/ }),

        /***/ 2923:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var LIBRARY = __webpack_require__(4461);
            var $export = __webpack_require__(2985);
            var redefine = __webpack_require__(7234);
            var hide = __webpack_require__(7728);
            var Iterators = __webpack_require__(2803);
            var $iterCreate = __webpack_require__(9988);
            var setToStringTag = __webpack_require__(2943);
            var getPrototypeOf = __webpack_require__(468);
            var ITERATOR = __webpack_require__(6314)('iterator');
            var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
            var FF_ITERATOR = '@@iterator';
            var KEYS = 'keys';
            var VALUES = 'values';

            var returnThis = function () { return this; };

            module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
                $iterCreate(Constructor, NAME, next);
                var getMethod = function (kind) {
                    if (!BUGGY && kind in proto) return proto[kind];
                    switch (kind) {
                        case KEYS: return function keys() { return new Constructor(this, kind); };
                        case VALUES: return function values() { return new Constructor(this, kind); };
                    } return function entries() { return new Constructor(this, kind); };
                };
                var TAG = NAME + ' Iterator';
                var DEF_VALUES = DEFAULT == VALUES;
                var VALUES_BUG = false;
                var proto = Base.prototype;
                var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
                var $default = $native || getMethod(DEFAULT);
                var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
                var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
                var methods, key, IteratorPrototype;
                // Fix native
                if ($anyNative) {
                    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
                    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
                        // Set @@toStringTag to native iterators
                        setToStringTag(IteratorPrototype, TAG, true);
                        // fix for some old engines
                        if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
                    }
                }
                // fix Array#{values, @@iterator}.name in V8 / FF
                if (DEF_VALUES && $native && $native.name !== VALUES) {
                    VALUES_BUG = true;
                    $default = function values() { return $native.call(this); };
                }
                // Define iterator
                if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
                    hide(proto, ITERATOR, $default);
                }
                // Plug for library
                Iterators[NAME] = $default;
                Iterators[TAG] = returnThis;
                if (DEFAULT) {
                    methods = {
                        values: DEF_VALUES ? $default : getMethod(VALUES),
                        keys: IS_SET ? $default : getMethod(KEYS),
                        entries: $entries
                    };
                    if (FORCED) for (key in methods) {
                        if (!(key in proto)) redefine(proto, key, methods[key]);
                    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
                }
                return methods;
            };


            /***/ }),

        /***/ 7462:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var ITERATOR = __webpack_require__(6314)('iterator');
            var SAFE_CLOSING = false;

            try {
                var riter = [7][ITERATOR]();
                riter['return'] = function () { SAFE_CLOSING = true; };
                // eslint-disable-next-line no-throw-literal
                Array.from(riter, function () { throw 2; });
            } catch (e) { /* empty */ }

            module.exports = function (exec, skipClosing) {
                if (!skipClosing && !SAFE_CLOSING) return false;
                var safe = false;
                try {
                    var arr = [7];
                    var iter = arr[ITERATOR]();
                    iter.next = function () { return { done: safe = true }; };
                    arr[ITERATOR] = function () { return iter; };
                    exec(arr);
                } catch (e) { /* empty */ }
                return safe;
            };


            /***/ }),

        /***/ 5436:
        /***/ ((module) => {

            module.exports = function (done, value) {
                return { value: value, done: !!done };
            };


            /***/ }),

        /***/ 2803:
        /***/ ((module) => {

            module.exports = {};


            /***/ }),

        /***/ 4461:
        /***/ ((module) => {

            module.exports = false;


            /***/ }),

        /***/ 3086:
        /***/ ((module) => {

// 20.2.2.14 Math.expm1(x)
            var $expm1 = Math.expm1;
            module.exports = (!$expm1
                // Old FF bug
                || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
                // Tor Browser bug
                || $expm1(-2e-17) != -2e-17
            ) ? function expm1(x) {
                return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
            } : $expm1;


            /***/ }),

        /***/ 4934:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.16 Math.fround(x)
            var sign = __webpack_require__(1801);
            var pow = Math.pow;
            var EPSILON = pow(2, -52);
            var EPSILON32 = pow(2, -23);
            var MAX32 = pow(2, 127) * (2 - EPSILON32);
            var MIN32 = pow(2, -126);

            var roundTiesToEven = function (n) {
                return n + 1 / EPSILON - 1 / EPSILON;
            };

            module.exports = Math.fround || function fround(x) {
                var $abs = Math.abs(x);
                var $sign = sign(x);
                var a, result;
                if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
                a = (1 + EPSILON32 / EPSILON) * $abs;
                result = a - (a - $abs);
                // eslint-disable-next-line no-self-compare
                if (result > MAX32 || result != result) return $sign * Infinity;
                return $sign * result;
            };


            /***/ }),

        /***/ 6206:
        /***/ ((module) => {

// 20.2.2.20 Math.log1p(x)
            module.exports = Math.log1p || function log1p(x) {
                return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
            };


            /***/ }),

        /***/ 1801:
        /***/ ((module) => {

// 20.2.2.28 Math.sign(x)
            module.exports = Math.sign || function sign(x) {
                // eslint-disable-next-line no-self-compare
                return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
            };


            /***/ }),

        /***/ 4728:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var META = __webpack_require__(3953)('meta');
            var isObject = __webpack_require__(5286);
            var has = __webpack_require__(9181);
            var setDesc = (__webpack_require__(9275).f);
            var id = 0;
            var isExtensible = Object.isExtensible || function () {
                return true;
            };
            var FREEZE = !__webpack_require__(4253)(function () {
                return isExtensible(Object.preventExtensions({}));
            });
            var setMeta = function (it) {
                setDesc(it, META, { value: {
                        i: 'O' + ++id, // object ID
                        w: {}          // weak collections IDs
                    } });
            };
            var fastKey = function (it, create) {
                // return primitive with prefix
                if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
                if (!has(it, META)) {
                    // can't set metadata to uncaught frozen object
                    if (!isExtensible(it)) return 'F';
                    // not necessary to add metadata
                    if (!create) return 'E';
                    // add missing metadata
                    setMeta(it);
                    // return object ID
                } return it[META].i;
            };
            var getWeak = function (it, create) {
                if (!has(it, META)) {
                    // can't set metadata to uncaught frozen object
                    if (!isExtensible(it)) return true;
                    // not necessary to add metadata
                    if (!create) return false;
                    // add missing metadata
                    setMeta(it);
                    // return hash weak collections IDs
                } return it[META].w;
            };
// add metadata on freeze-family methods calling
            var onFreeze = function (it) {
                if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
                return it;
            };
            var meta = module.exports = {
                KEY: META,
                NEED: false,
                fastKey: fastKey,
                getWeak: getWeak,
                onFreeze: onFreeze
            };


            /***/ }),

        /***/ 4351:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var global = __webpack_require__(3816);
            var macrotask = (__webpack_require__(4193).set);
            var Observer = global.MutationObserver || global.WebKitMutationObserver;
            var process = global.process;
            var Promise = global.Promise;
            var isNode = __webpack_require__(2032)(process) == 'process';

            module.exports = function () {
                var head, last, notify;

                var flush = function () {
                    var parent, fn;
                    if (isNode && (parent = process.domain)) parent.exit();
                    while (head) {
                        fn = head.fn;
                        head = head.next;
                        try {
                            fn();
                        } catch (e) {
                            if (head) notify();
                            else last = undefined;
                            throw e;
                        }
                    } last = undefined;
                    if (parent) parent.enter();
                };

                // Node.js
                if (isNode) {
                    notify = function () {
                        process.nextTick(flush);
                    };
                    // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
                } else if (Observer && !(global.navigator && global.navigator.standalone)) {
                    var toggle = true;
                    var node = document.createTextNode('');
                    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
                    notify = function () {
                        node.data = toggle = !toggle;
                    };
                    // environments with maybe non-completely correct, but existent Promise
                } else if (Promise && Promise.resolve) {
                    // Promise.resolve without an argument throws an error in LG WebOS 2
                    var promise = Promise.resolve(undefined);
                    notify = function () {
                        promise.then(flush);
                    };
                    // for other environments - macrotask based on:
                    // - setImmediate
                    // - MessageChannel
                    // - window.postMessag
                    // - onreadystatechange
                    // - setTimeout
                } else {
                    notify = function () {
                        // strange IE + webpack dev server bug - use .call(global)
                        macrotask.call(global, flush);
                    };
                }

                return function (fn) {
                    var task = { fn: fn, next: undefined };
                    if (last) last.next = task;
                    if (!head) {
                        head = task;
                        notify();
                    } last = task;
                };
            };


            /***/ }),

        /***/ 3499:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// 25.4.1.5 NewPromiseCapability(C)
            var aFunction = __webpack_require__(4963);

            function PromiseCapability(C) {
                var resolve, reject;
                this.promise = new C(function ($$resolve, $$reject) {
                    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
                    resolve = $$resolve;
                    reject = $$reject;
                });
                this.resolve = aFunction(resolve);
                this.reject = aFunction(reject);
            }

            module.exports.f = function (C) {
                return new PromiseCapability(C);
            };


            /***/ }),

        /***/ 5345:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// 19.1.2.1 Object.assign(target, source, ...)
            var DESCRIPTORS = __webpack_require__(7057);
            var getKeys = __webpack_require__(7184);
            var gOPS = __webpack_require__(4548);
            var pIE = __webpack_require__(4682);
            var toObject = __webpack_require__(508);
            var IObject = __webpack_require__(9797);
            var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
            module.exports = !$assign || __webpack_require__(4253)(function () {
                var A = {};
                var B = {};
                // eslint-disable-next-line no-undef
                var S = Symbol();
                var K = 'abcdefghijklmnopqrst';
                A[S] = 7;
                K.split('').forEach(function (k) { B[k] = k; });
                return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
            }) ? function assign(target, source) { // eslint-disable-line no-unused-vars
                var T = toObject(target);
                var aLen = arguments.length;
                var index = 1;
                var getSymbols = gOPS.f;
                var isEnum = pIE.f;
                while (aLen > index) {
                    var S = IObject(arguments[index++]);
                    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
                    var length = keys.length;
                    var j = 0;
                    var key;
                    while (length > j) {
                        key = keys[j++];
                        if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
                    }
                } return T;
            } : $assign;


            /***/ }),

        /***/ 2503:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
            var anObject = __webpack_require__(7007);
            var dPs = __webpack_require__(5588);
            var enumBugKeys = __webpack_require__(4430);
            var IE_PROTO = __webpack_require__(9335)('IE_PROTO');
            var Empty = function () { /* empty */ };
            var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
            var createDict = function () {
                // Thrash, waste and sodomy: IE GC bug
                var iframe = __webpack_require__(2457)('iframe');
                var i = enumBugKeys.length;
                var lt = '<';
                var gt = '>';
                var iframeDocument;
                iframe.style.display = 'none';
                (__webpack_require__(639).appendChild)(iframe);
                iframe.src = 'javascript:'; // eslint-disable-line no-script-url
                // createDict = iframe.contentWindow.Object;
                // html.removeChild(iframe);
                iframeDocument = iframe.contentWindow.document;
                iframeDocument.open();
                iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
                iframeDocument.close();
                createDict = iframeDocument.F;
                while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
                return createDict();
            };

            module.exports = Object.create || function create(O, Properties) {
                var result;
                if (O !== null) {
                    Empty[PROTOTYPE] = anObject(O);
                    result = new Empty();
                    Empty[PROTOTYPE] = null;
                    // add "__proto__" for Object.getPrototypeOf polyfill
                    result[IE_PROTO] = O;
                } else result = createDict();
                return Properties === undefined ? result : dPs(result, Properties);
            };


            /***/ }),

        /***/ 9275:
        /***/ ((__unused_webpack_module, exports, __webpack_require__) => {

            var anObject = __webpack_require__(7007);
            var IE8_DOM_DEFINE = __webpack_require__(1734);
            var toPrimitive = __webpack_require__(1689);
            var dP = Object.defineProperty;

            exports.f = __webpack_require__(7057) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
                anObject(O);
                P = toPrimitive(P, true);
                anObject(Attributes);
                if (IE8_DOM_DEFINE) try {
                    return dP(O, P, Attributes);
                } catch (e) { /* empty */ }
                if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
                if ('value' in Attributes) O[P] = Attributes.value;
                return O;
            };


            /***/ }),

        /***/ 5588:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var dP = __webpack_require__(9275);
            var anObject = __webpack_require__(7007);
            var getKeys = __webpack_require__(7184);

            module.exports = __webpack_require__(7057) ? Object.defineProperties : function defineProperties(O, Properties) {
                anObject(O);
                var keys = getKeys(Properties);
                var length = keys.length;
                var i = 0;
                var P;
                while (length > i) dP.f(O, P = keys[i++], Properties[P]);
                return O;
            };


            /***/ }),

        /***/ 8693:
        /***/ ((__unused_webpack_module, exports, __webpack_require__) => {

            var pIE = __webpack_require__(4682);
            var createDesc = __webpack_require__(681);
            var toIObject = __webpack_require__(2110);
            var toPrimitive = __webpack_require__(1689);
            var has = __webpack_require__(9181);
            var IE8_DOM_DEFINE = __webpack_require__(1734);
            var gOPD = Object.getOwnPropertyDescriptor;

            exports.f = __webpack_require__(7057) ? gOPD : function getOwnPropertyDescriptor(O, P) {
                O = toIObject(O);
                P = toPrimitive(P, true);
                if (IE8_DOM_DEFINE) try {
                    return gOPD(O, P);
                } catch (e) { /* empty */ }
                if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
            };


            /***/ }),

        /***/ 9327:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
            var toIObject = __webpack_require__(2110);
            var gOPN = (__webpack_require__(616).f);
            var toString = {}.toString;

            var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
                ? Object.getOwnPropertyNames(window) : [];

            var getWindowNames = function (it) {
                try {
                    return gOPN(it);
                } catch (e) {
                    return windowNames.slice();
                }
            };

            module.exports.f = function getOwnPropertyNames(it) {
                return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
            };


            /***/ }),

        /***/ 616:
        /***/ ((__unused_webpack_module, exports, __webpack_require__) => {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
            var $keys = __webpack_require__(189);
            var hiddenKeys = (__webpack_require__(4430).concat)('length', 'prototype');

            exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
                return $keys(O, hiddenKeys);
            };


            /***/ }),

        /***/ 4548:
        /***/ ((__unused_webpack_module, exports) => {

            exports.f = Object.getOwnPropertySymbols;


            /***/ }),

        /***/ 468:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
            var has = __webpack_require__(9181);
            var toObject = __webpack_require__(508);
            var IE_PROTO = __webpack_require__(9335)('IE_PROTO');
            var ObjectProto = Object.prototype;

            module.exports = Object.getPrototypeOf || function (O) {
                O = toObject(O);
                if (has(O, IE_PROTO)) return O[IE_PROTO];
                if (typeof O.constructor == 'function' && O instanceof O.constructor) {
                    return O.constructor.prototype;
                } return O instanceof Object ? ObjectProto : null;
            };


            /***/ }),

        /***/ 189:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var has = __webpack_require__(9181);
            var toIObject = __webpack_require__(2110);
            var arrayIndexOf = __webpack_require__(9315)(false);
            var IE_PROTO = __webpack_require__(9335)('IE_PROTO');

            module.exports = function (object, names) {
                var O = toIObject(object);
                var i = 0;
                var result = [];
                var key;
                for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
                // Don't enum bug & hidden keys
                while (names.length > i) if (has(O, key = names[i++])) {
                    ~arrayIndexOf(result, key) || result.push(key);
                }
                return result;
            };


            /***/ }),

        /***/ 7184:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
            var $keys = __webpack_require__(189);
            var enumBugKeys = __webpack_require__(4430);

            module.exports = Object.keys || function keys(O) {
                return $keys(O, enumBugKeys);
            };


            /***/ }),

        /***/ 4682:
        /***/ ((__unused_webpack_module, exports) => {

            exports.f = {}.propertyIsEnumerable;


            /***/ }),

        /***/ 3160:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// most Object methods by ES6 should accept primitives
            var $export = __webpack_require__(2985);
            var core = __webpack_require__(5645);
            var fails = __webpack_require__(4253);
            module.exports = function (KEY, exec) {
                var fn = (core.Object || {})[KEY] || Object[KEY];
                var exp = {};
                exp[KEY] = exec(fn);
                $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
            };


            /***/ }),

        /***/ 1131:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var DESCRIPTORS = __webpack_require__(7057);
            var getKeys = __webpack_require__(7184);
            var toIObject = __webpack_require__(2110);
            var isEnum = (__webpack_require__(4682).f);
            module.exports = function (isEntries) {
                return function (it) {
                    var O = toIObject(it);
                    var keys = getKeys(O);
                    var length = keys.length;
                    var i = 0;
                    var result = [];
                    var key;
                    while (length > i) {
                        key = keys[i++];
                        if (!DESCRIPTORS || isEnum.call(O, key)) {
                            result.push(isEntries ? [key, O[key]] : O[key]);
                        }
                    }
                    return result;
                };
            };


            /***/ }),

        /***/ 7643:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// all object keys, includes non-enumerable and symbols
            var gOPN = __webpack_require__(616);
            var gOPS = __webpack_require__(4548);
            var anObject = __webpack_require__(7007);
            var Reflect = (__webpack_require__(3816).Reflect);
            module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
                var keys = gOPN.f(anObject(it));
                var getSymbols = gOPS.f;
                return getSymbols ? keys.concat(getSymbols(it)) : keys;
            };


            /***/ }),

        /***/ 7743:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var $parseFloat = (__webpack_require__(3816).parseFloat);
            var $trim = (__webpack_require__(9599).trim);

            module.exports = 1 / $parseFloat(__webpack_require__(4644) + '-0') !== -Infinity ? function parseFloat(str) {
                var string = $trim(String(str), 3);
                var result = $parseFloat(string);
                return result === 0 && string.charAt(0) == '-' ? -0 : result;
            } : $parseFloat;


            /***/ }),

        /***/ 5960:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var $parseInt = (__webpack_require__(3816).parseInt);
            var $trim = (__webpack_require__(9599).trim);
            var ws = __webpack_require__(4644);
            var hex = /^[-+]?0[xX]/;

            module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
                var string = $trim(String(str), 3);
                return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
            } : $parseInt;


            /***/ }),

        /***/ 188:
        /***/ ((module) => {

            module.exports = function (exec) {
                try {
                    return { e: false, v: exec() };
                } catch (e) {
                    return { e: true, v: e };
                }
            };


            /***/ }),

        /***/ 94:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var anObject = __webpack_require__(7007);
            var isObject = __webpack_require__(5286);
            var newPromiseCapability = __webpack_require__(3499);

            module.exports = function (C, x) {
                anObject(C);
                if (isObject(x) && x.constructor === C) return x;
                var promiseCapability = newPromiseCapability.f(C);
                var resolve = promiseCapability.resolve;
                resolve(x);
                return promiseCapability.promise;
            };


            /***/ }),

        /***/ 681:
        /***/ ((module) => {

            module.exports = function (bitmap, value) {
                return {
                    enumerable: !(bitmap & 1),
                    configurable: !(bitmap & 2),
                    writable: !(bitmap & 4),
                    value: value
                };
            };


            /***/ }),

        /***/ 4408:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var redefine = __webpack_require__(7234);
            module.exports = function (target, src, safe) {
                for (var key in src) redefine(target, key, src[key], safe);
                return target;
            };


            /***/ }),

        /***/ 7234:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var global = __webpack_require__(3816);
            var hide = __webpack_require__(7728);
            var has = __webpack_require__(9181);
            var SRC = __webpack_require__(3953)('src');
            var $toString = __webpack_require__(18);
            var TO_STRING = 'toString';
            var TPL = ('' + $toString).split(TO_STRING);

            (__webpack_require__(5645).inspectSource) = function (it) {
                return $toString.call(it);
            };

            (module.exports = function (O, key, val, safe) {
                var isFunction = typeof val == 'function';
                if (isFunction) has(val, 'name') || hide(val, 'name', key);
                if (O[key] === val) return;
                if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
                if (O === global) {
                    O[key] = val;
                } else if (!safe) {
                    delete O[key];
                    hide(O, key, val);
                } else if (O[key]) {
                    O[key] = val;
                } else {
                    hide(O, key, val);
                }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
            })(Function.prototype, TO_STRING, function toString() {
                return typeof this == 'function' && this[SRC] || $toString.call(this);
            });


            /***/ }),

        /***/ 7787:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";


            var classof = __webpack_require__(1488);
            var builtinExec = RegExp.prototype.exec;

            // `RegExpExec` abstract operation
// https://tc39.github.io/ecma262/#sec-regexpexec
            module.exports = function (R, S) {
                var exec = R.exec;
                if (typeof exec === 'function') {
                    var result = exec.call(R, S);
                    if (typeof result !== 'object') {
                        throw new TypeError('RegExp exec method returned something other than an Object or null');
                    }
                    return result;
                }
                if (classof(R) !== 'RegExp') {
                    throw new TypeError('RegExp#exec called on incompatible receiver');
                }
                return builtinExec.call(R, S);
            };


            /***/ }),

        /***/ 1165:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";


            var regexpFlags = __webpack_require__(3218);

            var nativeExec = RegExp.prototype.exec;
// This always refers to the native implementation, because the
// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
// which loads this file before patching the method.
            var nativeReplace = String.prototype.replace;

            var patchedExec = nativeExec;

            var LAST_INDEX = 'lastIndex';

            var UPDATES_LAST_INDEX_WRONG = (function () {
                var re1 = /a/,
                    re2 = /b*/g;
                nativeExec.call(re1, 'a');
                nativeExec.call(re2, 'a');
                return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
            })();

// nonparticipating capturing group, copied from es5-shim's String#split patch.
            var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

            var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;

            if (PATCH) {
                patchedExec = function exec(str) {
                    var re = this;
                    var lastIndex, reCopy, match, i;

                    if (NPCG_INCLUDED) {
                        reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
                    }
                    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];

                    match = nativeExec.call(re, str);

                    if (UPDATES_LAST_INDEX_WRONG && match) {
                        re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
                    }
                    if (NPCG_INCLUDED && match && match.length > 1) {
                        // Fix browsers whose `exec` methods don't consistently return `undefined`
                        // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
                        // eslint-disable-next-line no-loop-func
                        nativeReplace.call(match[0], reCopy, function () {
                            for (i = 1; i < arguments.length - 2; i++) {
                                if (arguments[i] === undefined) match[i] = undefined;
                            }
                        });
                    }

                    return match;
                };
            }

            module.exports = patchedExec;


            /***/ }),

        /***/ 7195:
        /***/ ((module) => {

// 7.2.9 SameValue(x, y)
            module.exports = Object.is || function is(x, y) {
                // eslint-disable-next-line no-self-compare
                return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
            };


            /***/ }),

        /***/ 7375:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// Works with __proto__ only. Old v8 can't work with null proto objects.
            /* eslint-disable no-proto */
            var isObject = __webpack_require__(5286);
            var anObject = __webpack_require__(7007);
            var check = function (O, proto) {
                anObject(O);
                if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
            };
            module.exports = {
                set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
                    function (test, buggy, set) {
                        try {
                            set = __webpack_require__(741)(Function.call, (__webpack_require__(8693).f)(Object.prototype, '__proto__').set, 2);
                            set(test, []);
                            buggy = !(test instanceof Array);
                        } catch (e) { buggy = true; }
                        return function setPrototypeOf(O, proto) {
                            check(O, proto);
                            if (buggy) O.__proto__ = proto;
                            else set(O, proto);
                            return O;
                        };
                    }({}, false) : undefined),
                check: check
            };


            /***/ }),

        /***/ 2974:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var global = __webpack_require__(3816);
            var dP = __webpack_require__(9275);
            var DESCRIPTORS = __webpack_require__(7057);
            var SPECIES = __webpack_require__(6314)('species');

            module.exports = function (KEY) {
                var C = global[KEY];
                if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
                    configurable: true,
                    get: function () { return this; }
                });
            };


            /***/ }),

        /***/ 2943:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var def = (__webpack_require__(9275).f);
            var has = __webpack_require__(9181);
            var TAG = __webpack_require__(6314)('toStringTag');

            module.exports = function (it, tag, stat) {
                if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
            };


            /***/ }),

        /***/ 9335:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var shared = __webpack_require__(3825)('keys');
            var uid = __webpack_require__(3953);
            module.exports = function (key) {
                return shared[key] || (shared[key] = uid(key));
            };


            /***/ }),

        /***/ 3825:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var core = __webpack_require__(5645);
            var global = __webpack_require__(3816);
            var SHARED = '__core-js_shared__';
            var store = global[SHARED] || (global[SHARED] = {});

            (module.exports = function (key, value) {
                return store[key] || (store[key] = value !== undefined ? value : {});
            })('versions', []).push({
                version: core.version,
                mode: __webpack_require__(4461) ? 'pure' : 'global',
                copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
            });


            /***/ }),

        /***/ 8364:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
            var anObject = __webpack_require__(7007);
            var aFunction = __webpack_require__(4963);
            var SPECIES = __webpack_require__(6314)('species');
            module.exports = function (O, D) {
                var C = anObject(O).constructor;
                var S;
                return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
            };


            /***/ }),

        /***/ 7717:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var fails = __webpack_require__(4253);

            module.exports = function (method, arg) {
                return !!method && fails(function () {
                    // eslint-disable-next-line no-useless-call
                    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
                });
            };


            /***/ }),

        /***/ 4496:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var toInteger = __webpack_require__(1467);
            var defined = __webpack_require__(1355);
// true  -> String#at
// false -> String#codePointAt
            module.exports = function (TO_STRING) {
                return function (that, pos) {
                    var s = String(defined(that));
                    var i = toInteger(pos);
                    var l = s.length;
                    var a, b;
                    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
                    a = s.charCodeAt(i);
                    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
                        ? TO_STRING ? s.charAt(i) : a
                        : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
                };
            };


            /***/ }),

        /***/ 2094:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// helper for String#{startsWith, endsWith, includes}
            var isRegExp = __webpack_require__(5364);
            var defined = __webpack_require__(1355);

            module.exports = function (that, searchString, NAME) {
                if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
                return String(defined(that));
            };


            /***/ }),

        /***/ 9395:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
            var fails = __webpack_require__(4253);
            var defined = __webpack_require__(1355);
            var quot = /"/g;
// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
            var createHTML = function (string, tag, attribute, value) {
                var S = String(defined(string));
                var p1 = '<' + tag;
                if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
                return p1 + '>' + S + '</' + tag + '>';
            };
            module.exports = function (NAME, exec) {
                var O = {};
                O[NAME] = exec(createHTML);
                $export($export.P + $export.F * fails(function () {
                    var test = ''[NAME]('"');
                    return test !== test.toLowerCase() || test.split('"').length > 3;
                }), 'String', O);
            };


            /***/ }),

        /***/ 5442:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// https://github.com/tc39/proposal-string-pad-start-end
            var toLength = __webpack_require__(875);
            var repeat = __webpack_require__(8595);
            var defined = __webpack_require__(1355);

            module.exports = function (that, maxLength, fillString, left) {
                var S = String(defined(that));
                var stringLength = S.length;
                var fillStr = fillString === undefined ? ' ' : String(fillString);
                var intMaxLength = toLength(maxLength);
                if (intMaxLength <= stringLength || fillStr == '') return S;
                var fillLen = intMaxLength - stringLength;
                var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
                if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
                return left ? stringFiller + S : S + stringFiller;
            };


            /***/ }),

        /***/ 8595:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var toInteger = __webpack_require__(1467);
            var defined = __webpack_require__(1355);

            module.exports = function repeat(count) {
                var str = String(defined(this));
                var res = '';
                var n = toInteger(count);
                if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
                for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
                return res;
            };


            /***/ }),

        /***/ 9599:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
            var defined = __webpack_require__(1355);
            var fails = __webpack_require__(4253);
            var spaces = __webpack_require__(4644);
            var space = '[' + spaces + ']';
            var non = '\u200b\u0085';
            var ltrim = RegExp('^' + space + space + '*');
            var rtrim = RegExp(space + space + '*$');

            var exporter = function (KEY, exec, ALIAS) {
                var exp = {};
                var FORCE = fails(function () {
                    return !!spaces[KEY]() || non[KEY]() != non;
                });
                var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
                if (ALIAS) exp[ALIAS] = fn;
                $export($export.P + $export.F * FORCE, 'String', exp);
            };

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
            var trim = exporter.trim = function (string, TYPE) {
                string = String(defined(string));
                if (TYPE & 1) string = string.replace(ltrim, '');
                if (TYPE & 2) string = string.replace(rtrim, '');
                return string;
            };

            module.exports = exporter;


            /***/ }),

        /***/ 4644:
        /***/ ((module) => {

            module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
                '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


            /***/ }),

        /***/ 4193:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var ctx = __webpack_require__(741);
            var invoke = __webpack_require__(7242);
            var html = __webpack_require__(639);
            var cel = __webpack_require__(2457);
            var global = __webpack_require__(3816);
            var process = global.process;
            var setTask = global.setImmediate;
            var clearTask = global.clearImmediate;
            var MessageChannel = global.MessageChannel;
            var Dispatch = global.Dispatch;
            var counter = 0;
            var queue = {};
            var ONREADYSTATECHANGE = 'onreadystatechange';
            var defer, channel, port;
            var run = function () {
                var id = +this;
                // eslint-disable-next-line no-prototype-builtins
                if (queue.hasOwnProperty(id)) {
                    var fn = queue[id];
                    delete queue[id];
                    fn();
                }
            };
            var listener = function (event) {
                run.call(event.data);
            };
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
            if (!setTask || !clearTask) {
                setTask = function setImmediate(fn) {
                    var args = [];
                    var i = 1;
                    while (arguments.length > i) args.push(arguments[i++]);
                    queue[++counter] = function () {
                        // eslint-disable-next-line no-new-func
                        invoke(typeof fn == 'function' ? fn : Function(fn), args);
                    };
                    defer(counter);
                    return counter;
                };
                clearTask = function clearImmediate(id) {
                    delete queue[id];
                };
                // Node.js 0.8-
                if (__webpack_require__(2032)(process) == 'process') {
                    defer = function (id) {
                        process.nextTick(ctx(run, id, 1));
                    };
                    // Sphere (JS game engine) Dispatch API
                } else if (Dispatch && Dispatch.now) {
                    defer = function (id) {
                        Dispatch.now(ctx(run, id, 1));
                    };
                    // Browsers with MessageChannel, includes WebWorkers
                } else if (MessageChannel) {
                    channel = new MessageChannel();
                    port = channel.port2;
                    channel.port1.onmessage = listener;
                    defer = ctx(port.postMessage, port, 1);
                    // Browsers with postMessage, skip WebWorkers
                    // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
                } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
                    defer = function (id) {
                        global.postMessage(id + '', '*');
                    };
                    global.addEventListener('message', listener, false);
                    // IE8-
                } else if (ONREADYSTATECHANGE in cel('script')) {
                    defer = function (id) {
                        html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
                            html.removeChild(this);
                            run.call(id);
                        };
                    };
                    // Rest old browsers
                } else {
                    defer = function (id) {
                        setTimeout(ctx(run, id, 1), 0);
                    };
                }
            }
            module.exports = {
                set: setTask,
                clear: clearTask
            };


            /***/ }),

        /***/ 2337:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var toInteger = __webpack_require__(1467);
            var max = Math.max;
            var min = Math.min;
            module.exports = function (index, length) {
                index = toInteger(index);
                return index < 0 ? max(index + length, 0) : min(index, length);
            };


            /***/ }),

        /***/ 4843:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// https://tc39.github.io/ecma262/#sec-toindex
            var toInteger = __webpack_require__(1467);
            var toLength = __webpack_require__(875);
            module.exports = function (it) {
                if (it === undefined) return 0;
                var number = toInteger(it);
                var length = toLength(number);
                if (number !== length) throw RangeError('Wrong length!');
                return length;
            };


            /***/ }),

        /***/ 1467:
        /***/ ((module) => {

// 7.1.4 ToInteger
            var ceil = Math.ceil;
            var floor = Math.floor;
            module.exports = function (it) {
                return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
            };


            /***/ }),

        /***/ 2110:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// to indexed object, toObject with fallback for non-array-like ES3 strings
            var IObject = __webpack_require__(9797);
            var defined = __webpack_require__(1355);
            module.exports = function (it) {
                return IObject(defined(it));
            };


            /***/ }),

        /***/ 875:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 7.1.15 ToLength
            var toInteger = __webpack_require__(1467);
            var min = Math.min;
            module.exports = function (it) {
                return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
            };


            /***/ }),

        /***/ 508:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 7.1.13 ToObject(argument)
            var defined = __webpack_require__(1355);
            module.exports = function (it) {
                return Object(defined(it));
            };


            /***/ }),

        /***/ 1689:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// 7.1.1 ToPrimitive(input [, PreferredType])
            var isObject = __webpack_require__(5286);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
            module.exports = function (it, S) {
                if (!isObject(it)) return it;
                var fn, val;
                if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
                if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
                throw TypeError("Can't convert object to primitive value");
            };


            /***/ }),

        /***/ 8440:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            if (__webpack_require__(7057)) {
                var LIBRARY = __webpack_require__(4461);
                var global = __webpack_require__(3816);
                var fails = __webpack_require__(4253);
                var $export = __webpack_require__(2985);
                var $typed = __webpack_require__(9383);
                var $buffer = __webpack_require__(1125);
                var ctx = __webpack_require__(741);
                var anInstance = __webpack_require__(3328);
                var propertyDesc = __webpack_require__(681);
                var hide = __webpack_require__(7728);
                var redefineAll = __webpack_require__(4408);
                var toInteger = __webpack_require__(1467);
                var toLength = __webpack_require__(875);
                var toIndex = __webpack_require__(4843);
                var toAbsoluteIndex = __webpack_require__(2337);
                var toPrimitive = __webpack_require__(1689);
                var has = __webpack_require__(9181);
                var classof = __webpack_require__(1488);
                var isObject = __webpack_require__(5286);
                var toObject = __webpack_require__(508);
                var isArrayIter = __webpack_require__(6555);
                var create = __webpack_require__(2503);
                var getPrototypeOf = __webpack_require__(468);
                var gOPN = (__webpack_require__(616).f);
                var getIterFn = __webpack_require__(9002);
                var uid = __webpack_require__(3953);
                var wks = __webpack_require__(6314);
                var createArrayMethod = __webpack_require__(50);
                var createArrayIncludes = __webpack_require__(9315);
                var speciesConstructor = __webpack_require__(8364);
                var ArrayIterators = __webpack_require__(6997);
                var Iterators = __webpack_require__(2803);
                var $iterDetect = __webpack_require__(7462);
                var setSpecies = __webpack_require__(2974);
                var arrayFill = __webpack_require__(6852);
                var arrayCopyWithin = __webpack_require__(5216);
                var $DP = __webpack_require__(9275);
                var $GOPD = __webpack_require__(8693);
                var dP = $DP.f;
                var gOPD = $GOPD.f;
                var RangeError = global.RangeError;
                var TypeError = global.TypeError;
                var Uint8Array = global.Uint8Array;
                var ARRAY_BUFFER = 'ArrayBuffer';
                var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
                var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
                var PROTOTYPE = 'prototype';
                var ArrayProto = Array[PROTOTYPE];
                var $ArrayBuffer = $buffer.ArrayBuffer;
                var $DataView = $buffer.DataView;
                var arrayForEach = createArrayMethod(0);
                var arrayFilter = createArrayMethod(2);
                var arraySome = createArrayMethod(3);
                var arrayEvery = createArrayMethod(4);
                var arrayFind = createArrayMethod(5);
                var arrayFindIndex = createArrayMethod(6);
                var arrayIncludes = createArrayIncludes(true);
                var arrayIndexOf = createArrayIncludes(false);
                var arrayValues = ArrayIterators.values;
                var arrayKeys = ArrayIterators.keys;
                var arrayEntries = ArrayIterators.entries;
                var arrayLastIndexOf = ArrayProto.lastIndexOf;
                var arrayReduce = ArrayProto.reduce;
                var arrayReduceRight = ArrayProto.reduceRight;
                var arrayJoin = ArrayProto.join;
                var arraySort = ArrayProto.sort;
                var arraySlice = ArrayProto.slice;
                var arrayToString = ArrayProto.toString;
                var arrayToLocaleString = ArrayProto.toLocaleString;
                var ITERATOR = wks('iterator');
                var TAG = wks('toStringTag');
                var TYPED_CONSTRUCTOR = uid('typed_constructor');
                var DEF_CONSTRUCTOR = uid('def_constructor');
                var ALL_CONSTRUCTORS = $typed.CONSTR;
                var TYPED_ARRAY = $typed.TYPED;
                var VIEW = $typed.VIEW;
                var WRONG_LENGTH = 'Wrong length!';

                var $map = createArrayMethod(1, function (O, length) {
                    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
                });

                var LITTLE_ENDIAN = fails(function () {
                    // eslint-disable-next-line no-undef
                    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
                });

                var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
                    new Uint8Array(1).set({});
                });

                var toOffset = function (it, BYTES) {
                    var offset = toInteger(it);
                    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
                    return offset;
                };

                var validate = function (it) {
                    if (isObject(it) && TYPED_ARRAY in it) return it;
                    throw TypeError(it + ' is not a typed array!');
                };

                var allocate = function (C, length) {
                    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
                        throw TypeError('It is not a typed array constructor!');
                    } return new C(length);
                };

                var speciesFromList = function (O, list) {
                    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
                };

                var fromList = function (C, list) {
                    var index = 0;
                    var length = list.length;
                    var result = allocate(C, length);
                    while (length > index) result[index] = list[index++];
                    return result;
                };

                var addGetter = function (it, key, internal) {
                    dP(it, key, { get: function () { return this._d[internal]; } });
                };

                var $from = function from(source /* , mapfn, thisArg */) {
                    var O = toObject(source);
                    var aLen = arguments.length;
                    var mapfn = aLen > 1 ? arguments[1] : undefined;
                    var mapping = mapfn !== undefined;
                    var iterFn = getIterFn(O);
                    var i, length, values, result, step, iterator;
                    if (iterFn != undefined && !isArrayIter(iterFn)) {
                        for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
                            values.push(step.value);
                        } O = values;
                    }
                    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
                    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
                        result[i] = mapping ? mapfn(O[i], i) : O[i];
                    }
                    return result;
                };

                var $of = function of(/* ...items */) {
                    var index = 0;
                    var length = arguments.length;
                    var result = allocate(this, length);
                    while (length > index) result[index] = arguments[index++];
                    return result;
                };

                // iOS Safari 6.x fails here
                var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });

                var $toLocaleString = function toLocaleString() {
                    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
                };

                var proto = {
                    copyWithin: function copyWithin(target, start /* , end */) {
                        return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
                    },
                    every: function every(callbackfn /* , thisArg */) {
                        return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    },
                    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
                        return arrayFill.apply(validate(this), arguments);
                    },
                    filter: function filter(callbackfn /* , thisArg */) {
                        return speciesFromList(this, arrayFilter(validate(this), callbackfn,
                            arguments.length > 1 ? arguments[1] : undefined));
                    },
                    find: function find(predicate /* , thisArg */) {
                        return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
                    },
                    findIndex: function findIndex(predicate /* , thisArg */) {
                        return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
                    },
                    forEach: function forEach(callbackfn /* , thisArg */) {
                        arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    },
                    indexOf: function indexOf(searchElement /* , fromIndex */) {
                        return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
                    },
                    includes: function includes(searchElement /* , fromIndex */) {
                        return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
                    },
                    join: function join(separator) { // eslint-disable-line no-unused-vars
                        return arrayJoin.apply(validate(this), arguments);
                    },
                    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
                        return arrayLastIndexOf.apply(validate(this), arguments);
                    },
                    map: function map(mapfn /* , thisArg */) {
                        return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
                    },
                    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
                        return arrayReduce.apply(validate(this), arguments);
                    },
                    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
                        return arrayReduceRight.apply(validate(this), arguments);
                    },
                    reverse: function reverse() {
                        var that = this;
                        var length = validate(that).length;
                        var middle = Math.floor(length / 2);
                        var index = 0;
                        var value;
                        while (index < middle) {
                            value = that[index];
                            that[index++] = that[--length];
                            that[length] = value;
                        } return that;
                    },
                    some: function some(callbackfn /* , thisArg */) {
                        return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                    },
                    sort: function sort(comparefn) {
                        return arraySort.call(validate(this), comparefn);
                    },
                    subarray: function subarray(begin, end) {
                        var O = validate(this);
                        var length = O.length;
                        var $begin = toAbsoluteIndex(begin, length);
                        return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
                            O.buffer,
                            O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
                            toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
                        );
                    }
                };

                var $slice = function slice(start, end) {
                    return speciesFromList(this, arraySlice.call(validate(this), start, end));
                };

                var $set = function set(arrayLike /* , offset */) {
                    validate(this);
                    var offset = toOffset(arguments[1], 1);
                    var length = this.length;
                    var src = toObject(arrayLike);
                    var len = toLength(src.length);
                    var index = 0;
                    if (len + offset > length) throw RangeError(WRONG_LENGTH);
                    while (index < len) this[offset + index] = src[index++];
                };

                var $iterators = {
                    entries: function entries() {
                        return arrayEntries.call(validate(this));
                    },
                    keys: function keys() {
                        return arrayKeys.call(validate(this));
                    },
                    values: function values() {
                        return arrayValues.call(validate(this));
                    }
                };

                var isTAIndex = function (target, key) {
                    return isObject(target)
                        && target[TYPED_ARRAY]
                        && typeof key != 'symbol'
                        && key in target
                        && String(+key) == String(key);
                };
                var $getDesc = function getOwnPropertyDescriptor(target, key) {
                    return isTAIndex(target, key = toPrimitive(key, true))
                        ? propertyDesc(2, target[key])
                        : gOPD(target, key);
                };
                var $setDesc = function defineProperty(target, key, desc) {
                    if (isTAIndex(target, key = toPrimitive(key, true))
                        && isObject(desc)
                        && has(desc, 'value')
                        && !has(desc, 'get')
                        && !has(desc, 'set')
                        // TODO: add validation descriptor w/o calling accessors
                        && !desc.configurable
                        && (!has(desc, 'writable') || desc.writable)
                        && (!has(desc, 'enumerable') || desc.enumerable)
                    ) {
                        target[key] = desc.value;
                        return target;
                    } return dP(target, key, desc);
                };

                if (!ALL_CONSTRUCTORS) {
                    $GOPD.f = $getDesc;
                    $DP.f = $setDesc;
                }

                $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
                    getOwnPropertyDescriptor: $getDesc,
                    defineProperty: $setDesc
                });

                if (fails(function () { arrayToString.call({}); })) {
                    arrayToString = arrayToLocaleString = function toString() {
                        return arrayJoin.call(this);
                    };
                }

                var $TypedArrayPrototype$ = redefineAll({}, proto);
                redefineAll($TypedArrayPrototype$, $iterators);
                hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
                redefineAll($TypedArrayPrototype$, {
                    slice: $slice,
                    set: $set,
                    constructor: function () { /* noop */ },
                    toString: arrayToString,
                    toLocaleString: $toLocaleString
                });
                addGetter($TypedArrayPrototype$, 'buffer', 'b');
                addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
                addGetter($TypedArrayPrototype$, 'byteLength', 'l');
                addGetter($TypedArrayPrototype$, 'length', 'e');
                dP($TypedArrayPrototype$, TAG, {
                    get: function () { return this[TYPED_ARRAY]; }
                });

                // eslint-disable-next-line max-statements
                module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
                    CLAMPED = !!CLAMPED;
                    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
                    var GETTER = 'get' + KEY;
                    var SETTER = 'set' + KEY;
                    var TypedArray = global[NAME];
                    var Base = TypedArray || {};
                    var TAC = TypedArray && getPrototypeOf(TypedArray);
                    var FORCED = !TypedArray || !$typed.ABV;
                    var O = {};
                    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
                    var getter = function (that, index) {
                        var data = that._d;
                        return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
                    };
                    var setter = function (that, index, value) {
                        var data = that._d;
                        if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
                        data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
                    };
                    var addElement = function (that, index) {
                        dP(that, index, {
                            get: function () {
                                return getter(this, index);
                            },
                            set: function (value) {
                                return setter(this, index, value);
                            },
                            enumerable: true
                        });
                    };
                    if (FORCED) {
                        TypedArray = wrapper(function (that, data, $offset, $length) {
                            anInstance(that, TypedArray, NAME, '_d');
                            var index = 0;
                            var offset = 0;
                            var buffer, byteLength, length, klass;
                            if (!isObject(data)) {
                                length = toIndex(data);
                                byteLength = length * BYTES;
                                buffer = new $ArrayBuffer(byteLength);
                            } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                                buffer = data;
                                offset = toOffset($offset, BYTES);
                                var $len = data.byteLength;
                                if ($length === undefined) {
                                    if ($len % BYTES) throw RangeError(WRONG_LENGTH);
                                    byteLength = $len - offset;
                                    if (byteLength < 0) throw RangeError(WRONG_LENGTH);
                                } else {
                                    byteLength = toLength($length) * BYTES;
                                    if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
                                }
                                length = byteLength / BYTES;
                            } else if (TYPED_ARRAY in data) {
                                return fromList(TypedArray, data);
                            } else {
                                return $from.call(TypedArray, data);
                            }
                            hide(that, '_d', {
                                b: buffer,
                                o: offset,
                                l: byteLength,
                                e: length,
                                v: new $DataView(buffer)
                            });
                            while (index < length) addElement(that, index++);
                        });
                        TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
                        hide(TypedArrayPrototype, 'constructor', TypedArray);
                    } else if (!fails(function () {
                        TypedArray(1);
                    }) || !fails(function () {
                        new TypedArray(-1); // eslint-disable-line no-new
                    }) || !$iterDetect(function (iter) {
                        new TypedArray(); // eslint-disable-line no-new
                        new TypedArray(null); // eslint-disable-line no-new
                        new TypedArray(1.5); // eslint-disable-line no-new
                        new TypedArray(iter); // eslint-disable-line no-new
                    }, true)) {
                        TypedArray = wrapper(function (that, data, $offset, $length) {
                            anInstance(that, TypedArray, NAME);
                            var klass;
                            // `ws` module bug, temporarily remove validation length for Uint8Array
                            // https://github.com/websockets/ws/pull/645
                            if (!isObject(data)) return new Base(toIndex(data));
                            if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
                                return $length !== undefined
                                    ? new Base(data, toOffset($offset, BYTES), $length)
                                    : $offset !== undefined
                                        ? new Base(data, toOffset($offset, BYTES))
                                        : new Base(data);
                            }
                            if (TYPED_ARRAY in data) return fromList(TypedArray, data);
                            return $from.call(TypedArray, data);
                        });
                        arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
                            if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
                        });
                        TypedArray[PROTOTYPE] = TypedArrayPrototype;
                        if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
                    }
                    var $nativeIterator = TypedArrayPrototype[ITERATOR];
                    var CORRECT_ITER_NAME = !!$nativeIterator
                        && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
                    var $iterator = $iterators.values;
                    hide(TypedArray, TYPED_CONSTRUCTOR, true);
                    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
                    hide(TypedArrayPrototype, VIEW, true);
                    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);

                    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
                        dP(TypedArrayPrototype, TAG, {
                            get: function () { return NAME; }
                        });
                    }

                    O[NAME] = TypedArray;

                    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);

                    $export($export.S, NAME, {
                        BYTES_PER_ELEMENT: BYTES
                    });

                    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
                        from: $from,
                        of: $of
                    });

                    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);

                    $export($export.P, NAME, proto);

                    setSpecies(NAME);

                    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });

                    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);

                    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;

                    $export($export.P + $export.F * fails(function () {
                        new TypedArray(1).slice();
                    }), NAME, { slice: $slice });

                    $export($export.P + $export.F * (fails(function () {
                        return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
                    }) || !fails(function () {
                        TypedArrayPrototype.toLocaleString.call([1, 2]);
                    })), NAME, { toLocaleString: $toLocaleString });

                    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
                    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
                };
            } else module.exports = function () { /* empty */ };


            /***/ }),

        /***/ 1125:
        /***/ ((__unused_webpack_module, exports, __webpack_require__) => {

            "use strict";

            var global = __webpack_require__(3816);
            var DESCRIPTORS = __webpack_require__(7057);
            var LIBRARY = __webpack_require__(4461);
            var $typed = __webpack_require__(9383);
            var hide = __webpack_require__(7728);
            var redefineAll = __webpack_require__(4408);
            var fails = __webpack_require__(4253);
            var anInstance = __webpack_require__(3328);
            var toInteger = __webpack_require__(1467);
            var toLength = __webpack_require__(875);
            var toIndex = __webpack_require__(4843);
            var gOPN = (__webpack_require__(616).f);
            var dP = (__webpack_require__(9275).f);
            var arrayFill = __webpack_require__(6852);
            var setToStringTag = __webpack_require__(2943);
            var ARRAY_BUFFER = 'ArrayBuffer';
            var DATA_VIEW = 'DataView';
            var PROTOTYPE = 'prototype';
            var WRONG_LENGTH = 'Wrong length!';
            var WRONG_INDEX = 'Wrong index!';
            var $ArrayBuffer = global[ARRAY_BUFFER];
            var $DataView = global[DATA_VIEW];
            var Math = global.Math;
            var RangeError = global.RangeError;
// eslint-disable-next-line no-shadow-restricted-names
            var Infinity = global.Infinity;
            var BaseBuffer = $ArrayBuffer;
            var abs = Math.abs;
            var pow = Math.pow;
            var floor = Math.floor;
            var log = Math.log;
            var LN2 = Math.LN2;
            var BUFFER = 'buffer';
            var BYTE_LENGTH = 'byteLength';
            var BYTE_OFFSET = 'byteOffset';
            var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
            var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
            var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;

// IEEE754 conversions based on https://github.com/feross/ieee754
            function packIEEE754(value, mLen, nBytes) {
                var buffer = new Array(nBytes);
                var eLen = nBytes * 8 - mLen - 1;
                var eMax = (1 << eLen) - 1;
                var eBias = eMax >> 1;
                var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
                var i = 0;
                var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
                var e, m, c;
                value = abs(value);
                // eslint-disable-next-line no-self-compare
                if (value != value || value === Infinity) {
                    // eslint-disable-next-line no-self-compare
                    m = value != value ? 1 : 0;
                    e = eMax;
                } else {
                    e = floor(log(value) / LN2);
                    if (value * (c = pow(2, -e)) < 1) {
                        e--;
                        c *= 2;
                    }
                    if (e + eBias >= 1) {
                        value += rt / c;
                    } else {
                        value += rt * pow(2, 1 - eBias);
                    }
                    if (value * c >= 2) {
                        e++;
                        c /= 2;
                    }
                    if (e + eBias >= eMax) {
                        m = 0;
                        e = eMax;
                    } else if (e + eBias >= 1) {
                        m = (value * c - 1) * pow(2, mLen);
                        e = e + eBias;
                    } else {
                        m = value * pow(2, eBias - 1) * pow(2, mLen);
                        e = 0;
                    }
                }
                for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
                e = e << mLen | m;
                eLen += mLen;
                for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
                buffer[--i] |= s * 128;
                return buffer;
            }
            function unpackIEEE754(buffer, mLen, nBytes) {
                var eLen = nBytes * 8 - mLen - 1;
                var eMax = (1 << eLen) - 1;
                var eBias = eMax >> 1;
                var nBits = eLen - 7;
                var i = nBytes - 1;
                var s = buffer[i--];
                var e = s & 127;
                var m;
                s >>= 7;
                for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
                m = e & (1 << -nBits) - 1;
                e >>= -nBits;
                nBits += mLen;
                for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
                if (e === 0) {
                    e = 1 - eBias;
                } else if (e === eMax) {
                    return m ? NaN : s ? -Infinity : Infinity;
                } else {
                    m = m + pow(2, mLen);
                    e = e - eBias;
                } return (s ? -1 : 1) * m * pow(2, e - mLen);
            }

            function unpackI32(bytes) {
                return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
            }
            function packI8(it) {
                return [it & 0xff];
            }
            function packI16(it) {
                return [it & 0xff, it >> 8 & 0xff];
            }
            function packI32(it) {
                return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
            }
            function packF64(it) {
                return packIEEE754(it, 52, 8);
            }
            function packF32(it) {
                return packIEEE754(it, 23, 4);
            }

            function addGetter(C, key, internal) {
                dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
            }

            function get(view, bytes, index, isLittleEndian) {
                var numIndex = +index;
                var intIndex = toIndex(numIndex);
                if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
                var store = view[$BUFFER]._b;
                var start = intIndex + view[$OFFSET];
                var pack = store.slice(start, start + bytes);
                return isLittleEndian ? pack : pack.reverse();
            }
            function set(view, bytes, index, conversion, value, isLittleEndian) {
                var numIndex = +index;
                var intIndex = toIndex(numIndex);
                if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
                var store = view[$BUFFER]._b;
                var start = intIndex + view[$OFFSET];
                var pack = conversion(+value);
                for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
            }

            if (!$typed.ABV) {
                $ArrayBuffer = function ArrayBuffer(length) {
                    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
                    var byteLength = toIndex(length);
                    this._b = arrayFill.call(new Array(byteLength), 0);
                    this[$LENGTH] = byteLength;
                };

                $DataView = function DataView(buffer, byteOffset, byteLength) {
                    anInstance(this, $DataView, DATA_VIEW);
                    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
                    var bufferLength = buffer[$LENGTH];
                    var offset = toInteger(byteOffset);
                    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
                    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
                    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
                    this[$BUFFER] = buffer;
                    this[$OFFSET] = offset;
                    this[$LENGTH] = byteLength;
                };

                if (DESCRIPTORS) {
                    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
                    addGetter($DataView, BUFFER, '_b');
                    addGetter($DataView, BYTE_LENGTH, '_l');
                    addGetter($DataView, BYTE_OFFSET, '_o');
                }

                redefineAll($DataView[PROTOTYPE], {
                    getInt8: function getInt8(byteOffset) {
                        return get(this, 1, byteOffset)[0] << 24 >> 24;
                    },
                    getUint8: function getUint8(byteOffset) {
                        return get(this, 1, byteOffset)[0];
                    },
                    getInt16: function getInt16(byteOffset /* , littleEndian */) {
                        var bytes = get(this, 2, byteOffset, arguments[1]);
                        return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
                    },
                    getUint16: function getUint16(byteOffset /* , littleEndian */) {
                        var bytes = get(this, 2, byteOffset, arguments[1]);
                        return bytes[1] << 8 | bytes[0];
                    },
                    getInt32: function getInt32(byteOffset /* , littleEndian */) {
                        return unpackI32(get(this, 4, byteOffset, arguments[1]));
                    },
                    getUint32: function getUint32(byteOffset /* , littleEndian */) {
                        return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
                    },
                    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
                        return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
                    },
                    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
                        return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
                    },
                    setInt8: function setInt8(byteOffset, value) {
                        set(this, 1, byteOffset, packI8, value);
                    },
                    setUint8: function setUint8(byteOffset, value) {
                        set(this, 1, byteOffset, packI8, value);
                    },
                    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
                        set(this, 2, byteOffset, packI16, value, arguments[2]);
                    },
                    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
                        set(this, 2, byteOffset, packI16, value, arguments[2]);
                    },
                    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
                        set(this, 4, byteOffset, packI32, value, arguments[2]);
                    },
                    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
                        set(this, 4, byteOffset, packI32, value, arguments[2]);
                    },
                    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
                        set(this, 4, byteOffset, packF32, value, arguments[2]);
                    },
                    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
                        set(this, 8, byteOffset, packF64, value, arguments[2]);
                    }
                });
            } else {
                if (!fails(function () {
                    $ArrayBuffer(1);
                }) || !fails(function () {
                    new $ArrayBuffer(-1); // eslint-disable-line no-new
                }) || fails(function () {
                    new $ArrayBuffer(); // eslint-disable-line no-new
                    new $ArrayBuffer(1.5); // eslint-disable-line no-new
                    new $ArrayBuffer(NaN); // eslint-disable-line no-new
                    return $ArrayBuffer.name != ARRAY_BUFFER;
                })) {
                    $ArrayBuffer = function ArrayBuffer(length) {
                        anInstance(this, $ArrayBuffer);
                        return new BaseBuffer(toIndex(length));
                    };
                    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
                    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
                        if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
                    }
                    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
                }
                // iOS Safari 7.x bug
                var view = new $DataView(new $ArrayBuffer(2));
                var $setInt8 = $DataView[PROTOTYPE].setInt8;
                view.setInt8(0, 2147483648);
                view.setInt8(1, 2147483649);
                if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
                    setInt8: function setInt8(byteOffset, value) {
                        $setInt8.call(this, byteOffset, value << 24 >> 24);
                    },
                    setUint8: function setUint8(byteOffset, value) {
                        $setInt8.call(this, byteOffset, value << 24 >> 24);
                    }
                }, true);
            }
            setToStringTag($ArrayBuffer, ARRAY_BUFFER);
            setToStringTag($DataView, DATA_VIEW);
            hide($DataView[PROTOTYPE], $typed.VIEW, true);
            exports[ARRAY_BUFFER] = $ArrayBuffer;
            exports[DATA_VIEW] = $DataView;


            /***/ }),

        /***/ 9383:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var global = __webpack_require__(3816);
            var hide = __webpack_require__(7728);
            var uid = __webpack_require__(3953);
            var TYPED = uid('typed_array');
            var VIEW = uid('view');
            var ABV = !!(global.ArrayBuffer && global.DataView);
            var CONSTR = ABV;
            var i = 0;
            var l = 9;
            var Typed;

            var TypedArrayConstructors = (
                'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
            ).split(',');

            while (i < l) {
                if (Typed = global[TypedArrayConstructors[i++]]) {
                    hide(Typed.prototype, TYPED, true);
                    hide(Typed.prototype, VIEW, true);
                } else CONSTR = false;
            }

            module.exports = {
                ABV: ABV,
                CONSTR: CONSTR,
                TYPED: TYPED,
                VIEW: VIEW
            };


            /***/ }),

        /***/ 3953:
        /***/ ((module) => {

            var id = 0;
            var px = Math.random();
            module.exports = function (key) {
                return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
            };


            /***/ }),

        /***/ 575:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var global = __webpack_require__(3816);
            var navigator = global.navigator;

            module.exports = navigator && navigator.userAgent || '';


            /***/ }),

        /***/ 1616:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var isObject = __webpack_require__(5286);
            module.exports = function (it, TYPE) {
                if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
                return it;
            };


            /***/ }),

        /***/ 6074:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var global = __webpack_require__(3816);
            var core = __webpack_require__(5645);
            var LIBRARY = __webpack_require__(4461);
            var wksExt = __webpack_require__(8787);
            var defineProperty = (__webpack_require__(9275).f);
            module.exports = function (name) {
                var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
                if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
            };


            /***/ }),

        /***/ 8787:
        /***/ ((__unused_webpack_module, exports, __webpack_require__) => {

            exports.f = __webpack_require__(6314);


            /***/ }),

        /***/ 6314:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var store = __webpack_require__(3825)('wks');
            var uid = __webpack_require__(3953);
            var Symbol = (__webpack_require__(3816).Symbol);
            var USE_SYMBOL = typeof Symbol == 'function';

            var $exports = module.exports = function (name) {
                return store[name] || (store[name] =
                    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
            };

            $exports.store = store;


            /***/ }),

        /***/ 9002:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var classof = __webpack_require__(1488);
            var ITERATOR = __webpack_require__(6314)('iterator');
            var Iterators = __webpack_require__(2803);
            module.exports = (__webpack_require__(5645).getIteratorMethod) = function (it) {
                if (it != undefined) return it[ITERATOR]
                    || it['@@iterator']
                    || Iterators[classof(it)];
            };


            /***/ }),

        /***/ 2000:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
            var $export = __webpack_require__(2985);

            $export($export.P, 'Array', { copyWithin: __webpack_require__(5216) });

            __webpack_require__(7722)('copyWithin');


            /***/ }),

        /***/ 5745:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $every = __webpack_require__(50)(4);

            $export($export.P + $export.F * !__webpack_require__(7717)([].every, true), 'Array', {
                // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
                every: function every(callbackfn /* , thisArg */) {
                    return $every(this, callbackfn, arguments[1]);
                }
            });


            /***/ }),

        /***/ 8977:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
            var $export = __webpack_require__(2985);

            $export($export.P, 'Array', { fill: __webpack_require__(6852) });

            __webpack_require__(7722)('fill');


            /***/ }),

        /***/ 8837:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $filter = __webpack_require__(50)(2);

            $export($export.P + $export.F * !__webpack_require__(7717)([].filter, true), 'Array', {
                // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
                filter: function filter(callbackfn /* , thisArg */) {
                    return $filter(this, callbackfn, arguments[1]);
                }
            });


            /***/ }),

        /***/ 4899:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
            var $export = __webpack_require__(2985);
            var $find = __webpack_require__(50)(6);
            var KEY = 'findIndex';
            var forced = true;
// Shouldn't skip holes
            if (KEY in []) Array(1)[KEY](function () { forced = false; });
            $export($export.P + $export.F * forced, 'Array', {
                findIndex: function findIndex(callbackfn /* , that = undefined */) {
                    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                }
            });
            __webpack_require__(7722)(KEY);


            /***/ }),

        /***/ 2310:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
            var $export = __webpack_require__(2985);
            var $find = __webpack_require__(50)(5);
            var KEY = 'find';
            var forced = true;
// Shouldn't skip holes
            if (KEY in []) Array(1)[KEY](function () { forced = false; });
            $export($export.P + $export.F * forced, 'Array', {
                find: function find(callbackfn /* , that = undefined */) {
                    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
                }
            });
            __webpack_require__(7722)(KEY);


            /***/ }),

        /***/ 4336:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $forEach = __webpack_require__(50)(0);
            var STRICT = __webpack_require__(7717)([].forEach, true);

            $export($export.P + $export.F * !STRICT, 'Array', {
                // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
                forEach: function forEach(callbackfn /* , thisArg */) {
                    return $forEach(this, callbackfn, arguments[1]);
                }
            });


            /***/ }),

        /***/ 522:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var ctx = __webpack_require__(741);
            var $export = __webpack_require__(2985);
            var toObject = __webpack_require__(508);
            var call = __webpack_require__(8851);
            var isArrayIter = __webpack_require__(6555);
            var toLength = __webpack_require__(875);
            var createProperty = __webpack_require__(2811);
            var getIterFn = __webpack_require__(9002);

            $export($export.S + $export.F * !__webpack_require__(7462)(function (iter) { Array.from(iter); }), 'Array', {
                // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
                from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
                    var O = toObject(arrayLike);
                    var C = typeof this == 'function' ? this : Array;
                    var aLen = arguments.length;
                    var mapfn = aLen > 1 ? arguments[1] : undefined;
                    var mapping = mapfn !== undefined;
                    var index = 0;
                    var iterFn = getIterFn(O);
                    var length, result, step, iterator;
                    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
                    // if object isn't iterable or it's array with default iterator - use simple case
                    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
                        for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
                            createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
                        }
                    } else {
                        length = toLength(O.length);
                        for (result = new C(length); length > index; index++) {
                            createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
                        }
                    }
                    result.length = index;
                    return result;
                }
            });


            /***/ }),

        /***/ 3369:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $indexOf = __webpack_require__(9315)(false);
            var $native = [].indexOf;
            var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;

            $export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(7717)($native)), 'Array', {
                // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
                indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
                    return NEGATIVE_ZERO
                        // convert -0 to +0
                        ? $native.apply(this, arguments) || 0
                        : $indexOf(this, searchElement, arguments[1]);
                }
            });


            /***/ }),

        /***/ 774:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Array', { isArray: __webpack_require__(4302) });


            /***/ }),

        /***/ 6997:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var addToUnscopables = __webpack_require__(7722);
            var step = __webpack_require__(5436);
            var Iterators = __webpack_require__(2803);
            var toIObject = __webpack_require__(2110);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
            module.exports = __webpack_require__(2923)(Array, 'Array', function (iterated, kind) {
                this._t = toIObject(iterated); // target
                this._i = 0;                   // next index
                this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
            }, function () {
                var O = this._t;
                var kind = this._k;
                var index = this._i++;
                if (!O || index >= O.length) {
                    this._t = undefined;
                    return step(1);
                }
                if (kind == 'keys') return step(0, index);
                if (kind == 'values') return step(0, O[index]);
                return step(0, [index, O[index]]);
            }, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
            Iterators.Arguments = Iterators.Array;

            addToUnscopables('keys');
            addToUnscopables('values');
            addToUnscopables('entries');


            /***/ }),

        /***/ 7842:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// 22.1.3.13 Array.prototype.join(separator)
            var $export = __webpack_require__(2985);
            var toIObject = __webpack_require__(2110);
            var arrayJoin = [].join;

// fallback for not array-like strings
            $export($export.P + $export.F * (__webpack_require__(9797) != Object || !__webpack_require__(7717)(arrayJoin)), 'Array', {
                join: function join(separator) {
                    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
                }
            });


            /***/ }),

        /***/ 9564:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var toIObject = __webpack_require__(2110);
            var toInteger = __webpack_require__(1467);
            var toLength = __webpack_require__(875);
            var $native = [].lastIndexOf;
            var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;

            $export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(7717)($native)), 'Array', {
                // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
                lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
                    // convert -0 to +0
                    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
                    var O = toIObject(this);
                    var length = toLength(O.length);
                    var index = length - 1;
                    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
                    if (index < 0) index = length + index;
                    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
                    return -1;
                }
            });


            /***/ }),

        /***/ 1802:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $map = __webpack_require__(50)(1);

            $export($export.P + $export.F * !__webpack_require__(7717)([].map, true), 'Array', {
                // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
                map: function map(callbackfn /* , thisArg */) {
                    return $map(this, callbackfn, arguments[1]);
                }
            });


            /***/ }),

        /***/ 8295:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var createProperty = __webpack_require__(2811);

// WebKit Array.of isn't generic
            $export($export.S + $export.F * __webpack_require__(4253)(function () {
                function F() { /* empty */ }
                return !(Array.of.call(F) instanceof F);
            }), 'Array', {
                // 22.1.2.3 Array.of( ...items)
                of: function of(/* ...args */) {
                    var index = 0;
                    var aLen = arguments.length;
                    var result = new (typeof this == 'function' ? this : Array)(aLen);
                    while (aLen > index) createProperty(result, index, arguments[index++]);
                    result.length = aLen;
                    return result;
                }
            });


            /***/ }),

        /***/ 3750:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $reduce = __webpack_require__(7628);

            $export($export.P + $export.F * !__webpack_require__(7717)([].reduceRight, true), 'Array', {
                // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
                reduceRight: function reduceRight(callbackfn /* , initialValue */) {
                    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
                }
            });


            /***/ }),

        /***/ 3057:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $reduce = __webpack_require__(7628);

            $export($export.P + $export.F * !__webpack_require__(7717)([].reduce, true), 'Array', {
                // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
                reduce: function reduce(callbackfn /* , initialValue */) {
                    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
                }
            });


            /***/ }),

        /***/ 110:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var html = __webpack_require__(639);
            var cof = __webpack_require__(2032);
            var toAbsoluteIndex = __webpack_require__(2337);
            var toLength = __webpack_require__(875);
            var arraySlice = [].slice;

// fallback for not array-like ES3 strings and DOM objects
            $export($export.P + $export.F * __webpack_require__(4253)(function () {
                if (html) arraySlice.call(html);
            }), 'Array', {
                slice: function slice(begin, end) {
                    var len = toLength(this.length);
                    var klass = cof(this);
                    end = end === undefined ? len : end;
                    if (klass == 'Array') return arraySlice.call(this, begin, end);
                    var start = toAbsoluteIndex(begin, len);
                    var upTo = toAbsoluteIndex(end, len);
                    var size = toLength(upTo - start);
                    var cloned = new Array(size);
                    var i = 0;
                    for (; i < size; i++) cloned[i] = klass == 'String'
                        ? this.charAt(start + i)
                        : this[start + i];
                    return cloned;
                }
            });


            /***/ }),

        /***/ 6773:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $some = __webpack_require__(50)(3);

            $export($export.P + $export.F * !__webpack_require__(7717)([].some, true), 'Array', {
                // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
                some: function some(callbackfn /* , thisArg */) {
                    return $some(this, callbackfn, arguments[1]);
                }
            });


            /***/ }),

        /***/ 75:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var aFunction = __webpack_require__(4963);
            var toObject = __webpack_require__(508);
            var fails = __webpack_require__(4253);
            var $sort = [].sort;
            var test = [1, 2, 3];

            $export($export.P + $export.F * (fails(function () {
                // IE8-
                test.sort(undefined);
            }) || !fails(function () {
                // V8 bug
                test.sort(null);
                // Old WebKit
            }) || !__webpack_require__(7717)($sort)), 'Array', {
                // 22.1.3.25 Array.prototype.sort(comparefn)
                sort: function sort(comparefn) {
                    return comparefn === undefined
                        ? $sort.call(toObject(this))
                        : $sort.call(toObject(this), aFunction(comparefn));
                }
            });


            /***/ }),

        /***/ 1842:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(2974)('Array');


            /***/ }),

        /***/ 1822:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.3.3.1 / 15.9.4.4 Date.now()
            var $export = __webpack_require__(2985);

            $export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


            /***/ }),

        /***/ 1031:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
            var $export = __webpack_require__(2985);
            var toISOString = __webpack_require__(3537);

// PhantomJS / old WebKit has a broken implementations
            $export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
                toISOString: toISOString
            });


            /***/ }),

        /***/ 9977:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var toObject = __webpack_require__(508);
            var toPrimitive = __webpack_require__(1689);

            $export($export.P + $export.F * __webpack_require__(4253)(function () {
                return new Date(NaN).toJSON() !== null
                    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
            }), 'Date', {
                // eslint-disable-next-line no-unused-vars
                toJSON: function toJSON(key) {
                    var O = toObject(this);
                    var pv = toPrimitive(O);
                    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
                }
            });


            /***/ }),

        /***/ 1560:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var TO_PRIMITIVE = __webpack_require__(6314)('toPrimitive');
            var proto = Date.prototype;

            if (!(TO_PRIMITIVE in proto)) __webpack_require__(7728)(proto, TO_PRIMITIVE, __webpack_require__(870));


            /***/ }),

        /***/ 6331:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var DateProto = Date.prototype;
            var INVALID_DATE = 'Invalid Date';
            var TO_STRING = 'toString';
            var $toString = DateProto[TO_STRING];
            var getTime = DateProto.getTime;
            if (new Date(NaN) + '' != INVALID_DATE) {
                __webpack_require__(7234)(DateProto, TO_STRING, function toString() {
                    var value = getTime.call(this);
                    // eslint-disable-next-line no-self-compare
                    return value === value ? $toString.call(this) : INVALID_DATE;
                });
            }


            /***/ }),

        /***/ 9730:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
            var $export = __webpack_require__(2985);

            $export($export.P, 'Function', { bind: __webpack_require__(4398) });


            /***/ }),

        /***/ 8377:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var isObject = __webpack_require__(5286);
            var getPrototypeOf = __webpack_require__(468);
            var HAS_INSTANCE = __webpack_require__(6314)('hasInstance');
            var FunctionProto = Function.prototype;
// 19.2.3.6 Function.prototype[@@hasInstance](V)
            if (!(HAS_INSTANCE in FunctionProto)) (__webpack_require__(9275).f)(FunctionProto, HAS_INSTANCE, { value: function (O) {
                    if (typeof this != 'function' || !isObject(O)) return false;
                    if (!isObject(this.prototype)) return O instanceof this;
                    // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
                    while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
                    return false;
                } });


            /***/ }),

        /***/ 6059:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var dP = (__webpack_require__(9275).f);
            var FProto = Function.prototype;
            var nameRE = /^\s*function ([^ (]*)/;
            var NAME = 'name';

// 19.2.4.2 name
            NAME in FProto || __webpack_require__(7057) && dP(FProto, NAME, {
                configurable: true,
                get: function () {
                    try {
                        return ('' + this).match(nameRE)[1];
                    } catch (e) {
                        return '';
                    }
                }
            });


            /***/ }),

        /***/ 8416:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var strong = __webpack_require__(9824);
            var validate = __webpack_require__(1616);
            var MAP = 'Map';

// 23.1 Map Objects
            module.exports = __webpack_require__(5795)(MAP, function (get) {
                return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
            }, {
                // 23.1.3.6 Map.prototype.get(key)
                get: function get(key) {
                    var entry = strong.getEntry(validate(this, MAP), key);
                    return entry && entry.v;
                },
                // 23.1.3.9 Map.prototype.set(key, value)
                set: function set(key, value) {
                    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
                }
            }, strong, true);


            /***/ }),

        /***/ 6503:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.3 Math.acosh(x)
            var $export = __webpack_require__(2985);
            var log1p = __webpack_require__(6206);
            var sqrt = Math.sqrt;
            var $acosh = Math.acosh;

            $export($export.S + $export.F * !($acosh
                // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
                && Math.floor($acosh(Number.MAX_VALUE)) == 710
                // Tor Browser bug: Math.acosh(Infinity) -> NaN
                && $acosh(Infinity) == Infinity
            ), 'Math', {
                acosh: function acosh(x) {
                    return (x = +x) < 1 ? NaN : x > 94906265.62425156
                        ? Math.log(x) + Math.LN2
                        : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
                }
            });


            /***/ }),

        /***/ 6786:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.5 Math.asinh(x)
            var $export = __webpack_require__(2985);
            var $asinh = Math.asinh;

            function asinh(x) {
                return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
            }

// Tor Browser bug: Math.asinh(0) -> -0
            $export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


            /***/ }),

        /***/ 932:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.7 Math.atanh(x)
            var $export = __webpack_require__(2985);
            var $atanh = Math.atanh;

// Tor Browser bug: Math.atanh(-0) -> 0
            $export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
                atanh: function atanh(x) {
                    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
                }
            });


            /***/ }),

        /***/ 7526:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.9 Math.cbrt(x)
            var $export = __webpack_require__(2985);
            var sign = __webpack_require__(1801);

            $export($export.S, 'Math', {
                cbrt: function cbrt(x) {
                    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
                }
            });


            /***/ }),

        /***/ 1591:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.11 Math.clz32(x)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Math', {
                clz32: function clz32(x) {
                    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
                }
            });


            /***/ }),

        /***/ 9073:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.12 Math.cosh(x)
            var $export = __webpack_require__(2985);
            var exp = Math.exp;

            $export($export.S, 'Math', {
                cosh: function cosh(x) {
                    return (exp(x = +x) + exp(-x)) / 2;
                }
            });


            /***/ }),

        /***/ 347:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.14 Math.expm1(x)
            var $export = __webpack_require__(2985);
            var $expm1 = __webpack_require__(3086);

            $export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


            /***/ }),

        /***/ 579:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.16 Math.fround(x)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Math', { fround: __webpack_require__(4934) });


            /***/ }),

        /***/ 4669:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
            var $export = __webpack_require__(2985);
            var abs = Math.abs;

            $export($export.S, 'Math', {
                hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
                    var sum = 0;
                    var i = 0;
                    var aLen = arguments.length;
                    var larg = 0;
                    var arg, div;
                    while (i < aLen) {
                        arg = abs(arguments[i++]);
                        if (larg < arg) {
                            div = larg / arg;
                            sum = sum * div * div + 1;
                            larg = arg;
                        } else if (arg > 0) {
                            div = arg / larg;
                            sum += div * div;
                        } else sum += arg;
                    }
                    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
                }
            });


            /***/ }),

        /***/ 7710:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.18 Math.imul(x, y)
            var $export = __webpack_require__(2985);
            var $imul = Math.imul;

// some WebKit versions fails with big numbers, some has wrong arity
            $export($export.S + $export.F * __webpack_require__(4253)(function () {
                return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
            }), 'Math', {
                imul: function imul(x, y) {
                    var UINT16 = 0xffff;
                    var xn = +x;
                    var yn = +y;
                    var xl = UINT16 & xn;
                    var yl = UINT16 & yn;
                    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
                }
            });


            /***/ }),

        /***/ 5789:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.21 Math.log10(x)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Math', {
                log10: function log10(x) {
                    return Math.log(x) * Math.LOG10E;
                }
            });


            /***/ }),

        /***/ 3514:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.20 Math.log1p(x)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Math', { log1p: __webpack_require__(6206) });


            /***/ }),

        /***/ 9978:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.22 Math.log2(x)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Math', {
                log2: function log2(x) {
                    return Math.log(x) / Math.LN2;
                }
            });


            /***/ }),

        /***/ 8472:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.28 Math.sign(x)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Math', { sign: __webpack_require__(1801) });


            /***/ }),

        /***/ 6946:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.30 Math.sinh(x)
            var $export = __webpack_require__(2985);
            var expm1 = __webpack_require__(3086);
            var exp = Math.exp;

// V8 near Chromium 38 has a problem with very small numbers
            $export($export.S + $export.F * __webpack_require__(4253)(function () {
                return !Math.sinh(-2e-17) != -2e-17;
            }), 'Math', {
                sinh: function sinh(x) {
                    return Math.abs(x = +x) < 1
                        ? (expm1(x) - expm1(-x)) / 2
                        : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
                }
            });


            /***/ }),

        /***/ 5068:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.33 Math.tanh(x)
            var $export = __webpack_require__(2985);
            var expm1 = __webpack_require__(3086);
            var exp = Math.exp;

            $export($export.S, 'Math', {
                tanh: function tanh(x) {
                    var a = expm1(x = +x);
                    var b = expm1(-x);
                    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
                }
            });


            /***/ }),

        /***/ 413:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.2.2.34 Math.trunc(x)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Math', {
                trunc: function trunc(it) {
                    return (it > 0 ? Math.floor : Math.ceil)(it);
                }
            });


            /***/ }),

        /***/ 1246:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var global = __webpack_require__(3816);
            var has = __webpack_require__(9181);
            var cof = __webpack_require__(2032);
            var inheritIfRequired = __webpack_require__(266);
            var toPrimitive = __webpack_require__(1689);
            var fails = __webpack_require__(4253);
            var gOPN = (__webpack_require__(616).f);
            var gOPD = (__webpack_require__(8693).f);
            var dP = (__webpack_require__(9275).f);
            var $trim = (__webpack_require__(9599).trim);
            var NUMBER = 'Number';
            var $Number = global[NUMBER];
            var Base = $Number;
            var proto = $Number.prototype;
// Opera ~12 has broken Object#toString
            var BROKEN_COF = cof(__webpack_require__(2503)(proto)) == NUMBER;
            var TRIM = 'trim' in String.prototype;

// 7.1.3 ToNumber(argument)
            var toNumber = function (argument) {
                var it = toPrimitive(argument, false);
                if (typeof it == 'string' && it.length > 2) {
                    it = TRIM ? it.trim() : $trim(it, 3);
                    var first = it.charCodeAt(0);
                    var third, radix, maxCode;
                    if (first === 43 || first === 45) {
                        third = it.charCodeAt(2);
                        if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
                    } else if (first === 48) {
                        switch (it.charCodeAt(1)) {
                            case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
                            case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
                            default: return +it;
                        }
                        for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
                            code = digits.charCodeAt(i);
                            // parseInt parses a string to a first unavailable symbol
                            // but ToNumber should return NaN if a string contains unavailable symbols
                            if (code < 48 || code > maxCode) return NaN;
                        } return parseInt(digits, radix);
                    }
                } return +it;
            };

            if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
                $Number = function Number(value) {
                    var it = arguments.length < 1 ? 0 : value;
                    var that = this;
                    return that instanceof $Number
                    // check on 1..constructor(foo) case
                    && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
                        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
                };
                for (var keys = __webpack_require__(7057) ? gOPN(Base) : (
                    // ES3:
                    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
                    // ES6 (in case, if modules with ES6 Number statics required before):
                    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
                    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
                ).split(','), j = 0, key; keys.length > j; j++) {
                    if (has(Base, key = keys[j]) && !has($Number, key)) {
                        dP($Number, key, gOPD(Base, key));
                    }
                }
                $Number.prototype = proto;
                proto.constructor = $Number;
                __webpack_require__(7234)(global, NUMBER, $Number);
            }


            /***/ }),

        /***/ 5972:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.1.2.1 Number.EPSILON
            var $export = __webpack_require__(2985);

            $export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


            /***/ }),

        /***/ 3403:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.1.2.2 Number.isFinite(number)
            var $export = __webpack_require__(2985);
            var _isFinite = (__webpack_require__(3816).isFinite);

            $export($export.S, 'Number', {
                isFinite: function isFinite(it) {
                    return typeof it == 'number' && _isFinite(it);
                }
            });


            /***/ }),

        /***/ 2516:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.1.2.3 Number.isInteger(number)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Number', { isInteger: __webpack_require__(8367) });


            /***/ }),

        /***/ 9371:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.1.2.4 Number.isNaN(number)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Number', {
                isNaN: function isNaN(number) {
                    // eslint-disable-next-line no-self-compare
                    return number != number;
                }
            });


            /***/ }),

        /***/ 6479:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.1.2.5 Number.isSafeInteger(number)
            var $export = __webpack_require__(2985);
            var isInteger = __webpack_require__(8367);
            var abs = Math.abs;

            $export($export.S, 'Number', {
                isSafeInteger: function isSafeInteger(number) {
                    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
                }
            });


            /***/ }),

        /***/ 1736:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.1.2.6 Number.MAX_SAFE_INTEGER
            var $export = __webpack_require__(2985);

            $export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


            /***/ }),

        /***/ 1889:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 20.1.2.10 Number.MIN_SAFE_INTEGER
            var $export = __webpack_require__(2985);

            $export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


            /***/ }),

        /***/ 5177:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
            var $parseFloat = __webpack_require__(7743);
// 20.1.2.12 Number.parseFloat(string)
            $export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


            /***/ }),

        /***/ 6943:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
            var $parseInt = __webpack_require__(5960);
// 20.1.2.13 Number.parseInt(string, radix)
            $export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


            /***/ }),

        /***/ 726:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var toInteger = __webpack_require__(1467);
            var aNumberValue = __webpack_require__(3365);
            var repeat = __webpack_require__(8595);
            var $toFixed = 1.0.toFixed;
            var floor = Math.floor;
            var data = [0, 0, 0, 0, 0, 0];
            var ERROR = 'Number.toFixed: incorrect invocation!';
            var ZERO = '0';

            var multiply = function (n, c) {
                var i = -1;
                var c2 = c;
                while (++i < 6) {
                    c2 += n * data[i];
                    data[i] = c2 % 1e7;
                    c2 = floor(c2 / 1e7);
                }
            };
            var divide = function (n) {
                var i = 6;
                var c = 0;
                while (--i >= 0) {
                    c += data[i];
                    data[i] = floor(c / n);
                    c = (c % n) * 1e7;
                }
            };
            var numToString = function () {
                var i = 6;
                var s = '';
                while (--i >= 0) {
                    if (s !== '' || i === 0 || data[i] !== 0) {
                        var t = String(data[i]);
                        s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
                    }
                } return s;
            };
            var pow = function (x, n, acc) {
                return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
            };
            var log = function (x) {
                var n = 0;
                var x2 = x;
                while (x2 >= 4096) {
                    n += 12;
                    x2 /= 4096;
                }
                while (x2 >= 2) {
                    n += 1;
                    x2 /= 2;
                } return n;
            };

            $export($export.P + $export.F * (!!$toFixed && (
                0.00008.toFixed(3) !== '0.000' ||
                0.9.toFixed(0) !== '1' ||
                1.255.toFixed(2) !== '1.25' ||
                1000000000000000128.0.toFixed(0) !== '1000000000000000128'
            ) || !__webpack_require__(4253)(function () {
                // V8 ~ Android 4.3-
                $toFixed.call({});
            })), 'Number', {
                toFixed: function toFixed(fractionDigits) {
                    var x = aNumberValue(this, ERROR);
                    var f = toInteger(fractionDigits);
                    var s = '';
                    var m = ZERO;
                    var e, z, j, k;
                    if (f < 0 || f > 20) throw RangeError(ERROR);
                    // eslint-disable-next-line no-self-compare
                    if (x != x) return 'NaN';
                    if (x <= -1e21 || x >= 1e21) return String(x);
                    if (x < 0) {
                        s = '-';
                        x = -x;
                    }
                    if (x > 1e-21) {
                        e = log(x * pow(2, 69, 1)) - 69;
                        z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
                        z *= 0x10000000000000;
                        e = 52 - e;
                        if (e > 0) {
                            multiply(0, z);
                            j = f;
                            while (j >= 7) {
                                multiply(1e7, 0);
                                j -= 7;
                            }
                            multiply(pow(10, j, 1), 0);
                            j = e - 1;
                            while (j >= 23) {
                                divide(1 << 23);
                                j -= 23;
                            }
                            divide(1 << j);
                            multiply(1, 1);
                            divide(2);
                            m = numToString();
                        } else {
                            multiply(0, z);
                            multiply(1 << -e, 0);
                            m = numToString() + repeat.call(ZERO, f);
                        }
                    }
                    if (f > 0) {
                        k = m.length;
                        m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
                    } else {
                        m = s + m;
                    } return m;
                }
            });


            /***/ }),

        /***/ 1901:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $fails = __webpack_require__(4253);
            var aNumberValue = __webpack_require__(3365);
            var $toPrecision = 1.0.toPrecision;

            $export($export.P + $export.F * ($fails(function () {
                // IE7-
                return $toPrecision.call(1, undefined) !== '1';
            }) || !$fails(function () {
                // V8 ~ Android 4.3-
                $toPrecision.call({});
            })), 'Number', {
                toPrecision: function toPrecision(precision) {
                    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
                    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
                }
            });


            /***/ }),

        /***/ 5115:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.3.1 Object.assign(target, source)
            var $export = __webpack_require__(2985);

            $export($export.S + $export.F, 'Object', { assign: __webpack_require__(5345) });


            /***/ }),

        /***/ 8132:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
            $export($export.S, 'Object', { create: __webpack_require__(2503) });


            /***/ }),

        /***/ 7470:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
            $export($export.S + $export.F * !__webpack_require__(7057), 'Object', { defineProperties: __webpack_require__(5588) });


            /***/ }),

        /***/ 8388:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
            $export($export.S + $export.F * !__webpack_require__(7057), 'Object', { defineProperty: (__webpack_require__(9275).f) });


            /***/ }),

        /***/ 9375:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.5 Object.freeze(O)
            var isObject = __webpack_require__(5286);
            var meta = (__webpack_require__(4728).onFreeze);

            __webpack_require__(3160)('freeze', function ($freeze) {
                return function freeze(it) {
                    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
                };
            });


            /***/ }),

        /***/ 4882:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
            var toIObject = __webpack_require__(2110);
            var $getOwnPropertyDescriptor = (__webpack_require__(8693).f);

            __webpack_require__(3160)('getOwnPropertyDescriptor', function () {
                return function getOwnPropertyDescriptor(it, key) {
                    return $getOwnPropertyDescriptor(toIObject(it), key);
                };
            });


            /***/ }),

        /***/ 9622:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.7 Object.getOwnPropertyNames(O)
            __webpack_require__(3160)('getOwnPropertyNames', function () {
                return (__webpack_require__(9327).f);
            });


            /***/ }),

        /***/ 1520:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.9 Object.getPrototypeOf(O)
            var toObject = __webpack_require__(508);
            var $getPrototypeOf = __webpack_require__(468);

            __webpack_require__(3160)('getPrototypeOf', function () {
                return function getPrototypeOf(it) {
                    return $getPrototypeOf(toObject(it));
                };
            });


            /***/ }),

        /***/ 9892:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.11 Object.isExtensible(O)
            var isObject = __webpack_require__(5286);

            __webpack_require__(3160)('isExtensible', function ($isExtensible) {
                return function isExtensible(it) {
                    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
                };
            });


            /***/ }),

        /***/ 4157:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.12 Object.isFrozen(O)
            var isObject = __webpack_require__(5286);

            __webpack_require__(3160)('isFrozen', function ($isFrozen) {
                return function isFrozen(it) {
                    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
                };
            });


            /***/ }),

        /***/ 5095:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.13 Object.isSealed(O)
            var isObject = __webpack_require__(5286);

            __webpack_require__(3160)('isSealed', function ($isSealed) {
                return function isSealed(it) {
                    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
                };
            });


            /***/ }),

        /***/ 9176:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.3.10 Object.is(value1, value2)
            var $export = __webpack_require__(2985);
            $export($export.S, 'Object', { is: __webpack_require__(7195) });


            /***/ }),

        /***/ 7476:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.14 Object.keys(O)
            var toObject = __webpack_require__(508);
            var $keys = __webpack_require__(7184);

            __webpack_require__(3160)('keys', function () {
                return function keys(it) {
                    return $keys(toObject(it));
                };
            });


            /***/ }),

        /***/ 4672:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.15 Object.preventExtensions(O)
            var isObject = __webpack_require__(5286);
            var meta = (__webpack_require__(4728).onFreeze);

            __webpack_require__(3160)('preventExtensions', function ($preventExtensions) {
                return function preventExtensions(it) {
                    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
                };
            });


            /***/ }),

        /***/ 3533:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.2.17 Object.seal(O)
            var isObject = __webpack_require__(5286);
            var meta = (__webpack_require__(4728).onFreeze);

            __webpack_require__(3160)('seal', function ($seal) {
                return function seal(it) {
                    return $seal && isObject(it) ? $seal(meta(it)) : it;
                };
            });


            /***/ }),

        /***/ 8838:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
            var $export = __webpack_require__(2985);
            $export($export.S, 'Object', { setPrototypeOf: (__webpack_require__(7375).set) });


            /***/ }),

        /***/ 6253:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// 19.1.3.6 Object.prototype.toString()
            var classof = __webpack_require__(1488);
            var test = {};
            test[__webpack_require__(6314)('toStringTag')] = 'z';
            if (test + '' != '[object z]') {
                __webpack_require__(7234)(Object.prototype, 'toString', function toString() {
                    return '[object ' + classof(this) + ']';
                }, true);
            }


            /***/ }),

        /***/ 4299:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
            var $parseFloat = __webpack_require__(7743);
// 18.2.4 parseFloat(string)
            $export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


            /***/ }),

        /***/ 1084:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
            var $parseInt = __webpack_require__(5960);
// 18.2.5 parseInt(string, radix)
            $export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


            /***/ }),

        /***/ 851:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var LIBRARY = __webpack_require__(4461);
            var global = __webpack_require__(3816);
            var ctx = __webpack_require__(741);
            var classof = __webpack_require__(1488);
            var $export = __webpack_require__(2985);
            var isObject = __webpack_require__(5286);
            var aFunction = __webpack_require__(4963);
            var anInstance = __webpack_require__(3328);
            var forOf = __webpack_require__(3531);
            var speciesConstructor = __webpack_require__(8364);
            var task = (__webpack_require__(4193).set);
            var microtask = __webpack_require__(4351)();
            var newPromiseCapabilityModule = __webpack_require__(3499);
            var perform = __webpack_require__(188);
            var userAgent = __webpack_require__(575);
            var promiseResolve = __webpack_require__(94);
            var PROMISE = 'Promise';
            var TypeError = global.TypeError;
            var process = global.process;
            var versions = process && process.versions;
            var v8 = versions && versions.v8 || '';
            var $Promise = global[PROMISE];
            var isNode = classof(process) == 'process';
            var empty = function () { /* empty */ };
            var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
            var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

            var USE_NATIVE = !!function () {
                try {
                    // correct subclassing with @@species support
                    var promise = $Promise.resolve(1);
                    var FakePromise = (promise.constructor = {})[__webpack_require__(6314)('species')] = function (exec) {
                        exec(empty, empty);
                    };
                    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
                    return (isNode || typeof PromiseRejectionEvent == 'function')
                        && promise.then(empty) instanceof FakePromise
                        // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
                        // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
                        // we can't detect it synchronously, so just check versions
                        && v8.indexOf('6.6') !== 0
                        && userAgent.indexOf('Chrome/66') === -1;
                } catch (e) { /* empty */ }
            }();

// helpers
            var isThenable = function (it) {
                var then;
                return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
            };
            var notify = function (promise, isReject) {
                if (promise._n) return;
                promise._n = true;
                var chain = promise._c;
                microtask(function () {
                    var value = promise._v;
                    var ok = promise._s == 1;
                    var i = 0;
                    var run = function (reaction) {
                        var handler = ok ? reaction.ok : reaction.fail;
                        var resolve = reaction.resolve;
                        var reject = reaction.reject;
                        var domain = reaction.domain;
                        var result, then, exited;
                        try {
                            if (handler) {
                                if (!ok) {
                                    if (promise._h == 2) onHandleUnhandled(promise);
                                    promise._h = 1;
                                }
                                if (handler === true) result = value;
                                else {
                                    if (domain) domain.enter();
                                    result = handler(value); // may throw
                                    if (domain) {
                                        domain.exit();
                                        exited = true;
                                    }
                                }
                                if (result === reaction.promise) {
                                    reject(TypeError('Promise-chain cycle'));
                                } else if (then = isThenable(result)) {
                                    then.call(result, resolve, reject);
                                } else resolve(result);
                            } else reject(value);
                        } catch (e) {
                            if (domain && !exited) domain.exit();
                            reject(e);
                        }
                    };
                    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
                    promise._c = [];
                    promise._n = false;
                    if (isReject && !promise._h) onUnhandled(promise);
                });
            };
            var onUnhandled = function (promise) {
                task.call(global, function () {
                    var value = promise._v;
                    var unhandled = isUnhandled(promise);
                    var result, handler, console;
                    if (unhandled) {
                        result = perform(function () {
                            if (isNode) {
                                process.emit('unhandledRejection', value, promise);
                            } else if (handler = global.onunhandledrejection) {
                                handler({ promise: promise, reason: value });
                            } else if ((console = global.console) && console.error) {
                                console.error('Unhandled promise rejection', value);
                            }
                        });
                        // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
                        promise._h = isNode || isUnhandled(promise) ? 2 : 1;
                    } promise._a = undefined;
                    if (unhandled && result.e) throw result.v;
                });
            };
            var isUnhandled = function (promise) {
                return promise._h !== 1 && (promise._a || promise._c).length === 0;
            };
            var onHandleUnhandled = function (promise) {
                task.call(global, function () {
                    var handler;
                    if (isNode) {
                        process.emit('rejectionHandled', promise);
                    } else if (handler = global.onrejectionhandled) {
                        handler({ promise: promise, reason: promise._v });
                    }
                });
            };
            var $reject = function (value) {
                var promise = this;
                if (promise._d) return;
                promise._d = true;
                promise = promise._w || promise; // unwrap
                promise._v = value;
                promise._s = 2;
                if (!promise._a) promise._a = promise._c.slice();
                notify(promise, true);
            };
            var $resolve = function (value) {
                var promise = this;
                var then;
                if (promise._d) return;
                promise._d = true;
                promise = promise._w || promise; // unwrap
                try {
                    if (promise === value) throw TypeError("Promise can't be resolved itself");
                    if (then = isThenable(value)) {
                        microtask(function () {
                            var wrapper = { _w: promise, _d: false }; // wrap
                            try {
                                then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
                            } catch (e) {
                                $reject.call(wrapper, e);
                            }
                        });
                    } else {
                        promise._v = value;
                        promise._s = 1;
                        notify(promise, false);
                    }
                } catch (e) {
                    $reject.call({ _w: promise, _d: false }, e); // wrap
                }
            };

// constructor polyfill
            if (!USE_NATIVE) {
                // 25.4.3.1 Promise(executor)
                $Promise = function Promise(executor) {
                    anInstance(this, $Promise, PROMISE, '_h');
                    aFunction(executor);
                    Internal.call(this);
                    try {
                        executor(ctx($resolve, this, 1), ctx($reject, this, 1));
                    } catch (err) {
                        $reject.call(this, err);
                    }
                };
                // eslint-disable-next-line no-unused-vars
                Internal = function Promise(executor) {
                    this._c = [];             // <- awaiting reactions
                    this._a = undefined;      // <- checked in isUnhandled reactions
                    this._s = 0;              // <- state
                    this._d = false;          // <- done
                    this._v = undefined;      // <- value
                    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
                    this._n = false;          // <- notify
                };
                Internal.prototype = __webpack_require__(4408)($Promise.prototype, {
                    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
                    then: function then(onFulfilled, onRejected) {
                        var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
                        reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
                        reaction.fail = typeof onRejected == 'function' && onRejected;
                        reaction.domain = isNode ? process.domain : undefined;
                        this._c.push(reaction);
                        if (this._a) this._a.push(reaction);
                        if (this._s) notify(this, false);
                        return reaction.promise;
                    },
                    // 25.4.5.1 Promise.prototype.catch(onRejected)
                    'catch': function (onRejected) {
                        return this.then(undefined, onRejected);
                    }
                });
                OwnPromiseCapability = function () {
                    var promise = new Internal();
                    this.promise = promise;
                    this.resolve = ctx($resolve, promise, 1);
                    this.reject = ctx($reject, promise, 1);
                };
                newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
                    return C === $Promise || C === Wrapper
                        ? new OwnPromiseCapability(C)
                        : newGenericPromiseCapability(C);
                };
            }

            $export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
            __webpack_require__(2943)($Promise, PROMISE);
            __webpack_require__(2974)(PROMISE);
            Wrapper = __webpack_require__(5645)[PROMISE];

// statics
            $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
                // 25.4.4.5 Promise.reject(r)
                reject: function reject(r) {
                    var capability = newPromiseCapability(this);
                    var $$reject = capability.reject;
                    $$reject(r);
                    return capability.promise;
                }
            });
            $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
                // 25.4.4.6 Promise.resolve(x)
                resolve: function resolve(x) {
                    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
                }
            });
            $export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(7462)(function (iter) {
                $Promise.all(iter)['catch'](empty);
            })), PROMISE, {
                // 25.4.4.1 Promise.all(iterable)
                all: function all(iterable) {
                    var C = this;
                    var capability = newPromiseCapability(C);
                    var resolve = capability.resolve;
                    var reject = capability.reject;
                    var result = perform(function () {
                        var values = [];
                        var index = 0;
                        var remaining = 1;
                        forOf(iterable, false, function (promise) {
                            var $index = index++;
                            var alreadyCalled = false;
                            values.push(undefined);
                            remaining++;
                            C.resolve(promise).then(function (value) {
                                if (alreadyCalled) return;
                                alreadyCalled = true;
                                values[$index] = value;
                                --remaining || resolve(values);
                            }, reject);
                        });
                        --remaining || resolve(values);
                    });
                    if (result.e) reject(result.v);
                    return capability.promise;
                },
                // 25.4.4.4 Promise.race(iterable)
                race: function race(iterable) {
                    var C = this;
                    var capability = newPromiseCapability(C);
                    var reject = capability.reject;
                    var result = perform(function () {
                        forOf(iterable, false, function (promise) {
                            C.resolve(promise).then(capability.resolve, reject);
                        });
                    });
                    if (result.e) reject(result.v);
                    return capability.promise;
                }
            });


            /***/ }),

        /***/ 1572:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
            var $export = __webpack_require__(2985);
            var aFunction = __webpack_require__(4963);
            var anObject = __webpack_require__(7007);
            var rApply = ((__webpack_require__(3816).Reflect) || {}).apply;
            var fApply = Function.apply;
// MS Edge argumentsList argument is optional
            $export($export.S + $export.F * !__webpack_require__(4253)(function () {
                rApply(function () { /* empty */ });
            }), 'Reflect', {
                apply: function apply(target, thisArgument, argumentsList) {
                    var T = aFunction(target);
                    var L = anObject(argumentsList);
                    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
                }
            });


            /***/ }),

        /***/ 2139:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
            var $export = __webpack_require__(2985);
            var create = __webpack_require__(2503);
            var aFunction = __webpack_require__(4963);
            var anObject = __webpack_require__(7007);
            var isObject = __webpack_require__(5286);
            var fails = __webpack_require__(4253);
            var bind = __webpack_require__(4398);
            var rConstruct = ((__webpack_require__(3816).Reflect) || {}).construct;

// MS Edge supports only 2 arguments and argumentsList argument is optional
// FF Nightly sets third argument as `new.target`, but does not create `this` from it
            var NEW_TARGET_BUG = fails(function () {
                function F() { /* empty */ }
                return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
            });
            var ARGS_BUG = !fails(function () {
                rConstruct(function () { /* empty */ });
            });

            $export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
                construct: function construct(Target, args /* , newTarget */) {
                    aFunction(Target);
                    anObject(args);
                    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
                    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
                    if (Target == newTarget) {
                        // w/o altered newTarget, optimization for 0-4 arguments
                        switch (args.length) {
                            case 0: return new Target();
                            case 1: return new Target(args[0]);
                            case 2: return new Target(args[0], args[1]);
                            case 3: return new Target(args[0], args[1], args[2]);
                            case 4: return new Target(args[0], args[1], args[2], args[3]);
                        }
                        // w/o altered newTarget, lot of arguments case
                        var $args = [null];
                        $args.push.apply($args, args);
                        return new (bind.apply(Target, $args))();
                    }
                    // with altered newTarget, not support built-in constructors
                    var proto = newTarget.prototype;
                    var instance = create(isObject(proto) ? proto : Object.prototype);
                    var result = Function.apply.call(Target, instance, args);
                    return isObject(result) ? result : instance;
                }
            });


            /***/ }),

        /***/ 685:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
            var dP = __webpack_require__(9275);
            var $export = __webpack_require__(2985);
            var anObject = __webpack_require__(7007);
            var toPrimitive = __webpack_require__(1689);

// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
            $export($export.S + $export.F * __webpack_require__(4253)(function () {
                // eslint-disable-next-line no-undef
                Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
            }), 'Reflect', {
                defineProperty: function defineProperty(target, propertyKey, attributes) {
                    anObject(target);
                    propertyKey = toPrimitive(propertyKey, true);
                    anObject(attributes);
                    try {
                        dP.f(target, propertyKey, attributes);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
            });


            /***/ }),

        /***/ 5535:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.4 Reflect.deleteProperty(target, propertyKey)
            var $export = __webpack_require__(2985);
            var gOPD = (__webpack_require__(8693).f);
            var anObject = __webpack_require__(7007);

            $export($export.S, 'Reflect', {
                deleteProperty: function deleteProperty(target, propertyKey) {
                    var desc = gOPD(anObject(target), propertyKey);
                    return desc && !desc.configurable ? false : delete target[propertyKey];
                }
            });


            /***/ }),

        /***/ 7347:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// 26.1.5 Reflect.enumerate(target)
            var $export = __webpack_require__(2985);
            var anObject = __webpack_require__(7007);
            var Enumerate = function (iterated) {
                this._t = anObject(iterated); // target
                this._i = 0;                  // next index
                var keys = this._k = [];      // keys
                var key;
                for (key in iterated) keys.push(key);
            };
            __webpack_require__(9988)(Enumerate, 'Object', function () {
                var that = this;
                var keys = that._k;
                var key;
                do {
                    if (that._i >= keys.length) return { value: undefined, done: true };
                } while (!((key = keys[that._i++]) in that._t));
                return { value: key, done: false };
            });

            $export($export.S, 'Reflect', {
                enumerate: function enumerate(target) {
                    return new Enumerate(target);
                }
            });


            /***/ }),

        /***/ 6633:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
            var gOPD = __webpack_require__(8693);
            var $export = __webpack_require__(2985);
            var anObject = __webpack_require__(7007);

            $export($export.S, 'Reflect', {
                getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
                    return gOPD.f(anObject(target), propertyKey);
                }
            });


            /***/ }),

        /***/ 8989:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.8 Reflect.getPrototypeOf(target)
            var $export = __webpack_require__(2985);
            var getProto = __webpack_require__(468);
            var anObject = __webpack_require__(7007);

            $export($export.S, 'Reflect', {
                getPrototypeOf: function getPrototypeOf(target) {
                    return getProto(anObject(target));
                }
            });


            /***/ }),

        /***/ 3049:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.6 Reflect.get(target, propertyKey [, receiver])
            var gOPD = __webpack_require__(8693);
            var getPrototypeOf = __webpack_require__(468);
            var has = __webpack_require__(9181);
            var $export = __webpack_require__(2985);
            var isObject = __webpack_require__(5286);
            var anObject = __webpack_require__(7007);

            function get(target, propertyKey /* , receiver */) {
                var receiver = arguments.length < 3 ? target : arguments[2];
                var desc, proto;
                if (anObject(target) === receiver) return target[propertyKey];
                if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
                    ? desc.value
                    : desc.get !== undefined
                        ? desc.get.call(receiver)
                        : undefined;
                if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
            }

            $export($export.S, 'Reflect', { get: get });


            /***/ }),

        /***/ 8270:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.9 Reflect.has(target, propertyKey)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Reflect', {
                has: function has(target, propertyKey) {
                    return propertyKey in target;
                }
            });


            /***/ }),

        /***/ 4510:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.10 Reflect.isExtensible(target)
            var $export = __webpack_require__(2985);
            var anObject = __webpack_require__(7007);
            var $isExtensible = Object.isExtensible;

            $export($export.S, 'Reflect', {
                isExtensible: function isExtensible(target) {
                    anObject(target);
                    return $isExtensible ? $isExtensible(target) : true;
                }
            });


            /***/ }),

        /***/ 3984:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.11 Reflect.ownKeys(target)
            var $export = __webpack_require__(2985);

            $export($export.S, 'Reflect', { ownKeys: __webpack_require__(7643) });


            /***/ }),

        /***/ 5769:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.12 Reflect.preventExtensions(target)
            var $export = __webpack_require__(2985);
            var anObject = __webpack_require__(7007);
            var $preventExtensions = Object.preventExtensions;

            $export($export.S, 'Reflect', {
                preventExtensions: function preventExtensions(target) {
                    anObject(target);
                    try {
                        if ($preventExtensions) $preventExtensions(target);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
            });


            /***/ }),

        /***/ 6014:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.14 Reflect.setPrototypeOf(target, proto)
            var $export = __webpack_require__(2985);
            var setProto = __webpack_require__(7375);

            if (setProto) $export($export.S, 'Reflect', {
                setPrototypeOf: function setPrototypeOf(target, proto) {
                    setProto.check(target, proto);
                    try {
                        setProto.set(target, proto);
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
            });


            /***/ }),

        /***/ 55:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
            var dP = __webpack_require__(9275);
            var gOPD = __webpack_require__(8693);
            var getPrototypeOf = __webpack_require__(468);
            var has = __webpack_require__(9181);
            var $export = __webpack_require__(2985);
            var createDesc = __webpack_require__(681);
            var anObject = __webpack_require__(7007);
            var isObject = __webpack_require__(5286);

            function set(target, propertyKey, V /* , receiver */) {
                var receiver = arguments.length < 4 ? target : arguments[3];
                var ownDesc = gOPD.f(anObject(target), propertyKey);
                var existingDescriptor, proto;
                if (!ownDesc) {
                    if (isObject(proto = getPrototypeOf(target))) {
                        return set(proto, propertyKey, V, receiver);
                    }
                    ownDesc = createDesc(0);
                }
                if (has(ownDesc, 'value')) {
                    if (ownDesc.writable === false || !isObject(receiver)) return false;
                    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
                        if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
                        existingDescriptor.value = V;
                        dP.f(receiver, propertyKey, existingDescriptor);
                    } else dP.f(receiver, propertyKey, createDesc(0, V));
                    return true;
                }
                return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
            }

            $export($export.S, 'Reflect', { set: set });


            /***/ }),

        /***/ 3946:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var global = __webpack_require__(3816);
            var inheritIfRequired = __webpack_require__(266);
            var dP = (__webpack_require__(9275).f);
            var gOPN = (__webpack_require__(616).f);
            var isRegExp = __webpack_require__(5364);
            var $flags = __webpack_require__(3218);
            var $RegExp = global.RegExp;
            var Base = $RegExp;
            var proto = $RegExp.prototype;
            var re1 = /a/g;
            var re2 = /a/g;
// "new" creates a new object, old webkit buggy here
            var CORRECT_NEW = new $RegExp(re1) !== re1;

            if (__webpack_require__(7057) && (!CORRECT_NEW || __webpack_require__(4253)(function () {
                re2[__webpack_require__(6314)('match')] = false;
                // RegExp constructor can alter flags and IsRegExp works correct with @@match
                return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
            }))) {
                $RegExp = function RegExp(p, f) {
                    var tiRE = this instanceof $RegExp;
                    var piRE = isRegExp(p);
                    var fiU = f === undefined;
                    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
                        : inheritIfRequired(CORRECT_NEW
                                ? new Base(piRE && !fiU ? p.source : p, f)
                                : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
                            , tiRE ? this : proto, $RegExp);
                };
                var proxy = function (key) {
                    key in $RegExp || dP($RegExp, key, {
                        configurable: true,
                        get: function () { return Base[key]; },
                        set: function (it) { Base[key] = it; }
                    });
                };
                for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
                proto.constructor = $RegExp;
                $RegExp.prototype = proto;
                __webpack_require__(7234)(global, 'RegExp', $RegExp);
            }

            __webpack_require__(2974)('RegExp');


            /***/ }),

        /***/ 8269:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var regexpExec = __webpack_require__(1165);
            __webpack_require__(2985)({
                target: 'RegExp',
                proto: true,
                forced: regexpExec !== /./.exec
            }, {
                exec: regexpExec
            });


            /***/ }),

        /***/ 6774:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// 21.2.5.3 get RegExp.prototype.flags()
            if (__webpack_require__(7057) && /./g.flags != 'g') (__webpack_require__(9275).f)(RegExp.prototype, 'flags', {
                configurable: true,
                get: __webpack_require__(3218)
            });


            /***/ }),

        /***/ 1466:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";


            var anObject = __webpack_require__(7007);
            var toLength = __webpack_require__(875);
            var advanceStringIndex = __webpack_require__(6793);
            var regExpExec = __webpack_require__(7787);

// @@match logic
            __webpack_require__(8082)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
                return [
                    // `String.prototype.match` method
                    // https://tc39.github.io/ecma262/#sec-string.prototype.match
                    function match(regexp) {
                        var O = defined(this);
                        var fn = regexp == undefined ? undefined : regexp[MATCH];
                        return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
                    },
                    // `RegExp.prototype[@@match]` method
                    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
                    function (regexp) {
                        var res = maybeCallNative($match, regexp, this);
                        if (res.done) return res.value;
                        var rx = anObject(regexp);
                        var S = String(this);
                        if (!rx.global) return regExpExec(rx, S);
                        var fullUnicode = rx.unicode;
                        rx.lastIndex = 0;
                        var A = [];
                        var n = 0;
                        var result;
                        while ((result = regExpExec(rx, S)) !== null) {
                            var matchStr = String(result[0]);
                            A[n] = matchStr;
                            if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                            n++;
                        }
                        return n === 0 ? null : A;
                    }
                ];
            });


            /***/ }),

        /***/ 9357:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";


            var anObject = __webpack_require__(7007);
            var toObject = __webpack_require__(508);
            var toLength = __webpack_require__(875);
            var toInteger = __webpack_require__(1467);
            var advanceStringIndex = __webpack_require__(6793);
            var regExpExec = __webpack_require__(7787);
            var max = Math.max;
            var min = Math.min;
            var floor = Math.floor;
            var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
            var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;

            var maybeToString = function (it) {
                return it === undefined ? it : String(it);
            };

// @@replace logic
            __webpack_require__(8082)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
                return [
                    // `String.prototype.replace` method
                    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
                    function replace(searchValue, replaceValue) {
                        var O = defined(this);
                        var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
                        return fn !== undefined
                            ? fn.call(searchValue, O, replaceValue)
                            : $replace.call(String(O), searchValue, replaceValue);
                    },
                    // `RegExp.prototype[@@replace]` method
                    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
                    function (regexp, replaceValue) {
                        var res = maybeCallNative($replace, regexp, this, replaceValue);
                        if (res.done) return res.value;

                        var rx = anObject(regexp);
                        var S = String(this);
                        var functionalReplace = typeof replaceValue === 'function';
                        if (!functionalReplace) replaceValue = String(replaceValue);
                        var global = rx.global;
                        if (global) {
                            var fullUnicode = rx.unicode;
                            rx.lastIndex = 0;
                        }
                        var results = [];
                        while (true) {
                            var result = regExpExec(rx, S);
                            if (result === null) break;
                            results.push(result);
                            if (!global) break;
                            var matchStr = String(result[0]);
                            if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
                        }
                        var accumulatedResult = '';
                        var nextSourcePosition = 0;
                        for (var i = 0; i < results.length; i++) {
                            result = results[i];
                            var matched = String(result[0]);
                            var position = max(min(toInteger(result.index), S.length), 0);
                            var captures = [];
                            // NOTE: This is equivalent to
                            //   captures = result.slice(1).map(maybeToString)
                            // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
                            // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
                            // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
                            for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
                            var namedCaptures = result.groups;
                            if (functionalReplace) {
                                var replacerArgs = [matched].concat(captures, position, S);
                                if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
                                var replacement = String(replaceValue.apply(undefined, replacerArgs));
                            } else {
                                replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
                            }
                            if (position >= nextSourcePosition) {
                                accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
                                nextSourcePosition = position + matched.length;
                            }
                        }
                        return accumulatedResult + S.slice(nextSourcePosition);
                    }
                ];

                // https://tc39.github.io/ecma262/#sec-getsubstitution
                function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
                    var tailPos = position + matched.length;
                    var m = captures.length;
                    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
                    if (namedCaptures !== undefined) {
                        namedCaptures = toObject(namedCaptures);
                        symbols = SUBSTITUTION_SYMBOLS;
                    }
                    return $replace.call(replacement, symbols, function (match, ch) {
                        var capture;
                        switch (ch.charAt(0)) {
                            case '$': return '$';
                            case '&': return matched;
                            case '`': return str.slice(0, position);
                            case "'": return str.slice(tailPos);
                            case '<':
                                capture = namedCaptures[ch.slice(1, -1)];
                                break;
                            default: // \d\d?
                                var n = +ch;
                                if (n === 0) return match;
                                if (n > m) {
                                    var f = floor(n / 10);
                                    if (f === 0) return match;
                                    if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
                                    return match;
                                }
                                capture = captures[n - 1];
                        }
                        return capture === undefined ? '' : capture;
                    });
                }
            });


            /***/ }),

        /***/ 6142:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";


            var anObject = __webpack_require__(7007);
            var sameValue = __webpack_require__(7195);
            var regExpExec = __webpack_require__(7787);

// @@search logic
            __webpack_require__(8082)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
                return [
                    // `String.prototype.search` method
                    // https://tc39.github.io/ecma262/#sec-string.prototype.search
                    function search(regexp) {
                        var O = defined(this);
                        var fn = regexp == undefined ? undefined : regexp[SEARCH];
                        return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
                    },
                    // `RegExp.prototype[@@search]` method
                    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
                    function (regexp) {
                        var res = maybeCallNative($search, regexp, this);
                        if (res.done) return res.value;
                        var rx = anObject(regexp);
                        var S = String(this);
                        var previousLastIndex = rx.lastIndex;
                        if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
                        var result = regExpExec(rx, S);
                        if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
                        return result === null ? -1 : result.index;
                    }
                ];
            });


            /***/ }),

        /***/ 1876:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";


            var isRegExp = __webpack_require__(5364);
            var anObject = __webpack_require__(7007);
            var speciesConstructor = __webpack_require__(8364);
            var advanceStringIndex = __webpack_require__(6793);
            var toLength = __webpack_require__(875);
            var callRegExpExec = __webpack_require__(7787);
            var regexpExec = __webpack_require__(1165);
            var fails = __webpack_require__(4253);
            var $min = Math.min;
            var $push = [].push;
            var $SPLIT = 'split';
            var LENGTH = 'length';
            var LAST_INDEX = 'lastIndex';
            var MAX_UINT32 = 0xffffffff;

// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
            var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });

// @@split logic
            __webpack_require__(8082)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
                var internalSplit;
                if (
                    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
                    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
                    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
                    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
                    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
                    ''[$SPLIT](/.?/)[LENGTH]
                ) {
                    // based on es5-shim implementation, need to rework it
                    internalSplit = function (separator, limit) {
                        var string = String(this);
                        if (separator === undefined && limit === 0) return [];
                        // If `separator` is not a regex, use native split
                        if (!isRegExp(separator)) return $split.call(string, separator, limit);
                        var output = [];
                        var flags = (separator.ignoreCase ? 'i' : '') +
                            (separator.multiline ? 'm' : '') +
                            (separator.unicode ? 'u' : '') +
                            (separator.sticky ? 'y' : '');
                        var lastLastIndex = 0;
                        var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
                        // Make `global` and avoid `lastIndex` issues by working with a copy
                        var separatorCopy = new RegExp(separator.source, flags + 'g');
                        var match, lastIndex, lastLength;
                        while (match = regexpExec.call(separatorCopy, string)) {
                            lastIndex = separatorCopy[LAST_INDEX];
                            if (lastIndex > lastLastIndex) {
                                output.push(string.slice(lastLastIndex, match.index));
                                if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
                                lastLength = match[0][LENGTH];
                                lastLastIndex = lastIndex;
                                if (output[LENGTH] >= splitLimit) break;
                            }
                            if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
                        }
                        if (lastLastIndex === string[LENGTH]) {
                            if (lastLength || !separatorCopy.test('')) output.push('');
                        } else output.push(string.slice(lastLastIndex));
                        return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
                    };
                    // Chakra, V8
                } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
                    internalSplit = function (separator, limit) {
                        return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
                    };
                } else {
                    internalSplit = $split;
                }

                return [
                    // `String.prototype.split` method
                    // https://tc39.github.io/ecma262/#sec-string.prototype.split
                    function split(separator, limit) {
                        var O = defined(this);
                        var splitter = separator == undefined ? undefined : separator[SPLIT];
                        return splitter !== undefined
                            ? splitter.call(separator, O, limit)
                            : internalSplit.call(String(O), separator, limit);
                    },
                    // `RegExp.prototype[@@split]` method
                    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
                    //
                    // NOTE: This cannot be properly polyfilled in engines that don't support
                    // the 'y' flag.
                    function (regexp, limit) {
                        var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
                        if (res.done) return res.value;

                        var rx = anObject(regexp);
                        var S = String(this);
                        var C = speciesConstructor(rx, RegExp);

                        var unicodeMatching = rx.unicode;
                        var flags = (rx.ignoreCase ? 'i' : '') +
                            (rx.multiline ? 'm' : '') +
                            (rx.unicode ? 'u' : '') +
                            (SUPPORTS_Y ? 'y' : 'g');

                        // ^(? + rx + ) is needed, in combination with some S slicing, to
                        // simulate the 'y' flag.
                        var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
                        var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
                        if (lim === 0) return [];
                        if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
                        var p = 0;
                        var q = 0;
                        var A = [];
                        while (q < S.length) {
                            splitter.lastIndex = SUPPORTS_Y ? q : 0;
                            var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
                            var e;
                            if (
                                z === null ||
                                (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
                            ) {
                                q = advanceStringIndex(S, q, unicodeMatching);
                            } else {
                                A.push(S.slice(p, q));
                                if (A.length === lim) return A;
                                for (var i = 1; i <= z.length - 1; i++) {
                                    A.push(z[i]);
                                    if (A.length === lim) return A;
                                }
                                q = p = e;
                            }
                        }
                        A.push(S.slice(p));
                        return A;
                    }
                ];
            });


            /***/ }),

        /***/ 6108:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            __webpack_require__(6774);
            var anObject = __webpack_require__(7007);
            var $flags = __webpack_require__(3218);
            var DESCRIPTORS = __webpack_require__(7057);
            var TO_STRING = 'toString';
            var $toString = /./[TO_STRING];

            var define = function (fn) {
                __webpack_require__(7234)(RegExp.prototype, TO_STRING, fn, true);
            };

// 21.2.5.14 RegExp.prototype.toString()
            if (__webpack_require__(4253)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
                define(function toString() {
                    var R = anObject(this);
                    return '/'.concat(R.source, '/',
                        'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
                });
// FF44- RegExp#toString has a wrong name
            } else if ($toString.name != TO_STRING) {
                define(function toString() {
                    return $toString.call(this);
                });
            }


            /***/ }),

        /***/ 8184:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var strong = __webpack_require__(9824);
            var validate = __webpack_require__(1616);
            var SET = 'Set';

// 23.2 Set Objects
            module.exports = __webpack_require__(5795)(SET, function (get) {
                return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
            }, {
                // 23.2.3.1 Set.prototype.add(value)
                add: function add(value) {
                    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
                }
            }, strong);


            /***/ }),

        /***/ 856:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.2 String.prototype.anchor(name)
            __webpack_require__(9395)('anchor', function (createHTML) {
                return function anchor(name) {
                    return createHTML(this, 'a', 'name', name);
                };
            });


            /***/ }),

        /***/ 703:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.3 String.prototype.big()
            __webpack_require__(9395)('big', function (createHTML) {
                return function big() {
                    return createHTML(this, 'big', '', '');
                };
            });


            /***/ }),

        /***/ 1539:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.4 String.prototype.blink()
            __webpack_require__(9395)('blink', function (createHTML) {
                return function blink() {
                    return createHTML(this, 'blink', '', '');
                };
            });


            /***/ }),

        /***/ 5292:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.5 String.prototype.bold()
            __webpack_require__(9395)('bold', function (createHTML) {
                return function bold() {
                    return createHTML(this, 'b', '', '');
                };
            });


            /***/ }),

        /***/ 9539:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $at = __webpack_require__(4496)(false);
            $export($export.P, 'String', {
                // 21.1.3.3 String.prototype.codePointAt(pos)
                codePointAt: function codePointAt(pos) {
                    return $at(this, pos);
                }
            });


            /***/ }),

        /***/ 6620:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";
// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])

            var $export = __webpack_require__(2985);
            var toLength = __webpack_require__(875);
            var context = __webpack_require__(2094);
            var ENDS_WITH = 'endsWith';
            var $endsWith = ''[ENDS_WITH];

            $export($export.P + $export.F * __webpack_require__(8852)(ENDS_WITH), 'String', {
                endsWith: function endsWith(searchString /* , endPosition = @length */) {
                    var that = context(this, searchString, ENDS_WITH);
                    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
                    var len = toLength(that.length);
                    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
                    var search = String(searchString);
                    return $endsWith
                        ? $endsWith.call(that, search, end)
                        : that.slice(end - search.length, end) === search;
                }
            });


            /***/ }),

        /***/ 6629:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.6 String.prototype.fixed()
            __webpack_require__(9395)('fixed', function (createHTML) {
                return function fixed() {
                    return createHTML(this, 'tt', '', '');
                };
            });


            /***/ }),

        /***/ 3694:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.7 String.prototype.fontcolor(color)
            __webpack_require__(9395)('fontcolor', function (createHTML) {
                return function fontcolor(color) {
                    return createHTML(this, 'font', 'color', color);
                };
            });


            /***/ }),

        /***/ 7648:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.8 String.prototype.fontsize(size)
            __webpack_require__(9395)('fontsize', function (createHTML) {
                return function fontsize(size) {
                    return createHTML(this, 'font', 'size', size);
                };
            });


            /***/ }),

        /***/ 191:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
            var toAbsoluteIndex = __webpack_require__(2337);
            var fromCharCode = String.fromCharCode;
            var $fromCodePoint = String.fromCodePoint;

// length should be 1, old FF problem
            $export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
                // 21.1.2.2 String.fromCodePoint(...codePoints)
                fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
                    var res = [];
                    var aLen = arguments.length;
                    var i = 0;
                    var code;
                    while (aLen > i) {
                        code = +arguments[i++];
                        if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
                        res.push(code < 0x10000
                            ? fromCharCode(code)
                            : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
                        );
                    } return res.join('');
                }
            });


            /***/ }),

        /***/ 2850:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";
// 21.1.3.7 String.prototype.includes(searchString, position = 0)

            var $export = __webpack_require__(2985);
            var context = __webpack_require__(2094);
            var INCLUDES = 'includes';

            $export($export.P + $export.F * __webpack_require__(8852)(INCLUDES), 'String', {
                includes: function includes(searchString /* , position = 0 */) {
                    return !!~context(this, searchString, INCLUDES)
                        .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
                }
            });


            /***/ }),

        /***/ 7795:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.9 String.prototype.italics()
            __webpack_require__(9395)('italics', function (createHTML) {
                return function italics() {
                    return createHTML(this, 'i', '', '');
                };
            });


            /***/ }),

        /***/ 9115:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $at = __webpack_require__(4496)(true);

// 21.1.3.27 String.prototype[@@iterator]()
            __webpack_require__(2923)(String, 'String', function (iterated) {
                this._t = String(iterated); // target
                this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
            }, function () {
                var O = this._t;
                var index = this._i;
                var point;
                if (index >= O.length) return { value: undefined, done: true };
                point = $at(O, index);
                this._i += point.length;
                return { value: point, done: false };
            });


            /***/ }),

        /***/ 4531:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.10 String.prototype.link(url)
            __webpack_require__(9395)('link', function (createHTML) {
                return function link(url) {
                    return createHTML(this, 'a', 'href', url);
                };
            });


            /***/ }),

        /***/ 8306:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
            var toIObject = __webpack_require__(2110);
            var toLength = __webpack_require__(875);

            $export($export.S, 'String', {
                // 21.1.2.4 String.raw(callSite, ...substitutions)
                raw: function raw(callSite) {
                    var tpl = toIObject(callSite.raw);
                    var len = toLength(tpl.length);
                    var aLen = arguments.length;
                    var res = [];
                    var i = 0;
                    while (len > i) {
                        res.push(String(tpl[i++]));
                        if (i < aLen) res.push(String(arguments[i]));
                    } return res.join('');
                }
            });


            /***/ }),

        /***/ 823:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);

            $export($export.P, 'String', {
                // 21.1.3.13 String.prototype.repeat(count)
                repeat: __webpack_require__(8595)
            });


            /***/ }),

        /***/ 3605:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.11 String.prototype.small()
            __webpack_require__(9395)('small', function (createHTML) {
                return function small() {
                    return createHTML(this, 'small', '', '');
                };
            });


            /***/ }),

        /***/ 7732:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";
// 21.1.3.18 String.prototype.startsWith(searchString [, position ])

            var $export = __webpack_require__(2985);
            var toLength = __webpack_require__(875);
            var context = __webpack_require__(2094);
            var STARTS_WITH = 'startsWith';
            var $startsWith = ''[STARTS_WITH];

            $export($export.P + $export.F * __webpack_require__(8852)(STARTS_WITH), 'String', {
                startsWith: function startsWith(searchString /* , position = 0 */) {
                    var that = context(this, searchString, STARTS_WITH);
                    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
                    var search = String(searchString);
                    return $startsWith
                        ? $startsWith.call(that, search, index)
                        : that.slice(index, index + search.length) === search;
                }
            });


            /***/ }),

        /***/ 6780:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.12 String.prototype.strike()
            __webpack_require__(9395)('strike', function (createHTML) {
                return function strike() {
                    return createHTML(this, 'strike', '', '');
                };
            });


            /***/ }),

        /***/ 9937:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.13 String.prototype.sub()
            __webpack_require__(9395)('sub', function (createHTML) {
                return function sub() {
                    return createHTML(this, 'sub', '', '');
                };
            });


            /***/ }),

        /***/ 511:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// B.2.3.14 String.prototype.sup()
            __webpack_require__(9395)('sup', function (createHTML) {
                return function sup() {
                    return createHTML(this, 'sup', '', '');
                };
            });


            /***/ }),

        /***/ 4564:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// 21.1.3.25 String.prototype.trim()
            __webpack_require__(9599)('trim', function ($trim) {
                return function trim() {
                    return $trim(this, 3);
                };
            });


            /***/ }),

        /***/ 5767:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// ECMAScript 6 symbols shim
            var global = __webpack_require__(3816);
            var has = __webpack_require__(9181);
            var DESCRIPTORS = __webpack_require__(7057);
            var $export = __webpack_require__(2985);
            var redefine = __webpack_require__(7234);
            var META = (__webpack_require__(4728).KEY);
            var $fails = __webpack_require__(4253);
            var shared = __webpack_require__(3825);
            var setToStringTag = __webpack_require__(2943);
            var uid = __webpack_require__(3953);
            var wks = __webpack_require__(6314);
            var wksExt = __webpack_require__(8787);
            var wksDefine = __webpack_require__(6074);
            var enumKeys = __webpack_require__(5541);
            var isArray = __webpack_require__(4302);
            var anObject = __webpack_require__(7007);
            var isObject = __webpack_require__(5286);
            var toObject = __webpack_require__(508);
            var toIObject = __webpack_require__(2110);
            var toPrimitive = __webpack_require__(1689);
            var createDesc = __webpack_require__(681);
            var _create = __webpack_require__(2503);
            var gOPNExt = __webpack_require__(9327);
            var $GOPD = __webpack_require__(8693);
            var $GOPS = __webpack_require__(4548);
            var $DP = __webpack_require__(9275);
            var $keys = __webpack_require__(7184);
            var gOPD = $GOPD.f;
            var dP = $DP.f;
            var gOPN = gOPNExt.f;
            var $Symbol = global.Symbol;
            var $JSON = global.JSON;
            var _stringify = $JSON && $JSON.stringify;
            var PROTOTYPE = 'prototype';
            var HIDDEN = wks('_hidden');
            var TO_PRIMITIVE = wks('toPrimitive');
            var isEnum = {}.propertyIsEnumerable;
            var SymbolRegistry = shared('symbol-registry');
            var AllSymbols = shared('symbols');
            var OPSymbols = shared('op-symbols');
            var ObjectProto = Object[PROTOTYPE];
            var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
            var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
            var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
            var setSymbolDesc = DESCRIPTORS && $fails(function () {
                return _create(dP({}, 'a', {
                    get: function () { return dP(this, 'a', { value: 7 }).a; }
                })).a != 7;
            }) ? function (it, key, D) {
                var protoDesc = gOPD(ObjectProto, key);
                if (protoDesc) delete ObjectProto[key];
                dP(it, key, D);
                if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
            } : dP;

            var wrap = function (tag) {
                var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
                sym._k = tag;
                return sym;
            };

            var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
                return typeof it == 'symbol';
            } : function (it) {
                return it instanceof $Symbol;
            };

            var $defineProperty = function defineProperty(it, key, D) {
                if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
                anObject(it);
                key = toPrimitive(key, true);
                anObject(D);
                if (has(AllSymbols, key)) {
                    if (!D.enumerable) {
                        if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
                        it[HIDDEN][key] = true;
                    } else {
                        if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
                        D = _create(D, { enumerable: createDesc(0, false) });
                    } return setSymbolDesc(it, key, D);
                } return dP(it, key, D);
            };
            var $defineProperties = function defineProperties(it, P) {
                anObject(it);
                var keys = enumKeys(P = toIObject(P));
                var i = 0;
                var l = keys.length;
                var key;
                while (l > i) $defineProperty(it, key = keys[i++], P[key]);
                return it;
            };
            var $create = function create(it, P) {
                return P === undefined ? _create(it) : $defineProperties(_create(it), P);
            };
            var $propertyIsEnumerable = function propertyIsEnumerable(key) {
                var E = isEnum.call(this, key = toPrimitive(key, true));
                if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
                return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
            };
            var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
                it = toIObject(it);
                key = toPrimitive(key, true);
                if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
                var D = gOPD(it, key);
                if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
                return D;
            };
            var $getOwnPropertyNames = function getOwnPropertyNames(it) {
                var names = gOPN(toIObject(it));
                var result = [];
                var i = 0;
                var key;
                while (names.length > i) {
                    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
                } return result;
            };
            var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
                var IS_OP = it === ObjectProto;
                var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
                var result = [];
                var i = 0;
                var key;
                while (names.length > i) {
                    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
                } return result;
            };

// 19.4.1.1 Symbol([description])
            if (!USE_NATIVE) {
                $Symbol = function Symbol() {
                    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
                    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
                    var $set = function (value) {
                        if (this === ObjectProto) $set.call(OPSymbols, value);
                        if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
                        setSymbolDesc(this, tag, createDesc(1, value));
                    };
                    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
                    return wrap(tag);
                };
                redefine($Symbol[PROTOTYPE], 'toString', function toString() {
                    return this._k;
                });

                $GOPD.f = $getOwnPropertyDescriptor;
                $DP.f = $defineProperty;
                (__webpack_require__(616).f) = gOPNExt.f = $getOwnPropertyNames;
                (__webpack_require__(4682).f) = $propertyIsEnumerable;
                $GOPS.f = $getOwnPropertySymbols;

                if (DESCRIPTORS && !__webpack_require__(4461)) {
                    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
                }

                wksExt.f = function (name) {
                    return wrap(wks(name));
                };
            }

            $export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

            for (var es6Symbols = (
                // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
                'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
            ).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

            for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

            $export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
                // 19.4.2.1 Symbol.for(key)
                'for': function (key) {
                    return has(SymbolRegistry, key += '')
                        ? SymbolRegistry[key]
                        : SymbolRegistry[key] = $Symbol(key);
                },
                // 19.4.2.5 Symbol.keyFor(sym)
                keyFor: function keyFor(sym) {
                    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
                    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
                },
                useSetter: function () { setter = true; },
                useSimple: function () { setter = false; }
            });

            $export($export.S + $export.F * !USE_NATIVE, 'Object', {
                // 19.1.2.2 Object.create(O [, Properties])
                create: $create,
                // 19.1.2.4 Object.defineProperty(O, P, Attributes)
                defineProperty: $defineProperty,
                // 19.1.2.3 Object.defineProperties(O, Properties)
                defineProperties: $defineProperties,
                // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
                getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
                // 19.1.2.7 Object.getOwnPropertyNames(O)
                getOwnPropertyNames: $getOwnPropertyNames,
                // 19.1.2.8 Object.getOwnPropertySymbols(O)
                getOwnPropertySymbols: $getOwnPropertySymbols
            });

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
            var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

            $export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
                getOwnPropertySymbols: function getOwnPropertySymbols(it) {
                    return $GOPS.f(toObject(it));
                }
            });

// 24.3.2 JSON.stringify(value [, replacer [, space]])
            $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
                var S = $Symbol();
                // MS Edge converts symbol values to JSON as {}
                // WebKit converts symbol values to JSON as null
                // V8 throws on boxed symbols
                return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
            })), 'JSON', {
                stringify: function stringify(it) {
                    var args = [it];
                    var i = 1;
                    var replacer, $replacer;
                    while (arguments.length > i) args.push(arguments[i++]);
                    $replacer = replacer = args[1];
                    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
                    if (!isArray(replacer)) replacer = function (key, value) {
                        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
                        if (!isSymbol(value)) return value;
                    };
                    args[1] = replacer;
                    return _stringify.apply($JSON, args);
                }
            });

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
            $Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(7728)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
            setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
            setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
            setToStringTag(global.JSON, 'JSON', true);


            /***/ }),

        /***/ 142:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var $export = __webpack_require__(2985);
            var $typed = __webpack_require__(9383);
            var buffer = __webpack_require__(1125);
            var anObject = __webpack_require__(7007);
            var toAbsoluteIndex = __webpack_require__(2337);
            var toLength = __webpack_require__(875);
            var isObject = __webpack_require__(5286);
            var ArrayBuffer = (__webpack_require__(3816).ArrayBuffer);
            var speciesConstructor = __webpack_require__(8364);
            var $ArrayBuffer = buffer.ArrayBuffer;
            var $DataView = buffer.DataView;
            var $isView = $typed.ABV && ArrayBuffer.isView;
            var $slice = $ArrayBuffer.prototype.slice;
            var VIEW = $typed.VIEW;
            var ARRAY_BUFFER = 'ArrayBuffer';

            $export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });

            $export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
                // 24.1.3.1 ArrayBuffer.isView(arg)
                isView: function isView(it) {
                    return $isView && $isView(it) || isObject(it) && VIEW in it;
                }
            });

            $export($export.P + $export.U + $export.F * __webpack_require__(4253)(function () {
                return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
            }), ARRAY_BUFFER, {
                // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
                slice: function slice(start, end) {
                    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
                    var len = anObject(this).byteLength;
                    var first = toAbsoluteIndex(start, len);
                    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
                    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
                    var viewS = new $DataView(this);
                    var viewT = new $DataView(result);
                    var index = 0;
                    while (first < fin) {
                        viewT.setUint8(index++, viewS.getUint8(first++));
                    } return result;
                }
            });

            __webpack_require__(2974)(ARRAY_BUFFER);


            /***/ }),

        /***/ 1786:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
            $export($export.G + $export.W + $export.F * !(__webpack_require__(9383).ABV), {
                DataView: (__webpack_require__(1125).DataView)
            });


            /***/ }),

        /***/ 162:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(8440)('Float32', 4, function (init) {
                return function Float32Array(data, byteOffset, length) {
                    return init(this, data, byteOffset, length);
                };
            });


            /***/ }),

        /***/ 3834:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(8440)('Float64', 8, function (init) {
                return function Float64Array(data, byteOffset, length) {
                    return init(this, data, byteOffset, length);
                };
            });


            /***/ }),

        /***/ 4821:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(8440)('Int16', 2, function (init) {
                return function Int16Array(data, byteOffset, length) {
                    return init(this, data, byteOffset, length);
                };
            });


            /***/ }),

        /***/ 1303:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(8440)('Int32', 4, function (init) {
                return function Int32Array(data, byteOffset, length) {
                    return init(this, data, byteOffset, length);
                };
            });


            /***/ }),

        /***/ 5368:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(8440)('Int8', 1, function (init) {
                return function Int8Array(data, byteOffset, length) {
                    return init(this, data, byteOffset, length);
                };
            });


            /***/ }),

        /***/ 9103:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(8440)('Uint16', 2, function (init) {
                return function Uint16Array(data, byteOffset, length) {
                    return init(this, data, byteOffset, length);
                };
            });


            /***/ }),

        /***/ 3318:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(8440)('Uint32', 4, function (init) {
                return function Uint32Array(data, byteOffset, length) {
                    return init(this, data, byteOffset, length);
                };
            });


            /***/ }),

        /***/ 6964:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(8440)('Uint8', 1, function (init) {
                return function Uint8Array(data, byteOffset, length) {
                    return init(this, data, byteOffset, length);
                };
            });


            /***/ }),

        /***/ 2152:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(8440)('Uint8', 1, function (init) {
                return function Uint8ClampedArray(data, byteOffset, length) {
                    return init(this, data, byteOffset, length);
                };
            }, true);


            /***/ }),

        /***/ 147:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var global = __webpack_require__(3816);
            var each = __webpack_require__(50)(0);
            var redefine = __webpack_require__(7234);
            var meta = __webpack_require__(4728);
            var assign = __webpack_require__(5345);
            var weak = __webpack_require__(3657);
            var isObject = __webpack_require__(5286);
            var validate = __webpack_require__(1616);
            var NATIVE_WEAK_MAP = __webpack_require__(1616);
            var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
            var WEAK_MAP = 'WeakMap';
            var getWeak = meta.getWeak;
            var isExtensible = Object.isExtensible;
            var uncaughtFrozenStore = weak.ufstore;
            var InternalMap;

            var wrapper = function (get) {
                return function WeakMap() {
                    return get(this, arguments.length > 0 ? arguments[0] : undefined);
                };
            };

            var methods = {
                // 23.3.3.3 WeakMap.prototype.get(key)
                get: function get(key) {
                    if (isObject(key)) {
                        var data = getWeak(key);
                        if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
                        return data ? data[this._i] : undefined;
                    }
                },
                // 23.3.3.5 WeakMap.prototype.set(key, value)
                set: function set(key, value) {
                    return weak.def(validate(this, WEAK_MAP), key, value);
                }
            };

// 23.3 WeakMap Objects
            var $WeakMap = module.exports = __webpack_require__(5795)(WEAK_MAP, wrapper, methods, weak, true, true);

// IE11 WeakMap frozen keys fix
            if (NATIVE_WEAK_MAP && IS_IE11) {
                InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
                assign(InternalMap.prototype, methods);
                meta.NEED = true;
                each(['delete', 'has', 'get', 'set'], function (key) {
                    var proto = $WeakMap.prototype;
                    var method = proto[key];
                    redefine(proto, key, function (a, b) {
                        // store frozen objects on internal weakmap shim
                        if (isObject(a) && !isExtensible(a)) {
                            if (!this._f) this._f = new InternalMap();
                            var result = this._f[key](a, b);
                            return key == 'set' ? this : result;
                            // store all the rest on native weakmap
                        } return method.call(this, a, b);
                    });
                });
            }


            /***/ }),

        /***/ 9192:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

            var weak = __webpack_require__(3657);
            var validate = __webpack_require__(1616);
            var WEAK_SET = 'WeakSet';

// 23.4 WeakSet Objects
            __webpack_require__(5795)(WEAK_SET, function (get) {
                return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
            }, {
                // 23.4.3.1 WeakSet.prototype.add(value)
                add: function add(value) {
                    return weak.def(validate(this, WEAK_SET), value, true);
                }
            }, weak, false, true);


            /***/ }),

        /***/ 1268:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
            var $export = __webpack_require__(2985);
            var flattenIntoArray = __webpack_require__(3325);
            var toObject = __webpack_require__(508);
            var toLength = __webpack_require__(875);
            var aFunction = __webpack_require__(4963);
            var arraySpeciesCreate = __webpack_require__(6886);

            $export($export.P, 'Array', {
                flatMap: function flatMap(callbackfn /* , thisArg */) {
                    var O = toObject(this);
                    var sourceLen, A;
                    aFunction(callbackfn);
                    sourceLen = toLength(O.length);
                    A = arraySpeciesCreate(O, 0);
                    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
                    return A;
                }
            });

            __webpack_require__(7722)('flatMap');


            /***/ }),

        /***/ 2773:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// https://github.com/tc39/Array.prototype.includes
            var $export = __webpack_require__(2985);
            var $includes = __webpack_require__(9315)(true);

            $export($export.P, 'Array', {
                includes: function includes(el /* , fromIndex = 0 */) {
                    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
                }
            });

            __webpack_require__(7722)('includes');


            /***/ }),

        /***/ 3276:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// https://github.com/tc39/proposal-object-values-entries
            var $export = __webpack_require__(2985);
            var $entries = __webpack_require__(1131)(true);

            $export($export.S, 'Object', {
                entries: function entries(it) {
                    return $entries(it);
                }
            });


            /***/ }),

        /***/ 8351:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// https://github.com/tc39/proposal-object-getownpropertydescriptors
            var $export = __webpack_require__(2985);
            var ownKeys = __webpack_require__(7643);
            var toIObject = __webpack_require__(2110);
            var gOPD = __webpack_require__(8693);
            var createProperty = __webpack_require__(2811);

            $export($export.S, 'Object', {
                getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
                    var O = toIObject(object);
                    var getDesc = gOPD.f;
                    var keys = ownKeys(O);
                    var result = {};
                    var i = 0;
                    var key, desc;
                    while (keys.length > i) {
                        desc = getDesc(O, key = keys[i++]);
                        if (desc !== undefined) createProperty(result, key, desc);
                    }
                    return result;
                }
            });


            /***/ }),

        /***/ 6409:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// https://github.com/tc39/proposal-object-values-entries
            var $export = __webpack_require__(2985);
            var $values = __webpack_require__(1131)(false);

            $export($export.S, 'Object', {
                values: function values(it) {
                    return $values(it);
                }
            });


            /***/ }),

        /***/ 9865:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";
// https://github.com/tc39/proposal-promise-finally

            var $export = __webpack_require__(2985);
            var core = __webpack_require__(5645);
            var global = __webpack_require__(3816);
            var speciesConstructor = __webpack_require__(8364);
            var promiseResolve = __webpack_require__(94);

            $export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
                    var C = speciesConstructor(this, core.Promise || global.Promise);
                    var isFunction = typeof onFinally == 'function';
                    return this.then(
                        isFunction ? function (x) {
                            return promiseResolve(C, onFinally()).then(function () { return x; });
                        } : onFinally,
                        isFunction ? function (e) {
                            return promiseResolve(C, onFinally()).then(function () { throw e; });
                        } : onFinally
                    );
                } });


            /***/ }),

        /***/ 2770:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// https://github.com/tc39/proposal-string-pad-start-end
            var $export = __webpack_require__(2985);
            var $pad = __webpack_require__(5442);
            var userAgent = __webpack_require__(575);

// https://github.com/zloirock/core-js/issues/280
            var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

            $export($export.P + $export.F * WEBKIT_BUG, 'String', {
                padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
                    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
                }
            });


            /***/ }),

        /***/ 1784:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// https://github.com/tc39/proposal-string-pad-start-end
            var $export = __webpack_require__(2985);
            var $pad = __webpack_require__(5442);
            var userAgent = __webpack_require__(575);

// https://github.com/zloirock/core-js/issues/280
            var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);

            $export($export.P + $export.F * WEBKIT_BUG, 'String', {
                padStart: function padStart(maxLength /* , fillString = ' ' */) {
                    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
                }
            });


            /***/ }),

        /***/ 5869:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
            __webpack_require__(9599)('trimLeft', function ($trim) {
                return function trimLeft() {
                    return $trim(this, 1);
                };
            }, 'trimStart');


            /***/ }),

        /***/ 4325:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            "use strict";

// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
            __webpack_require__(9599)('trimRight', function ($trim) {
                return function trimRight() {
                    return $trim(this, 2);
                };
            }, 'trimEnd');


            /***/ }),

        /***/ 9665:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(6074)('asyncIterator');


            /***/ }),

        /***/ 1181:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $iterators = __webpack_require__(6997);
            var getKeys = __webpack_require__(7184);
            var redefine = __webpack_require__(7234);
            var global = __webpack_require__(3816);
            var hide = __webpack_require__(7728);
            var Iterators = __webpack_require__(2803);
            var wks = __webpack_require__(6314);
            var ITERATOR = wks('iterator');
            var TO_STRING_TAG = wks('toStringTag');
            var ArrayValues = Iterators.Array;

            var DOMIterables = {
                CSSRuleList: true, // TODO: Not spec compliant, should be false.
                CSSStyleDeclaration: false,
                CSSValueList: false,
                ClientRectList: false,
                DOMRectList: false,
                DOMStringList: false,
                DOMTokenList: true,
                DataTransferItemList: false,
                FileList: false,
                HTMLAllCollection: false,
                HTMLCollection: false,
                HTMLFormElement: false,
                HTMLSelectElement: false,
                MediaList: true, // TODO: Not spec compliant, should be false.
                MimeTypeArray: false,
                NamedNodeMap: false,
                NodeList: true,
                PaintRequestList: false,
                Plugin: false,
                PluginArray: false,
                SVGLengthList: false,
                SVGNumberList: false,
                SVGPathSegList: false,
                SVGPointList: false,
                SVGStringList: false,
                SVGTransformList: false,
                SourceBufferList: false,
                StyleSheetList: true, // TODO: Not spec compliant, should be false.
                TextTrackCueList: false,
                TextTrackList: false,
                TouchList: false
            };

            for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
                var NAME = collections[i];
                var explicit = DOMIterables[NAME];
                var Collection = global[NAME];
                var proto = Collection && Collection.prototype;
                var key;
                if (proto) {
                    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
                    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
                    Iterators[NAME] = ArrayValues;
                    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
                }
            }


            /***/ }),

        /***/ 4633:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

            var $export = __webpack_require__(2985);
            var $task = __webpack_require__(4193);
            $export($export.G + $export.B, {
                setImmediate: $task.set,
                clearImmediate: $task.clear
            });


            /***/ }),

        /***/ 2564:
        /***/ ((__unused_webpack_module, __unused_webpack_exports, __webpack_require__) => {

// ie9- setTimeout & setInterval additional parameters fix
            var global = __webpack_require__(3816);
            var $export = __webpack_require__(2985);
            var userAgent = __webpack_require__(575);
            var slice = [].slice;
            var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
            var wrap = function (set) {
                return function (fn, time /* , ...args */) {
                    var boundArgs = arguments.length > 2;
                    var args = boundArgs ? slice.call(arguments, 2) : false;
                    return set(boundArgs ? function () {
                        // eslint-disable-next-line no-new-func
                        (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
                    } : fn, time);
                };
            };
            $export($export.G + $export.B + $export.F * MSIE, {
                setTimeout: wrap(global.setTimeout),
                setInterval: wrap(global.setInterval)
            });


            /***/ }),

        /***/ 6337:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            __webpack_require__(2564);
            __webpack_require__(4633);
            __webpack_require__(1181);
            module.exports = __webpack_require__(5645);


            /***/ }),

        /***/ 9755:
        /***/ (function(module, exports) {

            var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.6.0
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2021-03-02T17:08Z
 */
            ( function( global, factory ) {

                "use strict";

                if (  true && typeof module.exports === "object" ) {

                    // For CommonJS and CommonJS-like environments where a proper `window`
                    // is present, execute the factory and get jQuery.
                    // For environments that do not have a `window` with a `document`
                    // (such as Node.js), expose a factory as module.exports.
                    // This accentuates the need for the creation of a real `window`.
                    // e.g. var jQuery = require("jquery")(window);
                    // See ticket #14549 for more info.
                    module.exports = global.document ?
                        factory( global, true ) :
                        function( w ) {
                            if ( !w.document ) {
                                throw new Error( "jQuery requires a window with a document" );
                            }
                            return factory( w );
                        };
                } else {
                    factory( global );
                }

// Pass this if window is not defined yet
            } )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
                "use strict";

                var arr = [];

                var getProto = Object.getPrototypeOf;

                var slice = arr.slice;

                var flat = arr.flat ? function( array ) {
                    return arr.flat.call( array );
                } : function( array ) {
                    return arr.concat.apply( [], array );
                };


                var push = arr.push;

                var indexOf = arr.indexOf;

                var class2type = {};

                var toString = class2type.toString;

                var hasOwn = class2type.hasOwnProperty;

                var fnToString = hasOwn.toString;

                var ObjectFunctionString = fnToString.call( Object );

                var support = {};

                var isFunction = function isFunction( obj ) {

                    // Support: Chrome <=57, Firefox <=52
                    // In some browsers, typeof returns "function" for HTML <object> elements
                    // (i.e., `typeof document.createElement( "object" ) === "function"`).
                    // We don't want to classify *any* DOM node as a function.
                    // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
                    // Plus for old WebKit, typeof returns "function" for HTML collections
                    // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
                    return typeof obj === "function" && typeof obj.nodeType !== "number" &&
                        typeof obj.item !== "function";
                };


                var isWindow = function isWindow( obj ) {
                    return obj != null && obj === obj.window;
                };


                var document = window.document;



                var preservedScriptAttributes = {
                    type: true,
                    src: true,
                    nonce: true,
                    noModule: true
                };

                function DOMEval( code, node, doc ) {
                    doc = doc || document;

                    var i, val,
                        script = doc.createElement( "script" );

                    script.text = code;
                    if ( node ) {
                        for ( i in preservedScriptAttributes ) {

                            // Support: Firefox 64+, Edge 18+
                            // Some browsers don't support the "nonce" property on scripts.
                            // On the other hand, just using `getAttribute` is not enough as
                            // the `nonce` attribute is reset to an empty string whenever it
                            // becomes browsing-context connected.
                            // See https://github.com/whatwg/html/issues/2369
                            // See https://html.spec.whatwg.org/#nonce-attributes
                            // The `node.getAttribute` check was added for the sake of
                            // `jQuery.globalEval` so that it can fake a nonce-containing node
                            // via an object.
                            val = node[ i ] || node.getAttribute && node.getAttribute( i );
                            if ( val ) {
                                script.setAttribute( i, val );
                            }
                        }
                    }
                    doc.head.appendChild( script ).parentNode.removeChild( script );
                }


                function toType( obj ) {
                    if ( obj == null ) {
                        return obj + "";
                    }

                    // Support: Android <=2.3 only (functionish RegExp)
                    return typeof obj === "object" || typeof obj === "function" ?
                        class2type[ toString.call( obj ) ] || "object" :
                        typeof obj;
                }
                /* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



                var
                    version = "3.6.0",

                    // Define a local copy of jQuery
                    jQuery = function( selector, context ) {

                        // The jQuery object is actually just the init constructor 'enhanced'
                        // Need init if jQuery is called (just allow error to be thrown if not included)
                        return new jQuery.fn.init( selector, context );
                    };

                jQuery.fn = jQuery.prototype = {

                    // The current version of jQuery being used
                    jquery: version,

                    constructor: jQuery,

                    // The default length of a jQuery object is 0
                    length: 0,

                    toArray: function() {
                        return slice.call( this );
                    },

                    // Get the Nth element in the matched element set OR
                    // Get the whole matched element set as a clean array
                    get: function( num ) {

                        // Return all the elements in a clean array
                        if ( num == null ) {
                            return slice.call( this );
                        }

                        // Return just the one element from the set
                        return num < 0 ? this[ num + this.length ] : this[ num ];
                    },

                    // Take an array of elements and push it onto the stack
                    // (returning the new matched element set)
                    pushStack: function( elems ) {

                        // Build a new jQuery matched element set
                        var ret = jQuery.merge( this.constructor(), elems );

                        // Add the old object onto the stack (as a reference)
                        ret.prevObject = this;

                        // Return the newly-formed element set
                        return ret;
                    },

                    // Execute a callback for every element in the matched set.
                    each: function( callback ) {
                        return jQuery.each( this, callback );
                    },

                    map: function( callback ) {
                        return this.pushStack( jQuery.map( this, function( elem, i ) {
                            return callback.call( elem, i, elem );
                        } ) );
                    },

                    slice: function() {
                        return this.pushStack( slice.apply( this, arguments ) );
                    },

                    first: function() {
                        return this.eq( 0 );
                    },

                    last: function() {
                        return this.eq( -1 );
                    },

                    even: function() {
                        return this.pushStack( jQuery.grep( this, function( _elem, i ) {
                            return ( i + 1 ) % 2;
                        } ) );
                    },

                    odd: function() {
                        return this.pushStack( jQuery.grep( this, function( _elem, i ) {
                            return i % 2;
                        } ) );
                    },

                    eq: function( i ) {
                        var len = this.length,
                            j = +i + ( i < 0 ? len : 0 );
                        return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
                    },

                    end: function() {
                        return this.prevObject || this.constructor();
                    },

                    // For internal use only.
                    // Behaves like an Array's method, not like a jQuery method.
                    push: push,
                    sort: arr.sort,
                    splice: arr.splice
                };

                jQuery.extend = jQuery.fn.extend = function() {
                    var options, name, src, copy, copyIsArray, clone,
                        target = arguments[ 0 ] || {},
                        i = 1,
                        length = arguments.length,
                        deep = false;

                    // Handle a deep copy situation
                    if ( typeof target === "boolean" ) {
                        deep = target;

                        // Skip the boolean and the target
                        target = arguments[ i ] || {};
                        i++;
                    }

                    // Handle case when target is a string or something (possible in deep copy)
                    if ( typeof target !== "object" && !isFunction( target ) ) {
                        target = {};
                    }

                    // Extend jQuery itself if only one argument is passed
                    if ( i === length ) {
                        target = this;
                        i--;
                    }

                    for ( ; i < length; i++ ) {

                        // Only deal with non-null/undefined values
                        if ( ( options = arguments[ i ] ) != null ) {

                            // Extend the base object
                            for ( name in options ) {
                                copy = options[ name ];

                                // Prevent Object.prototype pollution
                                // Prevent never-ending loop
                                if ( name === "__proto__" || target === copy ) {
                                    continue;
                                }

                                // Recurse if we're merging plain objects or arrays
                                if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
                                    ( copyIsArray = Array.isArray( copy ) ) ) ) {
                                    src = target[ name ];

                                    // Ensure proper type for the source value
                                    if ( copyIsArray && !Array.isArray( src ) ) {
                                        clone = [];
                                    } else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
                                        clone = {};
                                    } else {
                                        clone = src;
                                    }
                                    copyIsArray = false;

                                    // Never move original objects, clone them
                                    target[ name ] = jQuery.extend( deep, clone, copy );

                                    // Don't bring in undefined values
                                } else if ( copy !== undefined ) {
                                    target[ name ] = copy;
                                }
                            }
                        }
                    }

                    // Return the modified object
                    return target;
                };

                jQuery.extend( {

                    // Unique for each copy of jQuery on the page
                    expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

                    // Assume jQuery is ready without the ready module
                    isReady: true,

                    error: function( msg ) {
                        throw new Error( msg );
                    },

                    noop: function() {},

                    isPlainObject: function( obj ) {
                        var proto, Ctor;

                        // Detect obvious negatives
                        // Use toString instead of jQuery.type to catch host objects
                        if ( !obj || toString.call( obj ) !== "[object Object]" ) {
                            return false;
                        }

                        proto = getProto( obj );

                        // Objects with no prototype (e.g., `Object.create( null )`) are plain
                        if ( !proto ) {
                            return true;
                        }

                        // Objects with prototype are plain iff they were constructed by a global Object function
                        Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
                        return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
                    },

                    isEmptyObject: function( obj ) {
                        var name;

                        for ( name in obj ) {
                            return false;
                        }
                        return true;
                    },

                    // Evaluates a script in a provided context; falls back to the global one
                    // if not specified.
                    globalEval: function( code, options, doc ) {
                        DOMEval( code, { nonce: options && options.nonce }, doc );
                    },

                    each: function( obj, callback ) {
                        var length, i = 0;

                        if ( isArrayLike( obj ) ) {
                            length = obj.length;
                            for ( ; i < length; i++ ) {
                                if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                                    break;
                                }
                            }
                        } else {
                            for ( i in obj ) {
                                if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
                                    break;
                                }
                            }
                        }

                        return obj;
                    },

                    // results is for internal usage only
                    makeArray: function( arr, results ) {
                        var ret = results || [];

                        if ( arr != null ) {
                            if ( isArrayLike( Object( arr ) ) ) {
                                jQuery.merge( ret,
                                    typeof arr === "string" ?
                                        [ arr ] : arr
                                );
                            } else {
                                push.call( ret, arr );
                            }
                        }

                        return ret;
                    },

                    inArray: function( elem, arr, i ) {
                        return arr == null ? -1 : indexOf.call( arr, elem, i );
                    },

                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    merge: function( first, second ) {
                        var len = +second.length,
                            j = 0,
                            i = first.length;

                        for ( ; j < len; j++ ) {
                            first[ i++ ] = second[ j ];
                        }

                        first.length = i;

                        return first;
                    },

                    grep: function( elems, callback, invert ) {
                        var callbackInverse,
                            matches = [],
                            i = 0,
                            length = elems.length,
                            callbackExpect = !invert;

                        // Go through the array, only saving the items
                        // that pass the validator function
                        for ( ; i < length; i++ ) {
                            callbackInverse = !callback( elems[ i ], i );
                            if ( callbackInverse !== callbackExpect ) {
                                matches.push( elems[ i ] );
                            }
                        }

                        return matches;
                    },

                    // arg is for internal usage only
                    map: function( elems, callback, arg ) {
                        var length, value,
                            i = 0,
                            ret = [];

                        // Go through the array, translating each of the items to their new values
                        if ( isArrayLike( elems ) ) {
                            length = elems.length;
                            for ( ; i < length; i++ ) {
                                value = callback( elems[ i ], i, arg );

                                if ( value != null ) {
                                    ret.push( value );
                                }
                            }

                            // Go through every key on the object,
                        } else {
                            for ( i in elems ) {
                                value = callback( elems[ i ], i, arg );

                                if ( value != null ) {
                                    ret.push( value );
                                }
                            }
                        }

                        // Flatten any nested arrays
                        return flat( ret );
                    },

                    // A global GUID counter for objects
                    guid: 1,

                    // jQuery.support is not used in Core but other projects attach their
                    // properties to it so it needs to exist.
                    support: support
                } );

                if ( typeof Symbol === "function" ) {
                    jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
                }

// Populate the class2type map
                jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
                    function( _i, name ) {
                        class2type[ "[object " + name + "]" ] = name.toLowerCase();
                    } );

                function isArrayLike( obj ) {

                    // Support: real iOS 8.2 only (not reproducible in simulator)
                    // `in` check used to prevent JIT error (gh-2145)
                    // hasOwn isn't used here due to false negatives
                    // regarding Nodelist length in IE
                    var length = !!obj && "length" in obj && obj.length,
                        type = toType( obj );

                    if ( isFunction( obj ) || isWindow( obj ) ) {
                        return false;
                    }

                    return type === "array" || length === 0 ||
                        typeof length === "number" && length > 0 && ( length - 1 ) in obj;
                }
                var Sizzle =
                    /*!
 * Sizzle CSS Selector Engine v2.3.6
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://js.foundation/
 *
 * Date: 2021-02-16
 */
                    ( function( window ) {
                        var i,
                            support,
                            Expr,
                            getText,
                            isXML,
                            tokenize,
                            compile,
                            select,
                            outermostContext,
                            sortInput,
                            hasDuplicate,

                            // Local document vars
                            setDocument,
                            document,
                            docElem,
                            documentIsHTML,
                            rbuggyQSA,
                            rbuggyMatches,
                            matches,
                            contains,

                            // Instance-specific data
                            expando = "sizzle" + 1 * new Date(),
                            preferredDoc = window.document,
                            dirruns = 0,
                            done = 0,
                            classCache = createCache(),
                            tokenCache = createCache(),
                            compilerCache = createCache(),
                            nonnativeSelectorCache = createCache(),
                            sortOrder = function( a, b ) {
                                if ( a === b ) {
                                    hasDuplicate = true;
                                }
                                return 0;
                            },

                            // Instance methods
                            hasOwn = ( {} ).hasOwnProperty,
                            arr = [],
                            pop = arr.pop,
                            pushNative = arr.push,
                            push = arr.push,
                            slice = arr.slice,

                            // Use a stripped-down indexOf as it's faster than native
                            // https://jsperf.com/thor-indexof-vs-for/5
                            indexOf = function( list, elem ) {
                                var i = 0,
                                    len = list.length;
                                for ( ; i < len; i++ ) {
                                    if ( list[ i ] === elem ) {
                                        return i;
                                    }
                                }
                                return -1;
                            },

                            booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|" +
                                "ismap|loop|multiple|open|readonly|required|scoped",

                            // Regular expressions

                            // http://www.w3.org/TR/css3-selectors/#whitespace
                            whitespace = "[\\x20\\t\\r\\n\\f]",

                            // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
                            identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
                                "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

                            // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
                            attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

                                // Operator (capture 2)
                                "*([*^$|!~]?=)" + whitespace +

                                // "Attribute values must be CSS identifiers [capture 5]
                                // or strings [capture 3 or capture 4]"
                                "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
                                whitespace + "*\\]",

                            pseudos = ":(" + identifier + ")(?:\\((" +

                                // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
                                // 1. quoted (capture 3; capture 4 or capture 5)
                                "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

                                // 2. simple (capture 6)
                                "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

                                // 3. anything else (capture 2)
                                ".*" +
                                ")\\)|)",

                            // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
                            rwhitespace = new RegExp( whitespace + "+", "g" ),
                            rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" +
                                whitespace + "+$", "g" ),

                            rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
                            rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace +
                                "*" ),
                            rdescend = new RegExp( whitespace + "|>" ),

                            rpseudo = new RegExp( pseudos ),
                            ridentifier = new RegExp( "^" + identifier + "$" ),

                            matchExpr = {
                                "ID": new RegExp( "^#(" + identifier + ")" ),
                                "CLASS": new RegExp( "^\\.(" + identifier + ")" ),
                                "TAG": new RegExp( "^(" + identifier + "|[*])" ),
                                "ATTR": new RegExp( "^" + attributes ),
                                "PSEUDO": new RegExp( "^" + pseudos ),
                                "CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
                                    whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
                                    whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
                                "bool": new RegExp( "^(?:" + booleans + ")$", "i" ),

                                // For use in libraries implementing .is()
                                // We use this for POS matching in `select`
                                "needsContext": new RegExp( "^" + whitespace +
                                    "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
                                    "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
                            },

                            rhtml = /HTML$/i,
                            rinputs = /^(?:input|select|textarea|button)$/i,
                            rheader = /^h\d$/i,

                            rnative = /^[^{]+\{\s*\[native \w/,

                            // Easily-parseable/retrievable ID or TAG or CLASS selectors
                            rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

                            rsibling = /[+~]/,

                            // CSS escapes
                            // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
                            runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g" ),
                            funescape = function( escape, nonHex ) {
                                var high = "0x" + escape.slice( 1 ) - 0x10000;

                                return nonHex ?

                                    // Strip the backslash prefix from a non-hex escape sequence
                                    nonHex :

                                    // Replace a hexadecimal escape sequence with the encoded Unicode code point
                                    // Support: IE <=11+
                                    // For values outside the Basic Multilingual Plane (BMP), manually construct a
                                    // surrogate pair
                                    high < 0 ?
                                        String.fromCharCode( high + 0x10000 ) :
                                        String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
                            },

                            // CSS string/identifier serialization
                            // https://drafts.csswg.org/cssom/#common-serializing-idioms
                            rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                            fcssescape = function( ch, asCodePoint ) {
                                if ( asCodePoint ) {

                                    // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                                    if ( ch === "\0" ) {
                                        return "\uFFFD";
                                    }

                                    // Control characters and (dependent upon position) numbers get escaped as code points
                                    return ch.slice( 0, -1 ) + "\\" +
                                        ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
                                }

                                // Other potentially-special ASCII characters get backslash-escaped
                                return "\\" + ch;
                            },

                            // Used for iframes
                            // See setDocument()
                            // Removing the function wrapper causes a "Permission Denied"
                            // error in IE
                            unloadHandler = function() {
                                setDocument();
                            },

                            inDisabledFieldset = addCombinator(
                                function( elem ) {
                                    return elem.disabled === true && elem.nodeName.toLowerCase() === "fieldset";
                                },
                                { dir: "parentNode", next: "legend" }
                            );

// Optimize for push.apply( _, NodeList )
                        try {
                            push.apply(
                                ( arr = slice.call( preferredDoc.childNodes ) ),
                                preferredDoc.childNodes
                            );

                            // Support: Android<4.0
                            // Detect silently failing push.apply
                            // eslint-disable-next-line no-unused-expressions
                            arr[ preferredDoc.childNodes.length ].nodeType;
                        } catch ( e ) {
                            push = { apply: arr.length ?

                                    // Leverage slice if possible
                                    function( target, els ) {
                                        pushNative.apply( target, slice.call( els ) );
                                    } :

                                    // Support: IE<9
                                    // Otherwise append directly
                                    function( target, els ) {
                                        var j = target.length,
                                            i = 0;

                                        // Can't trust NodeList.length
                                        while ( ( target[ j++ ] = els[ i++ ] ) ) {}
                                        target.length = j - 1;
                                    }
                            };
                        }

                        function Sizzle( selector, context, results, seed ) {
                            var m, i, elem, nid, match, groups, newSelector,
                                newContext = context && context.ownerDocument,

                                // nodeType defaults to 9, since context defaults to document
                                nodeType = context ? context.nodeType : 9;

                            results = results || [];

                            // Return early from calls with invalid selector or context
                            if ( typeof selector !== "string" || !selector ||
                                nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

                                return results;
                            }

                            // Try to shortcut find operations (as opposed to filters) in HTML documents
                            if ( !seed ) {
                                setDocument( context );
                                context = context || document;

                                if ( documentIsHTML ) {

                                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                                    // (excepting DocumentFragment context, where the methods don't exist)
                                    if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

                                        // ID selector
                                        if ( ( m = match[ 1 ] ) ) {

                                            // Document context
                                            if ( nodeType === 9 ) {
                                                if ( ( elem = context.getElementById( m ) ) ) {

                                                    // Support: IE, Opera, Webkit
                                                    // TODO: identify versions
                                                    // getElementById can match elements by name instead of ID
                                                    if ( elem.id === m ) {
                                                        results.push( elem );
                                                        return results;
                                                    }
                                                } else {
                                                    return results;
                                                }

                                                // Element context
                                            } else {

                                                // Support: IE, Opera, Webkit
                                                // TODO: identify versions
                                                // getElementById can match elements by name instead of ID
                                                if ( newContext && ( elem = newContext.getElementById( m ) ) &&
                                                    contains( context, elem ) &&
                                                    elem.id === m ) {

                                                    results.push( elem );
                                                    return results;
                                                }
                                            }

                                            // Type selector
                                        } else if ( match[ 2 ] ) {
                                            push.apply( results, context.getElementsByTagName( selector ) );
                                            return results;

                                            // Class selector
                                        } else if ( ( m = match[ 3 ] ) && support.getElementsByClassName &&
                                            context.getElementsByClassName ) {

                                            push.apply( results, context.getElementsByClassName( m ) );
                                            return results;
                                        }
                                    }

                                    // Take advantage of querySelectorAll
                                    if ( support.qsa &&
                                        !nonnativeSelectorCache[ selector + " " ] &&
                                        ( !rbuggyQSA || !rbuggyQSA.test( selector ) ) &&

                                        // Support: IE 8 only
                                        // Exclude object elements
                                        ( nodeType !== 1 || context.nodeName.toLowerCase() !== "object" ) ) {

                                        newSelector = selector;
                                        newContext = context;

                                        // qSA considers elements outside a scoping root when evaluating child or
                                        // descendant combinators, which is not what we want.
                                        // In such cases, we work around the behavior by prefixing every selector in the
                                        // list with an ID selector referencing the scope context.
                                        // The technique has to be used as well when a leading combinator is used
                                        // as such selectors are not recognized by querySelectorAll.
                                        // Thanks to Andrew Dupont for this technique.
                                        if ( nodeType === 1 &&
                                            ( rdescend.test( selector ) || rcombinators.test( selector ) ) ) {

                                            // Expand context for sibling selectors
                                            newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
                                                context;

                                            // We can use :scope instead of the ID hack if the browser
                                            // supports it & if we're not changing the context.
                                            if ( newContext !== context || !support.scope ) {

                                                // Capture the context ID, setting it first if necessary
                                                if ( ( nid = context.getAttribute( "id" ) ) ) {
                                                    nid = nid.replace( rcssescape, fcssescape );
                                                } else {
                                                    context.setAttribute( "id", ( nid = expando ) );
                                                }
                                            }

                                            // Prefix every selector in the list
                                            groups = tokenize( selector );
                                            i = groups.length;
                                            while ( i-- ) {
                                                groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
                                                    toSelector( groups[ i ] );
                                            }
                                            newSelector = groups.join( "," );
                                        }

                                        try {
                                            push.apply( results,
                                                newContext.querySelectorAll( newSelector )
                                            );
                                            return results;
                                        } catch ( qsaError ) {
                                            nonnativeSelectorCache( selector, true );
                                        } finally {
                                            if ( nid === expando ) {
                                                context.removeAttribute( "id" );
                                            }
                                        }
                                    }
                                }
                            }

                            // All others
                            return select( selector.replace( rtrim, "$1" ), context, results, seed );
                        }

                        /**
                         * Create key-value caches of limited size
                         * @returns {function(string, object)} Returns the Object data after storing it on itself with
                         *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
                         *	deleting the oldest entry
                         */
                        function createCache() {
                            var keys = [];

                            function cache( key, value ) {

                                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                                if ( keys.push( key + " " ) > Expr.cacheLength ) {

                                    // Only keep the most recent entries
                                    delete cache[ keys.shift() ];
                                }
                                return ( cache[ key + " " ] = value );
                            }
                            return cache;
                        }

                        /**
                         * Mark a function for special use by Sizzle
                         * @param {Function} fn The function to mark
                         */
                        function markFunction( fn ) {
                            fn[ expando ] = true;
                            return fn;
                        }

                        /**
                         * Support testing using an element
                         * @param {Function} fn Passed the created element and returns a boolean result
                         */
                        function assert( fn ) {
                            var el = document.createElement( "fieldset" );

                            try {
                                return !!fn( el );
                            } catch ( e ) {
                                return false;
                            } finally {

                                // Remove from its parent by default
                                if ( el.parentNode ) {
                                    el.parentNode.removeChild( el );
                                }

                                // release memory in IE
                                el = null;
                            }
                        }

                        /**
                         * Adds the same handler for all of the specified attrs
                         * @param {String} attrs Pipe-separated list of attributes
                         * @param {Function} handler The method that will be applied
                         */
                        function addHandle( attrs, handler ) {
                            var arr = attrs.split( "|" ),
                                i = arr.length;

                            while ( i-- ) {
                                Expr.attrHandle[ arr[ i ] ] = handler;
                            }
                        }

                        /**
                         * Checks document order of two siblings
                         * @param {Element} a
                         * @param {Element} b
                         * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
                         */
                        function siblingCheck( a, b ) {
                            var cur = b && a,
                                diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
                                    a.sourceIndex - b.sourceIndex;

                            // Use IE sourceIndex if available on both nodes
                            if ( diff ) {
                                return diff;
                            }

                            // Check if b follows a
                            if ( cur ) {
                                while ( ( cur = cur.nextSibling ) ) {
                                    if ( cur === b ) {
                                        return -1;
                                    }
                                }
                            }

                            return a ? 1 : -1;
                        }

                        /**
                         * Returns a function to use in pseudos for input types
                         * @param {String} type
                         */
                        function createInputPseudo( type ) {
                            return function( elem ) {
                                var name = elem.nodeName.toLowerCase();
                                return name === "input" && elem.type === type;
                            };
                        }

                        /**
                         * Returns a function to use in pseudos for buttons
                         * @param {String} type
                         */
                        function createButtonPseudo( type ) {
                            return function( elem ) {
                                var name = elem.nodeName.toLowerCase();
                                return ( name === "input" || name === "button" ) && elem.type === type;
                            };
                        }

                        /**
                         * Returns a function to use in pseudos for :enabled/:disabled
                         * @param {Boolean} disabled true for :disabled; false for :enabled
                         */
                        function createDisabledPseudo( disabled ) {

                            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
                            return function( elem ) {

                                // Only certain elements can match :enabled or :disabled
                                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                                if ( "form" in elem ) {

                                    // Check for inherited disabledness on relevant non-disabled elements:
                                    // * listed form-associated elements in a disabled fieldset
                                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                                    // * option elements in a disabled optgroup
                                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                                    // All such elements have a "form" property.
                                    if ( elem.parentNode && elem.disabled === false ) {

                                        // Option elements defer to a parent optgroup if present
                                        if ( "label" in elem ) {
                                            if ( "label" in elem.parentNode ) {
                                                return elem.parentNode.disabled === disabled;
                                            } else {
                                                return elem.disabled === disabled;
                                            }
                                        }

                                        // Support: IE 6 - 11
                                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                                        return elem.isDisabled === disabled ||

                                            // Where there is no isDisabled, check manually
                                            /* jshint -W018 */
                                            elem.isDisabled !== !disabled &&
                                            inDisabledFieldset( elem ) === disabled;
                                    }

                                    return elem.disabled === disabled;

                                    // Try to winnow out elements that can't be disabled before trusting the disabled property.
                                    // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                                    // even exist on them, let alone have a boolean value.
                                } else if ( "label" in elem ) {
                                    return elem.disabled === disabled;
                                }

                                // Remaining elements are neither :enabled nor :disabled
                                return false;
                            };
                        }

                        /**
                         * Returns a function to use in pseudos for positionals
                         * @param {Function} fn
                         */
                        function createPositionalPseudo( fn ) {
                            return markFunction( function( argument ) {
                                argument = +argument;
                                return markFunction( function( seed, matches ) {
                                    var j,
                                        matchIndexes = fn( [], seed.length, argument ),
                                        i = matchIndexes.length;

                                    // Match elements found at the specified indexes
                                    while ( i-- ) {
                                        if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
                                            seed[ j ] = !( matches[ j ] = seed[ j ] );
                                        }
                                    }
                                } );
                            } );
                        }

                        /**
                         * Checks a node for validity as a Sizzle context
                         * @param {Element|Object=} context
                         * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
                         */
                        function testContext( context ) {
                            return context && typeof context.getElementsByTagName !== "undefined" && context;
                        }

// Expose support vars for convenience
                        support = Sizzle.support = {};

                        /**
                         * Detects XML nodes
                         * @param {Element|Object} elem An element or a document
                         * @returns {Boolean} True iff elem is a non-HTML XML node
                         */
                        isXML = Sizzle.isXML = function( elem ) {
                            var namespace = elem && elem.namespaceURI,
                                docElem = elem && ( elem.ownerDocument || elem ).documentElement;

                            // Support: IE <=8
                            // Assume HTML when documentElement doesn't yet exist, such as inside loading iframes
                            // https://bugs.jquery.com/ticket/4833
                            return !rhtml.test( namespace || docElem && docElem.nodeName || "HTML" );
                        };

                        /**
                         * Sets document-related variables once based on the current document
                         * @param {Element|Object} [doc] An element or document object to use to set the document
                         * @returns {Object} Returns the current document
                         */
                        setDocument = Sizzle.setDocument = function( node ) {
                            var hasCompare, subWindow,
                                doc = node ? node.ownerDocument || node : preferredDoc;

                            // Return early if doc is invalid or already selected
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                            // two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
                                return document;
                            }

                            // Update global variables
                            document = doc;
                            docElem = document.documentElement;
                            documentIsHTML = !isXML( document );

                            // Support: IE 9 - 11+, Edge 12 - 18+
                            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                            // two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if ( preferredDoc != document &&
                                ( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

                                // Support: IE 11, Edge
                                if ( subWindow.addEventListener ) {
                                    subWindow.addEventListener( "unload", unloadHandler, false );

                                    // Support: IE 9 - 10 only
                                } else if ( subWindow.attachEvent ) {
                                    subWindow.attachEvent( "onunload", unloadHandler );
                                }
                            }

                            // Support: IE 8 - 11+, Edge 12 - 18+, Chrome <=16 - 25 only, Firefox <=3.6 - 31 only,
                            // Safari 4 - 5 only, Opera <=11.6 - 12.x only
                            // IE/Edge & older browsers don't support the :scope pseudo-class.
                            // Support: Safari 6.0 only
                            // Safari 6.0 supports :scope but it's an alias of :root there.
                            support.scope = assert( function( el ) {
                                docElem.appendChild( el ).appendChild( document.createElement( "div" ) );
                                return typeof el.querySelectorAll !== "undefined" &&
                                    !el.querySelectorAll( ":scope fieldset div" ).length;
                            } );

                            /* Attributes
	---------------------------------------------------------------------- */

                            // Support: IE<8
                            // Verify that getAttribute really returns attributes and not properties
                            // (excepting IE8 booleans)
                            support.attributes = assert( function( el ) {
                                el.className = "i";
                                return !el.getAttribute( "className" );
                            } );

                            /* getElement(s)By*
	---------------------------------------------------------------------- */

                            // Check if getElementsByTagName("*") returns only elements
                            support.getElementsByTagName = assert( function( el ) {
                                el.appendChild( document.createComment( "" ) );
                                return !el.getElementsByTagName( "*" ).length;
                            } );

                            // Support: IE<9
                            support.getElementsByClassName = rnative.test( document.getElementsByClassName );

                            // Support: IE<10
                            // Check if getElementById returns elements by name
                            // The broken getElementById methods don't pick up programmatically-set names,
                            // so use a roundabout getElementsByName test
                            support.getById = assert( function( el ) {
                                docElem.appendChild( el ).id = expando;
                                return !document.getElementsByName || !document.getElementsByName( expando ).length;
                            } );

                            // ID filter and find
                            if ( support.getById ) {
                                Expr.filter[ "ID" ] = function( id ) {
                                    var attrId = id.replace( runescape, funescape );
                                    return function( elem ) {
                                        return elem.getAttribute( "id" ) === attrId;
                                    };
                                };
                                Expr.find[ "ID" ] = function( id, context ) {
                                    if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                                        var elem = context.getElementById( id );
                                        return elem ? [ elem ] : [];
                                    }
                                };
                            } else {
                                Expr.filter[ "ID" ] =  function( id ) {
                                    var attrId = id.replace( runescape, funescape );
                                    return function( elem ) {
                                        var node = typeof elem.getAttributeNode !== "undefined" &&
                                            elem.getAttributeNode( "id" );
                                        return node && node.value === attrId;
                                    };
                                };

                                // Support: IE 6 - 7 only
                                // getElementById is not reliable as a find shortcut
                                Expr.find[ "ID" ] = function( id, context ) {
                                    if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
                                        var node, i, elems,
                                            elem = context.getElementById( id );

                                        if ( elem ) {

                                            // Verify the id attribute
                                            node = elem.getAttributeNode( "id" );
                                            if ( node && node.value === id ) {
                                                return [ elem ];
                                            }

                                            // Fall back on getElementsByName
                                            elems = context.getElementsByName( id );
                                            i = 0;
                                            while ( ( elem = elems[ i++ ] ) ) {
                                                node = elem.getAttributeNode( "id" );
                                                if ( node && node.value === id ) {
                                                    return [ elem ];
                                                }
                                            }
                                        }

                                        return [];
                                    }
                                };
                            }

                            // Tag
                            Expr.find[ "TAG" ] = support.getElementsByTagName ?
                                function( tag, context ) {
                                    if ( typeof context.getElementsByTagName !== "undefined" ) {
                                        return context.getElementsByTagName( tag );

                                        // DocumentFragment nodes don't have gEBTN
                                    } else if ( support.qsa ) {
                                        return context.querySelectorAll( tag );
                                    }
                                } :

                                function( tag, context ) {
                                    var elem,
                                        tmp = [],
                                        i = 0,

                                        // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                                        results = context.getElementsByTagName( tag );

                                    // Filter out possible comments
                                    if ( tag === "*" ) {
                                        while ( ( elem = results[ i++ ] ) ) {
                                            if ( elem.nodeType === 1 ) {
                                                tmp.push( elem );
                                            }
                                        }

                                        return tmp;
                                    }
                                    return results;
                                };

                            // Class
                            Expr.find[ "CLASS" ] = support.getElementsByClassName && function( className, context ) {
                                if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
                                    return context.getElementsByClassName( className );
                                }
                            };

                            /* QSA/matchesSelector
	---------------------------------------------------------------------- */

                            // QSA and matchesSelector support

                            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
                            rbuggyMatches = [];

                            // qSa(:focus) reports false when true (Chrome 21)
                            // We allow this because of a bug in IE8/9 that throws an error
                            // whenever `document.activeElement` is accessed on an iframe
                            // So, we allow :focus to pass through QSA all the time to avoid the IE error
                            // See https://bugs.jquery.com/ticket/13378
                            rbuggyQSA = [];

                            if ( ( support.qsa = rnative.test( document.querySelectorAll ) ) ) {

                                // Build QSA regex
                                // Regex strategy adopted from Diego Perini
                                assert( function( el ) {

                                    var input;

                                    // Select is set to empty string on purpose
                                    // This is to test IE's treatment of not explicitly
                                    // setting a boolean content attribute,
                                    // since its presence should be enough
                                    // https://bugs.jquery.com/ticket/12359
                                    docElem.appendChild( el ).innerHTML = "<a id='" + expando + "'></a>" +
                                        "<select id='" + expando + "-\r\\' msallowcapture=''>" +
                                        "<option selected=''></option></select>";

                                    // Support: IE8, Opera 11-12.16
                                    // Nothing should be selected when empty strings follow ^= or $= or *=
                                    // The test attribute must be unknown in Opera but "safe" for WinRT
                                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                                    if ( el.querySelectorAll( "[msallowcapture^='']" ).length ) {
                                        rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
                                    }

                                    // Support: IE8
                                    // Boolean attributes and "value" are not treated correctly
                                    if ( !el.querySelectorAll( "[selected]" ).length ) {
                                        rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
                                    }

                                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                                    if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
                                        rbuggyQSA.push( "~=" );
                                    }

                                    // Support: IE 11+, Edge 15 - 18+
                                    // IE 11/Edge don't find elements on a `[name='']` query in some cases.
                                    // Adding a temporary attribute to the document before the selection works
                                    // around the issue.
                                    // Interestingly, IE 10 & older don't seem to have the issue.
                                    input = document.createElement( "input" );
                                    input.setAttribute( "name", "" );
                                    el.appendChild( input );
                                    if ( !el.querySelectorAll( "[name='']" ).length ) {
                                        rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
                                            whitespace + "*(?:''|\"\")" );
                                    }

                                    // Webkit/Opera - :checked should return selected option elements
                                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                                    // IE8 throws error here and will not see later tests
                                    if ( !el.querySelectorAll( ":checked" ).length ) {
                                        rbuggyQSA.push( ":checked" );
                                    }

                                    // Support: Safari 8+, iOS 8+
                                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                                    // In-page `selector#id sibling-combinator selector` fails
                                    if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
                                        rbuggyQSA.push( ".#.+[+~]" );
                                    }

                                    // Support: Firefox <=3.6 - 5 only
                                    // Old Firefox doesn't throw on a badly-escaped identifier.
                                    el.querySelectorAll( "\\\f" );
                                    rbuggyQSA.push( "[\\r\\n\\f]" );
                                } );

                                assert( function( el ) {
                                    el.innerHTML = "<a href='' disabled='disabled'></a>" +
                                        "<select disabled='disabled'><option/></select>";

                                    // Support: Windows 8 Native Apps
                                    // The type and name attributes are restricted during .innerHTML assignment
                                    var input = document.createElement( "input" );
                                    input.setAttribute( "type", "hidden" );
                                    el.appendChild( input ).setAttribute( "name", "D" );

                                    // Support: IE8
                                    // Enforce case-sensitivity of name attribute
                                    if ( el.querySelectorAll( "[name=d]" ).length ) {
                                        rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
                                    }

                                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                                    // IE8 throws error here and will not see later tests
                                    if ( el.querySelectorAll( ":enabled" ).length !== 2 ) {
                                        rbuggyQSA.push( ":enabled", ":disabled" );
                                    }

                                    // Support: IE9-11+
                                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                                    docElem.appendChild( el ).disabled = true;
                                    if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
                                        rbuggyQSA.push( ":enabled", ":disabled" );
                                    }

                                    // Support: Opera 10 - 11 only
                                    // Opera 10-11 does not throw on post-comma invalid pseudos
                                    el.querySelectorAll( "*,:x" );
                                    rbuggyQSA.push( ",.*:" );
                                } );
                            }

                            if ( ( support.matchesSelector = rnative.test( ( matches = docElem.matches ||
                                docElem.webkitMatchesSelector ||
                                docElem.mozMatchesSelector ||
                                docElem.oMatchesSelector ||
                                docElem.msMatchesSelector ) ) ) ) {

                                assert( function( el ) {

                                    // Check to see if it's possible to do matchesSelector
                                    // on a disconnected node (IE 9)
                                    support.disconnectedMatch = matches.call( el, "*" );

                                    // This should fail with an exception
                                    // Gecko does not error, returns false instead
                                    matches.call( el, "[s!='']:x" );
                                    rbuggyMatches.push( "!=", pseudos );
                                } );
                            }

                            rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );
                            rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join( "|" ) );

                            /* Contains
	---------------------------------------------------------------------- */
                            hasCompare = rnative.test( docElem.compareDocumentPosition );

                            // Element contains another
                            // Purposefully self-exclusive
                            // As in, an element does not contain itself
                            contains = hasCompare || rnative.test( docElem.contains ) ?
                                function( a, b ) {
                                    var adown = a.nodeType === 9 ? a.documentElement : a,
                                        bup = b && b.parentNode;
                                    return a === bup || !!( bup && bup.nodeType === 1 && (
                                        adown.contains ?
                                            adown.contains( bup ) :
                                            a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
                                    ) );
                                } :
                                function( a, b ) {
                                    if ( b ) {
                                        while ( ( b = b.parentNode ) ) {
                                            if ( b === a ) {
                                                return true;
                                            }
                                        }
                                    }
                                    return false;
                                };

                            /* Sorting
	---------------------------------------------------------------------- */

                            // Document order sorting
                            sortOrder = hasCompare ?
                                function( a, b ) {

                                    // Flag for duplicate removal
                                    if ( a === b ) {
                                        hasDuplicate = true;
                                        return 0;
                                    }

                                    // Sort on method existence if only one input has compareDocumentPosition
                                    var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                                    if ( compare ) {
                                        return compare;
                                    }

                                    // Calculate position if both inputs belong to the same document
                                    // Support: IE 11+, Edge 17 - 18+
                                    // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                    // two documents; shallow comparisons work.
                                    // eslint-disable-next-line eqeqeq
                                    compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
                                        a.compareDocumentPosition( b ) :

                                        // Otherwise we know they are disconnected
                                        1;

                                    // Disconnected nodes
                                    if ( compare & 1 ||
                                        ( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

                                        // Choose the first element that is related to our preferred document
                                        // Support: IE 11+, Edge 17 - 18+
                                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                        // two documents; shallow comparisons work.
                                        // eslint-disable-next-line eqeqeq
                                        if ( a == document || a.ownerDocument == preferredDoc &&
                                            contains( preferredDoc, a ) ) {
                                            return -1;
                                        }

                                        // Support: IE 11+, Edge 17 - 18+
                                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                        // two documents; shallow comparisons work.
                                        // eslint-disable-next-line eqeqeq
                                        if ( b == document || b.ownerDocument == preferredDoc &&
                                            contains( preferredDoc, b ) ) {
                                            return 1;
                                        }

                                        // Maintain original order
                                        return sortInput ?
                                            ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                                            0;
                                    }

                                    return compare & 4 ? -1 : 1;
                                } :
                                function( a, b ) {

                                    // Exit early if the nodes are identical
                                    if ( a === b ) {
                                        hasDuplicate = true;
                                        return 0;
                                    }

                                    var cur,
                                        i = 0,
                                        aup = a.parentNode,
                                        bup = b.parentNode,
                                        ap = [ a ],
                                        bp = [ b ];

                                    // Parentless nodes are either documents or disconnected
                                    if ( !aup || !bup ) {

                                        // Support: IE 11+, Edge 17 - 18+
                                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                        // two documents; shallow comparisons work.
                                        /* eslint-disable eqeqeq */
                                        return a == document ? -1 :
                                            b == document ? 1 :
                                                /* eslint-enable eqeqeq */
                                                aup ? -1 :
                                                    bup ? 1 :
                                                        sortInput ?
                                                            ( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
                                                            0;

                                        // If the nodes are siblings, we can do a quick check
                                    } else if ( aup === bup ) {
                                        return siblingCheck( a, b );
                                    }

                                    // Otherwise we need full lists of their ancestors for comparison
                                    cur = a;
                                    while ( ( cur = cur.parentNode ) ) {
                                        ap.unshift( cur );
                                    }
                                    cur = b;
                                    while ( ( cur = cur.parentNode ) ) {
                                        bp.unshift( cur );
                                    }

                                    // Walk down the tree looking for a discrepancy
                                    while ( ap[ i ] === bp[ i ] ) {
                                        i++;
                                    }

                                    return i ?

                                        // Do a sibling check if the nodes have a common ancestor
                                        siblingCheck( ap[ i ], bp[ i ] ) :

                                        // Otherwise nodes in our document sort first
                                        // Support: IE 11+, Edge 17 - 18+
                                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                        // two documents; shallow comparisons work.
                                        /* eslint-disable eqeqeq */
                                        ap[ i ] == preferredDoc ? -1 :
                                            bp[ i ] == preferredDoc ? 1 :
                                                /* eslint-enable eqeqeq */
                                                0;
                                };

                            return document;
                        };

                        Sizzle.matches = function( expr, elements ) {
                            return Sizzle( expr, null, null, elements );
                        };

                        Sizzle.matchesSelector = function( elem, expr ) {
                            setDocument( elem );

                            if ( support.matchesSelector && documentIsHTML &&
                                !nonnativeSelectorCache[ expr + " " ] &&
                                ( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
                                ( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

                                try {
                                    var ret = matches.call( elem, expr );

                                    // IE 9's matchesSelector returns false on disconnected nodes
                                    if ( ret || support.disconnectedMatch ||

                                        // As well, disconnected nodes are said to be in a document
                                        // fragment in IE 9
                                        elem.document && elem.document.nodeType !== 11 ) {
                                        return ret;
                                    }
                                } catch ( e ) {
                                    nonnativeSelectorCache( expr, true );
                                }
                            }

                            return Sizzle( expr, document, null, [ elem ] ).length > 0;
                        };

                        Sizzle.contains = function( context, elem ) {

                            // Set document vars if needed
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                            // two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if ( ( context.ownerDocument || context ) != document ) {
                                setDocument( context );
                            }
                            return contains( context, elem );
                        };

                        Sizzle.attr = function( elem, name ) {

                            // Set document vars if needed
                            // Support: IE 11+, Edge 17 - 18+
                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                            // two documents; shallow comparisons work.
                            // eslint-disable-next-line eqeqeq
                            if ( ( elem.ownerDocument || elem ) != document ) {
                                setDocument( elem );
                            }

                            var fn = Expr.attrHandle[ name.toLowerCase() ],

                                // Don't get fooled by Object.prototype properties (jQuery #13807)
                                val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
                                    fn( elem, name, !documentIsHTML ) :
                                    undefined;

                            return val !== undefined ?
                                val :
                                support.attributes || !documentIsHTML ?
                                    elem.getAttribute( name ) :
                                    ( val = elem.getAttributeNode( name ) ) && val.specified ?
                                        val.value :
                                        null;
                        };

                        Sizzle.escape = function( sel ) {
                            return ( sel + "" ).replace( rcssescape, fcssescape );
                        };

                        Sizzle.error = function( msg ) {
                            throw new Error( "Syntax error, unrecognized expression: " + msg );
                        };

                        /**
                         * Document sorting and removing duplicates
                         * @param {ArrayLike} results
                         */
                        Sizzle.uniqueSort = function( results ) {
                            var elem,
                                duplicates = [],
                                j = 0,
                                i = 0;

                            // Unless we *know* we can detect duplicates, assume their presence
                            hasDuplicate = !support.detectDuplicates;
                            sortInput = !support.sortStable && results.slice( 0 );
                            results.sort( sortOrder );

                            if ( hasDuplicate ) {
                                while ( ( elem = results[ i++ ] ) ) {
                                    if ( elem === results[ i ] ) {
                                        j = duplicates.push( i );
                                    }
                                }
                                while ( j-- ) {
                                    results.splice( duplicates[ j ], 1 );
                                }
                            }

                            // Clear input after sorting to release objects
                            // See https://github.com/jquery/sizzle/pull/225
                            sortInput = null;

                            return results;
                        };

                        /**
                         * Utility function for retrieving the text value of an array of DOM nodes
                         * @param {Array|Element} elem
                         */
                        getText = Sizzle.getText = function( elem ) {
                            var node,
                                ret = "",
                                i = 0,
                                nodeType = elem.nodeType;

                            if ( !nodeType ) {

                                // If no nodeType, this is expected to be an array
                                while ( ( node = elem[ i++ ] ) ) {

                                    // Do not traverse comment nodes
                                    ret += getText( node );
                                }
                            } else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {

                                // Use textContent for elements
                                // innerText usage removed for consistency of new lines (jQuery #11153)
                                if ( typeof elem.textContent === "string" ) {
                                    return elem.textContent;
                                } else {

                                    // Traverse its children
                                    for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                                        ret += getText( elem );
                                    }
                                }
                            } else if ( nodeType === 3 || nodeType === 4 ) {
                                return elem.nodeValue;
                            }

                            // Do not include comment or processing instruction nodes

                            return ret;
                        };

                        Expr = Sizzle.selectors = {

                            // Can be adjusted by the user
                            cacheLength: 50,

                            createPseudo: markFunction,

                            match: matchExpr,

                            attrHandle: {},

                            find: {},

                            relative: {
                                ">": { dir: "parentNode", first: true },
                                " ": { dir: "parentNode" },
                                "+": { dir: "previousSibling", first: true },
                                "~": { dir: "previousSibling" }
                            },

                            preFilter: {
                                "ATTR": function( match ) {
                                    match[ 1 ] = match[ 1 ].replace( runescape, funescape );

                                    // Move the given value to match[3] whether quoted or unquoted
                                    match[ 3 ] = ( match[ 3 ] || match[ 4 ] ||
                                        match[ 5 ] || "" ).replace( runescape, funescape );

                                    if ( match[ 2 ] === "~=" ) {
                                        match[ 3 ] = " " + match[ 3 ] + " ";
                                    }

                                    return match.slice( 0, 4 );
                                },

                                "CHILD": function( match ) {

                                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
                                    match[ 1 ] = match[ 1 ].toLowerCase();

                                    if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

                                        // nth-* requires argument
                                        if ( !match[ 3 ] ) {
                                            Sizzle.error( match[ 0 ] );
                                        }

                                        // numeric x and y parameters for Expr.filter.CHILD
                                        // remember that false/true cast respectively to 0/1
                                        match[ 4 ] = +( match[ 4 ] ?
                                            match[ 5 ] + ( match[ 6 ] || 1 ) :
                                            2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" ) );
                                        match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

                                        // other types prohibit arguments
                                    } else if ( match[ 3 ] ) {
                                        Sizzle.error( match[ 0 ] );
                                    }

                                    return match;
                                },

                                "PSEUDO": function( match ) {
                                    var excess,
                                        unquoted = !match[ 6 ] && match[ 2 ];

                                    if ( matchExpr[ "CHILD" ].test( match[ 0 ] ) ) {
                                        return null;
                                    }

                                    // Accept quoted arguments as-is
                                    if ( match[ 3 ] ) {
                                        match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

                                        // Strip excess characters from unquoted arguments
                                    } else if ( unquoted && rpseudo.test( unquoted ) &&

                                        // Get excess from tokenize (recursively)
                                        ( excess = tokenize( unquoted, true ) ) &&

                                        // advance to the next closing parenthesis
                                        ( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

                                        // excess is a negative index
                                        match[ 0 ] = match[ 0 ].slice( 0, excess );
                                        match[ 2 ] = unquoted.slice( 0, excess );
                                    }

                                    // Return only captures needed by the pseudo filter method (type and argument)
                                    return match.slice( 0, 3 );
                                }
                            },

                            filter: {

                                "TAG": function( nodeNameSelector ) {
                                    var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
                                    return nodeNameSelector === "*" ?
                                        function() {
                                            return true;
                                        } :
                                        function( elem ) {
                                            return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
                                        };
                                },

                                "CLASS": function( className ) {
                                    var pattern = classCache[ className + " " ];

                                    return pattern ||
                                        ( pattern = new RegExp( "(^|" + whitespace +
                                            ")" + className + "(" + whitespace + "|$)" ) ) && classCache(
                                            className, function( elem ) {
                                                return pattern.test(
                                                    typeof elem.className === "string" && elem.className ||
                                                    typeof elem.getAttribute !== "undefined" &&
                                                    elem.getAttribute( "class" ) ||
                                                    ""
                                                );
                                            } );
                                },

                                "ATTR": function( name, operator, check ) {
                                    return function( elem ) {
                                        var result = Sizzle.attr( elem, name );

                                        if ( result == null ) {
                                            return operator === "!=";
                                        }
                                        if ( !operator ) {
                                            return true;
                                        }

                                        result += "";

                                        /* eslint-disable max-len */

                                        return operator === "=" ? result === check :
                                            operator === "!=" ? result !== check :
                                                operator === "^=" ? check && result.indexOf( check ) === 0 :
                                                    operator === "*=" ? check && result.indexOf( check ) > -1 :
                                                        operator === "$=" ? check && result.slice( -check.length ) === check :
                                                            operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
                                                                operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
                                                                    false;
                                        /* eslint-enable max-len */

                                    };
                                },

                                "CHILD": function( type, what, _argument, first, last ) {
                                    var simple = type.slice( 0, 3 ) !== "nth",
                                        forward = type.slice( -4 ) !== "last",
                                        ofType = what === "of-type";

                                    return first === 1 && last === 0 ?

                                        // Shortcut for :nth-*(n)
                                        function( elem ) {
                                            return !!elem.parentNode;
                                        } :

                                        function( elem, _context, xml ) {
                                            var cache, uniqueCache, outerCache, node, nodeIndex, start,
                                                dir = simple !== forward ? "nextSibling" : "previousSibling",
                                                parent = elem.parentNode,
                                                name = ofType && elem.nodeName.toLowerCase(),
                                                useCache = !xml && !ofType,
                                                diff = false;

                                            if ( parent ) {

                                                // :(first|last|only)-(child|of-type)
                                                if ( simple ) {
                                                    while ( dir ) {
                                                        node = elem;
                                                        while ( ( node = node[ dir ] ) ) {
                                                            if ( ofType ?
                                                                node.nodeName.toLowerCase() === name :
                                                                node.nodeType === 1 ) {

                                                                return false;
                                                            }
                                                        }

                                                        // Reverse direction for :only-* (if we haven't yet done so)
                                                        start = dir = type === "only" && !start && "nextSibling";
                                                    }
                                                    return true;
                                                }

                                                start = [ forward ? parent.firstChild : parent.lastChild ];

                                                // non-xml :nth-child(...) stores cache data on `parent`
                                                if ( forward && useCache ) {

                                                    // Seek `elem` from a previously-cached index

                                                    // ...in a gzip-friendly way
                                                    node = parent;
                                                    outerCache = node[ expando ] || ( node[ expando ] = {} );

                                                    // Support: IE <9 only
                                                    // Defend against cloned attroperties (jQuery gh-1709)
                                                    uniqueCache = outerCache[ node.uniqueID ] ||
                                                        ( outerCache[ node.uniqueID ] = {} );

                                                    cache = uniqueCache[ type ] || [];
                                                    nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                                                    diff = nodeIndex && cache[ 2 ];
                                                    node = nodeIndex && parent.childNodes[ nodeIndex ];

                                                    while ( ( node = ++nodeIndex && node && node[ dir ] ||

                                                        // Fallback to seeking `elem` from the start
                                                        ( diff = nodeIndex = 0 ) || start.pop() ) ) {

                                                        // When found, cache indexes on `parent` and break
                                                        if ( node.nodeType === 1 && ++diff && node === elem ) {
                                                            uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
                                                            break;
                                                        }
                                                    }

                                                } else {

                                                    // Use previously-cached element index if available
                                                    if ( useCache ) {

                                                        // ...in a gzip-friendly way
                                                        node = elem;
                                                        outerCache = node[ expando ] || ( node[ expando ] = {} );

                                                        // Support: IE <9 only
                                                        // Defend against cloned attroperties (jQuery gh-1709)
                                                        uniqueCache = outerCache[ node.uniqueID ] ||
                                                            ( outerCache[ node.uniqueID ] = {} );

                                                        cache = uniqueCache[ type ] || [];
                                                        nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
                                                        diff = nodeIndex;
                                                    }

                                                    // xml :nth-child(...)
                                                    // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                                    if ( diff === false ) {

                                                        // Use the same loop as above to seek `elem` from the start
                                                        while ( ( node = ++nodeIndex && node && node[ dir ] ||
                                                            ( diff = nodeIndex = 0 ) || start.pop() ) ) {

                                                            if ( ( ofType ?
                                                                    node.nodeName.toLowerCase() === name :
                                                                    node.nodeType === 1 ) &&
                                                                ++diff ) {

                                                                // Cache the index of each encountered element
                                                                if ( useCache ) {
                                                                    outerCache = node[ expando ] ||
                                                                        ( node[ expando ] = {} );

                                                                    // Support: IE <9 only
                                                                    // Defend against cloned attroperties (jQuery gh-1709)
                                                                    uniqueCache = outerCache[ node.uniqueID ] ||
                                                                        ( outerCache[ node.uniqueID ] = {} );

                                                                    uniqueCache[ type ] = [ dirruns, diff ];
                                                                }

                                                                if ( node === elem ) {
                                                                    break;
                                                                }
                                                            }
                                                        }
                                                    }
                                                }

                                                // Incorporate the offset, then check against cycle size
                                                diff -= last;
                                                return diff === first || ( diff % first === 0 && diff / first >= 0 );
                                            }
                                        };
                                },

                                "PSEUDO": function( pseudo, argument ) {

                                    // pseudo-class names are case-insensitive
                                    // http://www.w3.org/TR/selectors/#pseudo-classes
                                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                                    // Remember that setFilters inherits from pseudos
                                    var args,
                                        fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
                                            Sizzle.error( "unsupported pseudo: " + pseudo );

                                    // The user may use createPseudo to indicate that
                                    // arguments are needed to create the filter function
                                    // just as Sizzle does
                                    if ( fn[ expando ] ) {
                                        return fn( argument );
                                    }

                                    // But maintain support for old signatures
                                    if ( fn.length > 1 ) {
                                        args = [ pseudo, pseudo, "", argument ];
                                        return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
                                            markFunction( function( seed, matches ) {
                                                var idx,
                                                    matched = fn( seed, argument ),
                                                    i = matched.length;
                                                while ( i-- ) {
                                                    idx = indexOf( seed, matched[ i ] );
                                                    seed[ idx ] = !( matches[ idx ] = matched[ i ] );
                                                }
                                            } ) :
                                            function( elem ) {
                                                return fn( elem, 0, args );
                                            };
                                    }

                                    return fn;
                                }
                            },

                            pseudos: {

                                // Potentially complex pseudos
                                "not": markFunction( function( selector ) {

                                    // Trim the selector passed to compile
                                    // to avoid treating leading and trailing
                                    // spaces as combinators
                                    var input = [],
                                        results = [],
                                        matcher = compile( selector.replace( rtrim, "$1" ) );

                                    return matcher[ expando ] ?
                                        markFunction( function( seed, matches, _context, xml ) {
                                            var elem,
                                                unmatched = matcher( seed, null, xml, [] ),
                                                i = seed.length;

                                            // Match elements unmatched by `matcher`
                                            while ( i-- ) {
                                                if ( ( elem = unmatched[ i ] ) ) {
                                                    seed[ i ] = !( matches[ i ] = elem );
                                                }
                                            }
                                        } ) :
                                        function( elem, _context, xml ) {
                                            input[ 0 ] = elem;
                                            matcher( input, null, xml, results );

                                            // Don't keep the element (issue #299)
                                            input[ 0 ] = null;
                                            return !results.pop();
                                        };
                                } ),

                                "has": markFunction( function( selector ) {
                                    return function( elem ) {
                                        return Sizzle( selector, elem ).length > 0;
                                    };
                                } ),

                                "contains": markFunction( function( text ) {
                                    text = text.replace( runescape, funescape );
                                    return function( elem ) {
                                        return ( elem.textContent || getText( elem ) ).indexOf( text ) > -1;
                                    };
                                } ),

                                // "Whether an element is represented by a :lang() selector
                                // is based solely on the element's language value
                                // being equal to the identifier C,
                                // or beginning with the identifier C immediately followed by "-".
                                // The matching of C against the element's language value is performed case-insensitively.
                                // The identifier C does not have to be a valid language name."
                                // http://www.w3.org/TR/selectors/#lang-pseudo
                                "lang": markFunction( function( lang ) {

                                    // lang value must be a valid identifier
                                    if ( !ridentifier.test( lang || "" ) ) {
                                        Sizzle.error( "unsupported lang: " + lang );
                                    }
                                    lang = lang.replace( runescape, funescape ).toLowerCase();
                                    return function( elem ) {
                                        var elemLang;
                                        do {
                                            if ( ( elemLang = documentIsHTML ?
                                                elem.lang :
                                                elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

                                                elemLang = elemLang.toLowerCase();
                                                return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
                                            }
                                        } while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
                                        return false;
                                    };
                                } ),

                                // Miscellaneous
                                "target": function( elem ) {
                                    var hash = window.location && window.location.hash;
                                    return hash && hash.slice( 1 ) === elem.id;
                                },

                                "root": function( elem ) {
                                    return elem === docElem;
                                },

                                "focus": function( elem ) {
                                    return elem === document.activeElement &&
                                        ( !document.hasFocus || document.hasFocus() ) &&
                                        !!( elem.type || elem.href || ~elem.tabIndex );
                                },

                                // Boolean properties
                                "enabled": createDisabledPseudo( false ),
                                "disabled": createDisabledPseudo( true ),

                                "checked": function( elem ) {

                                    // In CSS3, :checked should return both checked and selected elements
                                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                                    var nodeName = elem.nodeName.toLowerCase();
                                    return ( nodeName === "input" && !!elem.checked ) ||
                                        ( nodeName === "option" && !!elem.selected );
                                },

                                "selected": function( elem ) {

                                    // Accessing this property makes selected-by-default
                                    // options in Safari work properly
                                    if ( elem.parentNode ) {
                                        // eslint-disable-next-line no-unused-expressions
                                        elem.parentNode.selectedIndex;
                                    }

                                    return elem.selected === true;
                                },

                                // Contents
                                "empty": function( elem ) {

                                    // http://www.w3.org/TR/selectors/#empty-pseudo
                                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                                    // nodeType < 6 works because attributes (2) do not appear as children
                                    for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
                                        if ( elem.nodeType < 6 ) {
                                            return false;
                                        }
                                    }
                                    return true;
                                },

                                "parent": function( elem ) {
                                    return !Expr.pseudos[ "empty" ]( elem );
                                },

                                // Element/input types
                                "header": function( elem ) {
                                    return rheader.test( elem.nodeName );
                                },

                                "input": function( elem ) {
                                    return rinputs.test( elem.nodeName );
                                },

                                "button": function( elem ) {
                                    var name = elem.nodeName.toLowerCase();
                                    return name === "input" && elem.type === "button" || name === "button";
                                },

                                "text": function( elem ) {
                                    var attr;
                                    return elem.nodeName.toLowerCase() === "input" &&
                                        elem.type === "text" &&

                                        // Support: IE<8
                                        // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                                        ( ( attr = elem.getAttribute( "type" ) ) == null ||
                                            attr.toLowerCase() === "text" );
                                },

                                // Position-in-collection
                                "first": createPositionalPseudo( function() {
                                    return [ 0 ];
                                } ),

                                "last": createPositionalPseudo( function( _matchIndexes, length ) {
                                    return [ length - 1 ];
                                } ),

                                "eq": createPositionalPseudo( function( _matchIndexes, length, argument ) {
                                    return [ argument < 0 ? argument + length : argument ];
                                } ),

                                "even": createPositionalPseudo( function( matchIndexes, length ) {
                                    var i = 0;
                                    for ( ; i < length; i += 2 ) {
                                        matchIndexes.push( i );
                                    }
                                    return matchIndexes;
                                } ),

                                "odd": createPositionalPseudo( function( matchIndexes, length ) {
                                    var i = 1;
                                    for ( ; i < length; i += 2 ) {
                                        matchIndexes.push( i );
                                    }
                                    return matchIndexes;
                                } ),

                                "lt": createPositionalPseudo( function( matchIndexes, length, argument ) {
                                    var i = argument < 0 ?
                                        argument + length :
                                        argument > length ?
                                            length :
                                            argument;
                                    for ( ; --i >= 0; ) {
                                        matchIndexes.push( i );
                                    }
                                    return matchIndexes;
                                } ),

                                "gt": createPositionalPseudo( function( matchIndexes, length, argument ) {
                                    var i = argument < 0 ? argument + length : argument;
                                    for ( ; ++i < length; ) {
                                        matchIndexes.push( i );
                                    }
                                    return matchIndexes;
                                } )
                            }
                        };

                        Expr.pseudos[ "nth" ] = Expr.pseudos[ "eq" ];

// Add button/input type pseudos
                        for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
                            Expr.pseudos[ i ] = createInputPseudo( i );
                        }
                        for ( i in { submit: true, reset: true } ) {
                            Expr.pseudos[ i ] = createButtonPseudo( i );
                        }

// Easy API for creating new setFilters
                        function setFilters() {}
                        setFilters.prototype = Expr.filters = Expr.pseudos;
                        Expr.setFilters = new setFilters();

                        tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
                            var matched, match, tokens, type,
                                soFar, groups, preFilters,
                                cached = tokenCache[ selector + " " ];

                            if ( cached ) {
                                return parseOnly ? 0 : cached.slice( 0 );
                            }

                            soFar = selector;
                            groups = [];
                            preFilters = Expr.preFilter;

                            while ( soFar ) {

                                // Comma and first run
                                if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
                                    if ( match ) {

                                        // Don't consume trailing commas as valid
                                        soFar = soFar.slice( match[ 0 ].length ) || soFar;
                                    }
                                    groups.push( ( tokens = [] ) );
                                }

                                matched = false;

                                // Combinators
                                if ( ( match = rcombinators.exec( soFar ) ) ) {
                                    matched = match.shift();
                                    tokens.push( {
                                        value: matched,

                                        // Cast descendant combinators to space
                                        type: match[ 0 ].replace( rtrim, " " )
                                    } );
                                    soFar = soFar.slice( matched.length );
                                }

                                // Filters
                                for ( type in Expr.filter ) {
                                    if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
                                        ( match = preFilters[ type ]( match ) ) ) ) {
                                        matched = match.shift();
                                        tokens.push( {
                                            value: matched,
                                            type: type,
                                            matches: match
                                        } );
                                        soFar = soFar.slice( matched.length );
                                    }
                                }

                                if ( !matched ) {
                                    break;
                                }
                            }

                            // Return the length of the invalid excess
                            // if we're just parsing
                            // Otherwise, throw an error or return tokens
                            return parseOnly ?
                                soFar.length :
                                soFar ?
                                    Sizzle.error( selector ) :

                                    // Cache the tokens
                                    tokenCache( selector, groups ).slice( 0 );
                        };

                        function toSelector( tokens ) {
                            var i = 0,
                                len = tokens.length,
                                selector = "";
                            for ( ; i < len; i++ ) {
                                selector += tokens[ i ].value;
                            }
                            return selector;
                        }

                        function addCombinator( matcher, combinator, base ) {
                            var dir = combinator.dir,
                                skip = combinator.next,
                                key = skip || dir,
                                checkNonElements = base && key === "parentNode",
                                doneName = done++;

                            return combinator.first ?

                                // Check against closest ancestor/preceding element
                                function( elem, context, xml ) {
                                    while ( ( elem = elem[ dir ] ) ) {
                                        if ( elem.nodeType === 1 || checkNonElements ) {
                                            return matcher( elem, context, xml );
                                        }
                                    }
                                    return false;
                                } :

                                // Check against all ancestor/preceding elements
                                function( elem, context, xml ) {
                                    var oldCache, uniqueCache, outerCache,
                                        newCache = [ dirruns, doneName ];

                                    // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                                    if ( xml ) {
                                        while ( ( elem = elem[ dir ] ) ) {
                                            if ( elem.nodeType === 1 || checkNonElements ) {
                                                if ( matcher( elem, context, xml ) ) {
                                                    return true;
                                                }
                                            }
                                        }
                                    } else {
                                        while ( ( elem = elem[ dir ] ) ) {
                                            if ( elem.nodeType === 1 || checkNonElements ) {
                                                outerCache = elem[ expando ] || ( elem[ expando ] = {} );

                                                // Support: IE <9 only
                                                // Defend against cloned attroperties (jQuery gh-1709)
                                                uniqueCache = outerCache[ elem.uniqueID ] ||
                                                    ( outerCache[ elem.uniqueID ] = {} );

                                                if ( skip && skip === elem.nodeName.toLowerCase() ) {
                                                    elem = elem[ dir ] || elem;
                                                } else if ( ( oldCache = uniqueCache[ key ] ) &&
                                                    oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

                                                    // Assign to newCache so results back-propagate to previous elements
                                                    return ( newCache[ 2 ] = oldCache[ 2 ] );
                                                } else {

                                                    // Reuse newcache so results back-propagate to previous elements
                                                    uniqueCache[ key ] = newCache;

                                                    // A match means we're done; a fail means we have to keep checking
                                                    if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
                                                        return true;
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    return false;
                                };
                        }

                        function elementMatcher( matchers ) {
                            return matchers.length > 1 ?
                                function( elem, context, xml ) {
                                    var i = matchers.length;
                                    while ( i-- ) {
                                        if ( !matchers[ i ]( elem, context, xml ) ) {
                                            return false;
                                        }
                                    }
                                    return true;
                                } :
                                matchers[ 0 ];
                        }

                        function multipleContexts( selector, contexts, results ) {
                            var i = 0,
                                len = contexts.length;
                            for ( ; i < len; i++ ) {
                                Sizzle( selector, contexts[ i ], results );
                            }
                            return results;
                        }

                        function condense( unmatched, map, filter, context, xml ) {
                            var elem,
                                newUnmatched = [],
                                i = 0,
                                len = unmatched.length,
                                mapped = map != null;

                            for ( ; i < len; i++ ) {
                                if ( ( elem = unmatched[ i ] ) ) {
                                    if ( !filter || filter( elem, context, xml ) ) {
                                        newUnmatched.push( elem );
                                        if ( mapped ) {
                                            map.push( i );
                                        }
                                    }
                                }
                            }

                            return newUnmatched;
                        }

                        function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
                            if ( postFilter && !postFilter[ expando ] ) {
                                postFilter = setMatcher( postFilter );
                            }
                            if ( postFinder && !postFinder[ expando ] ) {
                                postFinder = setMatcher( postFinder, postSelector );
                            }
                            return markFunction( function( seed, results, context, xml ) {
                                var temp, i, elem,
                                    preMap = [],
                                    postMap = [],
                                    preexisting = results.length,

                                    // Get initial elements from seed or context
                                    elems = seed || multipleContexts(
                                        selector || "*",
                                        context.nodeType ? [ context ] : context,
                                        []
                                    ),

                                    // Prefilter to get matcher input, preserving a map for seed-results synchronization
                                    matcherIn = preFilter && ( seed || !selector ) ?
                                        condense( elems, preMap, preFilter, context, xml ) :
                                        elems,

                                    matcherOut = matcher ?

                                        // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                                        postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

                                            // ...intermediate processing is necessary
                                            [] :

                                            // ...otherwise use results directly
                                            results :
                                        matcherIn;

                                // Find primary matches
                                if ( matcher ) {
                                    matcher( matcherIn, matcherOut, context, xml );
                                }

                                // Apply postFilter
                                if ( postFilter ) {
                                    temp = condense( matcherOut, postMap );
                                    postFilter( temp, [], context, xml );

                                    // Un-match failing elements by moving them back to matcherIn
                                    i = temp.length;
                                    while ( i-- ) {
                                        if ( ( elem = temp[ i ] ) ) {
                                            matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
                                        }
                                    }
                                }

                                if ( seed ) {
                                    if ( postFinder || preFilter ) {
                                        if ( postFinder ) {

                                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                                            temp = [];
                                            i = matcherOut.length;
                                            while ( i-- ) {
                                                if ( ( elem = matcherOut[ i ] ) ) {

                                                    // Restore matcherIn since elem is not yet a final match
                                                    temp.push( ( matcherIn[ i ] = elem ) );
                                                }
                                            }
                                            postFinder( null, ( matcherOut = [] ), temp, xml );
                                        }

                                        // Move matched elements from seed to results to keep them synchronized
                                        i = matcherOut.length;
                                        while ( i-- ) {
                                            if ( ( elem = matcherOut[ i ] ) &&
                                                ( temp = postFinder ? indexOf( seed, elem ) : preMap[ i ] ) > -1 ) {

                                                seed[ temp ] = !( results[ temp ] = elem );
                                            }
                                        }
                                    }

                                    // Add elements to results, through postFinder if defined
                                } else {
                                    matcherOut = condense(
                                        matcherOut === results ?
                                            matcherOut.splice( preexisting, matcherOut.length ) :
                                            matcherOut
                                    );
                                    if ( postFinder ) {
                                        postFinder( null, results, matcherOut, xml );
                                    } else {
                                        push.apply( results, matcherOut );
                                    }
                                }
                            } );
                        }

                        function matcherFromTokens( tokens ) {
                            var checkContext, matcher, j,
                                len = tokens.length,
                                leadingRelative = Expr.relative[ tokens[ 0 ].type ],
                                implicitRelative = leadingRelative || Expr.relative[ " " ],
                                i = leadingRelative ? 1 : 0,

                                // The foundational matcher ensures that elements are reachable from top-level context(s)
                                matchContext = addCombinator( function( elem ) {
                                    return elem === checkContext;
                                }, implicitRelative, true ),
                                matchAnyContext = addCombinator( function( elem ) {
                                    return indexOf( checkContext, elem ) > -1;
                                }, implicitRelative, true ),
                                matchers = [ function( elem, context, xml ) {
                                    var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
                                        ( checkContext = context ).nodeType ?
                                            matchContext( elem, context, xml ) :
                                            matchAnyContext( elem, context, xml ) );

                                    // Avoid hanging onto element (issue #299)
                                    checkContext = null;
                                    return ret;
                                } ];

                            for ( ; i < len; i++ ) {
                                if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
                                    matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
                                } else {
                                    matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

                                    // Return special upon seeing a positional matcher
                                    if ( matcher[ expando ] ) {

                                        // Find the next relative operator (if any) for proper handling
                                        j = ++i;
                                        for ( ; j < len; j++ ) {
                                            if ( Expr.relative[ tokens[ j ].type ] ) {
                                                break;
                                            }
                                        }
                                        return setMatcher(
                                            i > 1 && elementMatcher( matchers ),
                                            i > 1 && toSelector(

                                                // If the preceding token was a descendant combinator, insert an implicit any-element `*`
                                                tokens
                                                    .slice( 0, i - 1 )
                                                    .concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
                                            ).replace( rtrim, "$1" ),
                                            matcher,
                                            i < j && matcherFromTokens( tokens.slice( i, j ) ),
                                            j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
                                            j < len && toSelector( tokens )
                                        );
                                    }
                                    matchers.push( matcher );
                                }
                            }

                            return elementMatcher( matchers );
                        }

                        function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
                            var bySet = setMatchers.length > 0,
                                byElement = elementMatchers.length > 0,
                                superMatcher = function( seed, context, xml, results, outermost ) {
                                    var elem, j, matcher,
                                        matchedCount = 0,
                                        i = "0",
                                        unmatched = seed && [],
                                        setMatched = [],
                                        contextBackup = outermostContext,

                                        // We must always have either seed elements or outermost context
                                        elems = seed || byElement && Expr.find[ "TAG" ]( "*", outermost ),

                                        // Use integer dirruns iff this is the outermost matcher
                                        dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
                                        len = elems.length;

                                    if ( outermost ) {

                                        // Support: IE 11+, Edge 17 - 18+
                                        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                        // two documents; shallow comparisons work.
                                        // eslint-disable-next-line eqeqeq
                                        outermostContext = context == document || context || outermost;
                                    }

                                    // Add elements passing elementMatchers directly to results
                                    // Support: IE<9, Safari
                                    // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                                    for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
                                        if ( byElement && elem ) {
                                            j = 0;

                                            // Support: IE 11+, Edge 17 - 18+
                                            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
                                            // two documents; shallow comparisons work.
                                            // eslint-disable-next-line eqeqeq
                                            if ( !context && elem.ownerDocument != document ) {
                                                setDocument( elem );
                                                xml = !documentIsHTML;
                                            }
                                            while ( ( matcher = elementMatchers[ j++ ] ) ) {
                                                if ( matcher( elem, context || document, xml ) ) {
                                                    results.push( elem );
                                                    break;
                                                }
                                            }
                                            if ( outermost ) {
                                                dirruns = dirrunsUnique;
                                            }
                                        }

                                        // Track unmatched elements for set filters
                                        if ( bySet ) {

                                            // They will have gone through all possible matchers
                                            if ( ( elem = !matcher && elem ) ) {
                                                matchedCount--;
                                            }

                                            // Lengthen the array for every element, matched or not
                                            if ( seed ) {
                                                unmatched.push( elem );
                                            }
                                        }
                                    }

                                    // `i` is now the count of elements visited above, and adding it to `matchedCount`
                                    // makes the latter nonnegative.
                                    matchedCount += i;

                                    // Apply set filters to unmatched elements
                                    // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                                    // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                                    // no element matchers and no seed.
                                    // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                                    // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                                    // numerically zero.
                                    if ( bySet && i !== matchedCount ) {
                                        j = 0;
                                        while ( ( matcher = setMatchers[ j++ ] ) ) {
                                            matcher( unmatched, setMatched, context, xml );
                                        }

                                        if ( seed ) {

                                            // Reintegrate element matches to eliminate the need for sorting
                                            if ( matchedCount > 0 ) {
                                                while ( i-- ) {
                                                    if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
                                                        setMatched[ i ] = pop.call( results );
                                                    }
                                                }
                                            }

                                            // Discard index placeholder values to get only actual matches
                                            setMatched = condense( setMatched );
                                        }

                                        // Add matches to results
                                        push.apply( results, setMatched );

                                        // Seedless set matches succeeding multiple successful matchers stipulate sorting
                                        if ( outermost && !seed && setMatched.length > 0 &&
                                            ( matchedCount + setMatchers.length ) > 1 ) {

                                            Sizzle.uniqueSort( results );
                                        }
                                    }

                                    // Override manipulation of globals by nested matchers
                                    if ( outermost ) {
                                        dirruns = dirrunsUnique;
                                        outermostContext = contextBackup;
                                    }

                                    return unmatched;
                                };

                            return bySet ?
                                markFunction( superMatcher ) :
                                superMatcher;
                        }

                        compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
                            var i,
                                setMatchers = [],
                                elementMatchers = [],
                                cached = compilerCache[ selector + " " ];

                            if ( !cached ) {

                                // Generate a function of recursive functions that can be used to check each element
                                if ( !match ) {
                                    match = tokenize( selector );
                                }
                                i = match.length;
                                while ( i-- ) {
                                    cached = matcherFromTokens( match[ i ] );
                                    if ( cached[ expando ] ) {
                                        setMatchers.push( cached );
                                    } else {
                                        elementMatchers.push( cached );
                                    }
                                }

                                // Cache the compiled function
                                cached = compilerCache(
                                    selector,
                                    matcherFromGroupMatchers( elementMatchers, setMatchers )
                                );

                                // Save selector and tokenization
                                cached.selector = selector;
                            }
                            return cached;
                        };

                        /**
                         * A low-level selection function that works with Sizzle's compiled
                         *  selector functions
                         * @param {String|Function} selector A selector or a pre-compiled
                         *  selector function built with Sizzle.compile
                         * @param {Element} context
                         * @param {Array} [results]
                         * @param {Array} [seed] A set of elements to match against
                         */
                        select = Sizzle.select = function( selector, context, results, seed ) {
                            var i, tokens, token, type, find,
                                compiled = typeof selector === "function" && selector,
                                match = !seed && tokenize( ( selector = compiled.selector || selector ) );

                            results = results || [];

                            // Try to minimize operations if there is only one selector in the list and no seed
                            // (the latter of which guarantees us context)
                            if ( match.length === 1 ) {

                                // Reduce context if the leading compound selector is an ID
                                tokens = match[ 0 ] = match[ 0 ].slice( 0 );
                                if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
                                    context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

                                    context = ( Expr.find[ "ID" ]( token.matches[ 0 ]
                                        .replace( runescape, funescape ), context ) || [] )[ 0 ];
                                    if ( !context ) {
                                        return results;

                                        // Precompiled matchers will still verify ancestry, so step up a level
                                    } else if ( compiled ) {
                                        context = context.parentNode;
                                    }

                                    selector = selector.slice( tokens.shift().value.length );
                                }

                                // Fetch a seed set for right-to-left matching
                                i = matchExpr[ "needsContext" ].test( selector ) ? 0 : tokens.length;
                                while ( i-- ) {
                                    token = tokens[ i ];

                                    // Abort if we hit a combinator
                                    if ( Expr.relative[ ( type = token.type ) ] ) {
                                        break;
                                    }
                                    if ( ( find = Expr.find[ type ] ) ) {

                                        // Search, expanding context for leading sibling combinators
                                        if ( ( seed = find(
                                            token.matches[ 0 ].replace( runescape, funescape ),
                                            rsibling.test( tokens[ 0 ].type ) && testContext( context.parentNode ) ||
                                            context
                                        ) ) ) {

                                            // If seed is empty or no tokens remain, we can return early
                                            tokens.splice( i, 1 );
                                            selector = seed.length && toSelector( tokens );
                                            if ( !selector ) {
                                                push.apply( results, seed );
                                                return results;
                                            }

                                            break;
                                        }
                                    }
                                }
                            }

                            // Compile and execute a filtering function if one is not provided
                            // Provide `match` to avoid retokenization if we modified the selector above
                            ( compiled || compile( selector, match ) )(
                                seed,
                                context,
                                !documentIsHTML,
                                results,
                                !context || rsibling.test( selector ) && testContext( context.parentNode ) || context
                            );
                            return results;
                        };

// One-time assignments

// Sort stability
                        support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
                        support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
                        setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
                        support.sortDetached = assert( function( el ) {

                            // Should return 1, but returns 4 (following)
                            return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
                        } );

// Support: IE<8
// Prevent attribute/property "interpolation"
// https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
                        if ( !assert( function( el ) {
                            el.innerHTML = "<a href='#'></a>";
                            return el.firstChild.getAttribute( "href" ) === "#";
                        } ) ) {
                            addHandle( "type|href|height|width", function( elem, name, isXML ) {
                                if ( !isXML ) {
                                    return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
                                }
                            } );
                        }

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
                        if ( !support.attributes || !assert( function( el ) {
                            el.innerHTML = "<input/>";
                            el.firstChild.setAttribute( "value", "" );
                            return el.firstChild.getAttribute( "value" ) === "";
                        } ) ) {
                            addHandle( "value", function( elem, _name, isXML ) {
                                if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
                                    return elem.defaultValue;
                                }
                            } );
                        }

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
                        if ( !assert( function( el ) {
                            return el.getAttribute( "disabled" ) == null;
                        } ) ) {
                            addHandle( booleans, function( elem, name, isXML ) {
                                var val;
                                if ( !isXML ) {
                                    return elem[ name ] === true ? name.toLowerCase() :
                                        ( val = elem.getAttributeNode( name ) ) && val.specified ?
                                            val.value :
                                            null;
                                }
                            } );
                        }

                        return Sizzle;

                    } )( window );



                jQuery.find = Sizzle;
                jQuery.expr = Sizzle.selectors;

// Deprecated
                jQuery.expr[ ":" ] = jQuery.expr.pseudos;
                jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
                jQuery.text = Sizzle.getText;
                jQuery.isXMLDoc = Sizzle.isXML;
                jQuery.contains = Sizzle.contains;
                jQuery.escapeSelector = Sizzle.escape;




                var dir = function( elem, dir, until ) {
                    var matched = [],
                        truncate = until !== undefined;

                    while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
                        if ( elem.nodeType === 1 ) {
                            if ( truncate && jQuery( elem ).is( until ) ) {
                                break;
                            }
                            matched.push( elem );
                        }
                    }
                    return matched;
                };


                var siblings = function( n, elem ) {
                    var matched = [];

                    for ( ; n; n = n.nextSibling ) {
                        if ( n.nodeType === 1 && n !== elem ) {
                            matched.push( n );
                        }
                    }

                    return matched;
                };


                var rneedsContext = jQuery.expr.match.needsContext;



                function nodeName( elem, name ) {

                    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

                }
                var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
                function winnow( elements, qualifier, not ) {
                    if ( isFunction( qualifier ) ) {
                        return jQuery.grep( elements, function( elem, i ) {
                            return !!qualifier.call( elem, i, elem ) !== not;
                        } );
                    }

                    // Single element
                    if ( qualifier.nodeType ) {
                        return jQuery.grep( elements, function( elem ) {
                            return ( elem === qualifier ) !== not;
                        } );
                    }

                    // Arraylike of elements (jQuery, arguments, Array)
                    if ( typeof qualifier !== "string" ) {
                        return jQuery.grep( elements, function( elem ) {
                            return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
                        } );
                    }

                    // Filtered directly for both simple and complex selectors
                    return jQuery.filter( qualifier, elements, not );
                }

                jQuery.filter = function( expr, elems, not ) {
                    var elem = elems[ 0 ];

                    if ( not ) {
                        expr = ":not(" + expr + ")";
                    }

                    if ( elems.length === 1 && elem.nodeType === 1 ) {
                        return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
                    }

                    return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
                        return elem.nodeType === 1;
                    } ) );
                };

                jQuery.fn.extend( {
                    find: function( selector ) {
                        var i, ret,
                            len = this.length,
                            self = this;

                        if ( typeof selector !== "string" ) {
                            return this.pushStack( jQuery( selector ).filter( function() {
                                for ( i = 0; i < len; i++ ) {
                                    if ( jQuery.contains( self[ i ], this ) ) {
                                        return true;
                                    }
                                }
                            } ) );
                        }

                        ret = this.pushStack( [] );

                        for ( i = 0; i < len; i++ ) {
                            jQuery.find( selector, self[ i ], ret );
                        }

                        return len > 1 ? jQuery.uniqueSort( ret ) : ret;
                    },
                    filter: function( selector ) {
                        return this.pushStack( winnow( this, selector || [], false ) );
                    },
                    not: function( selector ) {
                        return this.pushStack( winnow( this, selector || [], true ) );
                    },
                    is: function( selector ) {
                        return !!winnow(
                            this,

                            // If this is a positional/relative selector, check membership in the returned set
                            // so $("p:first").is("p:last") won't return true for a doc with two "p".
                            typeof selector === "string" && rneedsContext.test( selector ) ?
                                jQuery( selector ) :
                                selector || [],
                            false
                        ).length;
                    }
                } );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
                var rootjQuery,

                    // A simple way to check for HTML strings
                    // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
                    // Strict HTML recognition (#11290: must start with <)
                    // Shortcut simple #id case for speed
                    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

                    init = jQuery.fn.init = function( selector, context, root ) {
                        var match, elem;

                        // HANDLE: $(""), $(null), $(undefined), $(false)
                        if ( !selector ) {
                            return this;
                        }

                        // Method init() accepts an alternate rootjQuery
                        // so migrate can support jQuery.sub (gh-2101)
                        root = root || rootjQuery;

                        // Handle HTML strings
                        if ( typeof selector === "string" ) {
                            if ( selector[ 0 ] === "<" &&
                                selector[ selector.length - 1 ] === ">" &&
                                selector.length >= 3 ) {

                                // Assume that strings that start and end with <> are HTML and skip the regex check
                                match = [ null, selector, null ];

                            } else {
                                match = rquickExpr.exec( selector );
                            }

                            // Match html or make sure no context is specified for #id
                            if ( match && ( match[ 1 ] || !context ) ) {

                                // HANDLE: $(html) -> $(array)
                                if ( match[ 1 ] ) {
                                    context = context instanceof jQuery ? context[ 0 ] : context;

                                    // Option to run scripts is true for back-compat
                                    // Intentionally let the error be thrown if parseHTML is not present
                                    jQuery.merge( this, jQuery.parseHTML(
                                        match[ 1 ],
                                        context && context.nodeType ? context.ownerDocument || context : document,
                                        true
                                    ) );

                                    // HANDLE: $(html, props)
                                    if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
                                        for ( match in context ) {

                                            // Properties of context are called as methods if possible
                                            if ( isFunction( this[ match ] ) ) {
                                                this[ match ]( context[ match ] );

                                                // ...and otherwise set as attributes
                                            } else {
                                                this.attr( match, context[ match ] );
                                            }
                                        }
                                    }

                                    return this;

                                    // HANDLE: $(#id)
                                } else {
                                    elem = document.getElementById( match[ 2 ] );

                                    if ( elem ) {

                                        // Inject the element directly into the jQuery object
                                        this[ 0 ] = elem;
                                        this.length = 1;
                                    }
                                    return this;
                                }

                                // HANDLE: $(expr, $(...))
                            } else if ( !context || context.jquery ) {
                                return ( context || root ).find( selector );

                                // HANDLE: $(expr, context)
                                // (which is just equivalent to: $(context).find(expr)
                            } else {
                                return this.constructor( context ).find( selector );
                            }

                            // HANDLE: $(DOMElement)
                        } else if ( selector.nodeType ) {
                            this[ 0 ] = selector;
                            this.length = 1;
                            return this;

                            // HANDLE: $(function)
                            // Shortcut for document ready
                        } else if ( isFunction( selector ) ) {
                            return root.ready !== undefined ?
                                root.ready( selector ) :

                                // Execute immediately if ready is not present
                                selector( jQuery );
                        }

                        return jQuery.makeArray( selector, this );
                    };

// Give the init function the jQuery prototype for later instantiation
                init.prototype = jQuery.fn;

// Initialize central reference
                rootjQuery = jQuery( document );


                var rparentsprev = /^(?:parents|prev(?:Until|All))/,

                    // Methods guaranteed to produce a unique set when starting from a unique set
                    guaranteedUnique = {
                        children: true,
                        contents: true,
                        next: true,
                        prev: true
                    };

                jQuery.fn.extend( {
                    has: function( target ) {
                        var targets = jQuery( target, this ),
                            l = targets.length;

                        return this.filter( function() {
                            var i = 0;
                            for ( ; i < l; i++ ) {
                                if ( jQuery.contains( this, targets[ i ] ) ) {
                                    return true;
                                }
                            }
                        } );
                    },

                    closest: function( selectors, context ) {
                        var cur,
                            i = 0,
                            l = this.length,
                            matched = [],
                            targets = typeof selectors !== "string" && jQuery( selectors );

                        // Positional selectors never match, since there's no _selection_ context
                        if ( !rneedsContext.test( selectors ) ) {
                            for ( ; i < l; i++ ) {
                                for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

                                    // Always skip document fragments
                                    if ( cur.nodeType < 11 && ( targets ?
                                        targets.index( cur ) > -1 :

                                        // Don't pass non-elements to Sizzle
                                        cur.nodeType === 1 &&
                                        jQuery.find.matchesSelector( cur, selectors ) ) ) {

                                        matched.push( cur );
                                        break;
                                    }
                                }
                            }
                        }

                        return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
                    },

                    // Determine the position of an element within the set
                    index: function( elem ) {

                        // No argument, return index in parent
                        if ( !elem ) {
                            return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
                        }

                        // Index in selector
                        if ( typeof elem === "string" ) {
                            return indexOf.call( jQuery( elem ), this[ 0 ] );
                        }

                        // Locate the position of the desired element
                        return indexOf.call( this,

                            // If it receives a jQuery object, the first element is used
                            elem.jquery ? elem[ 0 ] : elem
                        );
                    },

                    add: function( selector, context ) {
                        return this.pushStack(
                            jQuery.uniqueSort(
                                jQuery.merge( this.get(), jQuery( selector, context ) )
                            )
                        );
                    },

                    addBack: function( selector ) {
                        return this.add( selector == null ?
                            this.prevObject : this.prevObject.filter( selector )
                        );
                    }
                } );

                function sibling( cur, dir ) {
                    while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
                    return cur;
                }

                jQuery.each( {
                    parent: function( elem ) {
                        var parent = elem.parentNode;
                        return parent && parent.nodeType !== 11 ? parent : null;
                    },
                    parents: function( elem ) {
                        return dir( elem, "parentNode" );
                    },
                    parentsUntil: function( elem, _i, until ) {
                        return dir( elem, "parentNode", until );
                    },
                    next: function( elem ) {
                        return sibling( elem, "nextSibling" );
                    },
                    prev: function( elem ) {
                        return sibling( elem, "previousSibling" );
                    },
                    nextAll: function( elem ) {
                        return dir( elem, "nextSibling" );
                    },
                    prevAll: function( elem ) {
                        return dir( elem, "previousSibling" );
                    },
                    nextUntil: function( elem, _i, until ) {
                        return dir( elem, "nextSibling", until );
                    },
                    prevUntil: function( elem, _i, until ) {
                        return dir( elem, "previousSibling", until );
                    },
                    siblings: function( elem ) {
                        return siblings( ( elem.parentNode || {} ).firstChild, elem );
                    },
                    children: function( elem ) {
                        return siblings( elem.firstChild );
                    },
                    contents: function( elem ) {
                        if ( elem.contentDocument != null &&

                            // Support: IE 11+
                            // <object> elements with no `data` attribute has an object
                            // `contentDocument` with a `null` prototype.
                            getProto( elem.contentDocument ) ) {

                            return elem.contentDocument;
                        }

                        // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
                        // Treat the template element as a regular one in browsers that
                        // don't support it.
                        if ( nodeName( elem, "template" ) ) {
                            elem = elem.content || elem;
                        }

                        return jQuery.merge( [], elem.childNodes );
                    }
                }, function( name, fn ) {
                    jQuery.fn[ name ] = function( until, selector ) {
                        var matched = jQuery.map( this, fn, until );

                        if ( name.slice( -5 ) !== "Until" ) {
                            selector = until;
                        }

                        if ( selector && typeof selector === "string" ) {
                            matched = jQuery.filter( selector, matched );
                        }

                        if ( this.length > 1 ) {

                            // Remove duplicates
                            if ( !guaranteedUnique[ name ] ) {
                                jQuery.uniqueSort( matched );
                            }

                            // Reverse order for parents* and prev-derivatives
                            if ( rparentsprev.test( name ) ) {
                                matched.reverse();
                            }
                        }

                        return this.pushStack( matched );
                    };
                } );
                var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
                function createOptions( options ) {
                    var object = {};
                    jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
                        object[ flag ] = true;
                    } );
                    return object;
                }

                /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
                jQuery.Callbacks = function( options ) {

                    // Convert options from String-formatted to Object-formatted if needed
                    // (we check in cache first)
                    options = typeof options === "string" ?
                        createOptions( options ) :
                        jQuery.extend( {}, options );

                    var // Flag to know if list is currently firing
                        firing,

                        // Last fire value for non-forgettable lists
                        memory,

                        // Flag to know if list was already fired
                        fired,

                        // Flag to prevent firing
                        locked,

                        // Actual callback list
                        list = [],

                        // Queue of execution data for repeatable lists
                        queue = [],

                        // Index of currently firing callback (modified by add/remove as needed)
                        firingIndex = -1,

                        // Fire callbacks
                        fire = function() {

                            // Enforce single-firing
                            locked = locked || options.once;

                            // Execute callbacks for all pending executions,
                            // respecting firingIndex overrides and runtime changes
                            fired = firing = true;
                            for ( ; queue.length; firingIndex = -1 ) {
                                memory = queue.shift();
                                while ( ++firingIndex < list.length ) {

                                    // Run callback and check for early termination
                                    if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
                                        options.stopOnFalse ) {

                                        // Jump to end and forget the data so .add doesn't re-fire
                                        firingIndex = list.length;
                                        memory = false;
                                    }
                                }
                            }

                            // Forget the data if we're done with it
                            if ( !options.memory ) {
                                memory = false;
                            }

                            firing = false;

                            // Clean up if we're done firing for good
                            if ( locked ) {

                                // Keep an empty list if we have data for future add calls
                                if ( memory ) {
                                    list = [];

                                    // Otherwise, this object is spent
                                } else {
                                    list = "";
                                }
                            }
                        },

                        // Actual Callbacks object
                        self = {

                            // Add a callback or a collection of callbacks to the list
                            add: function() {
                                if ( list ) {

                                    // If we have memory from a past run, we should fire after adding
                                    if ( memory && !firing ) {
                                        firingIndex = list.length - 1;
                                        queue.push( memory );
                                    }

                                    ( function add( args ) {
                                        jQuery.each( args, function( _, arg ) {
                                            if ( isFunction( arg ) ) {
                                                if ( !options.unique || !self.has( arg ) ) {
                                                    list.push( arg );
                                                }
                                            } else if ( arg && arg.length && toType( arg ) !== "string" ) {

                                                // Inspect recursively
                                                add( arg );
                                            }
                                        } );
                                    } )( arguments );

                                    if ( memory && !firing ) {
                                        fire();
                                    }
                                }
                                return this;
                            },

                            // Remove a callback from the list
                            remove: function() {
                                jQuery.each( arguments, function( _, arg ) {
                                    var index;
                                    while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
                                        list.splice( index, 1 );

                                        // Handle firing indexes
                                        if ( index <= firingIndex ) {
                                            firingIndex--;
                                        }
                                    }
                                } );
                                return this;
                            },

                            // Check if a given callback is in the list.
                            // If no argument is given, return whether or not list has callbacks attached.
                            has: function( fn ) {
                                return fn ?
                                    jQuery.inArray( fn, list ) > -1 :
                                    list.length > 0;
                            },

                            // Remove all callbacks from the list
                            empty: function() {
                                if ( list ) {
                                    list = [];
                                }
                                return this;
                            },

                            // Disable .fire and .add
                            // Abort any current/pending executions
                            // Clear all callbacks and values
                            disable: function() {
                                locked = queue = [];
                                list = memory = "";
                                return this;
                            },
                            disabled: function() {
                                return !list;
                            },

                            // Disable .fire
                            // Also disable .add unless we have memory (since it would have no effect)
                            // Abort any pending executions
                            lock: function() {
                                locked = queue = [];
                                if ( !memory && !firing ) {
                                    list = memory = "";
                                }
                                return this;
                            },
                            locked: function() {
                                return !!locked;
                            },

                            // Call all callbacks with the given context and arguments
                            fireWith: function( context, args ) {
                                if ( !locked ) {
                                    args = args || [];
                                    args = [ context, args.slice ? args.slice() : args ];
                                    queue.push( args );
                                    if ( !firing ) {
                                        fire();
                                    }
                                }
                                return this;
                            },

                            // Call all the callbacks with the given arguments
                            fire: function() {
                                self.fireWith( this, arguments );
                                return this;
                            },

                            // To know if the callbacks have already been called at least once
                            fired: function() {
                                return !!fired;
                            }
                        };

                    return self;
                };


                function Identity( v ) {
                    return v;
                }
                function Thrower( ex ) {
                    throw ex;
                }

                function adoptValue( value, resolve, reject, noValue ) {
                    var method;

                    try {

                        // Check for promise aspect first to privilege synchronous behavior
                        if ( value && isFunction( ( method = value.promise ) ) ) {
                            method.call( value ).done( resolve ).fail( reject );

                            // Other thenables
                        } else if ( value && isFunction( ( method = value.then ) ) ) {
                            method.call( value, resolve, reject );

                            // Other non-thenables
                        } else {

                            // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
                            // * false: [ value ].slice( 0 ) => resolve( value )
                            // * true: [ value ].slice( 1 ) => resolve()
                            resolve.apply( undefined, [ value ].slice( noValue ) );
                        }

                        // For Promises/A+, convert exceptions into rejections
                        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
                        // Deferred#then to conditionally suppress rejection.
                    } catch ( value ) {

                        // Support: Android 4.0 only
                        // Strict mode functions invoked without .call/.apply get global-object context
                        reject.apply( undefined, [ value ] );
                    }
                }

                jQuery.extend( {

                    Deferred: function( func ) {
                        var tuples = [

                                // action, add listener, callbacks,
                                // ... .then handlers, argument index, [final state]
                                [ "notify", "progress", jQuery.Callbacks( "memory" ),
                                    jQuery.Callbacks( "memory" ), 2 ],
                                [ "resolve", "done", jQuery.Callbacks( "once memory" ),
                                    jQuery.Callbacks( "once memory" ), 0, "resolved" ],
                                [ "reject", "fail", jQuery.Callbacks( "once memory" ),
                                    jQuery.Callbacks( "once memory" ), 1, "rejected" ]
                            ],
                            state = "pending",
                            promise = {
                                state: function() {
                                    return state;
                                },
                                always: function() {
                                    deferred.done( arguments ).fail( arguments );
                                    return this;
                                },
                                "catch": function( fn ) {
                                    return promise.then( null, fn );
                                },

                                // Keep pipe for back-compat
                                pipe: function( /* fnDone, fnFail, fnProgress */ ) {
                                    var fns = arguments;

                                    return jQuery.Deferred( function( newDefer ) {
                                        jQuery.each( tuples, function( _i, tuple ) {

                                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                                            var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

                                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                                            deferred[ tuple[ 1 ] ]( function() {
                                                var returned = fn && fn.apply( this, arguments );
                                                if ( returned && isFunction( returned.promise ) ) {
                                                    returned.promise()
                                                        .progress( newDefer.notify )
                                                        .done( newDefer.resolve )
                                                        .fail( newDefer.reject );
                                                } else {
                                                    newDefer[ tuple[ 0 ] + "With" ](
                                                        this,
                                                        fn ? [ returned ] : arguments
                                                    );
                                                }
                                            } );
                                        } );
                                        fns = null;
                                    } ).promise();
                                },
                                then: function( onFulfilled, onRejected, onProgress ) {
                                    var maxDepth = 0;
                                    function resolve( depth, deferred, handler, special ) {
                                        return function() {
                                            var that = this,
                                                args = arguments,
                                                mightThrow = function() {
                                                    var returned, then;

                                                    // Support: Promises/A+ section 2.3.3.3.3
                                                    // https://promisesaplus.com/#point-59
                                                    // Ignore double-resolution attempts
                                                    if ( depth < maxDepth ) {
                                                        return;
                                                    }

                                                    returned = handler.apply( that, args );

                                                    // Support: Promises/A+ section 2.3.1
                                                    // https://promisesaplus.com/#point-48
                                                    if ( returned === deferred.promise() ) {
                                                        throw new TypeError( "Thenable self-resolution" );
                                                    }

                                                    // Support: Promises/A+ sections 2.3.3.1, 3.5
                                                    // https://promisesaplus.com/#point-54
                                                    // https://promisesaplus.com/#point-75
                                                    // Retrieve `then` only once
                                                    then = returned &&

                                                        // Support: Promises/A+ section 2.3.4
                                                        // https://promisesaplus.com/#point-64
                                                        // Only check objects and functions for thenability
                                                        ( typeof returned === "object" ||
                                                            typeof returned === "function" ) &&
                                                        returned.then;

                                                    // Handle a returned thenable
                                                    if ( isFunction( then ) ) {

                                                        // Special processors (notify) just wait for resolution
                                                        if ( special ) {
                                                            then.call(
                                                                returned,
                                                                resolve( maxDepth, deferred, Identity, special ),
                                                                resolve( maxDepth, deferred, Thrower, special )
                                                            );

                                                            // Normal processors (resolve) also hook into progress
                                                        } else {

                                                            // ...and disregard older resolution values
                                                            maxDepth++;

                                                            then.call(
                                                                returned,
                                                                resolve( maxDepth, deferred, Identity, special ),
                                                                resolve( maxDepth, deferred, Thrower, special ),
                                                                resolve( maxDepth, deferred, Identity,
                                                                    deferred.notifyWith )
                                                            );
                                                        }

                                                        // Handle all other returned values
                                                    } else {

                                                        // Only substitute handlers pass on context
                                                        // and multiple values (non-spec behavior)
                                                        if ( handler !== Identity ) {
                                                            that = undefined;
                                                            args = [ returned ];
                                                        }

                                                        // Process the value(s)
                                                        // Default process is resolve
                                                        ( special || deferred.resolveWith )( that, args );
                                                    }
                                                },

                                                // Only normal processors (resolve) catch and reject exceptions
                                                process = special ?
                                                    mightThrow :
                                                    function() {
                                                        try {
                                                            mightThrow();
                                                        } catch ( e ) {

                                                            if ( jQuery.Deferred.exceptionHook ) {
                                                                jQuery.Deferred.exceptionHook( e,
                                                                    process.stackTrace );
                                                            }

                                                            // Support: Promises/A+ section 2.3.3.3.4.1
                                                            // https://promisesaplus.com/#point-61
                                                            // Ignore post-resolution exceptions
                                                            if ( depth + 1 >= maxDepth ) {

                                                                // Only substitute handlers pass on context
                                                                // and multiple values (non-spec behavior)
                                                                if ( handler !== Thrower ) {
                                                                    that = undefined;
                                                                    args = [ e ];
                                                                }

                                                                deferred.rejectWith( that, args );
                                                            }
                                                        }
                                                    };

                                            // Support: Promises/A+ section 2.3.3.3.1
                                            // https://promisesaplus.com/#point-57
                                            // Re-resolve promises immediately to dodge false rejection from
                                            // subsequent errors
                                            if ( depth ) {
                                                process();
                                            } else {

                                                // Call an optional hook to record the stack, in case of exception
                                                // since it's otherwise lost when execution goes async
                                                if ( jQuery.Deferred.getStackHook ) {
                                                    process.stackTrace = jQuery.Deferred.getStackHook();
                                                }
                                                window.setTimeout( process );
                                            }
                                        };
                                    }

                                    return jQuery.Deferred( function( newDefer ) {

                                        // progress_handlers.add( ... )
                                        tuples[ 0 ][ 3 ].add(
                                            resolve(
                                                0,
                                                newDefer,
                                                isFunction( onProgress ) ?
                                                    onProgress :
                                                    Identity,
                                                newDefer.notifyWith
                                            )
                                        );

                                        // fulfilled_handlers.add( ... )
                                        tuples[ 1 ][ 3 ].add(
                                            resolve(
                                                0,
                                                newDefer,
                                                isFunction( onFulfilled ) ?
                                                    onFulfilled :
                                                    Identity
                                            )
                                        );

                                        // rejected_handlers.add( ... )
                                        tuples[ 2 ][ 3 ].add(
                                            resolve(
                                                0,
                                                newDefer,
                                                isFunction( onRejected ) ?
                                                    onRejected :
                                                    Thrower
                                            )
                                        );
                                    } ).promise();
                                },

                                // Get a promise for this deferred
                                // If obj is provided, the promise aspect is added to the object
                                promise: function( obj ) {
                                    return obj != null ? jQuery.extend( obj, promise ) : promise;
                                }
                            },
                            deferred = {};

                        // Add list-specific methods
                        jQuery.each( tuples, function( i, tuple ) {
                            var list = tuple[ 2 ],
                                stateString = tuple[ 5 ];

                            // promise.progress = list.add
                            // promise.done = list.add
                            // promise.fail = list.add
                            promise[ tuple[ 1 ] ] = list.add;

                            // Handle state
                            if ( stateString ) {
                                list.add(
                                    function() {

                                        // state = "resolved" (i.e., fulfilled)
                                        // state = "rejected"
                                        state = stateString;
                                    },

                                    // rejected_callbacks.disable
                                    // fulfilled_callbacks.disable
                                    tuples[ 3 - i ][ 2 ].disable,

                                    // rejected_handlers.disable
                                    // fulfilled_handlers.disable
                                    tuples[ 3 - i ][ 3 ].disable,

                                    // progress_callbacks.lock
                                    tuples[ 0 ][ 2 ].lock,

                                    // progress_handlers.lock
                                    tuples[ 0 ][ 3 ].lock
                                );
                            }

                            // progress_handlers.fire
                            // fulfilled_handlers.fire
                            // rejected_handlers.fire
                            list.add( tuple[ 3 ].fire );

                            // deferred.notify = function() { deferred.notifyWith(...) }
                            // deferred.resolve = function() { deferred.resolveWith(...) }
                            // deferred.reject = function() { deferred.rejectWith(...) }
                            deferred[ tuple[ 0 ] ] = function() {
                                deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
                                return this;
                            };

                            // deferred.notifyWith = list.fireWith
                            // deferred.resolveWith = list.fireWith
                            // deferred.rejectWith = list.fireWith
                            deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
                        } );

                        // Make the deferred a promise
                        promise.promise( deferred );

                        // Call given func if any
                        if ( func ) {
                            func.call( deferred, deferred );
                        }

                        // All done!
                        return deferred;
                    },

                    // Deferred helper
                    when: function( singleValue ) {
                        var

                            // count of uncompleted subordinates
                            remaining = arguments.length,

                            // count of unprocessed arguments
                            i = remaining,

                            // subordinate fulfillment data
                            resolveContexts = Array( i ),
                            resolveValues = slice.call( arguments ),

                            // the primary Deferred
                            primary = jQuery.Deferred(),

                            // subordinate callback factory
                            updateFunc = function( i ) {
                                return function( value ) {
                                    resolveContexts[ i ] = this;
                                    resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
                                    if ( !( --remaining ) ) {
                                        primary.resolveWith( resolveContexts, resolveValues );
                                    }
                                };
                            };

                        // Single- and empty arguments are adopted like Promise.resolve
                        if ( remaining <= 1 ) {
                            adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
                                !remaining );

                            // Use .then() to unwrap secondary thenables (cf. gh-3000)
                            if ( primary.state() === "pending" ||
                                isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

                                return primary.then();
                            }
                        }

                        // Multiple arguments are aggregated like Promise.all array elements
                        while ( i-- ) {
                            adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
                        }

                        return primary.promise();
                    }
                } );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
                var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

                jQuery.Deferred.exceptionHook = function( error, stack ) {

                    // Support: IE 8 - 9 only
                    // Console exists when dev tools are open, which can happen at any time
                    if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
                        window.console.warn( "jQuery.Deferred exception: " + error.message, error.stack, stack );
                    }
                };




                jQuery.readyException = function( error ) {
                    window.setTimeout( function() {
                        throw error;
                    } );
                };




// The deferred used on DOM ready
                var readyList = jQuery.Deferred();

                jQuery.fn.ready = function( fn ) {

                    readyList
                        .then( fn )

                        // Wrap jQuery.readyException in a function so that the lookup
                        // happens at the time of error handling instead of callback
                        // registration.
                        .catch( function( error ) {
                            jQuery.readyException( error );
                        } );

                    return this;
                };

                jQuery.extend( {

                    // Is the DOM ready to be used? Set to true once it occurs.
                    isReady: false,

                    // A counter to track how many items to wait for before
                    // the ready event fires. See #6781
                    readyWait: 1,

                    // Handle when the DOM is ready
                    ready: function( wait ) {

                        // Abort if there are pending holds or we're already ready
                        if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
                            return;
                        }

                        // Remember that the DOM is ready
                        jQuery.isReady = true;

                        // If a normal DOM Ready event fired, decrement, and wait if need be
                        if ( wait !== true && --jQuery.readyWait > 0 ) {
                            return;
                        }

                        // If there are functions bound, to execute
                        readyList.resolveWith( document, [ jQuery ] );
                    }
                } );

                jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
                function completed() {
                    document.removeEventListener( "DOMContentLoaded", completed );
                    window.removeEventListener( "load", completed );
                    jQuery.ready();
                }

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
                if ( document.readyState === "complete" ||
                    ( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

                    // Handle it asynchronously to allow scripts the opportunity to delay ready
                    window.setTimeout( jQuery.ready );

                } else {

                    // Use the handy event callback
                    document.addEventListener( "DOMContentLoaded", completed );

                    // A fallback to window.onload, that will always work
                    window.addEventListener( "load", completed );
                }




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
                var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
                    var i = 0,
                        len = elems.length,
                        bulk = key == null;

                    // Sets many values
                    if ( toType( key ) === "object" ) {
                        chainable = true;
                        for ( i in key ) {
                            access( elems, fn, i, key[ i ], true, emptyGet, raw );
                        }

                        // Sets one value
                    } else if ( value !== undefined ) {
                        chainable = true;

                        if ( !isFunction( value ) ) {
                            raw = true;
                        }

                        if ( bulk ) {

                            // Bulk operations run against the entire set
                            if ( raw ) {
                                fn.call( elems, value );
                                fn = null;

                                // ...except when executing function values
                            } else {
                                bulk = fn;
                                fn = function( elem, _key, value ) {
                                    return bulk.call( jQuery( elem ), value );
                                };
                            }
                        }

                        if ( fn ) {
                            for ( ; i < len; i++ ) {
                                fn(
                                    elems[ i ], key, raw ?
                                        value :
                                        value.call( elems[ i ], i, fn( elems[ i ], key ) )
                                );
                            }
                        }
                    }

                    if ( chainable ) {
                        return elems;
                    }

                    // Gets
                    if ( bulk ) {
                        return fn.call( elems );
                    }

                    return len ? fn( elems[ 0 ], key ) : emptyGet;
                };


// Matches dashed string for camelizing
                var rmsPrefix = /^-ms-/,
                    rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
                function fcamelCase( _all, letter ) {
                    return letter.toUpperCase();
                }

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (#9572)
                function camelCase( string ) {
                    return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
                }
                var acceptData = function( owner ) {

                    // Accepts only:
                    //  - Node
                    //    - Node.ELEMENT_NODE
                    //    - Node.DOCUMENT_NODE
                    //  - Object
                    //    - Any
                    return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
                };




                function Data() {
                    this.expando = jQuery.expando + Data.uid++;
                }

                Data.uid = 1;

                Data.prototype = {

                    cache: function( owner ) {

                        // Check if the owner object already has a cache
                        var value = owner[ this.expando ];

                        // If not, create one
                        if ( !value ) {
                            value = {};

                            // We can accept data for non-element nodes in modern browsers,
                            // but we should not, see #8335.
                            // Always return an empty object.
                            if ( acceptData( owner ) ) {

                                // If it is a node unlikely to be stringify-ed or looped over
                                // use plain assignment
                                if ( owner.nodeType ) {
                                    owner[ this.expando ] = value;

                                    // Otherwise secure it in a non-enumerable property
                                    // configurable must be true to allow the property to be
                                    // deleted when data is removed
                                } else {
                                    Object.defineProperty( owner, this.expando, {
                                        value: value,
                                        configurable: true
                                    } );
                                }
                            }
                        }

                        return value;
                    },
                    set: function( owner, data, value ) {
                        var prop,
                            cache = this.cache( owner );

                        // Handle: [ owner, key, value ] args
                        // Always use camelCase key (gh-2257)
                        if ( typeof data === "string" ) {
                            cache[ camelCase( data ) ] = value;

                            // Handle: [ owner, { properties } ] args
                        } else {

                            // Copy the properties one-by-one to the cache object
                            for ( prop in data ) {
                                cache[ camelCase( prop ) ] = data[ prop ];
                            }
                        }
                        return cache;
                    },
                    get: function( owner, key ) {
                        return key === undefined ?
                            this.cache( owner ) :

                            // Always use camelCase key (gh-2257)
                            owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
                    },
                    access: function( owner, key, value ) {

                        // In cases where either:
                        //
                        //   1. No key was specified
                        //   2. A string key was specified, but no value provided
                        //
                        // Take the "read" path and allow the get method to determine
                        // which value to return, respectively either:
                        //
                        //   1. The entire cache object
                        //   2. The data stored at the key
                        //
                        if ( key === undefined ||
                            ( ( key && typeof key === "string" ) && value === undefined ) ) {

                            return this.get( owner, key );
                        }

                        // When the key is not a string, or both a key and value
                        // are specified, set or extend (existing objects) with either:
                        //
                        //   1. An object of properties
                        //   2. A key and value
                        //
                        this.set( owner, key, value );

                        // Since the "set" path can have two possible entry points
                        // return the expected data based on which path was taken[*]
                        return value !== undefined ? value : key;
                    },
                    remove: function( owner, key ) {
                        var i,
                            cache = owner[ this.expando ];

                        if ( cache === undefined ) {
                            return;
                        }

                        if ( key !== undefined ) {

                            // Support array or space separated string of keys
                            if ( Array.isArray( key ) ) {

                                // If key is an array of keys...
                                // We always set camelCase keys, so remove that.
                                key = key.map( camelCase );
                            } else {
                                key = camelCase( key );

                                // If a key with the spaces exists, use it.
                                // Otherwise, create an array by matching non-whitespace
                                key = key in cache ?
                                    [ key ] :
                                    ( key.match( rnothtmlwhite ) || [] );
                            }

                            i = key.length;

                            while ( i-- ) {
                                delete cache[ key[ i ] ];
                            }
                        }

                        // Remove the expando if there's no more data
                        if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

                            // Support: Chrome <=35 - 45
                            // Webkit & Blink performance suffers when deleting properties
                            // from DOM nodes, so set to undefined instead
                            // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                            if ( owner.nodeType ) {
                                owner[ this.expando ] = undefined;
                            } else {
                                delete owner[ this.expando ];
                            }
                        }
                    },
                    hasData: function( owner ) {
                        var cache = owner[ this.expando ];
                        return cache !== undefined && !jQuery.isEmptyObject( cache );
                    }
                };
                var dataPriv = new Data();

                var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

                var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                    rmultiDash = /[A-Z]/g;

                function getData( data ) {
                    if ( data === "true" ) {
                        return true;
                    }

                    if ( data === "false" ) {
                        return false;
                    }

                    if ( data === "null" ) {
                        return null;
                    }

                    // Only convert to a number if it doesn't change the string
                    if ( data === +data + "" ) {
                        return +data;
                    }

                    if ( rbrace.test( data ) ) {
                        return JSON.parse( data );
                    }

                    return data;
                }

                function dataAttr( elem, key, data ) {
                    var name;

                    // If nothing was found internally, try to fetch any
                    // data from the HTML5 data-* attribute
                    if ( data === undefined && elem.nodeType === 1 ) {
                        name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
                        data = elem.getAttribute( name );

                        if ( typeof data === "string" ) {
                            try {
                                data = getData( data );
                            } catch ( e ) {}

                            // Make sure we set the data so it isn't changed later
                            dataUser.set( elem, key, data );
                        } else {
                            data = undefined;
                        }
                    }
                    return data;
                }

                jQuery.extend( {
                    hasData: function( elem ) {
                        return dataUser.hasData( elem ) || dataPriv.hasData( elem );
                    },

                    data: function( elem, name, data ) {
                        return dataUser.access( elem, name, data );
                    },

                    removeData: function( elem, name ) {
                        dataUser.remove( elem, name );
                    },

                    // TODO: Now that all calls to _data and _removeData have been replaced
                    // with direct calls to dataPriv methods, these can be deprecated.
                    _data: function( elem, name, data ) {
                        return dataPriv.access( elem, name, data );
                    },

                    _removeData: function( elem, name ) {
                        dataPriv.remove( elem, name );
                    }
                } );

                jQuery.fn.extend( {
                    data: function( key, value ) {
                        var i, name, data,
                            elem = this[ 0 ],
                            attrs = elem && elem.attributes;

                        // Gets all values
                        if ( key === undefined ) {
                            if ( this.length ) {
                                data = dataUser.get( elem );

                                if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
                                    i = attrs.length;
                                    while ( i-- ) {

                                        // Support: IE 11 only
                                        // The attrs elements can be null (#14894)
                                        if ( attrs[ i ] ) {
                                            name = attrs[ i ].name;
                                            if ( name.indexOf( "data-" ) === 0 ) {
                                                name = camelCase( name.slice( 5 ) );
                                                dataAttr( elem, name, data[ name ] );
                                            }
                                        }
                                    }
                                    dataPriv.set( elem, "hasDataAttrs", true );
                                }
                            }

                            return data;
                        }

                        // Sets multiple values
                        if ( typeof key === "object" ) {
                            return this.each( function() {
                                dataUser.set( this, key );
                            } );
                        }

                        return access( this, function( value ) {
                            var data;

                            // The calling jQuery object (element matches) is not empty
                            // (and therefore has an element appears at this[ 0 ]) and the
                            // `value` parameter was not undefined. An empty jQuery object
                            // will result in `undefined` for elem = this[ 0 ] which will
                            // throw an exception if an attempt to read a data cache is made.
                            if ( elem && value === undefined ) {

                                // Attempt to get data from the cache
                                // The key will always be camelCased in Data
                                data = dataUser.get( elem, key );
                                if ( data !== undefined ) {
                                    return data;
                                }

                                // Attempt to "discover" the data in
                                // HTML5 custom data-* attrs
                                data = dataAttr( elem, key );
                                if ( data !== undefined ) {
                                    return data;
                                }

                                // We tried really hard, but the data doesn't exist.
                                return;
                            }

                            // Set the data...
                            this.each( function() {

                                // We always store the camelCased key
                                dataUser.set( this, key, value );
                            } );
                        }, null, value, arguments.length > 1, null, true );
                    },

                    removeData: function( key ) {
                        return this.each( function() {
                            dataUser.remove( this, key );
                        } );
                    }
                } );


                jQuery.extend( {
                    queue: function( elem, type, data ) {
                        var queue;

                        if ( elem ) {
                            type = ( type || "fx" ) + "queue";
                            queue = dataPriv.get( elem, type );

                            // Speed up dequeue by getting out quickly if this is just a lookup
                            if ( data ) {
                                if ( !queue || Array.isArray( data ) ) {
                                    queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
                                } else {
                                    queue.push( data );
                                }
                            }
                            return queue || [];
                        }
                    },

                    dequeue: function( elem, type ) {
                        type = type || "fx";

                        var queue = jQuery.queue( elem, type ),
                            startLength = queue.length,
                            fn = queue.shift(),
                            hooks = jQuery._queueHooks( elem, type ),
                            next = function() {
                                jQuery.dequeue( elem, type );
                            };

                        // If the fx queue is dequeued, always remove the progress sentinel
                        if ( fn === "inprogress" ) {
                            fn = queue.shift();
                            startLength--;
                        }

                        if ( fn ) {

                            // Add a progress sentinel to prevent the fx queue from being
                            // automatically dequeued
                            if ( type === "fx" ) {
                                queue.unshift( "inprogress" );
                            }

                            // Clear up the last queue stop function
                            delete hooks.stop;
                            fn.call( elem, next, hooks );
                        }

                        if ( !startLength && hooks ) {
                            hooks.empty.fire();
                        }
                    },

                    // Not public - generate a queueHooks object, or return the current one
                    _queueHooks: function( elem, type ) {
                        var key = type + "queueHooks";
                        return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
                            empty: jQuery.Callbacks( "once memory" ).add( function() {
                                dataPriv.remove( elem, [ type + "queue", key ] );
                            } )
                        } );
                    }
                } );

                jQuery.fn.extend( {
                    queue: function( type, data ) {
                        var setter = 2;

                        if ( typeof type !== "string" ) {
                            data = type;
                            type = "fx";
                            setter--;
                        }

                        if ( arguments.length < setter ) {
                            return jQuery.queue( this[ 0 ], type );
                        }

                        return data === undefined ?
                            this :
                            this.each( function() {
                                var queue = jQuery.queue( this, type, data );

                                // Ensure a hooks for this queue
                                jQuery._queueHooks( this, type );

                                if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
                                    jQuery.dequeue( this, type );
                                }
                            } );
                    },
                    dequeue: function( type ) {
                        return this.each( function() {
                            jQuery.dequeue( this, type );
                        } );
                    },
                    clearQueue: function( type ) {
                        return this.queue( type || "fx", [] );
                    },

                    // Get a promise resolved when queues of a certain type
                    // are emptied (fx is the type by default)
                    promise: function( type, obj ) {
                        var tmp,
                            count = 1,
                            defer = jQuery.Deferred(),
                            elements = this,
                            i = this.length,
                            resolve = function() {
                                if ( !( --count ) ) {
                                    defer.resolveWith( elements, [ elements ] );
                                }
                            };

                        if ( typeof type !== "string" ) {
                            obj = type;
                            type = undefined;
                        }
                        type = type || "fx";

                        while ( i-- ) {
                            tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
                            if ( tmp && tmp.empty ) {
                                count++;
                                tmp.empty.add( resolve );
                            }
                        }
                        resolve();
                        return defer.promise( obj );
                    }
                } );
                var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

                var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


                var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

                var documentElement = document.documentElement;



                var isAttached = function( elem ) {
                        return jQuery.contains( elem.ownerDocument, elem );
                    },
                    composed = { composed: true };

                // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
                // Check attachment across shadow DOM boundaries when possible (gh-3504)
                // Support: iOS 10.0-10.2 only
                // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
                // leading to errors. We need to check for `getRootNode`.
                if ( documentElement.getRootNode ) {
                    isAttached = function( elem ) {
                        return jQuery.contains( elem.ownerDocument, elem ) ||
                            elem.getRootNode( composed ) === elem.ownerDocument;
                    };
                }
                var isHiddenWithinTree = function( elem, el ) {

                    // isHiddenWithinTree might be called from jQuery#filter function;
                    // in that case, element will be second argument
                    elem = el || elem;

                    // Inline style trumps all
                    return elem.style.display === "none" ||
                        elem.style.display === "" &&

                        // Otherwise, check computed style
                        // Support: Firefox <=43 - 45
                        // Disconnected elements can have computed display: none, so first confirm that elem is
                        // in the document.
                        isAttached( elem ) &&

                        jQuery.css( elem, "display" ) === "none";
                };



                function adjustCSS( elem, prop, valueParts, tween ) {
                    var adjusted, scale,
                        maxIterations = 20,
                        currentValue = tween ?
                            function() {
                                return tween.cur();
                            } :
                            function() {
                                return jQuery.css( elem, prop, "" );
                            },
                        initial = currentValue(),
                        unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

                        // Starting value computation is required for potential unit mismatches
                        initialInUnit = elem.nodeType &&
                            ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
                            rcssNum.exec( jQuery.css( elem, prop ) );

                    if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

                        // Support: Firefox <=54
                        // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
                        initial = initial / 2;

                        // Trust units reported by jQuery.css
                        unit = unit || initialInUnit[ 3 ];

                        // Iteratively approximate from a nonzero starting point
                        initialInUnit = +initial || 1;

                        while ( maxIterations-- ) {

                            // Evaluate and update our best guess (doubling guesses that zero out).
                            // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
                            jQuery.style( elem, prop, initialInUnit + unit );
                            if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
                                maxIterations = 0;
                            }
                            initialInUnit = initialInUnit / scale;

                        }

                        initialInUnit = initialInUnit * 2;
                        jQuery.style( elem, prop, initialInUnit + unit );

                        // Make sure we update the tween properties later on
                        valueParts = valueParts || [];
                    }

                    if ( valueParts ) {
                        initialInUnit = +initialInUnit || +initial || 0;

                        // Apply relative offset (+=/-=) if specified
                        adjusted = valueParts[ 1 ] ?
                            initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
                            +valueParts[ 2 ];
                        if ( tween ) {
                            tween.unit = unit;
                            tween.start = initialInUnit;
                            tween.end = adjusted;
                        }
                    }
                    return adjusted;
                }


                var defaultDisplayMap = {};

                function getDefaultDisplay( elem ) {
                    var temp,
                        doc = elem.ownerDocument,
                        nodeName = elem.nodeName,
                        display = defaultDisplayMap[ nodeName ];

                    if ( display ) {
                        return display;
                    }

                    temp = doc.body.appendChild( doc.createElement( nodeName ) );
                    display = jQuery.css( temp, "display" );

                    temp.parentNode.removeChild( temp );

                    if ( display === "none" ) {
                        display = "block";
                    }
                    defaultDisplayMap[ nodeName ] = display;

                    return display;
                }

                function showHide( elements, show ) {
                    var display, elem,
                        values = [],
                        index = 0,
                        length = elements.length;

                    // Determine new display value for elements that need to change
                    for ( ; index < length; index++ ) {
                        elem = elements[ index ];
                        if ( !elem.style ) {
                            continue;
                        }

                        display = elem.style.display;
                        if ( show ) {

                            // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                            // check is required in this first loop unless we have a nonempty display value (either
                            // inline or about-to-be-restored)
                            if ( display === "none" ) {
                                values[ index ] = dataPriv.get( elem, "display" ) || null;
                                if ( !values[ index ] ) {
                                    elem.style.display = "";
                                }
                            }
                            if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
                                values[ index ] = getDefaultDisplay( elem );
                            }
                        } else {
                            if ( display !== "none" ) {
                                values[ index ] = "none";

                                // Remember what we're overwriting
                                dataPriv.set( elem, "display", display );
                            }
                        }
                    }

                    // Set the display of the elements in a second loop to avoid constant reflow
                    for ( index = 0; index < length; index++ ) {
                        if ( values[ index ] != null ) {
                            elements[ index ].style.display = values[ index ];
                        }
                    }

                    return elements;
                }

                jQuery.fn.extend( {
                    show: function() {
                        return showHide( this, true );
                    },
                    hide: function() {
                        return showHide( this );
                    },
                    toggle: function( state ) {
                        if ( typeof state === "boolean" ) {
                            return state ? this.show() : this.hide();
                        }

                        return this.each( function() {
                            if ( isHiddenWithinTree( this ) ) {
                                jQuery( this ).show();
                            } else {
                                jQuery( this ).hide();
                            }
                        } );
                    }
                } );
                var rcheckableType = ( /^(?:checkbox|radio)$/i );

                var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

                var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



                ( function() {
                    var fragment = document.createDocumentFragment(),
                        div = fragment.appendChild( document.createElement( "div" ) ),
                        input = document.createElement( "input" );

                    // Support: Android 4.0 - 4.3 only
                    // Check state lost if the name is set (#11217)
                    // Support: Windows Web Apps (WWA)
                    // `name` and `type` must use .setAttribute for WWA (#14901)
                    input.setAttribute( "type", "radio" );
                    input.setAttribute( "checked", "checked" );
                    input.setAttribute( "name", "t" );

                    div.appendChild( input );

                    // Support: Android <=4.1 only
                    // Older WebKit doesn't clone checked state correctly in fragments
                    support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

                    // Support: IE <=11 only
                    // Make sure textarea (and checkbox) defaultValue is properly cloned
                    div.innerHTML = "<textarea>x</textarea>";
                    support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

                    // Support: IE <=9 only
                    // IE <=9 replaces <option> tags with their contents when inserted outside of
                    // the select element.
                    div.innerHTML = "<option></option>";
                    support.option = !!div.lastChild;
                } )();


// We have to close these tags to support XHTML (#13200)
                var wrapMap = {

                    // XHTML parsers do not magically insert elements in the
                    // same way that tag soup parsers do. So we cannot shorten
                    // this by omitting <tbody> or other required elements.
                    thead: [ 1, "<table>", "</table>" ],
                    col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
                    tr: [ 2, "<table><tbody>", "</tbody></table>" ],
                    td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

                    _default: [ 0, "", "" ]
                };

                wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
                wrapMap.th = wrapMap.td;

// Support: IE <=9 only
                if ( !support.option ) {
                    wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
                }


                function getAll( context, tag ) {

                    // Support: IE <=9 - 11 only
                    // Use typeof to avoid zero-argument method invocation on host objects (#15151)
                    var ret;

                    if ( typeof context.getElementsByTagName !== "undefined" ) {
                        ret = context.getElementsByTagName( tag || "*" );

                    } else if ( typeof context.querySelectorAll !== "undefined" ) {
                        ret = context.querySelectorAll( tag || "*" );

                    } else {
                        ret = [];
                    }

                    if ( tag === undefined || tag && nodeName( context, tag ) ) {
                        return jQuery.merge( [ context ], ret );
                    }

                    return ret;
                }


// Mark scripts as having already been evaluated
                function setGlobalEval( elems, refElements ) {
                    var i = 0,
                        l = elems.length;

                    for ( ; i < l; i++ ) {
                        dataPriv.set(
                            elems[ i ],
                            "globalEval",
                            !refElements || dataPriv.get( refElements[ i ], "globalEval" )
                        );
                    }
                }


                var rhtml = /<|&#?\w+;/;

                function buildFragment( elems, context, scripts, selection, ignored ) {
                    var elem, tmp, tag, wrap, attached, j,
                        fragment = context.createDocumentFragment(),
                        nodes = [],
                        i = 0,
                        l = elems.length;

                    for ( ; i < l; i++ ) {
                        elem = elems[ i ];

                        if ( elem || elem === 0 ) {

                            // Add nodes directly
                            if ( toType( elem ) === "object" ) {

                                // Support: Android <=4.0 only, PhantomJS 1 only
                                // push.apply(_, arraylike) throws on ancient WebKit
                                jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

                                // Convert non-html into a text node
                            } else if ( !rhtml.test( elem ) ) {
                                nodes.push( context.createTextNode( elem ) );

                                // Convert html into DOM nodes
                            } else {
                                tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

                                // Deserialize a standard representation
                                tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
                                wrap = wrapMap[ tag ] || wrapMap._default;
                                tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

                                // Descend through wrappers to the right content
                                j = wrap[ 0 ];
                                while ( j-- ) {
                                    tmp = tmp.lastChild;
                                }

                                // Support: Android <=4.0 only, PhantomJS 1 only
                                // push.apply(_, arraylike) throws on ancient WebKit
                                jQuery.merge( nodes, tmp.childNodes );

                                // Remember the top-level container
                                tmp = fragment.firstChild;

                                // Ensure the created nodes are orphaned (#12392)
                                tmp.textContent = "";
                            }
                        }
                    }

                    // Remove wrapper from fragment
                    fragment.textContent = "";

                    i = 0;
                    while ( ( elem = nodes[ i++ ] ) ) {

                        // Skip elements already in the context collection (trac-4087)
                        if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
                            if ( ignored ) {
                                ignored.push( elem );
                            }
                            continue;
                        }

                        attached = isAttached( elem );

                        // Append to fragment
                        tmp = getAll( fragment.appendChild( elem ), "script" );

                        // Preserve script evaluation history
                        if ( attached ) {
                            setGlobalEval( tmp );
                        }

                        // Capture executables
                        if ( scripts ) {
                            j = 0;
                            while ( ( elem = tmp[ j++ ] ) ) {
                                if ( rscriptType.test( elem.type || "" ) ) {
                                    scripts.push( elem );
                                }
                            }
                        }
                    }

                    return fragment;
                }


                var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

                function returnTrue() {
                    return true;
                }

                function returnFalse() {
                    return false;
                }

// Support: IE <=9 - 11+
// focus() and blur() are asynchronous, except when they are no-op.
// So expect focus to be synchronous when the element is already active,
// and blur to be synchronous when the element is not already active.
// (focus and blur are always synchronous in other supported browsers,
// this just defines when we can count on it).
                function expectSync( elem, type ) {
                    return ( elem === safeActiveElement() ) === ( type === "focus" );
                }

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
                function safeActiveElement() {
                    try {
                        return document.activeElement;
                    } catch ( err ) { }
                }

                function on( elem, types, selector, data, fn, one ) {
                    var origFn, type;

                    // Types can be a map of types/handlers
                    if ( typeof types === "object" ) {

                        // ( types-Object, selector, data )
                        if ( typeof selector !== "string" ) {

                            // ( types-Object, data )
                            data = data || selector;
                            selector = undefined;
                        }
                        for ( type in types ) {
                            on( elem, type, selector, data, types[ type ], one );
                        }
                        return elem;
                    }

                    if ( data == null && fn == null ) {

                        // ( types, fn )
                        fn = selector;
                        data = selector = undefined;
                    } else if ( fn == null ) {
                        if ( typeof selector === "string" ) {

                            // ( types, selector, fn )
                            fn = data;
                            data = undefined;
                        } else {

                            // ( types, data, fn )
                            fn = data;
                            data = selector;
                            selector = undefined;
                        }
                    }
                    if ( fn === false ) {
                        fn = returnFalse;
                    } else if ( !fn ) {
                        return elem;
                    }

                    if ( one === 1 ) {
                        origFn = fn;
                        fn = function( event ) {

                            // Can use an empty set, since event contains the info
                            jQuery().off( event );
                            return origFn.apply( this, arguments );
                        };

                        // Use same guid so caller can remove using origFn
                        fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
                    }
                    return elem.each( function() {
                        jQuery.event.add( this, types, fn, data, selector );
                    } );
                }

                /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
                jQuery.event = {

                    global: {},

                    add: function( elem, types, handler, data, selector ) {

                        var handleObjIn, eventHandle, tmp,
                            events, t, handleObj,
                            special, handlers, type, namespaces, origType,
                            elemData = dataPriv.get( elem );

                        // Only attach events to objects that accept data
                        if ( !acceptData( elem ) ) {
                            return;
                        }

                        // Caller can pass in an object of custom data in lieu of the handler
                        if ( handler.handler ) {
                            handleObjIn = handler;
                            handler = handleObjIn.handler;
                            selector = handleObjIn.selector;
                        }

                        // Ensure that invalid selectors throw exceptions at attach time
                        // Evaluate against documentElement in case elem is a non-element node (e.g., document)
                        if ( selector ) {
                            jQuery.find.matchesSelector( documentElement, selector );
                        }

                        // Make sure that the handler has a unique ID, used to find/remove it later
                        if ( !handler.guid ) {
                            handler.guid = jQuery.guid++;
                        }

                        // Init the element's event structure and main handler, if this is the first
                        if ( !( events = elemData.events ) ) {
                            events = elemData.events = Object.create( null );
                        }
                        if ( !( eventHandle = elemData.handle ) ) {
                            eventHandle = elemData.handle = function( e ) {

                                // Discard the second event of a jQuery.event.trigger() and
                                // when an event is called after a page has unloaded
                                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
                                    jQuery.event.dispatch.apply( elem, arguments ) : undefined;
                            };
                        }

                        // Handle multiple events separated by a space
                        types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
                        t = types.length;
                        while ( t-- ) {
                            tmp = rtypenamespace.exec( types[ t ] ) || [];
                            type = origType = tmp[ 1 ];
                            namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

                            // There *must* be a type, no attaching namespace-only handlers
                            if ( !type ) {
                                continue;
                            }

                            // If event changes its type, use the special event handlers for the changed type
                            special = jQuery.event.special[ type ] || {};

                            // If selector defined, determine special event api type, otherwise given type
                            type = ( selector ? special.delegateType : special.bindType ) || type;

                            // Update special based on newly reset type
                            special = jQuery.event.special[ type ] || {};

                            // handleObj is passed to all event handlers
                            handleObj = jQuery.extend( {
                                type: type,
                                origType: origType,
                                data: data,
                                handler: handler,
                                guid: handler.guid,
                                selector: selector,
                                needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
                                namespace: namespaces.join( "." )
                            }, handleObjIn );

                            // Init the event handler queue if we're the first
                            if ( !( handlers = events[ type ] ) ) {
                                handlers = events[ type ] = [];
                                handlers.delegateCount = 0;

                                // Only use addEventListener if the special events handler returns false
                                if ( !special.setup ||
                                    special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

                                    if ( elem.addEventListener ) {
                                        elem.addEventListener( type, eventHandle );
                                    }
                                }
                            }

                            if ( special.add ) {
                                special.add.call( elem, handleObj );

                                if ( !handleObj.handler.guid ) {
                                    handleObj.handler.guid = handler.guid;
                                }
                            }

                            // Add to the element's handler list, delegates in front
                            if ( selector ) {
                                handlers.splice( handlers.delegateCount++, 0, handleObj );
                            } else {
                                handlers.push( handleObj );
                            }

                            // Keep track of which events have ever been used, for event optimization
                            jQuery.event.global[ type ] = true;
                        }

                    },

                    // Detach an event or set of events from an element
                    remove: function( elem, types, handler, selector, mappedTypes ) {

                        var j, origCount, tmp,
                            events, t, handleObj,
                            special, handlers, type, namespaces, origType,
                            elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

                        if ( !elemData || !( events = elemData.events ) ) {
                            return;
                        }

                        // Once for each type.namespace in types; type may be omitted
                        types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
                        t = types.length;
                        while ( t-- ) {
                            tmp = rtypenamespace.exec( types[ t ] ) || [];
                            type = origType = tmp[ 1 ];
                            namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

                            // Unbind all events (on this namespace, if provided) for the element
                            if ( !type ) {
                                for ( type in events ) {
                                    jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
                                }
                                continue;
                            }

                            special = jQuery.event.special[ type ] || {};
                            type = ( selector ? special.delegateType : special.bindType ) || type;
                            handlers = events[ type ] || [];
                            tmp = tmp[ 2 ] &&
                                new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

                            // Remove matching events
                            origCount = j = handlers.length;
                            while ( j-- ) {
                                handleObj = handlers[ j ];

                                if ( ( mappedTypes || origType === handleObj.origType ) &&
                                    ( !handler || handler.guid === handleObj.guid ) &&
                                    ( !tmp || tmp.test( handleObj.namespace ) ) &&
                                    ( !selector || selector === handleObj.selector ||
                                        selector === "**" && handleObj.selector ) ) {
                                    handlers.splice( j, 1 );

                                    if ( handleObj.selector ) {
                                        handlers.delegateCount--;
                                    }
                                    if ( special.remove ) {
                                        special.remove.call( elem, handleObj );
                                    }
                                }
                            }

                            // Remove generic event handler if we removed something and no more handlers exist
                            // (avoids potential for endless recursion during removal of special event handlers)
                            if ( origCount && !handlers.length ) {
                                if ( !special.teardown ||
                                    special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

                                    jQuery.removeEvent( elem, type, elemData.handle );
                                }

                                delete events[ type ];
                            }
                        }

                        // Remove data and the expando if it's no longer used
                        if ( jQuery.isEmptyObject( events ) ) {
                            dataPriv.remove( elem, "handle events" );
                        }
                    },

                    dispatch: function( nativeEvent ) {

                        var i, j, ret, matched, handleObj, handlerQueue,
                            args = new Array( arguments.length ),

                            // Make a writable jQuery.Event from the native event object
                            event = jQuery.event.fix( nativeEvent ),

                            handlers = (
                                dataPriv.get( this, "events" ) || Object.create( null )
                            )[ event.type ] || [],
                            special = jQuery.event.special[ event.type ] || {};

                        // Use the fix-ed jQuery.Event rather than the (read-only) native event
                        args[ 0 ] = event;

                        for ( i = 1; i < arguments.length; i++ ) {
                            args[ i ] = arguments[ i ];
                        }

                        event.delegateTarget = this;

                        // Call the preDispatch hook for the mapped type, and let it bail if desired
                        if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
                            return;
                        }

                        // Determine handlers
                        handlerQueue = jQuery.event.handlers.call( this, event, handlers );

                        // Run delegates first; they may want to stop propagation beneath us
                        i = 0;
                        while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
                            event.currentTarget = matched.elem;

                            j = 0;
                            while ( ( handleObj = matched.handlers[ j++ ] ) &&
                            !event.isImmediatePropagationStopped() ) {

                                // If the event is namespaced, then each handler is only invoked if it is
                                // specially universal or its namespaces are a superset of the event's.
                                if ( !event.rnamespace || handleObj.namespace === false ||
                                    event.rnamespace.test( handleObj.namespace ) ) {

                                    event.handleObj = handleObj;
                                    event.data = handleObj.data;

                                    ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
                                        handleObj.handler ).apply( matched.elem, args );

                                    if ( ret !== undefined ) {
                                        if ( ( event.result = ret ) === false ) {
                                            event.preventDefault();
                                            event.stopPropagation();
                                        }
                                    }
                                }
                            }
                        }

                        // Call the postDispatch hook for the mapped type
                        if ( special.postDispatch ) {
                            special.postDispatch.call( this, event );
                        }

                        return event.result;
                    },

                    handlers: function( event, handlers ) {
                        var i, handleObj, sel, matchedHandlers, matchedSelectors,
                            handlerQueue = [],
                            delegateCount = handlers.delegateCount,
                            cur = event.target;

                        // Find delegate handlers
                        if ( delegateCount &&

                            // Support: IE <=9
                            // Black-hole SVG <use> instance trees (trac-13180)
                            cur.nodeType &&

                            // Support: Firefox <=42
                            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
                            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
                            // Support: IE 11 only
                            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
                            !( event.type === "click" && event.button >= 1 ) ) {

                            for ( ; cur !== this; cur = cur.parentNode || this ) {

                                // Don't check non-elements (#13208)
                                // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                                if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
                                    matchedHandlers = [];
                                    matchedSelectors = {};
                                    for ( i = 0; i < delegateCount; i++ ) {
                                        handleObj = handlers[ i ];

                                        // Don't conflict with Object.prototype properties (#13203)
                                        sel = handleObj.selector + " ";

                                        if ( matchedSelectors[ sel ] === undefined ) {
                                            matchedSelectors[ sel ] = handleObj.needsContext ?
                                                jQuery( sel, this ).index( cur ) > -1 :
                                                jQuery.find( sel, this, null, [ cur ] ).length;
                                        }
                                        if ( matchedSelectors[ sel ] ) {
                                            matchedHandlers.push( handleObj );
                                        }
                                    }
                                    if ( matchedHandlers.length ) {
                                        handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
                                    }
                                }
                            }
                        }

                        // Add the remaining (directly-bound) handlers
                        cur = this;
                        if ( delegateCount < handlers.length ) {
                            handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
                        }

                        return handlerQueue;
                    },

                    addProp: function( name, hook ) {
                        Object.defineProperty( jQuery.Event.prototype, name, {
                            enumerable: true,
                            configurable: true,

                            get: isFunction( hook ) ?
                                function() {
                                    if ( this.originalEvent ) {
                                        return hook( this.originalEvent );
                                    }
                                } :
                                function() {
                                    if ( this.originalEvent ) {
                                        return this.originalEvent[ name ];
                                    }
                                },

                            set: function( value ) {
                                Object.defineProperty( this, name, {
                                    enumerable: true,
                                    configurable: true,
                                    writable: true,
                                    value: value
                                } );
                            }
                        } );
                    },

                    fix: function( originalEvent ) {
                        return originalEvent[ jQuery.expando ] ?
                            originalEvent :
                            new jQuery.Event( originalEvent );
                    },

                    special: {
                        load: {

                            // Prevent triggered image.load events from bubbling to window.load
                            noBubble: true
                        },
                        click: {

                            // Utilize native event to ensure correct state for checkable inputs
                            setup: function( data ) {

                                // For mutual compressibility with _default, replace `this` access with a local var.
                                // `|| data` is dead code meant only to preserve the variable through minification.
                                var el = this || data;

                                // Claim the first handler
                                if ( rcheckableType.test( el.type ) &&
                                    el.click && nodeName( el, "input" ) ) {

                                    // dataPriv.set( el, "click", ... )
                                    leverageNative( el, "click", returnTrue );
                                }

                                // Return false to allow normal processing in the caller
                                return false;
                            },
                            trigger: function( data ) {

                                // For mutual compressibility with _default, replace `this` access with a local var.
                                // `|| data` is dead code meant only to preserve the variable through minification.
                                var el = this || data;

                                // Force setup before triggering a click
                                if ( rcheckableType.test( el.type ) &&
                                    el.click && nodeName( el, "input" ) ) {

                                    leverageNative( el, "click" );
                                }

                                // Return non-false to allow normal event-path propagation
                                return true;
                            },

                            // For cross-browser consistency, suppress native .click() on links
                            // Also prevent it if we're currently inside a leveraged native-event stack
                            _default: function( event ) {
                                var target = event.target;
                                return rcheckableType.test( target.type ) &&
                                    target.click && nodeName( target, "input" ) &&
                                    dataPriv.get( target, "click" ) ||
                                    nodeName( target, "a" );
                            }
                        },

                        beforeunload: {
                            postDispatch: function( event ) {

                                // Support: Firefox 20+
                                // Firefox doesn't alert if the returnValue field is not set.
                                if ( event.result !== undefined && event.originalEvent ) {
                                    event.originalEvent.returnValue = event.result;
                                }
                            }
                        }
                    }
                };

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
                function leverageNative( el, type, expectSync ) {

                    // Missing expectSync indicates a trigger call, which must force setup through jQuery.event.add
                    if ( !expectSync ) {
                        if ( dataPriv.get( el, type ) === undefined ) {
                            jQuery.event.add( el, type, returnTrue );
                        }
                        return;
                    }

                    // Register the controller as a special universal handler for all event namespaces
                    dataPriv.set( el, type, false );
                    jQuery.event.add( el, type, {
                        namespace: false,
                        handler: function( event ) {
                            var notAsync, result,
                                saved = dataPriv.get( this, type );

                            if ( ( event.isTrigger & 1 ) && this[ type ] ) {

                                // Interrupt processing of the outer synthetic .trigger()ed event
                                // Saved data should be false in such cases, but might be a leftover capture object
                                // from an async native handler (gh-4350)
                                if ( !saved.length ) {

                                    // Store arguments for use when handling the inner native event
                                    // There will always be at least one argument (an event object), so this array
                                    // will not be confused with a leftover capture object.
                                    saved = slice.call( arguments );
                                    dataPriv.set( this, type, saved );

                                    // Trigger the native event and capture its result
                                    // Support: IE <=9 - 11+
                                    // focus() and blur() are asynchronous
                                    notAsync = expectSync( this, type );
                                    this[ type ]();
                                    result = dataPriv.get( this, type );
                                    if ( saved !== result || notAsync ) {
                                        dataPriv.set( this, type, false );
                                    } else {
                                        result = {};
                                    }
                                    if ( saved !== result ) {

                                        // Cancel the outer synthetic event
                                        event.stopImmediatePropagation();
                                        event.preventDefault();

                                        // Support: Chrome 86+
                                        // In Chrome, if an element having a focusout handler is blurred by
                                        // clicking outside of it, it invokes the handler synchronously. If
                                        // that handler calls `.remove()` on the element, the data is cleared,
                                        // leaving `result` undefined. We need to guard against this.
                                        return result && result.value;
                                    }

                                    // If this is an inner synthetic event for an event with a bubbling surrogate
                                    // (focus or blur), assume that the surrogate already propagated from triggering the
                                    // native event and prevent that from happening again here.
                                    // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
                                    // bubbling surrogate propagates *after* the non-bubbling base), but that seems
                                    // less bad than duplication.
                                } else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
                                    event.stopPropagation();
                                }

                                // If this is a native event triggered above, everything is now in order
                                // Fire an inner synthetic event with the original arguments
                            } else if ( saved.length ) {

                                // ...and capture the result
                                dataPriv.set( this, type, {
                                    value: jQuery.event.trigger(

                                        // Support: IE <=9 - 11+
                                        // Extend with the prototype to reset the above stopImmediatePropagation()
                                        jQuery.extend( saved[ 0 ], jQuery.Event.prototype ),
                                        saved.slice( 1 ),
                                        this
                                    )
                                } );

                                // Abort handling of the native event
                                event.stopImmediatePropagation();
                            }
                        }
                    } );
                }

                jQuery.removeEvent = function( elem, type, handle ) {

                    // This "if" is needed for plain objects
                    if ( elem.removeEventListener ) {
                        elem.removeEventListener( type, handle );
                    }
                };

                jQuery.Event = function( src, props ) {

                    // Allow instantiation without the 'new' keyword
                    if ( !( this instanceof jQuery.Event ) ) {
                        return new jQuery.Event( src, props );
                    }

                    // Event object
                    if ( src && src.type ) {
                        this.originalEvent = src;
                        this.type = src.type;

                        // Events bubbling up the document may have been marked as prevented
                        // by a handler lower down the tree; reflect the correct value.
                        this.isDefaultPrevented = src.defaultPrevented ||
                        src.defaultPrevented === undefined &&

                        // Support: Android <=2.3 only
                        src.returnValue === false ?
                            returnTrue :
                            returnFalse;

                        // Create target properties
                        // Support: Safari <=6 - 7 only
                        // Target should not be a text node (#504, #13143)
                        this.target = ( src.target && src.target.nodeType === 3 ) ?
                            src.target.parentNode :
                            src.target;

                        this.currentTarget = src.currentTarget;
                        this.relatedTarget = src.relatedTarget;

                        // Event type
                    } else {
                        this.type = src;
                    }

                    // Put explicitly provided properties onto the event object
                    if ( props ) {
                        jQuery.extend( this, props );
                    }

                    // Create a timestamp if incoming event doesn't have one
                    this.timeStamp = src && src.timeStamp || Date.now();

                    // Mark it as fixed
                    this[ jQuery.expando ] = true;
                };

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
                jQuery.Event.prototype = {
                    constructor: jQuery.Event,
                    isDefaultPrevented: returnFalse,
                    isPropagationStopped: returnFalse,
                    isImmediatePropagationStopped: returnFalse,
                    isSimulated: false,

                    preventDefault: function() {
                        var e = this.originalEvent;

                        this.isDefaultPrevented = returnTrue;

                        if ( e && !this.isSimulated ) {
                            e.preventDefault();
                        }
                    },
                    stopPropagation: function() {
                        var e = this.originalEvent;

                        this.isPropagationStopped = returnTrue;

                        if ( e && !this.isSimulated ) {
                            e.stopPropagation();
                        }
                    },
                    stopImmediatePropagation: function() {
                        var e = this.originalEvent;

                        this.isImmediatePropagationStopped = returnTrue;

                        if ( e && !this.isSimulated ) {
                            e.stopImmediatePropagation();
                        }

                        this.stopPropagation();
                    }
                };

// Includes all common event props including KeyEvent and MouseEvent specific props
                jQuery.each( {
                    altKey: true,
                    bubbles: true,
                    cancelable: true,
                    changedTouches: true,
                    ctrlKey: true,
                    detail: true,
                    eventPhase: true,
                    metaKey: true,
                    pageX: true,
                    pageY: true,
                    shiftKey: true,
                    view: true,
                    "char": true,
                    code: true,
                    charCode: true,
                    key: true,
                    keyCode: true,
                    button: true,
                    buttons: true,
                    clientX: true,
                    clientY: true,
                    offsetX: true,
                    offsetY: true,
                    pointerId: true,
                    pointerType: true,
                    screenX: true,
                    screenY: true,
                    targetTouches: true,
                    toElement: true,
                    touches: true,
                    which: true
                }, jQuery.event.addProp );

                jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {
                    jQuery.event.special[ type ] = {

                        // Utilize native event if possible so blur/focus sequence is correct
                        setup: function() {

                            // Claim the first handler
                            // dataPriv.set( this, "focus", ... )
                            // dataPriv.set( this, "blur", ... )
                            leverageNative( this, type, expectSync );

                            // Return false to allow normal processing in the caller
                            return false;
                        },
                        trigger: function() {

                            // Force setup before trigger
                            leverageNative( this, type );

                            // Return non-false to allow normal event-path propagation
                            return true;
                        },

                        // Suppress native focus or blur as it's already being fired
                        // in leverageNative.
                        _default: function() {
                            return true;
                        },

                        delegateType: delegateType
                    };
                } );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
                jQuery.each( {
                    mouseenter: "mouseover",
                    mouseleave: "mouseout",
                    pointerenter: "pointerover",
                    pointerleave: "pointerout"
                }, function( orig, fix ) {
                    jQuery.event.special[ orig ] = {
                        delegateType: fix,
                        bindType: fix,

                        handle: function( event ) {
                            var ret,
                                target = this,
                                related = event.relatedTarget,
                                handleObj = event.handleObj;

                            // For mouseenter/leave call the handler if related is outside the target.
                            // NB: No relatedTarget if the mouse left/entered the browser window
                            if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
                                event.type = handleObj.origType;
                                ret = handleObj.handler.apply( this, arguments );
                                event.type = fix;
                            }
                            return ret;
                        }
                    };
                } );

                jQuery.fn.extend( {

                    on: function( types, selector, data, fn ) {
                        return on( this, types, selector, data, fn );
                    },
                    one: function( types, selector, data, fn ) {
                        return on( this, types, selector, data, fn, 1 );
                    },
                    off: function( types, selector, fn ) {
                        var handleObj, type;
                        if ( types && types.preventDefault && types.handleObj ) {

                            // ( event )  dispatched jQuery.Event
                            handleObj = types.handleObj;
                            jQuery( types.delegateTarget ).off(
                                handleObj.namespace ?
                                    handleObj.origType + "." + handleObj.namespace :
                                    handleObj.origType,
                                handleObj.selector,
                                handleObj.handler
                            );
                            return this;
                        }
                        if ( typeof types === "object" ) {

                            // ( types-object [, selector] )
                            for ( type in types ) {
                                this.off( type, selector, types[ type ] );
                            }
                            return this;
                        }
                        if ( selector === false || typeof selector === "function" ) {

                            // ( types [, fn] )
                            fn = selector;
                            selector = undefined;
                        }
                        if ( fn === false ) {
                            fn = returnFalse;
                        }
                        return this.each( function() {
                            jQuery.event.remove( this, types, fn, selector );
                        } );
                    }
                } );


                var

                    // Support: IE <=10 - 11, Edge 12 - 13 only
                    // In IE/Edge using regex groups here causes severe slowdowns.
                    // See https://connect.microsoft.com/IE/feedback/details/1736512/
                    rnoInnerhtml = /<script|<style|<link/i,

                    // checked="checked" or checked
                    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
                    rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
                function manipulationTarget( elem, content ) {
                    if ( nodeName( elem, "table" ) &&
                        nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

                        return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
                    }

                    return elem;
                }

// Replace/restore the type attribute of script elements for safe DOM manipulation
                function disableScript( elem ) {
                    elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
                    return elem;
                }
                function restoreScript( elem ) {
                    if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
                        elem.type = elem.type.slice( 5 );
                    } else {
                        elem.removeAttribute( "type" );
                    }

                    return elem;
                }

                function cloneCopyEvent( src, dest ) {
                    var i, l, type, pdataOld, udataOld, udataCur, events;

                    if ( dest.nodeType !== 1 ) {
                        return;
                    }

                    // 1. Copy private data: events, handlers, etc.
                    if ( dataPriv.hasData( src ) ) {
                        pdataOld = dataPriv.get( src );
                        events = pdataOld.events;

                        if ( events ) {
                            dataPriv.remove( dest, "handle events" );

                            for ( type in events ) {
                                for ( i = 0, l = events[ type ].length; i < l; i++ ) {
                                    jQuery.event.add( dest, type, events[ type ][ i ] );
                                }
                            }
                        }
                    }

                    // 2. Copy user data
                    if ( dataUser.hasData( src ) ) {
                        udataOld = dataUser.access( src );
                        udataCur = jQuery.extend( {}, udataOld );

                        dataUser.set( dest, udataCur );
                    }
                }

// Fix IE bugs, see support tests
                function fixInput( src, dest ) {
                    var nodeName = dest.nodeName.toLowerCase();

                    // Fails to persist the checked state of a cloned checkbox or radio button.
                    if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
                        dest.checked = src.checked;

                        // Fails to return the selected option to the default selected state when cloning options
                    } else if ( nodeName === "input" || nodeName === "textarea" ) {
                        dest.defaultValue = src.defaultValue;
                    }
                }

                function domManip( collection, args, callback, ignored ) {

                    // Flatten any nested arrays
                    args = flat( args );

                    var fragment, first, scripts, hasScripts, node, doc,
                        i = 0,
                        l = collection.length,
                        iNoClone = l - 1,
                        value = args[ 0 ],
                        valueIsFunction = isFunction( value );

                    // We can't cloneNode fragments that contain checked, in WebKit
                    if ( valueIsFunction ||
                        ( l > 1 && typeof value === "string" &&
                            !support.checkClone && rchecked.test( value ) ) ) {
                        return collection.each( function( index ) {
                            var self = collection.eq( index );
                            if ( valueIsFunction ) {
                                args[ 0 ] = value.call( this, index, self.html() );
                            }
                            domManip( self, args, callback, ignored );
                        } );
                    }

                    if ( l ) {
                        fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
                        first = fragment.firstChild;

                        if ( fragment.childNodes.length === 1 ) {
                            fragment = first;
                        }

                        // Require either new content or an interest in ignored elements to invoke the callback
                        if ( first || ignored ) {
                            scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
                            hasScripts = scripts.length;

                            // Use the original fragment for the last item
                            // instead of the first because it can end up
                            // being emptied incorrectly in certain situations (#8070).
                            for ( ; i < l; i++ ) {
                                node = fragment;

                                if ( i !== iNoClone ) {
                                    node = jQuery.clone( node, true, true );

                                    // Keep references to cloned scripts for later restoration
                                    if ( hasScripts ) {

                                        // Support: Android <=4.0 only, PhantomJS 1 only
                                        // push.apply(_, arraylike) throws on ancient WebKit
                                        jQuery.merge( scripts, getAll( node, "script" ) );
                                    }
                                }

                                callback.call( collection[ i ], node, i );
                            }

                            if ( hasScripts ) {
                                doc = scripts[ scripts.length - 1 ].ownerDocument;

                                // Reenable scripts
                                jQuery.map( scripts, restoreScript );

                                // Evaluate executable scripts on first document insertion
                                for ( i = 0; i < hasScripts; i++ ) {
                                    node = scripts[ i ];
                                    if ( rscriptType.test( node.type || "" ) &&
                                        !dataPriv.access( node, "globalEval" ) &&
                                        jQuery.contains( doc, node ) ) {

                                        if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

                                            // Optional AJAX dependency, but won't run scripts if not present
                                            if ( jQuery._evalUrl && !node.noModule ) {
                                                jQuery._evalUrl( node.src, {
                                                    nonce: node.nonce || node.getAttribute( "nonce" )
                                                }, doc );
                                            }
                                        } else {
                                            DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
                                        }
                                    }
                                }
                            }
                        }
                    }

                    return collection;
                }

                function remove( elem, selector, keepData ) {
                    var node,
                        nodes = selector ? jQuery.filter( selector, elem ) : elem,
                        i = 0;

                    for ( ; ( node = nodes[ i ] ) != null; i++ ) {
                        if ( !keepData && node.nodeType === 1 ) {
                            jQuery.cleanData( getAll( node ) );
                        }

                        if ( node.parentNode ) {
                            if ( keepData && isAttached( node ) ) {
                                setGlobalEval( getAll( node, "script" ) );
                            }
                            node.parentNode.removeChild( node );
                        }
                    }

                    return elem;
                }

                jQuery.extend( {
                    htmlPrefilter: function( html ) {
                        return html;
                    },

                    clone: function( elem, dataAndEvents, deepDataAndEvents ) {
                        var i, l, srcElements, destElements,
                            clone = elem.cloneNode( true ),
                            inPage = isAttached( elem );

                        // Fix IE cloning issues
                        if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
                            !jQuery.isXMLDoc( elem ) ) {

                            // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                            destElements = getAll( clone );
                            srcElements = getAll( elem );

                            for ( i = 0, l = srcElements.length; i < l; i++ ) {
                                fixInput( srcElements[ i ], destElements[ i ] );
                            }
                        }

                        // Copy the events from the original to the clone
                        if ( dataAndEvents ) {
                            if ( deepDataAndEvents ) {
                                srcElements = srcElements || getAll( elem );
                                destElements = destElements || getAll( clone );

                                for ( i = 0, l = srcElements.length; i < l; i++ ) {
                                    cloneCopyEvent( srcElements[ i ], destElements[ i ] );
                                }
                            } else {
                                cloneCopyEvent( elem, clone );
                            }
                        }

                        // Preserve script evaluation history
                        destElements = getAll( clone, "script" );
                        if ( destElements.length > 0 ) {
                            setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
                        }

                        // Return the cloned set
                        return clone;
                    },

                    cleanData: function( elems ) {
                        var data, elem, type,
                            special = jQuery.event.special,
                            i = 0;

                        for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
                            if ( acceptData( elem ) ) {
                                if ( ( data = elem[ dataPriv.expando ] ) ) {
                                    if ( data.events ) {
                                        for ( type in data.events ) {
                                            if ( special[ type ] ) {
                                                jQuery.event.remove( elem, type );

                                                // This is a shortcut to avoid jQuery.event.remove's overhead
                                            } else {
                                                jQuery.removeEvent( elem, type, data.handle );
                                            }
                                        }
                                    }

                                    // Support: Chrome <=35 - 45+
                                    // Assign undefined instead of using delete, see Data#remove
                                    elem[ dataPriv.expando ] = undefined;
                                }
                                if ( elem[ dataUser.expando ] ) {

                                    // Support: Chrome <=35 - 45+
                                    // Assign undefined instead of using delete, see Data#remove
                                    elem[ dataUser.expando ] = undefined;
                                }
                            }
                        }
                    }
                } );

                jQuery.fn.extend( {
                    detach: function( selector ) {
                        return remove( this, selector, true );
                    },

                    remove: function( selector ) {
                        return remove( this, selector );
                    },

                    text: function( value ) {
                        return access( this, function( value ) {
                            return value === undefined ?
                                jQuery.text( this ) :
                                this.empty().each( function() {
                                    if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                                        this.textContent = value;
                                    }
                                } );
                        }, null, value, arguments.length );
                    },

                    append: function() {
                        return domManip( this, arguments, function( elem ) {
                            if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                                var target = manipulationTarget( this, elem );
                                target.appendChild( elem );
                            }
                        } );
                    },

                    prepend: function() {
                        return domManip( this, arguments, function( elem ) {
                            if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
                                var target = manipulationTarget( this, elem );
                                target.insertBefore( elem, target.firstChild );
                            }
                        } );
                    },

                    before: function() {
                        return domManip( this, arguments, function( elem ) {
                            if ( this.parentNode ) {
                                this.parentNode.insertBefore( elem, this );
                            }
                        } );
                    },

                    after: function() {
                        return domManip( this, arguments, function( elem ) {
                            if ( this.parentNode ) {
                                this.parentNode.insertBefore( elem, this.nextSibling );
                            }
                        } );
                    },

                    empty: function() {
                        var elem,
                            i = 0;

                        for ( ; ( elem = this[ i ] ) != null; i++ ) {
                            if ( elem.nodeType === 1 ) {

                                // Prevent memory leaks
                                jQuery.cleanData( getAll( elem, false ) );

                                // Remove any remaining nodes
                                elem.textContent = "";
                            }
                        }

                        return this;
                    },

                    clone: function( dataAndEvents, deepDataAndEvents ) {
                        dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
                        deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

                        return this.map( function() {
                            return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
                        } );
                    },

                    html: function( value ) {
                        return access( this, function( value ) {
                            var elem = this[ 0 ] || {},
                                i = 0,
                                l = this.length;

                            if ( value === undefined && elem.nodeType === 1 ) {
                                return elem.innerHTML;
                            }

                            // See if we can take a shortcut and just use innerHTML
                            if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
                                !wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

                                value = jQuery.htmlPrefilter( value );

                                try {
                                    for ( ; i < l; i++ ) {
                                        elem = this[ i ] || {};

                                        // Remove element nodes and prevent memory leaks
                                        if ( elem.nodeType === 1 ) {
                                            jQuery.cleanData( getAll( elem, false ) );
                                            elem.innerHTML = value;
                                        }
                                    }

                                    elem = 0;

                                    // If using innerHTML throws an exception, use the fallback method
                                } catch ( e ) {}
                            }

                            if ( elem ) {
                                this.empty().append( value );
                            }
                        }, null, value, arguments.length );
                    },

                    replaceWith: function() {
                        var ignored = [];

                        // Make the changes, replacing each non-ignored context element with the new content
                        return domManip( this, arguments, function( elem ) {
                            var parent = this.parentNode;

                            if ( jQuery.inArray( this, ignored ) < 0 ) {
                                jQuery.cleanData( getAll( this ) );
                                if ( parent ) {
                                    parent.replaceChild( elem, this );
                                }
                            }

                            // Force callback invocation
                        }, ignored );
                    }
                } );

                jQuery.each( {
                    appendTo: "append",
                    prependTo: "prepend",
                    insertBefore: "before",
                    insertAfter: "after",
                    replaceAll: "replaceWith"
                }, function( name, original ) {
                    jQuery.fn[ name ] = function( selector ) {
                        var elems,
                            ret = [],
                            insert = jQuery( selector ),
                            last = insert.length - 1,
                            i = 0;

                        for ( ; i <= last; i++ ) {
                            elems = i === last ? this : this.clone( true );
                            jQuery( insert[ i ] )[ original ]( elems );

                            // Support: Android <=4.0 only, PhantomJS 1 only
                            // .get() because push.apply(_, arraylike) throws on ancient WebKit
                            push.apply( ret, elems.get() );
                        }

                        return this.pushStack( ret );
                    };
                } );
                var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

                var getStyles = function( elem ) {

                    // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
                    // IE throws on elements created in popups
                    // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
                    var view = elem.ownerDocument.defaultView;

                    if ( !view || !view.opener ) {
                        view = window;
                    }

                    return view.getComputedStyle( elem );
                };

                var swap = function( elem, options, callback ) {
                    var ret, name,
                        old = {};

                    // Remember the old values, and insert the new ones
                    for ( name in options ) {
                        old[ name ] = elem.style[ name ];
                        elem.style[ name ] = options[ name ];
                    }

                    ret = callback.call( elem );

                    // Revert the old values
                    for ( name in options ) {
                        elem.style[ name ] = old[ name ];
                    }

                    return ret;
                };


                var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



                ( function() {

                    // Executing both pixelPosition & boxSizingReliable tests require only one layout
                    // so they're executed at the same time to save the second computation.
                    function computeStyleTests() {

                        // This is a singleton, we need to execute it only once
                        if ( !div ) {
                            return;
                        }

                        container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
                            "margin-top:1px;padding:0;border:0";
                        div.style.cssText =
                            "position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
                            "margin:auto;border:1px;padding:1px;" +
                            "width:60%;top:1%";
                        documentElement.appendChild( container ).appendChild( div );

                        var divStyle = window.getComputedStyle( div );
                        pixelPositionVal = divStyle.top !== "1%";

                        // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
                        reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

                        // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
                        // Some styles come back with percentage values, even though they shouldn't
                        div.style.right = "60%";
                        pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

                        // Support: IE 9 - 11 only
                        // Detect misreporting of content dimensions for box-sizing:border-box elements
                        boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

                        // Support: IE 9 only
                        // Detect overflow:scroll screwiness (gh-3699)
                        // Support: Chrome <=64
                        // Don't get tricked when zoom affects offsetWidth (gh-4029)
                        div.style.position = "absolute";
                        scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

                        documentElement.removeChild( container );

                        // Nullify the div so it wouldn't be stored in the memory and
                        // it will also be a sign that checks already performed
                        div = null;
                    }

                    function roundPixelMeasures( measure ) {
                        return Math.round( parseFloat( measure ) );
                    }

                    var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
                        reliableTrDimensionsVal, reliableMarginLeftVal,
                        container = document.createElement( "div" ),
                        div = document.createElement( "div" );

                    // Finish early in limited (non-browser) environments
                    if ( !div.style ) {
                        return;
                    }

                    // Support: IE <=9 - 11 only
                    // Style of cloned element affects source element cloned (#8908)
                    div.style.backgroundClip = "content-box";
                    div.cloneNode( true ).style.backgroundClip = "";
                    support.clearCloneStyle = div.style.backgroundClip === "content-box";

                    jQuery.extend( support, {
                        boxSizingReliable: function() {
                            computeStyleTests();
                            return boxSizingReliableVal;
                        },
                        pixelBoxStyles: function() {
                            computeStyleTests();
                            return pixelBoxStylesVal;
                        },
                        pixelPosition: function() {
                            computeStyleTests();
                            return pixelPositionVal;
                        },
                        reliableMarginLeft: function() {
                            computeStyleTests();
                            return reliableMarginLeftVal;
                        },
                        scrollboxSize: function() {
                            computeStyleTests();
                            return scrollboxSizeVal;
                        },

                        // Support: IE 9 - 11+, Edge 15 - 18+
                        // IE/Edge misreport `getComputedStyle` of table rows with width/height
                        // set in CSS while `offset*` properties report correct values.
                        // Behavior in IE 9 is more subtle than in newer versions & it passes
                        // some versions of this test; make sure not to make it pass there!
                        //
                        // Support: Firefox 70+
                        // Only Firefox includes border widths
                        // in computed dimensions. (gh-4529)
                        reliableTrDimensions: function() {
                            var table, tr, trChild, trStyle;
                            if ( reliableTrDimensionsVal == null ) {
                                table = document.createElement( "table" );
                                tr = document.createElement( "tr" );
                                trChild = document.createElement( "div" );

                                table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
                                tr.style.cssText = "border:1px solid";

                                // Support: Chrome 86+
                                // Height set through cssText does not get applied.
                                // Computed height then comes back as 0.
                                tr.style.height = "1px";
                                trChild.style.height = "9px";

                                // Support: Android 8 Chrome 86+
                                // In our bodyBackground.html iframe,
                                // display for all div elements is set to "inline",
                                // which causes a problem only in Android 8 Chrome 86.
                                // Ensuring the div is display: block
                                // gets around this issue.
                                trChild.style.display = "block";

                                documentElement
                                    .appendChild( table )
                                    .appendChild( tr )
                                    .appendChild( trChild );

                                trStyle = window.getComputedStyle( tr );
                                reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
                                    parseInt( trStyle.borderTopWidth, 10 ) +
                                    parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

                                documentElement.removeChild( table );
                            }
                            return reliableTrDimensionsVal;
                        }
                    } );
                } )();


                function curCSS( elem, name, computed ) {
                    var width, minWidth, maxWidth, ret,

                        // Support: Firefox 51+
                        // Retrieving style before computed somehow
                        // fixes an issue with getting wrong values
                        // on detached elements
                        style = elem.style;

                    computed = computed || getStyles( elem );

                    // getPropertyValue is needed for:
                    //   .css('filter') (IE 9 only, #12537)
                    //   .css('--customProperty) (#3144)
                    if ( computed ) {
                        ret = computed.getPropertyValue( name ) || computed[ name ];

                        if ( ret === "" && !isAttached( elem ) ) {
                            ret = jQuery.style( elem, name );
                        }

                        // A tribute to the "awesome hack by Dean Edwards"
                        // Android Browser returns percentage for some values,
                        // but width seems to be reliably pixels.
                        // This is against the CSSOM draft spec:
                        // https://drafts.csswg.org/cssom/#resolved-values
                        if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

                            // Remember the original values
                            width = style.width;
                            minWidth = style.minWidth;
                            maxWidth = style.maxWidth;

                            // Put in the new values to get a computed value out
                            style.minWidth = style.maxWidth = style.width = ret;
                            ret = computed.width;

                            // Revert the changed values
                            style.width = width;
                            style.minWidth = minWidth;
                            style.maxWidth = maxWidth;
                        }
                    }

                    return ret !== undefined ?

                        // Support: IE <=9 - 11 only
                        // IE returns zIndex value as an integer.
                        ret + "" :
                        ret;
                }


                function addGetHookIf( conditionFn, hookFn ) {

                    // Define the hook, we'll check on the first run if it's really needed.
                    return {
                        get: function() {
                            if ( conditionFn() ) {

                                // Hook not needed (or it's not possible to use it due
                                // to missing dependency), remove it.
                                delete this.get;
                                return;
                            }

                            // Hook needed; redefine it so that the support test is not executed again.
                            return ( this.get = hookFn ).apply( this, arguments );
                        }
                    };
                }


                var cssPrefixes = [ "Webkit", "Moz", "ms" ],
                    emptyStyle = document.createElement( "div" ).style,
                    vendorProps = {};

// Return a vendor-prefixed property or undefined
                function vendorPropName( name ) {

                    // Check for vendor prefixed names
                    var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
                        i = cssPrefixes.length;

                    while ( i-- ) {
                        name = cssPrefixes[ i ] + capName;
                        if ( name in emptyStyle ) {
                            return name;
                        }
                    }
                }

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
                function finalPropName( name ) {
                    var final = jQuery.cssProps[ name ] || vendorProps[ name ];

                    if ( final ) {
                        return final;
                    }
                    if ( name in emptyStyle ) {
                        return name;
                    }
                    return vendorProps[ name ] = vendorPropName( name ) || name;
                }


                var

                    // Swappable if display is none or starts with table
                    // except "table", "table-cell", or "table-caption"
                    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
                    rdisplayswap = /^(none|table(?!-c[ea]).+)/,
                    rcustomProp = /^--/,
                    cssShow = { position: "absolute", visibility: "hidden", display: "block" },
                    cssNormalTransform = {
                        letterSpacing: "0",
                        fontWeight: "400"
                    };

                function setPositiveNumber( _elem, value, subtract ) {

                    // Any relative (+/-) values have already been
                    // normalized at this point
                    var matches = rcssNum.exec( value );
                    return matches ?

                        // Guard against undefined "subtract", e.g., when used as in cssHooks
                        Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
                        value;
                }

                function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
                    var i = dimension === "width" ? 1 : 0,
                        extra = 0,
                        delta = 0;

                    // Adjustment may not be necessary
                    if ( box === ( isBorderBox ? "border" : "content" ) ) {
                        return 0;
                    }

                    for ( ; i < 4; i += 2 ) {

                        // Both box models exclude margin
                        if ( box === "margin" ) {
                            delta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
                        }

                        // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
                        if ( !isBorderBox ) {

                            // Add padding
                            delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

                            // For "border" or "margin", add border
                            if ( box !== "padding" ) {
                                delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

                                // But still keep track of it otherwise
                            } else {
                                extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
                            }

                            // If we get here with a border-box (content + padding + border), we're seeking "content" or
                            // "padding" or "margin"
                        } else {

                            // For "content", subtract padding
                            if ( box === "content" ) {
                                delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
                            }

                            // For "content" or "padding", subtract border
                            if ( box !== "margin" ) {
                                delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
                            }
                        }
                    }

                    // Account for positive content-box scroll gutter when requested by providing computedVal
                    if ( !isBorderBox && computedVal >= 0 ) {

                        // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
                        // Assuming integer scroll gutter, subtract the rest and round down
                        delta += Math.max( 0, Math.ceil(
                            elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
                            computedVal -
                            delta -
                            extra -
                            0.5

                            // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
                            // Use an explicit zero to avoid NaN (gh-3964)
                        ) ) || 0;
                    }

                    return delta;
                }

                function getWidthOrHeight( elem, dimension, extra ) {

                    // Start with computed style
                    var styles = getStyles( elem ),

                        // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
                        // Fake content-box until we know it's needed to know the true value.
                        boxSizingNeeded = !support.boxSizingReliable() || extra,
                        isBorderBox = boxSizingNeeded &&
                            jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
                        valueIsBorderBox = isBorderBox,

                        val = curCSS( elem, dimension, styles ),
                        offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

                    // Support: Firefox <=54
                    // Return a confounding non-pixel value or feign ignorance, as appropriate.
                    if ( rnumnonpx.test( val ) ) {
                        if ( !extra ) {
                            return val;
                        }
                        val = "auto";
                    }


                    // Support: IE 9 - 11 only
                    // Use offsetWidth/offsetHeight for when box sizing is unreliable.
                    // In those cases, the computed value can be trusted to be border-box.
                    if ( ( !support.boxSizingReliable() && isBorderBox ||

                            // Support: IE 10 - 11+, Edge 15 - 18+
                            // IE/Edge misreport `getComputedStyle` of table rows with width/height
                            // set in CSS while `offset*` properties report correct values.
                            // Interestingly, in some cases IE 9 doesn't suffer from this issue.
                            !support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

                            // Fall back to offsetWidth/offsetHeight when value is "auto"
                            // This happens for inline elements with no explicit setting (gh-3571)
                            val === "auto" ||

                            // Support: Android <=4.1 - 4.3 only
                            // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
                            !parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

                        // Make sure the element is visible & connected
                        elem.getClientRects().length ) {

                        isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

                        // Where available, offsetWidth/offsetHeight approximate border box dimensions.
                        // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
                        // retrieved value as a content box dimension.
                        valueIsBorderBox = offsetProp in elem;
                        if ( valueIsBorderBox ) {
                            val = elem[ offsetProp ];
                        }
                    }

                    // Normalize "" and auto
                    val = parseFloat( val ) || 0;

                    // Adjust for the element's box model
                    return ( val +
                        boxModelAdjustment(
                            elem,
                            dimension,
                            extra || ( isBorderBox ? "border" : "content" ),
                            valueIsBorderBox,
                            styles,

                            // Provide the current computed size to request scroll gutter calculation (gh-3589)
                            val
                        )
                    ) + "px";
                }

                jQuery.extend( {

                    // Add in style property hooks for overriding the default
                    // behavior of getting and setting a style property
                    cssHooks: {
                        opacity: {
                            get: function( elem, computed ) {
                                if ( computed ) {

                                    // We should always get a number back from opacity
                                    var ret = curCSS( elem, "opacity" );
                                    return ret === "" ? "1" : ret;
                                }
                            }
                        }
                    },

                    // Don't automatically add "px" to these possibly-unitless properties
                    cssNumber: {
                        "animationIterationCount": true,
                        "columnCount": true,
                        "fillOpacity": true,
                        "flexGrow": true,
                        "flexShrink": true,
                        "fontWeight": true,
                        "gridArea": true,
                        "gridColumn": true,
                        "gridColumnEnd": true,
                        "gridColumnStart": true,
                        "gridRow": true,
                        "gridRowEnd": true,
                        "gridRowStart": true,
                        "lineHeight": true,
                        "opacity": true,
                        "order": true,
                        "orphans": true,
                        "widows": true,
                        "zIndex": true,
                        "zoom": true
                    },

                    // Add in properties whose names you wish to fix before
                    // setting or getting the value
                    cssProps: {},

                    // Get and set the style property on a DOM Node
                    style: function( elem, name, value, extra ) {

                        // Don't set styles on text and comment nodes
                        if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
                            return;
                        }

                        // Make sure that we're working with the right name
                        var ret, type, hooks,
                            origName = camelCase( name ),
                            isCustomProp = rcustomProp.test( name ),
                            style = elem.style;

                        // Make sure that we're working with the right name. We don't
                        // want to query the value if it is a CSS custom property
                        // since they are user-defined.
                        if ( !isCustomProp ) {
                            name = finalPropName( origName );
                        }

                        // Gets hook for the prefixed version, then unprefixed version
                        hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

                        // Check if we're setting a value
                        if ( value !== undefined ) {
                            type = typeof value;

                            // Convert "+=" or "-=" to relative numbers (#7345)
                            if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
                                value = adjustCSS( elem, name, ret );

                                // Fixes bug #9237
                                type = "number";
                            }

                            // Make sure that null and NaN values aren't set (#7116)
                            if ( value == null || value !== value ) {
                                return;
                            }

                            // If a number was passed in, add the unit (except for certain CSS properties)
                            // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
                            // "px" to a few hardcoded values.
                            if ( type === "number" && !isCustomProp ) {
                                value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
                            }

                            // background-* props affect original clone's values
                            if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
                                style[ name ] = "inherit";
                            }

                            // If a hook was provided, use that value, otherwise just set the specified value
                            if ( !hooks || !( "set" in hooks ) ||
                                ( value = hooks.set( elem, value, extra ) ) !== undefined ) {

                                if ( isCustomProp ) {
                                    style.setProperty( name, value );
                                } else {
                                    style[ name ] = value;
                                }
                            }

                        } else {

                            // If a hook was provided get the non-computed value from there
                            if ( hooks && "get" in hooks &&
                                ( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

                                return ret;
                            }

                            // Otherwise just get the value from the style object
                            return style[ name ];
                        }
                    },

                    css: function( elem, name, extra, styles ) {
                        var val, num, hooks,
                            origName = camelCase( name ),
                            isCustomProp = rcustomProp.test( name );

                        // Make sure that we're working with the right name. We don't
                        // want to modify the value if it is a CSS custom property
                        // since they are user-defined.
                        if ( !isCustomProp ) {
                            name = finalPropName( origName );
                        }

                        // Try prefixed name followed by the unprefixed name
                        hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

                        // If a hook was provided get the computed value from there
                        if ( hooks && "get" in hooks ) {
                            val = hooks.get( elem, true, extra );
                        }

                        // Otherwise, if a way to get the computed value exists, use that
                        if ( val === undefined ) {
                            val = curCSS( elem, name, styles );
                        }

                        // Convert "normal" to computed value
                        if ( val === "normal" && name in cssNormalTransform ) {
                            val = cssNormalTransform[ name ];
                        }

                        // Make numeric if forced or a qualifier was provided and val looks numeric
                        if ( extra === "" || extra ) {
                            num = parseFloat( val );
                            return extra === true || isFinite( num ) ? num || 0 : val;
                        }

                        return val;
                    }
                } );

                jQuery.each( [ "height", "width" ], function( _i, dimension ) {
                    jQuery.cssHooks[ dimension ] = {
                        get: function( elem, computed, extra ) {
                            if ( computed ) {

                                // Certain elements can have dimension info if we invisibly show them
                                // but it must have a current display style that would benefit
                                return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

                                // Support: Safari 8+
                                // Table columns in Safari have non-zero offsetWidth & zero
                                // getBoundingClientRect().width unless display is changed.
                                // Support: IE <=11 only
                                // Running getBoundingClientRect on a disconnected node
                                // in IE throws an error.
                                ( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
                                    swap( elem, cssShow, function() {
                                        return getWidthOrHeight( elem, dimension, extra );
                                    } ) :
                                    getWidthOrHeight( elem, dimension, extra );
                            }
                        },

                        set: function( elem, value, extra ) {
                            var matches,
                                styles = getStyles( elem ),

                                // Only read styles.position if the test has a chance to fail
                                // to avoid forcing a reflow.
                                scrollboxSizeBuggy = !support.scrollboxSize() &&
                                    styles.position === "absolute",

                                // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
                                boxSizingNeeded = scrollboxSizeBuggy || extra,
                                isBorderBox = boxSizingNeeded &&
                                    jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
                                subtract = extra ?
                                    boxModelAdjustment(
                                        elem,
                                        dimension,
                                        extra,
                                        isBorderBox,
                                        styles
                                    ) :
                                    0;

                            // Account for unreliable border-box dimensions by comparing offset* to computed and
                            // faking a content-box to get border and padding (gh-3699)
                            if ( isBorderBox && scrollboxSizeBuggy ) {
                                subtract -= Math.ceil(
                                    elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
                                    parseFloat( styles[ dimension ] ) -
                                    boxModelAdjustment( elem, dimension, "border", false, styles ) -
                                    0.5
                                );
                            }

                            // Convert to pixels if value adjustment is needed
                            if ( subtract && ( matches = rcssNum.exec( value ) ) &&
                                ( matches[ 3 ] || "px" ) !== "px" ) {

                                elem.style[ dimension ] = value;
                                value = jQuery.css( elem, dimension );
                            }

                            return setPositiveNumber( elem, value, subtract );
                        }
                    };
                } );

                jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
                    function( elem, computed ) {
                        if ( computed ) {
                            return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
                                elem.getBoundingClientRect().left -
                                swap( elem, { marginLeft: 0 }, function() {
                                    return elem.getBoundingClientRect().left;
                                } )
                            ) + "px";
                        }
                    }
                );

// These hooks are used by animate to expand properties
                jQuery.each( {
                    margin: "",
                    padding: "",
                    border: "Width"
                }, function( prefix, suffix ) {
                    jQuery.cssHooks[ prefix + suffix ] = {
                        expand: function( value ) {
                            var i = 0,
                                expanded = {},

                                // Assumes a single number if not a string
                                parts = typeof value === "string" ? value.split( " " ) : [ value ];

                            for ( ; i < 4; i++ ) {
                                expanded[ prefix + cssExpand[ i ] + suffix ] =
                                    parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
                            }

                            return expanded;
                        }
                    };

                    if ( prefix !== "margin" ) {
                        jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
                    }
                } );

                jQuery.fn.extend( {
                    css: function( name, value ) {
                        return access( this, function( elem, name, value ) {
                            var styles, len,
                                map = {},
                                i = 0;

                            if ( Array.isArray( name ) ) {
                                styles = getStyles( elem );
                                len = name.length;

                                for ( ; i < len; i++ ) {
                                    map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
                                }

                                return map;
                            }

                            return value !== undefined ?
                                jQuery.style( elem, name, value ) :
                                jQuery.css( elem, name );
                        }, name, value, arguments.length > 1 );
                    }
                } );


                function Tween( elem, options, prop, end, easing ) {
                    return new Tween.prototype.init( elem, options, prop, end, easing );
                }
                jQuery.Tween = Tween;

                Tween.prototype = {
                    constructor: Tween,
                    init: function( elem, options, prop, end, easing, unit ) {
                        this.elem = elem;
                        this.prop = prop;
                        this.easing = easing || jQuery.easing._default;
                        this.options = options;
                        this.start = this.now = this.cur();
                        this.end = end;
                        this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
                    },
                    cur: function() {
                        var hooks = Tween.propHooks[ this.prop ];

                        return hooks && hooks.get ?
                            hooks.get( this ) :
                            Tween.propHooks._default.get( this );
                    },
                    run: function( percent ) {
                        var eased,
                            hooks = Tween.propHooks[ this.prop ];

                        if ( this.options.duration ) {
                            this.pos = eased = jQuery.easing[ this.easing ](
                                percent, this.options.duration * percent, 0, 1, this.options.duration
                            );
                        } else {
                            this.pos = eased = percent;
                        }
                        this.now = ( this.end - this.start ) * eased + this.start;

                        if ( this.options.step ) {
                            this.options.step.call( this.elem, this.now, this );
                        }

                        if ( hooks && hooks.set ) {
                            hooks.set( this );
                        } else {
                            Tween.propHooks._default.set( this );
                        }
                        return this;
                    }
                };

                Tween.prototype.init.prototype = Tween.prototype;

                Tween.propHooks = {
                    _default: {
                        get: function( tween ) {
                            var result;

                            // Use a property on the element directly when it is not a DOM element,
                            // or when there is no matching style property that exists.
                            if ( tween.elem.nodeType !== 1 ||
                                tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
                                return tween.elem[ tween.prop ];
                            }

                            // Passing an empty string as a 3rd parameter to .css will automatically
                            // attempt a parseFloat and fallback to a string if the parse fails.
                            // Simple values such as "10px" are parsed to Float;
                            // complex values such as "rotate(1rad)" are returned as-is.
                            result = jQuery.css( tween.elem, tween.prop, "" );

                            // Empty strings, null, undefined and "auto" are converted to 0.
                            return !result || result === "auto" ? 0 : result;
                        },
                        set: function( tween ) {

                            // Use step hook for back compat.
                            // Use cssHook if its there.
                            // Use .style if available and use plain properties where available.
                            if ( jQuery.fx.step[ tween.prop ] ) {
                                jQuery.fx.step[ tween.prop ]( tween );
                            } else if ( tween.elem.nodeType === 1 && (
                                jQuery.cssHooks[ tween.prop ] ||
                                tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
                                jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
                            } else {
                                tween.elem[ tween.prop ] = tween.now;
                            }
                        }
                    }
                };

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
                Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
                    set: function( tween ) {
                        if ( tween.elem.nodeType && tween.elem.parentNode ) {
                            tween.elem[ tween.prop ] = tween.now;
                        }
                    }
                };

                jQuery.easing = {
                    linear: function( p ) {
                        return p;
                    },
                    swing: function( p ) {
                        return 0.5 - Math.cos( p * Math.PI ) / 2;
                    },
                    _default: "swing"
                };

                jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
                jQuery.fx.step = {};




                var
                    fxNow, inProgress,
                    rfxtypes = /^(?:toggle|show|hide)$/,
                    rrun = /queueHooks$/;

                function schedule() {
                    if ( inProgress ) {
                        if ( document.hidden === false && window.requestAnimationFrame ) {
                            window.requestAnimationFrame( schedule );
                        } else {
                            window.setTimeout( schedule, jQuery.fx.interval );
                        }

                        jQuery.fx.tick();
                    }
                }

// Animations created synchronously will run synchronously
                function createFxNow() {
                    window.setTimeout( function() {
                        fxNow = undefined;
                    } );
                    return ( fxNow = Date.now() );
                }

// Generate parameters to create a standard animation
                function genFx( type, includeWidth ) {
                    var which,
                        i = 0,
                        attrs = { height: type };

                    // If we include width, step value is 1 to do all cssExpand values,
                    // otherwise step value is 2 to skip over Left and Right
                    includeWidth = includeWidth ? 1 : 0;
                    for ( ; i < 4; i += 2 - includeWidth ) {
                        which = cssExpand[ i ];
                        attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
                    }

                    if ( includeWidth ) {
                        attrs.opacity = attrs.width = type;
                    }

                    return attrs;
                }

                function createTween( value, prop, animation ) {
                    var tween,
                        collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
                        index = 0,
                        length = collection.length;
                    for ( ; index < length; index++ ) {
                        if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

                            // We're done with this property
                            return tween;
                        }
                    }
                }

                function defaultPrefilter( elem, props, opts ) {
                    var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
                        isBox = "width" in props || "height" in props,
                        anim = this,
                        orig = {},
                        style = elem.style,
                        hidden = elem.nodeType && isHiddenWithinTree( elem ),
                        dataShow = dataPriv.get( elem, "fxshow" );

                    // Queue-skipping animations hijack the fx hooks
                    if ( !opts.queue ) {
                        hooks = jQuery._queueHooks( elem, "fx" );
                        if ( hooks.unqueued == null ) {
                            hooks.unqueued = 0;
                            oldfire = hooks.empty.fire;
                            hooks.empty.fire = function() {
                                if ( !hooks.unqueued ) {
                                    oldfire();
                                }
                            };
                        }
                        hooks.unqueued++;

                        anim.always( function() {

                            // Ensure the complete handler is called before this completes
                            anim.always( function() {
                                hooks.unqueued--;
                                if ( !jQuery.queue( elem, "fx" ).length ) {
                                    hooks.empty.fire();
                                }
                            } );
                        } );
                    }

                    // Detect show/hide animations
                    for ( prop in props ) {
                        value = props[ prop ];
                        if ( rfxtypes.test( value ) ) {
                            delete props[ prop ];
                            toggle = toggle || value === "toggle";
                            if ( value === ( hidden ? "hide" : "show" ) ) {

                                // Pretend to be hidden if this is a "show" and
                                // there is still data from a stopped show/hide
                                if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
                                    hidden = true;

                                    // Ignore all other no-op show/hide data
                                } else {
                                    continue;
                                }
                            }
                            orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
                        }
                    }

                    // Bail out if this is a no-op like .hide().hide()
                    propTween = !jQuery.isEmptyObject( props );
                    if ( !propTween && jQuery.isEmptyObject( orig ) ) {
                        return;
                    }

                    // Restrict "overflow" and "display" styles during box animations
                    if ( isBox && elem.nodeType === 1 ) {

                        // Support: IE <=9 - 11, Edge 12 - 15
                        // Record all 3 overflow attributes because IE does not infer the shorthand
                        // from identically-valued overflowX and overflowY and Edge just mirrors
                        // the overflowX value there.
                        opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

                        // Identify a display type, preferring old show/hide data over the CSS cascade
                        restoreDisplay = dataShow && dataShow.display;
                        if ( restoreDisplay == null ) {
                            restoreDisplay = dataPriv.get( elem, "display" );
                        }
                        display = jQuery.css( elem, "display" );
                        if ( display === "none" ) {
                            if ( restoreDisplay ) {
                                display = restoreDisplay;
                            } else {

                                // Get nonempty value(s) by temporarily forcing visibility
                                showHide( [ elem ], true );
                                restoreDisplay = elem.style.display || restoreDisplay;
                                display = jQuery.css( elem, "display" );
                                showHide( [ elem ] );
                            }
                        }

                        // Animate inline elements as inline-block
                        if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
                            if ( jQuery.css( elem, "float" ) === "none" ) {

                                // Restore the original display value at the end of pure show/hide animations
                                if ( !propTween ) {
                                    anim.done( function() {
                                        style.display = restoreDisplay;
                                    } );
                                    if ( restoreDisplay == null ) {
                                        display = style.display;
                                        restoreDisplay = display === "none" ? "" : display;
                                    }
                                }
                                style.display = "inline-block";
                            }
                        }
                    }

                    if ( opts.overflow ) {
                        style.overflow = "hidden";
                        anim.always( function() {
                            style.overflow = opts.overflow[ 0 ];
                            style.overflowX = opts.overflow[ 1 ];
                            style.overflowY = opts.overflow[ 2 ];
                        } );
                    }

                    // Implement show/hide animations
                    propTween = false;
                    for ( prop in orig ) {

                        // General show/hide setup for this element animation
                        if ( !propTween ) {
                            if ( dataShow ) {
                                if ( "hidden" in dataShow ) {
                                    hidden = dataShow.hidden;
                                }
                            } else {
                                dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
                            }

                            // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                            if ( toggle ) {
                                dataShow.hidden = !hidden;
                            }

                            // Show elements before animating them
                            if ( hidden ) {
                                showHide( [ elem ], true );
                            }

                            /* eslint-disable no-loop-func */

                            anim.done( function() {

                                /* eslint-enable no-loop-func */

                                // The final step of a "hide" animation is actually hiding the element
                                if ( !hidden ) {
                                    showHide( [ elem ] );
                                }
                                dataPriv.remove( elem, "fxshow" );
                                for ( prop in orig ) {
                                    jQuery.style( elem, prop, orig[ prop ] );
                                }
                            } );
                        }

                        // Per-property setup
                        propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
                        if ( !( prop in dataShow ) ) {
                            dataShow[ prop ] = propTween.start;
                            if ( hidden ) {
                                propTween.end = propTween.start;
                                propTween.start = 0;
                            }
                        }
                    }
                }

                function propFilter( props, specialEasing ) {
                    var index, name, easing, value, hooks;

                    // camelCase, specialEasing and expand cssHook pass
                    for ( index in props ) {
                        name = camelCase( index );
                        easing = specialEasing[ name ];
                        value = props[ index ];
                        if ( Array.isArray( value ) ) {
                            easing = value[ 1 ];
                            value = props[ index ] = value[ 0 ];
                        }

                        if ( index !== name ) {
                            props[ name ] = value;
                            delete props[ index ];
                        }

                        hooks = jQuery.cssHooks[ name ];
                        if ( hooks && "expand" in hooks ) {
                            value = hooks.expand( value );
                            delete props[ name ];

                            // Not quite $.extend, this won't overwrite existing keys.
                            // Reusing 'index' because we have the correct "name"
                            for ( index in value ) {
                                if ( !( index in props ) ) {
                                    props[ index ] = value[ index ];
                                    specialEasing[ index ] = easing;
                                }
                            }
                        } else {
                            specialEasing[ name ] = easing;
                        }
                    }
                }

                function Animation( elem, properties, options ) {
                    var result,
                        stopped,
                        index = 0,
                        length = Animation.prefilters.length,
                        deferred = jQuery.Deferred().always( function() {

                            // Don't match elem in the :animated selector
                            delete tick.elem;
                        } ),
                        tick = function() {
                            if ( stopped ) {
                                return false;
                            }
                            var currentTime = fxNow || createFxNow(),
                                remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

                                // Support: Android 2.3 only
                                // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
                                temp = remaining / animation.duration || 0,
                                percent = 1 - temp,
                                index = 0,
                                length = animation.tweens.length;

                            for ( ; index < length; index++ ) {
                                animation.tweens[ index ].run( percent );
                            }

                            deferred.notifyWith( elem, [ animation, percent, remaining ] );

                            // If there's more to do, yield
                            if ( percent < 1 && length ) {
                                return remaining;
                            }

                            // If this was an empty animation, synthesize a final progress notification
                            if ( !length ) {
                                deferred.notifyWith( elem, [ animation, 1, 0 ] );
                            }

                            // Resolve the animation and report its conclusion
                            deferred.resolveWith( elem, [ animation ] );
                            return false;
                        },
                        animation = deferred.promise( {
                            elem: elem,
                            props: jQuery.extend( {}, properties ),
                            opts: jQuery.extend( true, {
                                specialEasing: {},
                                easing: jQuery.easing._default
                            }, options ),
                            originalProperties: properties,
                            originalOptions: options,
                            startTime: fxNow || createFxNow(),
                            duration: options.duration,
                            tweens: [],
                            createTween: function( prop, end ) {
                                var tween = jQuery.Tween( elem, animation.opts, prop, end,
                                    animation.opts.specialEasing[ prop ] || animation.opts.easing );
                                animation.tweens.push( tween );
                                return tween;
                            },
                            stop: function( gotoEnd ) {
                                var index = 0,

                                    // If we are going to the end, we want to run all the tweens
                                    // otherwise we skip this part
                                    length = gotoEnd ? animation.tweens.length : 0;
                                if ( stopped ) {
                                    return this;
                                }
                                stopped = true;
                                for ( ; index < length; index++ ) {
                                    animation.tweens[ index ].run( 1 );
                                }

                                // Resolve when we played the last frame; otherwise, reject
                                if ( gotoEnd ) {
                                    deferred.notifyWith( elem, [ animation, 1, 0 ] );
                                    deferred.resolveWith( elem, [ animation, gotoEnd ] );
                                } else {
                                    deferred.rejectWith( elem, [ animation, gotoEnd ] );
                                }
                                return this;
                            }
                        } ),
                        props = animation.props;

                    propFilter( props, animation.opts.specialEasing );

                    for ( ; index < length; index++ ) {
                        result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
                        if ( result ) {
                            if ( isFunction( result.stop ) ) {
                                jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
                                    result.stop.bind( result );
                            }
                            return result;
                        }
                    }

                    jQuery.map( props, createTween, animation );

                    if ( isFunction( animation.opts.start ) ) {
                        animation.opts.start.call( elem, animation );
                    }

                    // Attach callbacks from options
                    animation
                        .progress( animation.opts.progress )
                        .done( animation.opts.done, animation.opts.complete )
                        .fail( animation.opts.fail )
                        .always( animation.opts.always );

                    jQuery.fx.timer(
                        jQuery.extend( tick, {
                            elem: elem,
                            anim: animation,
                            queue: animation.opts.queue
                        } )
                    );

                    return animation;
                }

                jQuery.Animation = jQuery.extend( Animation, {

                    tweeners: {
                        "*": [ function( prop, value ) {
                            var tween = this.createTween( prop, value );
                            adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
                            return tween;
                        } ]
                    },

                    tweener: function( props, callback ) {
                        if ( isFunction( props ) ) {
                            callback = props;
                            props = [ "*" ];
                        } else {
                            props = props.match( rnothtmlwhite );
                        }

                        var prop,
                            index = 0,
                            length = props.length;

                        for ( ; index < length; index++ ) {
                            prop = props[ index ];
                            Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
                            Animation.tweeners[ prop ].unshift( callback );
                        }
                    },

                    prefilters: [ defaultPrefilter ],

                    prefilter: function( callback, prepend ) {
                        if ( prepend ) {
                            Animation.prefilters.unshift( callback );
                        } else {
                            Animation.prefilters.push( callback );
                        }
                    }
                } );

                jQuery.speed = function( speed, easing, fn ) {
                    var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
                        complete: fn || !fn && easing ||
                            isFunction( speed ) && speed,
                        duration: speed,
                        easing: fn && easing || easing && !isFunction( easing ) && easing
                    };

                    // Go to the end state if fx are off
                    if ( jQuery.fx.off ) {
                        opt.duration = 0;

                    } else {
                        if ( typeof opt.duration !== "number" ) {
                            if ( opt.duration in jQuery.fx.speeds ) {
                                opt.duration = jQuery.fx.speeds[ opt.duration ];

                            } else {
                                opt.duration = jQuery.fx.speeds._default;
                            }
                        }
                    }

                    // Normalize opt.queue - true/undefined/null -> "fx"
                    if ( opt.queue == null || opt.queue === true ) {
                        opt.queue = "fx";
                    }

                    // Queueing
                    opt.old = opt.complete;

                    opt.complete = function() {
                        if ( isFunction( opt.old ) ) {
                            opt.old.call( this );
                        }

                        if ( opt.queue ) {
                            jQuery.dequeue( this, opt.queue );
                        }
                    };

                    return opt;
                };

                jQuery.fn.extend( {
                    fadeTo: function( speed, to, easing, callback ) {

                        // Show any hidden elements after setting opacity to 0
                        return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

                            // Animate to the value specified
                            .end().animate( { opacity: to }, speed, easing, callback );
                    },
                    animate: function( prop, speed, easing, callback ) {
                        var empty = jQuery.isEmptyObject( prop ),
                            optall = jQuery.speed( speed, easing, callback ),
                            doAnimation = function() {

                                // Operate on a copy of prop so per-property easing won't be lost
                                var anim = Animation( this, jQuery.extend( {}, prop ), optall );

                                // Empty animations, or finishing resolves immediately
                                if ( empty || dataPriv.get( this, "finish" ) ) {
                                    anim.stop( true );
                                }
                            };

                        doAnimation.finish = doAnimation;

                        return empty || optall.queue === false ?
                            this.each( doAnimation ) :
                            this.queue( optall.queue, doAnimation );
                    },
                    stop: function( type, clearQueue, gotoEnd ) {
                        var stopQueue = function( hooks ) {
                            var stop = hooks.stop;
                            delete hooks.stop;
                            stop( gotoEnd );
                        };

                        if ( typeof type !== "string" ) {
                            gotoEnd = clearQueue;
                            clearQueue = type;
                            type = undefined;
                        }
                        if ( clearQueue ) {
                            this.queue( type || "fx", [] );
                        }

                        return this.each( function() {
                            var dequeue = true,
                                index = type != null && type + "queueHooks",
                                timers = jQuery.timers,
                                data = dataPriv.get( this );

                            if ( index ) {
                                if ( data[ index ] && data[ index ].stop ) {
                                    stopQueue( data[ index ] );
                                }
                            } else {
                                for ( index in data ) {
                                    if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
                                        stopQueue( data[ index ] );
                                    }
                                }
                            }

                            for ( index = timers.length; index--; ) {
                                if ( timers[ index ].elem === this &&
                                    ( type == null || timers[ index ].queue === type ) ) {

                                    timers[ index ].anim.stop( gotoEnd );
                                    dequeue = false;
                                    timers.splice( index, 1 );
                                }
                            }

                            // Start the next in the queue if the last step wasn't forced.
                            // Timers currently will call their complete callbacks, which
                            // will dequeue but only if they were gotoEnd.
                            if ( dequeue || !gotoEnd ) {
                                jQuery.dequeue( this, type );
                            }
                        } );
                    },
                    finish: function( type ) {
                        if ( type !== false ) {
                            type = type || "fx";
                        }
                        return this.each( function() {
                            var index,
                                data = dataPriv.get( this ),
                                queue = data[ type + "queue" ],
                                hooks = data[ type + "queueHooks" ],
                                timers = jQuery.timers,
                                length = queue ? queue.length : 0;

                            // Enable finishing flag on private data
                            data.finish = true;

                            // Empty the queue first
                            jQuery.queue( this, type, [] );

                            if ( hooks && hooks.stop ) {
                                hooks.stop.call( this, true );
                            }

                            // Look for any active animations, and finish them
                            for ( index = timers.length; index--; ) {
                                if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
                                    timers[ index ].anim.stop( true );
                                    timers.splice( index, 1 );
                                }
                            }

                            // Look for any animations in the old queue and finish them
                            for ( index = 0; index < length; index++ ) {
                                if ( queue[ index ] && queue[ index ].finish ) {
                                    queue[ index ].finish.call( this );
                                }
                            }

                            // Turn off finishing flag
                            delete data.finish;
                        } );
                    }
                } );

                jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
                    var cssFn = jQuery.fn[ name ];
                    jQuery.fn[ name ] = function( speed, easing, callback ) {
                        return speed == null || typeof speed === "boolean" ?
                            cssFn.apply( this, arguments ) :
                            this.animate( genFx( name, true ), speed, easing, callback );
                    };
                } );

// Generate shortcuts for custom animations
                jQuery.each( {
                    slideDown: genFx( "show" ),
                    slideUp: genFx( "hide" ),
                    slideToggle: genFx( "toggle" ),
                    fadeIn: { opacity: "show" },
                    fadeOut: { opacity: "hide" },
                    fadeToggle: { opacity: "toggle" }
                }, function( name, props ) {
                    jQuery.fn[ name ] = function( speed, easing, callback ) {
                        return this.animate( props, speed, easing, callback );
                    };
                } );

                jQuery.timers = [];
                jQuery.fx.tick = function() {
                    var timer,
                        i = 0,
                        timers = jQuery.timers;

                    fxNow = Date.now();

                    for ( ; i < timers.length; i++ ) {
                        timer = timers[ i ];

                        // Run the timer and safely remove it when done (allowing for external removal)
                        if ( !timer() && timers[ i ] === timer ) {
                            timers.splice( i--, 1 );
                        }
                    }

                    if ( !timers.length ) {
                        jQuery.fx.stop();
                    }
                    fxNow = undefined;
                };

                jQuery.fx.timer = function( timer ) {
                    jQuery.timers.push( timer );
                    jQuery.fx.start();
                };

                jQuery.fx.interval = 13;
                jQuery.fx.start = function() {
                    if ( inProgress ) {
                        return;
                    }

                    inProgress = true;
                    schedule();
                };

                jQuery.fx.stop = function() {
                    inProgress = null;
                };

                jQuery.fx.speeds = {
                    slow: 600,
                    fast: 200,

                    // Default speed
                    _default: 400
                };


// Based off of the plugin by Clint Helfers, with permission.
// https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
                jQuery.fn.delay = function( time, type ) {
                    time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
                    type = type || "fx";

                    return this.queue( type, function( next, hooks ) {
                        var timeout = window.setTimeout( next, time );
                        hooks.stop = function() {
                            window.clearTimeout( timeout );
                        };
                    } );
                };


                ( function() {
                    var input = document.createElement( "input" ),
                        select = document.createElement( "select" ),
                        opt = select.appendChild( document.createElement( "option" ) );

                    input.type = "checkbox";

                    // Support: Android <=4.3 only
                    // Default value for a checkbox should be "on"
                    support.checkOn = input.value !== "";

                    // Support: IE <=11 only
                    // Must access selectedIndex to make default options select
                    support.optSelected = opt.selected;

                    // Support: IE <=11 only
                    // An input loses its value after becoming a radio
                    input = document.createElement( "input" );
                    input.value = "t";
                    input.type = "radio";
                    support.radioValue = input.value === "t";
                } )();


                var boolHook,
                    attrHandle = jQuery.expr.attrHandle;

                jQuery.fn.extend( {
                    attr: function( name, value ) {
                        return access( this, jQuery.attr, name, value, arguments.length > 1 );
                    },

                    removeAttr: function( name ) {
                        return this.each( function() {
                            jQuery.removeAttr( this, name );
                        } );
                    }
                } );

                jQuery.extend( {
                    attr: function( elem, name, value ) {
                        var ret, hooks,
                            nType = elem.nodeType;

                        // Don't get/set attributes on text, comment and attribute nodes
                        if ( nType === 3 || nType === 8 || nType === 2 ) {
                            return;
                        }

                        // Fallback to prop when attributes are not supported
                        if ( typeof elem.getAttribute === "undefined" ) {
                            return jQuery.prop( elem, name, value );
                        }

                        // Attribute hooks are determined by the lowercase version
                        // Grab necessary hook if one is defined
                        if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
                            hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
                                ( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
                        }

                        if ( value !== undefined ) {
                            if ( value === null ) {
                                jQuery.removeAttr( elem, name );
                                return;
                            }

                            if ( hooks && "set" in hooks &&
                                ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                                return ret;
                            }

                            elem.setAttribute( name, value + "" );
                            return value;
                        }

                        if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
                            return ret;
                        }

                        ret = jQuery.find.attr( elem, name );

                        // Non-existent attributes return null, we normalize to undefined
                        return ret == null ? undefined : ret;
                    },

                    attrHooks: {
                        type: {
                            set: function( elem, value ) {
                                if ( !support.radioValue && value === "radio" &&
                                    nodeName( elem, "input" ) ) {
                                    var val = elem.value;
                                    elem.setAttribute( "type", value );
                                    if ( val ) {
                                        elem.value = val;
                                    }
                                    return value;
                                }
                            }
                        }
                    },

                    removeAttr: function( elem, value ) {
                        var name,
                            i = 0,

                            // Attribute names can contain non-HTML whitespace characters
                            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
                            attrNames = value && value.match( rnothtmlwhite );

                        if ( attrNames && elem.nodeType === 1 ) {
                            while ( ( name = attrNames[ i++ ] ) ) {
                                elem.removeAttribute( name );
                            }
                        }
                    }
                } );

// Hooks for boolean attributes
                boolHook = {
                    set: function( elem, value, name ) {
                        if ( value === false ) {

                            // Remove boolean attributes when set to false
                            jQuery.removeAttr( elem, name );
                        } else {
                            elem.setAttribute( name, name );
                        }
                        return name;
                    }
                };

                jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
                    var getter = attrHandle[ name ] || jQuery.find.attr;

                    attrHandle[ name ] = function( elem, name, isXML ) {
                        var ret, handle,
                            lowercaseName = name.toLowerCase();

                        if ( !isXML ) {

                            // Avoid an infinite loop by temporarily removing this function from the getter
                            handle = attrHandle[ lowercaseName ];
                            attrHandle[ lowercaseName ] = ret;
                            ret = getter( elem, name, isXML ) != null ?
                                lowercaseName :
                                null;
                            attrHandle[ lowercaseName ] = handle;
                        }
                        return ret;
                    };
                } );




                var rfocusable = /^(?:input|select|textarea|button)$/i,
                    rclickable = /^(?:a|area)$/i;

                jQuery.fn.extend( {
                    prop: function( name, value ) {
                        return access( this, jQuery.prop, name, value, arguments.length > 1 );
                    },

                    removeProp: function( name ) {
                        return this.each( function() {
                            delete this[ jQuery.propFix[ name ] || name ];
                        } );
                    }
                } );

                jQuery.extend( {
                    prop: function( elem, name, value ) {
                        var ret, hooks,
                            nType = elem.nodeType;

                        // Don't get/set properties on text, comment and attribute nodes
                        if ( nType === 3 || nType === 8 || nType === 2 ) {
                            return;
                        }

                        if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

                            // Fix name and attach hooks
                            name = jQuery.propFix[ name ] || name;
                            hooks = jQuery.propHooks[ name ];
                        }

                        if ( value !== undefined ) {
                            if ( hooks && "set" in hooks &&
                                ( ret = hooks.set( elem, value, name ) ) !== undefined ) {
                                return ret;
                            }

                            return ( elem[ name ] = value );
                        }

                        if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
                            return ret;
                        }

                        return elem[ name ];
                    },

                    propHooks: {
                        tabIndex: {
                            get: function( elem ) {

                                // Support: IE <=9 - 11 only
                                // elem.tabIndex doesn't always return the
                                // correct value when it hasn't been explicitly set
                                // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                                // Use proper attribute retrieval(#12072)
                                var tabindex = jQuery.find.attr( elem, "tabindex" );

                                if ( tabindex ) {
                                    return parseInt( tabindex, 10 );
                                }

                                if (
                                    rfocusable.test( elem.nodeName ) ||
                                    rclickable.test( elem.nodeName ) &&
                                    elem.href
                                ) {
                                    return 0;
                                }

                                return -1;
                            }
                        }
                    },

                    propFix: {
                        "for": "htmlFor",
                        "class": "className"
                    }
                } );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
                if ( !support.optSelected ) {
                    jQuery.propHooks.selected = {
                        get: function( elem ) {

                            /* eslint no-unused-expressions: "off" */

                            var parent = elem.parentNode;
                            if ( parent && parent.parentNode ) {
                                parent.parentNode.selectedIndex;
                            }
                            return null;
                        },
                        set: function( elem ) {

                            /* eslint no-unused-expressions: "off" */

                            var parent = elem.parentNode;
                            if ( parent ) {
                                parent.selectedIndex;

                                if ( parent.parentNode ) {
                                    parent.parentNode.selectedIndex;
                                }
                            }
                        }
                    };
                }

                jQuery.each( [
                    "tabIndex",
                    "readOnly",
                    "maxLength",
                    "cellSpacing",
                    "cellPadding",
                    "rowSpan",
                    "colSpan",
                    "useMap",
                    "frameBorder",
                    "contentEditable"
                ], function() {
                    jQuery.propFix[ this.toLowerCase() ] = this;
                } );




                // Strip and collapse whitespace according to HTML spec
                // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
                function stripAndCollapse( value ) {
                    var tokens = value.match( rnothtmlwhite ) || [];
                    return tokens.join( " " );
                }


                function getClass( elem ) {
                    return elem.getAttribute && elem.getAttribute( "class" ) || "";
                }

                function classesToArray( value ) {
                    if ( Array.isArray( value ) ) {
                        return value;
                    }
                    if ( typeof value === "string" ) {
                        return value.match( rnothtmlwhite ) || [];
                    }
                    return [];
                }

                jQuery.fn.extend( {
                    addClass: function( value ) {
                        var classes, elem, cur, curValue, clazz, j, finalValue,
                            i = 0;

                        if ( isFunction( value ) ) {
                            return this.each( function( j ) {
                                jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
                            } );
                        }

                        classes = classesToArray( value );

                        if ( classes.length ) {
                            while ( ( elem = this[ i++ ] ) ) {
                                curValue = getClass( elem );
                                cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

                                if ( cur ) {
                                    j = 0;
                                    while ( ( clazz = classes[ j++ ] ) ) {
                                        if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
                                            cur += clazz + " ";
                                        }
                                    }

                                    // Only assign if different to avoid unneeded rendering.
                                    finalValue = stripAndCollapse( cur );
                                    if ( curValue !== finalValue ) {
                                        elem.setAttribute( "class", finalValue );
                                    }
                                }
                            }
                        }

                        return this;
                    },

                    removeClass: function( value ) {
                        var classes, elem, cur, curValue, clazz, j, finalValue,
                            i = 0;

                        if ( isFunction( value ) ) {
                            return this.each( function( j ) {
                                jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
                            } );
                        }

                        if ( !arguments.length ) {
                            return this.attr( "class", "" );
                        }

                        classes = classesToArray( value );

                        if ( classes.length ) {
                            while ( ( elem = this[ i++ ] ) ) {
                                curValue = getClass( elem );

                                // This expression is here for better compressibility (see addClass)
                                cur = elem.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

                                if ( cur ) {
                                    j = 0;
                                    while ( ( clazz = classes[ j++ ] ) ) {

                                        // Remove *all* instances
                                        while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
                                            cur = cur.replace( " " + clazz + " ", " " );
                                        }
                                    }

                                    // Only assign if different to avoid unneeded rendering.
                                    finalValue = stripAndCollapse( cur );
                                    if ( curValue !== finalValue ) {
                                        elem.setAttribute( "class", finalValue );
                                    }
                                }
                            }
                        }

                        return this;
                    },

                    toggleClass: function( value, stateVal ) {
                        var type = typeof value,
                            isValidValue = type === "string" || Array.isArray( value );

                        if ( typeof stateVal === "boolean" && isValidValue ) {
                            return stateVal ? this.addClass( value ) : this.removeClass( value );
                        }

                        if ( isFunction( value ) ) {
                            return this.each( function( i ) {
                                jQuery( this ).toggleClass(
                                    value.call( this, i, getClass( this ), stateVal ),
                                    stateVal
                                );
                            } );
                        }

                        return this.each( function() {
                            var className, i, self, classNames;

                            if ( isValidValue ) {

                                // Toggle individual class names
                                i = 0;
                                self = jQuery( this );
                                classNames = classesToArray( value );

                                while ( ( className = classNames[ i++ ] ) ) {

                                    // Check each className given, space separated list
                                    if ( self.hasClass( className ) ) {
                                        self.removeClass( className );
                                    } else {
                                        self.addClass( className );
                                    }
                                }

                                // Toggle whole class name
                            } else if ( value === undefined || type === "boolean" ) {
                                className = getClass( this );
                                if ( className ) {

                                    // Store className if set
                                    dataPriv.set( this, "__className__", className );
                                }

                                // If the element has a class name or if we're passed `false`,
                                // then remove the whole classname (if there was one, the above saved it).
                                // Otherwise bring back whatever was previously saved (if anything),
                                // falling back to the empty string if nothing was stored.
                                if ( this.setAttribute ) {
                                    this.setAttribute( "class",
                                        className || value === false ?
                                            "" :
                                            dataPriv.get( this, "__className__" ) || ""
                                    );
                                }
                            }
                        } );
                    },

                    hasClass: function( selector ) {
                        var className, elem,
                            i = 0;

                        className = " " + selector + " ";
                        while ( ( elem = this[ i++ ] ) ) {
                            if ( elem.nodeType === 1 &&
                                ( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
                                return true;
                            }
                        }

                        return false;
                    }
                } );




                var rreturn = /\r/g;

                jQuery.fn.extend( {
                    val: function( value ) {
                        var hooks, ret, valueIsFunction,
                            elem = this[ 0 ];

                        if ( !arguments.length ) {
                            if ( elem ) {
                                hooks = jQuery.valHooks[ elem.type ] ||
                                    jQuery.valHooks[ elem.nodeName.toLowerCase() ];

                                if ( hooks &&
                                    "get" in hooks &&
                                    ( ret = hooks.get( elem, "value" ) ) !== undefined
                                ) {
                                    return ret;
                                }

                                ret = elem.value;

                                // Handle most common string cases
                                if ( typeof ret === "string" ) {
                                    return ret.replace( rreturn, "" );
                                }

                                // Handle cases where value is null/undef or number
                                return ret == null ? "" : ret;
                            }

                            return;
                        }

                        valueIsFunction = isFunction( value );

                        return this.each( function( i ) {
                            var val;

                            if ( this.nodeType !== 1 ) {
                                return;
                            }

                            if ( valueIsFunction ) {
                                val = value.call( this, i, jQuery( this ).val() );
                            } else {
                                val = value;
                            }

                            // Treat null/undefined as ""; convert numbers to string
                            if ( val == null ) {
                                val = "";

                            } else if ( typeof val === "number" ) {
                                val += "";

                            } else if ( Array.isArray( val ) ) {
                                val = jQuery.map( val, function( value ) {
                                    return value == null ? "" : value + "";
                                } );
                            }

                            hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

                            // If set returns undefined, fall back to normal setting
                            if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
                                this.value = val;
                            }
                        } );
                    }
                } );

                jQuery.extend( {
                    valHooks: {
                        option: {
                            get: function( elem ) {

                                var val = jQuery.find.attr( elem, "value" );
                                return val != null ?
                                    val :

                                    // Support: IE <=10 - 11 only
                                    // option.text throws exceptions (#14686, #14858)
                                    // Strip and collapse whitespace
                                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                                    stripAndCollapse( jQuery.text( elem ) );
                            }
                        },
                        select: {
                            get: function( elem ) {
                                var value, option, i,
                                    options = elem.options,
                                    index = elem.selectedIndex,
                                    one = elem.type === "select-one",
                                    values = one ? null : [],
                                    max = one ? index + 1 : options.length;

                                if ( index < 0 ) {
                                    i = max;

                                } else {
                                    i = one ? index : 0;
                                }

                                // Loop through all the selected options
                                for ( ; i < max; i++ ) {
                                    option = options[ i ];

                                    // Support: IE <=9 only
                                    // IE8-9 doesn't update selected after form reset (#2551)
                                    if ( ( option.selected || i === index ) &&

                                        // Don't return options that are disabled or in a disabled optgroup
                                        !option.disabled &&
                                        ( !option.parentNode.disabled ||
                                            !nodeName( option.parentNode, "optgroup" ) ) ) {

                                        // Get the specific value for the option
                                        value = jQuery( option ).val();

                                        // We don't need an array for one selects
                                        if ( one ) {
                                            return value;
                                        }

                                        // Multi-Selects return an array
                                        values.push( value );
                                    }
                                }

                                return values;
                            },

                            set: function( elem, value ) {
                                var optionSet, option,
                                    options = elem.options,
                                    values = jQuery.makeArray( value ),
                                    i = options.length;

                                while ( i-- ) {
                                    option = options[ i ];

                                    /* eslint-disable no-cond-assign */

                                    if ( option.selected =
                                        jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
                                    ) {
                                        optionSet = true;
                                    }

                                    /* eslint-enable no-cond-assign */
                                }

                                // Force browsers to behave consistently when non-matching value is set
                                if ( !optionSet ) {
                                    elem.selectedIndex = -1;
                                }
                                return values;
                            }
                        }
                    }
                } );

// Radios and checkboxes getter/setter
                jQuery.each( [ "radio", "checkbox" ], function() {
                    jQuery.valHooks[ this ] = {
                        set: function( elem, value ) {
                            if ( Array.isArray( value ) ) {
                                return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
                            }
                        }
                    };
                    if ( !support.checkOn ) {
                        jQuery.valHooks[ this ].get = function( elem ) {
                            return elem.getAttribute( "value" ) === null ? "on" : elem.value;
                        };
                    }
                } );




// Return jQuery for attributes-only inclusion


                support.focusin = "onfocusin" in window;


                var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
                    stopPropagationCallback = function( e ) {
                        e.stopPropagation();
                    };

                jQuery.extend( jQuery.event, {

                    trigger: function( event, data, elem, onlyHandlers ) {

                        var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
                            eventPath = [ elem || document ],
                            type = hasOwn.call( event, "type" ) ? event.type : event,
                            namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

                        cur = lastElement = tmp = elem = elem || document;

                        // Don't do events on text and comment nodes
                        if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
                            return;
                        }

                        // focus/blur morphs to focusin/out; ensure we're not firing them right now
                        if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
                            return;
                        }

                        if ( type.indexOf( "." ) > -1 ) {

                            // Namespaced trigger; create a regexp to match event type in handle()
                            namespaces = type.split( "." );
                            type = namespaces.shift();
                            namespaces.sort();
                        }
                        ontype = type.indexOf( ":" ) < 0 && "on" + type;

                        // Caller can pass in a jQuery.Event object, Object, or just an event type string
                        event = event[ jQuery.expando ] ?
                            event :
                            new jQuery.Event( type, typeof event === "object" && event );

                        // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
                        event.isTrigger = onlyHandlers ? 2 : 3;
                        event.namespace = namespaces.join( "." );
                        event.rnamespace = event.namespace ?
                            new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
                            null;

                        // Clean up the event in case it is being reused
                        event.result = undefined;
                        if ( !event.target ) {
                            event.target = elem;
                        }

                        // Clone any incoming data and prepend the event, creating the handler arg list
                        data = data == null ?
                            [ event ] :
                            jQuery.makeArray( data, [ event ] );

                        // Allow special events to draw outside the lines
                        special = jQuery.event.special[ type ] || {};
                        if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
                            return;
                        }

                        // Determine event propagation path in advance, per W3C events spec (#9951)
                        // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
                        if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

                            bubbleType = special.delegateType || type;
                            if ( !rfocusMorph.test( bubbleType + type ) ) {
                                cur = cur.parentNode;
                            }
                            for ( ; cur; cur = cur.parentNode ) {
                                eventPath.push( cur );
                                tmp = cur;
                            }

                            // Only add window if we got to document (e.g., not plain obj or detached DOM)
                            if ( tmp === ( elem.ownerDocument || document ) ) {
                                eventPath.push( tmp.defaultView || tmp.parentWindow || window );
                            }
                        }

                        // Fire handlers on the event path
                        i = 0;
                        while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
                            lastElement = cur;
                            event.type = i > 1 ?
                                bubbleType :
                                special.bindType || type;

                            // jQuery handler
                            handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
                                dataPriv.get( cur, "handle" );
                            if ( handle ) {
                                handle.apply( cur, data );
                            }

                            // Native handler
                            handle = ontype && cur[ ontype ];
                            if ( handle && handle.apply && acceptData( cur ) ) {
                                event.result = handle.apply( cur, data );
                                if ( event.result === false ) {
                                    event.preventDefault();
                                }
                            }
                        }
                        event.type = type;

                        // If nobody prevented the default action, do it now
                        if ( !onlyHandlers && !event.isDefaultPrevented() ) {

                            if ( ( !special._default ||
                                    special._default.apply( eventPath.pop(), data ) === false ) &&
                                acceptData( elem ) ) {

                                // Call a native DOM method on the target with the same name as the event.
                                // Don't do default actions on window, that's where global variables be (#6170)
                                if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

                                    // Don't re-trigger an onFOO event when we call its FOO() method
                                    tmp = elem[ ontype ];

                                    if ( tmp ) {
                                        elem[ ontype ] = null;
                                    }

                                    // Prevent re-triggering of the same event, since we already bubbled it above
                                    jQuery.event.triggered = type;

                                    if ( event.isPropagationStopped() ) {
                                        lastElement.addEventListener( type, stopPropagationCallback );
                                    }

                                    elem[ type ]();

                                    if ( event.isPropagationStopped() ) {
                                        lastElement.removeEventListener( type, stopPropagationCallback );
                                    }

                                    jQuery.event.triggered = undefined;

                                    if ( tmp ) {
                                        elem[ ontype ] = tmp;
                                    }
                                }
                            }
                        }

                        return event.result;
                    },

                    // Piggyback on a donor event to simulate a different one
                    // Used only for `focus(in | out)` events
                    simulate: function( type, elem, event ) {
                        var e = jQuery.extend(
                            new jQuery.Event(),
                            event,
                            {
                                type: type,
                                isSimulated: true
                            }
                        );

                        jQuery.event.trigger( e, null, elem );
                    }

                } );

                jQuery.fn.extend( {

                    trigger: function( type, data ) {
                        return this.each( function() {
                            jQuery.event.trigger( type, data, this );
                        } );
                    },
                    triggerHandler: function( type, data ) {
                        var elem = this[ 0 ];
                        if ( elem ) {
                            return jQuery.event.trigger( type, data, elem, true );
                        }
                    }
                } );


// Support: Firefox <=44
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
                if ( !support.focusin ) {
                    jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

                        // Attach a single capturing handler on the document while someone wants focusin/focusout
                        var handler = function( event ) {
                            jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
                        };

                        jQuery.event.special[ fix ] = {
                            setup: function() {

                                // Handle: regular nodes (via `this.ownerDocument`), window
                                // (via `this.document`) & document (via `this`).
                                var doc = this.ownerDocument || this.document || this,
                                    attaches = dataPriv.access( doc, fix );

                                if ( !attaches ) {
                                    doc.addEventListener( orig, handler, true );
                                }
                                dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
                            },
                            teardown: function() {
                                var doc = this.ownerDocument || this.document || this,
                                    attaches = dataPriv.access( doc, fix ) - 1;

                                if ( !attaches ) {
                                    doc.removeEventListener( orig, handler, true );
                                    dataPriv.remove( doc, fix );

                                } else {
                                    dataPriv.access( doc, fix, attaches );
                                }
                            }
                        };
                    } );
                }
                var location = window.location;

                var nonce = { guid: Date.now() };

                var rquery = ( /\?/ );



// Cross-browser xml parsing
                jQuery.parseXML = function( data ) {
                    var xml, parserErrorElem;
                    if ( !data || typeof data !== "string" ) {
                        return null;
                    }

                    // Support: IE 9 - 11 only
                    // IE throws on parseFromString with invalid input.
                    try {
                        xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
                    } catch ( e ) {}

                    parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
                    if ( !xml || parserErrorElem ) {
                        jQuery.error( "Invalid XML: " + (
                            parserErrorElem ?
                                jQuery.map( parserErrorElem.childNodes, function( el ) {
                                    return el.textContent;
                                } ).join( "\n" ) :
                                data
                        ) );
                    }
                    return xml;
                };


                var
                    rbracket = /\[\]$/,
                    rCRLF = /\r?\n/g,
                    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
                    rsubmittable = /^(?:input|select|textarea|keygen)/i;

                function buildParams( prefix, obj, traditional, add ) {
                    var name;

                    if ( Array.isArray( obj ) ) {

                        // Serialize array item.
                        jQuery.each( obj, function( i, v ) {
                            if ( traditional || rbracket.test( prefix ) ) {

                                // Treat each array item as a scalar.
                                add( prefix, v );

                            } else {

                                // Item is non-scalar (array or object), encode its numeric index.
                                buildParams(
                                    prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
                                    v,
                                    traditional,
                                    add
                                );
                            }
                        } );

                    } else if ( !traditional && toType( obj ) === "object" ) {

                        // Serialize object item.
                        for ( name in obj ) {
                            buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
                        }

                    } else {

                        // Serialize scalar item.
                        add( prefix, obj );
                    }
                }

// Serialize an array of form elements or a set of
// key/values into a query string
                jQuery.param = function( a, traditional ) {
                    var prefix,
                        s = [],
                        add = function( key, valueOrFunction ) {

                            // If value is a function, invoke it and use its return value
                            var value = isFunction( valueOrFunction ) ?
                                valueOrFunction() :
                                valueOrFunction;

                            s[ s.length ] = encodeURIComponent( key ) + "=" +
                                encodeURIComponent( value == null ? "" : value );
                        };

                    if ( a == null ) {
                        return "";
                    }

                    // If an array was passed in, assume that it is an array of form elements.
                    if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

                        // Serialize the form elements
                        jQuery.each( a, function() {
                            add( this.name, this.value );
                        } );

                    } else {

                        // If traditional, encode the "old" way (the way 1.3.2 or older
                        // did it), otherwise encode params recursively.
                        for ( prefix in a ) {
                            buildParams( prefix, a[ prefix ], traditional, add );
                        }
                    }

                    // Return the resulting serialization
                    return s.join( "&" );
                };

                jQuery.fn.extend( {
                    serialize: function() {
                        return jQuery.param( this.serializeArray() );
                    },
                    serializeArray: function() {
                        return this.map( function() {

                            // Can add propHook for "elements" to filter or add form elements
                            var elements = jQuery.prop( this, "elements" );
                            return elements ? jQuery.makeArray( elements ) : this;
                        } ).filter( function() {
                            var type = this.type;

                            // Use .is( ":disabled" ) so that fieldset[disabled] works
                            return this.name && !jQuery( this ).is( ":disabled" ) &&
                                rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
                                ( this.checked || !rcheckableType.test( type ) );
                        } ).map( function( _i, elem ) {
                            var val = jQuery( this ).val();

                            if ( val == null ) {
                                return null;
                            }

                            if ( Array.isArray( val ) ) {
                                return jQuery.map( val, function( val ) {
                                    return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
                                } );
                            }

                            return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
                        } ).get();
                    }
                } );


                var
                    r20 = /%20/g,
                    rhash = /#.*$/,
                    rantiCache = /([?&])_=[^&]*/,
                    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

                    // #7653, #8125, #8152: local protocol detection
                    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
                    rnoContent = /^(?:GET|HEAD)$/,
                    rprotocol = /^\/\//,

                    /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
                    prefilters = {},

                    /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
                    transports = {},

                    // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
                    allTypes = "*/".concat( "*" ),

                    // Anchor tag for parsing the document origin
                    originAnchor = document.createElement( "a" );

                originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
                function addToPrefiltersOrTransports( structure ) {

                    // dataTypeExpression is optional and defaults to "*"
                    return function( dataTypeExpression, func ) {

                        if ( typeof dataTypeExpression !== "string" ) {
                            func = dataTypeExpression;
                            dataTypeExpression = "*";
                        }

                        var dataType,
                            i = 0,
                            dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

                        if ( isFunction( func ) ) {

                            // For each dataType in the dataTypeExpression
                            while ( ( dataType = dataTypes[ i++ ] ) ) {

                                // Prepend if requested
                                if ( dataType[ 0 ] === "+" ) {
                                    dataType = dataType.slice( 1 ) || "*";
                                    ( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

                                    // Otherwise append
                                } else {
                                    ( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
                                }
                            }
                        }
                    };
                }

// Base inspection function for prefilters and transports
                function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

                    var inspected = {},
                        seekingTransport = ( structure === transports );

                    function inspect( dataType ) {
                        var selected;
                        inspected[ dataType ] = true;
                        jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
                            var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
                            if ( typeof dataTypeOrTransport === "string" &&
                                !seekingTransport && !inspected[ dataTypeOrTransport ] ) {

                                options.dataTypes.unshift( dataTypeOrTransport );
                                inspect( dataTypeOrTransport );
                                return false;
                            } else if ( seekingTransport ) {
                                return !( selected = dataTypeOrTransport );
                            }
                        } );
                        return selected;
                    }

                    return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
                }

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
                function ajaxExtend( target, src ) {
                    var key, deep,
                        flatOptions = jQuery.ajaxSettings.flatOptions || {};

                    for ( key in src ) {
                        if ( src[ key ] !== undefined ) {
                            ( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
                        }
                    }
                    if ( deep ) {
                        jQuery.extend( true, target, deep );
                    }

                    return target;
                }

                /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
                function ajaxHandleResponses( s, jqXHR, responses ) {

                    var ct, type, finalDataType, firstDataType,
                        contents = s.contents,
                        dataTypes = s.dataTypes;

                    // Remove auto dataType and get content-type in the process
                    while ( dataTypes[ 0 ] === "*" ) {
                        dataTypes.shift();
                        if ( ct === undefined ) {
                            ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
                        }
                    }

                    // Check if we're dealing with a known content-type
                    if ( ct ) {
                        for ( type in contents ) {
                            if ( contents[ type ] && contents[ type ].test( ct ) ) {
                                dataTypes.unshift( type );
                                break;
                            }
                        }
                    }

                    // Check to see if we have a response for the expected dataType
                    if ( dataTypes[ 0 ] in responses ) {
                        finalDataType = dataTypes[ 0 ];
                    } else {

                        // Try convertible dataTypes
                        for ( type in responses ) {
                            if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
                                finalDataType = type;
                                break;
                            }
                            if ( !firstDataType ) {
                                firstDataType = type;
                            }
                        }

                        // Or just use first one
                        finalDataType = finalDataType || firstDataType;
                    }

                    // If we found a dataType
                    // We add the dataType to the list if needed
                    // and return the corresponding response
                    if ( finalDataType ) {
                        if ( finalDataType !== dataTypes[ 0 ] ) {
                            dataTypes.unshift( finalDataType );
                        }
                        return responses[ finalDataType ];
                    }
                }

                /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
                function ajaxConvert( s, response, jqXHR, isSuccess ) {
                    var conv2, current, conv, tmp, prev,
                        converters = {},

                        // Work with a copy of dataTypes in case we need to modify it for conversion
                        dataTypes = s.dataTypes.slice();

                    // Create converters map with lowercased keys
                    if ( dataTypes[ 1 ] ) {
                        for ( conv in s.converters ) {
                            converters[ conv.toLowerCase() ] = s.converters[ conv ];
                        }
                    }

                    current = dataTypes.shift();

                    // Convert to each sequential dataType
                    while ( current ) {

                        if ( s.responseFields[ current ] ) {
                            jqXHR[ s.responseFields[ current ] ] = response;
                        }

                        // Apply the dataFilter if provided
                        if ( !prev && isSuccess && s.dataFilter ) {
                            response = s.dataFilter( response, s.dataType );
                        }

                        prev = current;
                        current = dataTypes.shift();

                        if ( current ) {

                            // There's only work to do if current dataType is non-auto
                            if ( current === "*" ) {

                                current = prev;

                                // Convert response if prev dataType is non-auto and differs from current
                            } else if ( prev !== "*" && prev !== current ) {

                                // Seek a direct converter
                                conv = converters[ prev + " " + current ] || converters[ "* " + current ];

                                // If none found, seek a pair
                                if ( !conv ) {
                                    for ( conv2 in converters ) {

                                        // If conv2 outputs current
                                        tmp = conv2.split( " " );
                                        if ( tmp[ 1 ] === current ) {

                                            // If prev can be converted to accepted input
                                            conv = converters[ prev + " " + tmp[ 0 ] ] ||
                                                converters[ "* " + tmp[ 0 ] ];
                                            if ( conv ) {

                                                // Condense equivalence converters
                                                if ( conv === true ) {
                                                    conv = converters[ conv2 ];

                                                    // Otherwise, insert the intermediate dataType
                                                } else if ( converters[ conv2 ] !== true ) {
                                                    current = tmp[ 0 ];
                                                    dataTypes.unshift( tmp[ 1 ] );
                                                }
                                                break;
                                            }
                                        }
                                    }
                                }

                                // Apply converter (if not an equivalence)
                                if ( conv !== true ) {

                                    // Unless errors are allowed to bubble, catch and return them
                                    if ( conv && s.throws ) {
                                        response = conv( response );
                                    } else {
                                        try {
                                            response = conv( response );
                                        } catch ( e ) {
                                            return {
                                                state: "parsererror",
                                                error: conv ? e : "No conversion from " + prev + " to " + current
                                            };
                                        }
                                    }
                                }
                            }
                        }
                    }

                    return { state: "success", data: response };
                }

                jQuery.extend( {

                    // Counter for holding the number of active queries
                    active: 0,

                    // Last-Modified header cache for next request
                    lastModified: {},
                    etag: {},

                    ajaxSettings: {
                        url: location.href,
                        type: "GET",
                        isLocal: rlocalProtocol.test( location.protocol ),
                        global: true,
                        processData: true,
                        async: true,
                        contentType: "application/x-www-form-urlencoded; charset=UTF-8",

                        /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

                        accepts: {
                            "*": allTypes,
                            text: "text/plain",
                            html: "text/html",
                            xml: "application/xml, text/xml",
                            json: "application/json, text/javascript"
                        },

                        contents: {
                            xml: /\bxml\b/,
                            html: /\bhtml/,
                            json: /\bjson\b/
                        },

                        responseFields: {
                            xml: "responseXML",
                            text: "responseText",
                            json: "responseJSON"
                        },

                        // Data converters
                        // Keys separate source (or catchall "*") and destination types with a single space
                        converters: {

                            // Convert anything to text
                            "* text": String,

                            // Text to html (true = no transformation)
                            "text html": true,

                            // Evaluate text as a json expression
                            "text json": JSON.parse,

                            // Parse text as xml
                            "text xml": jQuery.parseXML
                        },

                        // For options that shouldn't be deep extended:
                        // you can add your own custom options here if
                        // and when you create one that shouldn't be
                        // deep extended (see ajaxExtend)
                        flatOptions: {
                            url: true,
                            context: true
                        }
                    },

                    // Creates a full fledged settings object into target
                    // with both ajaxSettings and settings fields.
                    // If target is omitted, writes into ajaxSettings.
                    ajaxSetup: function( target, settings ) {
                        return settings ?

                            // Building a settings object
                            ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

                            // Extending ajaxSettings
                            ajaxExtend( jQuery.ajaxSettings, target );
                    },

                    ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
                    ajaxTransport: addToPrefiltersOrTransports( transports ),

                    // Main method
                    ajax: function( url, options ) {

                        // If url is an object, simulate pre-1.5 signature
                        if ( typeof url === "object" ) {
                            options = url;
                            url = undefined;
                        }

                        // Force options to be an object
                        options = options || {};

                        var transport,

                            // URL without anti-cache param
                            cacheURL,

                            // Response headers
                            responseHeadersString,
                            responseHeaders,

                            // timeout handle
                            timeoutTimer,

                            // Url cleanup var
                            urlAnchor,

                            // Request state (becomes false upon send and true upon completion)
                            completed,

                            // To know if global events are to be dispatched
                            fireGlobals,

                            // Loop variable
                            i,

                            // uncached part of the url
                            uncached,

                            // Create the final options object
                            s = jQuery.ajaxSetup( {}, options ),

                            // Callbacks context
                            callbackContext = s.context || s,

                            // Context for global events is callbackContext if it is a DOM node or jQuery collection
                            globalEventContext = s.context &&
                            ( callbackContext.nodeType || callbackContext.jquery ) ?
                                jQuery( callbackContext ) :
                                jQuery.event,

                            // Deferreds
                            deferred = jQuery.Deferred(),
                            completeDeferred = jQuery.Callbacks( "once memory" ),

                            // Status-dependent callbacks
                            statusCode = s.statusCode || {},

                            // Headers (they are sent all at once)
                            requestHeaders = {},
                            requestHeadersNames = {},

                            // Default abort message
                            strAbort = "canceled",

                            // Fake xhr
                            jqXHR = {
                                readyState: 0,

                                // Builds headers hashtable if needed
                                getResponseHeader: function( key ) {
                                    var match;
                                    if ( completed ) {
                                        if ( !responseHeaders ) {
                                            responseHeaders = {};
                                            while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
                                                responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
                                                    ( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
                                                        .concat( match[ 2 ] );
                                            }
                                        }
                                        match = responseHeaders[ key.toLowerCase() + " " ];
                                    }
                                    return match == null ? null : match.join( ", " );
                                },

                                // Raw string
                                getAllResponseHeaders: function() {
                                    return completed ? responseHeadersString : null;
                                },

                                // Caches the header
                                setRequestHeader: function( name, value ) {
                                    if ( completed == null ) {
                                        name = requestHeadersNames[ name.toLowerCase() ] =
                                            requestHeadersNames[ name.toLowerCase() ] || name;
                                        requestHeaders[ name ] = value;
                                    }
                                    return this;
                                },

                                // Overrides response content-type header
                                overrideMimeType: function( type ) {
                                    if ( completed == null ) {
                                        s.mimeType = type;
                                    }
                                    return this;
                                },

                                // Status-dependent callbacks
                                statusCode: function( map ) {
                                    var code;
                                    if ( map ) {
                                        if ( completed ) {

                                            // Execute the appropriate callbacks
                                            jqXHR.always( map[ jqXHR.status ] );
                                        } else {

                                            // Lazy-add the new callbacks in a way that preserves old ones
                                            for ( code in map ) {
                                                statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
                                            }
                                        }
                                    }
                                    return this;
                                },

                                // Cancel the request
                                abort: function( statusText ) {
                                    var finalText = statusText || strAbort;
                                    if ( transport ) {
                                        transport.abort( finalText );
                                    }
                                    done( 0, finalText );
                                    return this;
                                }
                            };

                        // Attach deferreds
                        deferred.promise( jqXHR );

                        // Add protocol if not provided (prefilters might expect it)
                        // Handle falsy url in the settings object (#10093: consistency with old signature)
                        // We also use the url parameter if available
                        s.url = ( ( url || s.url || location.href ) + "" )
                            .replace( rprotocol, location.protocol + "//" );

                        // Alias method option to type as per ticket #12004
                        s.type = options.method || options.type || s.method || s.type;

                        // Extract dataTypes list
                        s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

                        // A cross-domain request is in order when the origin doesn't match the current origin.
                        if ( s.crossDomain == null ) {
                            urlAnchor = document.createElement( "a" );

                            // Support: IE <=8 - 11, Edge 12 - 15
                            // IE throws exception on accessing the href property if url is malformed,
                            // e.g. http://example.com:80x/
                            try {
                                urlAnchor.href = s.url;

                                // Support: IE <=8 - 11 only
                                // Anchor's host property isn't correctly set when s.url is relative
                                urlAnchor.href = urlAnchor.href;
                                s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
                                    urlAnchor.protocol + "//" + urlAnchor.host;
                            } catch ( e ) {

                                // If there is an error parsing the URL, assume it is crossDomain,
                                // it can be rejected by the transport if it is invalid
                                s.crossDomain = true;
                            }
                        }

                        // Convert data if not already a string
                        if ( s.data && s.processData && typeof s.data !== "string" ) {
                            s.data = jQuery.param( s.data, s.traditional );
                        }

                        // Apply prefilters
                        inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

                        // If request was aborted inside a prefilter, stop there
                        if ( completed ) {
                            return jqXHR;
                        }

                        // We can fire global events as of now if asked to
                        // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
                        fireGlobals = jQuery.event && s.global;

                        // Watch for a new set of requests
                        if ( fireGlobals && jQuery.active++ === 0 ) {
                            jQuery.event.trigger( "ajaxStart" );
                        }

                        // Uppercase the type
                        s.type = s.type.toUpperCase();

                        // Determine if request has content
                        s.hasContent = !rnoContent.test( s.type );

                        // Save the URL in case we're toying with the If-Modified-Since
                        // and/or If-None-Match header later on
                        // Remove hash to simplify url manipulation
                        cacheURL = s.url.replace( rhash, "" );

                        // More options handling for requests with no content
                        if ( !s.hasContent ) {

                            // Remember the hash so we can put it back
                            uncached = s.url.slice( cacheURL.length );

                            // If data is available and should be processed, append data to url
                            if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
                                cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

                                // #9682: remove data so that it's not used in an eventual retry
                                delete s.data;
                            }

                            // Add or update anti-cache param if needed
                            if ( s.cache === false ) {
                                cacheURL = cacheURL.replace( rantiCache, "$1" );
                                uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
                                    uncached;
                            }

                            // Put hash and anti-cache on the URL that will be requested (gh-1732)
                            s.url = cacheURL + uncached;

                            // Change '%20' to '+' if this is encoded form body content (gh-2658)
                        } else if ( s.data && s.processData &&
                            ( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
                            s.data = s.data.replace( r20, "+" );
                        }

                        // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                        if ( s.ifModified ) {
                            if ( jQuery.lastModified[ cacheURL ] ) {
                                jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
                            }
                            if ( jQuery.etag[ cacheURL ] ) {
                                jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
                            }
                        }

                        // Set the correct header, if data is being sent
                        if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
                            jqXHR.setRequestHeader( "Content-Type", s.contentType );
                        }

                        // Set the Accepts header for the server, depending on the dataType
                        jqXHR.setRequestHeader(
                            "Accept",
                            s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
                                s.accepts[ s.dataTypes[ 0 ] ] +
                                ( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
                                s.accepts[ "*" ]
                        );

                        // Check for headers option
                        for ( i in s.headers ) {
                            jqXHR.setRequestHeader( i, s.headers[ i ] );
                        }

                        // Allow custom headers/mimetypes and early abort
                        if ( s.beforeSend &&
                            ( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

                            // Abort if not done already and return
                            return jqXHR.abort();
                        }

                        // Aborting is no longer a cancellation
                        strAbort = "abort";

                        // Install callbacks on deferreds
                        completeDeferred.add( s.complete );
                        jqXHR.done( s.success );
                        jqXHR.fail( s.error );

                        // Get transport
                        transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

                        // If no transport, we auto-abort
                        if ( !transport ) {
                            done( -1, "No Transport" );
                        } else {
                            jqXHR.readyState = 1;

                            // Send global event
                            if ( fireGlobals ) {
                                globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
                            }

                            // If request was aborted inside ajaxSend, stop there
                            if ( completed ) {
                                return jqXHR;
                            }

                            // Timeout
                            if ( s.async && s.timeout > 0 ) {
                                timeoutTimer = window.setTimeout( function() {
                                    jqXHR.abort( "timeout" );
                                }, s.timeout );
                            }

                            try {
                                completed = false;
                                transport.send( requestHeaders, done );
                            } catch ( e ) {

                                // Rethrow post-completion exceptions
                                if ( completed ) {
                                    throw e;
                                }

                                // Propagate others as results
                                done( -1, e );
                            }
                        }

                        // Callback for when everything is done
                        function done( status, nativeStatusText, responses, headers ) {
                            var isSuccess, success, error, response, modified,
                                statusText = nativeStatusText;

                            // Ignore repeat invocations
                            if ( completed ) {
                                return;
                            }

                            completed = true;

                            // Clear timeout if it exists
                            if ( timeoutTimer ) {
                                window.clearTimeout( timeoutTimer );
                            }

                            // Dereference transport for early garbage collection
                            // (no matter how long the jqXHR object will be used)
                            transport = undefined;

                            // Cache response headers
                            responseHeadersString = headers || "";

                            // Set readyState
                            jqXHR.readyState = status > 0 ? 4 : 0;

                            // Determine if successful
                            isSuccess = status >= 200 && status < 300 || status === 304;

                            // Get response data
                            if ( responses ) {
                                response = ajaxHandleResponses( s, jqXHR, responses );
                            }

                            // Use a noop converter for missing script but not if jsonp
                            if ( !isSuccess &&
                                jQuery.inArray( "script", s.dataTypes ) > -1 &&
                                jQuery.inArray( "json", s.dataTypes ) < 0 ) {
                                s.converters[ "text script" ] = function() {};
                            }

                            // Convert no matter what (that way responseXXX fields are always set)
                            response = ajaxConvert( s, response, jqXHR, isSuccess );

                            // If successful, handle type chaining
                            if ( isSuccess ) {

                                // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                                if ( s.ifModified ) {
                                    modified = jqXHR.getResponseHeader( "Last-Modified" );
                                    if ( modified ) {
                                        jQuery.lastModified[ cacheURL ] = modified;
                                    }
                                    modified = jqXHR.getResponseHeader( "etag" );
                                    if ( modified ) {
                                        jQuery.etag[ cacheURL ] = modified;
                                    }
                                }

                                // if no content
                                if ( status === 204 || s.type === "HEAD" ) {
                                    statusText = "nocontent";

                                    // if not modified
                                } else if ( status === 304 ) {
                                    statusText = "notmodified";

                                    // If we have data, let's convert it
                                } else {
                                    statusText = response.state;
                                    success = response.data;
                                    error = response.error;
                                    isSuccess = !error;
                                }
                            } else {

                                // Extract error from statusText and normalize for non-aborts
                                error = statusText;
                                if ( status || !statusText ) {
                                    statusText = "error";
                                    if ( status < 0 ) {
                                        status = 0;
                                    }
                                }
                            }

                            // Set data for the fake xhr object
                            jqXHR.status = status;
                            jqXHR.statusText = ( nativeStatusText || statusText ) + "";

                            // Success/Error
                            if ( isSuccess ) {
                                deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
                            } else {
                                deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
                            }

                            // Status-dependent callbacks
                            jqXHR.statusCode( statusCode );
                            statusCode = undefined;

                            if ( fireGlobals ) {
                                globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
                                    [ jqXHR, s, isSuccess ? success : error ] );
                            }

                            // Complete
                            completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

                            if ( fireGlobals ) {
                                globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

                                // Handle the global AJAX counter
                                if ( !( --jQuery.active ) ) {
                                    jQuery.event.trigger( "ajaxStop" );
                                }
                            }
                        }

                        return jqXHR;
                    },

                    getJSON: function( url, data, callback ) {
                        return jQuery.get( url, data, callback, "json" );
                    },

                    getScript: function( url, callback ) {
                        return jQuery.get( url, undefined, callback, "script" );
                    }
                } );

                jQuery.each( [ "get", "post" ], function( _i, method ) {
                    jQuery[ method ] = function( url, data, callback, type ) {

                        // Shift arguments if data argument was omitted
                        if ( isFunction( data ) ) {
                            type = type || callback;
                            callback = data;
                            data = undefined;
                        }

                        // The url can be an options object (which then must have .url)
                        return jQuery.ajax( jQuery.extend( {
                            url: url,
                            type: method,
                            dataType: type,
                            data: data,
                            success: callback
                        }, jQuery.isPlainObject( url ) && url ) );
                    };
                } );

                jQuery.ajaxPrefilter( function( s ) {
                    var i;
                    for ( i in s.headers ) {
                        if ( i.toLowerCase() === "content-type" ) {
                            s.contentType = s.headers[ i ] || "";
                        }
                    }
                } );


                jQuery._evalUrl = function( url, options, doc ) {
                    return jQuery.ajax( {
                        url: url,

                        // Make this explicit, since user can override this through ajaxSetup (#11264)
                        type: "GET",
                        dataType: "script",
                        cache: true,
                        async: false,
                        global: false,

                        // Only evaluate the response if it is successful (gh-4126)
                        // dataFilter is not invoked for failure responses, so using it instead
                        // of the default converter is kludgy but it works.
                        converters: {
                            "text script": function() {}
                        },
                        dataFilter: function( response ) {
                            jQuery.globalEval( response, options, doc );
                        }
                    } );
                };


                jQuery.fn.extend( {
                    wrapAll: function( html ) {
                        var wrap;

                        if ( this[ 0 ] ) {
                            if ( isFunction( html ) ) {
                                html = html.call( this[ 0 ] );
                            }

                            // The elements to wrap the target around
                            wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

                            if ( this[ 0 ].parentNode ) {
                                wrap.insertBefore( this[ 0 ] );
                            }

                            wrap.map( function() {
                                var elem = this;

                                while ( elem.firstElementChild ) {
                                    elem = elem.firstElementChild;
                                }

                                return elem;
                            } ).append( this );
                        }

                        return this;
                    },

                    wrapInner: function( html ) {
                        if ( isFunction( html ) ) {
                            return this.each( function( i ) {
                                jQuery( this ).wrapInner( html.call( this, i ) );
                            } );
                        }

                        return this.each( function() {
                            var self = jQuery( this ),
                                contents = self.contents();

                            if ( contents.length ) {
                                contents.wrapAll( html );

                            } else {
                                self.append( html );
                            }
                        } );
                    },

                    wrap: function( html ) {
                        var htmlIsFunction = isFunction( html );

                        return this.each( function( i ) {
                            jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
                        } );
                    },

                    unwrap: function( selector ) {
                        this.parent( selector ).not( "body" ).each( function() {
                            jQuery( this ).replaceWith( this.childNodes );
                        } );
                        return this;
                    }
                } );


                jQuery.expr.pseudos.hidden = function( elem ) {
                    return !jQuery.expr.pseudos.visible( elem );
                };
                jQuery.expr.pseudos.visible = function( elem ) {
                    return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
                };




                jQuery.ajaxSettings.xhr = function() {
                    try {
                        return new window.XMLHttpRequest();
                    } catch ( e ) {}
                };

                var xhrSuccessStatus = {

                        // File protocol always yields status code 0, assume 200
                        0: 200,

                        // Support: IE <=9 only
                        // #1450: sometimes IE returns 1223 when it should be 204
                        1223: 204
                    },
                    xhrSupported = jQuery.ajaxSettings.xhr();

                support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
                support.ajax = xhrSupported = !!xhrSupported;

                jQuery.ajaxTransport( function( options ) {
                    var callback, errorCallback;

                    // Cross domain only allowed if supported through XMLHttpRequest
                    if ( support.cors || xhrSupported && !options.crossDomain ) {
                        return {
                            send: function( headers, complete ) {
                                var i,
                                    xhr = options.xhr();

                                xhr.open(
                                    options.type,
                                    options.url,
                                    options.async,
                                    options.username,
                                    options.password
                                );

                                // Apply custom fields if provided
                                if ( options.xhrFields ) {
                                    for ( i in options.xhrFields ) {
                                        xhr[ i ] = options.xhrFields[ i ];
                                    }
                                }

                                // Override mime type if needed
                                if ( options.mimeType && xhr.overrideMimeType ) {
                                    xhr.overrideMimeType( options.mimeType );
                                }

                                // X-Requested-With header
                                // For cross-domain requests, seeing as conditions for a preflight are
                                // akin to a jigsaw puzzle, we simply never set it to be sure.
                                // (it can always be set on a per-request basis or even using ajaxSetup)
                                // For same-domain requests, won't change header if already provided.
                                if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
                                    headers[ "X-Requested-With" ] = "XMLHttpRequest";
                                }

                                // Set headers
                                for ( i in headers ) {
                                    xhr.setRequestHeader( i, headers[ i ] );
                                }

                                // Callback
                                callback = function( type ) {
                                    return function() {
                                        if ( callback ) {
                                            callback = errorCallback = xhr.onload =
                                                xhr.onerror = xhr.onabort = xhr.ontimeout =
                                                    xhr.onreadystatechange = null;

                                            if ( type === "abort" ) {
                                                xhr.abort();
                                            } else if ( type === "error" ) {

                                                // Support: IE <=9 only
                                                // On a manual native abort, IE9 throws
                                                // errors on any property access that is not readyState
                                                if ( typeof xhr.status !== "number" ) {
                                                    complete( 0, "error" );
                                                } else {
                                                    complete(

                                                        // File: protocol always yields status 0; see #8605, #14207
                                                        xhr.status,
                                                        xhr.statusText
                                                    );
                                                }
                                            } else {
                                                complete(
                                                    xhrSuccessStatus[ xhr.status ] || xhr.status,
                                                    xhr.statusText,

                                                    // Support: IE <=9 only
                                                    // IE9 has no XHR2 but throws on binary (trac-11426)
                                                    // For XHR2 non-text, let the caller handle it (gh-2498)
                                                    ( xhr.responseType || "text" ) !== "text"  ||
                                                    typeof xhr.responseText !== "string" ?
                                                        { binary: xhr.response } :
                                                        { text: xhr.responseText },
                                                    xhr.getAllResponseHeaders()
                                                );
                                            }
                                        }
                                    };
                                };

                                // Listen to events
                                xhr.onload = callback();
                                errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

                                // Support: IE 9 only
                                // Use onreadystatechange to replace onabort
                                // to handle uncaught aborts
                                if ( xhr.onabort !== undefined ) {
                                    xhr.onabort = errorCallback;
                                } else {
                                    xhr.onreadystatechange = function() {

                                        // Check readyState before timeout as it changes
                                        if ( xhr.readyState === 4 ) {

                                            // Allow onerror to be called first,
                                            // but that will not handle a native abort
                                            // Also, save errorCallback to a variable
                                            // as xhr.onerror cannot be accessed
                                            window.setTimeout( function() {
                                                if ( callback ) {
                                                    errorCallback();
                                                }
                                            } );
                                        }
                                    };
                                }

                                // Create the abort callback
                                callback = callback( "abort" );

                                try {

                                    // Do send the request (this may raise an exception)
                                    xhr.send( options.hasContent && options.data || null );
                                } catch ( e ) {

                                    // #14683: Only rethrow if this hasn't been notified as an error yet
                                    if ( callback ) {
                                        throw e;
                                    }
                                }
                            },

                            abort: function() {
                                if ( callback ) {
                                    callback();
                                }
                            }
                        };
                    }
                } );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
                jQuery.ajaxPrefilter( function( s ) {
                    if ( s.crossDomain ) {
                        s.contents.script = false;
                    }
                } );

// Install script dataType
                jQuery.ajaxSetup( {
                    accepts: {
                        script: "text/javascript, application/javascript, " +
                            "application/ecmascript, application/x-ecmascript"
                    },
                    contents: {
                        script: /\b(?:java|ecma)script\b/
                    },
                    converters: {
                        "text script": function( text ) {
                            jQuery.globalEval( text );
                            return text;
                        }
                    }
                } );

// Handle cache's special case and crossDomain
                jQuery.ajaxPrefilter( "script", function( s ) {
                    if ( s.cache === undefined ) {
                        s.cache = false;
                    }
                    if ( s.crossDomain ) {
                        s.type = "GET";
                    }
                } );

// Bind script tag hack transport
                jQuery.ajaxTransport( "script", function( s ) {

                    // This transport only deals with cross domain or forced-by-attrs requests
                    if ( s.crossDomain || s.scriptAttrs ) {
                        var script, callback;
                        return {
                            send: function( _, complete ) {
                                script = jQuery( "<script>" )
                                    .attr( s.scriptAttrs || {} )
                                    .prop( { charset: s.scriptCharset, src: s.url } )
                                    .on( "load error", callback = function( evt ) {
                                        script.remove();
                                        callback = null;
                                        if ( evt ) {
                                            complete( evt.type === "error" ? 404 : 200, evt.type );
                                        }
                                    } );

                                // Use native DOM manipulation to avoid our domManip AJAX trickery
                                document.head.appendChild( script[ 0 ] );
                            },
                            abort: function() {
                                if ( callback ) {
                                    callback();
                                }
                            }
                        };
                    }
                } );




                var oldCallbacks = [],
                    rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
                jQuery.ajaxSetup( {
                    jsonp: "callback",
                    jsonpCallback: function() {
                        var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
                        this[ callback ] = true;
                        return callback;
                    }
                } );

// Detect, normalize options and install callbacks for jsonp requests
                jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

                    var callbackName, overwritten, responseContainer,
                        jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
                                "url" :
                                typeof s.data === "string" &&
                                ( s.contentType || "" )
                                    .indexOf( "application/x-www-form-urlencoded" ) === 0 &&
                                rjsonp.test( s.data ) && "data"
                        );

                    // Handle iff the expected data type is "jsonp" or we have a parameter to set
                    if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

                        // Get callback name, remembering preexisting value associated with it
                        callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
                            s.jsonpCallback() :
                            s.jsonpCallback;

                        // Insert callback into url or form data
                        if ( jsonProp ) {
                            s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
                        } else if ( s.jsonp !== false ) {
                            s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
                        }

                        // Use data converter to retrieve json after script execution
                        s.converters[ "script json" ] = function() {
                            if ( !responseContainer ) {
                                jQuery.error( callbackName + " was not called" );
                            }
                            return responseContainer[ 0 ];
                        };

                        // Force json dataType
                        s.dataTypes[ 0 ] = "json";

                        // Install callback
                        overwritten = window[ callbackName ];
                        window[ callbackName ] = function() {
                            responseContainer = arguments;
                        };

                        // Clean-up function (fires after converters)
                        jqXHR.always( function() {

                            // If previous value didn't exist - remove it
                            if ( overwritten === undefined ) {
                                jQuery( window ).removeProp( callbackName );

                                // Otherwise restore preexisting value
                            } else {
                                window[ callbackName ] = overwritten;
                            }

                            // Save back as free
                            if ( s[ callbackName ] ) {

                                // Make sure that re-using the options doesn't screw things around
                                s.jsonpCallback = originalSettings.jsonpCallback;

                                // Save the callback name for future use
                                oldCallbacks.push( callbackName );
                            }

                            // Call if it was a function and we have a response
                            if ( responseContainer && isFunction( overwritten ) ) {
                                overwritten( responseContainer[ 0 ] );
                            }

                            responseContainer = overwritten = undefined;
                        } );

                        // Delegate to script
                        return "script";
                    }
                } );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
                support.createHTMLDocument = ( function() {
                    var body = document.implementation.createHTMLDocument( "" ).body;
                    body.innerHTML = "<form></form><form></form>";
                    return body.childNodes.length === 2;
                } )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
                jQuery.parseHTML = function( data, context, keepScripts ) {
                    if ( typeof data !== "string" ) {
                        return [];
                    }
                    if ( typeof context === "boolean" ) {
                        keepScripts = context;
                        context = false;
                    }

                    var base, parsed, scripts;

                    if ( !context ) {

                        // Stop scripts or inline event handlers from being executed immediately
                        // by using document.implementation
                        if ( support.createHTMLDocument ) {
                            context = document.implementation.createHTMLDocument( "" );

                            // Set the base href for the created document
                            // so any parsed elements with URLs
                            // are based on the document's URL (gh-2965)
                            base = context.createElement( "base" );
                            base.href = document.location.href;
                            context.head.appendChild( base );
                        } else {
                            context = document;
                        }
                    }

                    parsed = rsingleTag.exec( data );
                    scripts = !keepScripts && [];

                    // Single tag
                    if ( parsed ) {
                        return [ context.createElement( parsed[ 1 ] ) ];
                    }

                    parsed = buildFragment( [ data ], context, scripts );

                    if ( scripts && scripts.length ) {
                        jQuery( scripts ).remove();
                    }

                    return jQuery.merge( [], parsed.childNodes );
                };


                /**
                 * Load a url into a page
                 */
                jQuery.fn.load = function( url, params, callback ) {
                    var selector, type, response,
                        self = this,
                        off = url.indexOf( " " );

                    if ( off > -1 ) {
                        selector = stripAndCollapse( url.slice( off ) );
                        url = url.slice( 0, off );
                    }

                    // If it's a function
                    if ( isFunction( params ) ) {

                        // We assume that it's the callback
                        callback = params;
                        params = undefined;

                        // Otherwise, build a param string
                    } else if ( params && typeof params === "object" ) {
                        type = "POST";
                    }

                    // If we have elements to modify, make the request
                    if ( self.length > 0 ) {
                        jQuery.ajax( {
                            url: url,

                            // If "type" variable is undefined, then "GET" method will be used.
                            // Make value of this field explicit since
                            // user can override it through ajaxSetup method
                            type: type || "GET",
                            dataType: "html",
                            data: params
                        } ).done( function( responseText ) {

                            // Save response for use in complete callback
                            response = arguments;

                            self.html( selector ?

                                // If a selector was specified, locate the right elements in a dummy div
                                // Exclude scripts to avoid IE 'Permission Denied' errors
                                jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

                                // Otherwise use the full result
                                responseText );

                            // If the request succeeds, this function gets "data", "status", "jqXHR"
                            // but they are ignored because response was set above.
                            // If it fails, this function gets "jqXHR", "status", "error"
                        } ).always( callback && function( jqXHR, status ) {
                            self.each( function() {
                                callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
                            } );
                        } );
                    }

                    return this;
                };




                jQuery.expr.pseudos.animated = function( elem ) {
                    return jQuery.grep( jQuery.timers, function( fn ) {
                        return elem === fn.elem;
                    } ).length;
                };




                jQuery.offset = {
                    setOffset: function( elem, options, i ) {
                        var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
                            position = jQuery.css( elem, "position" ),
                            curElem = jQuery( elem ),
                            props = {};

                        // Set position first, in-case top/left are set even on static elem
                        if ( position === "static" ) {
                            elem.style.position = "relative";
                        }

                        curOffset = curElem.offset();
                        curCSSTop = jQuery.css( elem, "top" );
                        curCSSLeft = jQuery.css( elem, "left" );
                        calculatePosition = ( position === "absolute" || position === "fixed" ) &&
                            ( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

                        // Need to be able to calculate position if either
                        // top or left is auto and position is either absolute or fixed
                        if ( calculatePosition ) {
                            curPosition = curElem.position();
                            curTop = curPosition.top;
                            curLeft = curPosition.left;

                        } else {
                            curTop = parseFloat( curCSSTop ) || 0;
                            curLeft = parseFloat( curCSSLeft ) || 0;
                        }

                        if ( isFunction( options ) ) {

                            // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
                            options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
                        }

                        if ( options.top != null ) {
                            props.top = ( options.top - curOffset.top ) + curTop;
                        }
                        if ( options.left != null ) {
                            props.left = ( options.left - curOffset.left ) + curLeft;
                        }

                        if ( "using" in options ) {
                            options.using.call( elem, props );

                        } else {
                            curElem.css( props );
                        }
                    }
                };

                jQuery.fn.extend( {

                    // offset() relates an element's border box to the document origin
                    offset: function( options ) {

                        // Preserve chaining for setter
                        if ( arguments.length ) {
                            return options === undefined ?
                                this :
                                this.each( function( i ) {
                                    jQuery.offset.setOffset( this, options, i );
                                } );
                        }

                        var rect, win,
                            elem = this[ 0 ];

                        if ( !elem ) {
                            return;
                        }

                        // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
                        // Support: IE <=11 only
                        // Running getBoundingClientRect on a
                        // disconnected node in IE throws an error
                        if ( !elem.getClientRects().length ) {
                            return { top: 0, left: 0 };
                        }

                        // Get document-relative position by adding viewport scroll to viewport-relative gBCR
                        rect = elem.getBoundingClientRect();
                        win = elem.ownerDocument.defaultView;
                        return {
                            top: rect.top + win.pageYOffset,
                            left: rect.left + win.pageXOffset
                        };
                    },

                    // position() relates an element's margin box to its offset parent's padding box
                    // This corresponds to the behavior of CSS absolute positioning
                    position: function() {
                        if ( !this[ 0 ] ) {
                            return;
                        }

                        var offsetParent, offset, doc,
                            elem = this[ 0 ],
                            parentOffset = { top: 0, left: 0 };

                        // position:fixed elements are offset from the viewport, which itself always has zero offset
                        if ( jQuery.css( elem, "position" ) === "fixed" ) {

                            // Assume position:fixed implies availability of getBoundingClientRect
                            offset = elem.getBoundingClientRect();

                        } else {
                            offset = this.offset();

                            // Account for the *real* offset parent, which can be the document or its root element
                            // when a statically positioned element is identified
                            doc = elem.ownerDocument;
                            offsetParent = elem.offsetParent || doc.documentElement;
                            while ( offsetParent &&
                            ( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
                            jQuery.css( offsetParent, "position" ) === "static" ) {

                                offsetParent = offsetParent.parentNode;
                            }
                            if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

                                // Incorporate borders into its offset, since they are outside its content origin
                                parentOffset = jQuery( offsetParent ).offset();
                                parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
                                parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
                            }
                        }

                        // Subtract parent offsets and element margins
                        return {
                            top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
                            left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
                        };
                    },

                    // This method will return documentElement in the following cases:
                    // 1) For the element inside the iframe without offsetParent, this method will return
                    //    documentElement of the parent window
                    // 2) For the hidden or detached element
                    // 3) For body or html element, i.e. in case of the html node - it will return itself
                    //
                    // but those exceptions were never presented as a real life use-cases
                    // and might be considered as more preferable results.
                    //
                    // This logic, however, is not guaranteed and can change at any point in the future
                    offsetParent: function() {
                        return this.map( function() {
                            var offsetParent = this.offsetParent;

                            while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
                                offsetParent = offsetParent.offsetParent;
                            }

                            return offsetParent || documentElement;
                        } );
                    }
                } );

// Create scrollLeft and scrollTop methods
                jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
                    var top = "pageYOffset" === prop;

                    jQuery.fn[ method ] = function( val ) {
                        return access( this, function( elem, method, val ) {

                            // Coalesce documents and windows
                            var win;
                            if ( isWindow( elem ) ) {
                                win = elem;
                            } else if ( elem.nodeType === 9 ) {
                                win = elem.defaultView;
                            }

                            if ( val === undefined ) {
                                return win ? win[ prop ] : elem[ method ];
                            }

                            if ( win ) {
                                win.scrollTo(
                                    !top ? val : win.pageXOffset,
                                    top ? val : win.pageYOffset
                                );

                            } else {
                                elem[ method ] = val;
                            }
                        }, method, val, arguments.length );
                    };
                } );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
                jQuery.each( [ "top", "left" ], function( _i, prop ) {
                    jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
                        function( elem, computed ) {
                            if ( computed ) {
                                computed = curCSS( elem, prop );

                                // If curCSS returns percentage, fallback to offset
                                return rnumnonpx.test( computed ) ?
                                    jQuery( elem ).position()[ prop ] + "px" :
                                    computed;
                            }
                        }
                    );
                } );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
                jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
                    jQuery.each( {
                        padding: "inner" + name,
                        content: type,
                        "": "outer" + name
                    }, function( defaultExtra, funcName ) {

                        // Margin is only for outerHeight, outerWidth
                        jQuery.fn[ funcName ] = function( margin, value ) {
                            var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
                                extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

                            return access( this, function( elem, type, value ) {
                                var doc;

                                if ( isWindow( elem ) ) {

                                    // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                                    return funcName.indexOf( "outer" ) === 0 ?
                                        elem[ "inner" + name ] :
                                        elem.document.documentElement[ "client" + name ];
                                }

                                // Get document width or height
                                if ( elem.nodeType === 9 ) {
                                    doc = elem.documentElement;

                                    // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                                    // whichever is greatest
                                    return Math.max(
                                        elem.body[ "scroll" + name ], doc[ "scroll" + name ],
                                        elem.body[ "offset" + name ], doc[ "offset" + name ],
                                        doc[ "client" + name ]
                                    );
                                }

                                return value === undefined ?

                                    // Get width or height on the element, requesting but not forcing parseFloat
                                    jQuery.css( elem, type, extra ) :

                                    // Set width or height on the element
                                    jQuery.style( elem, type, value, extra );
                            }, type, chainable ? margin : undefined, chainable );
                        };
                    } );
                } );


                jQuery.each( [
                    "ajaxStart",
                    "ajaxStop",
                    "ajaxComplete",
                    "ajaxError",
                    "ajaxSuccess",
                    "ajaxSend"
                ], function( _i, type ) {
                    jQuery.fn[ type ] = function( fn ) {
                        return this.on( type, fn );
                    };
                } );




                jQuery.fn.extend( {

                    bind: function( types, data, fn ) {
                        return this.on( types, null, data, fn );
                    },
                    unbind: function( types, fn ) {
                        return this.off( types, null, fn );
                    },

                    delegate: function( selector, types, data, fn ) {
                        return this.on( types, selector, data, fn );
                    },
                    undelegate: function( selector, types, fn ) {

                        // ( namespace ) or ( selector, types [, fn] )
                        return arguments.length === 1 ?
                            this.off( selector, "**" ) :
                            this.off( types, selector || "**", fn );
                    },

                    hover: function( fnOver, fnOut ) {
                        return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
                    }
                } );

                jQuery.each(
                    ( "blur focus focusin focusout resize scroll click dblclick " +
                        "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
                        "change select submit keydown keypress keyup contextmenu" ).split( " " ),
                    function( _i, name ) {

                        // Handle event binding
                        jQuery.fn[ name ] = function( data, fn ) {
                            return arguments.length > 0 ?
                                this.on( name, null, data, fn ) :
                                this.trigger( name );
                        };
                    }
                );




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
                var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
                jQuery.proxy = function( fn, context ) {
                    var tmp, args, proxy;

                    if ( typeof context === "string" ) {
                        tmp = fn[ context ];
                        context = fn;
                        fn = tmp;
                    }

                    // Quick check to determine if target is callable, in the spec
                    // this throws a TypeError, but we will just return undefined.
                    if ( !isFunction( fn ) ) {
                        return undefined;
                    }

                    // Simulated bind
                    args = slice.call( arguments, 2 );
                    proxy = function() {
                        return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
                    };

                    // Set the guid of unique handler to the same of original handler, so it can be removed
                    proxy.guid = fn.guid = fn.guid || jQuery.guid++;

                    return proxy;
                };

                jQuery.holdReady = function( hold ) {
                    if ( hold ) {
                        jQuery.readyWait++;
                    } else {
                        jQuery.ready( true );
                    }
                };
                jQuery.isArray = Array.isArray;
                jQuery.parseJSON = JSON.parse;
                jQuery.nodeName = nodeName;
                jQuery.isFunction = isFunction;
                jQuery.isWindow = isWindow;
                jQuery.camelCase = camelCase;
                jQuery.type = toType;

                jQuery.now = Date.now;

                jQuery.isNumeric = function( obj ) {

                    // As of jQuery 3.0, isNumeric is limited to
                    // strings and numbers (primitives or objects)
                    // that can be coerced to finite numbers (gh-2662)
                    var type = jQuery.type( obj );
                    return ( type === "number" || type === "string" ) &&

                        // parseFloat NaNs numeric-cast false positives ("")
                        // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
                        // subtraction forces infinities to NaN
                        !isNaN( obj - parseFloat( obj ) );
                };

                jQuery.trim = function( text ) {
                    return text == null ?
                        "" :
                        ( text + "" ).replace( rtrim, "" );
                };



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

                if ( true ) {
                    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                        return jQuery;
                    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                }




                var

                    // Map over jQuery in case of overwrite
                    _jQuery = window.jQuery,

                    // Map over the $ in case of overwrite
                    _$ = window.$;

                jQuery.noConflict = function( deep ) {
                    if ( window.$ === jQuery ) {
                        window.$ = _$;
                    }

                    if ( deep && window.jQuery === jQuery ) {
                        window.jQuery = _jQuery;
                    }

                    return jQuery;
                };

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
                if ( typeof noGlobal === "undefined" ) {
                    window.jQuery = window.$ = jQuery;
                }




                return jQuery;
            } );


            /***/ }),

        /***/ 5825:
        /***/ (function(module, exports) {

            var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! jQuery v3.6.0 | (c) OpenJS Foundation and other contributors | jquery.org/license */
            !function(e,t){"use strict"; true&&"object"==typeof module.exports?module.exports=e.document?t(e,!0):function(e){if(!e.document)throw new Error("jQuery requires a window with a document");return t(e)}:t(e)}("undefined"!=typeof window?window:this,function(C,e){"use strict";var t=[],r=Object.getPrototypeOf,s=t.slice,g=t.flat?function(e){return t.flat.call(e)}:function(e){return t.concat.apply([],e)},u=t.push,i=t.indexOf,n={},o=n.toString,v=n.hasOwnProperty,a=v.toString,l=a.call(Object),y={},m=function(e){return"function"==typeof e&&"number"!=typeof e.nodeType&&"function"!=typeof e.item},x=function(e){return null!=e&&e===e.window},E=C.document,c={type:!0,src:!0,nonce:!0,noModule:!0};function b(e,t,n){var r,i,o=(n=n||E).createElement("script");if(o.text=e,t)for(r in c)(i=t[r]||t.getAttribute&&t.getAttribute(r))&&o.setAttribute(r,i);n.head.appendChild(o).parentNode.removeChild(o)}function w(e){return null==e?e+"":"object"==typeof e||"function"==typeof e?n[o.call(e)]||"object":typeof e}var f="3.6.0",S=function(e,t){return new S.fn.init(e,t)};function p(e){var t=!!e&&"length"in e&&e.length,n=w(e);return!m(e)&&!x(e)&&("array"===n||0===t||"number"==typeof t&&0<t&&t-1 in e)}S.fn=S.prototype={jquery:f,constructor:S,length:0,toArray:function(){return s.call(this)},get:function(e){return null==e?s.call(this):e<0?this[e+this.length]:this[e]},pushStack:function(e){var t=S.merge(this.constructor(),e);return t.prevObject=this,t},each:function(e){return S.each(this,e)},map:function(n){return this.pushStack(S.map(this,function(e,t){return n.call(e,t,e)}))},slice:function(){return this.pushStack(s.apply(this,arguments))},first:function(){return this.eq(0)},last:function(){return this.eq(-1)},even:function(){return this.pushStack(S.grep(this,function(e,t){return(t+1)%2}))},odd:function(){return this.pushStack(S.grep(this,function(e,t){return t%2}))},eq:function(e){var t=this.length,n=+e+(e<0?t:0);return this.pushStack(0<=n&&n<t?[this[n]]:[])},end:function(){return this.prevObject||this.constructor()},push:u,sort:t.sort,splice:t.splice},S.extend=S.fn.extend=function(){var e,t,n,r,i,o,a=arguments[0]||{},s=1,u=arguments.length,l=!1;for("boolean"==typeof a&&(l=a,a=arguments[s]||{},s++),"object"==typeof a||m(a)||(a={}),s===u&&(a=this,s--);s<u;s++)if(null!=(e=arguments[s]))for(t in e)r=e[t],"__proto__"!==t&&a!==r&&(l&&r&&(S.isPlainObject(r)||(i=Array.isArray(r)))?(n=a[t],o=i&&!Array.isArray(n)?[]:i||S.isPlainObject(n)?n:{},i=!1,a[t]=S.extend(l,o,r)):void 0!==r&&(a[t]=r));return a},S.extend({expando:"jQuery"+(f+Math.random()).replace(/\D/g,""),isReady:!0,error:function(e){throw new Error(e)},noop:function(){},isPlainObject:function(e){var t,n;return!(!e||"[object Object]"!==o.call(e))&&(!(t=r(e))||"function"==typeof(n=v.call(t,"constructor")&&t.constructor)&&a.call(n)===l)},isEmptyObject:function(e){var t;for(t in e)return!1;return!0},globalEval:function(e,t,n){b(e,{nonce:t&&t.nonce},n)},each:function(e,t){var n,r=0;if(p(e)){for(n=e.length;r<n;r++)if(!1===t.call(e[r],r,e[r]))break}else for(r in e)if(!1===t.call(e[r],r,e[r]))break;return e},makeArray:function(e,t){var n=t||[];return null!=e&&(p(Object(e))?S.merge(n,"string"==typeof e?[e]:e):u.call(n,e)),n},inArray:function(e,t,n){return null==t?-1:i.call(t,e,n)},merge:function(e,t){for(var n=+t.length,r=0,i=e.length;r<n;r++)e[i++]=t[r];return e.length=i,e},grep:function(e,t,n){for(var r=[],i=0,o=e.length,a=!n;i<o;i++)!t(e[i],i)!==a&&r.push(e[i]);return r},map:function(e,t,n){var r,i,o=0,a=[];if(p(e))for(r=e.length;o<r;o++)null!=(i=t(e[o],o,n))&&a.push(i);else for(o in e)null!=(i=t(e[o],o,n))&&a.push(i);return g(a)},guid:1,support:y}),"function"==typeof Symbol&&(S.fn[Symbol.iterator]=t[Symbol.iterator]),S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "),function(e,t){n["[object "+t+"]"]=t.toLowerCase()});var d=function(n){var e,d,b,o,i,h,f,g,w,u,l,T,C,a,E,v,s,c,y,S="sizzle"+1*new Date,p=n.document,k=0,r=0,m=ue(),x=ue(),A=ue(),N=ue(),j=function(e,t){return e===t&&(l=!0),0},D={}.hasOwnProperty,t=[],q=t.pop,L=t.push,H=t.push,O=t.slice,P=function(e,t){for(var n=0,r=e.length;n<r;n++)if(e[n]===t)return n;return-1},R="checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",M="[\\x20\\t\\r\\n\\f]",I="(?:\\\\[\\da-fA-F]{1,6}"+M+"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",W="\\["+M+"*("+I+")(?:"+M+"*([*^$|!~]?=)"+M+"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|("+I+"))|)"+M+"*\\]",F=":("+I+")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|"+W+")*)|.*)\\)|)",B=new RegExp(M+"+","g"),$=new RegExp("^"+M+"+|((?:^|[^\\\\])(?:\\\\.)*)"+M+"+$","g"),_=new RegExp("^"+M+"*,"+M+"*"),z=new RegExp("^"+M+"*([>+~]|"+M+")"+M+"*"),U=new RegExp(M+"|>"),X=new RegExp(F),V=new RegExp("^"+I+"$"),G={ID:new RegExp("^#("+I+")"),CLASS:new RegExp("^\\.("+I+")"),TAG:new RegExp("^("+I+"|[*])"),ATTR:new RegExp("^"+W),PSEUDO:new RegExp("^"+F),CHILD:new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\("+M+"*(even|odd|(([+-]|)(\\d*)n|)"+M+"*(?:([+-]|)"+M+"*(\\d+)|))"+M+"*\\)|)","i"),bool:new RegExp("^(?:"+R+")$","i"),needsContext:new RegExp("^"+M+"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\("+M+"*((?:-\\d)?\\d*)"+M+"*\\)|)(?=[^-]|$)","i")},Y=/HTML$/i,Q=/^(?:input|select|textarea|button)$/i,J=/^h\d$/i,K=/^[^{]+\{\s*\[native \w/,Z=/^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,ee=/[+~]/,te=new RegExp("\\\\[\\da-fA-F]{1,6}"+M+"?|\\\\([^\\r\\n\\f])","g"),ne=function(e,t){var n="0x"+e.slice(1)-65536;return t||(n<0?String.fromCharCode(n+65536):String.fromCharCode(n>>10|55296,1023&n|56320))},re=/([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,ie=function(e,t){return t?"\0"===e?"\ufffd":e.slice(0,-1)+"\\"+e.charCodeAt(e.length-1).toString(16)+" ":"\\"+e},oe=function(){T()},ae=be(function(e){return!0===e.disabled&&"fieldset"===e.nodeName.toLowerCase()},{dir:"parentNode",next:"legend"});try{H.apply(t=O.call(p.childNodes),p.childNodes),t[p.childNodes.length].nodeType}catch(e){H={apply:t.length?function(e,t){L.apply(e,O.call(t))}:function(e,t){var n=e.length,r=0;while(e[n++]=t[r++]);e.length=n-1}}}function se(t,e,n,r){var i,o,a,s,u,l,c,f=e&&e.ownerDocument,p=e?e.nodeType:9;if(n=n||[],"string"!=typeof t||!t||1!==p&&9!==p&&11!==p)return n;if(!r&&(T(e),e=e||C,E)){if(11!==p&&(u=Z.exec(t)))if(i=u[1]){if(9===p){if(!(a=e.getElementById(i)))return n;if(a.id===i)return n.push(a),n}else if(f&&(a=f.getElementById(i))&&y(e,a)&&a.id===i)return n.push(a),n}else{if(u[2])return H.apply(n,e.getElementsByTagName(t)),n;if((i=u[3])&&d.getElementsByClassName&&e.getElementsByClassName)return H.apply(n,e.getElementsByClassName(i)),n}if(d.qsa&&!N[t+" "]&&(!v||!v.test(t))&&(1!==p||"object"!==e.nodeName.toLowerCase())){if(c=t,f=e,1===p&&(U.test(t)||z.test(t))){(f=ee.test(t)&&ye(e.parentNode)||e)===e&&d.scope||((s=e.getAttribute("id"))?s=s.replace(re,ie):e.setAttribute("id",s=S)),o=(l=h(t)).length;while(o--)l[o]=(s?"#"+s:":scope")+" "+xe(l[o]);c=l.join(",")}try{return H.apply(n,f.querySelectorAll(c)),n}catch(e){N(t,!0)}finally{s===S&&e.removeAttribute("id")}}}return g(t.replace($,"$1"),e,n,r)}function ue(){var r=[];return function e(t,n){return r.push(t+" ")>b.cacheLength&&delete e[r.shift()],e[t+" "]=n}}function le(e){return e[S]=!0,e}function ce(e){var t=C.createElement("fieldset");try{return!!e(t)}catch(e){return!1}finally{t.parentNode&&t.parentNode.removeChild(t),t=null}}function fe(e,t){var n=e.split("|"),r=n.length;while(r--)b.attrHandle[n[r]]=t}function pe(e,t){var n=t&&e,r=n&&1===e.nodeType&&1===t.nodeType&&e.sourceIndex-t.sourceIndex;if(r)return r;if(n)while(n=n.nextSibling)if(n===t)return-1;return e?1:-1}function de(t){return function(e){return"input"===e.nodeName.toLowerCase()&&e.type===t}}function he(n){return function(e){var t=e.nodeName.toLowerCase();return("input"===t||"button"===t)&&e.type===n}}function ge(t){return function(e){return"form"in e?e.parentNode&&!1===e.disabled?"label"in e?"label"in e.parentNode?e.parentNode.disabled===t:e.disabled===t:e.isDisabled===t||e.isDisabled!==!t&&ae(e)===t:e.disabled===t:"label"in e&&e.disabled===t}}function ve(a){return le(function(o){return o=+o,le(function(e,t){var n,r=a([],e.length,o),i=r.length;while(i--)e[n=r[i]]&&(e[n]=!(t[n]=e[n]))})})}function ye(e){return e&&"undefined"!=typeof e.getElementsByTagName&&e}for(e in d=se.support={},i=se.isXML=function(e){var t=e&&e.namespaceURI,n=e&&(e.ownerDocument||e).documentElement;return!Y.test(t||n&&n.nodeName||"HTML")},T=se.setDocument=function(e){var t,n,r=e?e.ownerDocument||e:p;return r!=C&&9===r.nodeType&&r.documentElement&&(a=(C=r).documentElement,E=!i(C),p!=C&&(n=C.defaultView)&&n.top!==n&&(n.addEventListener?n.addEventListener("unload",oe,!1):n.attachEvent&&n.attachEvent("onunload",oe)),d.scope=ce(function(e){return a.appendChild(e).appendChild(C.createElement("div")),"undefined"!=typeof e.querySelectorAll&&!e.querySelectorAll(":scope fieldset div").length}),d.attributes=ce(function(e){return e.className="i",!e.getAttribute("className")}),d.getElementsByTagName=ce(function(e){return e.appendChild(C.createComment("")),!e.getElementsByTagName("*").length}),d.getElementsByClassName=K.test(C.getElementsByClassName),d.getById=ce(function(e){return a.appendChild(e).id=S,!C.getElementsByName||!C.getElementsByName(S).length}),d.getById?(b.filter.ID=function(e){var t=e.replace(te,ne);return function(e){return e.getAttribute("id")===t}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n=t.getElementById(e);return n?[n]:[]}}):(b.filter.ID=function(e){var n=e.replace(te,ne);return function(e){var t="undefined"!=typeof e.getAttributeNode&&e.getAttributeNode("id");return t&&t.value===n}},b.find.ID=function(e,t){if("undefined"!=typeof t.getElementById&&E){var n,r,i,o=t.getElementById(e);if(o){if((n=o.getAttributeNode("id"))&&n.value===e)return[o];i=t.getElementsByName(e),r=0;while(o=i[r++])if((n=o.getAttributeNode("id"))&&n.value===e)return[o]}return[]}}),b.find.TAG=d.getElementsByTagName?function(e,t){return"undefined"!=typeof t.getElementsByTagName?t.getElementsByTagName(e):d.qsa?t.querySelectorAll(e):void 0}:function(e,t){var n,r=[],i=0,o=t.getElementsByTagName(e);if("*"===e){while(n=o[i++])1===n.nodeType&&r.push(n);return r}return o},b.find.CLASS=d.getElementsByClassName&&function(e,t){if("undefined"!=typeof t.getElementsByClassName&&E)return t.getElementsByClassName(e)},s=[],v=[],(d.qsa=K.test(C.querySelectorAll))&&(ce(function(e){var t;a.appendChild(e).innerHTML="<a id='"+S+"'></a><select id='"+S+"-\r\\' msallowcapture=''><option selected=''></option></select>",e.querySelectorAll("[msallowcapture^='']").length&&v.push("[*^$]="+M+"*(?:''|\"\")"),e.querySelectorAll("[selected]").length||v.push("\\["+M+"*(?:value|"+R+")"),e.querySelectorAll("[id~="+S+"-]").length||v.push("~="),(t=C.createElement("input")).setAttribute("name",""),e.appendChild(t),e.querySelectorAll("[name='']").length||v.push("\\["+M+"*name"+M+"*="+M+"*(?:''|\"\")"),e.querySelectorAll(":checked").length||v.push(":checked"),e.querySelectorAll("a#"+S+"+*").length||v.push(".#.+[+~]"),e.querySelectorAll("\\\f"),v.push("[\\r\\n\\f]")}),ce(function(e){e.innerHTML="<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";var t=C.createElement("input");t.setAttribute("type","hidden"),e.appendChild(t).setAttribute("name","D"),e.querySelectorAll("[name=d]").length&&v.push("name"+M+"*[*^$|!~]?="),2!==e.querySelectorAll(":enabled").length&&v.push(":enabled",":disabled"),a.appendChild(e).disabled=!0,2!==e.querySelectorAll(":disabled").length&&v.push(":enabled",":disabled"),e.querySelectorAll("*,:x"),v.push(",.*:")})),(d.matchesSelector=K.test(c=a.matches||a.webkitMatchesSelector||a.mozMatchesSelector||a.oMatchesSelector||a.msMatchesSelector))&&ce(function(e){d.disconnectedMatch=c.call(e,"*"),c.call(e,"[s!='']:x"),s.push("!=",F)}),v=v.length&&new RegExp(v.join("|")),s=s.length&&new RegExp(s.join("|")),t=K.test(a.compareDocumentPosition),y=t||K.test(a.contains)?function(e,t){var n=9===e.nodeType?e.documentElement:e,r=t&&t.parentNode;return e===r||!(!r||1!==r.nodeType||!(n.contains?n.contains(r):e.compareDocumentPosition&&16&e.compareDocumentPosition(r)))}:function(e,t){if(t)while(t=t.parentNode)if(t===e)return!0;return!1},j=t?function(e,t){if(e===t)return l=!0,0;var n=!e.compareDocumentPosition-!t.compareDocumentPosition;return n||(1&(n=(e.ownerDocument||e)==(t.ownerDocument||t)?e.compareDocumentPosition(t):1)||!d.sortDetached&&t.compareDocumentPosition(e)===n?e==C||e.ownerDocument==p&&y(p,e)?-1:t==C||t.ownerDocument==p&&y(p,t)?1:u?P(u,e)-P(u,t):0:4&n?-1:1)}:function(e,t){if(e===t)return l=!0,0;var n,r=0,i=e.parentNode,o=t.parentNode,a=[e],s=[t];if(!i||!o)return e==C?-1:t==C?1:i?-1:o?1:u?P(u,e)-P(u,t):0;if(i===o)return pe(e,t);n=e;while(n=n.parentNode)a.unshift(n);n=t;while(n=n.parentNode)s.unshift(n);while(a[r]===s[r])r++;return r?pe(a[r],s[r]):a[r]==p?-1:s[r]==p?1:0}),C},se.matches=function(e,t){return se(e,null,null,t)},se.matchesSelector=function(e,t){if(T(e),d.matchesSelector&&E&&!N[t+" "]&&(!s||!s.test(t))&&(!v||!v.test(t)))try{var n=c.call(e,t);if(n||d.disconnectedMatch||e.document&&11!==e.document.nodeType)return n}catch(e){N(t,!0)}return 0<se(t,C,null,[e]).length},se.contains=function(e,t){return(e.ownerDocument||e)!=C&&T(e),y(e,t)},se.attr=function(e,t){(e.ownerDocument||e)!=C&&T(e);var n=b.attrHandle[t.toLowerCase()],r=n&&D.call(b.attrHandle,t.toLowerCase())?n(e,t,!E):void 0;return void 0!==r?r:d.attributes||!E?e.getAttribute(t):(r=e.getAttributeNode(t))&&r.specified?r.value:null},se.escape=function(e){return(e+"").replace(re,ie)},se.error=function(e){throw new Error("Syntax error, unrecognized expression: "+e)},se.uniqueSort=function(e){var t,n=[],r=0,i=0;if(l=!d.detectDuplicates,u=!d.sortStable&&e.slice(0),e.sort(j),l){while(t=e[i++])t===e[i]&&(r=n.push(i));while(r--)e.splice(n[r],1)}return u=null,e},o=se.getText=function(e){var t,n="",r=0,i=e.nodeType;if(i){if(1===i||9===i||11===i){if("string"==typeof e.textContent)return e.textContent;for(e=e.firstChild;e;e=e.nextSibling)n+=o(e)}else if(3===i||4===i)return e.nodeValue}else while(t=e[r++])n+=o(t);return n},(b=se.selectors={cacheLength:50,createPseudo:le,match:G,attrHandle:{},find:{},relative:{">":{dir:"parentNode",first:!0}," ":{dir:"parentNode"},"+":{dir:"previousSibling",first:!0},"~":{dir:"previousSibling"}},preFilter:{ATTR:function(e){return e[1]=e[1].replace(te,ne),e[3]=(e[3]||e[4]||e[5]||"").replace(te,ne),"~="===e[2]&&(e[3]=" "+e[3]+" "),e.slice(0,4)},CHILD:function(e){return e[1]=e[1].toLowerCase(),"nth"===e[1].slice(0,3)?(e[3]||se.error(e[0]),e[4]=+(e[4]?e[5]+(e[6]||1):2*("even"===e[3]||"odd"===e[3])),e[5]=+(e[7]+e[8]||"odd"===e[3])):e[3]&&se.error(e[0]),e},PSEUDO:function(e){var t,n=!e[6]&&e[2];return G.CHILD.test(e[0])?null:(e[3]?e[2]=e[4]||e[5]||"":n&&X.test(n)&&(t=h(n,!0))&&(t=n.indexOf(")",n.length-t)-n.length)&&(e[0]=e[0].slice(0,t),e[2]=n.slice(0,t)),e.slice(0,3))}},filter:{TAG:function(e){var t=e.replace(te,ne).toLowerCase();return"*"===e?function(){return!0}:function(e){return e.nodeName&&e.nodeName.toLowerCase()===t}},CLASS:function(e){var t=m[e+" "];return t||(t=new RegExp("(^|"+M+")"+e+"("+M+"|$)"))&&m(e,function(e){return t.test("string"==typeof e.className&&e.className||"undefined"!=typeof e.getAttribute&&e.getAttribute("class")||"")})},ATTR:function(n,r,i){return function(e){var t=se.attr(e,n);return null==t?"!="===r:!r||(t+="","="===r?t===i:"!="===r?t!==i:"^="===r?i&&0===t.indexOf(i):"*="===r?i&&-1<t.indexOf(i):"$="===r?i&&t.slice(-i.length)===i:"~="===r?-1<(" "+t.replace(B," ")+" ").indexOf(i):"|="===r&&(t===i||t.slice(0,i.length+1)===i+"-"))}},CHILD:function(h,e,t,g,v){var y="nth"!==h.slice(0,3),m="last"!==h.slice(-4),x="of-type"===e;return 1===g&&0===v?function(e){return!!e.parentNode}:function(e,t,n){var r,i,o,a,s,u,l=y!==m?"nextSibling":"previousSibling",c=e.parentNode,f=x&&e.nodeName.toLowerCase(),p=!n&&!x,d=!1;if(c){if(y){while(l){a=e;while(a=a[l])if(x?a.nodeName.toLowerCase()===f:1===a.nodeType)return!1;u=l="only"===h&&!u&&"nextSibling"}return!0}if(u=[m?c.firstChild:c.lastChild],m&&p){d=(s=(r=(i=(o=(a=c)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1])&&r[2],a=s&&c.childNodes[s];while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if(1===a.nodeType&&++d&&a===e){i[h]=[k,s,d];break}}else if(p&&(d=s=(r=(i=(o=(a=e)[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]||[])[0]===k&&r[1]),!1===d)while(a=++s&&a&&a[l]||(d=s=0)||u.pop())if((x?a.nodeName.toLowerCase()===f:1===a.nodeType)&&++d&&(p&&((i=(o=a[S]||(a[S]={}))[a.uniqueID]||(o[a.uniqueID]={}))[h]=[k,d]),a===e))break;return(d-=v)===g||d%g==0&&0<=d/g}}},PSEUDO:function(e,o){var t,a=b.pseudos[e]||b.setFilters[e.toLowerCase()]||se.error("unsupported pseudo: "+e);return a[S]?a(o):1<a.length?(t=[e,e,"",o],b.setFilters.hasOwnProperty(e.toLowerCase())?le(function(e,t){var n,r=a(e,o),i=r.length;while(i--)e[n=P(e,r[i])]=!(t[n]=r[i])}):function(e){return a(e,0,t)}):a}},pseudos:{not:le(function(e){var r=[],i=[],s=f(e.replace($,"$1"));return s[S]?le(function(e,t,n,r){var i,o=s(e,null,r,[]),a=e.length;while(a--)(i=o[a])&&(e[a]=!(t[a]=i))}):function(e,t,n){return r[0]=e,s(r,null,n,i),r[0]=null,!i.pop()}}),has:le(function(t){return function(e){return 0<se(t,e).length}}),contains:le(function(t){return t=t.replace(te,ne),function(e){return-1<(e.textContent||o(e)).indexOf(t)}}),lang:le(function(n){return V.test(n||"")||se.error("unsupported lang: "+n),n=n.replace(te,ne).toLowerCase(),function(e){var t;do{if(t=E?e.lang:e.getAttribute("xml:lang")||e.getAttribute("lang"))return(t=t.toLowerCase())===n||0===t.indexOf(n+"-")}while((e=e.parentNode)&&1===e.nodeType);return!1}}),target:function(e){var t=n.location&&n.location.hash;return t&&t.slice(1)===e.id},root:function(e){return e===a},focus:function(e){return e===C.activeElement&&(!C.hasFocus||C.hasFocus())&&!!(e.type||e.href||~e.tabIndex)},enabled:ge(!1),disabled:ge(!0),checked:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&!!e.checked||"option"===t&&!!e.selected},selected:function(e){return e.parentNode&&e.parentNode.selectedIndex,!0===e.selected},empty:function(e){for(e=e.firstChild;e;e=e.nextSibling)if(e.nodeType<6)return!1;return!0},parent:function(e){return!b.pseudos.empty(e)},header:function(e){return J.test(e.nodeName)},input:function(e){return Q.test(e.nodeName)},button:function(e){var t=e.nodeName.toLowerCase();return"input"===t&&"button"===e.type||"button"===t},text:function(e){var t;return"input"===e.nodeName.toLowerCase()&&"text"===e.type&&(null==(t=e.getAttribute("type"))||"text"===t.toLowerCase())},first:ve(function(){return[0]}),last:ve(function(e,t){return[t-1]}),eq:ve(function(e,t,n){return[n<0?n+t:n]}),even:ve(function(e,t){for(var n=0;n<t;n+=2)e.push(n);return e}),odd:ve(function(e,t){for(var n=1;n<t;n+=2)e.push(n);return e}),lt:ve(function(e,t,n){for(var r=n<0?n+t:t<n?t:n;0<=--r;)e.push(r);return e}),gt:ve(function(e,t,n){for(var r=n<0?n+t:n;++r<t;)e.push(r);return e})}}).pseudos.nth=b.pseudos.eq,{radio:!0,checkbox:!0,file:!0,password:!0,image:!0})b.pseudos[e]=de(e);for(e in{submit:!0,reset:!0})b.pseudos[e]=he(e);function me(){}function xe(e){for(var t=0,n=e.length,r="";t<n;t++)r+=e[t].value;return r}function be(s,e,t){var u=e.dir,l=e.next,c=l||u,f=t&&"parentNode"===c,p=r++;return e.first?function(e,t,n){while(e=e[u])if(1===e.nodeType||f)return s(e,t,n);return!1}:function(e,t,n){var r,i,o,a=[k,p];if(n){while(e=e[u])if((1===e.nodeType||f)&&s(e,t,n))return!0}else while(e=e[u])if(1===e.nodeType||f)if(i=(o=e[S]||(e[S]={}))[e.uniqueID]||(o[e.uniqueID]={}),l&&l===e.nodeName.toLowerCase())e=e[u]||e;else{if((r=i[c])&&r[0]===k&&r[1]===p)return a[2]=r[2];if((i[c]=a)[2]=s(e,t,n))return!0}return!1}}function we(i){return 1<i.length?function(e,t,n){var r=i.length;while(r--)if(!i[r](e,t,n))return!1;return!0}:i[0]}function Te(e,t,n,r,i){for(var o,a=[],s=0,u=e.length,l=null!=t;s<u;s++)(o=e[s])&&(n&&!n(o,r,i)||(a.push(o),l&&t.push(s)));return a}function Ce(d,h,g,v,y,e){return v&&!v[S]&&(v=Ce(v)),y&&!y[S]&&(y=Ce(y,e)),le(function(e,t,n,r){var i,o,a,s=[],u=[],l=t.length,c=e||function(e,t,n){for(var r=0,i=t.length;r<i;r++)se(e,t[r],n);return n}(h||"*",n.nodeType?[n]:n,[]),f=!d||!e&&h?c:Te(c,s,d,n,r),p=g?y||(e?d:l||v)?[]:t:f;if(g&&g(f,p,n,r),v){i=Te(p,u),v(i,[],n,r),o=i.length;while(o--)(a=i[o])&&(p[u[o]]=!(f[u[o]]=a))}if(e){if(y||d){if(y){i=[],o=p.length;while(o--)(a=p[o])&&i.push(f[o]=a);y(null,p=[],i,r)}o=p.length;while(o--)(a=p[o])&&-1<(i=y?P(e,a):s[o])&&(e[i]=!(t[i]=a))}}else p=Te(p===t?p.splice(l,p.length):p),y?y(null,t,p,r):H.apply(t,p)})}function Ee(e){for(var i,t,n,r=e.length,o=b.relative[e[0].type],a=o||b.relative[" "],s=o?1:0,u=be(function(e){return e===i},a,!0),l=be(function(e){return-1<P(i,e)},a,!0),c=[function(e,t,n){var r=!o&&(n||t!==w)||((i=t).nodeType?u(e,t,n):l(e,t,n));return i=null,r}];s<r;s++)if(t=b.relative[e[s].type])c=[be(we(c),t)];else{if((t=b.filter[e[s].type].apply(null,e[s].matches))[S]){for(n=++s;n<r;n++)if(b.relative[e[n].type])break;return Ce(1<s&&we(c),1<s&&xe(e.slice(0,s-1).concat({value:" "===e[s-2].type?"*":""})).replace($,"$1"),t,s<n&&Ee(e.slice(s,n)),n<r&&Ee(e=e.slice(n)),n<r&&xe(e))}c.push(t)}return we(c)}return me.prototype=b.filters=b.pseudos,b.setFilters=new me,h=se.tokenize=function(e,t){var n,r,i,o,a,s,u,l=x[e+" "];if(l)return t?0:l.slice(0);a=e,s=[],u=b.preFilter;while(a){for(o in n&&!(r=_.exec(a))||(r&&(a=a.slice(r[0].length)||a),s.push(i=[])),n=!1,(r=z.exec(a))&&(n=r.shift(),i.push({value:n,type:r[0].replace($," ")}),a=a.slice(n.length)),b.filter)!(r=G[o].exec(a))||u[o]&&!(r=u[o](r))||(n=r.shift(),i.push({value:n,type:o,matches:r}),a=a.slice(n.length));if(!n)break}return t?a.length:a?se.error(e):x(e,s).slice(0)},f=se.compile=function(e,t){var n,v,y,m,x,r,i=[],o=[],a=A[e+" "];if(!a){t||(t=h(e)),n=t.length;while(n--)(a=Ee(t[n]))[S]?i.push(a):o.push(a);(a=A(e,(v=o,m=0<(y=i).length,x=0<v.length,r=function(e,t,n,r,i){var o,a,s,u=0,l="0",c=e&&[],f=[],p=w,d=e||x&&b.find.TAG("*",i),h=k+=null==p?1:Math.random()||.1,g=d.length;for(i&&(w=t==C||t||i);l!==g&&null!=(o=d[l]);l++){if(x&&o){a=0,t||o.ownerDocument==C||(T(o),n=!E);while(s=v[a++])if(s(o,t||C,n)){r.push(o);break}i&&(k=h)}m&&((o=!s&&o)&&u--,e&&c.push(o))}if(u+=l,m&&l!==u){a=0;while(s=y[a++])s(c,f,t,n);if(e){if(0<u)while(l--)c[l]||f[l]||(f[l]=q.call(r));f=Te(f)}H.apply(r,f),i&&!e&&0<f.length&&1<u+y.length&&se.uniqueSort(r)}return i&&(k=h,w=p),c},m?le(r):r))).selector=e}return a},g=se.select=function(e,t,n,r){var i,o,a,s,u,l="function"==typeof e&&e,c=!r&&h(e=l.selector||e);if(n=n||[],1===c.length){if(2<(o=c[0]=c[0].slice(0)).length&&"ID"===(a=o[0]).type&&9===t.nodeType&&E&&b.relative[o[1].type]){if(!(t=(b.find.ID(a.matches[0].replace(te,ne),t)||[])[0]))return n;l&&(t=t.parentNode),e=e.slice(o.shift().value.length)}i=G.needsContext.test(e)?0:o.length;while(i--){if(a=o[i],b.relative[s=a.type])break;if((u=b.find[s])&&(r=u(a.matches[0].replace(te,ne),ee.test(o[0].type)&&ye(t.parentNode)||t))){if(o.splice(i,1),!(e=r.length&&xe(o)))return H.apply(n,r),n;break}}}return(l||f(e,c))(r,t,!E,n,!t||ee.test(e)&&ye(t.parentNode)||t),n},d.sortStable=S.split("").sort(j).join("")===S,d.detectDuplicates=!!l,T(),d.sortDetached=ce(function(e){return 1&e.compareDocumentPosition(C.createElement("fieldset"))}),ce(function(e){return e.innerHTML="<a href='#'></a>","#"===e.firstChild.getAttribute("href")})||fe("type|href|height|width",function(e,t,n){if(!n)return e.getAttribute(t,"type"===t.toLowerCase()?1:2)}),d.attributes&&ce(function(e){return e.innerHTML="<input/>",e.firstChild.setAttribute("value",""),""===e.firstChild.getAttribute("value")})||fe("value",function(e,t,n){if(!n&&"input"===e.nodeName.toLowerCase())return e.defaultValue}),ce(function(e){return null==e.getAttribute("disabled")})||fe(R,function(e,t,n){var r;if(!n)return!0===e[t]?t.toLowerCase():(r=e.getAttributeNode(t))&&r.specified?r.value:null}),se}(C);S.find=d,S.expr=d.selectors,S.expr[":"]=S.expr.pseudos,S.uniqueSort=S.unique=d.uniqueSort,S.text=d.getText,S.isXMLDoc=d.isXML,S.contains=d.contains,S.escapeSelector=d.escape;var h=function(e,t,n){var r=[],i=void 0!==n;while((e=e[t])&&9!==e.nodeType)if(1===e.nodeType){if(i&&S(e).is(n))break;r.push(e)}return r},T=function(e,t){for(var n=[];e;e=e.nextSibling)1===e.nodeType&&e!==t&&n.push(e);return n},k=S.expr.match.needsContext;function A(e,t){return e.nodeName&&e.nodeName.toLowerCase()===t.toLowerCase()}var N=/^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;function j(e,n,r){return m(n)?S.grep(e,function(e,t){return!!n.call(e,t,e)!==r}):n.nodeType?S.grep(e,function(e){return e===n!==r}):"string"!=typeof n?S.grep(e,function(e){return-1<i.call(n,e)!==r}):S.filter(n,e,r)}S.filter=function(e,t,n){var r=t[0];return n&&(e=":not("+e+")"),1===t.length&&1===r.nodeType?S.find.matchesSelector(r,e)?[r]:[]:S.find.matches(e,S.grep(t,function(e){return 1===e.nodeType}))},S.fn.extend({find:function(e){var t,n,r=this.length,i=this;if("string"!=typeof e)return this.pushStack(S(e).filter(function(){for(t=0;t<r;t++)if(S.contains(i[t],this))return!0}));for(n=this.pushStack([]),t=0;t<r;t++)S.find(e,i[t],n);return 1<r?S.uniqueSort(n):n},filter:function(e){return this.pushStack(j(this,e||[],!1))},not:function(e){return this.pushStack(j(this,e||[],!0))},is:function(e){return!!j(this,"string"==typeof e&&k.test(e)?S(e):e||[],!1).length}});var D,q=/^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;(S.fn.init=function(e,t,n){var r,i;if(!e)return this;if(n=n||D,"string"==typeof e){if(!(r="<"===e[0]&&">"===e[e.length-1]&&3<=e.length?[null,e,null]:q.exec(e))||!r[1]&&t)return!t||t.jquery?(t||n).find(e):this.constructor(t).find(e);if(r[1]){if(t=t instanceof S?t[0]:t,S.merge(this,S.parseHTML(r[1],t&&t.nodeType?t.ownerDocument||t:E,!0)),N.test(r[1])&&S.isPlainObject(t))for(r in t)m(this[r])?this[r](t[r]):this.attr(r,t[r]);return this}return(i=E.getElementById(r[2]))&&(this[0]=i,this.length=1),this}return e.nodeType?(this[0]=e,this.length=1,this):m(e)?void 0!==n.ready?n.ready(e):e(S):S.makeArray(e,this)}).prototype=S.fn,D=S(E);var L=/^(?:parents|prev(?:Until|All))/,H={children:!0,contents:!0,next:!0,prev:!0};function O(e,t){while((e=e[t])&&1!==e.nodeType);return e}S.fn.extend({has:function(e){var t=S(e,this),n=t.length;return this.filter(function(){for(var e=0;e<n;e++)if(S.contains(this,t[e]))return!0})},closest:function(e,t){var n,r=0,i=this.length,o=[],a="string"!=typeof e&&S(e);if(!k.test(e))for(;r<i;r++)for(n=this[r];n&&n!==t;n=n.parentNode)if(n.nodeType<11&&(a?-1<a.index(n):1===n.nodeType&&S.find.matchesSelector(n,e))){o.push(n);break}return this.pushStack(1<o.length?S.uniqueSort(o):o)},index:function(e){return e?"string"==typeof e?i.call(S(e),this[0]):i.call(this,e.jquery?e[0]:e):this[0]&&this[0].parentNode?this.first().prevAll().length:-1},add:function(e,t){return this.pushStack(S.uniqueSort(S.merge(this.get(),S(e,t))))},addBack:function(e){return this.add(null==e?this.prevObject:this.prevObject.filter(e))}}),S.each({parent:function(e){var t=e.parentNode;return t&&11!==t.nodeType?t:null},parents:function(e){return h(e,"parentNode")},parentsUntil:function(e,t,n){return h(e,"parentNode",n)},next:function(e){return O(e,"nextSibling")},prev:function(e){return O(e,"previousSibling")},nextAll:function(e){return h(e,"nextSibling")},prevAll:function(e){return h(e,"previousSibling")},nextUntil:function(e,t,n){return h(e,"nextSibling",n)},prevUntil:function(e,t,n){return h(e,"previousSibling",n)},siblings:function(e){return T((e.parentNode||{}).firstChild,e)},children:function(e){return T(e.firstChild)},contents:function(e){return null!=e.contentDocument&&r(e.contentDocument)?e.contentDocument:(A(e,"template")&&(e=e.content||e),S.merge([],e.childNodes))}},function(r,i){S.fn[r]=function(e,t){var n=S.map(this,i,e);return"Until"!==r.slice(-5)&&(t=e),t&&"string"==typeof t&&(n=S.filter(t,n)),1<this.length&&(H[r]||S.uniqueSort(n),L.test(r)&&n.reverse()),this.pushStack(n)}});var P=/[^\x20\t\r\n\f]+/g;function R(e){return e}function M(e){throw e}function I(e,t,n,r){var i;try{e&&m(i=e.promise)?i.call(e).done(t).fail(n):e&&m(i=e.then)?i.call(e,t,n):t.apply(void 0,[e].slice(r))}catch(e){n.apply(void 0,[e])}}S.Callbacks=function(r){var e,n;r="string"==typeof r?(e=r,n={},S.each(e.match(P)||[],function(e,t){n[t]=!0}),n):S.extend({},r);var i,t,o,a,s=[],u=[],l=-1,c=function(){for(a=a||r.once,o=i=!0;u.length;l=-1){t=u.shift();while(++l<s.length)!1===s[l].apply(t[0],t[1])&&r.stopOnFalse&&(l=s.length,t=!1)}r.memory||(t=!1),i=!1,a&&(s=t?[]:"")},f={add:function(){return s&&(t&&!i&&(l=s.length-1,u.push(t)),function n(e){S.each(e,function(e,t){m(t)?r.unique&&f.has(t)||s.push(t):t&&t.length&&"string"!==w(t)&&n(t)})}(arguments),t&&!i&&c()),this},remove:function(){return S.each(arguments,function(e,t){var n;while(-1<(n=S.inArray(t,s,n)))s.splice(n,1),n<=l&&l--}),this},has:function(e){return e?-1<S.inArray(e,s):0<s.length},empty:function(){return s&&(s=[]),this},disable:function(){return a=u=[],s=t="",this},disabled:function(){return!s},lock:function(){return a=u=[],t||i||(s=t=""),this},locked:function(){return!!a},fireWith:function(e,t){return a||(t=[e,(t=t||[]).slice?t.slice():t],u.push(t),i||c()),this},fire:function(){return f.fireWith(this,arguments),this},fired:function(){return!!o}};return f},S.extend({Deferred:function(e){var o=[["notify","progress",S.Callbacks("memory"),S.Callbacks("memory"),2],["resolve","done",S.Callbacks("once memory"),S.Callbacks("once memory"),0,"resolved"],["reject","fail",S.Callbacks("once memory"),S.Callbacks("once memory"),1,"rejected"]],i="pending",a={state:function(){return i},always:function(){return s.done(arguments).fail(arguments),this},"catch":function(e){return a.then(null,e)},pipe:function(){var i=arguments;return S.Deferred(function(r){S.each(o,function(e,t){var n=m(i[t[4]])&&i[t[4]];s[t[1]](function(){var e=n&&n.apply(this,arguments);e&&m(e.promise)?e.promise().progress(r.notify).done(r.resolve).fail(r.reject):r[t[0]+"With"](this,n?[e]:arguments)})}),i=null}).promise()},then:function(t,n,r){var u=0;function l(i,o,a,s){return function(){var n=this,r=arguments,e=function(){var e,t;if(!(i<u)){if((e=a.apply(n,r))===o.promise())throw new TypeError("Thenable self-resolution");t=e&&("object"==typeof e||"function"==typeof e)&&e.then,m(t)?s?t.call(e,l(u,o,R,s),l(u,o,M,s)):(u++,t.call(e,l(u,o,R,s),l(u,o,M,s),l(u,o,R,o.notifyWith))):(a!==R&&(n=void 0,r=[e]),(s||o.resolveWith)(n,r))}},t=s?e:function(){try{e()}catch(e){S.Deferred.exceptionHook&&S.Deferred.exceptionHook(e,t.stackTrace),u<=i+1&&(a!==M&&(n=void 0,r=[e]),o.rejectWith(n,r))}};i?t():(S.Deferred.getStackHook&&(t.stackTrace=S.Deferred.getStackHook()),C.setTimeout(t))}}return S.Deferred(function(e){o[0][3].add(l(0,e,m(r)?r:R,e.notifyWith)),o[1][3].add(l(0,e,m(t)?t:R)),o[2][3].add(l(0,e,m(n)?n:M))}).promise()},promise:function(e){return null!=e?S.extend(e,a):a}},s={};return S.each(o,function(e,t){var n=t[2],r=t[5];a[t[1]]=n.add,r&&n.add(function(){i=r},o[3-e][2].disable,o[3-e][3].disable,o[0][2].lock,o[0][3].lock),n.add(t[3].fire),s[t[0]]=function(){return s[t[0]+"With"](this===s?void 0:this,arguments),this},s[t[0]+"With"]=n.fireWith}),a.promise(s),e&&e.call(s,s),s},when:function(e){var n=arguments.length,t=n,r=Array(t),i=s.call(arguments),o=S.Deferred(),a=function(t){return function(e){r[t]=this,i[t]=1<arguments.length?s.call(arguments):e,--n||o.resolveWith(r,i)}};if(n<=1&&(I(e,o.done(a(t)).resolve,o.reject,!n),"pending"===o.state()||m(i[t]&&i[t].then)))return o.then();while(t--)I(i[t],a(t),o.reject);return o.promise()}});var W=/^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;S.Deferred.exceptionHook=function(e,t){C.console&&C.console.warn&&e&&W.test(e.name)&&C.console.warn("jQuery.Deferred exception: "+e.message,e.stack,t)},S.readyException=function(e){C.setTimeout(function(){throw e})};var F=S.Deferred();function B(){E.removeEventListener("DOMContentLoaded",B),C.removeEventListener("load",B),S.ready()}S.fn.ready=function(e){return F.then(e)["catch"](function(e){S.readyException(e)}),this},S.extend({isReady:!1,readyWait:1,ready:function(e){(!0===e?--S.readyWait:S.isReady)||(S.isReady=!0)!==e&&0<--S.readyWait||F.resolveWith(E,[S])}}),S.ready.then=F.then,"complete"===E.readyState||"loading"!==E.readyState&&!E.documentElement.doScroll?C.setTimeout(S.ready):(E.addEventListener("DOMContentLoaded",B),C.addEventListener("load",B));var $=function(e,t,n,r,i,o,a){var s=0,u=e.length,l=null==n;if("object"===w(n))for(s in i=!0,n)$(e,t,s,n[s],!0,o,a);else if(void 0!==r&&(i=!0,m(r)||(a=!0),l&&(a?(t.call(e,r),t=null):(l=t,t=function(e,t,n){return l.call(S(e),n)})),t))for(;s<u;s++)t(e[s],n,a?r:r.call(e[s],s,t(e[s],n)));return i?e:l?t.call(e):u?t(e[0],n):o},_=/^-ms-/,z=/-([a-z])/g;function U(e,t){return t.toUpperCase()}function X(e){return e.replace(_,"ms-").replace(z,U)}var V=function(e){return 1===e.nodeType||9===e.nodeType||!+e.nodeType};function G(){this.expando=S.expando+G.uid++}G.uid=1,G.prototype={cache:function(e){var t=e[this.expando];return t||(t={},V(e)&&(e.nodeType?e[this.expando]=t:Object.defineProperty(e,this.expando,{value:t,configurable:!0}))),t},set:function(e,t,n){var r,i=this.cache(e);if("string"==typeof t)i[X(t)]=n;else for(r in t)i[X(r)]=t[r];return i},get:function(e,t){return void 0===t?this.cache(e):e[this.expando]&&e[this.expando][X(t)]},access:function(e,t,n){return void 0===t||t&&"string"==typeof t&&void 0===n?this.get(e,t):(this.set(e,t,n),void 0!==n?n:t)},remove:function(e,t){var n,r=e[this.expando];if(void 0!==r){if(void 0!==t){n=(t=Array.isArray(t)?t.map(X):(t=X(t))in r?[t]:t.match(P)||[]).length;while(n--)delete r[t[n]]}(void 0===t||S.isEmptyObject(r))&&(e.nodeType?e[this.expando]=void 0:delete e[this.expando])}},hasData:function(e){var t=e[this.expando];return void 0!==t&&!S.isEmptyObject(t)}};var Y=new G,Q=new G,J=/^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,K=/[A-Z]/g;function Z(e,t,n){var r,i;if(void 0===n&&1===e.nodeType)if(r="data-"+t.replace(K,"-$&").toLowerCase(),"string"==typeof(n=e.getAttribute(r))){try{n="true"===(i=n)||"false"!==i&&("null"===i?null:i===+i+""?+i:J.test(i)?JSON.parse(i):i)}catch(e){}Q.set(e,t,n)}else n=void 0;return n}S.extend({hasData:function(e){return Q.hasData(e)||Y.hasData(e)},data:function(e,t,n){return Q.access(e,t,n)},removeData:function(e,t){Q.remove(e,t)},_data:function(e,t,n){return Y.access(e,t,n)},_removeData:function(e,t){Y.remove(e,t)}}),S.fn.extend({data:function(n,e){var t,r,i,o=this[0],a=o&&o.attributes;if(void 0===n){if(this.length&&(i=Q.get(o),1===o.nodeType&&!Y.get(o,"hasDataAttrs"))){t=a.length;while(t--)a[t]&&0===(r=a[t].name).indexOf("data-")&&(r=X(r.slice(5)),Z(o,r,i[r]));Y.set(o,"hasDataAttrs",!0)}return i}return"object"==typeof n?this.each(function(){Q.set(this,n)}):$(this,function(e){var t;if(o&&void 0===e)return void 0!==(t=Q.get(o,n))?t:void 0!==(t=Z(o,n))?t:void 0;this.each(function(){Q.set(this,n,e)})},null,e,1<arguments.length,null,!0)},removeData:function(e){return this.each(function(){Q.remove(this,e)})}}),S.extend({queue:function(e,t,n){var r;if(e)return t=(t||"fx")+"queue",r=Y.get(e,t),n&&(!r||Array.isArray(n)?r=Y.access(e,t,S.makeArray(n)):r.push(n)),r||[]},dequeue:function(e,t){t=t||"fx";var n=S.queue(e,t),r=n.length,i=n.shift(),o=S._queueHooks(e,t);"inprogress"===i&&(i=n.shift(),r--),i&&("fx"===t&&n.unshift("inprogress"),delete o.stop,i.call(e,function(){S.dequeue(e,t)},o)),!r&&o&&o.empty.fire()},_queueHooks:function(e,t){var n=t+"queueHooks";return Y.get(e,n)||Y.access(e,n,{empty:S.Callbacks("once memory").add(function(){Y.remove(e,[t+"queue",n])})})}}),S.fn.extend({queue:function(t,n){var e=2;return"string"!=typeof t&&(n=t,t="fx",e--),arguments.length<e?S.queue(this[0],t):void 0===n?this:this.each(function(){var e=S.queue(this,t,n);S._queueHooks(this,t),"fx"===t&&"inprogress"!==e[0]&&S.dequeue(this,t)})},dequeue:function(e){return this.each(function(){S.dequeue(this,e)})},clearQueue:function(e){return this.queue(e||"fx",[])},promise:function(e,t){var n,r=1,i=S.Deferred(),o=this,a=this.length,s=function(){--r||i.resolveWith(o,[o])};"string"!=typeof e&&(t=e,e=void 0),e=e||"fx";while(a--)(n=Y.get(o[a],e+"queueHooks"))&&n.empty&&(r++,n.empty.add(s));return s(),i.promise(t)}});var ee=/[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,te=new RegExp("^(?:([+-])=|)("+ee+")([a-z%]*)$","i"),ne=["Top","Right","Bottom","Left"],re=E.documentElement,ie=function(e){return S.contains(e.ownerDocument,e)},oe={composed:!0};re.getRootNode&&(ie=function(e){return S.contains(e.ownerDocument,e)||e.getRootNode(oe)===e.ownerDocument});var ae=function(e,t){return"none"===(e=t||e).style.display||""===e.style.display&&ie(e)&&"none"===S.css(e,"display")};function se(e,t,n,r){var i,o,a=20,s=r?function(){return r.cur()}:function(){return S.css(e,t,"")},u=s(),l=n&&n[3]||(S.cssNumber[t]?"":"px"),c=e.nodeType&&(S.cssNumber[t]||"px"!==l&&+u)&&te.exec(S.css(e,t));if(c&&c[3]!==l){u/=2,l=l||c[3],c=+u||1;while(a--)S.style(e,t,c+l),(1-o)*(1-(o=s()/u||.5))<=0&&(a=0),c/=o;c*=2,S.style(e,t,c+l),n=n||[]}return n&&(c=+c||+u||0,i=n[1]?c+(n[1]+1)*n[2]:+n[2],r&&(r.unit=l,r.start=c,r.end=i)),i}var ue={};function le(e,t){for(var n,r,i,o,a,s,u,l=[],c=0,f=e.length;c<f;c++)(r=e[c]).style&&(n=r.style.display,t?("none"===n&&(l[c]=Y.get(r,"display")||null,l[c]||(r.style.display="")),""===r.style.display&&ae(r)&&(l[c]=(u=a=o=void 0,a=(i=r).ownerDocument,s=i.nodeName,(u=ue[s])||(o=a.body.appendChild(a.createElement(s)),u=S.css(o,"display"),o.parentNode.removeChild(o),"none"===u&&(u="block"),ue[s]=u)))):"none"!==n&&(l[c]="none",Y.set(r,"display",n)));for(c=0;c<f;c++)null!=l[c]&&(e[c].style.display=l[c]);return e}S.fn.extend({show:function(){return le(this,!0)},hide:function(){return le(this)},toggle:function(e){return"boolean"==typeof e?e?this.show():this.hide():this.each(function(){ae(this)?S(this).show():S(this).hide()})}});var ce,fe,pe=/^(?:checkbox|radio)$/i,de=/<([a-z][^\/\0>\x20\t\r\n\f]*)/i,he=/^$|^module$|\/(?:java|ecma)script/i;ce=E.createDocumentFragment().appendChild(E.createElement("div")),(fe=E.createElement("input")).setAttribute("type","radio"),fe.setAttribute("checked","checked"),fe.setAttribute("name","t"),ce.appendChild(fe),y.checkClone=ce.cloneNode(!0).cloneNode(!0).lastChild.checked,ce.innerHTML="<textarea>x</textarea>",y.noCloneChecked=!!ce.cloneNode(!0).lastChild.defaultValue,ce.innerHTML="<option></option>",y.option=!!ce.lastChild;var ge={thead:[1,"<table>","</table>"],col:[2,"<table><colgroup>","</colgroup></table>"],tr:[2,"<table><tbody>","</tbody></table>"],td:[3,"<table><tbody><tr>","</tr></tbody></table>"],_default:[0,"",""]};function ve(e,t){var n;return n="undefined"!=typeof e.getElementsByTagName?e.getElementsByTagName(t||"*"):"undefined"!=typeof e.querySelectorAll?e.querySelectorAll(t||"*"):[],void 0===t||t&&A(e,t)?S.merge([e],n):n}function ye(e,t){for(var n=0,r=e.length;n<r;n++)Y.set(e[n],"globalEval",!t||Y.get(t[n],"globalEval"))}ge.tbody=ge.tfoot=ge.colgroup=ge.caption=ge.thead,ge.th=ge.td,y.option||(ge.optgroup=ge.option=[1,"<select multiple='multiple'>","</select>"]);var me=/<|&#?\w+;/;function xe(e,t,n,r,i){for(var o,a,s,u,l,c,f=t.createDocumentFragment(),p=[],d=0,h=e.length;d<h;d++)if((o=e[d])||0===o)if("object"===w(o))S.merge(p,o.nodeType?[o]:o);else if(me.test(o)){a=a||f.appendChild(t.createElement("div")),s=(de.exec(o)||["",""])[1].toLowerCase(),u=ge[s]||ge._default,a.innerHTML=u[1]+S.htmlPrefilter(o)+u[2],c=u[0];while(c--)a=a.lastChild;S.merge(p,a.childNodes),(a=f.firstChild).textContent=""}else p.push(t.createTextNode(o));f.textContent="",d=0;while(o=p[d++])if(r&&-1<S.inArray(o,r))i&&i.push(o);else if(l=ie(o),a=ve(f.appendChild(o),"script"),l&&ye(a),n){c=0;while(o=a[c++])he.test(o.type||"")&&n.push(o)}return f}var be=/^([^.]*)(?:\.(.+)|)/;function we(){return!0}function Te(){return!1}function Ce(e,t){return e===function(){try{return E.activeElement}catch(e){}}()==("focus"===t)}function Ee(e,t,n,r,i,o){var a,s;if("object"==typeof t){for(s in"string"!=typeof n&&(r=r||n,n=void 0),t)Ee(e,s,n,r,t[s],o);return e}if(null==r&&null==i?(i=n,r=n=void 0):null==i&&("string"==typeof n?(i=r,r=void 0):(i=r,r=n,n=void 0)),!1===i)i=Te;else if(!i)return e;return 1===o&&(a=i,(i=function(e){return S().off(e),a.apply(this,arguments)}).guid=a.guid||(a.guid=S.guid++)),e.each(function(){S.event.add(this,t,i,r,n)})}function Se(e,i,o){o?(Y.set(e,i,!1),S.event.add(e,i,{namespace:!1,handler:function(e){var t,n,r=Y.get(this,i);if(1&e.isTrigger&&this[i]){if(r.length)(S.event.special[i]||{}).delegateType&&e.stopPropagation();else if(r=s.call(arguments),Y.set(this,i,r),t=o(this,i),this[i](),r!==(n=Y.get(this,i))||t?Y.set(this,i,!1):n={},r!==n)return e.stopImmediatePropagation(),e.preventDefault(),n&&n.value}else r.length&&(Y.set(this,i,{value:S.event.trigger(S.extend(r[0],S.Event.prototype),r.slice(1),this)}),e.stopImmediatePropagation())}})):void 0===Y.get(e,i)&&S.event.add(e,i,we)}S.event={global:{},add:function(t,e,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Y.get(t);if(V(t)){n.handler&&(n=(o=n).handler,i=o.selector),i&&S.find.matchesSelector(re,i),n.guid||(n.guid=S.guid++),(u=v.events)||(u=v.events=Object.create(null)),(a=v.handle)||(a=v.handle=function(e){return"undefined"!=typeof S&&S.event.triggered!==e.type?S.event.dispatch.apply(t,arguments):void 0}),l=(e=(e||"").match(P)||[""]).length;while(l--)d=g=(s=be.exec(e[l])||[])[1],h=(s[2]||"").split(".").sort(),d&&(f=S.event.special[d]||{},d=(i?f.delegateType:f.bindType)||d,f=S.event.special[d]||{},c=S.extend({type:d,origType:g,data:r,handler:n,guid:n.guid,selector:i,needsContext:i&&S.expr.match.needsContext.test(i),namespace:h.join(".")},o),(p=u[d])||((p=u[d]=[]).delegateCount=0,f.setup&&!1!==f.setup.call(t,r,h,a)||t.addEventListener&&t.addEventListener(d,a)),f.add&&(f.add.call(t,c),c.handler.guid||(c.handler.guid=n.guid)),i?p.splice(p.delegateCount++,0,c):p.push(c),S.event.global[d]=!0)}},remove:function(e,t,n,r,i){var o,a,s,u,l,c,f,p,d,h,g,v=Y.hasData(e)&&Y.get(e);if(v&&(u=v.events)){l=(t=(t||"").match(P)||[""]).length;while(l--)if(d=g=(s=be.exec(t[l])||[])[1],h=(s[2]||"").split(".").sort(),d){f=S.event.special[d]||{},p=u[d=(r?f.delegateType:f.bindType)||d]||[],s=s[2]&&new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"),a=o=p.length;while(o--)c=p[o],!i&&g!==c.origType||n&&n.guid!==c.guid||s&&!s.test(c.namespace)||r&&r!==c.selector&&("**"!==r||!c.selector)||(p.splice(o,1),c.selector&&p.delegateCount--,f.remove&&f.remove.call(e,c));a&&!p.length&&(f.teardown&&!1!==f.teardown.call(e,h,v.handle)||S.removeEvent(e,d,v.handle),delete u[d])}else for(d in u)S.event.remove(e,d+t[l],n,r,!0);S.isEmptyObject(u)&&Y.remove(e,"handle events")}},dispatch:function(e){var t,n,r,i,o,a,s=new Array(arguments.length),u=S.event.fix(e),l=(Y.get(this,"events")||Object.create(null))[u.type]||[],c=S.event.special[u.type]||{};for(s[0]=u,t=1;t<arguments.length;t++)s[t]=arguments[t];if(u.delegateTarget=this,!c.preDispatch||!1!==c.preDispatch.call(this,u)){a=S.event.handlers.call(this,u,l),t=0;while((i=a[t++])&&!u.isPropagationStopped()){u.currentTarget=i.elem,n=0;while((o=i.handlers[n++])&&!u.isImmediatePropagationStopped())u.rnamespace&&!1!==o.namespace&&!u.rnamespace.test(o.namespace)||(u.handleObj=o,u.data=o.data,void 0!==(r=((S.event.special[o.origType]||{}).handle||o.handler).apply(i.elem,s))&&!1===(u.result=r)&&(u.preventDefault(),u.stopPropagation()))}return c.postDispatch&&c.postDispatch.call(this,u),u.result}},handlers:function(e,t){var n,r,i,o,a,s=[],u=t.delegateCount,l=e.target;if(u&&l.nodeType&&!("click"===e.type&&1<=e.button))for(;l!==this;l=l.parentNode||this)if(1===l.nodeType&&("click"!==e.type||!0!==l.disabled)){for(o=[],a={},n=0;n<u;n++)void 0===a[i=(r=t[n]).selector+" "]&&(a[i]=r.needsContext?-1<S(i,this).index(l):S.find(i,this,null,[l]).length),a[i]&&o.push(r);o.length&&s.push({elem:l,handlers:o})}return l=this,u<t.length&&s.push({elem:l,handlers:t.slice(u)}),s},addProp:function(t,e){Object.defineProperty(S.Event.prototype,t,{enumerable:!0,configurable:!0,get:m(e)?function(){if(this.originalEvent)return e(this.originalEvent)}:function(){if(this.originalEvent)return this.originalEvent[t]},set:function(e){Object.defineProperty(this,t,{enumerable:!0,configurable:!0,writable:!0,value:e})}})},fix:function(e){return e[S.expando]?e:new S.Event(e)},special:{load:{noBubble:!0},click:{setup:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&Se(t,"click",we),!1},trigger:function(e){var t=this||e;return pe.test(t.type)&&t.click&&A(t,"input")&&Se(t,"click"),!0},_default:function(e){var t=e.target;return pe.test(t.type)&&t.click&&A(t,"input")&&Y.get(t,"click")||A(t,"a")}},beforeunload:{postDispatch:function(e){void 0!==e.result&&e.originalEvent&&(e.originalEvent.returnValue=e.result)}}}},S.removeEvent=function(e,t,n){e.removeEventListener&&e.removeEventListener(t,n)},S.Event=function(e,t){if(!(this instanceof S.Event))return new S.Event(e,t);e&&e.type?(this.originalEvent=e,this.type=e.type,this.isDefaultPrevented=e.defaultPrevented||void 0===e.defaultPrevented&&!1===e.returnValue?we:Te,this.target=e.target&&3===e.target.nodeType?e.target.parentNode:e.target,this.currentTarget=e.currentTarget,this.relatedTarget=e.relatedTarget):this.type=e,t&&S.extend(this,t),this.timeStamp=e&&e.timeStamp||Date.now(),this[S.expando]=!0},S.Event.prototype={constructor:S.Event,isDefaultPrevented:Te,isPropagationStopped:Te,isImmediatePropagationStopped:Te,isSimulated:!1,preventDefault:function(){var e=this.originalEvent;this.isDefaultPrevented=we,e&&!this.isSimulated&&e.preventDefault()},stopPropagation:function(){var e=this.originalEvent;this.isPropagationStopped=we,e&&!this.isSimulated&&e.stopPropagation()},stopImmediatePropagation:function(){var e=this.originalEvent;this.isImmediatePropagationStopped=we,e&&!this.isSimulated&&e.stopImmediatePropagation(),this.stopPropagation()}},S.each({altKey:!0,bubbles:!0,cancelable:!0,changedTouches:!0,ctrlKey:!0,detail:!0,eventPhase:!0,metaKey:!0,pageX:!0,pageY:!0,shiftKey:!0,view:!0,"char":!0,code:!0,charCode:!0,key:!0,keyCode:!0,button:!0,buttons:!0,clientX:!0,clientY:!0,offsetX:!0,offsetY:!0,pointerId:!0,pointerType:!0,screenX:!0,screenY:!0,targetTouches:!0,toElement:!0,touches:!0,which:!0},S.event.addProp),S.each({focus:"focusin",blur:"focusout"},function(e,t){S.event.special[e]={setup:function(){return Se(this,e,Ce),!1},trigger:function(){return Se(this,e),!0},_default:function(){return!0},delegateType:t}}),S.each({mouseenter:"mouseover",mouseleave:"mouseout",pointerenter:"pointerover",pointerleave:"pointerout"},function(e,i){S.event.special[e]={delegateType:i,bindType:i,handle:function(e){var t,n=e.relatedTarget,r=e.handleObj;return n&&(n===this||S.contains(this,n))||(e.type=r.origType,t=r.handler.apply(this,arguments),e.type=i),t}}}),S.fn.extend({on:function(e,t,n,r){return Ee(this,e,t,n,r)},one:function(e,t,n,r){return Ee(this,e,t,n,r,1)},off:function(e,t,n){var r,i;if(e&&e.preventDefault&&e.handleObj)return r=e.handleObj,S(e.delegateTarget).off(r.namespace?r.origType+"."+r.namespace:r.origType,r.selector,r.handler),this;if("object"==typeof e){for(i in e)this.off(i,t,e[i]);return this}return!1!==t&&"function"!=typeof t||(n=t,t=void 0),!1===n&&(n=Te),this.each(function(){S.event.remove(this,e,n,t)})}});var ke=/<script|<style|<link/i,Ae=/checked\s*(?:[^=]|=\s*.checked.)/i,Ne=/^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;function je(e,t){return A(e,"table")&&A(11!==t.nodeType?t:t.firstChild,"tr")&&S(e).children("tbody")[0]||e}function De(e){return e.type=(null!==e.getAttribute("type"))+"/"+e.type,e}function qe(e){return"true/"===(e.type||"").slice(0,5)?e.type=e.type.slice(5):e.removeAttribute("type"),e}function Le(e,t){var n,r,i,o,a,s;if(1===t.nodeType){if(Y.hasData(e)&&(s=Y.get(e).events))for(i in Y.remove(t,"handle events"),s)for(n=0,r=s[i].length;n<r;n++)S.event.add(t,i,s[i][n]);Q.hasData(e)&&(o=Q.access(e),a=S.extend({},o),Q.set(t,a))}}function He(n,r,i,o){r=g(r);var e,t,a,s,u,l,c=0,f=n.length,p=f-1,d=r[0],h=m(d);if(h||1<f&&"string"==typeof d&&!y.checkClone&&Ae.test(d))return n.each(function(e){var t=n.eq(e);h&&(r[0]=d.call(this,e,t.html())),He(t,r,i,o)});if(f&&(t=(e=xe(r,n[0].ownerDocument,!1,n,o)).firstChild,1===e.childNodes.length&&(e=t),t||o)){for(s=(a=S.map(ve(e,"script"),De)).length;c<f;c++)u=e,c!==p&&(u=S.clone(u,!0,!0),s&&S.merge(a,ve(u,"script"))),i.call(n[c],u,c);if(s)for(l=a[a.length-1].ownerDocument,S.map(a,qe),c=0;c<s;c++)u=a[c],he.test(u.type||"")&&!Y.access(u,"globalEval")&&S.contains(l,u)&&(u.src&&"module"!==(u.type||"").toLowerCase()?S._evalUrl&&!u.noModule&&S._evalUrl(u.src,{nonce:u.nonce||u.getAttribute("nonce")},l):b(u.textContent.replace(Ne,""),u,l))}return n}function Oe(e,t,n){for(var r,i=t?S.filter(t,e):e,o=0;null!=(r=i[o]);o++)n||1!==r.nodeType||S.cleanData(ve(r)),r.parentNode&&(n&&ie(r)&&ye(ve(r,"script")),r.parentNode.removeChild(r));return e}S.extend({htmlPrefilter:function(e){return e},clone:function(e,t,n){var r,i,o,a,s,u,l,c=e.cloneNode(!0),f=ie(e);if(!(y.noCloneChecked||1!==e.nodeType&&11!==e.nodeType||S.isXMLDoc(e)))for(a=ve(c),r=0,i=(o=ve(e)).length;r<i;r++)s=o[r],u=a[r],void 0,"input"===(l=u.nodeName.toLowerCase())&&pe.test(s.type)?u.checked=s.checked:"input"!==l&&"textarea"!==l||(u.defaultValue=s.defaultValue);if(t)if(n)for(o=o||ve(e),a=a||ve(c),r=0,i=o.length;r<i;r++)Le(o[r],a[r]);else Le(e,c);return 0<(a=ve(c,"script")).length&&ye(a,!f&&ve(e,"script")),c},cleanData:function(e){for(var t,n,r,i=S.event.special,o=0;void 0!==(n=e[o]);o++)if(V(n)){if(t=n[Y.expando]){if(t.events)for(r in t.events)i[r]?S.event.remove(n,r):S.removeEvent(n,r,t.handle);n[Y.expando]=void 0}n[Q.expando]&&(n[Q.expando]=void 0)}}}),S.fn.extend({detach:function(e){return Oe(this,e,!0)},remove:function(e){return Oe(this,e)},text:function(e){return $(this,function(e){return void 0===e?S.text(this):this.empty().each(function(){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||(this.textContent=e)})},null,e,arguments.length)},append:function(){return He(this,arguments,function(e){1!==this.nodeType&&11!==this.nodeType&&9!==this.nodeType||je(this,e).appendChild(e)})},prepend:function(){return He(this,arguments,function(e){if(1===this.nodeType||11===this.nodeType||9===this.nodeType){var t=je(this,e);t.insertBefore(e,t.firstChild)}})},before:function(){return He(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this)})},after:function(){return He(this,arguments,function(e){this.parentNode&&this.parentNode.insertBefore(e,this.nextSibling)})},empty:function(){for(var e,t=0;null!=(e=this[t]);t++)1===e.nodeType&&(S.cleanData(ve(e,!1)),e.textContent="");return this},clone:function(e,t){return e=null!=e&&e,t=null==t?e:t,this.map(function(){return S.clone(this,e,t)})},html:function(e){return $(this,function(e){var t=this[0]||{},n=0,r=this.length;if(void 0===e&&1===t.nodeType)return t.innerHTML;if("string"==typeof e&&!ke.test(e)&&!ge[(de.exec(e)||["",""])[1].toLowerCase()]){e=S.htmlPrefilter(e);try{for(;n<r;n++)1===(t=this[n]||{}).nodeType&&(S.cleanData(ve(t,!1)),t.innerHTML=e);t=0}catch(e){}}t&&this.empty().append(e)},null,e,arguments.length)},replaceWith:function(){var n=[];return He(this,arguments,function(e){var t=this.parentNode;S.inArray(this,n)<0&&(S.cleanData(ve(this)),t&&t.replaceChild(e,this))},n)}}),S.each({appendTo:"append",prependTo:"prepend",insertBefore:"before",insertAfter:"after",replaceAll:"replaceWith"},function(e,a){S.fn[e]=function(e){for(var t,n=[],r=S(e),i=r.length-1,o=0;o<=i;o++)t=o===i?this:this.clone(!0),S(r[o])[a](t),u.apply(n,t.get());return this.pushStack(n)}});var Pe=new RegExp("^("+ee+")(?!px)[a-z%]+$","i"),Re=function(e){var t=e.ownerDocument.defaultView;return t&&t.opener||(t=C),t.getComputedStyle(e)},Me=function(e,t,n){var r,i,o={};for(i in t)o[i]=e.style[i],e.style[i]=t[i];for(i in r=n.call(e),t)e.style[i]=o[i];return r},Ie=new RegExp(ne.join("|"),"i");function We(e,t,n){var r,i,o,a,s=e.style;return(n=n||Re(e))&&(""!==(a=n.getPropertyValue(t)||n[t])||ie(e)||(a=S.style(e,t)),!y.pixelBoxStyles()&&Pe.test(a)&&Ie.test(t)&&(r=s.width,i=s.minWidth,o=s.maxWidth,s.minWidth=s.maxWidth=s.width=a,a=n.width,s.width=r,s.minWidth=i,s.maxWidth=o)),void 0!==a?a+"":a}function Fe(e,t){return{get:function(){if(!e())return(this.get=t).apply(this,arguments);delete this.get}}}!function(){function e(){if(l){u.style.cssText="position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0",l.style.cssText="position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%",re.appendChild(u).appendChild(l);var e=C.getComputedStyle(l);n="1%"!==e.top,s=12===t(e.marginLeft),l.style.right="60%",o=36===t(e.right),r=36===t(e.width),l.style.position="absolute",i=12===t(l.offsetWidth/3),re.removeChild(u),l=null}}function t(e){return Math.round(parseFloat(e))}var n,r,i,o,a,s,u=E.createElement("div"),l=E.createElement("div");l.style&&(l.style.backgroundClip="content-box",l.cloneNode(!0).style.backgroundClip="",y.clearCloneStyle="content-box"===l.style.backgroundClip,S.extend(y,{boxSizingReliable:function(){return e(),r},pixelBoxStyles:function(){return e(),o},pixelPosition:function(){return e(),n},reliableMarginLeft:function(){return e(),s},scrollboxSize:function(){return e(),i},reliableTrDimensions:function(){var e,t,n,r;return null==a&&(e=E.createElement("table"),t=E.createElement("tr"),n=E.createElement("div"),e.style.cssText="position:absolute;left:-11111px;border-collapse:separate",t.style.cssText="border:1px solid",t.style.height="1px",n.style.height="9px",n.style.display="block",re.appendChild(e).appendChild(t).appendChild(n),r=C.getComputedStyle(t),a=parseInt(r.height,10)+parseInt(r.borderTopWidth,10)+parseInt(r.borderBottomWidth,10)===t.offsetHeight,re.removeChild(e)),a}}))}();var Be=["Webkit","Moz","ms"],$e=E.createElement("div").style,_e={};function ze(e){var t=S.cssProps[e]||_e[e];return t||(e in $e?e:_e[e]=function(e){var t=e[0].toUpperCase()+e.slice(1),n=Be.length;while(n--)if((e=Be[n]+t)in $e)return e}(e)||e)}var Ue=/^(none|table(?!-c[ea]).+)/,Xe=/^--/,Ve={position:"absolute",visibility:"hidden",display:"block"},Ge={letterSpacing:"0",fontWeight:"400"};function Ye(e,t,n){var r=te.exec(t);return r?Math.max(0,r[2]-(n||0))+(r[3]||"px"):t}function Qe(e,t,n,r,i,o){var a="width"===t?1:0,s=0,u=0;if(n===(r?"border":"content"))return 0;for(;a<4;a+=2)"margin"===n&&(u+=S.css(e,n+ne[a],!0,i)),r?("content"===n&&(u-=S.css(e,"padding"+ne[a],!0,i)),"margin"!==n&&(u-=S.css(e,"border"+ne[a]+"Width",!0,i))):(u+=S.css(e,"padding"+ne[a],!0,i),"padding"!==n?u+=S.css(e,"border"+ne[a]+"Width",!0,i):s+=S.css(e,"border"+ne[a]+"Width",!0,i));return!r&&0<=o&&(u+=Math.max(0,Math.ceil(e["offset"+t[0].toUpperCase()+t.slice(1)]-o-u-s-.5))||0),u}function Je(e,t,n){var r=Re(e),i=(!y.boxSizingReliable()||n)&&"border-box"===S.css(e,"boxSizing",!1,r),o=i,a=We(e,t,r),s="offset"+t[0].toUpperCase()+t.slice(1);if(Pe.test(a)){if(!n)return a;a="auto"}return(!y.boxSizingReliable()&&i||!y.reliableTrDimensions()&&A(e,"tr")||"auto"===a||!parseFloat(a)&&"inline"===S.css(e,"display",!1,r))&&e.getClientRects().length&&(i="border-box"===S.css(e,"boxSizing",!1,r),(o=s in e)&&(a=e[s])),(a=parseFloat(a)||0)+Qe(e,t,n||(i?"border":"content"),o,r,a)+"px"}function Ke(e,t,n,r,i){return new Ke.prototype.init(e,t,n,r,i)}S.extend({cssHooks:{opacity:{get:function(e,t){if(t){var n=We(e,"opacity");return""===n?"1":n}}}},cssNumber:{animationIterationCount:!0,columnCount:!0,fillOpacity:!0,flexGrow:!0,flexShrink:!0,fontWeight:!0,gridArea:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnStart:!0,gridRow:!0,gridRowEnd:!0,gridRowStart:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,widows:!0,zIndex:!0,zoom:!0},cssProps:{},style:function(e,t,n,r){if(e&&3!==e.nodeType&&8!==e.nodeType&&e.style){var i,o,a,s=X(t),u=Xe.test(t),l=e.style;if(u||(t=ze(s)),a=S.cssHooks[t]||S.cssHooks[s],void 0===n)return a&&"get"in a&&void 0!==(i=a.get(e,!1,r))?i:l[t];"string"===(o=typeof n)&&(i=te.exec(n))&&i[1]&&(n=se(e,t,i),o="number"),null!=n&&n==n&&("number"!==o||u||(n+=i&&i[3]||(S.cssNumber[s]?"":"px")),y.clearCloneStyle||""!==n||0!==t.indexOf("background")||(l[t]="inherit"),a&&"set"in a&&void 0===(n=a.set(e,n,r))||(u?l.setProperty(t,n):l[t]=n))}},css:function(e,t,n,r){var i,o,a,s=X(t);return Xe.test(t)||(t=ze(s)),(a=S.cssHooks[t]||S.cssHooks[s])&&"get"in a&&(i=a.get(e,!0,n)),void 0===i&&(i=We(e,t,r)),"normal"===i&&t in Ge&&(i=Ge[t]),""===n||n?(o=parseFloat(i),!0===n||isFinite(o)?o||0:i):i}}),S.each(["height","width"],function(e,u){S.cssHooks[u]={get:function(e,t,n){if(t)return!Ue.test(S.css(e,"display"))||e.getClientRects().length&&e.getBoundingClientRect().width?Je(e,u,n):Me(e,Ve,function(){return Je(e,u,n)})},set:function(e,t,n){var r,i=Re(e),o=!y.scrollboxSize()&&"absolute"===i.position,a=(o||n)&&"border-box"===S.css(e,"boxSizing",!1,i),s=n?Qe(e,u,n,a,i):0;return a&&o&&(s-=Math.ceil(e["offset"+u[0].toUpperCase()+u.slice(1)]-parseFloat(i[u])-Qe(e,u,"border",!1,i)-.5)),s&&(r=te.exec(t))&&"px"!==(r[3]||"px")&&(e.style[u]=t,t=S.css(e,u)),Ye(0,t,s)}}}),S.cssHooks.marginLeft=Fe(y.reliableMarginLeft,function(e,t){if(t)return(parseFloat(We(e,"marginLeft"))||e.getBoundingClientRect().left-Me(e,{marginLeft:0},function(){return e.getBoundingClientRect().left}))+"px"}),S.each({margin:"",padding:"",border:"Width"},function(i,o){S.cssHooks[i+o]={expand:function(e){for(var t=0,n={},r="string"==typeof e?e.split(" "):[e];t<4;t++)n[i+ne[t]+o]=r[t]||r[t-2]||r[0];return n}},"margin"!==i&&(S.cssHooks[i+o].set=Ye)}),S.fn.extend({css:function(e,t){return $(this,function(e,t,n){var r,i,o={},a=0;if(Array.isArray(t)){for(r=Re(e),i=t.length;a<i;a++)o[t[a]]=S.css(e,t[a],!1,r);return o}return void 0!==n?S.style(e,t,n):S.css(e,t)},e,t,1<arguments.length)}}),((S.Tween=Ke).prototype={constructor:Ke,init:function(e,t,n,r,i,o){this.elem=e,this.prop=n,this.easing=i||S.easing._default,this.options=t,this.start=this.now=this.cur(),this.end=r,this.unit=o||(S.cssNumber[n]?"":"px")},cur:function(){var e=Ke.propHooks[this.prop];return e&&e.get?e.get(this):Ke.propHooks._default.get(this)},run:function(e){var t,n=Ke.propHooks[this.prop];return this.options.duration?this.pos=t=S.easing[this.easing](e,this.options.duration*e,0,1,this.options.duration):this.pos=t=e,this.now=(this.end-this.start)*t+this.start,this.options.step&&this.options.step.call(this.elem,this.now,this),n&&n.set?n.set(this):Ke.propHooks._default.set(this),this}}).init.prototype=Ke.prototype,(Ke.propHooks={_default:{get:function(e){var t;return 1!==e.elem.nodeType||null!=e.elem[e.prop]&&null==e.elem.style[e.prop]?e.elem[e.prop]:(t=S.css(e.elem,e.prop,""))&&"auto"!==t?t:0},set:function(e){S.fx.step[e.prop]?S.fx.step[e.prop](e):1!==e.elem.nodeType||!S.cssHooks[e.prop]&&null==e.elem.style[ze(e.prop)]?e.elem[e.prop]=e.now:S.style(e.elem,e.prop,e.now+e.unit)}}}).scrollTop=Ke.propHooks.scrollLeft={set:function(e){e.elem.nodeType&&e.elem.parentNode&&(e.elem[e.prop]=e.now)}},S.easing={linear:function(e){return e},swing:function(e){return.5-Math.cos(e*Math.PI)/2},_default:"swing"},S.fx=Ke.prototype.init,S.fx.step={};var Ze,et,tt,nt,rt=/^(?:toggle|show|hide)$/,it=/queueHooks$/;function ot(){et&&(!1===E.hidden&&C.requestAnimationFrame?C.requestAnimationFrame(ot):C.setTimeout(ot,S.fx.interval),S.fx.tick())}function at(){return C.setTimeout(function(){Ze=void 0}),Ze=Date.now()}function st(e,t){var n,r=0,i={height:e};for(t=t?1:0;r<4;r+=2-t)i["margin"+(n=ne[r])]=i["padding"+n]=e;return t&&(i.opacity=i.width=e),i}function ut(e,t,n){for(var r,i=(lt.tweeners[t]||[]).concat(lt.tweeners["*"]),o=0,a=i.length;o<a;o++)if(r=i[o].call(n,t,e))return r}function lt(o,e,t){var n,a,r=0,i=lt.prefilters.length,s=S.Deferred().always(function(){delete u.elem}),u=function(){if(a)return!1;for(var e=Ze||at(),t=Math.max(0,l.startTime+l.duration-e),n=1-(t/l.duration||0),r=0,i=l.tweens.length;r<i;r++)l.tweens[r].run(n);return s.notifyWith(o,[l,n,t]),n<1&&i?t:(i||s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l]),!1)},l=s.promise({elem:o,props:S.extend({},e),opts:S.extend(!0,{specialEasing:{},easing:S.easing._default},t),originalProperties:e,originalOptions:t,startTime:Ze||at(),duration:t.duration,tweens:[],createTween:function(e,t){var n=S.Tween(o,l.opts,e,t,l.opts.specialEasing[e]||l.opts.easing);return l.tweens.push(n),n},stop:function(e){var t=0,n=e?l.tweens.length:0;if(a)return this;for(a=!0;t<n;t++)l.tweens[t].run(1);return e?(s.notifyWith(o,[l,1,0]),s.resolveWith(o,[l,e])):s.rejectWith(o,[l,e]),this}}),c=l.props;for(!function(e,t){var n,r,i,o,a;for(n in e)if(i=t[r=X(n)],o=e[n],Array.isArray(o)&&(i=o[1],o=e[n]=o[0]),n!==r&&(e[r]=o,delete e[n]),(a=S.cssHooks[r])&&"expand"in a)for(n in o=a.expand(o),delete e[r],o)n in e||(e[n]=o[n],t[n]=i);else t[r]=i}(c,l.opts.specialEasing);r<i;r++)if(n=lt.prefilters[r].call(l,o,c,l.opts))return m(n.stop)&&(S._queueHooks(l.elem,l.opts.queue).stop=n.stop.bind(n)),n;return S.map(c,ut,l),m(l.opts.start)&&l.opts.start.call(o,l),l.progress(l.opts.progress).done(l.opts.done,l.opts.complete).fail(l.opts.fail).always(l.opts.always),S.fx.timer(S.extend(u,{elem:o,anim:l,queue:l.opts.queue})),l}S.Animation=S.extend(lt,{tweeners:{"*":[function(e,t){var n=this.createTween(e,t);return se(n.elem,e,te.exec(t),n),n}]},tweener:function(e,t){m(e)?(t=e,e=["*"]):e=e.match(P);for(var n,r=0,i=e.length;r<i;r++)n=e[r],lt.tweeners[n]=lt.tweeners[n]||[],lt.tweeners[n].unshift(t)},prefilters:[function(e,t,n){var r,i,o,a,s,u,l,c,f="width"in t||"height"in t,p=this,d={},h=e.style,g=e.nodeType&&ae(e),v=Y.get(e,"fxshow");for(r in n.queue||(null==(a=S._queueHooks(e,"fx")).unqueued&&(a.unqueued=0,s=a.empty.fire,a.empty.fire=function(){a.unqueued||s()}),a.unqueued++,p.always(function(){p.always(function(){a.unqueued--,S.queue(e,"fx").length||a.empty.fire()})})),t)if(i=t[r],rt.test(i)){if(delete t[r],o=o||"toggle"===i,i===(g?"hide":"show")){if("show"!==i||!v||void 0===v[r])continue;g=!0}d[r]=v&&v[r]||S.style(e,r)}if((u=!S.isEmptyObject(t))||!S.isEmptyObject(d))for(r in f&&1===e.nodeType&&(n.overflow=[h.overflow,h.overflowX,h.overflowY],null==(l=v&&v.display)&&(l=Y.get(e,"display")),"none"===(c=S.css(e,"display"))&&(l?c=l:(le([e],!0),l=e.style.display||l,c=S.css(e,"display"),le([e]))),("inline"===c||"inline-block"===c&&null!=l)&&"none"===S.css(e,"float")&&(u||(p.done(function(){h.display=l}),null==l&&(c=h.display,l="none"===c?"":c)),h.display="inline-block")),n.overflow&&(h.overflow="hidden",p.always(function(){h.overflow=n.overflow[0],h.overflowX=n.overflow[1],h.overflowY=n.overflow[2]})),u=!1,d)u||(v?"hidden"in v&&(g=v.hidden):v=Y.access(e,"fxshow",{display:l}),o&&(v.hidden=!g),g&&le([e],!0),p.done(function(){for(r in g||le([e]),Y.remove(e,"fxshow"),d)S.style(e,r,d[r])})),u=ut(g?v[r]:0,r,p),r in v||(v[r]=u.start,g&&(u.end=u.start,u.start=0))}],prefilter:function(e,t){t?lt.prefilters.unshift(e):lt.prefilters.push(e)}}),S.speed=function(e,t,n){var r=e&&"object"==typeof e?S.extend({},e):{complete:n||!n&&t||m(e)&&e,duration:e,easing:n&&t||t&&!m(t)&&t};return S.fx.off?r.duration=0:"number"!=typeof r.duration&&(r.duration in S.fx.speeds?r.duration=S.fx.speeds[r.duration]:r.duration=S.fx.speeds._default),null!=r.queue&&!0!==r.queue||(r.queue="fx"),r.old=r.complete,r.complete=function(){m(r.old)&&r.old.call(this),r.queue&&S.dequeue(this,r.queue)},r},S.fn.extend({fadeTo:function(e,t,n,r){return this.filter(ae).css("opacity",0).show().end().animate({opacity:t},e,n,r)},animate:function(t,e,n,r){var i=S.isEmptyObject(t),o=S.speed(e,n,r),a=function(){var e=lt(this,S.extend({},t),o);(i||Y.get(this,"finish"))&&e.stop(!0)};return a.finish=a,i||!1===o.queue?this.each(a):this.queue(o.queue,a)},stop:function(i,e,o){var a=function(e){var t=e.stop;delete e.stop,t(o)};return"string"!=typeof i&&(o=e,e=i,i=void 0),e&&this.queue(i||"fx",[]),this.each(function(){var e=!0,t=null!=i&&i+"queueHooks",n=S.timers,r=Y.get(this);if(t)r[t]&&r[t].stop&&a(r[t]);else for(t in r)r[t]&&r[t].stop&&it.test(t)&&a(r[t]);for(t=n.length;t--;)n[t].elem!==this||null!=i&&n[t].queue!==i||(n[t].anim.stop(o),e=!1,n.splice(t,1));!e&&o||S.dequeue(this,i)})},finish:function(a){return!1!==a&&(a=a||"fx"),this.each(function(){var e,t=Y.get(this),n=t[a+"queue"],r=t[a+"queueHooks"],i=S.timers,o=n?n.length:0;for(t.finish=!0,S.queue(this,a,[]),r&&r.stop&&r.stop.call(this,!0),e=i.length;e--;)i[e].elem===this&&i[e].queue===a&&(i[e].anim.stop(!0),i.splice(e,1));for(e=0;e<o;e++)n[e]&&n[e].finish&&n[e].finish.call(this);delete t.finish})}}),S.each(["toggle","show","hide"],function(e,r){var i=S.fn[r];S.fn[r]=function(e,t,n){return null==e||"boolean"==typeof e?i.apply(this,arguments):this.animate(st(r,!0),e,t,n)}}),S.each({slideDown:st("show"),slideUp:st("hide"),slideToggle:st("toggle"),fadeIn:{opacity:"show"},fadeOut:{opacity:"hide"},fadeToggle:{opacity:"toggle"}},function(e,r){S.fn[e]=function(e,t,n){return this.animate(r,e,t,n)}}),S.timers=[],S.fx.tick=function(){var e,t=0,n=S.timers;for(Ze=Date.now();t<n.length;t++)(e=n[t])()||n[t]!==e||n.splice(t--,1);n.length||S.fx.stop(),Ze=void 0},S.fx.timer=function(e){S.timers.push(e),S.fx.start()},S.fx.interval=13,S.fx.start=function(){et||(et=!0,ot())},S.fx.stop=function(){et=null},S.fx.speeds={slow:600,fast:200,_default:400},S.fn.delay=function(r,e){return r=S.fx&&S.fx.speeds[r]||r,e=e||"fx",this.queue(e,function(e,t){var n=C.setTimeout(e,r);t.stop=function(){C.clearTimeout(n)}})},tt=E.createElement("input"),nt=E.createElement("select").appendChild(E.createElement("option")),tt.type="checkbox",y.checkOn=""!==tt.value,y.optSelected=nt.selected,(tt=E.createElement("input")).value="t",tt.type="radio",y.radioValue="t"===tt.value;var ct,ft=S.expr.attrHandle;S.fn.extend({attr:function(e,t){return $(this,S.attr,e,t,1<arguments.length)},removeAttr:function(e){return this.each(function(){S.removeAttr(this,e)})}}),S.extend({attr:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return"undefined"==typeof e.getAttribute?S.prop(e,t,n):(1===o&&S.isXMLDoc(e)||(i=S.attrHooks[t.toLowerCase()]||(S.expr.match.bool.test(t)?ct:void 0)),void 0!==n?null===n?void S.removeAttr(e,t):i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:(e.setAttribute(t,n+""),n):i&&"get"in i&&null!==(r=i.get(e,t))?r:null==(r=S.find.attr(e,t))?void 0:r)},attrHooks:{type:{set:function(e,t){if(!y.radioValue&&"radio"===t&&A(e,"input")){var n=e.value;return e.setAttribute("type",t),n&&(e.value=n),t}}}},removeAttr:function(e,t){var n,r=0,i=t&&t.match(P);if(i&&1===e.nodeType)while(n=i[r++])e.removeAttribute(n)}}),ct={set:function(e,t,n){return!1===t?S.removeAttr(e,n):e.setAttribute(n,n),n}},S.each(S.expr.match.bool.source.match(/\w+/g),function(e,t){var a=ft[t]||S.find.attr;ft[t]=function(e,t,n){var r,i,o=t.toLowerCase();return n||(i=ft[o],ft[o]=r,r=null!=a(e,t,n)?o:null,ft[o]=i),r}});var pt=/^(?:input|select|textarea|button)$/i,dt=/^(?:a|area)$/i;function ht(e){return(e.match(P)||[]).join(" ")}function gt(e){return e.getAttribute&&e.getAttribute("class")||""}function vt(e){return Array.isArray(e)?e:"string"==typeof e&&e.match(P)||[]}S.fn.extend({prop:function(e,t){return $(this,S.prop,e,t,1<arguments.length)},removeProp:function(e){return this.each(function(){delete this[S.propFix[e]||e]})}}),S.extend({prop:function(e,t,n){var r,i,o=e.nodeType;if(3!==o&&8!==o&&2!==o)return 1===o&&S.isXMLDoc(e)||(t=S.propFix[t]||t,i=S.propHooks[t]),void 0!==n?i&&"set"in i&&void 0!==(r=i.set(e,n,t))?r:e[t]=n:i&&"get"in i&&null!==(r=i.get(e,t))?r:e[t]},propHooks:{tabIndex:{get:function(e){var t=S.find.attr(e,"tabindex");return t?parseInt(t,10):pt.test(e.nodeName)||dt.test(e.nodeName)&&e.href?0:-1}}},propFix:{"for":"htmlFor","class":"className"}}),y.optSelected||(S.propHooks.selected={get:function(e){var t=e.parentNode;return t&&t.parentNode&&t.parentNode.selectedIndex,null},set:function(e){var t=e.parentNode;t&&(t.selectedIndex,t.parentNode&&t.parentNode.selectedIndex)}}),S.each(["tabIndex","readOnly","maxLength","cellSpacing","cellPadding","rowSpan","colSpan","useMap","frameBorder","contentEditable"],function(){S.propFix[this.toLowerCase()]=this}),S.fn.extend({addClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){S(this).addClass(t.call(this,e,gt(this)))});if((e=vt(t)).length)while(n=this[u++])if(i=gt(n),r=1===n.nodeType&&" "+ht(i)+" "){a=0;while(o=e[a++])r.indexOf(" "+o+" ")<0&&(r+=o+" ");i!==(s=ht(r))&&n.setAttribute("class",s)}return this},removeClass:function(t){var e,n,r,i,o,a,s,u=0;if(m(t))return this.each(function(e){S(this).removeClass(t.call(this,e,gt(this)))});if(!arguments.length)return this.attr("class","");if((e=vt(t)).length)while(n=this[u++])if(i=gt(n),r=1===n.nodeType&&" "+ht(i)+" "){a=0;while(o=e[a++])while(-1<r.indexOf(" "+o+" "))r=r.replace(" "+o+" "," ");i!==(s=ht(r))&&n.setAttribute("class",s)}return this},toggleClass:function(i,t){var o=typeof i,a="string"===o||Array.isArray(i);return"boolean"==typeof t&&a?t?this.addClass(i):this.removeClass(i):m(i)?this.each(function(e){S(this).toggleClass(i.call(this,e,gt(this),t),t)}):this.each(function(){var e,t,n,r;if(a){t=0,n=S(this),r=vt(i);while(e=r[t++])n.hasClass(e)?n.removeClass(e):n.addClass(e)}else void 0!==i&&"boolean"!==o||((e=gt(this))&&Y.set(this,"__className__",e),this.setAttribute&&this.setAttribute("class",e||!1===i?"":Y.get(this,"__className__")||""))})},hasClass:function(e){var t,n,r=0;t=" "+e+" ";while(n=this[r++])if(1===n.nodeType&&-1<(" "+ht(gt(n))+" ").indexOf(t))return!0;return!1}});var yt=/\r/g;S.fn.extend({val:function(n){var r,e,i,t=this[0];return arguments.length?(i=m(n),this.each(function(e){var t;1===this.nodeType&&(null==(t=i?n.call(this,e,S(this).val()):n)?t="":"number"==typeof t?t+="":Array.isArray(t)&&(t=S.map(t,function(e){return null==e?"":e+""})),(r=S.valHooks[this.type]||S.valHooks[this.nodeName.toLowerCase()])&&"set"in r&&void 0!==r.set(this,t,"value")||(this.value=t))})):t?(r=S.valHooks[t.type]||S.valHooks[t.nodeName.toLowerCase()])&&"get"in r&&void 0!==(e=r.get(t,"value"))?e:"string"==typeof(e=t.value)?e.replace(yt,""):null==e?"":e:void 0}}),S.extend({valHooks:{option:{get:function(e){var t=S.find.attr(e,"value");return null!=t?t:ht(S.text(e))}},select:{get:function(e){var t,n,r,i=e.options,o=e.selectedIndex,a="select-one"===e.type,s=a?null:[],u=a?o+1:i.length;for(r=o<0?u:a?o:0;r<u;r++)if(((n=i[r]).selected||r===o)&&!n.disabled&&(!n.parentNode.disabled||!A(n.parentNode,"optgroup"))){if(t=S(n).val(),a)return t;s.push(t)}return s},set:function(e,t){var n,r,i=e.options,o=S.makeArray(t),a=i.length;while(a--)((r=i[a]).selected=-1<S.inArray(S.valHooks.option.get(r),o))&&(n=!0);return n||(e.selectedIndex=-1),o}}}}),S.each(["radio","checkbox"],function(){S.valHooks[this]={set:function(e,t){if(Array.isArray(t))return e.checked=-1<S.inArray(S(e).val(),t)}},y.checkOn||(S.valHooks[this].get=function(e){return null===e.getAttribute("value")?"on":e.value})}),y.focusin="onfocusin"in C;var mt=/^(?:focusinfocus|focusoutblur)$/,xt=function(e){e.stopPropagation()};S.extend(S.event,{trigger:function(e,t,n,r){var i,o,a,s,u,l,c,f,p=[n||E],d=v.call(e,"type")?e.type:e,h=v.call(e,"namespace")?e.namespace.split("."):[];if(o=f=a=n=n||E,3!==n.nodeType&&8!==n.nodeType&&!mt.test(d+S.event.triggered)&&(-1<d.indexOf(".")&&(d=(h=d.split(".")).shift(),h.sort()),u=d.indexOf(":")<0&&"on"+d,(e=e[S.expando]?e:new S.Event(d,"object"==typeof e&&e)).isTrigger=r?2:3,e.namespace=h.join("."),e.rnamespace=e.namespace?new RegExp("(^|\\.)"+h.join("\\.(?:.*\\.|)")+"(\\.|$)"):null,e.result=void 0,e.target||(e.target=n),t=null==t?[e]:S.makeArray(t,[e]),c=S.event.special[d]||{},r||!c.trigger||!1!==c.trigger.apply(n,t))){if(!r&&!c.noBubble&&!x(n)){for(s=c.delegateType||d,mt.test(s+d)||(o=o.parentNode);o;o=o.parentNode)p.push(o),a=o;a===(n.ownerDocument||E)&&p.push(a.defaultView||a.parentWindow||C)}i=0;while((o=p[i++])&&!e.isPropagationStopped())f=o,e.type=1<i?s:c.bindType||d,(l=(Y.get(o,"events")||Object.create(null))[e.type]&&Y.get(o,"handle"))&&l.apply(o,t),(l=u&&o[u])&&l.apply&&V(o)&&(e.result=l.apply(o,t),!1===e.result&&e.preventDefault());return e.type=d,r||e.isDefaultPrevented()||c._default&&!1!==c._default.apply(p.pop(),t)||!V(n)||u&&m(n[d])&&!x(n)&&((a=n[u])&&(n[u]=null),S.event.triggered=d,e.isPropagationStopped()&&f.addEventListener(d,xt),n[d](),e.isPropagationStopped()&&f.removeEventListener(d,xt),S.event.triggered=void 0,a&&(n[u]=a)),e.result}},simulate:function(e,t,n){var r=S.extend(new S.Event,n,{type:e,isSimulated:!0});S.event.trigger(r,null,t)}}),S.fn.extend({trigger:function(e,t){return this.each(function(){S.event.trigger(e,t,this)})},triggerHandler:function(e,t){var n=this[0];if(n)return S.event.trigger(e,t,n,!0)}}),y.focusin||S.each({focus:"focusin",blur:"focusout"},function(n,r){var i=function(e){S.event.simulate(r,e.target,S.event.fix(e))};S.event.special[r]={setup:function(){var e=this.ownerDocument||this.document||this,t=Y.access(e,r);t||e.addEventListener(n,i,!0),Y.access(e,r,(t||0)+1)},teardown:function(){var e=this.ownerDocument||this.document||this,t=Y.access(e,r)-1;t?Y.access(e,r,t):(e.removeEventListener(n,i,!0),Y.remove(e,r))}}});var bt=C.location,wt={guid:Date.now()},Tt=/\?/;S.parseXML=function(e){var t,n;if(!e||"string"!=typeof e)return null;try{t=(new C.DOMParser).parseFromString(e,"text/xml")}catch(e){}return n=t&&t.getElementsByTagName("parsererror")[0],t&&!n||S.error("Invalid XML: "+(n?S.map(n.childNodes,function(e){return e.textContent}).join("\n"):e)),t};var Ct=/\[\]$/,Et=/\r?\n/g,St=/^(?:submit|button|image|reset|file)$/i,kt=/^(?:input|select|textarea|keygen)/i;function At(n,e,r,i){var t;if(Array.isArray(e))S.each(e,function(e,t){r||Ct.test(n)?i(n,t):At(n+"["+("object"==typeof t&&null!=t?e:"")+"]",t,r,i)});else if(r||"object"!==w(e))i(n,e);else for(t in e)At(n+"["+t+"]",e[t],r,i)}S.param=function(e,t){var n,r=[],i=function(e,t){var n=m(t)?t():t;r[r.length]=encodeURIComponent(e)+"="+encodeURIComponent(null==n?"":n)};if(null==e)return"";if(Array.isArray(e)||e.jquery&&!S.isPlainObject(e))S.each(e,function(){i(this.name,this.value)});else for(n in e)At(n,e[n],t,i);return r.join("&")},S.fn.extend({serialize:function(){return S.param(this.serializeArray())},serializeArray:function(){return this.map(function(){var e=S.prop(this,"elements");return e?S.makeArray(e):this}).filter(function(){var e=this.type;return this.name&&!S(this).is(":disabled")&&kt.test(this.nodeName)&&!St.test(e)&&(this.checked||!pe.test(e))}).map(function(e,t){var n=S(this).val();return null==n?null:Array.isArray(n)?S.map(n,function(e){return{name:t.name,value:e.replace(Et,"\r\n")}}):{name:t.name,value:n.replace(Et,"\r\n")}}).get()}});var Nt=/%20/g,jt=/#.*$/,Dt=/([?&])_=[^&]*/,qt=/^(.*?):[ \t]*([^\r\n]*)$/gm,Lt=/^(?:GET|HEAD)$/,Ht=/^\/\//,Ot={},Pt={},Rt="*/".concat("*"),Mt=E.createElement("a");function It(o){return function(e,t){"string"!=typeof e&&(t=e,e="*");var n,r=0,i=e.toLowerCase().match(P)||[];if(m(t))while(n=i[r++])"+"===n[0]?(n=n.slice(1)||"*",(o[n]=o[n]||[]).unshift(t)):(o[n]=o[n]||[]).push(t)}}function Wt(t,i,o,a){var s={},u=t===Pt;function l(e){var r;return s[e]=!0,S.each(t[e]||[],function(e,t){var n=t(i,o,a);return"string"!=typeof n||u||s[n]?u?!(r=n):void 0:(i.dataTypes.unshift(n),l(n),!1)}),r}return l(i.dataTypes[0])||!s["*"]&&l("*")}function Ft(e,t){var n,r,i=S.ajaxSettings.flatOptions||{};for(n in t)void 0!==t[n]&&((i[n]?e:r||(r={}))[n]=t[n]);return r&&S.extend(!0,e,r),e}Mt.href=bt.href,S.extend({active:0,lastModified:{},etag:{},ajaxSettings:{url:bt.href,type:"GET",isLocal:/^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(bt.protocol),global:!0,processData:!0,async:!0,contentType:"application/x-www-form-urlencoded; charset=UTF-8",accepts:{"*":Rt,text:"text/plain",html:"text/html",xml:"application/xml, text/xml",json:"application/json, text/javascript"},contents:{xml:/\bxml\b/,html:/\bhtml/,json:/\bjson\b/},responseFields:{xml:"responseXML",text:"responseText",json:"responseJSON"},converters:{"* text":String,"text html":!0,"text json":JSON.parse,"text xml":S.parseXML},flatOptions:{url:!0,context:!0}},ajaxSetup:function(e,t){return t?Ft(Ft(e,S.ajaxSettings),t):Ft(S.ajaxSettings,e)},ajaxPrefilter:It(Ot),ajaxTransport:It(Pt),ajax:function(e,t){"object"==typeof e&&(t=e,e=void 0),t=t||{};var c,f,p,n,d,r,h,g,i,o,v=S.ajaxSetup({},t),y=v.context||v,m=v.context&&(y.nodeType||y.jquery)?S(y):S.event,x=S.Deferred(),b=S.Callbacks("once memory"),w=v.statusCode||{},a={},s={},u="canceled",T={readyState:0,getResponseHeader:function(e){var t;if(h){if(!n){n={};while(t=qt.exec(p))n[t[1].toLowerCase()+" "]=(n[t[1].toLowerCase()+" "]||[]).concat(t[2])}t=n[e.toLowerCase()+" "]}return null==t?null:t.join(", ")},getAllResponseHeaders:function(){return h?p:null},setRequestHeader:function(e,t){return null==h&&(e=s[e.toLowerCase()]=s[e.toLowerCase()]||e,a[e]=t),this},overrideMimeType:function(e){return null==h&&(v.mimeType=e),this},statusCode:function(e){var t;if(e)if(h)T.always(e[T.status]);else for(t in e)w[t]=[w[t],e[t]];return this},abort:function(e){var t=e||u;return c&&c.abort(t),l(0,t),this}};if(x.promise(T),v.url=((e||v.url||bt.href)+"").replace(Ht,bt.protocol+"//"),v.type=t.method||t.type||v.method||v.type,v.dataTypes=(v.dataType||"*").toLowerCase().match(P)||[""],null==v.crossDomain){r=E.createElement("a");try{r.href=v.url,r.href=r.href,v.crossDomain=Mt.protocol+"//"+Mt.host!=r.protocol+"//"+r.host}catch(e){v.crossDomain=!0}}if(v.data&&v.processData&&"string"!=typeof v.data&&(v.data=S.param(v.data,v.traditional)),Wt(Ot,v,t,T),h)return T;for(i in(g=S.event&&v.global)&&0==S.active++&&S.event.trigger("ajaxStart"),v.type=v.type.toUpperCase(),v.hasContent=!Lt.test(v.type),f=v.url.replace(jt,""),v.hasContent?v.data&&v.processData&&0===(v.contentType||"").indexOf("application/x-www-form-urlencoded")&&(v.data=v.data.replace(Nt,"+")):(o=v.url.slice(f.length),v.data&&(v.processData||"string"==typeof v.data)&&(f+=(Tt.test(f)?"&":"?")+v.data,delete v.data),!1===v.cache&&(f=f.replace(Dt,"$1"),o=(Tt.test(f)?"&":"?")+"_="+wt.guid+++o),v.url=f+o),v.ifModified&&(S.lastModified[f]&&T.setRequestHeader("If-Modified-Since",S.lastModified[f]),S.etag[f]&&T.setRequestHeader("If-None-Match",S.etag[f])),(v.data&&v.hasContent&&!1!==v.contentType||t.contentType)&&T.setRequestHeader("Content-Type",v.contentType),T.setRequestHeader("Accept",v.dataTypes[0]&&v.accepts[v.dataTypes[0]]?v.accepts[v.dataTypes[0]]+("*"!==v.dataTypes[0]?", "+Rt+"; q=0.01":""):v.accepts["*"]),v.headers)T.setRequestHeader(i,v.headers[i]);if(v.beforeSend&&(!1===v.beforeSend.call(y,T,v)||h))return T.abort();if(u="abort",b.add(v.complete),T.done(v.success),T.fail(v.error),c=Wt(Pt,v,t,T)){if(T.readyState=1,g&&m.trigger("ajaxSend",[T,v]),h)return T;v.async&&0<v.timeout&&(d=C.setTimeout(function(){T.abort("timeout")},v.timeout));try{h=!1,c.send(a,l)}catch(e){if(h)throw e;l(-1,e)}}else l(-1,"No Transport");function l(e,t,n,r){var i,o,a,s,u,l=t;h||(h=!0,d&&C.clearTimeout(d),c=void 0,p=r||"",T.readyState=0<e?4:0,i=200<=e&&e<300||304===e,n&&(s=function(e,t,n){var r,i,o,a,s=e.contents,u=e.dataTypes;while("*"===u[0])u.shift(),void 0===r&&(r=e.mimeType||t.getResponseHeader("Content-Type"));if(r)for(i in s)if(s[i]&&s[i].test(r)){u.unshift(i);break}if(u[0]in n)o=u[0];else{for(i in n){if(!u[0]||e.converters[i+" "+u[0]]){o=i;break}a||(a=i)}o=o||a}if(o)return o!==u[0]&&u.unshift(o),n[o]}(v,T,n)),!i&&-1<S.inArray("script",v.dataTypes)&&S.inArray("json",v.dataTypes)<0&&(v.converters["text script"]=function(){}),s=function(e,t,n,r){var i,o,a,s,u,l={},c=e.dataTypes.slice();if(c[1])for(a in e.converters)l[a.toLowerCase()]=e.converters[a];o=c.shift();while(o)if(e.responseFields[o]&&(n[e.responseFields[o]]=t),!u&&r&&e.dataFilter&&(t=e.dataFilter(t,e.dataType)),u=o,o=c.shift())if("*"===o)o=u;else if("*"!==u&&u!==o){if(!(a=l[u+" "+o]||l["* "+o]))for(i in l)if((s=i.split(" "))[1]===o&&(a=l[u+" "+s[0]]||l["* "+s[0]])){!0===a?a=l[i]:!0!==l[i]&&(o=s[0],c.unshift(s[1]));break}if(!0!==a)if(a&&e["throws"])t=a(t);else try{t=a(t)}catch(e){return{state:"parsererror",error:a?e:"No conversion from "+u+" to "+o}}}return{state:"success",data:t}}(v,s,T,i),i?(v.ifModified&&((u=T.getResponseHeader("Last-Modified"))&&(S.lastModified[f]=u),(u=T.getResponseHeader("etag"))&&(S.etag[f]=u)),204===e||"HEAD"===v.type?l="nocontent":304===e?l="notmodified":(l=s.state,o=s.data,i=!(a=s.error))):(a=l,!e&&l||(l="error",e<0&&(e=0))),T.status=e,T.statusText=(t||l)+"",i?x.resolveWith(y,[o,l,T]):x.rejectWith(y,[T,l,a]),T.statusCode(w),w=void 0,g&&m.trigger(i?"ajaxSuccess":"ajaxError",[T,v,i?o:a]),b.fireWith(y,[T,l]),g&&(m.trigger("ajaxComplete",[T,v]),--S.active||S.event.trigger("ajaxStop")))}return T},getJSON:function(e,t,n){return S.get(e,t,n,"json")},getScript:function(e,t){return S.get(e,void 0,t,"script")}}),S.each(["get","post"],function(e,i){S[i]=function(e,t,n,r){return m(t)&&(r=r||n,n=t,t=void 0),S.ajax(S.extend({url:e,type:i,dataType:r,data:t,success:n},S.isPlainObject(e)&&e))}}),S.ajaxPrefilter(function(e){var t;for(t in e.headers)"content-type"===t.toLowerCase()&&(e.contentType=e.headers[t]||"")}),S._evalUrl=function(e,t,n){return S.ajax({url:e,type:"GET",dataType:"script",cache:!0,async:!1,global:!1,converters:{"text script":function(){}},dataFilter:function(e){S.globalEval(e,t,n)}})},S.fn.extend({wrapAll:function(e){var t;return this[0]&&(m(e)&&(e=e.call(this[0])),t=S(e,this[0].ownerDocument).eq(0).clone(!0),this[0].parentNode&&t.insertBefore(this[0]),t.map(function(){var e=this;while(e.firstElementChild)e=e.firstElementChild;return e}).append(this)),this},wrapInner:function(n){return m(n)?this.each(function(e){S(this).wrapInner(n.call(this,e))}):this.each(function(){var e=S(this),t=e.contents();t.length?t.wrapAll(n):e.append(n)})},wrap:function(t){var n=m(t);return this.each(function(e){S(this).wrapAll(n?t.call(this,e):t)})},unwrap:function(e){return this.parent(e).not("body").each(function(){S(this).replaceWith(this.childNodes)}),this}}),S.expr.pseudos.hidden=function(e){return!S.expr.pseudos.visible(e)},S.expr.pseudos.visible=function(e){return!!(e.offsetWidth||e.offsetHeight||e.getClientRects().length)},S.ajaxSettings.xhr=function(){try{return new C.XMLHttpRequest}catch(e){}};var Bt={0:200,1223:204},$t=S.ajaxSettings.xhr();y.cors=!!$t&&"withCredentials"in $t,y.ajax=$t=!!$t,S.ajaxTransport(function(i){var o,a;if(y.cors||$t&&!i.crossDomain)return{send:function(e,t){var n,r=i.xhr();if(r.open(i.type,i.url,i.async,i.username,i.password),i.xhrFields)for(n in i.xhrFields)r[n]=i.xhrFields[n];for(n in i.mimeType&&r.overrideMimeType&&r.overrideMimeType(i.mimeType),i.crossDomain||e["X-Requested-With"]||(e["X-Requested-With"]="XMLHttpRequest"),e)r.setRequestHeader(n,e[n]);o=function(e){return function(){o&&(o=a=r.onload=r.onerror=r.onabort=r.ontimeout=r.onreadystatechange=null,"abort"===e?r.abort():"error"===e?"number"!=typeof r.status?t(0,"error"):t(r.status,r.statusText):t(Bt[r.status]||r.status,r.statusText,"text"!==(r.responseType||"text")||"string"!=typeof r.responseText?{binary:r.response}:{text:r.responseText},r.getAllResponseHeaders()))}},r.onload=o(),a=r.onerror=r.ontimeout=o("error"),void 0!==r.onabort?r.onabort=a:r.onreadystatechange=function(){4===r.readyState&&C.setTimeout(function(){o&&a()})},o=o("abort");try{r.send(i.hasContent&&i.data||null)}catch(e){if(o)throw e}},abort:function(){o&&o()}}}),S.ajaxPrefilter(function(e){e.crossDomain&&(e.contents.script=!1)}),S.ajaxSetup({accepts:{script:"text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"},contents:{script:/\b(?:java|ecma)script\b/},converters:{"text script":function(e){return S.globalEval(e),e}}}),S.ajaxPrefilter("script",function(e){void 0===e.cache&&(e.cache=!1),e.crossDomain&&(e.type="GET")}),S.ajaxTransport("script",function(n){var r,i;if(n.crossDomain||n.scriptAttrs)return{send:function(e,t){r=S("<script>").attr(n.scriptAttrs||{}).prop({charset:n.scriptCharset,src:n.url}).on("load error",i=function(e){r.remove(),i=null,e&&t("error"===e.type?404:200,e.type)}),E.head.appendChild(r[0])},abort:function(){i&&i()}}});var _t,zt=[],Ut=/(=)\?(?=&|$)|\?\?/;S.ajaxSetup({jsonp:"callback",jsonpCallback:function(){var e=zt.pop()||S.expando+"_"+wt.guid++;return this[e]=!0,e}}),S.ajaxPrefilter("json jsonp",function(e,t,n){var r,i,o,a=!1!==e.jsonp&&(Ut.test(e.url)?"url":"string"==typeof e.data&&0===(e.contentType||"").indexOf("application/x-www-form-urlencoded")&&Ut.test(e.data)&&"data");if(a||"jsonp"===e.dataTypes[0])return r=e.jsonpCallback=m(e.jsonpCallback)?e.jsonpCallback():e.jsonpCallback,a?e[a]=e[a].replace(Ut,"$1"+r):!1!==e.jsonp&&(e.url+=(Tt.test(e.url)?"&":"?")+e.jsonp+"="+r),e.converters["script json"]=function(){return o||S.error(r+" was not called"),o[0]},e.dataTypes[0]="json",i=C[r],C[r]=function(){o=arguments},n.always(function(){void 0===i?S(C).removeProp(r):C[r]=i,e[r]&&(e.jsonpCallback=t.jsonpCallback,zt.push(r)),o&&m(i)&&i(o[0]),o=i=void 0}),"script"}),y.createHTMLDocument=((_t=E.implementation.createHTMLDocument("").body).innerHTML="<form></form><form></form>",2===_t.childNodes.length),S.parseHTML=function(e,t,n){return"string"!=typeof e?[]:("boolean"==typeof t&&(n=t,t=!1),t||(y.createHTMLDocument?((r=(t=E.implementation.createHTMLDocument("")).createElement("base")).href=E.location.href,t.head.appendChild(r)):t=E),o=!n&&[],(i=N.exec(e))?[t.createElement(i[1])]:(i=xe([e],t,o),o&&o.length&&S(o).remove(),S.merge([],i.childNodes)));var r,i,o},S.fn.load=function(e,t,n){var r,i,o,a=this,s=e.indexOf(" ");return-1<s&&(r=ht(e.slice(s)),e=e.slice(0,s)),m(t)?(n=t,t=void 0):t&&"object"==typeof t&&(i="POST"),0<a.length&&S.ajax({url:e,type:i||"GET",dataType:"html",data:t}).done(function(e){o=arguments,a.html(r?S("<div>").append(S.parseHTML(e)).find(r):e)}).always(n&&function(e,t){a.each(function(){n.apply(this,o||[e.responseText,t,e])})}),this},S.expr.pseudos.animated=function(t){return S.grep(S.timers,function(e){return t===e.elem}).length},S.offset={setOffset:function(e,t,n){var r,i,o,a,s,u,l=S.css(e,"position"),c=S(e),f={};"static"===l&&(e.style.position="relative"),s=c.offset(),o=S.css(e,"top"),u=S.css(e,"left"),("absolute"===l||"fixed"===l)&&-1<(o+u).indexOf("auto")?(a=(r=c.position()).top,i=r.left):(a=parseFloat(o)||0,i=parseFloat(u)||0),m(t)&&(t=t.call(e,n,S.extend({},s))),null!=t.top&&(f.top=t.top-s.top+a),null!=t.left&&(f.left=t.left-s.left+i),"using"in t?t.using.call(e,f):c.css(f)}},S.fn.extend({offset:function(t){if(arguments.length)return void 0===t?this:this.each(function(e){S.offset.setOffset(this,t,e)});var e,n,r=this[0];return r?r.getClientRects().length?(e=r.getBoundingClientRect(),n=r.ownerDocument.defaultView,{top:e.top+n.pageYOffset,left:e.left+n.pageXOffset}):{top:0,left:0}:void 0},position:function(){if(this[0]){var e,t,n,r=this[0],i={top:0,left:0};if("fixed"===S.css(r,"position"))t=r.getBoundingClientRect();else{t=this.offset(),n=r.ownerDocument,e=r.offsetParent||n.documentElement;while(e&&(e===n.body||e===n.documentElement)&&"static"===S.css(e,"position"))e=e.parentNode;e&&e!==r&&1===e.nodeType&&((i=S(e).offset()).top+=S.css(e,"borderTopWidth",!0),i.left+=S.css(e,"borderLeftWidth",!0))}return{top:t.top-i.top-S.css(r,"marginTop",!0),left:t.left-i.left-S.css(r,"marginLeft",!0)}}},offsetParent:function(){return this.map(function(){var e=this.offsetParent;while(e&&"static"===S.css(e,"position"))e=e.offsetParent;return e||re})}}),S.each({scrollLeft:"pageXOffset",scrollTop:"pageYOffset"},function(t,i){var o="pageYOffset"===i;S.fn[t]=function(e){return $(this,function(e,t,n){var r;if(x(e)?r=e:9===e.nodeType&&(r=e.defaultView),void 0===n)return r?r[i]:e[t];r?r.scrollTo(o?r.pageXOffset:n,o?n:r.pageYOffset):e[t]=n},t,e,arguments.length)}}),S.each(["top","left"],function(e,n){S.cssHooks[n]=Fe(y.pixelPosition,function(e,t){if(t)return t=We(e,n),Pe.test(t)?S(e).position()[n]+"px":t})}),S.each({Height:"height",Width:"width"},function(a,s){S.each({padding:"inner"+a,content:s,"":"outer"+a},function(r,o){S.fn[o]=function(e,t){var n=arguments.length&&(r||"boolean"!=typeof e),i=r||(!0===e||!0===t?"margin":"border");return $(this,function(e,t,n){var r;return x(e)?0===o.indexOf("outer")?e["inner"+a]:e.document.documentElement["client"+a]:9===e.nodeType?(r=e.documentElement,Math.max(e.body["scroll"+a],r["scroll"+a],e.body["offset"+a],r["offset"+a],r["client"+a])):void 0===n?S.css(e,t,i):S.style(e,t,n,i)},s,n?e:void 0,n)}})}),S.each(["ajaxStart","ajaxStop","ajaxComplete","ajaxError","ajaxSuccess","ajaxSend"],function(e,t){S.fn[t]=function(e){return this.on(t,e)}}),S.fn.extend({bind:function(e,t,n){return this.on(e,null,t,n)},unbind:function(e,t){return this.off(e,null,t)},delegate:function(e,t,n,r){return this.on(t,e,n,r)},undelegate:function(e,t,n){return 1===arguments.length?this.off(e,"**"):this.off(t,e||"**",n)},hover:function(e,t){return this.mouseenter(e).mouseleave(t||e)}}),S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "),function(e,n){S.fn[n]=function(e,t){return 0<arguments.length?this.on(n,null,e,t):this.trigger(n)}});var Xt=/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;S.proxy=function(e,t){var n,r,i;if("string"==typeof t&&(n=e[t],t=e,e=n),m(e))return r=s.call(arguments,2),(i=function(){return e.apply(t||this,r.concat(s.call(arguments)))}).guid=e.guid=e.guid||S.guid++,i},S.holdReady=function(e){e?S.readyWait++:S.ready(!0)},S.isArray=Array.isArray,S.parseJSON=JSON.parse,S.nodeName=A,S.isFunction=m,S.isWindow=x,S.camelCase=X,S.type=w,S.now=Date.now,S.isNumeric=function(e){var t=S.type(e);return("number"===t||"string"===t)&&!isNaN(e-parseFloat(e))},S.trim=function(e){return null==e?"":(e+"").replace(Xt,"")}, true&&!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function(){return S}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
            __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));var Vt=C.jQuery,Gt=C.$;return S.noConflict=function(e){return C.$===S&&(C.$=Gt),e&&C.jQuery===S&&(C.jQuery=Vt),S},"undefined"==typeof e&&(C.jQuery=C.$=S),S});


            /***/ }),

        /***/ 7090:
        /***/ ((module) => {

            (function(window, factory) {
                var lazySizes = factory(window, window.document, Date);
                window.lazySizes = lazySizes;
                if( true && module.exports){
                    module.exports = lazySizes;
                }
            }(typeof window != 'undefined' ?
                    window : {},
                /**
                 * import("./types/global")
                 * @typedef { import("./types/lazysizes-config").LazySizesConfigPartial } LazySizesConfigPartial
                 */
                function l(window, document, Date) { // Pass in the window Date function also for SSR because the Date class can be lost
                    'use strict';
                    /*jshint eqnull:true */

                    var lazysizes,
                        /**
                         * @type { LazySizesConfigPartial }
                         */
                        lazySizesCfg;

                    (function(){
                        var prop;

                        var lazySizesDefaults = {
                            lazyClass: 'lazyload',
                            loadedClass: 'lazyloaded',
                            loadingClass: 'lazyloading',
                            preloadClass: 'lazypreload',
                            errorClass: 'lazyerror',
                            //strictClass: 'lazystrict',
                            autosizesClass: 'lazyautosizes',
                            fastLoadedClass: 'ls-is-cached',
                            iframeLoadMode: 0,
                            srcAttr: 'data-src',
                            srcsetAttr: 'data-srcset',
                            sizesAttr: 'data-sizes',
                            //preloadAfterLoad: false,
                            minSize: 40,
                            customMedia: {},
                            init: true,
                            expFactor: 1.5,
                            hFac: 0.8,
                            loadMode: 2,
                            loadHidden: true,
                            ricTimeout: 0,
                            throttleDelay: 125,
                        };

                        lazySizesCfg = window.lazySizesConfig || window.lazysizesConfig || {};

                        for(prop in lazySizesDefaults){
                            if(!(prop in lazySizesCfg)){
                                lazySizesCfg[prop] = lazySizesDefaults[prop];
                            }
                        }
                    })();

                    if (!document || !document.getElementsByClassName) {
                        return {
                            init: function () {},
                            /**
                             * @type { LazySizesConfigPartial }
                             */
                            cfg: lazySizesCfg,
                            /**
                             * @type { true }
                             */
                            noSupport: true,
                        };
                    }

                    var docElem = document.documentElement;

                    var supportPicture = window.HTMLPictureElement;

                    var _addEventListener = 'addEventListener';

                    var _getAttribute = 'getAttribute';

                    /**
                     * Update to bind to window because 'this' becomes null during SSR
                     * builds.
                     */
                    var addEventListener = window[_addEventListener].bind(window);

                    var setTimeout = window.setTimeout;

                    var requestAnimationFrame = window.requestAnimationFrame || setTimeout;

                    var requestIdleCallback = window.requestIdleCallback;

                    var regPicture = /^picture$/i;

                    var loadEvents = ['load', 'error', 'lazyincluded', '_lazyloaded'];

                    var regClassCache = {};

                    var forEach = Array.prototype.forEach;

                    /**
                     * @param ele {Element}
                     * @param cls {string}
                     */
                    var hasClass = function(ele, cls) {
                        if(!regClassCache[cls]){
                            regClassCache[cls] = new RegExp('(\\s|^)'+cls+'(\\s|$)');
                        }
                        return regClassCache[cls].test(ele[_getAttribute]('class') || '') && regClassCache[cls];
                    };

                    /**
                     * @param ele {Element}
                     * @param cls {string}
                     */
                    var addClass = function(ele, cls) {
                        if (!hasClass(ele, cls)){
                            ele.setAttribute('class', (ele[_getAttribute]('class') || '').trim() + ' ' + cls);
                        }
                    };

                    /**
                     * @param ele {Element}
                     * @param cls {string}
                     */
                    var removeClass = function(ele, cls) {
                        var reg;
                        if ((reg = hasClass(ele,cls))) {
                            ele.setAttribute('class', (ele[_getAttribute]('class') || '').replace(reg, ' '));
                        }
                    };

                    var addRemoveLoadEvents = function(dom, fn, add){
                        var action = add ? _addEventListener : 'removeEventListener';
                        if(add){
                            addRemoveLoadEvents(dom, fn);
                        }
                        loadEvents.forEach(function(evt){
                            dom[action](evt, fn);
                        });
                    };

                    /**
                     * @param elem { Element }
                     * @param name { string }
                     * @param detail { any }
                     * @param noBubbles { boolean }
                     * @param noCancelable { boolean }
                     * @returns { CustomEvent }
                     */
                    var triggerEvent = function(elem, name, detail, noBubbles, noCancelable){
                        var event = document.createEvent('Event');

                        if(!detail){
                            detail = {};
                        }

                        detail.instance = lazysizes;

                        event.initEvent(name, !noBubbles, !noCancelable);

                        event.detail = detail;

                        elem.dispatchEvent(event);
                        return event;
                    };

                    var updatePolyfill = function (el, full){
                        var polyfill;
                        if( !supportPicture && ( polyfill = (window.picturefill || lazySizesCfg.pf) ) ){
                            if(full && full.src && !el[_getAttribute]('srcset')){
                                el.setAttribute('srcset', full.src);
                            }
                            polyfill({reevaluate: true, elements: [el]});
                        } else if(full && full.src){
                            el.src = full.src;
                        }
                    };

                    var getCSS = function (elem, style){
                        return (getComputedStyle(elem, null) || {})[style];
                    };

                    /**
                     *
                     * @param elem { Element }
                     * @param parent { Element }
                     * @param [width] {number}
                     * @returns {number}
                     */
                    var getWidth = function(elem, parent, width){
                        width = width || elem.offsetWidth;

                        while(width < lazySizesCfg.minSize && parent && !elem._lazysizesWidth){
                            width =  parent.offsetWidth;
                            parent = parent.parentNode;
                        }

                        return width;
                    };

                    var rAF = (function(){
                        var running, waiting;
                        var firstFns = [];
                        var secondFns = [];
                        var fns = firstFns;

                        var run = function(){
                            var runFns = fns;

                            fns = firstFns.length ? secondFns : firstFns;

                            running = true;
                            waiting = false;

                            while(runFns.length){
                                runFns.shift()();
                            }

                            running = false;
                        };

                        var rafBatch = function(fn, queue){
                            if(running && !queue){
                                fn.apply(this, arguments);
                            } else {
                                fns.push(fn);

                                if(!waiting){
                                    waiting = true;
                                    (document.hidden ? setTimeout : requestAnimationFrame)(run);
                                }
                            }
                        };

                        rafBatch._lsFlush = run;

                        return rafBatch;
                    })();

                    var rAFIt = function(fn, simple){
                        return simple ?
                            function() {
                                rAF(fn);
                            } :
                            function(){
                                var that = this;
                                var args = arguments;
                                rAF(function(){
                                    fn.apply(that, args);
                                });
                            }
                            ;
                    };

                    var throttle = function(fn){
                        var running;
                        var lastTime = 0;
                        var gDelay = lazySizesCfg.throttleDelay;
                        var rICTimeout = lazySizesCfg.ricTimeout;
                        var run = function(){
                            running = false;
                            lastTime = Date.now();
                            fn();
                        };
                        var idleCallback = requestIdleCallback && rICTimeout > 49 ?
                            function(){
                                requestIdleCallback(run, {timeout: rICTimeout});

                                if(rICTimeout !== lazySizesCfg.ricTimeout){
                                    rICTimeout = lazySizesCfg.ricTimeout;
                                }
                            } :
                            rAFIt(function(){
                                setTimeout(run);
                            }, true)
                        ;

                        return function(isPriority){
                            var delay;

                            if((isPriority = isPriority === true)){
                                rICTimeout = 33;
                            }

                            if(running){
                                return;
                            }

                            running =  true;

                            delay = gDelay - (Date.now() - lastTime);

                            if(delay < 0){
                                delay = 0;
                            }

                            if(isPriority || delay < 9){
                                idleCallback();
                            } else {
                                setTimeout(idleCallback, delay);
                            }
                        };
                    };

                    //based on http://modernjavascript.blogspot.de/2013/08/building-better-debounce.html
                    var debounce = function(func) {
                        var timeout, timestamp;
                        var wait = 99;
                        var run = function(){
                            timeout = null;
                            func();
                        };
                        var later = function() {
                            var last = Date.now() - timestamp;

                            if (last < wait) {
                                setTimeout(later, wait - last);
                            } else {
                                (requestIdleCallback || run)(run);
                            }
                        };

                        return function() {
                            timestamp = Date.now();

                            if (!timeout) {
                                timeout = setTimeout(later, wait);
                            }
                        };
                    };

                    var loader = (function(){
                        var preloadElems, isCompleted, resetPreloadingTimer, loadMode, started;

                        var eLvW, elvH, eLtop, eLleft, eLright, eLbottom, isBodyHidden;

                        var regImg = /^img$/i;
                        var regIframe = /^iframe$/i;

                        var supportScroll = ('onscroll' in window) && !(/(gle|ing)bot/.test(navigator.userAgent));

                        var shrinkExpand = 0;
                        var currentExpand = 0;

                        var isLoading = 0;
                        var lowRuns = -1;

                        var resetPreloading = function(e){
                            isLoading--;
                            if(!e || isLoading < 0 || !e.target){
                                isLoading = 0;
                            }
                        };

                        var isVisible = function (elem) {
                            if (isBodyHidden == null) {
                                isBodyHidden = getCSS(document.body, 'visibility') == 'hidden';
                            }

                            return isBodyHidden || !(getCSS(elem.parentNode, 'visibility') == 'hidden' && getCSS(elem, 'visibility') == 'hidden');
                        };

                        var isNestedVisible = function(elem, elemExpand){
                            var outerRect;
                            var parent = elem;
                            var visible = isVisible(elem);

                            eLtop -= elemExpand;
                            eLbottom += elemExpand;
                            eLleft -= elemExpand;
                            eLright += elemExpand;

                            while(visible && (parent = parent.offsetParent) && parent != document.body && parent != docElem){
                                visible = ((getCSS(parent, 'opacity') || 1) > 0);

                                if(visible && getCSS(parent, 'overflow') != 'visible'){
                                    outerRect = parent.getBoundingClientRect();
                                    visible = eLright > outerRect.left &&
                                        eLleft < outerRect.right &&
                                        eLbottom > outerRect.top - 1 &&
                                        eLtop < outerRect.bottom + 1
                                    ;
                                }
                            }

                            return visible;
                        };

                        var checkElements = function() {
                            var eLlen, i, rect, autoLoadElem, loadedSomething, elemExpand, elemNegativeExpand, elemExpandVal,
                                beforeExpandVal, defaultExpand, preloadExpand, hFac;
                            var lazyloadElems = lazysizes.elements;

                            if((loadMode = lazySizesCfg.loadMode) && isLoading < 8 && (eLlen = lazyloadElems.length)){

                                i = 0;

                                lowRuns++;

                                for(; i < eLlen; i++){

                                    if(!lazyloadElems[i] || lazyloadElems[i]._lazyRace){continue;}

                                    if(!supportScroll || (lazysizes.prematureUnveil && lazysizes.prematureUnveil(lazyloadElems[i]))){unveilElement(lazyloadElems[i]);continue;}

                                    if(!(elemExpandVal = lazyloadElems[i][_getAttribute]('data-expand')) || !(elemExpand = elemExpandVal * 1)){
                                        elemExpand = currentExpand;
                                    }

                                    if (!defaultExpand) {
                                        defaultExpand = (!lazySizesCfg.expand || lazySizesCfg.expand < 1) ?
                                            docElem.clientHeight > 500 && docElem.clientWidth > 500 ? 500 : 370 :
                                            lazySizesCfg.expand;

                                        lazysizes._defEx = defaultExpand;

                                        preloadExpand = defaultExpand * lazySizesCfg.expFactor;
                                        hFac = lazySizesCfg.hFac;
                                        isBodyHidden = null;

                                        if(currentExpand < preloadExpand && isLoading < 1 && lowRuns > 2 && loadMode > 2 && !document.hidden){
                                            currentExpand = preloadExpand;
                                            lowRuns = 0;
                                        } else if(loadMode > 1 && lowRuns > 1 && isLoading < 6){
                                            currentExpand = defaultExpand;
                                        } else {
                                            currentExpand = shrinkExpand;
                                        }
                                    }

                                    if(beforeExpandVal !== elemExpand){
                                        eLvW = innerWidth + (elemExpand * hFac);
                                        elvH = innerHeight + elemExpand;
                                        elemNegativeExpand = elemExpand * -1;
                                        beforeExpandVal = elemExpand;
                                    }

                                    rect = lazyloadElems[i].getBoundingClientRect();

                                    if ((eLbottom = rect.bottom) >= elemNegativeExpand &&
                                        (eLtop = rect.top) <= elvH &&
                                        (eLright = rect.right) >= elemNegativeExpand * hFac &&
                                        (eLleft = rect.left) <= eLvW &&
                                        (eLbottom || eLright || eLleft || eLtop) &&
                                        (lazySizesCfg.loadHidden || isVisible(lazyloadElems[i])) &&
                                        ((isCompleted && isLoading < 3 && !elemExpandVal && (loadMode < 3 || lowRuns < 4)) || isNestedVisible(lazyloadElems[i], elemExpand))){
                                        unveilElement(lazyloadElems[i]);
                                        loadedSomething = true;
                                        if(isLoading > 9){break;}
                                    } else if(!loadedSomething && isCompleted && !autoLoadElem &&
                                        isLoading < 4 && lowRuns < 4 && loadMode > 2 &&
                                        (preloadElems[0] || lazySizesCfg.preloadAfterLoad) &&
                                        (preloadElems[0] || (!elemExpandVal && ((eLbottom || eLright || eLleft || eLtop) || lazyloadElems[i][_getAttribute](lazySizesCfg.sizesAttr) != 'auto')))){
                                        autoLoadElem = preloadElems[0] || lazyloadElems[i];
                                    }
                                }

                                if(autoLoadElem && !loadedSomething){
                                    unveilElement(autoLoadElem);
                                }
                            }
                        };

                        var throttledCheckElements = throttle(checkElements);

                        var switchLoadingClass = function(e){
                            var elem = e.target;

                            if (elem._lazyCache) {
                                delete elem._lazyCache;
                                return;
                            }

                            resetPreloading(e);
                            addClass(elem, lazySizesCfg.loadedClass);
                            removeClass(elem, lazySizesCfg.loadingClass);
                            addRemoveLoadEvents(elem, rafSwitchLoadingClass);
                            triggerEvent(elem, 'lazyloaded');
                        };
                        var rafedSwitchLoadingClass = rAFIt(switchLoadingClass);
                        var rafSwitchLoadingClass = function(e){
                            rafedSwitchLoadingClass({target: e.target});
                        };

                        var changeIframeSrc = function(elem, src){
                            var loadMode = elem.getAttribute('data-load-mode') || lazySizesCfg.iframeLoadMode;

                            // loadMode can be also a string!
                            if (loadMode == 0) {
                                elem.contentWindow.location.replace(src);
                            } else if (loadMode == 1) {
                                elem.src = src;
                            }
                        };

                        var handleSources = function(source){
                            var customMedia;

                            var sourceSrcset = source[_getAttribute](lazySizesCfg.srcsetAttr);

                            if( (customMedia = lazySizesCfg.customMedia[source[_getAttribute]('data-media') || source[_getAttribute]('media')]) ){
                                source.setAttribute('media', customMedia);
                            }

                            if(sourceSrcset){
                                source.setAttribute('srcset', sourceSrcset);
                            }
                        };

                        var lazyUnveil = rAFIt(function (elem, detail, isAuto, sizes, isImg){
                            var src, srcset, parent, isPicture, event, firesLoad;

                            if(!(event = triggerEvent(elem, 'lazybeforeunveil', detail)).defaultPrevented){

                                if(sizes){
                                    if(isAuto){
                                        addClass(elem, lazySizesCfg.autosizesClass);
                                    } else {
                                        elem.setAttribute('sizes', sizes);
                                    }
                                }

                                srcset = elem[_getAttribute](lazySizesCfg.srcsetAttr);
                                src = elem[_getAttribute](lazySizesCfg.srcAttr);

                                if(isImg) {
                                    parent = elem.parentNode;
                                    isPicture = parent && regPicture.test(parent.nodeName || '');
                                }

                                firesLoad = detail.firesLoad || (('src' in elem) && (srcset || src || isPicture));

                                event = {target: elem};

                                addClass(elem, lazySizesCfg.loadingClass);

                                if(firesLoad){
                                    clearTimeout(resetPreloadingTimer);
                                    resetPreloadingTimer = setTimeout(resetPreloading, 2500);
                                    addRemoveLoadEvents(elem, rafSwitchLoadingClass, true);
                                }

                                if(isPicture){
                                    forEach.call(parent.getElementsByTagName('source'), handleSources);
                                }

                                if(srcset){
                                    elem.setAttribute('srcset', srcset);
                                } else if(src && !isPicture){
                                    if(regIframe.test(elem.nodeName)){
                                        changeIframeSrc(elem, src);
                                    } else {
                                        elem.src = src;
                                    }
                                }

                                if(isImg && (srcset || isPicture)){
                                    updatePolyfill(elem, {src: src});
                                }
                            }

                            if(elem._lazyRace){
                                delete elem._lazyRace;
                            }
                            removeClass(elem, lazySizesCfg.lazyClass);

                            rAF(function(){
                                // Part of this can be removed as soon as this fix is older: https://bugs.chromium.org/p/chromium/issues/detail?id=7731 (2015)
                                var isLoaded = elem.complete && elem.naturalWidth > 1;

                                if( !firesLoad || isLoaded){
                                    if (isLoaded) {
                                        addClass(elem, lazySizesCfg.fastLoadedClass);
                                    }
                                    switchLoadingClass(event);
                                    elem._lazyCache = true;
                                    setTimeout(function(){
                                        if ('_lazyCache' in elem) {
                                            delete elem._lazyCache;
                                        }
                                    }, 9);
                                }
                                if (elem.loading == 'lazy') {
                                    isLoading--;
                                }
                            }, true);
                        });

                        /**
                         *
                         * @param elem { Element }
                         */
                        var unveilElement = function (elem){
                            if (elem._lazyRace) {return;}
                            var detail;

                            var isImg = regImg.test(elem.nodeName);

                            //allow using sizes="auto", but don't use. it's invalid. Use data-sizes="auto" or a valid value for sizes instead (i.e.: sizes="80vw")
                            var sizes = isImg && (elem[_getAttribute](lazySizesCfg.sizesAttr) || elem[_getAttribute]('sizes'));
                            var isAuto = sizes == 'auto';

                            if( (isAuto || !isCompleted) && isImg && (elem[_getAttribute]('src') || elem.srcset) && !elem.complete && !hasClass(elem, lazySizesCfg.errorClass) && hasClass(elem, lazySizesCfg.lazyClass)){return;}

                            detail = triggerEvent(elem, 'lazyunveilread').detail;

                            if(isAuto){
                                autoSizer.updateElem(elem, true, elem.offsetWidth);
                            }

                            elem._lazyRace = true;
                            isLoading++;

                            lazyUnveil(elem, detail, isAuto, sizes, isImg);
                        };

                        var afterScroll = debounce(function(){
                            lazySizesCfg.loadMode = 3;
                            throttledCheckElements();
                        });

                        var altLoadmodeScrollListner = function(){
                            if(lazySizesCfg.loadMode == 3){
                                lazySizesCfg.loadMode = 2;
                            }
                            afterScroll();
                        };

                        var onload = function(){
                            if(isCompleted){return;}
                            if(Date.now() - started < 999){
                                setTimeout(onload, 999);
                                return;
                            }


                            isCompleted = true;

                            lazySizesCfg.loadMode = 3;

                            throttledCheckElements();

                            addEventListener('scroll', altLoadmodeScrollListner, true);
                        };

                        return {
                            _: function(){
                                started = Date.now();

                                lazysizes.elements = document.getElementsByClassName(lazySizesCfg.lazyClass);
                                preloadElems = document.getElementsByClassName(lazySizesCfg.lazyClass + ' ' + lazySizesCfg.preloadClass);

                                addEventListener('scroll', throttledCheckElements, true);

                                addEventListener('resize', throttledCheckElements, true);

                                addEventListener('pageshow', function (e) {
                                    if (e.persisted) {
                                        var loadingElements = document.querySelectorAll('.' + lazySizesCfg.loadingClass);

                                        if (loadingElements.length && loadingElements.forEach) {
                                            requestAnimationFrame(function () {
                                                loadingElements.forEach( function (img) {
                                                    if (img.complete) {
                                                        unveilElement(img);
                                                    }
                                                });
                                            });
                                        }
                                    }
                                });

                                if(window.MutationObserver){
                                    new MutationObserver( throttledCheckElements ).observe( docElem, {childList: true, subtree: true, attributes: true} );
                                } else {
                                    docElem[_addEventListener]('DOMNodeInserted', throttledCheckElements, true);
                                    docElem[_addEventListener]('DOMAttrModified', throttledCheckElements, true);
                                    setInterval(throttledCheckElements, 999);
                                }

                                addEventListener('hashchange', throttledCheckElements, true);

                                //, 'fullscreenchange'
                                ['focus', 'mouseover', 'click', 'load', 'transitionend', 'animationend'].forEach(function(name){
                                    document[_addEventListener](name, throttledCheckElements, true);
                                });

                                if((/d$|^c/.test(document.readyState))){
                                    onload();
                                } else {
                                    addEventListener('load', onload);
                                    document[_addEventListener]('DOMContentLoaded', throttledCheckElements);
                                    setTimeout(onload, 20000);
                                }

                                if(lazysizes.elements.length){
                                    checkElements();
                                    rAF._lsFlush();
                                } else {
                                    throttledCheckElements();
                                }
                            },
                            checkElems: throttledCheckElements,
                            unveil: unveilElement,
                            _aLSL: altLoadmodeScrollListner,
                        };
                    })();


                    var autoSizer = (function(){
                        var autosizesElems;

                        var sizeElement = rAFIt(function(elem, parent, event, width){
                            var sources, i, len;
                            elem._lazysizesWidth = width;
                            width += 'px';

                            elem.setAttribute('sizes', width);

                            if(regPicture.test(parent.nodeName || '')){
                                sources = parent.getElementsByTagName('source');
                                for(i = 0, len = sources.length; i < len; i++){
                                    sources[i].setAttribute('sizes', width);
                                }
                            }

                            if(!event.detail.dataAttr){
                                updatePolyfill(elem, event.detail);
                            }
                        });
                        /**
                         *
                         * @param elem {Element}
                         * @param dataAttr
                         * @param [width] { number }
                         */
                        var getSizeElement = function (elem, dataAttr, width){
                            var event;
                            var parent = elem.parentNode;

                            if(parent){
                                width = getWidth(elem, parent, width);
                                event = triggerEvent(elem, 'lazybeforesizes', {width: width, dataAttr: !!dataAttr});

                                if(!event.defaultPrevented){
                                    width = event.detail.width;

                                    if(width && width !== elem._lazysizesWidth){
                                        sizeElement(elem, parent, event, width);
                                    }
                                }
                            }
                        };

                        var updateElementsSizes = function(){
                            var i;
                            var len = autosizesElems.length;
                            if(len){
                                i = 0;

                                for(; i < len; i++){
                                    getSizeElement(autosizesElems[i]);
                                }
                            }
                        };

                        var debouncedUpdateElementsSizes = debounce(updateElementsSizes);

                        return {
                            _: function(){
                                autosizesElems = document.getElementsByClassName(lazySizesCfg.autosizesClass);
                                addEventListener('resize', debouncedUpdateElementsSizes);
                            },
                            checkElems: debouncedUpdateElementsSizes,
                            updateElem: getSizeElement
                        };
                    })();

                    var init = function(){
                        if(!init.i && document.getElementsByClassName){
                            init.i = true;
                            autoSizer._();
                            loader._();
                        }
                    };

                    setTimeout(function(){
                        if(lazySizesCfg.init){
                            init();
                        }
                    });

                    lazysizes = {
                        /**
                         * @type { LazySizesConfigPartial }
                         */
                        cfg: lazySizesCfg,
                        autoSizer: autoSizer,
                        loader: loader,
                        init: init,
                        uP: updatePolyfill,
                        aC: addClass,
                        rC: removeClass,
                        hC: hasClass,
                        fire: triggerEvent,
                        gW: getWidth,
                        rAF: rAF,
                    };

                    return lazysizes;
                }
            ));


            /***/ }),

        /***/ 1770:
        /***/ ((module, exports, __webpack_require__) => {

            /* provided dependency */ var jQuery = __webpack_require__(5825);
            var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(window, factory) {
                if(!window) {return;}
                var globalInstall = function(){
                    factory(window.lazySizes);
                    window.removeEventListener('lazyunveilread', globalInstall, true);
                };

                factory = factory.bind(null, window, window.document);

                if( true && module.exports){
                    factory(__webpack_require__(7090));
                } else if (true) {
                    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7090)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                        __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                            (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                } else {}
            }(typeof window != 'undefined' ?
                window : 0, function(window, document, lazySizes) {
                'use strict';

                if(!window.addEventListener){return;}

                var regDescriptors = /\s+(\d+)(w|h)\s+(\d+)(w|h)/;
                var regCssFit = /parent-fit["']*\s*:\s*["']*(contain|cover|width)/;
                var regCssObject = /parent-container["']*\s*:\s*["']*(.+?)(?=(\s|$|,|'|"|;))/;
                var regPicture = /^picture$/i;
                var cfg = lazySizes.cfg;

                var getCSS = function (elem){
                    return (getComputedStyle(elem, null) || {});
                };

                var parentFit = {

                    getParent: function(element, parentSel){
                        var parent = element;
                        var parentNode = element.parentNode;

                        if((!parentSel || parentSel == 'prev') && parentNode && regPicture.test(parentNode.nodeName || '')){
                            parentNode = parentNode.parentNode;
                        }

                        if(parentSel != 'self'){
                            if(parentSel == 'prev'){
                                parent = element.previousElementSibling;
                            } else if(parentSel && (parentNode.closest || window.jQuery)){
                                parent = (parentNode.closest ?
                                        parentNode.closest(parentSel) :
                                        jQuery(parentNode).closest(parentSel)[0]) ||
                                    parentNode
                                ;
                            } else {
                                parent = parentNode;
                            }
                        }

                        return parent;
                    },

                    getFit: function(element){
                        var tmpMatch, parentObj;
                        var css = getCSS(element);
                        var content = css.content || css.fontFamily;
                        var obj = {
                            fit: element._lazysizesParentFit || element.getAttribute('data-parent-fit')
                        };

                        if(!obj.fit && content && (tmpMatch = content.match(regCssFit))){
                            obj.fit = tmpMatch[1];
                        }

                        if(obj.fit){
                            parentObj = element._lazysizesParentContainer || element.getAttribute('data-parent-container');

                            if(!parentObj && content && (tmpMatch = content.match(regCssObject))){
                                parentObj = tmpMatch[1];
                            }

                            obj.parent = parentFit.getParent(element, parentObj);


                        } else {
                            obj.fit = css.objectFit;
                        }

                        return obj;
                    },

                    getImageRatio: function(element){
                        var i, srcset, media, ratio, match, width, height;
                        var parent = element.parentNode;
                        var elements = parent && regPicture.test(parent.nodeName || '') ?
                            parent.querySelectorAll('source, img') :
                            [element]
                        ;

                        for(i = 0; i < elements.length; i++){
                            element = elements[i];
                            srcset = element.getAttribute(cfg.srcsetAttr) || element.getAttribute('srcset') || element.getAttribute('data-pfsrcset') || element.getAttribute('data-risrcset') || '';
                            media = element._lsMedia || element.getAttribute('media');
                            media = cfg.customMedia[element.getAttribute('data-media') || media] || media;

                            if(srcset && (!media || (window.matchMedia && matchMedia(media) || {}).matches )){
                                ratio = parseFloat(element.getAttribute('data-aspectratio'));

                                if (!ratio) {
                                    match = srcset.match(regDescriptors);

                                    if (match) {
                                        if(match[2] == 'w'){
                                            width = match[1];
                                            height = match[3];
                                        } else {
                                            width = match[3];
                                            height = match[1];
                                        }
                                    } else {
                                        width = element.getAttribute('width');
                                        height = element.getAttribute('height');
                                    }

                                    ratio = width / height;
                                }

                                break;
                            }
                        }

                        return ratio;
                    },

                    calculateSize: function(element, width){
                        var displayRatio, height, imageRatio, retWidth;
                        var fitObj = this.getFit(element);
                        var fit = fitObj.fit;
                        var fitElem = fitObj.parent;

                        if(fit != 'width' && ((fit != 'contain' && fit != 'cover') || !(imageRatio = this.getImageRatio(element)))){
                            return width;
                        }

                        if(fitElem){
                            width = fitElem.clientWidth;
                        } else {
                            fitElem = element;
                        }

                        retWidth = width;

                        if(fit == 'width'){
                            retWidth = width;
                        } else {
                            height = fitElem.clientHeight;

                            if((displayRatio =  width / height) && ((fit == 'cover' && displayRatio < imageRatio) || (fit == 'contain' && displayRatio > imageRatio))){
                                retWidth = width * (imageRatio / displayRatio);
                            }
                        }

                        return retWidth;
                    }
                };

                lazySizes.parentFit = parentFit;

                document.addEventListener('lazybeforesizes', function(e){
                    if(e.defaultPrevented || e.detail.instance != lazySizes){return;}

                    var element = e.target;
                    e.detail.width = parentFit.calculateSize(element, e.detail.width);
                });
            }));


            /***/ }),

        /***/ 1035:
        /***/ ((module, exports, __webpack_require__) => {

            var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(window, factory) {
                var globalInstall = function(){
                    factory(window.lazySizes);
                    window.removeEventListener('lazyunveilread', globalInstall, true);
                };

                factory = factory.bind(null, window, window.document);

                if( true && module.exports){
                    factory(__webpack_require__(7090));
                } else if (true) {
                    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(7090)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
                        __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                            (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                } else {}
            }(window, function(window, document, lazySizes) {
                /*jshint eqnull:true */
                'use strict';

                var config, riasCfg;
                var lazySizesCfg = lazySizes.cfg;
                var replaceTypes = {string: 1, number: 1};
                var regNumber = /^\-*\+*\d+\.*\d*$/;
                var regPicture = /^picture$/i;
                var regWidth = /\s*\{\s*width\s*\}\s*/i;
                var regHeight = /\s*\{\s*height\s*\}\s*/i;
                var regPlaceholder = /\s*\{\s*([a-z0-9]+)\s*\}\s*/ig;
                var regObj = /^\[.*\]|\{.*\}$/;
                var regAllowedSizes = /^(?:auto|\d+(px)?)$/;
                var anchor = document.createElement('a');
                var img = document.createElement('img');
                var buggySizes = ('srcset' in img) && !('sizes' in img);
                var supportPicture = !!window.HTMLPictureElement && !buggySizes;

                (function(){
                    var prop;
                    var noop = function(){};
                    var riasDefaults = {
                        prefix: '',
                        postfix: '',
                        srcAttr: 'data-src',
                        absUrl: false,
                        modifyOptions: noop,
                        widthmap: {},
                        ratio: false,
                        traditionalRatio: false,
                        aspectratio: false,
                    };

                    config = lazySizes && lazySizes.cfg;

                    if(!config.supportsType){
                        config.supportsType = function(type/*, elem*/){
                            return !type;
                        };
                    }

                    if(!config.rias){
                        config.rias = {};
                    }
                    riasCfg = config.rias;

                    if(!('widths' in riasCfg)){
                        riasCfg.widths = [];
                        (function (widths){
                            var width;
                            var i = 0;
                            while(!width || width < 3000){
                                i += 5;
                                if(i > 30){
                                    i += 1;
                                }
                                width = (36 * i);
                                widths.push(width);
                            }
                        })(riasCfg.widths);
                    }

                    for(prop in riasDefaults){
                        if(!(prop in riasCfg)){
                            riasCfg[prop] = riasDefaults[prop];
                        }
                    }
                })();

                function getElementOptions(elem, src, options){
                    var attr, parent, setOption, prop, opts;
                    var elemStyles = window.getComputedStyle(elem);

                    if (!options) {
                        parent = elem.parentNode;

                        options = {
                            isPicture: !!(parent && regPicture.test(parent.nodeName || ''))
                        };
                    } else {
                        opts = {};

                        for (prop in options) {
                            opts[prop] = options[prop];
                        }

                        options = opts;
                    }

                    setOption = function(attr, run){
                        var attrVal = elem.getAttribute('data-'+ attr);

                        if (!attrVal) {
                            // no data- attr, get value from the CSS
                            var styles = elemStyles.getPropertyValue('--ls-' + attr);
                            // at least Safari 9 returns null rather than
                            // an empty string for getPropertyValue causing
                            // .trim() to fail
                            if (styles) {
                                attrVal = styles.trim();
                            }
                        }

                        if (attrVal) {
                            if(attrVal == 'true'){
                                attrVal = true;
                            } else if(attrVal == 'false'){
                                attrVal = false;
                            } else if(regNumber.test(attrVal)){
                                attrVal = parseFloat(attrVal);
                            } else if(typeof riasCfg[attr] == 'function'){
                                attrVal = riasCfg[attr](elem, attrVal);
                            } else if(regObj.test(attrVal)){
                                try {
                                    attrVal = JSON.parse(attrVal);
                                } catch(e){}
                            }
                            options[attr] = attrVal;
                        } else if((attr in riasCfg) && typeof riasCfg[attr] != 'function' && !options[attr]){
                            options[attr] = riasCfg[attr];
                        } else if(run && typeof riasCfg[attr] == 'function'){
                            options[attr] = riasCfg[attr](elem, attrVal);
                        }
                    };

                    for(attr in riasCfg){
                        setOption(attr);
                    }
                    src.replace(regPlaceholder, function(full, match){
                        if(!(match in options)){
                            setOption(match, true);
                        }
                    });

                    return options;
                }

                function replaceUrlProps(url, options){
                    var candidates = [];
                    var replaceFn = function(full, match){
                        return (replaceTypes[typeof options[match]]) ? options[match] : full;
                    };
                    candidates.srcset = [];

                    if(options.absUrl){
                        anchor.setAttribute('href', url);
                        url = anchor.href;
                    }

                    url = ((options.prefix || '') + url + (options.postfix || '')).replace(regPlaceholder, replaceFn);

                    options.widths.forEach(function(width){
                        var widthAlias = options.widthmap[width] || width;
                        var ratio = options.aspectratio || options.ratio;
                        var traditionalRatio = !options.aspectratio && riasCfg.traditionalRatio;
                        var candidate = {
                            u: url.replace(regWidth, widthAlias)
                                .replace(regHeight, ratio ?
                                    traditionalRatio ?
                                        Math.round(width * ratio) :
                                        Math.round(width / ratio)
                                    : ''),
                            w: width
                        };

                        candidates.push(candidate);
                        candidates.srcset.push( (candidate.c = candidate.u + ' ' + width + 'w') );
                    });
                    return candidates;
                }

                function setSrc(src, opts, elem){
                    var elemW = 0;
                    var elemH = 0;
                    var sizeElement = elem;

                    if(!src){return;}

                    if (opts.ratio === 'container') {
                        // calculate image or parent ratio
                        elemW = sizeElement.scrollWidth;
                        elemH = sizeElement.scrollHeight;

                        while ((!elemW || !elemH) && sizeElement !== document) {
                            sizeElement = sizeElement.parentNode;
                            elemW = sizeElement.scrollWidth;
                            elemH = sizeElement.scrollHeight;
                        }
                        if (elemW && elemH) {
                            opts.ratio = opts.traditionalRatio ? elemH / elemW : elemW / elemH;
                        }
                    }

                    src = replaceUrlProps(src, opts);

                    src.isPicture = opts.isPicture;

                    if(buggySizes && elem.nodeName.toUpperCase() == 'IMG'){
                        elem.removeAttribute(config.srcsetAttr);
                    } else {
                        elem.setAttribute(config.srcsetAttr, src.srcset.join(', '));
                    }

                    Object.defineProperty(elem, '_lazyrias', {
                        value: src,
                        writable: true
                    });
                }

                function createAttrObject(elem, src){
                    var opts = getElementOptions(elem, src);

                    riasCfg.modifyOptions.call(elem, {target: elem, details: opts, detail: opts});

                    lazySizes.fire(elem, 'lazyriasmodifyoptions', opts);
                    return opts;
                }

                function getSrc(elem){
                    return elem.getAttribute( elem.getAttribute('data-srcattr') || riasCfg.srcAttr ) || elem.getAttribute(config.srcsetAttr) || elem.getAttribute(config.srcAttr) || elem.getAttribute('data-pfsrcset') || '';
                }

                addEventListener('lazybeforesizes', function(e){
                    if(e.detail.instance != lazySizes){return;}

                    var elem, src, elemOpts, sourceOpts, parent, sources, i, len, sourceSrc, sizes, detail, hasPlaceholder, modified, emptyList;
                    elem = e.target;

                    if(!e.detail.dataAttr || e.defaultPrevented || riasCfg.disabled || !((sizes = elem.getAttribute(config.sizesAttr) || elem.getAttribute('sizes')) && regAllowedSizes.test(sizes))){return;}

                    src = getSrc(elem);

                    elemOpts = createAttrObject(elem, src);

                    hasPlaceholder = regWidth.test(elemOpts.prefix) || regWidth.test(elemOpts.postfix);

                    if(elemOpts.isPicture && (parent = elem.parentNode)){
                        sources = parent.getElementsByTagName('source');
                        for(i = 0, len = sources.length; i < len; i++){
                            if ( hasPlaceholder || regWidth.test(sourceSrc = getSrc(sources[i])) ){
                                sourceOpts = getElementOptions(sources[i], sourceSrc, elemOpts);
                                setSrc(sourceSrc, sourceOpts, sources[i]);
                                modified = true;
                            }
                        }
                    }

                    if ( hasPlaceholder || regWidth.test(src) ){
                        setSrc(src, elemOpts, elem);
                        modified = true;
                    } else if (modified) {
                        emptyList = [];
                        emptyList.srcset = [];
                        emptyList.isPicture = true;
                        Object.defineProperty(elem, '_lazyrias', {
                            value: emptyList,
                            writable: true
                        });
                    }

                    if(modified){
                        if(supportPicture){
                            elem.removeAttribute(config.srcAttr);
                        } else if(sizes != 'auto') {
                            detail = {
                                width: parseInt(sizes, 10)
                            };
                            polyfill({
                                target: elem,
                                detail: detail
                            });
                        }
                    }
                }, true);
                // partial polyfill
                var polyfill = (function(){
                    var ascendingSort = function( a, b ) {
                        return a.w - b.w;
                    };

                    var reduceCandidate = function (srces) {
                        var lowerCandidate, bonusFactor;
                        var len = srces.length;
                        var candidate = srces[len -1];
                        var i = 0;

                        for(i; i < len;i++){
                            candidate = srces[i];
                            candidate.d = candidate.w / srces.w;
                            if(candidate.d >= srces.d){
                                if(!candidate.cached && (lowerCandidate = srces[i - 1]) &&
                                    lowerCandidate.d > srces.d - (0.13 * Math.pow(srces.d, 2.2))){

                                    bonusFactor = Math.pow(lowerCandidate.d - 0.6, 1.6);

                                    if(lowerCandidate.cached) {
                                        lowerCandidate.d += 0.15 * bonusFactor;
                                    }

                                    if(lowerCandidate.d + ((candidate.d - srces.d) * bonusFactor) > srces.d){
                                        candidate = lowerCandidate;
                                    }
                                }
                                break;
                            }
                        }
                        return candidate;
                    };

                    var getWSet = function(elem, testPicture){
                        var src;
                        if(!elem._lazyrias && lazySizes.pWS && (src = lazySizes.pWS(elem.getAttribute(config.srcsetAttr || ''))).length){
                            Object.defineProperty(elem, '_lazyrias', {
                                value: src,
                                writable: true
                            });
                            if(testPicture && elem.parentNode){
                                src.isPicture = elem.parentNode.nodeName.toUpperCase() == 'PICTURE';
                            }
                        }
                        return elem._lazyrias;
                    };

                    var getX = function(elem){
                        var dpr = window.devicePixelRatio || 1;
                        var optimum = lazySizes.getX && lazySizes.getX(elem);
                        return Math.min(optimum || dpr, 2.4, dpr);
                    };

                    var getCandidate = function(elem, width){
                        var sources, i, len, media, srces, src;

                        srces = elem._lazyrias;

                        if(srces.isPicture && window.matchMedia){
                            for(i = 0, sources = elem.parentNode.getElementsByTagName('source'), len = sources.length; i < len; i++){
                                if(getWSet(sources[i]) && !sources[i].getAttribute('type') && ( !(media = sources[i].getAttribute('media')) || ((matchMedia(media) || {}).matches))){
                                    srces = sources[i]._lazyrias;
                                    break;
                                }
                            }
                        }

                        if(!srces.w || srces.w < width){
                            srces.w = width;
                            srces.d = getX(elem);
                            src = reduceCandidate(srces.sort(ascendingSort));
                        }

                        return src;
                    };

                    var polyfill = function(e){
                        if(e.detail.instance != lazySizes){return;}

                        var candidate;
                        var elem = e.target;

                        if(!buggySizes && (window.respimage || window.picturefill || lazySizesCfg.pf)){
                            document.removeEventListener('lazybeforesizes', polyfill);
                            return;
                        }

                        if(!('_lazyrias' in elem) && (!e.detail.dataAttr || !getWSet(elem, true))){
                            return;
                        }

                        candidate = getCandidate(elem, e.detail.width);

                        if(candidate && candidate.u && elem._lazyrias.cur != candidate.u){
                            elem._lazyrias.cur = candidate.u;
                            candidate.cached = true;
                            lazySizes.rAF(function(){
                                elem.setAttribute(config.srcAttr, candidate.u);
                                elem.setAttribute('src', candidate.u);
                            });
                        }
                    };

                    if(!supportPicture){
                        addEventListener('lazybeforesizes', polyfill);
                    } else {
                        polyfill = function(){};
                    }

                    return polyfill;

                })();

            }));


            /***/ }),

        /***/ 3945:
        /***/ ((module, exports, __webpack_require__) => {

            var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(e){if(true)module.exports=e();else { var f; }})(function(){"use strict";var we=(e,n)=>()=>(n||e((n={exports:{}}).exports,n),n.exports);var Ye=we((Ig,ru)=>{var rr=function(e){return e&&e.Math==Math&&e};ru.exports=rr(typeof globalThis=="object"&&globalThis)||rr(typeof window=="object"&&window)||rr(typeof self=="object"&&self)||rr(typeof __webpack_require__.g=="object"&&__webpack_require__.g)||function(){return this}()||Function("return this")()});var Dt=we((Lg,nu)=>{nu.exports=function(e){try{return!!e()}catch{return!0}}});var Ct=we((jg,uu)=>{var So=Dt();uu.exports=!So(function(){return Object.defineProperty({},1,{get:function(){return 7}})[1]!=7})});var nr=we((Og,su)=>{var xo=Dt();su.exports=!xo(function(){var e=function(){}.bind();return typeof e!="function"||e.hasOwnProperty("prototype")})});var Et=we((qg,iu)=>{var bo=nr(),ur=Function.prototype.call;iu.exports=bo?ur.bind(ur):function(){return ur.apply(ur,arguments)}});var cu=we(lu=>{"use strict";var au={}.propertyIsEnumerable,ou=Object.getOwnPropertyDescriptor,To=ou&&!au.call({1:2},1);lu.f=To?function(n){var t=ou(this,n);return!!t&&t.enumerable}:au});var sr=we((Rg,pu)=>{pu.exports=function(e,n){return{enumerable:!(e&1),configurable:!(e&2),writable:!(e&4),value:n}}});var at=we((Vg,mu)=>{var fu=nr(),Du=Function.prototype,Bo=Du.bind,Or=Du.call,No=fu&&Bo.bind(Or,Or);mu.exports=fu?function(e){return e&&No(e)}:function(e){return e&&function(){return Or.apply(e,arguments)}}});var ir=we((Wg,gu)=>{var du=at(),wo=du({}.toString),_o=du("".slice);gu.exports=function(e){return _o(wo(e),8,-1)}});var hu=we(($g,yu)=>{var Po=Ye(),ko=at(),Io=Dt(),Lo=ir(),qr=Po.Object,jo=ko("".split);yu.exports=Io(function(){return!qr("z").propertyIsEnumerable(0)})?function(e){return Lo(e)=="String"?jo(e,""):qr(e)}:qr});var Mr=we((Hg,vu)=>{var Oo=Ye(),qo=Oo.TypeError;vu.exports=function(e){if(e==null)throw qo("Can't call method on "+e);return e}});var ar=we((Gg,Cu)=>{var Mo=hu(),Ro=Mr();Cu.exports=function(e){return Mo(Ro(e))}});var ot=we((Jg,Eu)=>{Eu.exports=function(e){return typeof e=="function"}});var Ft=we((Ug,Fu)=>{var Vo=ot();Fu.exports=function(e){return typeof e=="object"?e!==null:Vo(e)}});var Rt=we((zg,Au)=>{var Rr=Ye(),Wo=ot(),$o=function(e){return Wo(e)?e:void 0};Au.exports=function(e,n){return arguments.length<2?$o(Rr[e]):Rr[e]&&Rr[e][n]}});var Vr=we((Xg,Su)=>{var Ho=at();Su.exports=Ho({}.isPrototypeOf)});var bu=we((Kg,xu)=>{var Go=Rt();xu.exports=Go("navigator","userAgent")||""});var ku=we((Yg,Pu)=>{var _u=Ye(),Wr=bu(),Tu=_u.process,Bu=_u.Deno,Nu=Tu&&Tu.versions||Bu&&Bu.version,wu=Nu&&Nu.v8,ft,or;wu&&(ft=wu.split("."),or=ft[0]>0&&ft[0]<4?1:+(ft[0]+ft[1]));!or&&Wr&&(ft=Wr.match(/Edge\/(\d+)/),(!ft||ft[1]>=74)&&(ft=Wr.match(/Chrome\/(\d+)/),ft&&(or=+ft[1])));Pu.exports=or});var $r=we((Qg,Lu)=>{var Iu=ku(),Jo=Dt();Lu.exports=!!Object.getOwnPropertySymbols&&!Jo(function(){var e=Symbol();return!String(e)||!(Object(e)instanceof Symbol)||!Symbol.sham&&Iu&&Iu<41})});var Hr=we((Zg,ju)=>{var Uo=$r();ju.exports=Uo&&!Symbol.sham&&typeof Symbol.iterator=="symbol"});var Gr=we((e0,Ou)=>{var zo=Ye(),Xo=Rt(),Ko=ot(),Yo=Vr(),Qo=Hr(),Zo=zo.Object;Ou.exports=Qo?function(e){return typeof e=="symbol"}:function(e){var n=Xo("Symbol");return Ko(n)&&Yo(n.prototype,Zo(e))}});var lr=we((t0,qu)=>{var el=Ye(),tl=el.String;qu.exports=function(e){try{return tl(e)}catch{return"Object"}}});var Vt=we((r0,Mu)=>{var rl=Ye(),nl=ot(),ul=lr(),sl=rl.TypeError;Mu.exports=function(e){if(nl(e))return e;throw sl(ul(e)+" is not a function")}});var cr=we((n0,Ru)=>{var il=Vt();Ru.exports=function(e,n){var t=e[n];return t==null?void 0:il(t)}});var Wu=we((u0,Vu)=>{var al=Ye(),Jr=Et(),Ur=ot(),zr=Ft(),ol=al.TypeError;Vu.exports=function(e,n){var t,s;if(n==="string"&&Ur(t=e.toString)&&!zr(s=Jr(t,e))||Ur(t=e.valueOf)&&!zr(s=Jr(t,e))||n!=="string"&&Ur(t=e.toString)&&!zr(s=Jr(t,e)))return s;throw ol("Can't convert object to primitive value")}});var Hu=we((s0,$u)=>{$u.exports=!1});var pr=we((i0,Ju)=>{var Gu=Ye(),ll=Object.defineProperty;Ju.exports=function(e,n){try{ll(Gu,e,{value:n,configurable:!0,writable:!0})}catch{Gu[e]=n}return n}});var fr=we((a0,zu)=>{var cl=Ye(),pl=pr(),Uu="__core-js_shared__",fl=cl[Uu]||pl(Uu,{});zu.exports=fl});var Xr=we((o0,Ku)=>{var Dl=Hu(),Xu=fr();(Ku.exports=function(e,n){return Xu[e]||(Xu[e]=n!==void 0?n:{})})("versions",[]).push({version:"3.22.2",mode:Dl?"pure":"global",copyright:"\xA9 2014-2022 Denis Pushkarev (zloirock.ru)",license:"https://github.com/zloirock/core-js/blob/v3.22.2/LICENSE",source:"https://github.com/zloirock/core-js"})});var Dr=we((l0,Yu)=>{var ml=Ye(),dl=Mr(),gl=ml.Object;Yu.exports=function(e){return gl(dl(e))}});var gt=we((c0,Qu)=>{var yl=at(),hl=Dr(),vl=yl({}.hasOwnProperty);Qu.exports=Object.hasOwn||function(n,t){return vl(hl(n),t)}});var Kr=we((p0,Zu)=>{var Cl=at(),El=0,Fl=Math.random(),Al=Cl(1 .toString);Zu.exports=function(e){return"Symbol("+(e===void 0?"":e)+")_"+Al(++El+Fl,36)}});var St=we((f0,us)=>{var Sl=Ye(),xl=Xr(),es=gt(),bl=Kr(),ts=$r(),ns=Hr(),Nt=xl("wks"),At=Sl.Symbol,rs=At&&At.for,Tl=ns?At:At&&At.withoutSetter||bl;us.exports=function(e){if(!es(Nt,e)||!(ts||typeof Nt[e]=="string")){var n="Symbol."+e;ts&&es(At,e)?Nt[e]=At[e]:ns&&rs?Nt[e]=rs(n):Nt[e]=Tl(n)}return Nt[e]}});var os=we((D0,as)=>{var Bl=Ye(),Nl=Et(),ss=Ft(),is=Gr(),wl=cr(),_l=Wu(),Pl=St(),kl=Bl.TypeError,Il=Pl("toPrimitive");as.exports=function(e,n){if(!ss(e)||is(e))return e;var t=wl(e,Il),s;if(t){if(n===void 0&&(n="default"),s=Nl(t,e,n),!ss(s)||is(s))return s;throw kl("Can't convert object to primitive value")}return n===void 0&&(n="number"),_l(e,n)}});var mr=we((m0,ls)=>{var Ll=os(),jl=Gr();ls.exports=function(e){var n=Ll(e,"string");return jl(n)?n:n+""}});var fs=we((d0,ps)=>{var Ol=Ye(),cs=Ft(),Yr=Ol.document,ql=cs(Yr)&&cs(Yr.createElement);ps.exports=function(e){return ql?Yr.createElement(e):{}}});var Qr=we((g0,Ds)=>{var Ml=Ct(),Rl=Dt(),Vl=fs();Ds.exports=!Ml&&!Rl(function(){return Object.defineProperty(Vl("div"),"a",{get:function(){return 7}}).a!=7})});var Zr=we(ds=>{var Wl=Ct(),$l=Et(),Hl=cu(),Gl=sr(),Jl=ar(),Ul=mr(),zl=gt(),Xl=Qr(),ms=Object.getOwnPropertyDescriptor;ds.f=Wl?ms:function(n,t){if(n=Jl(n),t=Ul(t),Xl)try{return ms(n,t)}catch{}if(zl(n,t))return Gl(!$l(Hl.f,n,t),n[t])}});var ys=we((h0,gs)=>{var Kl=Ct(),Yl=Dt();gs.exports=Kl&&Yl(function(){return Object.defineProperty(function(){},"prototype",{value:42,writable:!1}).prototype!=42})});var wt=we((v0,vs)=>{var hs=Ye(),Ql=Ft(),Zl=hs.String,ec=hs.TypeError;vs.exports=function(e){if(Ql(e))return e;throw ec(Zl(e)+" is not an object")}});var gr=we(Es=>{var tc=Ye(),rc=Ct(),nc=Qr(),uc=ys(),dr=wt(),Cs=mr(),sc=tc.TypeError,en=Object.defineProperty,ic=Object.getOwnPropertyDescriptor,tn="enumerable",rn="configurable",nn="writable";Es.f=rc?uc?function(n,t,s){if(dr(n),t=Cs(t),dr(s),typeof n=="function"&&t==="prototype"&&"value"in s&&nn in s&&!s[nn]){var a=ic(n,t);a&&a[nn]&&(n[t]=s.value,s={configurable:rn in s?s[rn]:a[rn],enumerable:tn in s?s[tn]:a[tn],writable:!1})}return en(n,t,s)}:en:function(n,t,s){if(dr(n),t=Cs(t),dr(s),nc)try{return en(n,t,s)}catch{}if("get"in s||"set"in s)throw sc("Accessors not supported");return"value"in s&&(n[t]=s.value),n}});var yr=we((E0,Fs)=>{var ac=Ct(),oc=gr(),lc=sr();Fs.exports=ac?function(e,n,t){return oc.f(e,n,lc(1,t))}:function(e,n,t){return e[n]=t,e}});var hr=we((F0,As)=>{var cc=at(),pc=ot(),un=fr(),fc=cc(Function.toString);pc(un.inspectSource)||(un.inspectSource=function(e){return fc(e)});As.exports=un.inspectSource});var bs=we((A0,xs)=>{var Dc=Ye(),mc=ot(),dc=hr(),Ss=Dc.WeakMap;xs.exports=mc(Ss)&&/native code/.test(dc(Ss))});var Ns=we((S0,Bs)=>{var gc=Xr(),yc=Kr(),Ts=gc("keys");Bs.exports=function(e){return Ts[e]||(Ts[e]=yc(e))}});var sn=we((x0,ws)=>{ws.exports={}});var js=we((b0,Ls)=>{var hc=bs(),Is=Ye(),an=at(),vc=Ft(),Cc=yr(),on=gt(),ln=fr(),Ec=Ns(),Fc=sn(),_s="Object already initialized",pn=Is.TypeError,Ac=Is.WeakMap,vr,Wt,Cr,Sc=function(e){return Cr(e)?Wt(e):vr(e,{})},xc=function(e){return function(n){var t;if(!vc(n)||(t=Wt(n)).type!==e)throw pn("Incompatible receiver, "+e+" required");return t}};hc||ln.state?(yt=ln.state||(ln.state=new Ac),Ps=an(yt.get),cn=an(yt.has),ks=an(yt.set),vr=function(e,n){if(cn(yt,e))throw new pn(_s);return n.facade=e,ks(yt,e,n),n},Wt=function(e){return Ps(yt,e)||{}},Cr=function(e){return cn(yt,e)}):(xt=Ec("state"),Fc[xt]=!0,vr=function(e,n){if(on(e,xt))throw new pn(_s);return n.facade=e,Cc(e,xt,n),n},Wt=function(e){return on(e,xt)?e[xt]:{}},Cr=function(e){return on(e,xt)});var yt,Ps,cn,ks,xt;Ls.exports={set:vr,get:Wt,has:Cr,enforce:Sc,getterFor:xc}});var Ms=we((T0,qs)=>{var fn=Ct(),bc=gt(),Os=Function.prototype,Tc=fn&&Object.getOwnPropertyDescriptor,Dn=bc(Os,"name"),Bc=Dn&&function(){}.name==="something",Nc=Dn&&(!fn||fn&&Tc(Os,"name").configurable);qs.exports={EXISTS:Dn,PROPER:Bc,CONFIGURABLE:Nc}});var Hs=we((B0,$s)=>{var wc=Ye(),Rs=ot(),_c=gt(),Vs=yr(),Pc=pr(),kc=hr(),Ws=js(),Ic=Ms().CONFIGURABLE,Lc=Ws.get,jc=Ws.enforce,Oc=String(String).split("String");($s.exports=function(e,n,t,s){var a=s?!!s.unsafe:!1,r=s?!!s.enumerable:!1,u=s?!!s.noTargetGet:!1,i=s&&s.name!==void 0?s.name:n,o;if(Rs(t)&&(String(i).slice(0,7)==="Symbol("&&(i="["+String(i).replace(/^Symbol\(([^)]*)\)/,"$1")+"]"),(!_c(t,"name")||Ic&&t.name!==i)&&Vs(t,"name",i),o=jc(t),o.source||(o.source=Oc.join(typeof i=="string"?i:""))),e===wc){r?e[n]=t:Pc(n,t);return}else a?!u&&e[n]&&(r=!0):delete e[n];r?e[n]=t:Vs(e,n,t)})(Function.prototype,"toString",function(){return Rs(this)&&Lc(this).source||kc(this)})});var Er=we((N0,Gs)=>{var qc=Math.ceil,Mc=Math.floor;Gs.exports=function(e){var n=+e;return n!==n||n===0?0:(n>0?Mc:qc)(n)}});var Us=we((w0,Js)=>{var Rc=Er(),Vc=Math.max,Wc=Math.min;Js.exports=function(e,n){var t=Rc(e);return t<0?Vc(t+n,0):Wc(t,n)}});var Xs=we((_0,zs)=>{var $c=Er(),Hc=Math.min;zs.exports=function(e){return e>0?Hc($c(e),9007199254740991):0}});var _t=we((P0,Ks)=>{var Gc=Xs();Ks.exports=function(e){return Gc(e.length)}});var Zs=we((k0,Qs)=>{var Jc=ar(),Uc=Us(),zc=_t(),Ys=function(e){return function(n,t,s){var a=Jc(n),r=zc(a),u=Uc(s,r),i;if(e&&t!=t){for(;r>u;)if(i=a[u++],i!=i)return!0}else for(;r>u;u++)if((e||u in a)&&a[u]===t)return e||u||0;return!e&&-1}};Qs.exports={includes:Ys(!0),indexOf:Ys(!1)}});var ri=we((I0,ti)=>{var Xc=at(),mn=gt(),Kc=ar(),Yc=Zs().indexOf,Qc=sn(),ei=Xc([].push);ti.exports=function(e,n){var t=Kc(e),s=0,a=[],r;for(r in t)!mn(Qc,r)&&mn(t,r)&&ei(a,r);for(;n.length>s;)mn(t,r=n[s++])&&(~Yc(a,r)||ei(a,r));return a}});var ui=we((L0,ni)=>{ni.exports=["constructor","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","toLocaleString","toString","valueOf"]});var ii=we(si=>{var Zc=ri(),ep=ui(),tp=ep.concat("length","prototype");si.f=Object.getOwnPropertyNames||function(n){return Zc(n,tp)}});var oi=we(ai=>{ai.f=Object.getOwnPropertySymbols});var ci=we((q0,li)=>{var rp=Rt(),np=at(),up=ii(),sp=oi(),ip=wt(),ap=np([].concat);li.exports=rp("Reflect","ownKeys")||function(n){var t=up.f(ip(n)),s=sp.f;return s?ap(t,s(n)):t}});var Di=we((M0,fi)=>{var pi=gt(),op=ci(),lp=Zr(),cp=gr();fi.exports=function(e,n,t){for(var s=op(n),a=cp.f,r=lp.f,u=0;u<s.length;u++){var i=s[u];!pi(e,i)&&!(t&&pi(t,i))&&a(e,i,r(n,i))}}});var di=we((R0,mi)=>{var pp=Dt(),fp=ot(),Dp=/#|\.prototype\./,$t=function(e,n){var t=dp[mp(e)];return t==yp?!0:t==gp?!1:fp(n)?pp(n):!!n},mp=$t.normalize=function(e){return String(e).replace(Dp,".").toLowerCase()},dp=$t.data={},gp=$t.NATIVE="N",yp=$t.POLYFILL="P";mi.exports=$t});var Ht=we((V0,gi)=>{var dn=Ye(),hp=Zr().f,vp=yr(),Cp=Hs(),Ep=pr(),Fp=Di(),Ap=di();gi.exports=function(e,n){var t=e.target,s=e.global,a=e.stat,r,u,i,o,c,v;if(s?u=dn:a?u=dn[t]||Ep(t,{}):u=(dn[t]||{}).prototype,u)for(i in n){if(c=n[i],e.noTargetGet?(v=hp(u,i),o=v&&v.value):o=u[i],r=Ap(s?i:t+(a?".":"#")+i,e.forced),!r&&o!==void 0){if(typeof c==typeof o)continue;Fp(c,o)}(e.sham||o&&o.sham)&&vp(c,"sham",!0),Cp(u,i,c,e)}}});var gn=we((W0,yi)=>{var Sp=ir();yi.exports=Array.isArray||function(n){return Sp(n)=="Array"}});var yn=we(($0,vi)=>{var hi=at(),xp=Vt(),bp=nr(),Tp=hi(hi.bind);vi.exports=function(e,n){return xp(e),n===void 0?e:bp?Tp(e,n):function(){return e.apply(n,arguments)}}});var hn=we((H0,Ei)=>{"use strict";var Bp=Ye(),Np=gn(),wp=_t(),_p=yn(),Pp=Bp.TypeError,Ci=function(e,n,t,s,a,r,u,i){for(var o=a,c=0,v=u?_p(u,i):!1,m,d;c<s;){if(c in t){if(m=v?v(t[c],c,n):t[c],r>0&&Np(m))d=wp(m),o=Ci(e,n,m,d,o,r-1)-1;else{if(o>=9007199254740991)throw Pp("Exceed the acceptable array length");e[o]=m}o++}c++}return o};Ei.exports=Ci});var Si=we((G0,Ai)=>{var kp=St(),Ip=kp("toStringTag"),Fi={};Fi[Ip]="z";Ai.exports=String(Fi)==="[object z]"});var vn=we((J0,xi)=>{var Lp=Ye(),jp=Si(),Op=ot(),Fr=ir(),qp=St(),Mp=qp("toStringTag"),Rp=Lp.Object,Vp=Fr(function(){return arguments}())=="Arguments",Wp=function(e,n){try{return e[n]}catch{}};xi.exports=jp?Fr:function(e){var n,t,s;return e===void 0?"Undefined":e===null?"Null":typeof(t=Wp(n=Rp(e),Mp))=="string"?t:Vp?Fr(n):(s=Fr(n))=="Object"&&Op(n.callee)?"Arguments":s}});var _i=we((U0,wi)=>{var $p=at(),Hp=Dt(),bi=ot(),Gp=vn(),Jp=Rt(),Up=hr(),Ti=function(){},zp=[],Bi=Jp("Reflect","construct"),Cn=/^\s*(?:class|function)\b/,Xp=$p(Cn.exec),Kp=!Cn.exec(Ti),Gt=function(n){if(!bi(n))return!1;try{return Bi(Ti,zp,n),!0}catch{return!1}},Ni=function(n){if(!bi(n))return!1;switch(Gp(n)){case"AsyncFunction":case"GeneratorFunction":case"AsyncGeneratorFunction":return!1}try{return Kp||!!Xp(Cn,Up(n))}catch{return!0}};Ni.sham=!0;wi.exports=!Bi||Hp(function(){var e;return Gt(Gt.call)||!Gt(Object)||!Gt(function(){e=!0})||e})?Ni:Gt});var Li=we((z0,Ii)=>{var Yp=Ye(),Pi=gn(),Qp=_i(),Zp=Ft(),ef=St(),tf=ef("species"),ki=Yp.Array;Ii.exports=function(e){var n;return Pi(e)&&(n=e.constructor,Qp(n)&&(n===ki||Pi(n.prototype))?n=void 0:Zp(n)&&(n=n[tf],n===null&&(n=void 0))),n===void 0?ki:n}});var En=we((X0,ji)=>{var rf=Li();ji.exports=function(e,n){return new(rf(e))(n===0?0:n)}});var Oi=we(()=>{"use strict";var nf=Ht(),uf=hn(),sf=Vt(),af=Dr(),of=_t(),lf=En();nf({target:"Array",proto:!0},{flatMap:function(n){var t=af(this),s=of(t),a;return sf(n),a=lf(t,0),a.length=uf(a,t,t,s,0,1,n,arguments.length>1?arguments[1]:void 0),a}})});var Fn=we((Q0,qi)=>{qi.exports={}});var Ri=we((Z0,Mi)=>{var cf=St(),pf=Fn(),ff=cf("iterator"),Df=Array.prototype;Mi.exports=function(e){return e!==void 0&&(pf.Array===e||Df[ff]===e)}});var An=we((ey,Wi)=>{var mf=vn(),Vi=cr(),df=Fn(),gf=St(),yf=gf("iterator");Wi.exports=function(e){if(e!=null)return Vi(e,yf)||Vi(e,"@@iterator")||df[mf(e)]}});var Hi=we((ty,$i)=>{var hf=Ye(),vf=Et(),Cf=Vt(),Ef=wt(),Ff=lr(),Af=An(),Sf=hf.TypeError;$i.exports=function(e,n){var t=arguments.length<2?Af(e):n;if(Cf(t))return Ef(vf(t,e));throw Sf(Ff(e)+" is not iterable")}});var Ui=we((ry,Ji)=>{var xf=Et(),Gi=wt(),bf=cr();Ji.exports=function(e,n,t){var s,a;Gi(e);try{if(s=bf(e,"return"),!s){if(n==="throw")throw t;return t}s=xf(s,e)}catch(r){a=!0,s=r}if(n==="throw")throw t;if(a)throw s;return Gi(s),t}});var Qi=we((ny,Yi)=>{var Tf=Ye(),Bf=yn(),Nf=Et(),wf=wt(),_f=lr(),Pf=Ri(),kf=_t(),zi=Vr(),If=Hi(),Lf=An(),Xi=Ui(),jf=Tf.TypeError,Ar=function(e,n){this.stopped=e,this.result=n},Ki=Ar.prototype;Yi.exports=function(e,n,t){var s=t&&t.that,a=!!(t&&t.AS_ENTRIES),r=!!(t&&t.IS_ITERATOR),u=!!(t&&t.INTERRUPTED),i=Bf(n,s),o,c,v,m,d,p,f,h=function(T){return o&&Xi(o,"normal",T),new Ar(!0,T)},w=function(T){return a?(wf(T),u?i(T[0],T[1],h):i(T[0],T[1])):u?i(T,h):i(T)};if(r)o=e;else{if(c=Lf(e),!c)throw jf(_f(e)+" is not iterable");if(Pf(c)){for(v=0,m=kf(e);m>v;v++)if(d=w(e[v]),d&&zi(Ki,d))return d;return new Ar(!1)}o=If(e,c)}for(p=o.next;!(f=Nf(p,o)).done;){try{d=w(f.value)}catch(T){Xi(o,"throw",T)}if(typeof d=="object"&&d&&zi(Ki,d))return d}return new Ar(!1)}});var ea=we((uy,Zi)=>{"use strict";var Of=mr(),qf=gr(),Mf=sr();Zi.exports=function(e,n,t){var s=Of(n);s in e?qf.f(e,s,Mf(0,t)):e[s]=t}});var ta=we(()=>{var Rf=Ht(),Vf=Qi(),Wf=ea();Rf({target:"Object",stat:!0},{fromEntries:function(n){var t={};return Vf(n,function(s,a){Wf(t,s,a)},{AS_ENTRIES:!0}),t}})});var ra=we(()=>{var $f=Ht(),Hf=Ye();$f({global:!0},{globalThis:Hf})});var na=we(()=>{ra()});var ua=we(()=>{"use strict";var Gf=Ht(),Jf=hn(),Uf=Dr(),zf=_t(),Xf=Er(),Kf=En();Gf({target:"Array",proto:!0},{flat:function(){var n=arguments.length?arguments[0]:void 0,t=Uf(this),s=zf(t),a=Kf(t,0);return a.length=Jf(a,t,t,s,0,n===void 0?1:Xf(n)),a}})});var Pg=we((my,Co)=>{var Yf=["cliName","cliCategory","cliDescription"],Qf=["_"],Zf=["languageId"],sa,ia,aa,oa,la,ca;function kn(e,n){if(e==null)return{};var t=eD(e,n),s,a;if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);for(a=0;a<r.length;a++)s=r[a],!(n.indexOf(s)>=0)&&(!Object.prototype.propertyIsEnumerable.call(e,s)||(t[s]=e[s]))}return t}function eD(e,n){if(e==null)return{};var t={},s=Object.keys(e),a,r;for(r=0;r<s.length;r++)a=s[r],!(n.indexOf(a)>=0)&&(t[a]=e[a]);return t}Oi();ta();na();ua();function Pt(e,n){return n||(n=e.slice(0)),Object.freeze(Object.defineProperties(e,{raw:{value:Object.freeze(n)}}))}var tD=Object.create,Br=Object.defineProperty,rD=Object.getOwnPropertyDescriptor,In=Object.getOwnPropertyNames,nD=Object.getPrototypeOf,uD=Object.prototype.hasOwnProperty,mt=(e,n)=>function(){return e&&(n=(0,e[In(e)[0]])(e=0)),n},Z=(e,n)=>function(){return n||(0,e[In(e)[0]])((n={exports:{}}).exports,n),n.exports},Ut=(e,n)=>{for(var t in n)Br(e,t,{get:n[t],enumerable:!0})},ga=(e,n,t,s)=>{if(n&&typeof n=="object"||typeof n=="function")for(let a of In(n))!uD.call(e,a)&&a!==t&&Br(e,a,{get:()=>n[a],enumerable:!(s=rD(n,a))||s.enumerable});return e},sD=(e,n,t)=>(t=e!=null?tD(nD(e)):{},ga(n||!e||!e.__esModule?Br(t,"default",{value:e,enumerable:!0}):t,e)),lt=e=>ga(Br({},"__esModule",{value:!0}),e),pa,fa,Tt,re=mt({"<define:process>"(){pa={},fa=[],Tt={env:pa,argv:fa}}}),ya=Z({"package.json"(e,n){n.exports={version:"2.7.1"}}}),iD=Z({"node_modules/diff/lib/diff/base.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0}),e.default=n;function n(){}n.prototype={diff:function(r,u){var i=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{},o=i.callback;typeof i=="function"&&(o=i,i={}),this.options=i;var c=this;function v(S){return o?(setTimeout(function(){o(void 0,S)},0),!0):S}r=this.castInput(r),u=this.castInput(u),r=this.removeEmpty(this.tokenize(r)),u=this.removeEmpty(this.tokenize(u));var m=u.length,d=r.length,p=1,f=m+d,h=[{newPos:-1,components:[]}],w=this.extractCommon(h[0],u,r,0);if(h[0].newPos+1>=m&&w+1>=d)return v([{value:this.join(u),count:u.length}]);function T(){for(var S=-1*p;S<=p;S+=2){var B=void 0,I=h[S-1],k=h[S+1],P=(k?k.newPos:0)-S;I&&(h[S-1]=void 0);var C=I&&I.newPos+1<m,D=k&&0<=P&&P<d;if(!C&&!D){h[S]=void 0;continue}if(!C||D&&I.newPos<k.newPos?(B=s(k),c.pushComponent(B.components,void 0,!0)):(B=I,B.newPos++,c.pushComponent(B.components,!0,void 0)),P=c.extractCommon(B,u,r,S),B.newPos+1>=m&&P+1>=d)return v(t(c,B.components,u,r,c.useLongestToken));h[S]=B}p++}if(o)(function S(){setTimeout(function(){if(p>f)return o();T()||S()},0)})();else for(;p<=f;){var A=T();if(A)return A}},pushComponent:function(r,u,i){var o=r[r.length-1];o&&o.added===u&&o.removed===i?r[r.length-1]={count:o.count+1,added:u,removed:i}:r.push({count:1,added:u,removed:i})},extractCommon:function(r,u,i,o){for(var c=u.length,v=i.length,m=r.newPos,d=m-o,p=0;m+1<c&&d+1<v&&this.equals(u[m+1],i[d+1]);)m++,d++,p++;return p&&r.components.push({count:p}),r.newPos=m,d},equals:function(r,u){return this.options.comparator?this.options.comparator(r,u):r===u||this.options.ignoreCase&&r.toLowerCase()===u.toLowerCase()},removeEmpty:function(r){for(var u=[],i=0;i<r.length;i++)r[i]&&u.push(r[i]);return u},castInput:function(r){return r},tokenize:function(r){return r.split("")},join:function(r){return r.join("")}};function t(a,r,u,i,o){for(var c=0,v=r.length,m=0,d=0;c<v;c++){var p=r[c];if(p.removed){if(p.value=a.join(i.slice(d,d+p.count)),d+=p.count,c&&r[c-1].added){var h=r[c-1];r[c-1]=r[c],r[c]=h}}else{if(!p.added&&o){var f=u.slice(m,m+p.count);f=f.map(function(T,A){var S=i[d+A];return S.length>T.length?S:T}),p.value=a.join(f)}else p.value=a.join(u.slice(m,m+p.count));m+=p.count,p.added||(d+=p.count)}}var w=r[v-1];return v>1&&typeof w.value=="string"&&(w.added||w.removed)&&a.equals("",w.value)&&(r[v-2].value+=w.value,r.pop()),r}function s(a){return{newPos:a.newPos,components:a.components.slice(0)}}}}),aD=Z({"node_modules/diff/lib/diff/array.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0}),e.diffArrays=a,e.arrayDiff=void 0;var n=t(iD());function t(r){return r&&r.__esModule?r:{default:r}}var s=new n.default;e.arrayDiff=s,s.tokenize=function(r){return r.slice()},s.join=s.removeEmpty=function(r){return r};function a(r,u,i){return s.diff(r,u,i)}}}),Ln=Z({"src/document/doc-builders.js"(e,n){"use strict";re();function t(F){return{type:"concat",parts:F}}function s(F){return{type:"indent",contents:F}}function a(F,l){return{type:"align",contents:l,n:F}}function r(F){let l=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};return{type:"group",id:l.id,contents:F,break:Boolean(l.shouldBreak),expandedStates:l.expandedStates}}function u(F){return a(Number.NEGATIVE_INFINITY,F)}function i(F){return a({type:"root"},F)}function o(F){return a(-1,F)}function c(F,l){return r(F[0],Object.assign(Object.assign({},l),{},{expandedStates:F}))}function v(F){return{type:"fill",parts:F}}function m(F,l){let E=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{};return{type:"if-break",breakContents:F,flatContents:l,groupId:E.groupId}}function d(F,l){return{type:"indent-if-break",contents:F,groupId:l.groupId,negate:l.negate}}function p(F){return{type:"line-suffix",contents:F}}var f={type:"line-suffix-boundary"},h={type:"break-parent"},w={type:"trim"},T={type:"line",hard:!0},A={type:"line",hard:!0,literal:!0},S={type:"line"},B={type:"line",soft:!0},I=t([T,h]),k=t([A,h]),P={type:"cursor",placeholder:Symbol("cursor")};function C(F,l){let E=[];for(let y=0;y<l.length;y++)y!==0&&E.push(F),E.push(l[y]);return t(E)}function D(F,l,E){let y=F;if(l>0){for(let N=0;N<Math.floor(l/E);++N)y=s(y);y=a(l%E,y),y=a(Number.NEGATIVE_INFINITY,y)}return y}function g(F,l){return{type:"label",label:F,contents:l}}n.exports={concat:t,join:C,line:S,softline:B,hardline:I,literalline:k,group:r,conditionalGroup:c,fill:v,lineSuffix:p,lineSuffixBoundary:f,cursor:P,breakParent:h,ifBreak:m,trim:w,indent:s,indentIfBreak:d,align:a,addAlignmentToDoc:D,markAsRoot:i,dedentToRoot:u,dedent:o,hardlineWithoutBreakParent:T,literallineWithoutBreakParent:A,label:g}}}),jn=Z({"src/common/end-of-line.js"(e,n){"use strict";re();function t(u){let i=u.indexOf("\r");return i>=0?u.charAt(i+1)===`
`?"crlf":"cr":"lf"}function s(u){switch(u){case"cr":return"\r";case"crlf":return`\r
`;default:return`
`}}function a(u,i){let o;switch(i){case`
`:o=/\n/g;break;case"\r":o=/\r/g;break;case`\r
`:o=/\r\n/g;break;default:throw new Error('Unexpected "eol" '.concat(JSON.stringify(i),"."))}let c=u.match(o);return c?c.length:0}function r(u){return u.replace(/\r\n?/g,`
`)}n.exports={guessEndOfLine:t,convertEndOfLineToChars:s,countEndOfLineChars:a,normalizeEndOfLine:r}}}),it=Z({"src/utils/get-last.js"(e,n){"use strict";re();var t=s=>s[s.length-1];n.exports=t}});function oD(){let{onlyFirst:e=!1}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{},n=["[\\u001B\\u009B][[\\]()#;?]*(?:(?:(?:(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]+)*|[a-zA-Z\\d]+(?:;[-a-zA-Z\\d\\/#&.:=?%@~_]*)*)?\\u0007)","(?:(?:\\d{1,4}(?:;\\d{0,4})*)?[\\dA-PR-TZcf-ntqry=><~]))"].join("|");return new RegExp(n,e?void 0:"g")}var lD=mt({"node_modules/strip-ansi/node_modules/ansi-regex/index.js"(){re()}});function cD(e){if(typeof e!="string")throw new TypeError("Expected a `string`, got `".concat(typeof e,"`"));return e.replace(oD(),"")}var pD=mt({"node_modules/strip-ansi/index.js"(){re(),lD()}});function fD(e){return Number.isInteger(e)?e>=4352&&(e<=4447||e===9001||e===9002||11904<=e&&e<=12871&&e!==12351||12880<=e&&e<=19903||19968<=e&&e<=42182||43360<=e&&e<=43388||44032<=e&&e<=55203||63744<=e&&e<=64255||65040<=e&&e<=65049||65072<=e&&e<=65131||65281<=e&&e<=65376||65504<=e&&e<=65510||110592<=e&&e<=110593||127488<=e&&e<=127569||131072<=e&&e<=262141):!1}var DD=mt({"node_modules/is-fullwidth-code-point/index.js"(){re()}}),mD=Z({"node_modules/emoji-regex/index.js"(e,n){"use strict";re(),n.exports=function(){return/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g}}}),ha={};Ut(ha,{default:()=>dD});function dD(e){if(typeof e!="string"||e.length===0||(e=cD(e),e.length===0))return 0;e=e.replace((0,va.default)(),"  ");let n=0;for(let t=0;t<e.length;t++){let s=e.codePointAt(t);s<=31||s>=127&&s<=159||s>=768&&s<=879||(s>65535&&t++,n+=fD(s)?2:1)}return n}var va,gD=mt({"node_modules/string-width/index.js"(){re(),pD(),DD(),va=sD(mD())}}),Ca=Z({"src/utils/get-string-width.js"(e,n){"use strict";re();var t=(gD(),lt(ha)).default,s=/[^\x20-\x7F]/;function a(r){return r?s.test(r)?t(r):r.length:0}n.exports=a}}),On=Z({"src/document/doc-utils.js"(e,n){"use strict";re();var t=it(),{literalline:s,join:a}=Ln(),r=l=>Array.isArray(l)||l&&l.type==="concat",u=l=>{if(Array.isArray(l))return l;if(l.type!=="concat"&&l.type!=="fill")throw new Error("Expect doc type to be `concat` or `fill`.");return l.parts},i={};function o(l,E,y,N){let x=[l];for(;x.length>0;){let b=x.pop();if(b===i){y(x.pop());continue}if(y&&x.push(b,i),!E||E(b)!==!1)if(r(b)||b.type==="fill"){let L=u(b);for(let M=L.length,j=M-1;j>=0;--j)x.push(L[j])}else if(b.type==="if-break")b.flatContents&&x.push(b.flatContents),b.breakContents&&x.push(b.breakContents);else if(b.type==="group"&&b.expandedStates)if(N)for(let L=b.expandedStates.length,M=L-1;M>=0;--M)x.push(b.expandedStates[M]);else x.push(b.contents);else b.contents&&x.push(b.contents)}}function c(l,E){let y=new Map;return N(l);function N(b){if(y.has(b))return y.get(b);let L=x(b);return y.set(b,L),L}function x(b){if(Array.isArray(b))return E(b.map(N));if(b.type==="concat"||b.type==="fill"){let L=b.parts.map(N);return E(Object.assign(Object.assign({},b),{},{parts:L}))}if(b.type==="if-break"){let L=b.breakContents&&N(b.breakContents),M=b.flatContents&&N(b.flatContents);return E(Object.assign(Object.assign({},b),{},{breakContents:L,flatContents:M}))}if(b.type==="group"&&b.expandedStates){let L=b.expandedStates.map(N),M=L[0];return E(Object.assign(Object.assign({},b),{},{contents:M,expandedStates:L}))}if(b.contents){let L=N(b.contents);return E(Object.assign(Object.assign({},b),{},{contents:L}))}return E(b)}}function v(l,E,y){let N=y,x=!1;function b(L){let M=E(L);if(M!==void 0&&(x=!0,N=M),x)return!1}return o(l,b),N}function m(l){if(l.type==="group"&&l.break||l.type==="line"&&l.hard||l.type==="break-parent")return!0}function d(l){return v(l,m,!1)}function p(l){if(l.length>0){let E=t(l);!E.expandedStates&&!E.break&&(E.break="propagated")}return null}function f(l){let E=new Set,y=[];function N(b){if(b.type==="break-parent"&&p(y),b.type==="group"){if(y.push(b),E.has(b))return!1;E.add(b)}}function x(b){b.type==="group"&&y.pop().break&&p(y)}o(l,N,x,!0)}function h(l){return l.type==="line"&&!l.hard?l.soft?"":" ":l.type==="if-break"?l.flatContents||"":l}function w(l){return c(l,h)}var T=(l,E)=>l&&l.type==="line"&&l.hard&&E&&E.type==="break-parent";function A(l){if(!l)return l;if(r(l)||l.type==="fill"){let E=u(l);for(;E.length>1&&T(...E.slice(-2));)E.length-=2;if(E.length>0){let y=A(t(E));E[E.length-1]=y}return Array.isArray(l)?E:Object.assign(Object.assign({},l),{},{parts:E})}switch(l.type){case"align":case"indent":case"indent-if-break":case"group":case"line-suffix":case"label":{let E=A(l.contents);return Object.assign(Object.assign({},l),{},{contents:E})}case"if-break":{let E=A(l.breakContents),y=A(l.flatContents);return Object.assign(Object.assign({},l),{},{breakContents:E,flatContents:y})}}return l}function S(l){return A(I(l))}function B(l){switch(l.type){case"fill":if(l.parts.every(y=>y===""))return"";break;case"group":if(!l.contents&&!l.id&&!l.break&&!l.expandedStates)return"";if(l.contents.type==="group"&&l.contents.id===l.id&&l.contents.break===l.break&&l.contents.expandedStates===l.expandedStates)return l.contents;break;case"align":case"indent":case"indent-if-break":case"line-suffix":if(!l.contents)return"";break;case"if-break":if(!l.flatContents&&!l.breakContents)return"";break}if(!r(l))return l;let E=[];for(let y of u(l)){if(!y)continue;let[N,...x]=r(y)?u(y):[y];typeof N=="string"&&typeof t(E)=="string"?E[E.length-1]+=N:E.push(N),E.push(...x)}return E.length===0?"":E.length===1?E[0]:Array.isArray(l)?E:Object.assign(Object.assign({},l),{},{parts:E})}function I(l){return c(l,E=>B(E))}function k(l){let E=[],y=l.filter(Boolean);for(;y.length>0;){let N=y.shift();if(!!N){if(r(N)){y.unshift(...u(N));continue}if(E.length>0&&typeof t(E)=="string"&&typeof N=="string"){E[E.length-1]+=N;continue}E.push(N)}}return E}function P(l){return c(l,E=>Array.isArray(E)?k(E):E.parts?Object.assign(Object.assign({},E),{},{parts:k(E.parts)}):E)}function C(l){return c(l,E=>typeof E=="string"&&E.includes(`
`)?D(E):E)}function D(l){let E=arguments.length>1&&arguments[1]!==void 0?arguments[1]:s;return a(E,l.split(`
`)).parts}function g(l){if(l.type==="line")return!0}function F(l){return v(l,g,!1)}n.exports={isConcat:r,getDocParts:u,willBreak:d,traverseDoc:o,findInDoc:v,mapDoc:c,propagateBreaks:f,removeLines:w,stripTrailingHardline:S,normalizeParts:k,normalizeDoc:P,cleanDoc:I,replaceTextEndOfLine:D,replaceEndOfLine:C,canBreak:F}}}),yD=Z({"src/document/doc-printer.js"(e,n){"use strict";re();var{convertEndOfLineToChars:t}=jn(),s=it(),a=Ca(),{fill:r,cursor:u,indent:i}=Ln(),{isConcat:o,getDocParts:c}=On(),v,m=1,d=2;function p(){return{value:"",length:0,queue:[]}}function f(B,I){return w(B,{type:"indent"},I)}function h(B,I,k){return I===Number.NEGATIVE_INFINITY?B.root||p():I<0?w(B,{type:"dedent"},k):I?I.type==="root"?Object.assign(Object.assign({},B),{},{root:B}):w(B,{type:typeof I=="string"?"stringAlign":"numberAlign",n:I},k):B}function w(B,I,k){let P=I.type==="dedent"?B.queue.slice(0,-1):[...B.queue,I],C="",D=0,g=0,F=0;for(let L of P)switch(L.type){case"indent":y(),k.useTabs?l(1):E(k.tabWidth);break;case"stringAlign":y(),C+=L.n,D+=L.n.length;break;case"numberAlign":g+=1,F+=L.n;break;default:throw new Error("Unexpected type '".concat(L.type,"'"))}return x(),Object.assign(Object.assign({},B),{},{value:C,length:D,queue:P});function l(L){C+="	".repeat(L),D+=k.tabWidth*L}function E(L){C+=" ".repeat(L),D+=L}function y(){k.useTabs?N():x()}function N(){g>0&&l(g),b()}function x(){F>0&&E(F),b()}function b(){g=0,F=0}}function T(B){if(B.length===0)return 0;let I=0;for(;B.length>0&&typeof s(B)=="string"&&/^[\t ]*$/.test(s(B));)I+=B.pop().length;if(B.length>0&&typeof s(B)=="string"){let k=s(B).replace(/[\t ]*$/,"");I+=s(B).length-k.length,B[B.length-1]=k}return I}function A(B,I,k,P,C,D){let g=I.length,F=[B],l=[];for(;k>=0;){if(F.length===0){if(g===0)return!0;F.push(I[g-1]),g--;continue}let[E,y,N]=F.pop();if(typeof N=="string")l.push(N),k-=a(N);else if(o(N)){let x=c(N);for(let b=x.length-1;b>=0;b--)F.push([E,y,x[b]])}else switch(N.type){case"indent":F.push([f(E,P),y,N.contents]);break;case"align":F.push([h(E,N.n,P),y,N.contents]);break;case"trim":k+=T(l);break;case"group":{if(D&&N.break)return!1;let x=N.break?m:y;F.push([E,x,N.expandedStates&&x===m?s(N.expandedStates):N.contents]),N.id&&(v[N.id]=x);break}case"fill":for(let x=N.parts.length-1;x>=0;x--)F.push([E,y,N.parts[x]]);break;case"if-break":case"indent-if-break":{let x=N.groupId?v[N.groupId]:y;if(x===m){let b=N.type==="if-break"?N.breakContents:N.negate?N.contents:i(N.contents);b&&F.push([E,y,b])}if(x===d){let b=N.type==="if-break"?N.flatContents:N.negate?i(N.contents):N.contents;b&&F.push([E,y,b])}break}case"line":switch(y){case d:if(!N.hard){N.soft||(l.push(" "),k-=1);break}return!0;case m:return!0}break;case"line-suffix":C=!0;break;case"line-suffix-boundary":if(C)return!1;break;case"label":F.push([E,y,N.contents]);break}}return!1}function S(B,I){v={};let k=I.printWidth,P=t(I.endOfLine),C=0,D=[[p(),m,B]],g=[],F=!1,l=[];for(;D.length>0;){let[y,N,x]=D.pop();if(typeof x=="string"){let b=P!==`
`?x.replace(/\n/g,P):x;g.push(b),C+=a(b)}else if(o(x)){let b=c(x);for(let L=b.length-1;L>=0;L--)D.push([y,N,b[L]])}else switch(x.type){case"cursor":g.push(u.placeholder);break;case"indent":D.push([f(y,I),N,x.contents]);break;case"align":D.push([h(y,x.n,I),N,x.contents]);break;case"trim":C-=T(g);break;case"group":switch(N){case d:if(!F){D.push([y,x.break?m:d,x.contents]);break}case m:{F=!1;let b=[y,d,x.contents],L=k-C,M=l.length>0;if(!x.break&&A(b,D,L,I,M))D.push(b);else if(x.expandedStates){let j=s(x.expandedStates);if(x.break){D.push([y,m,j]);break}else for(let $=1;$<x.expandedStates.length+1;$++)if($>=x.expandedStates.length){D.push([y,m,j]);break}else{let V=x.expandedStates[$],q=[y,d,V];if(A(q,D,L,I,M)){D.push(q);break}}}else D.push([y,m,x.contents]);break}}x.id&&(v[x.id]=s(D)[1]);break;case"fill":{let b=k-C,{parts:L}=x;if(L.length===0)break;let[M,j]=L,$=[y,d,M],V=[y,m,M],q=A($,[],b,I,l.length>0,!0);if(L.length===1){q?D.push($):D.push(V);break}let Y=[y,d,j],H=[y,m,j];if(L.length===2){q?D.push(Y,$):D.push(H,V);break}L.splice(0,2);let R=[y,N,r(L)],Q=L[0];A([y,d,[M,j,Q]],[],b,I,l.length>0,!0)?D.push(R,Y,$):q?D.push(R,H,$):D.push(R,H,V);break}case"if-break":case"indent-if-break":{let b=x.groupId?v[x.groupId]:N;if(b===m){let L=x.type==="if-break"?x.breakContents:x.negate?x.contents:i(x.contents);L&&D.push([y,N,L])}if(b===d){let L=x.type==="if-break"?x.flatContents:x.negate?i(x.contents):x.contents;L&&D.push([y,N,L])}break}case"line-suffix":l.push([y,N,x.contents]);break;case"line-suffix-boundary":l.length>0&&D.push([y,N,{type:"line",hard:!0}]);break;case"line":switch(N){case d:if(x.hard)F=!0;else{x.soft||(g.push(" "),C+=1);break}case m:if(l.length>0){D.push([y,N,x],...l.reverse()),l=[];break}x.literal?y.root?(g.push(P,y.root.value),C=y.root.length):(g.push(P),C=0):(C-=T(g),g.push(P+y.value),C=y.length);break}break;case"label":D.push([y,N,x.contents]);break;default:}D.length===0&&l.length>0&&(D.push(...l.reverse()),l=[])}let E=g.indexOf(u.placeholder);if(E!==-1){let y=g.indexOf(u.placeholder,E+1),N=g.slice(0,E).join(""),x=g.slice(E+1,y).join(""),b=g.slice(y+1).join("");return{formatted:N+x+b,cursorNodeStart:N.length,cursorNodeText:x}}return{formatted:g.join("")}}n.exports={printDocToString:S}}}),hD=Z({"src/document/doc-debug.js"(e,n){"use strict";re();var{isConcat:t,getDocParts:s}=On();function a(u){if(!u)return"";if(t(u)){let i=[];for(let o of s(u))if(t(o))i.push(...a(o).parts);else{let c=a(o);c!==""&&i.push(c)}return{type:"concat",parts:i}}return u.type==="if-break"?Object.assign(Object.assign({},u),{},{breakContents:a(u.breakContents),flatContents:a(u.flatContents)}):u.type==="group"?Object.assign(Object.assign({},u),{},{contents:a(u.contents),expandedStates:u.expandedStates&&u.expandedStates.map(a)}):u.type==="fill"?{type:"fill",parts:u.parts.map(a)}:u.contents?Object.assign(Object.assign({},u),{},{contents:a(u.contents)}):u}function r(u){let i=Object.create(null),o=new Set;return c(a(u));function c(m,d,p){if(typeof m=="string")return JSON.stringify(m);if(t(m)){let f=s(m).map(c).filter(Boolean);return f.length===1?f[0]:"[".concat(f.join(", "),"]")}if(m.type==="line"){let f=Array.isArray(p)&&p[d+1]&&p[d+1].type==="break-parent";return m.literal?f?"literalline":"literallineWithoutBreakParent":m.hard?f?"hardline":"hardlineWithoutBreakParent":m.soft?"softline":"line"}if(m.type==="break-parent")return Array.isArray(p)&&p[d-1]&&p[d-1].type==="line"&&p[d-1].hard?void 0:"breakParent";if(m.type==="trim")return"trim";if(m.type==="indent")return"indent("+c(m.contents)+")";if(m.type==="align")return m.n===Number.NEGATIVE_INFINITY?"dedentToRoot("+c(m.contents)+")":m.n<0?"dedent("+c(m.contents)+")":m.n.type==="root"?"markAsRoot("+c(m.contents)+")":"align("+JSON.stringify(m.n)+", "+c(m.contents)+")";if(m.type==="if-break")return"ifBreak("+c(m.breakContents)+(m.flatContents?", "+c(m.flatContents):"")+(m.groupId?(m.flatContents?"":', ""')+", { groupId: ".concat(v(m.groupId)," }"):"")+")";if(m.type==="indent-if-break"){let f=[];m.negate&&f.push("negate: true"),m.groupId&&f.push("groupId: ".concat(v(m.groupId)));let h=f.length>0?", { ".concat(f.join(", ")," }"):"";return"indentIfBreak(".concat(c(m.contents)).concat(h,")")}if(m.type==="group"){let f=[];m.break&&m.break!=="propagated"&&f.push("shouldBreak: true"),m.id&&f.push("id: ".concat(v(m.id)));let h=f.length>0?", { ".concat(f.join(", ")," }"):"";return m.expandedStates?"conditionalGroup([".concat(m.expandedStates.map(w=>c(w)).join(","),"]").concat(h,")"):"group(".concat(c(m.contents)).concat(h,")")}if(m.type==="fill")return"fill([".concat(m.parts.map(f=>c(f)).join(", "),"])");if(m.type==="line-suffix")return"lineSuffix("+c(m.contents)+")";if(m.type==="line-suffix-boundary")return"lineSuffixBoundary";if(m.type==="label")return"label(".concat(JSON.stringify(m.label),", ").concat(c(m.contents),")");throw new Error("Unknown doc type "+m.type)}function v(m){if(typeof m!="symbol")return JSON.stringify(String(m));if(m in i)return i[m];let d=String(m).slice(7,-1)||"symbol";for(let p=0;;p++){let f=d+(p>0?" #".concat(p):"");if(!o.has(f))return o.add(f),i[m]="Symbol.for(".concat(JSON.stringify(f),")")}}}n.exports={printDocToDebug:r}}}),Oe=Z({"src/document/index.js"(e,n){"use strict";re(),n.exports={builders:Ln(),printer:yD(),utils:On(),debug:hD()}}}),Ea={};Ut(Ea,{default:()=>vD});function vD(e){if(typeof e!="string")throw new TypeError("Expected a string");return e.replace(/[|\\{}()[\]^$+*?.]/g,"\\$&").replace(/-/g,"\\x2d")}var CD=mt({"node_modules/escape-string-regexp/index.js"(){re()}}),Fa=Z({"node_modules/semver/internal/debug.js"(e,n){re();var t=typeof Tt=="object"&&Tt.env&&Tt.env.NODE_DEBUG&&/\bsemver\b/i.test(Tt.env.NODE_DEBUG)?function(){for(var s=arguments.length,a=new Array(s),r=0;r<s;r++)a[r]=arguments[r];return console.error("SEMVER",...a)}:()=>{};n.exports=t}}),Aa=Z({"node_modules/semver/internal/constants.js"(e,n){re();var t="2.0.0",s=256,a=Number.MAX_SAFE_INTEGER||9007199254740991,r=16;n.exports={SEMVER_SPEC_VERSION:t,MAX_LENGTH:s,MAX_SAFE_INTEGER:a,MAX_SAFE_COMPONENT_LENGTH:r}}}),ED=Z({"node_modules/semver/internal/re.js"(e,n){re();var{MAX_SAFE_COMPONENT_LENGTH:t}=Aa(),s=Fa();e=n.exports={};var a=e.re=[],r=e.src=[],u=e.t={},i=0,o=(c,v,m)=>{let d=i++;s(c,d,v),u[c]=d,r[d]=v,a[d]=new RegExp(v,m?"g":void 0)};o("NUMERICIDENTIFIER","0|[1-9]\\d*"),o("NUMERICIDENTIFIERLOOSE","[0-9]+"),o("NONNUMERICIDENTIFIER","\\d*[a-zA-Z-][a-zA-Z0-9-]*"),o("MAINVERSION","(".concat(r[u.NUMERICIDENTIFIER],")\\.(").concat(r[u.NUMERICIDENTIFIER],")\\.(").concat(r[u.NUMERICIDENTIFIER],")")),o("MAINVERSIONLOOSE","(".concat(r[u.NUMERICIDENTIFIERLOOSE],")\\.(").concat(r[u.NUMERICIDENTIFIERLOOSE],")\\.(").concat(r[u.NUMERICIDENTIFIERLOOSE],")")),o("PRERELEASEIDENTIFIER","(?:".concat(r[u.NUMERICIDENTIFIER],"|").concat(r[u.NONNUMERICIDENTIFIER],")")),o("PRERELEASEIDENTIFIERLOOSE","(?:".concat(r[u.NUMERICIDENTIFIERLOOSE],"|").concat(r[u.NONNUMERICIDENTIFIER],")")),o("PRERELEASE","(?:-(".concat(r[u.PRERELEASEIDENTIFIER],"(?:\\.").concat(r[u.PRERELEASEIDENTIFIER],")*))")),o("PRERELEASELOOSE","(?:-?(".concat(r[u.PRERELEASEIDENTIFIERLOOSE],"(?:\\.").concat(r[u.PRERELEASEIDENTIFIERLOOSE],")*))")),o("BUILDIDENTIFIER","[0-9A-Za-z-]+"),o("BUILD","(?:\\+(".concat(r[u.BUILDIDENTIFIER],"(?:\\.").concat(r[u.BUILDIDENTIFIER],")*))")),o("FULLPLAIN","v?".concat(r[u.MAINVERSION]).concat(r[u.PRERELEASE],"?").concat(r[u.BUILD],"?")),o("FULL","^".concat(r[u.FULLPLAIN],"$")),o("LOOSEPLAIN","[v=\\s]*".concat(r[u.MAINVERSIONLOOSE]).concat(r[u.PRERELEASELOOSE],"?").concat(r[u.BUILD],"?")),o("LOOSE","^".concat(r[u.LOOSEPLAIN],"$")),o("GTLT","((?:<|>)?=?)"),o("XRANGEIDENTIFIERLOOSE","".concat(r[u.NUMERICIDENTIFIERLOOSE],"|x|X|\\*")),o("XRANGEIDENTIFIER","".concat(r[u.NUMERICIDENTIFIER],"|x|X|\\*")),o("XRANGEPLAIN","[v=\\s]*(".concat(r[u.XRANGEIDENTIFIER],")(?:\\.(").concat(r[u.XRANGEIDENTIFIER],")(?:\\.(").concat(r[u.XRANGEIDENTIFIER],")(?:").concat(r[u.PRERELEASE],")?").concat(r[u.BUILD],"?)?)?")),o("XRANGEPLAINLOOSE","[v=\\s]*(".concat(r[u.XRANGEIDENTIFIERLOOSE],")(?:\\.(").concat(r[u.XRANGEIDENTIFIERLOOSE],")(?:\\.(").concat(r[u.XRANGEIDENTIFIERLOOSE],")(?:").concat(r[u.PRERELEASELOOSE],")?").concat(r[u.BUILD],"?)?)?")),o("XRANGE","^".concat(r[u.GTLT],"\\s*").concat(r[u.XRANGEPLAIN],"$")),o("XRANGELOOSE","^".concat(r[u.GTLT],"\\s*").concat(r[u.XRANGEPLAINLOOSE],"$")),o("COERCE","(^|[^\\d])(\\d{1,".concat(t,"})(?:\\.(\\d{1,").concat(t,"}))?(?:\\.(\\d{1,").concat(t,"}))?(?:$|[^\\d])")),o("COERCERTL",r[u.COERCE],!0),o("LONETILDE","(?:~>?)"),o("TILDETRIM","(\\s*)".concat(r[u.LONETILDE],"\\s+"),!0),e.tildeTrimReplace="$1~",o("TILDE","^".concat(r[u.LONETILDE]).concat(r[u.XRANGEPLAIN],"$")),o("TILDELOOSE","^".concat(r[u.LONETILDE]).concat(r[u.XRANGEPLAINLOOSE],"$")),o("LONECARET","(?:\\^)"),o("CARETTRIM","(\\s*)".concat(r[u.LONECARET],"\\s+"),!0),e.caretTrimReplace="$1^",o("CARET","^".concat(r[u.LONECARET]).concat(r[u.XRANGEPLAIN],"$")),o("CARETLOOSE","^".concat(r[u.LONECARET]).concat(r[u.XRANGEPLAINLOOSE],"$")),o("COMPARATORLOOSE","^".concat(r[u.GTLT],"\\s*(").concat(r[u.LOOSEPLAIN],")$|^$")),o("COMPARATOR","^".concat(r[u.GTLT],"\\s*(").concat(r[u.FULLPLAIN],")$|^$")),o("COMPARATORTRIM","(\\s*)".concat(r[u.GTLT],"\\s*(").concat(r[u.LOOSEPLAIN],"|").concat(r[u.XRANGEPLAIN],")"),!0),e.comparatorTrimReplace="$1$2$3",o("HYPHENRANGE","^\\s*(".concat(r[u.XRANGEPLAIN],")\\s+-\\s+(").concat(r[u.XRANGEPLAIN],")\\s*$")),o("HYPHENRANGELOOSE","^\\s*(".concat(r[u.XRANGEPLAINLOOSE],")\\s+-\\s+(").concat(r[u.XRANGEPLAINLOOSE],")\\s*$")),o("STAR","(<|>)?=?\\s*\\*"),o("GTE0","^\\s*>=\\s*0\\.0\\.0\\s*$"),o("GTE0PRE","^\\s*>=\\s*0\\.0\\.0-0\\s*$")}}),FD=Z({"node_modules/semver/internal/parse-options.js"(e,n){re();var t=["includePrerelease","loose","rtl"],s=a=>a?typeof a!="object"?{loose:!0}:t.filter(r=>a[r]).reduce((r,u)=>(r[u]=!0,r),{}):{};n.exports=s}}),AD=Z({"node_modules/semver/internal/identifiers.js"(e,n){re();var t=/^[0-9]+$/,s=(r,u)=>{let i=t.test(r),o=t.test(u);return i&&o&&(r=+r,u=+u),r===u?0:i&&!o?-1:o&&!i?1:r<u?-1:1},a=(r,u)=>s(u,r);n.exports={compareIdentifiers:s,rcompareIdentifiers:a}}}),SD=Z({"node_modules/semver/classes/semver.js"(e,n){re();var t=Fa(),{MAX_LENGTH:s,MAX_SAFE_INTEGER:a}=Aa(),{re:r,t:u}=ED(),i=FD(),{compareIdentifiers:o}=AD(),c=class{constructor(v,m){if(m=i(m),v instanceof c){if(v.loose===!!m.loose&&v.includePrerelease===!!m.includePrerelease)return v;v=v.version}else if(typeof v!="string")throw new TypeError("Invalid Version: ".concat(v));if(v.length>s)throw new TypeError("version is longer than ".concat(s," characters"));t("SemVer",v,m),this.options=m,this.loose=!!m.loose,this.includePrerelease=!!m.includePrerelease;let d=v.trim().match(m.loose?r[u.LOOSE]:r[u.FULL]);if(!d)throw new TypeError("Invalid Version: ".concat(v));if(this.raw=v,this.major=+d[1],this.minor=+d[2],this.patch=+d[3],this.major>a||this.major<0)throw new TypeError("Invalid major version");if(this.minor>a||this.minor<0)throw new TypeError("Invalid minor version");if(this.patch>a||this.patch<0)throw new TypeError("Invalid patch version");d[4]?this.prerelease=d[4].split(".").map(p=>{if(/^[0-9]+$/.test(p)){let f=+p;if(f>=0&&f<a)return f}return p}):this.prerelease=[],this.build=d[5]?d[5].split("."):[],this.format()}format(){return this.version="".concat(this.major,".").concat(this.minor,".").concat(this.patch),this.prerelease.length&&(this.version+="-".concat(this.prerelease.join("."))),this.version}toString(){return this.version}compare(v){if(t("SemVer.compare",this.version,this.options,v),!(v instanceof c)){if(typeof v=="string"&&v===this.version)return 0;v=new c(v,this.options)}return v.version===this.version?0:this.compareMain(v)||this.comparePre(v)}compareMain(v){return v instanceof c||(v=new c(v,this.options)),o(this.major,v.major)||o(this.minor,v.minor)||o(this.patch,v.patch)}comparePre(v){if(v instanceof c||(v=new c(v,this.options)),this.prerelease.length&&!v.prerelease.length)return-1;if(!this.prerelease.length&&v.prerelease.length)return 1;if(!this.prerelease.length&&!v.prerelease.length)return 0;let m=0;do{let d=this.prerelease[m],p=v.prerelease[m];if(t("prerelease compare",m,d,p),d===void 0&&p===void 0)return 0;if(p===void 0)return 1;if(d===void 0)return-1;if(d===p)continue;return o(d,p)}while(++m)}compareBuild(v){v instanceof c||(v=new c(v,this.options));let m=0;do{let d=this.build[m],p=v.build[m];if(t("prerelease compare",m,d,p),d===void 0&&p===void 0)return 0;if(p===void 0)return 1;if(d===void 0)return-1;if(d===p)continue;return o(d,p)}while(++m)}inc(v,m){switch(v){case"premajor":this.prerelease.length=0,this.patch=0,this.minor=0,this.major++,this.inc("pre",m);break;case"preminor":this.prerelease.length=0,this.patch=0,this.minor++,this.inc("pre",m);break;case"prepatch":this.prerelease.length=0,this.inc("patch",m),this.inc("pre",m);break;case"prerelease":this.prerelease.length===0&&this.inc("patch",m),this.inc("pre",m);break;case"major":(this.minor!==0||this.patch!==0||this.prerelease.length===0)&&this.major++,this.minor=0,this.patch=0,this.prerelease=[];break;case"minor":(this.patch!==0||this.prerelease.length===0)&&this.minor++,this.patch=0,this.prerelease=[];break;case"patch":this.prerelease.length===0&&this.patch++,this.prerelease=[];break;case"pre":if(this.prerelease.length===0)this.prerelease=[0];else{let d=this.prerelease.length;for(;--d>=0;)typeof this.prerelease[d]=="number"&&(this.prerelease[d]++,d=-2);d===-1&&this.prerelease.push(0)}m&&(o(this.prerelease[0],m)===0?isNaN(this.prerelease[1])&&(this.prerelease=[m,0]):this.prerelease=[m,0]);break;default:throw new Error("invalid increment argument: ".concat(v))}return this.format(),this.raw=this.version,this}};n.exports=c}}),qn=Z({"node_modules/semver/functions/compare.js"(e,n){re();var t=SD(),s=(a,r,u)=>new t(a,u).compare(new t(r,u));n.exports=s}}),xD=Z({"node_modules/semver/functions/lt.js"(e,n){re();var t=qn(),s=(a,r,u)=>t(a,r,u)<0;n.exports=s}}),bD=Z({"node_modules/semver/functions/gte.js"(e,n){re();var t=qn(),s=(a,r,u)=>t(a,r,u)>=0;n.exports=s}}),TD=Z({"src/utils/arrayify.js"(e,n){"use strict";re(),n.exports=(t,s)=>Object.entries(t).map(a=>{let[r,u]=a;return Object.assign({[s]:r},u)})}}),BD=Z({"node_modules/outdent/lib/index.js"(e,n){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0}),e.outdent=void 0;function t(){for(var A=[],S=0;S<arguments.length;S++)A[S]=arguments[S]}function s(){return typeof WeakMap<"u"?new WeakMap:a()}function a(){return{add:t,delete:t,get:t,set:t,has:function(A){return!1}}}var r=Object.prototype.hasOwnProperty,u=function(A,S){return r.call(A,S)};function i(A,S){for(var B in S)u(S,B)&&(A[B]=S[B]);return A}var o=/^[ \t]*(?:\r\n|\r|\n)/,c=/(?:\r\n|\r|\n)[ \t]*$/,v=/^(?:[\r\n]|$)/,m=/(?:\r\n|\r|\n)([ \t]*)(?:[^ \t\r\n]|$)/,d=/^[ \t]*[\r\n][ \t\r\n]*$/;function p(A,S,B){var I=0,k=A[0].match(m);k&&(I=k[1].length);var P="(\\r\\n|\\r|\\n).{0,"+I+"}",C=new RegExp(P,"g");S&&(A=A.slice(1));var D=B.newline,g=B.trimLeadingNewline,F=B.trimTrailingNewline,l=typeof D=="string",E=A.length,y=A.map(function(N,x){return N=N.replace(C,"$1"),x===0&&g&&(N=N.replace(o,"")),x===E-1&&F&&(N=N.replace(c,"")),l&&(N=N.replace(/\r\n|\n|\r/g,function(b){return D})),N});return y}function f(A,S){for(var B="",I=0,k=A.length;I<k;I++)B+=A[I],I<k-1&&(B+=S[I]);return B}function h(A){return u(A,"raw")&&u(A,"length")}function w(A){var S=s(),B=s();function I(P){for(var C=[],D=1;D<arguments.length;D++)C[D-1]=arguments[D];if(h(P)){var g=P,F=(C[0]===I||C[0]===T)&&d.test(g[0])&&v.test(g[1]),l=F?B:S,E=l.get(g);if(E||(E=p(g,F,A),l.set(g,E)),C.length===0)return E[0];var y=f(E,F?C.slice(1):C);return y}else return w(i(i({},A),P||{}))}var k=i(I,{string:function(P){return p([P],!1,A)[0]}});return k}var T=w({trimLeadingNewline:!0,trimTrailingNewline:!0});if(e.outdent=T,e.default=T,typeof n<"u")try{n.exports=T,Object.defineProperty(T,"__esModule",{value:!0}),T.default=T,T.outdent=T}catch{}}}),ND=Z({"src/main/core-options.js"(e,n){"use strict";re();var{outdent:t}=BD(),s="Config",a="Editor",r="Format",u="Other",i="Output",o="Global",c="Special",v={cursorOffset:{since:"1.4.0",category:c,type:"int",default:-1,range:{start:-1,end:Number.POSITIVE_INFINITY,step:1},description:t(sa||(sa=Pt([`
      Print (to stderr) where a cursor at the given position would move to after formatting.
      This option cannot be used with --range-start and --range-end.
    `]))),cliCategory:a},endOfLine:{since:"1.15.0",category:o,type:"choice",default:[{since:"1.15.0",value:"auto"},{since:"2.0.0",value:"lf"}],description:"Which end of line characters to apply.",choices:[{value:"lf",description:"Line Feed only (\\n), common on Linux and macOS as well as inside git repos"},{value:"crlf",description:"Carriage Return + Line Feed characters (\\r\\n), common on Windows"},{value:"cr",description:"Carriage Return character only (\\r), used very rarely"},{value:"auto",description:t(ia||(ia=Pt([`
          Maintain existing
          (mixed values within one file are normalised by looking at what's used after the first line)
        `])))}]},filepath:{since:"1.4.0",category:c,type:"path",description:"Specify the input filepath. This will be used to do parser inference.",cliName:"stdin-filepath",cliCategory:u,cliDescription:"Path to the file to pretend that stdin comes from."},insertPragma:{since:"1.8.0",category:c,type:"boolean",default:!1,description:"Insert @format pragma into file's first docblock comment.",cliCategory:u},parser:{since:"0.0.10",category:o,type:"choice",default:[{since:"0.0.10",value:"babylon"},{since:"1.13.0",value:void 0}],description:"Which parser to use.",exception:m=>typeof m=="string"||typeof m=="function",choices:[{value:"flow",description:"Flow"},{value:"babel",since:"1.16.0",description:"JavaScript"},{value:"babel-flow",since:"1.16.0",description:"Flow"},{value:"babel-ts",since:"2.0.0",description:"TypeScript"},{value:"typescript",since:"1.4.0",description:"TypeScript"},{value:"acorn",since:"2.6.0",description:"JavaScript"},{value:"espree",since:"2.2.0",description:"JavaScript"},{value:"meriyah",since:"2.2.0",description:"JavaScript"},{value:"css",since:"1.7.1",description:"CSS"},{value:"less",since:"1.7.1",description:"Less"},{value:"scss",since:"1.7.1",description:"SCSS"},{value:"json",since:"1.5.0",description:"JSON"},{value:"json5",since:"1.13.0",description:"JSON5"},{value:"json-stringify",since:"1.13.0",description:"JSON.stringify"},{value:"graphql",since:"1.5.0",description:"GraphQL"},{value:"markdown",since:"1.8.0",description:"Markdown"},{value:"mdx",since:"1.15.0",description:"MDX"},{value:"vue",since:"1.10.0",description:"Vue"},{value:"yaml",since:"1.14.0",description:"YAML"},{value:"glimmer",since:"2.3.0",description:"Ember / Handlebars"},{value:"html",since:"1.15.0",description:"HTML"},{value:"angular",since:"1.15.0",description:"Angular"},{value:"lwc",since:"1.17.0",description:"Lightning Web Components"}]},plugins:{since:"1.10.0",type:"path",array:!0,default:[{value:[]}],category:o,description:"Add a plugin. Multiple plugins can be passed as separate `--plugin`s.",exception:m=>typeof m=="string"||typeof m=="object",cliName:"plugin",cliCategory:s},pluginSearchDirs:{since:"1.13.0",type:"path",array:!0,default:[{value:[]}],category:o,description:t(aa||(aa=Pt([`
      Custom directory that contains prettier plugins in node_modules subdirectory.
      Overrides default behavior when plugins are searched relatively to the location of Prettier.
      Multiple values are accepted.
    `]))),exception:m=>typeof m=="string"||typeof m=="object",cliName:"plugin-search-dir",cliCategory:s},printWidth:{since:"0.0.0",category:o,type:"int",default:80,description:"The line length where Prettier will try wrap.",range:{start:0,end:Number.POSITIVE_INFINITY,step:1}},rangeEnd:{since:"1.4.0",category:c,type:"int",default:Number.POSITIVE_INFINITY,range:{start:0,end:Number.POSITIVE_INFINITY,step:1},description:t(oa||(oa=Pt([`
      Format code ending at a given character offset (exclusive).
      The range will extend forwards to the end of the selected statement.
      This option cannot be used with --cursor-offset.
    `]))),cliCategory:a},rangeStart:{since:"1.4.0",category:c,type:"int",default:0,range:{start:0,end:Number.POSITIVE_INFINITY,step:1},description:t(la||(la=Pt([`
      Format code starting at a given character offset.
      The range will extend backwards to the start of the first line containing the selected statement.
      This option cannot be used with --cursor-offset.
    `]))),cliCategory:a},requirePragma:{since:"1.7.0",category:c,type:"boolean",default:!1,description:t(ca||(ca=Pt([`
      Require either '@prettier' or '@format' to be present in the file's first docblock comment
      in order for it to be formatted.
    `]))),cliCategory:u},tabWidth:{type:"int",category:o,default:2,description:"Number of spaces per indentation level.",range:{start:0,end:Number.POSITIVE_INFINITY,step:1}},useTabs:{since:"1.0.0",category:o,type:"boolean",default:!1,description:"Indent with tabs instead of spaces."},embeddedLanguageFormatting:{since:"2.1.0",category:o,type:"choice",default:[{since:"2.1.0",value:"auto"}],description:"Control how Prettier formats quoted code embedded in the file.",choices:[{value:"auto",description:"Format embedded code if Prettier can automatically identify it."},{value:"off",description:"Never automatically format embedded code."}]}};n.exports={CATEGORY_CONFIG:s,CATEGORY_EDITOR:a,CATEGORY_FORMAT:r,CATEGORY_OTHER:u,CATEGORY_OUTPUT:i,CATEGORY_GLOBAL:o,CATEGORY_SPECIAL:c,options:v}}}),Mn=Z({"src/main/support.js"(e,n){"use strict";re();var t={compare:qn(),lt:xD(),gte:bD()},s=TD(),a=ya().version,r=ND().options;function u(){let{plugins:o=[],showUnreleased:c=!1,showDeprecated:v=!1,showInternal:m=!1}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{},d=a.split("-",1)[0],p=o.flatMap(A=>A.languages||[]).filter(h),f=s(Object.assign({},...o.map(A=>{let{options:S}=A;return S}),r),"name").filter(A=>h(A)&&w(A)).sort((A,S)=>A.name===S.name?0:A.name<S.name?-1:1).map(T).map(A=>{A=Object.assign({},A),Array.isArray(A.default)&&(A.default=A.default.length===1?A.default[0].value:A.default.filter(h).sort((B,I)=>t.compare(I.since,B.since))[0].value),Array.isArray(A.choices)&&(A.choices=A.choices.filter(B=>h(B)&&w(B)),A.name==="parser"&&i(A,p,o));let S=Object.fromEntries(o.filter(B=>B.defaultOptions&&B.defaultOptions[A.name]!==void 0).map(B=>[B.name,B.defaultOptions[A.name]]));return Object.assign(Object.assign({},A),{},{pluginDefaults:S})});return{languages:p,options:f};function h(A){return c||!("since"in A)||A.since&&t.gte(d,A.since)}function w(A){return v||!("deprecated"in A)||A.deprecated&&t.lt(d,A.deprecated)}function T(A){if(m)return A;let{cliName:S,cliCategory:B,cliDescription:I}=A;return kn(A,Yf)}}function i(o,c,v){let m=new Set(o.choices.map(d=>d.value));for(let d of c)if(d.parsers){for(let p of d.parsers)if(!m.has(p)){m.add(p);let f=v.find(w=>w.parsers&&w.parsers[p]),h=d.name;f&&f.name&&(h+=" (plugin: ".concat(f.name,")")),o.choices.push({value:p,description:h})}}}n.exports={getSupportInfo:u}}}),Rn=Z({"src/utils/is-non-empty-array.js"(e,n){"use strict";re();function t(s){return Array.isArray(s)&&s.length>0}n.exports=t}}),Nr=Z({"src/utils/text/skip.js"(e,n){"use strict";re();function t(i){return(o,c,v)=>{let m=v&&v.backwards;if(c===!1)return!1;let{length:d}=o,p=c;for(;p>=0&&p<d;){let f=o.charAt(p);if(i instanceof RegExp){if(!i.test(f))return p}else if(!i.includes(f))return p;m?p--:p++}return p===-1||p===d?p:!1}}var s=t(/\s/),a=t(" 	"),r=t(",; 	"),u=t(/[^\n\r]/);n.exports={skipWhitespace:s,skipSpaces:a,skipToLineEnd:r,skipEverythingButNewLine:u}}}),Sa=Z({"src/utils/text/skip-inline-comment.js"(e,n){"use strict";re();function t(s,a){if(a===!1)return!1;if(s.charAt(a)==="/"&&s.charAt(a+1)==="*"){for(let r=a+2;r<s.length;++r)if(s.charAt(r)==="*"&&s.charAt(r+1)==="/")return r+2}return a}n.exports=t}}),xa=Z({"src/utils/text/skip-trailing-comment.js"(e,n){"use strict";re();var{skipEverythingButNewLine:t}=Nr();function s(a,r){return r===!1?!1:a.charAt(r)==="/"&&a.charAt(r+1)==="/"?t(a,r):r}n.exports=s}}),ba=Z({"src/utils/text/skip-newline.js"(e,n){"use strict";re();function t(s,a,r){let u=r&&r.backwards;if(a===!1)return!1;let i=s.charAt(a);if(u){if(s.charAt(a-1)==="\r"&&i===`
`)return a-2;if(i===`
`||i==="\r"||i==="\u2028"||i==="\u2029")return a-1}else{if(i==="\r"&&s.charAt(a+1)===`
`)return a+2;if(i===`
`||i==="\r"||i==="\u2028"||i==="\u2029")return a+1}return a}n.exports=t}}),wD=Z({"src/utils/text/get-next-non-space-non-comment-character-index-with-start-index.js"(e,n){"use strict";re();var t=Sa(),s=ba(),a=xa(),{skipSpaces:r}=Nr();function u(i,o){let c=null,v=o;for(;v!==c;)c=v,v=r(i,v),v=t(i,v),v=a(i,v),v=s(i,v);return v}n.exports=u}}),Ue=Z({"src/common/util.js"(e,n){"use strict";re();var{default:t}=(CD(),lt(Ea)),s=it(),{getSupportInfo:a}=Mn(),r=Rn(),u=Ca(),{skipWhitespace:i,skipSpaces:o,skipToLineEnd:c,skipEverythingButNewLine:v}=Nr(),m=Sa(),d=xa(),p=ba(),f=wD(),h=H=>H[H.length-2];function w(H){return(R,Q,ee)=>{let te=ee&&ee.backwards;if(Q===!1)return!1;let{length:oe}=R,W=Q;for(;W>=0&&W<oe;){let X=R.charAt(W);if(H instanceof RegExp){if(!H.test(X))return W}else if(!H.includes(X))return W;te?W--:W++}return W===-1||W===oe?W:!1}}function T(H,R){let Q=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{},ee=o(H,Q.backwards?R-1:R,Q),te=p(H,ee,Q);return ee!==te}function A(H,R,Q){for(let ee=R;ee<Q;++ee)if(H.charAt(ee)===`
`)return!0;return!1}function S(H,R,Q){let ee=Q(R)-1;ee=o(H,ee,{backwards:!0}),ee=p(H,ee,{backwards:!0}),ee=o(H,ee,{backwards:!0});let te=p(H,ee,{backwards:!0});return ee!==te}function B(H,R){let Q=null,ee=R;for(;ee!==Q;)Q=ee,ee=c(H,ee),ee=m(H,ee),ee=o(H,ee);return ee=d(H,ee),ee=p(H,ee),ee!==!1&&T(H,ee)}function I(H,R,Q){return B(H,Q(R))}function k(H,R,Q){return f(H,Q(R))}function P(H,R,Q){return H.charAt(k(H,R,Q))}function C(H,R){let Q=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{};return o(H,Q.backwards?R-1:R,Q)!==R}function D(H,R){let Q=arguments.length>2&&arguments[2]!==void 0?arguments[2]:0,ee=0;for(let te=Q;te<H.length;++te)H[te]==="	"?ee=ee+R-ee%R:ee++;return ee}function g(H,R){let Q=H.lastIndexOf(`
`);return Q===-1?0:D(H.slice(Q+1).match(/^[\t ]*/)[0],R)}function F(H,R){let Q={quote:'"',regex:/"/g,escaped:"&quot;"},ee={quote:"'",regex:/'/g,escaped:"&apos;"},te=R==="'"?ee:Q,oe=te===ee?Q:ee,W=te;if(H.includes(te.quote)||H.includes(oe.quote)){let X=(H.match(te.regex)||[]).length,ue=(H.match(oe.regex)||[]).length;W=X>ue?oe:te}return W}function l(H,R){let Q=H.slice(1,-1),ee=R.parser==="json"||R.parser==="json5"&&R.quoteProps==="preserve"&&!R.singleQuote?'"':R.__isInHtmlAttribute?"'":F(Q,R.singleQuote?"'":'"').quote;return E(Q,ee,!(R.parser==="css"||R.parser==="less"||R.parser==="scss"||R.__embeddedInHtml))}function E(H,R,Q){let ee=R==='"'?"'":'"',te=/\\(.)|(["'])/gs,oe=H.replace(te,(W,X,ue)=>X===ee?X:ue===R?"\\"+ue:ue||(Q&&/^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(X)?X:"\\"+X));return R+oe+R}function y(H){return H.toLowerCase().replace(/^([+-]?[\d.]+e)(?:\+|(-))?0*(\d)/,"$1$2$3").replace(/^([+-]?[\d.]+)e[+-]?0+$/,"$1").replace(/^([+-])?\./,"$10.").replace(/(\.\d+?)0+(?=e|$)/,"$1").replace(/\.(?=e|$)/,"")}function N(H,R){let Q=H.match(new RegExp("(".concat(t(R),")+"),"g"));return Q===null?0:Q.reduce((ee,te)=>Math.max(ee,te.length/R.length),0)}function x(H,R){let Q=H.match(new RegExp("(".concat(t(R),")+"),"g"));if(Q===null)return 0;let ee=new Map,te=0;for(let oe of Q){let W=oe.length/R.length;ee.set(W,!0),W>te&&(te=W)}for(let oe=1;oe<te;oe++)if(!ee.get(oe))return oe;return te+1}function b(H,R){(H.comments||(H.comments=[])).push(R),R.printed=!1,R.nodeDescription=Y(H)}function L(H,R){R.leading=!0,R.trailing=!1,b(H,R)}function M(H,R,Q){R.leading=!1,R.trailing=!1,Q&&(R.marker=Q),b(H,R)}function j(H,R){R.leading=!1,R.trailing=!0,b(H,R)}function $(H,R){let{languages:Q}=a({plugins:R.plugins}),ee=Q.find(te=>{let{name:oe}=te;return oe.toLowerCase()===H})||Q.find(te=>{let{aliases:oe}=te;return Array.isArray(oe)&&oe.includes(H)})||Q.find(te=>{let{extensions:oe}=te;return Array.isArray(oe)&&oe.includes(".".concat(H))});return ee&&ee.parsers[0]}function V(H){return H&&H.type==="front-matter"}function q(H){let R=new WeakMap;return function(Q){return R.has(Q)||R.set(Q,Symbol(H)),R.get(Q)}}function Y(H){let R=H.type||H.kind||"(unknown type)",Q=String(H.name||H.id&&(typeof H.id=="object"?H.id.name:H.id)||H.key&&(typeof H.key=="object"?H.key.name:H.key)||H.value&&(typeof H.value=="object"?"":String(H.value))||H.operator||"");return Q.length>20&&(Q=Q.slice(0,19)+"\u2026"),R+(Q?" "+Q:"")}n.exports={inferParserByLanguage:$,getStringWidth:u,getMaxContinuousCount:N,getMinNotPresentContinuousCount:x,getPenultimate:h,getLast:s,getNextNonSpaceNonCommentCharacterIndexWithStartIndex:f,getNextNonSpaceNonCommentCharacterIndex:k,getNextNonSpaceNonCommentCharacter:P,skip:w,skipWhitespace:i,skipSpaces:o,skipToLineEnd:c,skipEverythingButNewLine:v,skipInlineComment:m,skipTrailingComment:d,skipNewline:p,isNextLineEmptyAfterIndex:B,isNextLineEmpty:I,isPreviousLineEmpty:S,hasNewline:T,hasNewlineInRange:A,hasSpaces:C,getAlignmentSize:D,getIndentSize:g,getPreferredQuote:F,printString:l,printNumber:y,makeString:E,addLeadingComment:L,addDanglingComment:M,addTrailingComment:j,isFrontMatterNode:V,isNonEmptyArray:r,createGroupIdMapper:q}}}),Ta={};Ut(Ta,{basename:()=>Pa,default:()=>Ia,delimiter:()=>Bn,dirname:()=>_a,extname:()=>ka,isAbsolute:()=>Wn,join:()=>Na,normalize:()=>Vn,relative:()=>wa,resolve:()=>Tr,sep:()=>Tn});function Ba(e,n){for(var t=0,s=e.length-1;s>=0;s--){var a=e[s];a==="."?e.splice(s,1):a===".."?(e.splice(s,1),t++):t&&(e.splice(s,1),t--)}if(n)for(;t--;t)e.unshift("..");return e}function Tr(){for(var e="",n=!1,t=arguments.length-1;t>=-1&&!n;t--){var s=t>=0?arguments[t]:"/";if(typeof s!="string")throw new TypeError("Arguments to path.resolve must be strings");if(!s)continue;e=s+"/"+e,n=s.charAt(0)==="/"}return e=Ba($n(e.split("/"),function(a){return!!a}),!n).join("/"),(n?"/":"")+e||"."}function Vn(e){var n=Wn(e),t=La(e,-1)==="/";return e=Ba($n(e.split("/"),function(s){return!!s}),!n).join("/"),!e&&!n&&(e="."),e&&t&&(e+="/"),(n?"/":"")+e}function Wn(e){return e.charAt(0)==="/"}function Na(){var e=Array.prototype.slice.call(arguments,0);return Vn($n(e,function(n,t){if(typeof n!="string")throw new TypeError("Arguments to path.join must be strings");return n}).join("/"))}function wa(e,n){e=Tr(e).substr(1),n=Tr(n).substr(1);function t(c){for(var v=0;v<c.length&&c[v]==="";v++);for(var m=c.length-1;m>=0&&c[m]==="";m--);return v>m?[]:c.slice(v,m-v+1)}for(var s=t(e.split("/")),a=t(n.split("/")),r=Math.min(s.length,a.length),u=r,i=0;i<r;i++)if(s[i]!==a[i]){u=i;break}for(var o=[],i=u;i<s.length;i++)o.push("..");return o=o.concat(a.slice(u)),o.join("/")}function _a(e){var n=wr(e),t=n[0],s=n[1];return!t&&!s?".":(s&&(s=s.substr(0,s.length-1)),t+s)}function Pa(e,n){var t=wr(e)[2];return n&&t.substr(-1*n.length)===n&&(t=t.substr(0,t.length-n.length)),t}function ka(e){return wr(e)[3]}function $n(e,n){if(e.filter)return e.filter(n);for(var t=[],s=0;s<e.length;s++)n(e[s],s,e)&&t.push(e[s]);return t}var Da,wr,Tn,Bn,Ia,La,_D=mt({"node-modules-polyfills:path"(){re(),Da=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,wr=function(e){return Da.exec(e).slice(1)},Tn="/",Bn=":",Ia={extname:ka,basename:Pa,dirname:_a,sep:Tn,delimiter:Bn,relative:wa,join:Na,isAbsolute:Wn,normalize:Vn,resolve:Tr},La= true?function(e,n,t){return e.substr(n,t)}:0}}),PD=Z({"node-modules-polyfills-commonjs:path"(e,n){re();var t=(_D(),lt(Ta));if(t&&t.default){n.exports=t.default;for(let s in t)n.exports[s]=t[s]}else t&&(n.exports=t)}}),zt=Z({"src/common/errors.js"(e,n){"use strict";re();var t=class extends Error{},s=class extends Error{},a=class extends Error{},r=class extends Error{};n.exports={ConfigError:t,DebugError:s,UndefinedParserError:a,ArgExpansionBailout:r}}}),dt={};Ut(dt,{__assign:()=>br,__asyncDelegator:()=>GD,__asyncGenerator:()=>HD,__asyncValues:()=>JD,__await:()=>Jt,__awaiter:()=>qD,__classPrivateFieldGet:()=>KD,__classPrivateFieldSet:()=>YD,__createBinding:()=>RD,__decorate:()=>LD,__exportStar:()=>VD,__extends:()=>kD,__generator:()=>MD,__importDefault:()=>XD,__importStar:()=>zD,__makeTemplateObject:()=>UD,__metadata:()=>OD,__param:()=>jD,__read:()=>ja,__rest:()=>ID,__spread:()=>WD,__spreadArrays:()=>$D,__values:()=>Nn});function kD(e,n){xr(e,n);function t(){this.constructor=e}e.prototype=n===null?Object.create(n):(t.prototype=n.prototype,new t)}function ID(e,n){var t={};for(var s in e)Object.prototype.hasOwnProperty.call(e,s)&&n.indexOf(s)<0&&(t[s]=e[s]);if(e!=null&&typeof Object.getOwnPropertySymbols=="function")for(var a=0,s=Object.getOwnPropertySymbols(e);a<s.length;a++)n.indexOf(s[a])<0&&Object.prototype.propertyIsEnumerable.call(e,s[a])&&(t[s[a]]=e[s[a]]);return t}function LD(e,n,t,s){var a=arguments.length,r=a<3?n:s===null?s=Object.getOwnPropertyDescriptor(n,t):s,u;if(typeof Reflect=="object"&&typeof Reflect.decorate=="function")r=Reflect.decorate(e,n,t,s);else for(var i=e.length-1;i>=0;i--)(u=e[i])&&(r=(a<3?u(r):a>3?u(n,t,r):u(n,t))||r);return a>3&&r&&Object.defineProperty(n,t,r),r}function jD(e,n){return function(t,s){n(t,s,e)}}function OD(e,n){if(typeof Reflect=="object"&&typeof Reflect.metadata=="function")return Reflect.metadata(e,n)}function qD(e,n,t,s){function a(r){return r instanceof t?r:new t(function(u){u(r)})}return new(t||(t=Promise))(function(r,u){function i(v){try{c(s.next(v))}catch(m){u(m)}}function o(v){try{c(s.throw(v))}catch(m){u(m)}}function c(v){v.done?r(v.value):a(v.value).then(i,o)}c((s=s.apply(e,n||[])).next())})}function MD(e,n){var t={label:0,sent:function(){if(r[0]&1)throw r[1];return r[1]},trys:[],ops:[]},s,a,r,u;return u={next:i(0),throw:i(1),return:i(2)},typeof Symbol=="function"&&(u[Symbol.iterator]=function(){return this}),u;function i(c){return function(v){return o([c,v])}}function o(c){if(s)throw new TypeError("Generator is already executing.");for(;t;)try{if(s=1,a&&(r=c[0]&2?a.return:c[0]?a.throw||((r=a.return)&&r.call(a),0):a.next)&&!(r=r.call(a,c[1])).done)return r;switch(a=0,r&&(c=[c[0]&2,r.value]),c[0]){case 0:case 1:r=c;break;case 4:return t.label++,{value:c[1],done:!1};case 5:t.label++,a=c[1],c=[0];continue;case 7:c=t.ops.pop(),t.trys.pop();continue;default:if(r=t.trys,!(r=r.length>0&&r[r.length-1])&&(c[0]===6||c[0]===2)){t=0;continue}if(c[0]===3&&(!r||c[1]>r[0]&&c[1]<r[3])){t.label=c[1];break}if(c[0]===6&&t.label<r[1]){t.label=r[1],r=c;break}if(r&&t.label<r[2]){t.label=r[2],t.ops.push(c);break}r[2]&&t.ops.pop(),t.trys.pop();continue}c=n.call(e,t)}catch(v){c=[6,v],a=0}finally{s=r=0}if(c[0]&5)throw c[1];return{value:c[0]?c[1]:void 0,done:!0}}}function RD(e,n,t,s){s===void 0&&(s=t),e[s]=n[t]}function VD(e,n){for(var t in e)t!=="default"&&!n.hasOwnProperty(t)&&(n[t]=e[t])}function Nn(e){var n=typeof Symbol=="function"&&Symbol.iterator,t=n&&e[n],s=0;if(t)return t.call(e);if(e&&typeof e.length=="number")return{next:function(){return e&&s>=e.length&&(e=void 0),{value:e&&e[s++],done:!e}}};throw new TypeError(n?"Object is not iterable.":"Symbol.iterator is not defined.")}function ja(e,n){var t=typeof Symbol=="function"&&e[Symbol.iterator];if(!t)return e;var s=t.call(e),a,r=[],u;try{for(;(n===void 0||n-- >0)&&!(a=s.next()).done;)r.push(a.value)}catch(i){u={error:i}}finally{try{a&&!a.done&&(t=s.return)&&t.call(s)}finally{if(u)throw u.error}}return r}function WD(){for(var e=[],n=0;n<arguments.length;n++)e=e.concat(ja(arguments[n]));return e}function $D(){for(var e=0,n=0,t=arguments.length;n<t;n++)e+=arguments[n].length;for(var s=Array(e),a=0,n=0;n<t;n++)for(var r=arguments[n],u=0,i=r.length;u<i;u++,a++)s[a]=r[u];return s}function Jt(e){return this instanceof Jt?(this.v=e,this):new Jt(e)}function HD(e,n,t){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var s=t.apply(e,n||[]),a,r=[];return a={},u("next"),u("throw"),u("return"),a[Symbol.asyncIterator]=function(){return this},a;function u(d){s[d]&&(a[d]=function(p){return new Promise(function(f,h){r.push([d,p,f,h])>1||i(d,p)})})}function i(d,p){try{o(s[d](p))}catch(f){m(r[0][3],f)}}function o(d){d.value instanceof Jt?Promise.resolve(d.value.v).then(c,v):m(r[0][2],d)}function c(d){i("next",d)}function v(d){i("throw",d)}function m(d,p){d(p),r.shift(),r.length&&i(r[0][0],r[0][1])}}function GD(e){var n,t;return n={},s("next"),s("throw",function(a){throw a}),s("return"),n[Symbol.iterator]=function(){return this},n;function s(a,r){n[a]=e[a]?function(u){return(t=!t)?{value:Jt(e[a](u)),done:a==="return"}:r?r(u):u}:r}}function JD(e){if(!Symbol.asyncIterator)throw new TypeError("Symbol.asyncIterator is not defined.");var n=e[Symbol.asyncIterator],t;return n?n.call(e):(e=typeof Nn=="function"?Nn(e):e[Symbol.iterator](),t={},s("next"),s("throw"),s("return"),t[Symbol.asyncIterator]=function(){return this},t);function s(r){t[r]=e[r]&&function(u){return new Promise(function(i,o){u=e[r](u),a(i,o,u.done,u.value)})}}function a(r,u,i,o){Promise.resolve(o).then(function(c){r({value:c,done:i})},u)}}function UD(e,n){return Object.defineProperty?Object.defineProperty(e,"raw",{value:n}):e.raw=n,e}function zD(e){if(e&&e.__esModule)return e;var n={};if(e!=null)for(var t in e)Object.hasOwnProperty.call(e,t)&&(n[t]=e[t]);return n.default=e,n}function XD(e){return e&&e.__esModule?e:{default:e}}function KD(e,n){if(!n.has(e))throw new TypeError("attempted to get private field on non-instance");return n.get(e)}function YD(e,n,t){if(!n.has(e))throw new TypeError("attempted to set private field on non-instance");return n.set(e,t),t}var xr,br,ht=mt({"node_modules/tslib/tslib.es6.js"(){re(),xr=function(e,n){return xr=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,s){t.__proto__=s}||function(t,s){for(var a in s)s.hasOwnProperty(a)&&(t[a]=s[a])},xr(e,n)},br=function(){return br=Object.assign||function(n){for(var t,s=1,a=arguments.length;s<a;s++){t=arguments[s];for(var r in t)Object.prototype.hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},br.apply(this,arguments)}}}),Oa=Z({"node_modules/vnopts/lib/descriptors/api.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0}),e.apiDescriptor={key:n=>/^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(n)?n:JSON.stringify(n),value(n){if(n===null||typeof n!="object")return JSON.stringify(n);if(Array.isArray(n))return"[".concat(n.map(s=>e.apiDescriptor.value(s)).join(", "),"]");let t=Object.keys(n);return t.length===0?"{}":"{ ".concat(t.map(s=>"".concat(e.apiDescriptor.key(s),": ").concat(e.apiDescriptor.value(n[s]))).join(", ")," }")},pair:n=>{let{key:t,value:s}=n;return e.apiDescriptor.value({[t]:s})}}}}),QD=Z({"node_modules/vnopts/lib/descriptors/index.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=(ht(),lt(dt));n.__exportStar(Oa(),e)}}),_r=Z({"scripts/build/shims/chalk.cjs"(e,n){"use strict";re();var t=s=>s;t.grey=t,t.red=t,t.bold=t,t.yellow=t,t.blue=t,t.default=t,n.exports=t}}),qa=Z({"node_modules/vnopts/lib/handlers/deprecated/common.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=_r();e.commonDeprecatedHandler=(t,s,a)=>{let{descriptor:r}=a,u=["".concat(n.default.yellow(typeof t=="string"?r.key(t):r.pair(t))," is deprecated")];return s&&u.push("we now treat it as ".concat(n.default.blue(typeof s=="string"?r.key(s):r.pair(s)))),u.join("; ")+"."}}}),ZD=Z({"node_modules/vnopts/lib/handlers/deprecated/index.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=(ht(),lt(dt));n.__exportStar(qa(),e)}}),em=Z({"node_modules/vnopts/lib/handlers/invalid/common.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=_r();e.commonInvalidHandler=(t,s,a)=>["Invalid ".concat(n.default.red(a.descriptor.key(t))," value."),"Expected ".concat(n.default.blue(a.schemas[t].expected(a)),","),"but received ".concat(n.default.red(a.descriptor.value(s)),".")].join(" ")}}),Ma=Z({"node_modules/vnopts/lib/handlers/invalid/index.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=(ht(),lt(dt));n.__exportStar(em(),e)}}),tm=Z({"node_modules/vnopts/node_modules/leven/index.js"(e,n){"use strict";re();var t=[],s=[];n.exports=function(a,r){if(a===r)return 0;var u=a;a.length>r.length&&(a=r,r=u);var i=a.length,o=r.length;if(i===0)return o;if(o===0)return i;for(;i>0&&a.charCodeAt(~-i)===r.charCodeAt(~-o);)i--,o--;if(i===0)return o;for(var c=0;c<i&&a.charCodeAt(c)===r.charCodeAt(c);)c++;if(i-=c,o-=c,i===0)return o;for(var v,m,d,p,f=0,h=0;f<i;)s[c+f]=a.charCodeAt(c+f),t[f]=++f;for(;h<o;)for(v=r.charCodeAt(c+h),d=h++,m=h,f=0;f<i;f++)p=v===s[c+f]?d:d+1,d=t[f],m=t[f]=d>m?p>m?m+1:p:p>d?d+1:p;return m}}}),Ra=Z({"node_modules/vnopts/lib/handlers/unknown/leven.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=_r(),t=tm();e.levenUnknownHandler=(s,a,r)=>{let{descriptor:u,logger:i,schemas:o}=r,c=["Ignored unknown option ".concat(n.default.yellow(u.pair({key:s,value:a})),".")],v=Object.keys(o).sort().find(m=>t(s,m)<3);v&&c.push("Did you mean ".concat(n.default.blue(u.key(v)),"?")),i.warn(c.join(" "))}}}),rm=Z({"node_modules/vnopts/lib/handlers/unknown/index.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=(ht(),lt(dt));n.__exportStar(Ra(),e)}}),nm=Z({"node_modules/vnopts/lib/handlers/index.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=(ht(),lt(dt));n.__exportStar(ZD(),e),n.__exportStar(Ma(),e),n.__exportStar(rm(),e)}}),vt=Z({"node_modules/vnopts/lib/schema.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=["default","expected","validate","deprecated","forward","redirect","overlap","preprocess","postprocess"];function t(r,u){let i=new r(u),o=Object.create(i);for(let c of n)c in u&&(o[c]=a(u[c],i,s.prototype[c].length));return o}e.createSchema=t;var s=class{constructor(r){this.name=r.name}static create(r){return t(this,r)}default(r){}expected(r){return"nothing"}validate(r,u){return!1}deprecated(r,u){return!1}forward(r,u){}redirect(r,u){}overlap(r,u,i){return r}preprocess(r,u){return r}postprocess(r,u){return r}};e.Schema=s;function a(r,u,i){return typeof r=="function"?function(){for(var o=arguments.length,c=new Array(o),v=0;v<o;v++)c[v]=arguments[v];return r(...c.slice(0,i-1),u,...c.slice(i-1))}:()=>r}}}),um=Z({"node_modules/vnopts/lib/schemas/alias.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=vt(),t=class extends n.Schema{constructor(s){super(s),this._sourceName=s.sourceName}expected(s){return s.schemas[this._sourceName].expected(s)}validate(s,a){return a.schemas[this._sourceName].validate(s,a)}redirect(s,a){return this._sourceName}};e.AliasSchema=t}}),sm=Z({"node_modules/vnopts/lib/schemas/any.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=vt(),t=class extends n.Schema{expected(){return"anything"}validate(){return!0}};e.AnySchema=t}}),im=Z({"node_modules/vnopts/lib/schemas/array.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=(ht(),lt(dt)),t=vt(),s=class extends t.Schema{constructor(r){var{valueSchema:u,name:i=u.name}=r,o=n.__rest(r,["valueSchema","name"]);super(Object.assign({},o,{name:i})),this._valueSchema=u}expected(r){return"an array of ".concat(this._valueSchema.expected(r))}validate(r,u){if(!Array.isArray(r))return!1;let i=[];for(let o of r){let c=u.normalizeValidateResult(this._valueSchema.validate(o,u),o);c!==!0&&i.push(c.value)}return i.length===0?!0:{value:i}}deprecated(r,u){let i=[];for(let o of r){let c=u.normalizeDeprecatedResult(this._valueSchema.deprecated(o,u),o);c!==!1&&i.push(...c.map(v=>{let{value:m}=v;return{value:[m]}}))}return i}forward(r,u){let i=[];for(let o of r){let c=u.normalizeForwardResult(this._valueSchema.forward(o,u),o);i.push(...c.map(a))}return i}redirect(r,u){let i=[],o=[];for(let c of r){let v=u.normalizeRedirectResult(this._valueSchema.redirect(c,u),c);"remain"in v&&i.push(v.remain),o.push(...v.redirect.map(a))}return i.length===0?{redirect:o}:{redirect:o,remain:i}}overlap(r,u){return r.concat(u)}};e.ArraySchema=s;function a(r){let{from:u,to:i}=r;return{from:[u],to:i}}}}),am=Z({"node_modules/vnopts/lib/schemas/boolean.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=vt(),t=class extends n.Schema{expected(){return"true or false"}validate(s){return typeof s=="boolean"}};e.BooleanSchema=t}}),Hn=Z({"node_modules/vnopts/lib/utils.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});function n(p,f){let h=Object.create(null);for(let w of p){let T=w[f];if(h[T])throw new Error("Duplicate ".concat(f," ").concat(JSON.stringify(T)));h[T]=w}return h}e.recordFromArray=n;function t(p,f){let h=new Map;for(let w of p){let T=w[f];if(h.has(T))throw new Error("Duplicate ".concat(f," ").concat(JSON.stringify(T)));h.set(T,w)}return h}e.mapFromArray=t;function s(){let p=Object.create(null);return f=>{let h=JSON.stringify(f);return p[h]?!0:(p[h]=!0,!1)}}e.createAutoChecklist=s;function a(p,f){let h=[],w=[];for(let T of p)f(T)?h.push(T):w.push(T);return[h,w]}e.partition=a;function r(p){return p===Math.floor(p)}e.isInt=r;function u(p,f){if(p===f)return 0;let h=typeof p,w=typeof f,T=["undefined","object","boolean","number","string"];return h!==w?T.indexOf(h)-T.indexOf(w):h!=="string"?Number(p)-Number(f):p.localeCompare(f)}e.comparePrimitive=u;function i(p){return p===void 0?{}:p}e.normalizeDefaultResult=i;function o(p,f){return p===!0?!0:p===!1?{value:f}:p}e.normalizeValidateResult=o;function c(p,f){let h=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!1;return p===!1?!1:p===!0?h?!0:[{value:f}]:"value"in p?[p]:p.length===0?!1:p}e.normalizeDeprecatedResult=c;function v(p,f){return typeof p=="string"||"key"in p?{from:f,to:p}:"from"in p?{from:p.from,to:p.to}:{from:f,to:p.to}}e.normalizeTransferResult=v;function m(p,f){return p===void 0?[]:Array.isArray(p)?p.map(h=>v(h,f)):[v(p,f)]}e.normalizeForwardResult=m;function d(p,f){let h=m(typeof p=="object"&&"redirect"in p?p.redirect:p,f);return h.length===0?{remain:f,redirect:h}:typeof p=="object"&&"remain"in p?{remain:p.remain,redirect:h}:{redirect:h}}e.normalizeRedirectResult=d}}),om=Z({"node_modules/vnopts/lib/schemas/choice.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=vt(),t=Hn(),s=class extends n.Schema{constructor(a){super(a),this._choices=t.mapFromArray(a.choices.map(r=>r&&typeof r=="object"?r:{value:r}),"value")}expected(a){let{descriptor:r}=a,u=Array.from(this._choices.keys()).map(c=>this._choices.get(c)).filter(c=>!c.deprecated).map(c=>c.value).sort(t.comparePrimitive).map(r.value),i=u.slice(0,-2),o=u.slice(-2);return i.concat(o.join(" or ")).join(", ")}validate(a){return this._choices.has(a)}deprecated(a){let r=this._choices.get(a);return r&&r.deprecated?{value:a}:!1}forward(a){let r=this._choices.get(a);return r?r.forward:void 0}redirect(a){let r=this._choices.get(a);return r?r.redirect:void 0}};e.ChoiceSchema=s}}),Va=Z({"node_modules/vnopts/lib/schemas/number.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=vt(),t=class extends n.Schema{expected(){return"a number"}validate(s,a){return typeof s=="number"}};e.NumberSchema=t}}),lm=Z({"node_modules/vnopts/lib/schemas/integer.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=Hn(),t=Va(),s=class extends t.NumberSchema{expected(){return"an integer"}validate(a,r){return r.normalizeValidateResult(super.validate(a,r),a)===!0&&n.isInt(a)}};e.IntegerSchema=s}}),cm=Z({"node_modules/vnopts/lib/schemas/string.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=vt(),t=class extends n.Schema{expected(){return"a string"}validate(s){return typeof s=="string"}};e.StringSchema=t}}),pm=Z({"node_modules/vnopts/lib/schemas/index.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=(ht(),lt(dt));n.__exportStar(um(),e),n.__exportStar(sm(),e),n.__exportStar(im(),e),n.__exportStar(am(),e),n.__exportStar(om(),e),n.__exportStar(lm(),e),n.__exportStar(Va(),e),n.__exportStar(cm(),e)}}),fm=Z({"node_modules/vnopts/lib/defaults.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=Oa(),t=qa(),s=Ma(),a=Ra();e.defaultDescriptor=n.apiDescriptor,e.defaultUnknownHandler=a.levenUnknownHandler,e.defaultInvalidHandler=s.commonInvalidHandler,e.defaultDeprecatedHandler=t.commonDeprecatedHandler}}),Dm=Z({"node_modules/vnopts/lib/normalize.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=fm(),t=Hn();e.normalize=(a,r,u)=>new s(r,u).normalize(a);var s=class{constructor(a,r){let{logger:u=console,descriptor:i=n.defaultDescriptor,unknown:o=n.defaultUnknownHandler,invalid:c=n.defaultInvalidHandler,deprecated:v=n.defaultDeprecatedHandler}=r||{};this._utils={descriptor:i,logger:u||{warn:()=>{}},schemas:t.recordFromArray(a,"name"),normalizeDefaultResult:t.normalizeDefaultResult,normalizeDeprecatedResult:t.normalizeDeprecatedResult,normalizeForwardResult:t.normalizeForwardResult,normalizeRedirectResult:t.normalizeRedirectResult,normalizeValidateResult:t.normalizeValidateResult},this._unknownHandler=o,this._invalidHandler=c,this._deprecatedHandler=v,this.cleanHistory()}cleanHistory(){this._hasDeprecationWarned=t.createAutoChecklist()}normalize(a){let r={},u=[a],i=()=>{for(;u.length!==0;){let o=u.shift(),c=this._applyNormalization(o,r);u.push(...c)}};i();for(let o of Object.keys(this._utils.schemas)){let c=this._utils.schemas[o];if(!(o in r)){let v=t.normalizeDefaultResult(c.default(this._utils));"value"in v&&u.push({[o]:v.value})}}i();for(let o of Object.keys(this._utils.schemas)){let c=this._utils.schemas[o];o in r&&(r[o]=c.postprocess(r[o],this._utils))}return r}_applyNormalization(a,r){let u=[],[i,o]=t.partition(Object.keys(a),c=>c in this._utils.schemas);for(let c of i){let v=this._utils.schemas[c],m=v.preprocess(a[c],this._utils),d=t.normalizeValidateResult(v.validate(m,this._utils),m);if(d!==!0){let{value:T}=d,A=this._invalidHandler(c,T,this._utils);throw typeof A=="string"?new Error(A):A}let p=T=>{let{from:A,to:S}=T;u.push(typeof S=="string"?{[S]:A}:{[S.key]:S.value})},f=T=>{let{value:A,redirectTo:S}=T,B=t.normalizeDeprecatedResult(v.deprecated(A,this._utils),m,!0);if(B!==!1)if(B===!0)this._hasDeprecationWarned(c)||this._utils.logger.warn(this._deprecatedHandler(c,S,this._utils));else for(let{value:I}of B){let k={key:c,value:I};if(!this._hasDeprecationWarned(k)){let P=typeof S=="string"?{key:S,value:I}:S;this._utils.logger.warn(this._deprecatedHandler(k,P,this._utils))}}};t.normalizeForwardResult(v.forward(m,this._utils),m).forEach(p);let w=t.normalizeRedirectResult(v.redirect(m,this._utils),m);if(w.redirect.forEach(p),"remain"in w){let T=w.remain;r[c]=c in r?v.overlap(r[c],T,this._utils):T,f({value:T})}for(let{from:T,to:A}of w.redirect)f({value:T,redirectTo:A})}for(let c of o){let v=a[c],m=this._unknownHandler(c,v,this._utils);if(m)for(let d of Object.keys(m)){let p={[d]:m[d]};d in this._utils.schemas?u.push(p):Object.assign(r,p)}}return u}};e.Normalizer=s}}),mm=Z({"node_modules/vnopts/lib/index.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=(ht(),lt(dt));n.__exportStar(QD(),e),n.__exportStar(nm(),e),n.__exportStar(pm(),e),n.__exportStar(Dm(),e),n.__exportStar(vt(),e)}}),dm=Z({"src/main/options-normalizer.js"(e,n){"use strict";re();var t=mm(),s=it(),a={key:d=>d.length===1?"-".concat(d):"--".concat(d),value:d=>t.apiDescriptor.value(d),pair:d=>{let{key:p,value:f}=d;return f===!1?"--no-".concat(p):f===!0?a.key(p):f===""?"".concat(a.key(p)," without an argument"):"".concat(a.key(p),"=").concat(f)}},r=d=>{let{colorsModule:p,levenshteinDistance:f}=d;return class extends t.ChoiceSchema{constructor(w){let{name:T,flags:A}=w;super({name:T,choices:A}),this._flags=[...A].sort()}preprocess(w,T){if(typeof w=="string"&&w.length>0&&!this._flags.includes(w)){let A=this._flags.find(S=>f(S,w)<3);if(A)return T.logger.warn(["Unknown flag ".concat(p.yellow(T.descriptor.value(w)),","),"did you mean ".concat(p.blue(T.descriptor.value(A)),"?")].join(" ")),A}return w}expected(){return"a flag"}}},u;function i(d,p){let{logger:f=!1,isCLI:h=!1,passThrough:w=!1,colorsModule:T=null,levenshteinDistance:A=null}=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{},S=w?Array.isArray(w)?(D,g)=>w.includes(D)?{[D]:g}:void 0:(D,g)=>({[D]:g}):(D,g,F)=>{let l=F.schemas,{_:E}=l,y=kn(l,Qf);return t.levenUnknownHandler(D,g,Object.assign(Object.assign({},F),{},{schemas:y}))},B=h?a:t.apiDescriptor,I=o(p,{isCLI:h,colorsModule:T,levenshteinDistance:A}),k=new t.Normalizer(I,{logger:f,unknown:S,descriptor:B}),P=f!==!1;P&&u&&(k._hasDeprecationWarned=u);let C=k.normalize(d);return P&&(u=k._hasDeprecationWarned),h&&C["plugin-search"]===!1&&(C["plugin-search-dir"]=!1),C}function o(d,p){let{isCLI:f,colorsModule:h,levenshteinDistance:w}=p,T=[];f&&T.push(t.AnySchema.create({name:"_"}));for(let A of d)T.push(c(A,{isCLI:f,optionInfos:d,colorsModule:h,levenshteinDistance:w})),A.alias&&f&&T.push(t.AliasSchema.create({name:A.alias,sourceName:A.name}));return T}function c(d,p){let{isCLI:f,optionInfos:h,colorsModule:w,levenshteinDistance:T}=p,{name:A}=d;if(A==="plugin-search-dir"||A==="pluginSearchDirs")return t.AnySchema.create({name:A,preprocess(k){return k===!1||(k=Array.isArray(k)?k:[k]),k},validate(k){return k===!1?!0:k.every(P=>typeof P=="string")},expected(){return"false or paths to plugin search dir"}});let S={name:A},B,I={};switch(d.type){case"int":B=t.IntegerSchema,f&&(S.preprocess=Number);break;case"string":B=t.StringSchema;break;case"choice":B=t.ChoiceSchema,S.choices=d.choices.map(k=>typeof k=="object"&&k.redirect?Object.assign(Object.assign({},k),{},{redirect:{to:{key:d.name,value:k.redirect}}}):k);break;case"boolean":B=t.BooleanSchema;break;case"flag":B=r({colorsModule:w,levenshteinDistance:T}),S.flags=h.flatMap(k=>[k.alias,k.description&&k.name,k.oppositeDescription&&"no-".concat(k.name)].filter(Boolean));break;case"path":B=t.StringSchema;break;default:throw new Error("Unexpected type ".concat(d.type))}if(d.exception?S.validate=(k,P,C)=>d.exception(k)||P.validate(k,C):S.validate=(k,P,C)=>k===void 0||P.validate(k,C),d.redirect&&(I.redirect=k=>k?{to:{key:d.redirect.option,value:d.redirect.value}}:void 0),d.deprecated&&(I.deprecated=!0),f&&!d.array){let k=S.preprocess||(P=>P);S.preprocess=(P,C,D)=>C.preprocess(k(Array.isArray(P)?s(P):P),D)}return d.array?t.ArraySchema.create(Object.assign(Object.assign(Object.assign({},f?{preprocess:k=>Array.isArray(k)?k:[k]}:{}),I),{},{valueSchema:B.create(S)})):B.create(Object.assign(Object.assign({},S),I))}function v(d,p,f){return i(d,p,f)}function m(d,p,f){return i(d,p,Object.assign({isCLI:!0},f))}n.exports={normalizeApiOptions:v,normalizeCliOptions:m}}}),st=Z({"src/language-js/loc.js"(e,n){"use strict";re();var t=Rn();function s(o,c){let{ignoreDecorators:v}=c||{};if(!v){let m=o.declaration&&o.declaration.decorators||o.decorators;if(t(m))return s(m[0])}return o.range?o.range[0]:o.start}function a(o){return o.range?o.range[1]:o.end}function r(o,c){let v=s(o);return Number.isInteger(v)&&v===s(c)}function u(o,c){let v=a(o);return Number.isInteger(v)&&v===a(c)}function i(o,c){return r(o,c)&&u(o,c)}n.exports={locStart:s,locEnd:a,hasSameLocStart:r,hasSameLoc:i}}}),gm=Z({"src/main/load-parser.js"(e,n){re(),n.exports=()=>{}}}),ym=Z({"scripts/build/shims/babel-highlight.cjs"(e,n){"use strict";re();var t=_r(),s={shouldHighlight:()=>!1,getChalk:()=>t};n.exports=s}}),hm=Z({"node_modules/@babel/code-frame/lib/index.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0}),e.codeFrameColumns=u,e.default=i;var n=ym(),t=!1;function s(o){return{gutter:o.grey,marker:o.red.bold,message:o.red.bold}}var a=/\r\n|[\n\r\u2028\u2029]/;function r(o,c,v){let m=Object.assign({column:0,line:-1},o.start),d=Object.assign({},m,o.end),{linesAbove:p=2,linesBelow:f=3}=v||{},h=m.line,w=m.column,T=d.line,A=d.column,S=Math.max(h-(p+1),0),B=Math.min(c.length,T+f);h===-1&&(S=0),T===-1&&(B=c.length);let I=T-h,k={};if(I)for(let P=0;P<=I;P++){let C=P+h;if(!w)k[C]=!0;else if(P===0){let D=c[C-1].length;k[C]=[w,D-w+1]}else if(P===I)k[C]=[0,A];else{let D=c[C-P].length;k[C]=[0,D]}}else w===A?w?k[h]=[w,0]:k[h]=!0:k[h]=[w,A-w];return{start:S,end:B,markerLines:k}}function u(o,c){let v=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{},m=(v.highlightCode||v.forceColor)&&(0,n.shouldHighlight)(v),d=(0,n.getChalk)(v),p=s(d),f=(P,C)=>m?P(C):C,h=o.split(a),{start:w,end:T,markerLines:A}=r(c,h,v),S=c.start&&typeof c.start.column=="number",B=String(T).length,k=(m?(0,n.default)(o,v):o).split(a,T).slice(w,T).map((P,C)=>{let D=w+1+C,g=" ".concat(D).slice(-B),F=" ".concat(g," |"),l=A[D],E=!A[D+1];if(l){let y="";if(Array.isArray(l)){let N=P.slice(0,Math.max(l[0]-1,0)).replace(/[^\t]/g," "),x=l[1]||1;y=[`
 `,f(p.gutter,F.replace(/\d/g," "))," ",N,f(p.marker,"^").repeat(x)].join(""),E&&v.message&&(y+=" "+f(p.message,v.message))}return[f(p.marker,">"),f(p.gutter,F),P.length>0?" ".concat(P):"",y].join("")}else return" ".concat(f(p.gutter,F)).concat(P.length>0?" ".concat(P):"")}).join(`
`);return v.message&&!S&&(k="".concat(" ".repeat(B+1)).concat(v.message,`
`).concat(k)),m?d.reset(k):k}function i(o,c,v){let m=arguments.length>3&&arguments[3]!==void 0?arguments[3]:{};if(!t){t=!0;let p="Passing lineNumber and colNumber is deprecated to @babel/code-frame. Please use `codeFrameColumns`.";if(Tt.emitWarning)Tt.emitWarning(p,"DeprecationWarning");else{let f=new Error(p);f.name="DeprecationWarning",console.warn(new Error(p))}}return v=Math.max(v,0),u(o,{start:{column:v,line:c}},m)}}}),Gn=Z({"src/main/parser.js"(e,n){"use strict";re();var{ConfigError:t}=zt(),s=st(),a=gm(),{locStart:r,locEnd:u}=s,i=Object.getOwnPropertyNames,o=Object.getOwnPropertyDescriptor;function c(d){let p={};for(let f of d.plugins)if(!!f.parsers)for(let h of i(f.parsers))Object.defineProperty(p,h,o(f.parsers,h));return p}function v(d){let p=arguments.length>1&&arguments[1]!==void 0?arguments[1]:c(d);if(typeof d.parser=="function")return{parse:d.parser,astFormat:"estree",locStart:r,locEnd:u};if(typeof d.parser=="string"){if(Object.prototype.hasOwnProperty.call(p,d.parser))return p[d.parser];throw new t(`Couldn't resolve parser "`.concat(d.parser,'". Parsers must be explicitly added to the standalone bundle.'))}}function m(d,p){let f=c(p),h=Object.defineProperties({},Object.fromEntries(Object.keys(f).map(T=>[T,{enumerable:!0,get(){return f[T].parse}}]))),w=v(p,f);try{return w.preprocess&&(d=w.preprocess(d,p)),{text:d,ast:w.parse(d,h,p)}}catch(T){let{loc:A}=T;if(A){let{codeFrameColumns:S}=hm();throw T.codeFrame=S(d,A,{highlightCode:!0}),T.message+=`
`+T.codeFrame,T}throw T.stack}}n.exports={parse:m,resolveParser:v}}}),Wa=Z({"src/main/options.js"(e,n){"use strict";re();var t=PD(),{UndefinedParserError:s}=zt(),{getSupportInfo:a}=Mn(),r=dm(),{resolveParser:u}=Gn(),i={astFormat:"estree",printer:{},originalText:void 0,locStart:null,locEnd:null};function o(m){let d=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{},p=Object.assign({},m),f=a({plugins:m.plugins,showUnreleased:!0,showDeprecated:!0}).options,h=Object.assign(Object.assign({},i),Object.fromEntries(f.filter(B=>B.default!==void 0).map(B=>[B.name,B.default])));if(!p.parser){if(!p.filepath)(d.logger||console).warn("No parser and no filepath given, using 'babel' the parser now but this will throw an error in the future. Please specify a parser or a filepath so one can be inferred."),p.parser="babel";else if(p.parser=v(p.filepath,p.plugins),!p.parser)throw new s("No parser could be inferred for file: ".concat(p.filepath))}let w=u(r.normalizeApiOptions(p,[f.find(B=>B.name==="parser")],{passThrough:!0,logger:!1}));p.astFormat=w.astFormat,p.locEnd=w.locEnd,p.locStart=w.locStart;let T=c(p);p.printer=T.printers[p.astFormat];let A=Object.fromEntries(f.filter(B=>B.pluginDefaults&&B.pluginDefaults[T.name]!==void 0).map(B=>[B.name,B.pluginDefaults[T.name]])),S=Object.assign(Object.assign({},h),A);for(let[B,I]of Object.entries(S))(p[B]===null||p[B]===void 0)&&(p[B]=I);return p.parser==="json"&&(p.trailingComma="none"),r.normalizeApiOptions(p,f,Object.assign({passThrough:Object.keys(i)},d))}function c(m){let{astFormat:d}=m;if(!d)throw new Error("getPlugin() requires astFormat to be set");let p=m.plugins.find(f=>f.printers&&f.printers[d]);if(!p)throw new Error(`Couldn't find plugin for AST format "`.concat(d,'"'));return p}function v(m,d){let p=t.basename(m).toLowerCase(),h=a({plugins:d}).languages.filter(w=>w.since!==null).find(w=>w.extensions&&w.extensions.some(T=>p.endsWith(T))||w.filenames&&w.filenames.some(T=>T.toLowerCase()===p));return h&&h.parsers[0]}n.exports={normalize:o,hiddenDefaults:i,inferParser:v}}}),vm=Z({"src/main/massage-ast.js"(e,n){"use strict";re();function t(s,a,r){if(Array.isArray(s))return s.map(c=>t(c,a,r)).filter(Boolean);if(!s||typeof s!="object")return s;let u=a.printer.massageAstNode,i;u&&u.ignoredProperties?i=u.ignoredProperties:i=new Set;let o={};for(let[c,v]of Object.entries(s))!i.has(c)&&typeof v!="function"&&(o[c]=t(v,a,s));if(u){let c=u(s,o,r);if(c===null)return;if(c)return c}return o}n.exports=t}}),Xt=Z({"scripts/build/shims/assert.cjs"(e,n){"use strict";re();var t=()=>{};t.ok=t,t.strictEqual=t,n.exports=t}}),et=Z({"src/main/comments.js"(e,n){"use strict";re();var t=Xt(),{builders:{line:s,hardline:a,breakParent:r,indent:u,lineSuffix:i,join:o,cursor:c}}=Oe(),{hasNewline:v,skipNewline:m,skipSpaces:d,isPreviousLineEmpty:p,addLeadingComment:f,addDanglingComment:h,addTrailingComment:w}=Ue(),T=new WeakMap;function A(L,M,j){if(!L)return;let{printer:$,locStart:V,locEnd:q}=M;if(j){if($.canAttachComment&&$.canAttachComment(L)){let H;for(H=j.length-1;H>=0&&!(V(j[H])<=V(L)&&q(j[H])<=q(L));--H);j.splice(H+1,0,L);return}}else if(T.has(L))return T.get(L);let Y=$.getCommentChildNodes&&$.getCommentChildNodes(L,M)||typeof L=="object"&&Object.entries(L).filter(H=>{let[R]=H;return R!=="enclosingNode"&&R!=="precedingNode"&&R!=="followingNode"&&R!=="tokens"&&R!=="comments"&&R!=="parent"}).map(H=>{let[,R]=H;return R});if(!!Y){j||(j=[],T.set(L,j));for(let H of Y)A(H,M,j);return j}}function S(L,M,j,$){let{locStart:V,locEnd:q}=j,Y=V(M),H=q(M),R=A(L,j),Q,ee,te=0,oe=R.length;for(;te<oe;){let W=te+oe>>1,X=R[W],ue=V(X),De=q(X);if(ue<=Y&&H<=De)return S(X,M,j,X);if(De<=Y){Q=X,te=W+1;continue}if(H<=ue){ee=X,oe=W;continue}throw new Error("Comment location overlaps with node location")}if($&&$.type==="TemplateLiteral"){let{quasis:W}=$,X=F(W,M,j);Q&&F(W,Q,j)!==X&&(Q=null),ee&&F(W,ee,j)!==X&&(ee=null)}return{enclosingNode:$,precedingNode:Q,followingNode:ee}}var B=()=>!1;function I(L,M,j,$){if(!Array.isArray(L))return;let V=[],{locStart:q,locEnd:Y,printer:{handleComments:H={}}}=$,{avoidAstMutation:R,ownLine:Q=B,endOfLine:ee=B,remaining:te=B}=H,oe=L.map((W,X)=>Object.assign(Object.assign({},S(M,W,$)),{},{comment:W,text:j,options:$,ast:M,isLastComment:L.length-1===X}));for(let[W,X]of oe.entries()){let{comment:ue,precedingNode:De,enclosingNode:ie,followingNode:G,text:z,options:U,ast:le,isLastComment:ge}=X;if(U.parser==="json"||U.parser==="json5"||U.parser==="__js_expression"||U.parser==="__vue_expression"||U.parser==="__vue_ts_expression"){if(q(ue)-q(le)<=0){f(le,ue);continue}if(Y(ue)-Y(le)>=0){w(le,ue);continue}}let Ae;if(R?Ae=[X]:(ue.enclosingNode=ie,ue.precedingNode=De,ue.followingNode=G,Ae=[ue,z,U,le,ge]),P(z,U,oe,W))ue.placement="ownLine",Q(...Ae)||(G?f(G,ue):De?w(De,ue):h(ie||le,ue));else if(C(z,U,oe,W))ue.placement="endOfLine",ee(...Ae)||(De?w(De,ue):G?f(G,ue):h(ie||le,ue));else if(ue.placement="remaining",!te(...Ae))if(De&&G){let Ne=V.length;Ne>0&&V[Ne-1].followingNode!==G&&D(V,z,U),V.push(X)}else De?w(De,ue):G?f(G,ue):h(ie||le,ue)}if(D(V,j,$),!R)for(let W of L)delete W.precedingNode,delete W.enclosingNode,delete W.followingNode}var k=L=>!/[\S\n\u2028\u2029]/.test(L);function P(L,M,j,$){let{comment:V,precedingNode:q}=j[$],{locStart:Y,locEnd:H}=M,R=Y(V);if(q)for(let Q=$-1;Q>=0;Q--){let{comment:ee,precedingNode:te}=j[Q];if(te!==q||!k(L.slice(H(ee),R)))break;R=Y(ee)}return v(L,R,{backwards:!0})}function C(L,M,j,$){let{comment:V,followingNode:q}=j[$],{locStart:Y,locEnd:H}=M,R=H(V);if(q)for(let Q=$+1;Q<j.length;Q++){let{comment:ee,followingNode:te}=j[Q];if(te!==q||!k(L.slice(R,Y(ee))))break;R=H(ee)}return v(L,R)}function D(L,M,j){let $=L.length;if($===0)return;let{precedingNode:V,followingNode:q,enclosingNode:Y}=L[0],H=j.printer.getGapRegex&&j.printer.getGapRegex(Y)||/^[\s(]*$/,R=j.locStart(q),Q;for(Q=$;Q>0;--Q){let{comment:ee,precedingNode:te,followingNode:oe}=L[Q-1];t.strictEqual(te,V),t.strictEqual(oe,q);let W=M.slice(j.locEnd(ee),R);if(H.test(W))R=j.locStart(ee);else break}for(let[ee,{comment:te}]of L.entries())ee<Q?w(V,te):f(q,te);for(let ee of[V,q])ee.comments&&ee.comments.length>1&&ee.comments.sort((te,oe)=>j.locStart(te)-j.locStart(oe));L.length=0}function g(L,M){let j=L.getValue();return j.printed=!0,M.printer.printComment(L,M)}function F(L,M,j){let $=j.locStart(M)-1;for(let V=1;V<L.length;++V)if($<j.locStart(L[V]))return V-1;return 0}function l(L,M){let j=L.getValue(),$=[g(L,M)],{printer:V,originalText:q,locStart:Y,locEnd:H}=M;if(V.isBlockComment&&V.isBlockComment(j)){let ee=v(q,H(j))?v(q,Y(j),{backwards:!0})?a:s:" ";$.push(ee)}else $.push(a);let Q=m(q,d(q,H(j)));return Q!==!1&&v(q,Q)&&$.push(a),$}function E(L,M){let j=L.getValue(),$=g(L,M),{printer:V,originalText:q,locStart:Y}=M,H=V.isBlockComment&&V.isBlockComment(j);if(v(q,Y(j),{backwards:!0})){let Q=p(q,j,Y);return i([a,Q?a:"",$])}let R=[" ",$];return H||(R=[i(R),r]),R}function y(L,M,j,$){let V=[],q=L.getValue();return!q||!q.comments||(L.each(()=>{let Y=L.getValue();!Y.leading&&!Y.trailing&&(!$||$(Y))&&V.push(g(L,M))},"comments"),V.length===0)?"":j?o(a,V):u([a,o(a,V)])}function N(L,M,j){let $=L.getValue();if(!$)return{};let V=$.comments||[];j&&(V=V.filter(R=>!j.has(R)));let q=$===M.cursorNode;if(V.length===0){let R=q?c:"";return{leading:R,trailing:R}}let Y=[],H=[];return L.each(()=>{let R=L.getValue();if(j&&j.has(R))return;let{leading:Q,trailing:ee}=R;Q?Y.push(l(L,M)):ee&&H.push(E(L,M))},"comments"),q&&(Y.unshift(c),H.push(c)),{leading:Y,trailing:H}}function x(L,M,j,$){let{leading:V,trailing:q}=N(L,j,$);return!V&&!q?M:[V,M,q]}function b(L){if(!!L)for(let M of L){if(!M.printed)throw new Error('Comment "'+M.value.trim()+'" was not printed. Please report this error!');delete M.printed}}n.exports={attach:I,printComments:x,printCommentsSeparately:N,printDanglingComments:y,getSortedChildNodes:A,ensureAllCommentsPrinted:b}}}),Cm=Z({"src/common/ast-path.js"(e,n){"use strict";re();var t=it();function s(u,i){let o=a(u.stack,i);return o===-1?null:u.stack[o]}function a(u,i){for(let o=u.length-1;o>=0;o-=2){let c=u[o];if(c&&!Array.isArray(c)&&--i<0)return o}return-1}var r=class{constructor(u){this.stack=[u]}getName(){let{stack:u}=this,{length:i}=u;return i>1?u[i-2]:null}getValue(){return t(this.stack)}getNode(){let u=arguments.length>0&&arguments[0]!==void 0?arguments[0]:0;return s(this,u)}getParentNode(){let u=arguments.length>0&&arguments[0]!==void 0?arguments[0]:0;return s(this,u+1)}call(u){let{stack:i}=this,{length:o}=i,c=t(i);for(var v=arguments.length,m=new Array(v>1?v-1:0),d=1;d<v;d++)m[d-1]=arguments[d];for(let f of m)c=c[f],i.push(f,c);let p=u(this);return i.length=o,p}callParent(u){let i=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0,o=a(this.stack,i+1),c=this.stack.splice(o+1),v=u(this);return this.stack.push(...c),v}each(u){let{stack:i}=this,{length:o}=i,c=t(i);for(var v=arguments.length,m=new Array(v>1?v-1:0),d=1;d<v;d++)m[d-1]=arguments[d];for(let p of m)c=c[p],i.push(p,c);for(let p=0;p<c.length;++p)i.push(p,c[p]),u(this,p,c),i.length-=2;i.length=o}map(u){let i=[];for(var o=arguments.length,c=new Array(o>1?o-1:0),v=1;v<o;v++)c[v-1]=arguments[v];return this.each((m,d,p)=>{i[d]=u(m,d,p)},...c),i}try(u){let{stack:i}=this,o=[...i];try{return u()}finally{i.length=0,i.push(...o)}}match(){let u=this.stack.length-1,i=null,o=this.stack[u--];for(var c=arguments.length,v=new Array(c),m=0;m<c;m++)v[m]=arguments[m];for(let d of v){if(o===void 0)return!1;let p=null;if(typeof i=="number"&&(p=i,i=this.stack[u--],o=this.stack[u--]),d&&!d(o,i,p))return!1;i=this.stack[u--],o=this.stack[u--]}return!0}findAncestor(u){let i=this.stack.length-1,o=null,c=this.stack[i--];for(;c;){let v=null;if(typeof o=="number"&&(v=o,o=this.stack[i--],c=this.stack[i--]),o!==null&&u(c,o,v))return c;o=this.stack[i--],c=this.stack[i--]}}};n.exports=r}}),Em=Z({"src/main/multiparser.js"(e,n){"use strict";re();var{utils:{stripTrailingHardline:t}}=Oe(),{normalize:s}=Wa(),a=et();function r(i,o,c,v){if(c.printer.embed&&c.embeddedLanguageFormatting==="auto")return c.printer.embed(i,o,(m,d,p)=>u(m,d,c,v,p),c)}function u(i,o,c,v){let{stripTrailingHardline:m=!1}=arguments.length>4&&arguments[4]!==void 0?arguments[4]:{},d=s(Object.assign(Object.assign(Object.assign({},c),o),{},{parentParser:c.parser,originalText:i}),{passThrough:!0}),p=Gn().parse(i,d),{ast:f}=p;i=p.text;let h=f.comments;delete f.comments,a.attach(h,f,i,d),d[Symbol.for("comments")]=h||[],d[Symbol.for("tokens")]=f.tokens||[];let w=v(f,d);return a.ensureAllCommentsPrinted(h),m?typeof w=="string"?w.replace(/(?:\r?\n)*$/,""):t(w):w}n.exports={printSubtree:r}}}),Fm=Z({"src/main/ast-to-doc.js"(e,n){"use strict";re();var t=Cm(),{builders:{hardline:s,addAlignmentToDoc:a},utils:{propagateBreaks:r}}=Oe(),{printComments:u}=et(),i=Em();function o(m,d){let p=arguments.length>2&&arguments[2]!==void 0?arguments[2]:0,{printer:f}=d;f.preprocess&&(m=f.preprocess(m,d));let h=new Map,w=new t(m),T=A();return p>0&&(T=a([s,T],p,d.tabWidth)),r(T),T;function A(B,I){return B===void 0||B===w?S(I):Array.isArray(B)?w.call(()=>S(I),...B):w.call(()=>S(I),B)}function S(B){let I=w.getValue(),k=I&&typeof I=="object"&&B===void 0;if(k&&h.has(I))return h.get(I);let P=v(w,d,A,B);return k&&h.set(I,P),P}}function c(m,d){let{originalText:p,[Symbol.for("comments")]:f,locStart:h,locEnd:w}=d,T=h(m),A=w(m),S=new Set;for(let B of f)h(B)>=T&&w(B)<=A&&(B.printed=!0,S.add(B));return{doc:p.slice(T,A),printedComments:S}}function v(m,d,p,f){let h=m.getValue(),{printer:w}=d,T,A;if(w.hasPrettierIgnore&&w.hasPrettierIgnore(m))({doc:T,printedComments:A}=c(h,d));else{if(h)try{T=i.printSubtree(m,p,d,o)}catch(S){if(globalThis.PRETTIER_DEBUG)throw S}T||(T=w.print(m,d,p,f))}return(!w.willPrintOwnComments||!w.willPrintOwnComments(m,d))&&(T=u(m,T,d,A)),T}n.exports=o}}),Am=Z({"src/main/range-util.js"(e,n){"use strict";re();var t=Xt(),s=et(),a=f=>{let{parser:h}=f;return h==="json"||h==="json5"||h==="json-stringify"};function r(f,h){let w=[f.node,...f.parentNodes],T=new Set([h.node,...h.parentNodes]);return w.find(A=>v.has(A.type)&&T.has(A))}function u(f){let h=f.length-1;for(;;){let w=f[h];if(w&&(w.type==="Program"||w.type==="File"))h--;else break}return f.slice(0,h+1)}function i(f,h,w){let{locStart:T,locEnd:A}=w,S=f.node,B=h.node;if(S===B)return{startNode:S,endNode:B};let I=T(f.node);for(let P of u(h.parentNodes))if(T(P)>=I)B=P;else break;let k=A(h.node);for(let P of u(f.parentNodes))if(A(P)<=k)S=P;else break;return{startNode:S,endNode:B}}function o(f,h,w,T){let A=arguments.length>4&&arguments[4]!==void 0?arguments[4]:[],S=arguments.length>5?arguments[5]:void 0,{locStart:B,locEnd:I}=w,k=B(f),P=I(f);if(!(h>P||h<k||S==="rangeEnd"&&h===k||S==="rangeStart"&&h===P)){for(let C of s.getSortedChildNodes(f,w)){let D=o(C,h,w,T,[f,...A],S);if(D)return D}if(!T||T(f,A[0]))return{node:f,parentNodes:A}}}function c(f,h){return h!=="DeclareExportDeclaration"&&f!=="TypeParameterDeclaration"&&(f==="Directive"||f==="TypeAlias"||f==="TSExportAssignment"||f.startsWith("Declare")||f.startsWith("TSDeclare")||f.endsWith("Statement")||f.endsWith("Declaration"))}var v=new Set(["ObjectExpression","ArrayExpression","StringLiteral","NumericLiteral","BooleanLiteral","NullLiteral","UnaryExpression","TemplateLiteral"]),m=new Set(["OperationDefinition","FragmentDefinition","VariableDefinition","TypeExtensionDefinition","ObjectTypeDefinition","FieldDefinition","DirectiveDefinition","EnumTypeDefinition","EnumValueDefinition","InputValueDefinition","InputObjectTypeDefinition","SchemaDefinition","OperationTypeDefinition","InterfaceTypeDefinition","UnionTypeDefinition","ScalarTypeDefinition"]);function d(f,h,w){if(!h)return!1;switch(f.parser){case"flow":case"babel":case"babel-flow":case"babel-ts":case"typescript":case"acorn":case"espree":case"meriyah":case"__babel_estree":return c(h.type,w&&w.type);case"json":case"json5":case"json-stringify":return v.has(h.type);case"graphql":return m.has(h.kind);case"vue":return h.tag!=="root"}return!1}function p(f,h,w){let{rangeStart:T,rangeEnd:A,locStart:S,locEnd:B}=h;t.ok(A>T);let I=f.slice(T,A).search(/\S/),k=I===-1;if(!k)for(T+=I;A>T&&!/\S/.test(f[A-1]);--A);let P=o(w,T,h,(F,l)=>d(h,F,l),[],"rangeStart"),C=k?P:o(w,A,h,F=>d(h,F),[],"rangeEnd");if(!P||!C)return{rangeStart:0,rangeEnd:0};let D,g;if(a(h)){let F=r(P,C);D=F,g=F}else({startNode:D,endNode:g}=i(P,C,h));return{rangeStart:Math.min(S(D),S(g)),rangeEnd:Math.max(B(D),B(g))}}n.exports={calculateRange:p,findNodeAtOffset:o}}}),Sm=Z({"src/main/core.js"(e,n){"use strict";re();var{diffArrays:t}=aD(),{printer:{printDocToString:s},debug:{printDocToDebug:a}}=Oe(),{getAlignmentSize:r}=Ue(),{guessEndOfLine:u,convertEndOfLineToChars:i,countEndOfLineChars:o,normalizeEndOfLine:c}=jn(),v=Wa().normalize,m=vm(),d=et(),p=Gn(),f=Fm(),h=Am(),w="\uFEFF",T=Symbol("cursor");function A(g,F,l){let E=F.comments;return E&&(delete F.comments,d.attach(E,F,g,l)),l[Symbol.for("comments")]=E||[],l[Symbol.for("tokens")]=F.tokens||[],l.originalText=g,E}function S(g,F){let l=arguments.length>2&&arguments[2]!==void 0?arguments[2]:0;if(!g||g.trim().length===0)return{formatted:"",cursorOffset:-1,comments:[]};let{ast:E,text:y}=p.parse(g,F);if(F.cursorOffset>=0){let L=h.findNodeAtOffset(E,F.cursorOffset,F);L&&L.node&&(F.cursorNode=L.node)}let N=A(y,E,F),x=f(E,F,l),b=s(x,F);if(d.ensureAllCommentsPrinted(N),l>0){let L=b.formatted.trim();b.cursorNodeStart!==void 0&&(b.cursorNodeStart-=b.formatted.indexOf(L)),b.formatted=L+i(F.endOfLine)}if(F.cursorOffset>=0){let L,M,j,$,V;if(F.cursorNode&&b.cursorNodeText?(L=F.locStart(F.cursorNode),M=y.slice(L,F.locEnd(F.cursorNode)),j=F.cursorOffset-L,$=b.cursorNodeStart,V=b.cursorNodeText):(L=0,M=y,j=F.cursorOffset,$=0,V=b.formatted),M===V)return{formatted:b.formatted,cursorOffset:$+j,comments:N};let q=[...M];q.splice(j,0,T);let Y=[...V],H=t(q,Y),R=$;for(let Q of H)if(Q.removed){if(Q.value.includes(T))break}else R+=Q.count;return{formatted:b.formatted,cursorOffset:R,comments:N}}return{formatted:b.formatted,cursorOffset:-1,comments:N}}function B(g,F){let{ast:l,text:E}=p.parse(g,F),{rangeStart:y,rangeEnd:N}=h.calculateRange(E,F,l),x=E.slice(y,N),b=Math.min(y,E.lastIndexOf(`
`,y)+1),L=E.slice(b,y).match(/^\s*/)[0],M=r(L,F.tabWidth),j=S(x,Object.assign(Object.assign({},F),{},{rangeStart:0,rangeEnd:Number.POSITIVE_INFINITY,cursorOffset:F.cursorOffset>y&&F.cursorOffset<=N?F.cursorOffset-y:-1,endOfLine:"lf"}),M),$=j.formatted.trimEnd(),{cursorOffset:V}=F;V>N?V+=$.length-x.length:j.cursorOffset>=0&&(V=j.cursorOffset+y);let q=E.slice(0,y)+$+E.slice(N);if(F.endOfLine!=="lf"){let Y=i(F.endOfLine);V>=0&&Y===`\r
`&&(V+=o(q.slice(0,V),`
`)),q=q.replace(/\n/g,Y)}return{formatted:q,cursorOffset:V,comments:j.comments}}function I(g,F,l){return typeof F!="number"||Number.isNaN(F)||F<0||F>g.length?l:F}function k(g,F){let{cursorOffset:l,rangeStart:E,rangeEnd:y}=F;return l=I(g,l,-1),E=I(g,E,0),y=I(g,y,g.length),Object.assign(Object.assign({},F),{},{cursorOffset:l,rangeStart:E,rangeEnd:y})}function P(g,F){let{cursorOffset:l,rangeStart:E,rangeEnd:y,endOfLine:N}=k(g,F),x=g.charAt(0)===w;if(x&&(g=g.slice(1),l--,E--,y--),N==="auto"&&(N=u(g)),g.includes("\r")){let b=L=>o(g.slice(0,Math.max(L,0)),`\r
`);l-=b(l),E-=b(E),y-=b(y),g=c(g)}return{hasBOM:x,text:g,options:k(g,Object.assign(Object.assign({},F),{},{cursorOffset:l,rangeStart:E,rangeEnd:y,endOfLine:N}))}}function C(g,F){let l=p.resolveParser(F);return!l.hasPragma||l.hasPragma(g)}function D(g,F){let{hasBOM:l,text:E,options:y}=P(g,v(F));if(y.rangeStart>=y.rangeEnd&&E!==""||y.requirePragma&&!C(E,y))return{formatted:g,cursorOffset:F.cursorOffset,comments:[]};let N;return y.rangeStart>0||y.rangeEnd<E.length?N=B(E,y):(!y.requirePragma&&y.insertPragma&&y.printer.insertPragma&&!C(E,y)&&(E=y.printer.insertPragma(E)),N=S(E,y)),l&&(N.formatted=w+N.formatted,N.cursorOffset>=0&&N.cursorOffset++),N}n.exports={formatWithCursor:D,parse(g,F,l){let{text:E,options:y}=P(g,v(F)),N=p.parse(E,y);return l&&(N.ast=m(N.ast,y)),N},formatAST(g,F){F=v(F);let l=f(g,F);return s(l,F)},formatDoc(g,F){return D(a(g),Object.assign(Object.assign({},F),{},{parser:"__js_expression"})).formatted},printToDoc(g,F){F=v(F);let{ast:l,text:E}=p.parse(g,F);return A(E,l,F),f(l,F)},printDocToString(g,F){return s(g,v(F))}}}}),xm=Z({"src/common/util-shared.js"(e,n){"use strict";re();var{getMaxContinuousCount:t,getStringWidth:s,getAlignmentSize:a,getIndentSize:r,skip:u,skipWhitespace:i,skipSpaces:o,skipNewline:c,skipToLineEnd:v,skipEverythingButNewLine:m,skipInlineComment:d,skipTrailingComment:p,hasNewline:f,hasNewlineInRange:h,hasSpaces:w,isNextLineEmpty:T,isNextLineEmptyAfterIndex:A,isPreviousLineEmpty:S,getNextNonSpaceNonCommentCharacterIndex:B,makeString:I,addLeadingComment:k,addDanglingComment:P,addTrailingComment:C}=Ue();n.exports={getMaxContinuousCount:t,getStringWidth:s,getAlignmentSize:a,getIndentSize:r,skip:u,skipWhitespace:i,skipSpaces:o,skipNewline:c,skipToLineEnd:v,skipEverythingButNewLine:m,skipInlineComment:d,skipTrailingComment:p,hasNewline:f,hasNewlineInRange:h,hasSpaces:w,isNextLineEmpty:T,isNextLineEmptyAfterIndex:A,isPreviousLineEmpty:S,getNextNonSpaceNonCommentCharacterIndex:B,makeString:I,addLeadingComment:k,addDanglingComment:P,addTrailingComment:C}}}),Bt=Z({"src/utils/create-language.js"(e,n){"use strict";re(),n.exports=function(t,s){let{languageId:a}=t,r=kn(t,Zf);return Object.assign(Object.assign({linguistLanguageId:a},r),s(t))}}}),bm=Z({"node_modules/esutils/lib/ast.js"(e,n){re(),function(){"use strict";function t(o){if(o==null)return!1;switch(o.type){case"ArrayExpression":case"AssignmentExpression":case"BinaryExpression":case"CallExpression":case"ConditionalExpression":case"FunctionExpression":case"Identifier":case"Literal":case"LogicalExpression":case"MemberExpression":case"NewExpression":case"ObjectExpression":case"SequenceExpression":case"ThisExpression":case"UnaryExpression":case"UpdateExpression":return!0}return!1}function s(o){if(o==null)return!1;switch(o.type){case"DoWhileStatement":case"ForInStatement":case"ForStatement":case"WhileStatement":return!0}return!1}function a(o){if(o==null)return!1;switch(o.type){case"BlockStatement":case"BreakStatement":case"ContinueStatement":case"DebuggerStatement":case"DoWhileStatement":case"EmptyStatement":case"ExpressionStatement":case"ForInStatement":case"ForStatement":case"IfStatement":case"LabeledStatement":case"ReturnStatement":case"SwitchStatement":case"ThrowStatement":case"TryStatement":case"VariableDeclaration":case"WhileStatement":case"WithStatement":return!0}return!1}function r(o){return a(o)||o!=null&&o.type==="FunctionDeclaration"}function u(o){switch(o.type){case"IfStatement":return o.alternate!=null?o.alternate:o.consequent;case"LabeledStatement":case"ForStatement":case"ForInStatement":case"WhileStatement":case"WithStatement":return o.body}return null}function i(o){var c;if(o.type!=="IfStatement"||o.alternate==null)return!1;c=o.consequent;do{if(c.type==="IfStatement"&&c.alternate==null)return!0;c=u(c)}while(c);return!1}n.exports={isExpression:t,isStatement:a,isIterationStatement:s,isSourceElement:r,isProblematicIfStatement:i,trailingStatement:u}}()}}),$a=Z({"node_modules/esutils/lib/code.js"(e,n){re(),function(){"use strict";var t,s,a,r,u,i;s={NonAsciiIdentifierStart:/[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,NonAsciiIdentifierPart:/[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/},t={NonAsciiIdentifierStart:/[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309B-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]/,NonAsciiIdentifierPart:/[\xAA\xB5\xB7\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D01-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1369-\u1371\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF6\u1CF8\u1CF9\u1D00-\u1DF5\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200C\u200D\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2118-\u211D\u2124\u2126\u2128\u212A-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF30-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00\uDC01]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/};function o(A){return 48<=A&&A<=57}function c(A){return 48<=A&&A<=57||97<=A&&A<=102||65<=A&&A<=70}function v(A){return A>=48&&A<=55}a=[5760,8192,8193,8194,8195,8196,8197,8198,8199,8200,8201,8202,8239,8287,12288,65279];function m(A){return A===32||A===9||A===11||A===12||A===160||A>=5760&&a.indexOf(A)>=0}function d(A){return A===10||A===13||A===8232||A===8233}function p(A){if(A<=65535)return String.fromCharCode(A);var S=String.fromCharCode(Math.floor((A-65536)/1024)+55296),B=String.fromCharCode((A-65536)%1024+56320);return S+B}for(r=new Array(128),i=0;i<128;++i)r[i]=i>=97&&i<=122||i>=65&&i<=90||i===36||i===95;for(u=new Array(128),i=0;i<128;++i)u[i]=i>=97&&i<=122||i>=65&&i<=90||i>=48&&i<=57||i===36||i===95;function f(A){return A<128?r[A]:s.NonAsciiIdentifierStart.test(p(A))}function h(A){return A<128?u[A]:s.NonAsciiIdentifierPart.test(p(A))}function w(A){return A<128?r[A]:t.NonAsciiIdentifierStart.test(p(A))}function T(A){return A<128?u[A]:t.NonAsciiIdentifierPart.test(p(A))}n.exports={isDecimalDigit:o,isHexDigit:c,isOctalDigit:v,isWhiteSpace:m,isLineTerminator:d,isIdentifierStartES5:f,isIdentifierPartES5:h,isIdentifierStartES6:w,isIdentifierPartES6:T}}()}}),Tm=Z({"node_modules/esutils/lib/keyword.js"(e,n){re(),function(){"use strict";var t=$a();function s(f){switch(f){case"implements":case"interface":case"package":case"private":case"protected":case"public":case"static":case"let":return!0;default:return!1}}function a(f,h){return!h&&f==="yield"?!1:r(f,h)}function r(f,h){if(h&&s(f))return!0;switch(f.length){case 2:return f==="if"||f==="in"||f==="do";case 3:return f==="var"||f==="for"||f==="new"||f==="try";case 4:return f==="this"||f==="else"||f==="case"||f==="void"||f==="with"||f==="enum";case 5:return f==="while"||f==="break"||f==="catch"||f==="throw"||f==="const"||f==="yield"||f==="class"||f==="super";case 6:return f==="return"||f==="typeof"||f==="delete"||f==="switch"||f==="export"||f==="import";case 7:return f==="default"||f==="finally"||f==="extends";case 8:return f==="function"||f==="continue"||f==="debugger";case 10:return f==="instanceof";default:return!1}}function u(f,h){return f==="null"||f==="true"||f==="false"||a(f,h)}function i(f,h){return f==="null"||f==="true"||f==="false"||r(f,h)}function o(f){return f==="eval"||f==="arguments"}function c(f){var h,w,T;if(f.length===0||(T=f.charCodeAt(0),!t.isIdentifierStartES5(T)))return!1;for(h=1,w=f.length;h<w;++h)if(T=f.charCodeAt(h),!t.isIdentifierPartES5(T))return!1;return!0}function v(f,h){return(f-55296)*1024+(h-56320)+65536}function m(f){var h,w,T,A,S;if(f.length===0)return!1;for(S=t.isIdentifierStartES6,h=0,w=f.length;h<w;++h){if(T=f.charCodeAt(h),55296<=T&&T<=56319){if(++h,h>=w||(A=f.charCodeAt(h),!(56320<=A&&A<=57343)))return!1;T=v(T,A)}if(!S(T))return!1;S=t.isIdentifierPartES6}return!0}function d(f,h){return c(f)&&!u(f,h)}function p(f,h){return m(f)&&!i(f,h)}n.exports={isKeywordES5:a,isKeywordES6:r,isReservedWordES5:u,isReservedWordES6:i,isRestrictedWord:o,isIdentifierNameES5:c,isIdentifierNameES6:m,isIdentifierES5:d,isIdentifierES6:p}}()}}),Bm=Z({"node_modules/esutils/lib/utils.js"(e){re(),function(){"use strict";e.ast=bm(),e.code=$a(),e.keyword=Tm()}()}}),It=Z({"src/language-js/utils/is-block-comment.js"(e,n){"use strict";re();var t=new Set(["Block","CommentBlock","MultiLine"]),s=a=>t.has(a==null?void 0:a.type);n.exports=s}}),Nm=Z({"src/language-js/utils/is-node-matches.js"(e,n){"use strict";re();function t(a,r){let u=r.split(".");for(let i=u.length-1;i>=0;i--){let o=u[i];if(i===0)return a.type==="Identifier"&&a.name===o;if(a.type!=="MemberExpression"||a.optional||a.computed||a.property.type!=="Identifier"||a.property.name!==o)return!1;a=a.object}}function s(a,r){return r.some(u=>t(a,u))}n.exports=s}}),Ke=Z({"src/language-js/utils/index.js"(e,n){"use strict";re();var t=Bm().keyword.isIdentifierNameES5,{getLast:s,hasNewline:a,skipWhitespace:r,isNonEmptyArray:u,isNextLineEmptyAfterIndex:i,getStringWidth:o}=Ue(),{locStart:c,locEnd:v,hasSameLocStart:m}=st(),d=It(),p=Nm(),f="(?:(?=.)\\s)",h=new RegExp("^".concat(f,"*:")),w=new RegExp("^".concat(f,"*::"));function T(O){var fe,Te;return((fe=O.extra)===null||fe===void 0?void 0:fe.parenthesized)&&d((Te=O.trailingComments)===null||Te===void 0?void 0:Te[0])&&h.test(O.trailingComments[0].value)}function A(O){let fe=O==null?void 0:O[0];return d(fe)&&w.test(fe.value)}function S(O,fe){if(!O||typeof O!="object")return!1;if(Array.isArray(O))return O.some($e=>S($e,fe));let Te=fe(O);return typeof Te=="boolean"?Te:Object.values(O).some($e=>S($e,fe))}function B(O){return O.type==="AssignmentExpression"||O.type==="BinaryExpression"||O.type==="LogicalExpression"||O.type==="NGPipeExpression"||O.type==="ConditionalExpression"||ue(O)||De(O)||O.type==="SequenceExpression"||O.type==="TaggedTemplateExpression"||O.type==="BindExpression"||O.type==="UpdateExpression"&&!O.prefix||O.type==="TSAsExpression"||O.type==="TSNonNullExpression"}function I(O){var fe,Te,$e,Je,Ze,ut;return O.expressions?O.expressions[0]:(fe=(Te=($e=(Je=(Ze=(ut=O.left)!==null&&ut!==void 0?ut:O.test)!==null&&Ze!==void 0?Ze:O.callee)!==null&&Je!==void 0?Je:O.object)!==null&&$e!==void 0?$e:O.tag)!==null&&Te!==void 0?Te:O.argument)!==null&&fe!==void 0?fe:O.expression}function k(O,fe){if(fe.expressions)return["expressions",0];if(fe.left)return["left"];if(fe.test)return["test"];if(fe.object)return["object"];if(fe.callee)return["callee"];if(fe.tag)return["tag"];if(fe.argument)return["argument"];if(fe.expression)return["expression"];throw new Error("Unexpected node has no left side.")}function P(O){return O=new Set(O),fe=>O.has(fe==null?void 0:fe.type)}var C=P(["Line","CommentLine","SingleLine","HashbangComment","HTMLOpen","HTMLClose"]),D=P(["ExportDefaultDeclaration","ExportDefaultSpecifier","DeclareExportDeclaration","ExportNamedDeclaration","ExportAllDeclaration"]);function g(O){let fe=O.getParentNode();return O.getName()==="declaration"&&D(fe)?fe:null}var F=P(["BooleanLiteral","DirectiveLiteral","Literal","NullLiteral","NumericLiteral","BigIntLiteral","DecimalLiteral","RegExpLiteral","StringLiteral","TemplateLiteral","TSTypeLiteral","JSXText"]);function l(O){return O.type==="NumericLiteral"||O.type==="Literal"&&typeof O.value=="number"}function E(O){return O.type==="UnaryExpression"&&(O.operator==="+"||O.operator==="-")&&l(O.argument)}function y(O){return O.type==="StringLiteral"||O.type==="Literal"&&typeof O.value=="string"}var N=P(["ObjectTypeAnnotation","TSTypeLiteral","TSMappedType"]),x=P(["FunctionExpression","ArrowFunctionExpression"]);function b(O){return O.type==="FunctionExpression"||O.type==="ArrowFunctionExpression"&&O.body.type==="BlockStatement"}function L(O){return ue(O)&&O.callee.type==="Identifier"&&["async","inject","fakeAsync","waitForAsync"].includes(O.callee.name)}var M=P(["JSXElement","JSXFragment"]);function j(O,fe){if(O.parentParser!=="markdown"&&O.parentParser!=="mdx")return!1;let Te=fe.getNode();if(!Te.expression||!M(Te.expression))return!1;let $e=fe.getParentNode();return $e.type==="Program"&&$e.body.length===1}function $(O){return O.kind==="get"||O.kind==="set"}function V(O){return $(O)||m(O,O.value)}function q(O){return(O.type==="ObjectTypeProperty"||O.type==="ObjectTypeInternalSlot")&&O.value.type==="FunctionTypeAnnotation"&&!O.static&&!V(O)}function Y(O){return(O.type==="TypeAnnotation"||O.type==="TSTypeAnnotation")&&O.typeAnnotation.type==="FunctionTypeAnnotation"&&!O.static&&!m(O,O.typeAnnotation)}var H=P(["BinaryExpression","LogicalExpression","NGPipeExpression"]);function R(O){return De(O)||O.type==="BindExpression"&&Boolean(O.object)}var Q=new Set(["AnyTypeAnnotation","TSAnyKeyword","NullLiteralTypeAnnotation","TSNullKeyword","ThisTypeAnnotation","TSThisType","NumberTypeAnnotation","TSNumberKeyword","VoidTypeAnnotation","TSVoidKeyword","BooleanTypeAnnotation","TSBooleanKeyword","BigIntTypeAnnotation","TSBigIntKeyword","SymbolTypeAnnotation","TSSymbolKeyword","StringTypeAnnotation","TSStringKeyword","BooleanLiteralTypeAnnotation","StringLiteralTypeAnnotation","BigIntLiteralTypeAnnotation","NumberLiteralTypeAnnotation","TSLiteralType","TSTemplateLiteralType","EmptyTypeAnnotation","MixedTypeAnnotation","TSNeverKeyword","TSObjectKeyword","TSUndefinedKeyword","TSUnknownKeyword"]);function ee(O){return O?!!((O.type==="GenericTypeAnnotation"||O.type==="TSTypeReference")&&!O.typeParameters||Q.has(O.type)):!1}function te(O){let fe=/^(?:before|after)(?:Each|All)$/;return O.callee.type==="Identifier"&&fe.test(O.callee.name)&&O.arguments.length===1}var oe=["it","it.only","it.skip","describe","describe.only","describe.skip","test","test.only","test.skip","test.step","test.describe","test.describe.only","test.describe.parallel","test.describe.parallel.only","test.describe.serial","test.describe.serial.only","skip","xit","xdescribe","xtest","fit","fdescribe","ftest"];function W(O){return p(O,oe)}function X(O,fe){if(O.type!=="CallExpression")return!1;if(O.arguments.length===1){if(L(O)&&fe&&X(fe))return x(O.arguments[0]);if(te(O))return L(O.arguments[0])}else if((O.arguments.length===2||O.arguments.length===3)&&(O.arguments[0].type==="TemplateLiteral"||y(O.arguments[0]))&&W(O.callee))return O.arguments[2]&&!l(O.arguments[2])?!1:(O.arguments.length===2?x(O.arguments[1]):b(O.arguments[1])&&Se(O.arguments[1]).length<=1)||L(O.arguments[1]);return!1}var ue=P(["CallExpression","OptionalCallExpression"]),De=P(["MemberExpression","OptionalMemberExpression"]);function ie(O){let fe="expressions";O.type==="TSTemplateLiteralType"&&(fe="types");let Te=O[fe];return Te.length===0?!1:Te.every($e=>{if(se($e))return!1;if($e.type==="Identifier"||$e.type==="ThisExpression")return!0;if(De($e)){let Je=$e;for(;De(Je);)if(Je.property.type!=="Identifier"&&Je.property.type!=="Literal"&&Je.property.type!=="StringLiteral"&&Je.property.type!=="NumericLiteral"||(Je=Je.object,se(Je)))return!1;return Je.type==="Identifier"||Je.type==="ThisExpression"}return!1})}function G(O,fe){return O==="+"||O==="-"?O+fe:fe}function z(O,fe){let Te=c(fe),$e=r(O,v(fe));return $e!==!1&&O.slice(Te,Te+2)==="/*"&&O.slice($e,$e+2)==="*/"}function U(O,fe){return M(fe)?Re(fe):se(fe,Le.Leading,Te=>a(O,v(Te)))}function le(O,fe){return fe.parser!=="json"&&y(O.key)&&ve(O.key).slice(1,-1)===O.key.value&&(t(O.key.value)&&!(fe.parser==="babel-ts"&&O.type==="ClassProperty"||fe.parser==="typescript"&&O.type==="PropertyDefinition")||ge(O.key.value)&&String(Number(O.key.value))===O.key.value&&(fe.parser==="babel"||fe.parser==="acorn"||fe.parser==="espree"||fe.parser==="meriyah"||fe.parser==="__babel_estree"))}function ge(O){return/^(?:\d+|\d+\.\d+)$/.test(O)}function Ae(O,fe){let Te=/^[fx]?(?:describe|it|test)$/;return fe.type==="TaggedTemplateExpression"&&fe.quasi===O&&fe.tag.type==="MemberExpression"&&fe.tag.property.type==="Identifier"&&fe.tag.property.name==="each"&&(fe.tag.object.type==="Identifier"&&Te.test(fe.tag.object.name)||fe.tag.object.type==="MemberExpression"&&fe.tag.object.property.type==="Identifier"&&(fe.tag.object.property.name==="only"||fe.tag.object.property.name==="skip")&&fe.tag.object.object.type==="Identifier"&&Te.test(fe.tag.object.object.name))}function Ne(O){return O.quasis.some(fe=>fe.value.raw.includes(`
`))}function ke(O,fe){return(O.type==="TemplateLiteral"&&Ne(O)||O.type==="TaggedTemplateExpression"&&Ne(O.quasi))&&!a(fe,c(O),{backwards:!0})}function ce(O){if(!se(O))return!1;let fe=s(He(O,Le.Dangling));return fe&&!d(fe)}function pe(O){if(O.length<=1)return!1;let fe=0;for(let Te of O)if(x(Te)){if(fe+=1,fe>1)return!0}else if(ue(Te)){for(let $e of Te.arguments)if(x($e))return!0}return!1}function de(O){let fe=O.getValue(),Te=O.getParentNode();return ue(fe)&&ue(Te)&&Te.callee===fe&&fe.arguments.length>Te.arguments.length&&Te.arguments.length>0}function ae(O,fe){if(fe>=2)return!1;let Te=Je=>ae(Je,fe+1),$e=O.type==="Literal"&&"regex"in O&&O.regex.pattern||O.type==="RegExpLiteral"&&O.pattern;return $e&&o($e)>5?!1:O.type==="Literal"||O.type==="BigIntLiteral"||O.type==="DecimalLiteral"||O.type==="BooleanLiteral"||O.type==="NullLiteral"||O.type==="NumericLiteral"||O.type==="RegExpLiteral"||O.type==="StringLiteral"||O.type==="Identifier"||O.type==="ThisExpression"||O.type==="Super"||O.type==="PrivateName"||O.type==="PrivateIdentifier"||O.type==="ArgumentPlaceholder"||O.type==="Import"?!0:O.type==="TemplateLiteral"?O.quasis.every(Je=>!Je.value.raw.includes(`
`))&&O.expressions.every(Te):O.type==="ObjectExpression"?O.properties.every(Je=>!Je.computed&&(Je.shorthand||Je.value&&Te(Je.value))):O.type==="ArrayExpression"?O.elements.every(Je=>Je===null||Te(Je)):ze(O)?(O.type==="ImportExpression"||ae(O.callee,fe))&&Xe(O).every(Te):De(O)?ae(O.object,fe)&&ae(O.property,fe):O.type==="UnaryExpression"&&(O.operator==="!"||O.operator==="-")?ae(O.argument,fe):O.type==="TSNonNullExpression"?ae(O.expression,fe):!1}function ve(O){var fe,Te;return(fe=(Te=O.extra)===null||Te===void 0?void 0:Te.raw)!==null&&fe!==void 0?fe:O.raw}function K(O){return O}function he(O){return O.filepath&&/\.tsx$/i.test(O.filepath)}function ye(O){let fe=arguments.length>1&&arguments[1]!==void 0?arguments[1]:"es5";return O.trailingComma==="es5"&&fe==="es5"||O.trailingComma==="all"&&(fe==="all"||fe==="es5")}function Ce(O,fe){switch(O=Ee(O),O.type){case"FunctionExpression":case"ClassExpression":case"DoExpression":return fe;case"ObjectExpression":return!0;case"MemberExpression":case"OptionalMemberExpression":return Ce(O.object,fe);case"TaggedTemplateExpression":return O.tag.type==="FunctionExpression"?!1:Ce(O.tag,fe);case"CallExpression":case"OptionalCallExpression":return O.callee.type==="FunctionExpression"?!1:Ce(O.callee,fe);case"ConditionalExpression":return Ce(O.test,fe);case"UpdateExpression":return!O.prefix&&Ce(O.argument,fe);case"BindExpression":return O.object&&Ce(O.object,fe);case"SequenceExpression":return Ce(O.expressions[0],fe);case"TSAsExpression":case"TSNonNullExpression":return Ce(O.expression,fe);default:return!1}}var Ie={"==":!0,"!=":!0,"===":!0,"!==":!0},Fe={"*":!0,"/":!0,"%":!0},me={">>":!0,">>>":!0,"<<":!0};function _(O,fe){return!(ne(fe)!==ne(O)||O==="**"||Ie[O]&&Ie[fe]||fe==="%"&&Fe[O]||O==="%"&&Fe[fe]||fe!==O&&Fe[fe]&&Fe[O]||me[O]&&me[fe])}var J=new Map([["|>"],["??"],["||"],["&&"],["|"],["^"],["&"],["==","===","!=","!=="],["<",">","<=",">=","in","instanceof"],[">>","<<",">>>"],["+","-"],["*","/","%"],["**"]].flatMap((O,fe)=>O.map(Te=>[Te,fe])));function ne(O){return J.get(O)}function Ee(O){for(;O.left;)O=O.left;return O}function We(O){return Boolean(me[O])||O==="|"||O==="^"||O==="&"}function Be(O){var fe;if(O.rest)return!0;let Te=Se(O);return((fe=s(Te))===null||fe===void 0?void 0:fe.type)==="RestElement"}var Pe=new WeakMap;function Se(O){if(Pe.has(O))return Pe.get(O);let fe=[];return O.this&&fe.push(O.this),Array.isArray(O.parameters)?fe.push(...O.parameters):Array.isArray(O.params)&&fe.push(...O.params),O.rest&&fe.push(O.rest),Pe.set(O,fe),fe}function Qe(O,fe){let Te=O.getValue(),$e=0,Je=Ze=>fe(Ze,$e++);Te.this&&O.call(Je,"this"),Array.isArray(Te.parameters)?O.each(Je,"parameters"):Array.isArray(Te.params)&&O.each(Je,"params"),Te.rest&&O.call(Je,"rest")}var xe=new WeakMap;function Xe(O){if(xe.has(O))return xe.get(O);let fe=O.arguments;return O.type==="ImportExpression"&&(fe=[O.source],O.attributes&&fe.push(O.attributes)),xe.set(O,fe),fe}function _e(O,fe){let Te=O.getValue();Te.type==="ImportExpression"?(O.call($e=>fe($e,0),"source"),Te.attributes&&O.call($e=>fe($e,1),"attributes")):O.each(fe,"arguments")}function je(O){return O.value.trim()==="prettier-ignore"&&!O.unignore}function Re(O){return O&&(O.prettierIgnore||se(O,Le.PrettierIgnore))}function be(O){let fe=O.getValue();return Re(fe)}var Le={Leading:1<<1,Trailing:1<<2,Dangling:1<<3,Block:1<<4,Line:1<<5,PrettierIgnore:1<<6,First:1<<7,Last:1<<8},qe=(O,fe)=>{if(typeof O=="function"&&(fe=O,O=0),O||fe)return(Te,$e,Je)=>!(O&Le.Leading&&!Te.leading||O&Le.Trailing&&!Te.trailing||O&Le.Dangling&&(Te.leading||Te.trailing)||O&Le.Block&&!d(Te)||O&Le.Line&&!C(Te)||O&Le.First&&$e!==0||O&Le.Last&&$e!==Je.length-1||O&Le.PrettierIgnore&&!je(Te)||fe&&!fe(Te))};function se(O,fe,Te){if(!u(O==null?void 0:O.comments))return!1;let $e=qe(fe,Te);return $e?O.comments.some($e):!0}function He(O,fe,Te){if(!Array.isArray(O==null?void 0:O.comments))return[];let $e=qe(fe,Te);return $e?O.comments.filter($e):O.comments}var Me=(O,fe)=>{let{originalText:Te}=fe;return i(Te,v(O))};function ze(O){return ue(O)||O.type==="NewExpression"||O.type==="ImportExpression"}function nt(O){return O&&(O.type==="ObjectProperty"||O.type==="Property"&&!O.method&&O.kind==="init")}function tt(O){return Boolean(O.__isUsingHackPipeline)}var pt=Symbol("ifWithoutBlockAndSameLineComment");n.exports={getFunctionParameters:Se,iterateFunctionParametersPath:Qe,getCallArguments:Xe,iterateCallArgumentsPath:_e,hasRestParameter:Be,getLeftSide:I,getLeftSidePathName:k,getParentExportDeclaration:g,getTypeScriptMappedTypeModifier:G,hasFlowAnnotationComment:A,hasFlowShorthandAnnotationComment:T,hasLeadingOwnLineComment:U,hasNakedLeftSide:B,hasNode:S,hasIgnoreComment:be,hasNodeIgnoreComment:Re,identity:K,isBinaryish:H,isCallLikeExpression:ze,isEnabledHackPipeline:tt,isLineComment:C,isPrettierIgnoreComment:je,isCallExpression:ue,isMemberExpression:De,isExportDeclaration:D,isFlowAnnotationComment:z,isFunctionCompositionArgs:pe,isFunctionNotation:V,isFunctionOrArrowExpression:x,isGetterOrSetter:$,isJestEachTemplateLiteral:Ae,isJsxNode:M,isLiteral:F,isLongCurriedCallExpression:de,isSimpleCallArgument:ae,isMemberish:R,isNumericLiteral:l,isSignedNumericLiteral:E,isObjectProperty:nt,isObjectType:N,isObjectTypePropertyAFunction:q,isSimpleType:ee,isSimpleNumber:ge,isSimpleTemplateLiteral:ie,isStringLiteral:y,isStringPropSafeToUnquote:le,isTemplateOnItsOwnLine:ke,isTestCall:X,isTheOnlyJsxElementInMarkdown:j,isTSXFile:he,isTypeAnnotationAFunction:Y,isNextLineEmpty:Me,needsHardlineAfterDanglingComment:ce,rawText:ve,shouldPrintComma:ye,isBitwiseOperator:We,shouldFlatten:_,startsWithNoLookaheadToken:Ce,getPrecedence:ne,hasComment:se,getComments:He,CommentCheckFlags:Le,markerForIfWithoutBlockAndSameLineComment:pt}}}),Lt=Z({"src/language-js/print/template-literal.js"(e,n){"use strict";re();var t=it(),{getStringWidth:s,getIndentSize:a}=Ue(),{builders:{join:r,hardline:u,softline:i,group:o,indent:c,align:v,lineSuffixBoundary:m,addAlignmentToDoc:d},printer:{printDocToString:p},utils:{mapDoc:f}}=Oe(),{isBinaryish:h,isJestEachTemplateLiteral:w,isSimpleTemplateLiteral:T,hasComment:A,isMemberExpression:S}=Ke();function B(g,F,l){let E=g.getValue();if(E.type==="TemplateLiteral"&&w(E,g.getParentNode())){let M=I(g,l,F);if(M)return M}let N="expressions";E.type==="TSTemplateLiteralType"&&(N="types");let x=[],b=g.map(F,N),L=T(E);return L&&(b=b.map(M=>p(M,Object.assign(Object.assign({},l),{},{printWidth:Number.POSITIVE_INFINITY})).formatted)),x.push(m,"`"),g.each(M=>{let j=M.getName();if(x.push(F()),j<b.length){let{tabWidth:$}=l,V=M.getValue(),q=a(V.value.raw,$),Y=b[j];if(!L){let R=E[N][j];(A(R)||S(R)||R.type==="ConditionalExpression"||R.type==="SequenceExpression"||R.type==="TSAsExpression"||h(R))&&(Y=[c([i,Y]),i])}let H=q===0&&V.value.raw.endsWith(`
`)?v(Number.NEGATIVE_INFINITY,Y):d(Y,q,$);x.push(o(["${",H,m,"}"]))}},"quasis"),x.push("`"),x}function I(g,F,l){let E=g.getNode(),y=E.quasis[0].value.raw.trim().split(/\s*\|\s*/);if(y.length>1||y.some(N=>N.length>0)){F.__inJestEach=!0;let N=g.map(l,"expressions");F.__inJestEach=!1;let x=[],b=N.map(V=>"${"+p(V,Object.assign(Object.assign({},F),{},{printWidth:Number.POSITIVE_INFINITY,endOfLine:"lf"})).formatted+"}"),L=[{hasLineBreak:!1,cells:[]}];for(let V=1;V<E.quasis.length;V++){let q=t(L),Y=b[V-1];q.cells.push(Y),Y.includes(`
`)&&(q.hasLineBreak=!0),E.quasis[V].value.raw.includes(`
`)&&L.push({hasLineBreak:!1,cells:[]})}let M=Math.max(y.length,...L.map(V=>V.cells.length)),j=Array.from({length:M}).fill(0),$=[{cells:y},...L.filter(V=>V.cells.length>0)];for(let{cells:V}of $.filter(q=>!q.hasLineBreak))for(let[q,Y]of V.entries())j[q]=Math.max(j[q],s(Y));return x.push(m,"`",c([u,r(u,$.map(V=>r(" | ",V.cells.map((q,Y)=>V.hasLineBreak?q:q+" ".repeat(j[Y]-s(q))))))]),u,"`"),x}}function k(g,F){let l=g.getValue(),E=F();return A(l)&&(E=o([c([i,E]),i])),["${",E,m,"}"]}function P(g,F){return g.map(l=>k(l,F),"expressions")}function C(g,F){return f(g,l=>typeof l=="string"?F?l.replace(/(\\*)`/g,"$1$1\\`"):D(l):l)}function D(g){return g.replace(/([\\`]|\${)/g,"\\$1")}n.exports={printTemplateLiteral:B,printTemplateExpressions:P,escapeTemplateCharacters:C,uncookTemplateElementValue:D}}}),wm=Z({"src/language-js/embed/markdown.js"(e,n){"use strict";re();var{builders:{indent:t,softline:s,literalline:a,dedentToRoot:r}}=Oe(),{escapeTemplateCharacters:u}=Lt();function i(c,v,m){let p=c.getValue().quasis[0].value.raw.replace(/((?:\\\\)*)\\`/g,(T,A)=>"\\".repeat(A.length/2)+"`"),f=o(p),h=f!=="";h&&(p=p.replace(new RegExp("^".concat(f),"gm"),""));let w=u(m(p,{parser:"markdown",__inJsTemplate:!0},{stripTrailingHardline:!0}),!0);return["`",h?t([s,w]):[a,r(w)],s,"`"]}function o(c){let v=c.match(/^([^\S\n]*)\S/m);return v===null?"":v[1]}n.exports=i}}),_m=Z({"src/language-js/embed/css.js"(e,n){"use strict";re();var{isNonEmptyArray:t}=Ue(),{builders:{indent:s,hardline:a,softline:r},utils:{mapDoc:u,replaceEndOfLine:i,cleanDoc:o}}=Oe(),{printTemplateExpressions:c}=Lt();function v(p,f,h){let w=p.getValue(),T=w.quasis.map(k=>k.value.raw),A=0,S=T.reduce((k,P,C)=>C===0?P:k+"@prettier-placeholder-"+A+++"-id"+P,""),B=h(S,{parser:"scss"},{stripTrailingHardline:!0}),I=c(p,f);return m(B,w,I)}function m(p,f,h){if(f.quasis.length===1&&!f.quasis[0].value.raw.trim())return"``";let T=d(p,h);if(!T)throw new Error("Couldn't insert all the expressions");return["`",s([a,T]),r,"`"]}function d(p,f){if(!t(f))return p;let h=0,w=u(o(p),T=>typeof T!="string"||!T.includes("@prettier-placeholder")?T:T.split(/@prettier-placeholder-(\d+)-id/).map((A,S)=>S%2===0?i(A):(h++,f[A])));return f.length===h?w:null}n.exports=v}}),Pm=Z({"src/language-js/embed/graphql.js"(e,n){"use strict";re();var{builders:{indent:t,join:s,hardline:a}}=Oe(),{escapeTemplateCharacters:r,printTemplateExpressions:u}=Lt();function i(c,v,m){let d=c.getValue(),p=d.quasis.length;if(p===1&&d.quasis[0].value.raw.trim()==="")return"``";let f=u(c,v),h=[];for(let w=0;w<p;w++){let T=d.quasis[w],A=w===0,S=w===p-1,B=T.value.cooked,I=B.split(`
`),k=I.length,P=f[w],C=k>2&&I[0].trim()===""&&I[1].trim()==="",D=k>2&&I[k-1].trim()===""&&I[k-2].trim()==="",g=I.every(l=>/^\s*(?:#[^\n\r]*)?$/.test(l));if(!S&&/#[^\n\r]*$/.test(I[k-1]))return null;let F=null;g?F=o(I):F=m(B,{parser:"graphql"},{stripTrailingHardline:!0}),F?(F=r(F,!1),!A&&C&&h.push(""),h.push(F),!S&&D&&h.push("")):!A&&!S&&C&&h.push(""),P&&h.push(P)}return["`",t([a,s(a,h)]),a,"`"]}function o(c){let v=[],m=!1,d=c.map(p=>p.trim());for(let[p,f]of d.entries())f!==""&&(d[p-1]===""&&m?v.push([a,f]):v.push(f),m=!0);return v.length===0?null:s(a,v)}n.exports=i}}),km=Z({"src/language-js/embed/html.js"(e,n){"use strict";re();var{builders:{indent:t,line:s,hardline:a,group:r},utils:{mapDoc:u}}=Oe(),{printTemplateExpressions:i,uncookTemplateElementValue:o}=Lt(),c=0;function v(m,d,p,f,h){let{parser:w}=h,T=m.getValue(),A=c;c=c+1>>>0;let S=E=>"PRETTIER_HTML_PLACEHOLDER_".concat(E,"_").concat(A,"_IN_JS"),B=T.quasis.map((E,y,N)=>y===N.length-1?E.value.cooked:E.value.cooked+S(y)).join(""),I=i(m,d);if(I.length===0&&B.trim().length===0)return"``";let k=new RegExp(S("(\\d+)"),"g"),P=0,C=p(B,{parser:w,__onHtmlRoot(E){P=E.children.length}},{stripTrailingHardline:!0}),D=u(C,E=>{if(typeof E!="string")return E;let y=[],N=E.split(k);for(let x=0;x<N.length;x++){let b=N[x];if(x%2===0){b&&(b=o(b),f.__embeddedInHtml&&(b=b.replace(/<\/(script)\b/gi,"<\\/$1")),y.push(b));continue}let L=Number(b);y.push(I[L])}return y}),g=/^\s/.test(B)?" ":"",F=/\s$/.test(B)?" ":"",l=f.htmlWhitespaceSensitivity==="ignore"?a:g&&F?s:null;return r(l?["`",t([l,r(D)]),l,"`"]:["`",g,P>1?t(r(D)):r(D),F,"`"])}n.exports=v}}),Im=Z({"src/language-js/embed.js"(e,n){"use strict";re();var{hasComment:t,CommentCheckFlags:s,isObjectProperty:a}=Ke(),r=wm(),u=_m(),i=Pm(),o=km();function c(C){if(d(C)||w(C)||T(C)||p(C))return"css";if(B(C))return"graphql";if(k(C))return"html";if(f(C))return"angular";if(m(C))return"markdown"}function v(C,D,g,F){let l=C.getValue();if(l.type!=="TemplateLiteral"||P(l))return;let E=c(C);if(!!E){if(E==="markdown")return r(C,D,g);if(E==="css")return u(C,D,g);if(E==="graphql")return i(C,D,g);if(E==="html"||E==="angular")return o(C,D,g,F,{parser:E})}}function m(C){let D=C.getValue(),g=C.getParentNode();return g&&g.type==="TaggedTemplateExpression"&&D.quasis.length===1&&g.tag.type==="Identifier"&&(g.tag.name==="md"||g.tag.name==="markdown")}function d(C){let D=C.getValue(),g=C.getParentNode(),F=C.getParentNode(1);return F&&D.quasis&&g.type==="JSXExpressionContainer"&&F.type==="JSXElement"&&F.openingElement.name.name==="style"&&F.openingElement.attributes.some(l=>l.name.name==="jsx")||g&&g.type==="TaggedTemplateExpression"&&g.tag.type==="Identifier"&&g.tag.name==="css"||g&&g.type==="TaggedTemplateExpression"&&g.tag.type==="MemberExpression"&&g.tag.object.name==="css"&&(g.tag.property.name==="global"||g.tag.property.name==="resolve")}function p(C){return C.match(D=>D.type==="TemplateLiteral",(D,g)=>D.type==="ArrayExpression"&&g==="elements",(D,g)=>a(D)&&D.key.type==="Identifier"&&D.key.name==="styles"&&g==="value",...h)}function f(C){return C.match(D=>D.type==="TemplateLiteral",(D,g)=>a(D)&&D.key.type==="Identifier"&&D.key.name==="template"&&g==="value",...h)}var h=[(C,D)=>C.type==="ObjectExpression"&&D==="properties",(C,D)=>C.type==="CallExpression"&&C.callee.type==="Identifier"&&C.callee.name==="Component"&&D==="arguments",(C,D)=>C.type==="Decorator"&&D==="expression"];function w(C){let D=C.getParentNode();if(!D||D.type!=="TaggedTemplateExpression")return!1;let g=D.tag.type==="ParenthesizedExpression"?D.tag.expression:D.tag;switch(g.type){case"MemberExpression":return A(g.object)||S(g);case"CallExpression":return A(g.callee)||g.callee.type==="MemberExpression"&&(g.callee.object.type==="MemberExpression"&&(A(g.callee.object.object)||S(g.callee.object))||g.callee.object.type==="CallExpression"&&A(g.callee.object.callee));case"Identifier":return g.name==="css";default:return!1}}function T(C){let D=C.getParentNode(),g=C.getParentNode(1);return g&&D.type==="JSXExpressionContainer"&&g.type==="JSXAttribute"&&g.name.type==="JSXIdentifier"&&g.name.name==="css"}function A(C){return C.type==="Identifier"&&C.name==="styled"}function S(C){return/^[A-Z]/.test(C.object.name)&&C.property.name==="extend"}function B(C){let D=C.getValue(),g=C.getParentNode();return I(D,"GraphQL")||g&&(g.type==="TaggedTemplateExpression"&&(g.tag.type==="MemberExpression"&&g.tag.object.name==="graphql"&&g.tag.property.name==="experimental"||g.tag.type==="Identifier"&&(g.tag.name==="gql"||g.tag.name==="graphql"))||g.type==="CallExpression"&&g.callee.type==="Identifier"&&g.callee.name==="graphql")}function I(C,D){return t(C,s.Block|s.Leading,g=>{let{value:F}=g;return F===" ".concat(D," ")})}function k(C){return I(C.getValue(),"HTML")||C.match(D=>D.type==="TemplateLiteral",(D,g)=>D.type==="TaggedTemplateExpression"&&D.tag.type==="Identifier"&&D.tag.name==="html"&&g==="quasi")}function P(C){let{quasis:D}=C;return D.some(g=>{let{value:{cooked:F}}=g;return F===null})}n.exports=v}}),Lm=Z({"src/language-js/clean.js"(e,n){"use strict";re();var t=It(),s=new Set(["range","raw","comments","leadingComments","trailingComments","innerComments","extra","start","end","loc","flags","errors","tokens"]),a=u=>{for(let i of u.quasis)delete i.value};function r(u,i,o){if(u.type==="Program"&&delete i.sourceType,(u.type==="BigIntLiteral"||u.type==="BigIntLiteralTypeAnnotation")&&i.value&&(i.value=i.value.toLowerCase()),(u.type==="BigIntLiteral"||u.type==="Literal")&&i.bigint&&(i.bigint=i.bigint.toLowerCase()),u.type==="DecimalLiteral"&&(i.value=Number(i.value)),u.type==="Literal"&&i.decimal&&(i.decimal=Number(i.decimal)),u.type==="EmptyStatement"||u.type==="JSXText"||u.type==="JSXExpressionContainer"&&(u.expression.type==="Literal"||u.expression.type==="StringLiteral")&&u.expression.value===" ")return null;if((u.type==="Property"||u.type==="ObjectProperty"||u.type==="MethodDefinition"||u.type==="ClassProperty"||u.type==="ClassMethod"||u.type==="PropertyDefinition"||u.type==="TSDeclareMethod"||u.type==="TSPropertySignature"||u.type==="ObjectTypeProperty")&&typeof u.key=="object"&&u.key&&(u.key.type==="Literal"||u.key.type==="NumericLiteral"||u.key.type==="StringLiteral"||u.key.type==="Identifier")&&delete i.key,u.type==="JSXElement"&&u.openingElement.name.name==="style"&&u.openingElement.attributes.some(m=>m.name.name==="jsx"))for(let{type:m,expression:d}of i.children)m==="JSXExpressionContainer"&&d.type==="TemplateLiteral"&&a(d);u.type==="JSXAttribute"&&u.name.name==="css"&&u.value.type==="JSXExpressionContainer"&&u.value.expression.type==="TemplateLiteral"&&a(i.value.expression),u.type==="JSXAttribute"&&u.value&&u.value.type==="Literal"&&/["']|&quot;|&apos;/.test(u.value.value)&&(i.value.value=i.value.value.replace(/["']|&quot;|&apos;/g,'"'));let c=u.expression||u.callee;if(u.type==="Decorator"&&c.type==="CallExpression"&&c.callee.name==="Component"&&c.arguments.length===1){let m=u.expression.arguments[0].properties;for(let[d,p]of i.expression.arguments[0].properties.entries())switch(m[d].key.name){case"styles":p.value.type==="ArrayExpression"&&a(p.value.elements[0]);break;case"template":p.value.type==="TemplateLiteral"&&a(p.value);break}}if(u.type==="TaggedTemplateExpression"&&(u.tag.type==="MemberExpression"||u.tag.type==="Identifier"&&(u.tag.name==="gql"||u.tag.name==="graphql"||u.tag.name==="css"||u.tag.name==="md"||u.tag.name==="markdown"||u.tag.name==="html")||u.tag.type==="CallExpression")&&a(i.quasi),u.type==="TemplateLiteral"){var v;(((v=u.leadingComments)===null||v===void 0?void 0:v.some(d=>t(d)&&["GraphQL","HTML"].some(p=>d.value===" ".concat(p," "))))||o.type==="CallExpression"&&o.callee.name==="graphql"||!u.leadingComments)&&a(i)}if(u.type==="InterpreterDirective"&&(i.value=i.value.trimEnd()),(u.type==="TSIntersectionType"||u.type==="TSUnionType")&&u.types.length===1)return i.types[0]}r.ignoredProperties=s,n.exports=r}}),Ha={};Ut(Ha,{EOL:()=>Pn,arch:()=>jm,cpus:()=>Ya,default:()=>ro,endianness:()=>Ga,freemem:()=>Xa,getNetworkInterfaces:()=>to,hostname:()=>Ja,loadavg:()=>Ua,networkInterfaces:()=>eo,platform:()=>Om,release:()=>Za,tmpDir:()=>wn,tmpdir:()=>_n,totalmem:()=>Ka,type:()=>Qa,uptime:()=>za});function Ga(){if(typeof Sr>"u"){var e=new ArrayBuffer(2),n=new Uint8Array(e),t=new Uint16Array(e);if(n[0]=1,n[1]=2,t[0]===258)Sr="BE";else if(t[0]===513)Sr="LE";else throw new Error("unable to figure out endianess")}return Sr}function Ja(){return typeof globalThis.location<"u"?globalThis.location.hostname:""}function Ua(){return[]}function za(){return 0}function Xa(){return Number.MAX_VALUE}function Ka(){return Number.MAX_VALUE}function Ya(){return[]}function Qa(){return"Browser"}function Za(){return typeof globalThis.navigator<"u"?globalThis.navigator.appVersion:""}function eo(){}function to(){}function jm(){return"javascript"}function Om(){return"browser"}function wn(){return"/tmp"}var Sr,_n,Pn,ro,qm=mt({"node-modules-polyfills:os"(){re(),_n=wn,Pn=`
`,ro={EOL:Pn,tmpdir:_n,tmpDir:wn,networkInterfaces:eo,getNetworkInterfaces:to,release:Za,type:Qa,cpus:Ya,totalmem:Ka,freemem:Xa,uptime:za,loadavg:Ua,hostname:Ja,endianness:Ga}}}),Mm=Z({"node-modules-polyfills-commonjs:os"(e,n){re();var t=(qm(),lt(Ha));if(t&&t.default){n.exports=t.default;for(let s in t)n.exports[s]=t[s]}else t&&(n.exports=t)}}),Rm=Z({"node_modules/detect-newline/index.js"(e,n){"use strict";re();var t=s=>{if(typeof s!="string")throw new TypeError("Expected a string");let a=s.match(/(?:\r?\n)/g)||[];if(a.length===0)return;let r=a.filter(i=>i===`\r
`).length,u=a.length-r;return r>u?`\r
`:`
`};n.exports=t,n.exports.graceful=s=>typeof s=="string"&&t(s)||`
`}}),Vm=Z({"node_modules/jest-docblock/build/index.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0}),e.extract=p,e.parse=h,e.parseWithComments=w,e.print=T,e.strip=f;function n(){let S=Mm();return n=function(){return S},S}function t(){let S=s(Rm());return t=function(){return S},S}function s(S){return S&&S.__esModule?S:{default:S}}var a=/\*\/$/,r=/^\/\*\*/,u=/^\s*(\/\*\*?(.|\r?\n)*?\*\/)/,i=/(^|\s+)\/\/([^\r\n]*)/g,o=/^(\r?\n)+/,c=/(?:^|\r?\n) *(@[^\r\n]*?) *\r?\n *(?![^@\r\n]*\/\/[^]*)([^@\r\n\s][^@\r\n]+?) *\r?\n/g,v=/(?:^|\r?\n) *@(\S+) *([^\r\n]*)/g,m=/(\r?\n|^) *\* ?/g,d=[];function p(S){let B=S.match(u);return B?B[0].trimLeft():""}function f(S){let B=S.match(u);return B&&B[0]?S.substring(B[0].length):S}function h(S){return w(S).pragmas}function w(S){let B=(0,t().default)(S)||n().EOL;S=S.replace(r,"").replace(a,"").replace(m,"$1");let I="";for(;I!==S;)I=S,S=S.replace(c,"".concat(B,"$1 $2").concat(B));S=S.replace(o,"").trimRight();let k=Object.create(null),P=S.replace(v,"").replace(o,"").trimRight(),C;for(;C=v.exec(S);){let D=C[2].replace(i,"");typeof k[C[1]]=="string"||Array.isArray(k[C[1]])?k[C[1]]=d.concat(k[C[1]],D):k[C[1]]=D}return{comments:P,pragmas:k}}function T(S){let{comments:B="",pragmas:I={}}=S,k=(0,t().default)(B)||n().EOL,P="/**",C=" *",D=" */",g=Object.keys(I),F=g.map(E=>A(E,I[E])).reduce((E,y)=>E.concat(y),[]).map(E=>C+" "+E+k).join("");if(!B){if(g.length===0)return"";if(g.length===1&&!Array.isArray(I[g[0]])){let E=I[g[0]];return"".concat(P," ").concat(A(g[0],E)[0]).concat(D)}}let l=B.split(k).map(E=>"".concat(C," ").concat(E)).join(k)+k;return P+k+(B?l:"")+(B&&g.length?C+k:"")+F+D}function A(S,B){return d.concat(B).map(I=>"@".concat(S," ").concat(I).trim())}}}),Wm=Z({"src/language-js/utils/get-shebang.js"(e,n){"use strict";re();function t(s){if(!s.startsWith("#!"))return"";let a=s.indexOf(`
`);return a===-1?s:s.slice(0,a)}n.exports=t}}),no=Z({"src/language-js/pragma.js"(e,n){"use strict";re();var{parseWithComments:t,strip:s,extract:a,print:r}=Vm(),{normalizeEndOfLine:u}=jn(),i=Wm();function o(m){let d=i(m);d&&(m=m.slice(d.length+1));let p=a(m),{pragmas:f,comments:h}=t(p);return{shebang:d,text:m,pragmas:f,comments:h}}function c(m){let d=Object.keys(o(m).pragmas);return d.includes("prettier")||d.includes("format")}function v(m){let{shebang:d,text:p,pragmas:f,comments:h}=o(m),w=s(p),T=r({pragmas:Object.assign({format:""},f),comments:h.trimStart()});return(d?"".concat(d,`
`):"")+u(T)+(w.startsWith(`
`)?`
`:`

`)+w}n.exports={hasPragma:c,insertPragma:v}}}),uo=Z({"src/language-js/comments.js"(e,n){"use strict";re();var{getLast:t,hasNewline:s,getNextNonSpaceNonCommentCharacterIndexWithStartIndex:a,getNextNonSpaceNonCommentCharacter:r,hasNewlineInRange:u,addLeadingComment:i,addTrailingComment:o,addDanglingComment:c,getNextNonSpaceNonCommentCharacterIndex:v,isNonEmptyArray:m}=Ue(),{getFunctionParameters:d,isPrettierIgnoreComment:p,isJsxNode:f,hasFlowShorthandAnnotationComment:h,hasFlowAnnotationComment:w,hasIgnoreComment:T,isCallLikeExpression:A,getCallArguments:S,isCallExpression:B,isMemberExpression:I,isObjectProperty:k,isLineComment:P,getComments:C,CommentCheckFlags:D,markerForIfWithoutBlockAndSameLineComment:g}=Ke(),{locStart:F,locEnd:l}=st(),E=It();function y(me){return[ve,De,q,j,$,V,Q,Ae,U,ge,Ne,ke,te,ie,G].some(_=>_(me))}function N(me){return[M,De,Y,Ne,j,$,V,Q,ie,z,le,ge,de,G,he].some(_=>_(me))}function x(me){return[ve,j,$,H,ue,te,ge,X,W,K,G,ae].some(_=>_(me))}function b(me,_){let J=(me.body||me.properties).find(ne=>{let{type:Ee}=ne;return Ee!=="EmptyStatement"});J?i(J,_):c(me,_)}function L(me,_){me.type==="BlockStatement"?b(me,_):i(me,_)}function M(me){let{comment:_,followingNode:J}=me;return J&&Ie(_)?(i(J,_),!0):!1}function j(me){let{comment:_,precedingNode:J,enclosingNode:ne,followingNode:Ee,text:We}=me;if((ne==null?void 0:ne.type)!=="IfStatement"||!Ee)return!1;if(r(We,_,l)===")")return o(J,_),!0;if(J===ne.consequent&&Ee===ne.alternate){if(J.type==="BlockStatement")o(J,_);else{let Pe=_.type==="SingleLine"||_.loc.start.line===_.loc.end.line,Se=_.loc.start.line===J.loc.start.line;Pe&&Se?c(J,_,g):c(ne,_)}return!0}return Ee.type==="BlockStatement"?(b(Ee,_),!0):Ee.type==="IfStatement"?(L(Ee.consequent,_),!0):ne.consequent===Ee?(i(Ee,_),!0):!1}function $(me){let{comment:_,precedingNode:J,enclosingNode:ne,followingNode:Ee,text:We}=me;return(ne==null?void 0:ne.type)!=="WhileStatement"||!Ee?!1:r(We,_,l)===")"?(o(J,_),!0):Ee.type==="BlockStatement"?(b(Ee,_),!0):ne.body===Ee?(i(Ee,_),!0):!1}function V(me){let{comment:_,precedingNode:J,enclosingNode:ne,followingNode:Ee}=me;return(ne==null?void 0:ne.type)!=="TryStatement"&&(ne==null?void 0:ne.type)!=="CatchClause"||!Ee?!1:ne.type==="CatchClause"&&J?(o(J,_),!0):Ee.type==="BlockStatement"?(b(Ee,_),!0):Ee.type==="TryStatement"?(L(Ee.finalizer,_),!0):Ee.type==="CatchClause"?(L(Ee.body,_),!0):!1}function q(me){let{comment:_,enclosingNode:J,followingNode:ne}=me;return I(J)&&(ne==null?void 0:ne.type)==="Identifier"?(i(J,_),!0):!1}function Y(me){let{comment:_,precedingNode:J,enclosingNode:ne,followingNode:Ee,text:We}=me,Be=J&&!u(We,l(J),F(_));return(!J||!Be)&&((ne==null?void 0:ne.type)==="ConditionalExpression"||(ne==null?void 0:ne.type)==="TSConditionalType")&&Ee?(i(Ee,_),!0):!1}function H(me){let{comment:_,precedingNode:J,enclosingNode:ne}=me;return k(ne)&&ne.shorthand&&ne.key===J&&ne.value.type==="AssignmentPattern"?(o(ne.value.left,_),!0):!1}var R=new Set(["ClassDeclaration","ClassExpression","DeclareClass","DeclareInterface","InterfaceDeclaration","TSInterfaceDeclaration"]);function Q(me){let{comment:_,precedingNode:J,enclosingNode:ne,followingNode:Ee}=me;if(R.has(ne==null?void 0:ne.type)){if(m(ne.decorators)&&!(Ee&&Ee.type==="Decorator"))return o(t(ne.decorators),_),!0;if(ne.body&&Ee===ne.body)return b(ne.body,_),!0;if(Ee){if(ne.superClass&&Ee===ne.superClass&&J&&(J===ne.id||J===ne.typeParameters))return o(J,_),!0;for(let We of["implements","extends","mixins"])if(ne[We]&&Ee===ne[We][0])return J&&(J===ne.id||J===ne.typeParameters||J===ne.superClass)?o(J,_):c(ne,_,We),!0}}return!1}var ee=new Set(["ClassMethod","ClassProperty","PropertyDefinition","TSAbstractPropertyDefinition","TSAbstractMethodDefinition","TSDeclareMethod","MethodDefinition"]);function te(me){let{comment:_,precedingNode:J,enclosingNode:ne,text:Ee}=me;return ne&&J&&r(Ee,_,l)==="("&&(ne.type==="Property"||ne.type==="TSDeclareMethod"||ne.type==="TSAbstractMethodDefinition")&&J.type==="Identifier"&&ne.key===J&&r(Ee,J,l)!==":"||(J==null?void 0:J.type)==="Decorator"&&ee.has(ne==null?void 0:ne.type)?(o(J,_),!0):!1}var oe=new Set(["FunctionDeclaration","FunctionExpression","ClassMethod","MethodDefinition","ObjectMethod"]);function W(me){let{comment:_,precedingNode:J,enclosingNode:ne,text:Ee}=me;return r(Ee,_,l)!=="("?!1:J&&oe.has(ne==null?void 0:ne.type)?(o(J,_),!0):!1}function X(me){let{comment:_,enclosingNode:J,text:ne}=me;if((J==null?void 0:J.type)!=="ArrowFunctionExpression")return!1;let Ee=v(ne,_,l);return Ee!==!1&&ne.slice(Ee,Ee+2)==="=>"?(c(J,_),!0):!1}function ue(me){let{comment:_,enclosingNode:J,text:ne}=me;return r(ne,_,l)!==")"?!1:J&&(ye(J)&&d(J).length===0||A(J)&&S(J).length===0)?(c(J,_),!0):((J==null?void 0:J.type)==="MethodDefinition"||(J==null?void 0:J.type)==="TSAbstractMethodDefinition")&&d(J.value).length===0?(c(J.value,_),!0):!1}function De(me){let{comment:_,precedingNode:J,enclosingNode:ne,followingNode:Ee,text:We}=me;if((J==null?void 0:J.type)==="FunctionTypeParam"&&(ne==null?void 0:ne.type)==="FunctionTypeAnnotation"&&(Ee==null?void 0:Ee.type)!=="FunctionTypeParam"||((J==null?void 0:J.type)==="Identifier"||(J==null?void 0:J.type)==="AssignmentPattern")&&ne&&ye(ne)&&r(We,_,l)===")")return o(J,_),!0;if((ne==null?void 0:ne.type)==="FunctionDeclaration"&&(Ee==null?void 0:Ee.type)==="BlockStatement"){let Be=(()=>{let Pe=d(ne);if(Pe.length>0)return a(We,l(t(Pe)));let Se=a(We,l(ne.id));return Se!==!1&&a(We,Se+1)})();if(F(_)>Be)return b(Ee,_),!0}return!1}function ie(me){let{comment:_,enclosingNode:J}=me;return(J==null?void 0:J.type)==="LabeledStatement"?(i(J,_),!0):!1}function G(me){let{comment:_,enclosingNode:J}=me;return((J==null?void 0:J.type)==="ContinueStatement"||(J==null?void 0:J.type)==="BreakStatement")&&!J.label?(o(J,_),!0):!1}function z(me){let{comment:_,precedingNode:J,enclosingNode:ne}=me;return B(ne)&&J&&ne.callee===J&&ne.arguments.length>0?(i(ne.arguments[0],_),!0):!1}function U(me){let{comment:_,precedingNode:J,enclosingNode:ne,followingNode:Ee}=me;return(ne==null?void 0:ne.type)==="UnionTypeAnnotation"||(ne==null?void 0:ne.type)==="TSUnionType"?(p(_)&&(Ee.prettierIgnore=!0,_.unignore=!0),J?(o(J,_),!0):!1):(((Ee==null?void 0:Ee.type)==="UnionTypeAnnotation"||(Ee==null?void 0:Ee.type)==="TSUnionType")&&p(_)&&(Ee.types[0].prettierIgnore=!0,_.unignore=!0),!1)}function le(me){let{comment:_,enclosingNode:J}=me;return k(J)?(i(J,_),!0):!1}function ge(me){let{comment:_,enclosingNode:J,followingNode:ne,ast:Ee,isLastComment:We}=me;return Ee&&Ee.body&&Ee.body.length===0?(We?c(Ee,_):i(Ee,_),!0):(J==null?void 0:J.type)==="Program"&&(J==null?void 0:J.body.length)===0&&!m(J.directives)?(We?c(J,_):i(J,_),!0):(ne==null?void 0:ne.type)==="Program"&&(ne==null?void 0:ne.body.length)===0&&(J==null?void 0:J.type)==="ModuleExpression"?(c(ne,_),!0):!1}function Ae(me){let{comment:_,enclosingNode:J}=me;return(J==null?void 0:J.type)==="ForInStatement"||(J==null?void 0:J.type)==="ForOfStatement"?(i(J,_),!0):!1}function Ne(me){let{comment:_,precedingNode:J,enclosingNode:ne,text:Ee}=me;if((ne==null?void 0:ne.type)==="ImportSpecifier"||(ne==null?void 0:ne.type)==="ExportSpecifier")return i(ne,_),!0;let We=(J==null?void 0:J.type)==="ImportSpecifier"&&(ne==null?void 0:ne.type)==="ImportDeclaration",Be=(J==null?void 0:J.type)==="ExportSpecifier"&&(ne==null?void 0:ne.type)==="ExportNamedDeclaration";return(We||Be)&&s(Ee,l(_))?(o(J,_),!0):!1}function ke(me){let{comment:_,enclosingNode:J}=me;return(J==null?void 0:J.type)==="AssignmentPattern"?(i(J,_),!0):!1}var ce=new Set(["VariableDeclarator","AssignmentExpression","TypeAlias","TSTypeAliasDeclaration"]),pe=new Set(["ObjectExpression","ArrayExpression","TemplateLiteral","TaggedTemplateExpression","ObjectTypeAnnotation","TSTypeLiteral"]);function de(me){let{comment:_,enclosingNode:J,followingNode:ne}=me;return ce.has(J==null?void 0:J.type)&&ne&&(pe.has(ne.type)||E(_))?(i(ne,_),!0):!1}function ae(me){let{comment:_,enclosingNode:J,followingNode:ne,text:Ee}=me;return!ne&&((J==null?void 0:J.type)==="TSMethodSignature"||(J==null?void 0:J.type)==="TSDeclareFunction"||(J==null?void 0:J.type)==="TSAbstractMethodDefinition")&&r(Ee,_,l)===";"?(o(J,_),!0):!1}function ve(me){let{comment:_,enclosingNode:J,followingNode:ne}=me;if(p(_)&&(J==null?void 0:J.type)==="TSMappedType"&&(ne==null?void 0:ne.type)==="TSTypeParameter"&&ne.constraint)return J.prettierIgnore=!0,_.unignore=!0,!0}function K(me){let{comment:_,precedingNode:J,enclosingNode:ne,followingNode:Ee}=me;return(ne==null?void 0:ne.type)!=="TSMappedType"?!1:(Ee==null?void 0:Ee.type)==="TSTypeParameter"&&Ee.name?(i(Ee.name,_),!0):(J==null?void 0:J.type)==="TSTypeParameter"&&J.constraint?(o(J.constraint,_),!0):!1}function he(me){let{comment:_,enclosingNode:J,followingNode:ne}=me;return!J||J.type!=="SwitchCase"||J.test?!1:(ne.type==="BlockStatement"&&P(_)?b(ne,_):c(J,_),!0)}function ye(me){return me.type==="ArrowFunctionExpression"||me.type==="FunctionExpression"||me.type==="FunctionDeclaration"||me.type==="ObjectMethod"||me.type==="ClassMethod"||me.type==="TSDeclareFunction"||me.type==="TSCallSignatureDeclaration"||me.type==="TSConstructSignatureDeclaration"||me.type==="TSMethodSignature"||me.type==="TSConstructorType"||me.type==="TSFunctionType"||me.type==="TSDeclareMethod"}function Ce(me,_){if((_.parser==="typescript"||_.parser==="flow"||_.parser==="acorn"||_.parser==="espree"||_.parser==="meriyah"||_.parser==="__babel_estree")&&me.type==="MethodDefinition"&&me.value&&me.value.type==="FunctionExpression"&&d(me.value).length===0&&!me.value.returnType&&!m(me.value.typeParameters)&&me.value.body)return[...me.decorators||[],me.key,me.value.body]}function Ie(me){return E(me)&&me.value[0]==="*"&&/@type\b/.test(me.value)}function Fe(me){let _=me.getValue(),J=me.getParentNode(),ne=Ee=>w(C(Ee,D.Leading))||w(C(Ee,D.Trailing));return(_&&(f(_)||h(_)||B(J)&&ne(_))||J&&(J.type==="JSXSpreadAttribute"||J.type==="JSXSpreadChild"||J.type==="UnionTypeAnnotation"||J.type==="TSUnionType"||(J.type==="ClassDeclaration"||J.type==="ClassExpression")&&J.superClass===_))&&(!T(me)||J.type==="UnionTypeAnnotation"||J.type==="TSUnionType")}n.exports={handleOwnLineComment:y,handleEndOfLineComment:N,handleRemainingComment:x,isTypeCastComment:Ie,getCommentChildNodes:Ce,willPrintOwnComments:Fe}}}),jt=Z({"src/language-js/needs-parens.js"(e,n){"use strict";re();var t=it(),s=Rn(),{getFunctionParameters:a,getLeftSidePathName:r,hasFlowShorthandAnnotationComment:u,hasNakedLeftSide:i,hasNode:o,isBitwiseOperator:c,startsWithNoLookaheadToken:v,shouldFlatten:m,getPrecedence:d,isCallExpression:p,isMemberExpression:f,isObjectProperty:h}=Ke();function w(P,C){let D=P.getParentNode();if(!D)return!1;let g=P.getName(),F=P.getNode();if(C.__isInHtmlInterpolation&&!C.bracketSpacing&&B(F)&&I(P))return!0;if(T(F))return!1;if(C.parser!=="flow"&&u(P.getValue()))return!0;if(F.type==="Identifier")return!!(F.extra&&F.extra.parenthesized&&/^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test(F.name)||g==="left"&&F.name==="async"&&D.type==="ForOfStatement"&&!D.await);switch(D.type){case"ParenthesizedExpression":return!1;case"ClassDeclaration":case"ClassExpression":{if(g==="superClass"&&(F.type==="ArrowFunctionExpression"||F.type==="AssignmentExpression"||F.type==="AwaitExpression"||F.type==="BinaryExpression"||F.type==="ConditionalExpression"||F.type==="LogicalExpression"||F.type==="NewExpression"||F.type==="ObjectExpression"||F.type==="SequenceExpression"||F.type==="TaggedTemplateExpression"||F.type==="UnaryExpression"||F.type==="UpdateExpression"||F.type==="YieldExpression"||F.type==="TSNonNullExpression"))return!0;break}case"ExportDefaultDeclaration":return k(P,C)||F.type==="SequenceExpression";case"Decorator":{if(g==="expression"){let l=!1,E=!1,y=F;for(;y;)switch(y.type){case"MemberExpression":E=!0,y=y.object;break;case"CallExpression":if(E||l)return C.parser!=="typescript";l=!0,y=y.callee;break;case"Identifier":return!1;case"TaggedTemplateExpression":return C.parser!=="typescript";default:return!0}return!0}break}case"ExpressionStatement":{if(v(F,!0))return!0;break}case"ArrowFunctionExpression":{if(g==="body"&&F.type!=="SequenceExpression"&&v(F,!1))return!0;break}}switch(F.type){case"UpdateExpression":if(D.type==="UnaryExpression")return F.prefix&&(F.operator==="++"&&D.operator==="+"||F.operator==="--"&&D.operator==="-");case"UnaryExpression":switch(D.type){case"UnaryExpression":return F.operator===D.operator&&(F.operator==="+"||F.operator==="-");case"BindExpression":return!0;case"MemberExpression":case"OptionalMemberExpression":return g==="object";case"TaggedTemplateExpression":return!0;case"NewExpression":case"CallExpression":case"OptionalCallExpression":return g==="callee";case"BinaryExpression":return g==="left"&&D.operator==="**";case"TSNonNullExpression":return!0;default:return!1}case"BinaryExpression":{if(D.type==="UpdateExpression"||F.operator==="in"&&A(P))return!0;if(F.operator==="|>"&&F.extra&&F.extra.parenthesized){let l=P.getParentNode(1);if(l.type==="BinaryExpression"&&l.operator==="|>")return!0}}case"TSTypeAssertion":case"TSAsExpression":case"LogicalExpression":switch(D.type){case"TSAsExpression":return F.type!=="TSAsExpression";case"ConditionalExpression":return F.type==="TSAsExpression";case"CallExpression":case"NewExpression":case"OptionalCallExpression":return g==="callee";case"ClassExpression":case"ClassDeclaration":return g==="superClass";case"TSTypeAssertion":case"TaggedTemplateExpression":case"UnaryExpression":case"JSXSpreadAttribute":case"SpreadElement":case"SpreadProperty":case"BindExpression":case"AwaitExpression":case"TSNonNullExpression":case"UpdateExpression":return!0;case"MemberExpression":case"OptionalMemberExpression":return g==="object";case"AssignmentExpression":case"AssignmentPattern":return g==="left"&&(F.type==="TSTypeAssertion"||F.type==="TSAsExpression");case"LogicalExpression":if(F.type==="LogicalExpression")return D.operator!==F.operator;case"BinaryExpression":{let{operator:l,type:E}=F;if(!l&&E!=="TSTypeAssertion")return!0;let y=d(l),N=D.operator,x=d(N);return x>y||g==="right"&&x===y||x===y&&!m(N,l)?!0:x<y&&l==="%"?N==="+"||N==="-":!!c(N)}default:return!1}case"SequenceExpression":switch(D.type){case"ReturnStatement":return!1;case"ForStatement":return!1;case"ExpressionStatement":return g!=="expression";case"ArrowFunctionExpression":return g!=="body";default:return!0}case"YieldExpression":if(D.type==="UnaryExpression"||D.type==="AwaitExpression"||D.type==="TSAsExpression"||D.type==="TSNonNullExpression")return!0;case"AwaitExpression":switch(D.type){case"TaggedTemplateExpression":case"UnaryExpression":case"LogicalExpression":case"SpreadElement":case"SpreadProperty":case"TSAsExpression":case"TSNonNullExpression":case"BindExpression":return!0;case"MemberExpression":case"OptionalMemberExpression":return g==="object";case"NewExpression":case"CallExpression":case"OptionalCallExpression":return g==="callee";case"ConditionalExpression":return g==="test";case"BinaryExpression":return!(!F.argument&&D.operator==="|>");default:return!1}case"TSConditionalType":if(g==="extendsType"&&D.type==="TSConditionalType")return!0;case"TSFunctionType":case"TSConstructorType":if(g==="checkType"&&D.type==="TSConditionalType")return!0;case"TSUnionType":case"TSIntersectionType":if((D.type==="TSUnionType"||D.type==="TSIntersectionType")&&D.types.length>1&&(!F.types||F.types.length>1))return!0;case"TSInferType":if(F.type==="TSInferType"&&D.type==="TSRestType")return!1;case"TSTypeOperator":return D.type==="TSArrayType"||D.type==="TSOptionalType"||D.type==="TSRestType"||g==="objectType"&&D.type==="TSIndexedAccessType"||D.type==="TSTypeOperator"||D.type==="TSTypeAnnotation"&&P.getParentNode(1).type.startsWith("TSJSDoc");case"ArrayTypeAnnotation":return D.type==="NullableTypeAnnotation";case"IntersectionTypeAnnotation":case"UnionTypeAnnotation":return D.type==="ArrayTypeAnnotation"||D.type==="NullableTypeAnnotation"||D.type==="IntersectionTypeAnnotation"||D.type==="UnionTypeAnnotation"||g==="objectType"&&(D.type==="IndexedAccessType"||D.type==="OptionalIndexedAccessType");case"NullableTypeAnnotation":return D.type==="ArrayTypeAnnotation"||g==="objectType"&&(D.type==="IndexedAccessType"||D.type==="OptionalIndexedAccessType");case"FunctionTypeAnnotation":{let l=D.type==="NullableTypeAnnotation"?P.getParentNode(1):D;return l.type==="UnionTypeAnnotation"||l.type==="IntersectionTypeAnnotation"||l.type==="ArrayTypeAnnotation"||g==="objectType"&&(l.type==="IndexedAccessType"||l.type==="OptionalIndexedAccessType")||l.type==="NullableTypeAnnotation"||D.type==="FunctionTypeParam"&&D.name===null&&a(F).some(E=>E.typeAnnotation&&E.typeAnnotation.type==="NullableTypeAnnotation")}case"OptionalIndexedAccessType":return g==="objectType"&&D.type==="IndexedAccessType";case"TypeofTypeAnnotation":return g==="objectType"&&(D.type==="IndexedAccessType"||D.type==="OptionalIndexedAccessType");case"StringLiteral":case"NumericLiteral":case"Literal":if(typeof F.value=="string"&&D.type==="ExpressionStatement"&&!D.directive){let l=P.getParentNode(1);return l.type==="Program"||l.type==="BlockStatement"}return g==="object"&&D.type==="MemberExpression"&&typeof F.value=="number";case"AssignmentExpression":{let l=P.getParentNode(1);return g==="body"&&D.type==="ArrowFunctionExpression"?!0:g==="key"&&(D.type==="ClassProperty"||D.type==="PropertyDefinition")&&D.computed||(g==="init"||g==="update")&&D.type==="ForStatement"?!1:D.type==="ExpressionStatement"?F.left.type==="ObjectPattern":!(g==="key"&&D.type==="TSPropertySignature"||D.type==="AssignmentExpression"||D.type==="SequenceExpression"&&l&&l.type==="ForStatement"&&(l.init===D||l.update===D)||g==="value"&&D.type==="Property"&&l&&l.type==="ObjectPattern"&&l.properties.includes(D)||D.type==="NGChainedExpression")}case"ConditionalExpression":switch(D.type){case"TaggedTemplateExpression":case"UnaryExpression":case"SpreadElement":case"SpreadProperty":case"BinaryExpression":case"LogicalExpression":case"NGPipeExpression":case"ExportDefaultDeclaration":case"AwaitExpression":case"JSXSpreadAttribute":case"TSTypeAssertion":case"TypeCastExpression":case"TSAsExpression":case"TSNonNullExpression":return!0;case"NewExpression":case"CallExpression":case"OptionalCallExpression":return g==="callee";case"ConditionalExpression":return g==="test";case"MemberExpression":case"OptionalMemberExpression":return g==="object";default:return!1}case"FunctionExpression":switch(D.type){case"NewExpression":case"CallExpression":case"OptionalCallExpression":return g==="callee";case"TaggedTemplateExpression":return!0;default:return!1}case"ArrowFunctionExpression":switch(D.type){case"BinaryExpression":return D.operator!=="|>"||F.extra&&F.extra.parenthesized;case"NewExpression":case"CallExpression":case"OptionalCallExpression":return g==="callee";case"MemberExpression":case"OptionalMemberExpression":return g==="object";case"TSAsExpression":case"TSNonNullExpression":case"BindExpression":case"TaggedTemplateExpression":case"UnaryExpression":case"LogicalExpression":case"AwaitExpression":case"TSTypeAssertion":return!0;case"ConditionalExpression":return g==="test";default:return!1}case"ClassExpression":if(s(F.decorators))return!0;switch(D.type){case"NewExpression":return g==="callee";default:return!1}case"OptionalMemberExpression":case"OptionalCallExpression":{let l=P.getParentNode(1);if(g==="object"&&D.type==="MemberExpression"||g==="callee"&&(D.type==="CallExpression"||D.type==="NewExpression")||D.type==="TSNonNullExpression"&&l.type==="MemberExpression"&&l.object===D)return!0}case"CallExpression":case"MemberExpression":case"TaggedTemplateExpression":case"TSNonNullExpression":if(g==="callee"&&(D.type==="BindExpression"||D.type==="NewExpression")){let l=F;for(;l;)switch(l.type){case"CallExpression":case"OptionalCallExpression":return!0;case"MemberExpression":case"OptionalMemberExpression":case"BindExpression":l=l.object;break;case"TaggedTemplateExpression":l=l.tag;break;case"TSNonNullExpression":l=l.expression;break;default:return!1}}return!1;case"BindExpression":return g==="callee"&&(D.type==="BindExpression"||D.type==="NewExpression")||g==="object"&&f(D);case"NGPipeExpression":return!(D.type==="NGRoot"||D.type==="NGMicrosyntaxExpression"||D.type==="ObjectProperty"&&!(F.extra&&F.extra.parenthesized)||D.type==="ArrayExpression"||p(D)&&D.arguments[g]===F||g==="right"&&D.type==="NGPipeExpression"||g==="property"&&D.type==="MemberExpression"||D.type==="AssignmentExpression");case"JSXFragment":case"JSXElement":return g==="callee"||g==="left"&&D.type==="BinaryExpression"&&D.operator==="<"||D.type!=="ArrayExpression"&&D.type!=="ArrowFunctionExpression"&&D.type!=="AssignmentExpression"&&D.type!=="AssignmentPattern"&&D.type!=="BinaryExpression"&&D.type!=="NewExpression"&&D.type!=="ConditionalExpression"&&D.type!=="ExpressionStatement"&&D.type!=="JsExpressionRoot"&&D.type!=="JSXAttribute"&&D.type!=="JSXElement"&&D.type!=="JSXExpressionContainer"&&D.type!=="JSXFragment"&&D.type!=="LogicalExpression"&&!p(D)&&!h(D)&&D.type!=="ReturnStatement"&&D.type!=="ThrowStatement"&&D.type!=="TypeCastExpression"&&D.type!=="VariableDeclarator"&&D.type!=="YieldExpression";case"TypeAnnotation":return g==="returnType"&&D.type==="ArrowFunctionExpression"&&S(F)}return!1}function T(P){return P.type==="BlockStatement"||P.type==="BreakStatement"||P.type==="ClassBody"||P.type==="ClassDeclaration"||P.type==="ClassMethod"||P.type==="ClassProperty"||P.type==="PropertyDefinition"||P.type==="ClassPrivateProperty"||P.type==="ContinueStatement"||P.type==="DebuggerStatement"||P.type==="DeclareClass"||P.type==="DeclareExportAllDeclaration"||P.type==="DeclareExportDeclaration"||P.type==="DeclareFunction"||P.type==="DeclareInterface"||P.type==="DeclareModule"||P.type==="DeclareModuleExports"||P.type==="DeclareVariable"||P.type==="DoWhileStatement"||P.type==="EnumDeclaration"||P.type==="ExportAllDeclaration"||P.type==="ExportDefaultDeclaration"||P.type==="ExportNamedDeclaration"||P.type==="ExpressionStatement"||P.type==="ForInStatement"||P.type==="ForOfStatement"||P.type==="ForStatement"||P.type==="FunctionDeclaration"||P.type==="IfStatement"||P.type==="ImportDeclaration"||P.type==="InterfaceDeclaration"||P.type==="LabeledStatement"||P.type==="MethodDefinition"||P.type==="ReturnStatement"||P.type==="SwitchStatement"||P.type==="ThrowStatement"||P.type==="TryStatement"||P.type==="TSDeclareFunction"||P.type==="TSEnumDeclaration"||P.type==="TSImportEqualsDeclaration"||P.type==="TSInterfaceDeclaration"||P.type==="TSModuleDeclaration"||P.type==="TSNamespaceExportDeclaration"||P.type==="TypeAlias"||P.type==="VariableDeclaration"||P.type==="WhileStatement"||P.type==="WithStatement"}function A(P){let C=0,D=P.getValue();for(;D;){let g=P.getParentNode(C++);if(g&&g.type==="ForStatement"&&g.init===D)return!0;D=g}return!1}function S(P){return o(P,C=>C.type==="ObjectTypeAnnotation"&&o(C,D=>D.type==="FunctionTypeAnnotation"||void 0)||void 0)}function B(P){switch(P.type){case"ObjectExpression":return!0;default:return!1}}function I(P){let C=P.getValue(),D=P.getParentNode(),g=P.getName();switch(D.type){case"NGPipeExpression":if(typeof g=="number"&&D.arguments[g]===C&&D.arguments.length-1===g)return P.callParent(I);break;case"ObjectProperty":if(g==="value"){let F=P.getParentNode(1);return t(F.properties)===D}break;case"BinaryExpression":case"LogicalExpression":if(g==="right")return P.callParent(I);break;case"ConditionalExpression":if(g==="alternate")return P.callParent(I);break;case"UnaryExpression":if(D.prefix)return P.callParent(I);break}return!1}function k(P,C){let D=P.getValue(),g=P.getParentNode();return D.type==="FunctionExpression"||D.type==="ClassExpression"?g.type==="ExportDefaultDeclaration"||!w(P,C):!i(D)||g.type!=="ExportDefaultDeclaration"&&w(P,C)?!1:P.call(F=>k(F,C),...r(P,D))}n.exports=w}}),so=Z({"src/language-js/print-preprocess.js"(e,n){"use strict";re();function t(s,a){switch(a.parser){case"json":case"json5":case"json-stringify":case"__js_expression":case"__vue_expression":case"__vue_ts_expression":return Object.assign(Object.assign({},s),{},{type:a.parser.startsWith("__")?"JsExpressionRoot":"JsonRoot",node:s,comments:[],rootMarker:a.rootMarker});default:return s}}n.exports=t}}),$m=Z({"src/language-js/print/html-binding.js"(e,n){"use strict";re();var{builders:{join:t,line:s,group:a,softline:r,indent:u}}=Oe();function i(c,v,m){let d=c.getValue();if(v.__onHtmlBindingRoot&&c.getName()===null&&v.__onHtmlBindingRoot(d,v),d.type==="File"){if(v.__isVueForBindingLeft)return c.call(p=>{let f=t([",",s],p.map(m,"params")),{params:h}=p.getValue();return h.length===1?f:["(",u([r,a(f)]),r,")"]},"program","body",0);if(v.__isVueBindings)return c.call(p=>t([",",s],p.map(m,"params")),"program","body",0)}}function o(c){switch(c.type){case"MemberExpression":switch(c.property.type){case"Identifier":case"NumericLiteral":case"StringLiteral":return o(c.object)}return!1;case"Identifier":return!0;default:return!1}}n.exports={isVueEventBindingExpression:o,printHtmlBinding:i}}}),Jn=Z({"src/language-js/print/binaryish.js"(e,n){"use strict";re();var{printComments:t}=et(),{getLast:s}=Ue(),{builders:{join:a,line:r,softline:u,group:i,indent:o,align:c,ifBreak:v,indentIfBreak:m},utils:{cleanDoc:d,getDocParts:p,isConcat:f}}=Oe(),{hasLeadingOwnLineComment:h,isBinaryish:w,isJsxNode:T,shouldFlatten:A,hasComment:S,CommentCheckFlags:B,isCallExpression:I,isMemberExpression:k,isObjectProperty:P,isEnabledHackPipeline:C}=Ke(),D=0;function g(E,y,N){let x=E.getValue(),b=E.getParentNode(),L=E.getParentNode(1),M=x!==b.body&&(b.type==="IfStatement"||b.type==="WhileStatement"||b.type==="SwitchStatement"||b.type==="DoWhileStatement"),j=C(y)&&x.operator==="|>",$=F(E,N,y,!1,M);if(M)return $;if(j)return i($);if(I(b)&&b.callee===x||b.type==="UnaryExpression"||k(b)&&!b.computed)return i([o([u,...$]),u]);let V=b.type==="ReturnStatement"||b.type==="ThrowStatement"||b.type==="JSXExpressionContainer"&&L.type==="JSXAttribute"||x.operator!=="|"&&b.type==="JsExpressionRoot"||x.type!=="NGPipeExpression"&&(b.type==="NGRoot"&&y.parser==="__ng_binding"||b.type==="NGMicrosyntaxExpression"&&L.type==="NGMicrosyntax"&&L.body.length===1)||x===b.body&&b.type==="ArrowFunctionExpression"||x!==b.body&&b.type==="ForStatement"||b.type==="ConditionalExpression"&&L.type!=="ReturnStatement"&&L.type!=="ThrowStatement"&&!I(L)||b.type==="TemplateLiteral",q=b.type==="AssignmentExpression"||b.type==="VariableDeclarator"||b.type==="ClassProperty"||b.type==="PropertyDefinition"||b.type==="TSAbstractPropertyDefinition"||b.type==="ClassPrivateProperty"||P(b),Y=w(x.left)&&A(x.operator,x.left.operator);if(V||l(x)&&!Y||!l(x)&&q)return i($);if($.length===0)return"";let H=T(x.right),R=$.findIndex(X=>typeof X!="string"&&!Array.isArray(X)&&X.type==="group"),Q=$.slice(0,R===-1?1:R+1),ee=$.slice(Q.length,H?-1:void 0),te=Symbol("logicalChain-"+ ++D),oe=i([...Q,o(ee)],{id:te});if(!H)return oe;let W=s($);return i([oe,m(W,{groupId:te})])}function F(E,y,N,x,b){let L=E.getValue();if(!w(L))return[i(y())];let M=[];A(L.operator,L.left.operator)?M=E.call(ee=>F(ee,y,N,!0,b),"left"):M.push(i(y("left")));let j=l(L),$=(L.operator==="|>"||L.type==="NGPipeExpression"||L.operator==="|"&&N.parser==="__vue_expression")&&!h(N.originalText,L.right),V=L.type==="NGPipeExpression"?"|":L.operator,q=L.type==="NGPipeExpression"&&L.arguments.length>0?i(o([u,": ",a([u,":",v(" ")],E.map(y,"arguments").map(ee=>c(2,i(ee))))])):"",Y;if(j)Y=[V," ",y("right"),q];else{let te=C(N)&&V==="|>"?E.call(oe=>F(oe,y,N,!0,b),"right"):y("right");Y=[$?r:"",V,$?" ":r,te,q]}let H=E.getParentNode(),R=S(L.left,B.Trailing|B.Line),Q=R||!(b&&L.type==="LogicalExpression")&&H.type!==L.type&&L.left.type!==L.type&&L.right.type!==L.type;if(M.push($?"":" ",Q?i(Y,{shouldBreak:R}):Y),x&&S(L)){let ee=d(t(E,M,N));return f(ee)||ee.type==="fill"?p(ee):[ee]}return M}function l(E){return E.type!=="LogicalExpression"?!1:!!(E.right.type==="ObjectExpression"&&E.right.properties.length>0||E.right.type==="ArrayExpression"&&E.right.elements.length>0||T(E.right))}n.exports={printBinaryishExpression:g,shouldInlineLogicalExpression:l}}}),Hm=Z({"src/language-js/print/angular.js"(e,n){"use strict";re();var{builders:{join:t,line:s,group:a}}=Oe(),{hasNode:r,hasComment:u,getComments:i}=Ke(),{printBinaryishExpression:o}=Jn();function c(d,p,f){let h=d.getValue();if(!!h.type.startsWith("NG"))switch(h.type){case"NGRoot":return[f("node"),u(h.node)?" //"+i(h.node)[0].value.trimEnd():""];case"NGPipeExpression":return o(d,p,f);case"NGChainedExpression":return a(t([";",s],d.map(w=>m(w)?f():["(",f(),")"],"expressions")));case"NGEmptyExpression":return"";case"NGQuotedExpression":return[h.prefix,": ",h.value.trim()];case"NGMicrosyntax":return d.map((w,T)=>[T===0?"":v(w.getValue(),T,h)?" ":[";",s],f()],"body");case"NGMicrosyntaxKey":return/^[$_a-z][\w$]*(?:-[$_a-z][\w$])*$/i.test(h.name)?h.name:JSON.stringify(h.name);case"NGMicrosyntaxExpression":return[f("expression"),h.alias===null?"":[" as ",f("alias")]];case"NGMicrosyntaxKeyedExpression":{let w=d.getName(),T=d.getParentNode(),A=v(h,w,T)||(w===1&&(h.key.name==="then"||h.key.name==="else")||w===2&&h.key.name==="else"&&T.body[w-1].type==="NGMicrosyntaxKeyedExpression"&&T.body[w-1].key.name==="then")&&T.body[0].type==="NGMicrosyntaxExpression";return[f("key"),A?" ":": ",f("expression")]}case"NGMicrosyntaxLet":return["let ",f("key"),h.value===null?"":[" = ",f("value")]];case"NGMicrosyntaxAs":return[f("key")," as ",f("alias")];default:throw new Error("Unknown Angular node type: ".concat(JSON.stringify(h.type),"."))}}function v(d,p,f){return d.type==="NGMicrosyntaxKeyedExpression"&&d.key.name==="of"&&p===1&&f.body[0].type==="NGMicrosyntaxLet"&&f.body[0].value===null}function m(d){return r(d.getValue(),p=>{switch(p.type){case void 0:return!1;case"CallExpression":case"OptionalCallExpression":case"AssignmentExpression":return!0}})}n.exports={printAngular:c}}}),Gm=Z({"src/language-js/print/jsx.js"(e,n){"use strict";re();var{printComments:t,printDanglingComments:s}=et(),{builders:{line:a,hardline:r,softline:u,group:i,indent:o,conditionalGroup:c,fill:v,ifBreak:m,lineSuffixBoundary:d,join:p},utils:{willBreak:f}}=Oe(),{getLast:h,getPreferredQuote:w}=Ue(),{isJsxNode:T,rawText:A,isLiteral:S,isCallExpression:B,isStringLiteral:I,isBinaryish:k,hasComment:P,CommentCheckFlags:C,hasNodeIgnoreComment:D}=Ke(),g=jt(),{willPrintOwnComments:F}=uo(),l=ie=>ie===""||ie===a||ie===r||ie===u;function E(ie,G,z){let U=ie.getValue();if(U.type==="JSXElement"&&W(U))return[z("openingElement"),z("closingElement")];let le=U.type==="JSXElement"?z("openingElement"):z("openingFragment"),ge=U.type==="JSXElement"?z("closingElement"):z("closingFragment");if(U.children.length===1&&U.children[0].type==="JSXExpressionContainer"&&(U.children[0].expression.type==="TemplateLiteral"||U.children[0].expression.type==="TaggedTemplateExpression"))return[le,...ie.map(z,"children"),ge];U.children=U.children.map(Fe=>ue(Fe)?{type:"JSXText",value:" ",raw:" "}:Fe);let Ae=U.children.some(T),Ne=U.children.filter(Fe=>Fe.type==="JSXExpressionContainer").length>1,ke=U.type==="JSXElement"&&U.openingElement.attributes.length>1,ce=f(le)||Ae||ke||Ne,pe=ie.getParentNode().rootMarker==="mdx",de=G.singleQuote?"{' '}":'{" "}',ae=pe?" ":m([de,u]," "),ve=U.openingElement&&U.openingElement.name&&U.openingElement.name.name==="fbt",K=y(ie,G,z,ae,ve),he=U.children.some(Fe=>X(Fe));for(let Fe=K.length-2;Fe>=0;Fe--){let me=K[Fe]===""&&K[Fe+1]==="",_=K[Fe]===r&&K[Fe+1]===""&&K[Fe+2]===r,J=(K[Fe]===u||K[Fe]===r)&&K[Fe+1]===""&&K[Fe+2]===ae,ne=K[Fe]===ae&&K[Fe+1]===""&&(K[Fe+2]===u||K[Fe+2]===r),Ee=K[Fe]===ae&&K[Fe+1]===""&&K[Fe+2]===ae,We=K[Fe]===u&&K[Fe+1]===""&&K[Fe+2]===r||K[Fe]===r&&K[Fe+1]===""&&K[Fe+2]===u;_&&he||me||J||Ee||We?K.splice(Fe,2):ne&&K.splice(Fe+1,2)}for(;K.length>0&&l(h(K));)K.pop();for(;K.length>1&&l(K[0])&&l(K[1]);)K.shift(),K.shift();let ye=[];for(let[Fe,me]of K.entries()){if(me===ae){if(Fe===1&&K[Fe-1]===""){if(K.length===2){ye.push(de);continue}ye.push([de,r]);continue}else if(Fe===K.length-1){ye.push(de);continue}else if(K[Fe-1]===""&&K[Fe-2]===r){ye.push(de);continue}}ye.push(me),f(me)&&(ce=!0)}let Ce=he?v(ye):i(ye,{shouldBreak:!0});if(pe)return Ce;let Ie=i([le,o([r,Ce]),r,ge]);return ce?Ie:c([i([le,...K,ge]),Ie])}function y(ie,G,z,U,le){let ge=[];return ie.each((Ae,Ne,ke)=>{let ce=Ae.getValue();if(S(ce)){let pe=A(ce);if(X(ce)){let de=pe.split(ee);if(de[0]===""){if(ge.push(""),de.shift(),/\n/.test(de[0])){let ve=ke[Ne+1];ge.push(x(le,de[1],ce,ve))}else ge.push(U);de.shift()}let ae;if(h(de)===""&&(de.pop(),ae=de.pop()),de.length===0)return;for(let[ve,K]of de.entries())ve%2===1?ge.push(a):ge.push(K);if(ae!==void 0)if(/\n/.test(ae)){let ve=ke[Ne+1];ge.push(x(le,h(ge),ce,ve))}else ge.push(U);else{let ve=ke[Ne+1];ge.push(N(le,h(ge),ce,ve))}}else/\n/.test(pe)?pe.match(/\n/g).length>1&&ge.push("",r):ge.push("",U)}else{let pe=z();ge.push(pe);let de=ke[Ne+1];if(de&&X(de)){let ve=oe(A(de)).split(ee)[0];ge.push(N(le,ve,ce,de))}else ge.push(r)}},"children"),ge}function N(ie,G,z,U){return ie?"":z.type==="JSXElement"&&!z.closingElement||U&&U.type==="JSXElement"&&!U.closingElement?G.length===1?u:r:u}function x(ie,G,z,U){return ie?r:G.length===1?z.type==="JSXElement"&&!z.closingElement||U&&U.type==="JSXElement"&&!U.closingElement?r:u:r}function b(ie,G,z){let U=ie.getParentNode();if(!U||{ArrayExpression:!0,JSXAttribute:!0,JSXElement:!0,JSXExpressionContainer:!0,JSXFragment:!0,ExpressionStatement:!0,CallExpression:!0,OptionalCallExpression:!0,ConditionalExpression:!0,JsExpressionRoot:!0}[U.type])return G;let ge=ie.match(void 0,Ne=>Ne.type==="ArrowFunctionExpression",B,Ne=>Ne.type==="JSXExpressionContainer"),Ae=g(ie,z);return i([Ae?"":m("("),o([u,G]),u,Ae?"":m(")")],{shouldBreak:ge})}function L(ie,G,z){let U=ie.getValue(),le=[];if(le.push(z("name")),U.value){let ge;if(I(U.value)){let Ne=A(U.value).slice(1,-1).replace(/&apos;/g,"'").replace(/&quot;/g,'"'),{escaped:ke,quote:ce,regex:pe}=w(Ne,G.jsxSingleQuote?"'":'"');Ne=Ne.replace(pe,ke),ge=[ce,Ne,ce]}else ge=z("value");le.push("=",ge)}return le}function M(ie,G,z){let U=ie.getValue(),le=(ge,Ae)=>ge.type==="JSXEmptyExpression"||!P(ge)&&(ge.type==="ArrayExpression"||ge.type==="ObjectExpression"||ge.type==="ArrowFunctionExpression"||ge.type==="AwaitExpression"&&(le(ge.argument,ge)||ge.argument.type==="JSXElement")||B(ge)||ge.type==="FunctionExpression"||ge.type==="TemplateLiteral"||ge.type==="TaggedTemplateExpression"||ge.type==="DoExpression"||T(Ae)&&(ge.type==="ConditionalExpression"||k(ge)));return le(U.expression,ie.getParentNode(0))?i(["{",z("expression"),d,"}"]):i(["{",o([u,z("expression")]),u,d,"}"])}function j(ie,G,z){let U=ie.getValue(),le=U.name&&P(U.name)||U.typeParameters&&P(U.typeParameters);if(U.selfClosing&&U.attributes.length===0&&!le)return["<",z("name"),z("typeParameters")," />"];if(U.attributes&&U.attributes.length===1&&U.attributes[0].value&&I(U.attributes[0].value)&&!U.attributes[0].value.value.includes(`
`)&&!le&&!P(U.attributes[0]))return i(["<",z("name"),z("typeParameters")," ",...ie.map(z,"attributes"),U.selfClosing?" />":">"]);let ge=U.attributes.length>0&&P(h(U.attributes),C.Trailing),Ae=U.attributes.length===0&&!le||(G.bracketSameLine||G.jsxBracketSameLine)&&(!le||U.attributes.length>0)&&!ge,Ne=U.attributes&&U.attributes.some(ce=>ce.value&&I(ce.value)&&ce.value.value.includes(`
`)),ke=G.singleAttributePerLine&&U.attributes.length>1?r:a;return i(["<",z("name"),z("typeParameters"),o(ie.map(()=>[ke,z()],"attributes")),U.selfClosing?a:Ae?">":u,U.selfClosing?"/>":Ae?"":">"],{shouldBreak:Ne})}function $(ie,G,z){let U=ie.getValue(),le=[];le.push("</");let ge=z("name");return P(U.name,C.Leading|C.Line)?le.push(o([r,ge]),r):P(U.name,C.Leading|C.Block)?le.push(" ",ge):le.push(ge),le.push(">"),le}function V(ie,G){let z=ie.getValue(),U=P(z),le=P(z,C.Line),ge=z.type==="JSXOpeningFragment";return[ge?"<":"</",o([le?r:U&&!ge?" ":"",s(ie,G,!0)]),le?r:"",">"]}function q(ie,G,z){let U=t(ie,E(ie,G,z),G);return b(ie,U,G)}function Y(ie,G){let z=ie.getValue(),U=P(z,C.Line);return[s(ie,G,!U),U?r:""]}function H(ie,G,z){let U=ie.getValue();return["{",ie.call(le=>{let ge=["...",z()],Ae=le.getValue();return!P(Ae)||!F(le)?ge:[o([u,t(le,ge,G)]),u]},U.type==="JSXSpreadAttribute"?"argument":"expression"),"}"]}function R(ie,G,z){let U=ie.getValue();if(!!U.type.startsWith("JSX"))switch(U.type){case"JSXAttribute":return L(ie,G,z);case"JSXIdentifier":return String(U.name);case"JSXNamespacedName":return p(":",[z("namespace"),z("name")]);case"JSXMemberExpression":return p(".",[z("object"),z("property")]);case"JSXSpreadAttribute":return H(ie,G,z);case"JSXSpreadChild":return H(ie,G,z);case"JSXExpressionContainer":return M(ie,G,z);case"JSXFragment":case"JSXElement":return q(ie,G,z);case"JSXOpeningElement":return j(ie,G,z);case"JSXClosingElement":return $(ie,G,z);case"JSXOpeningFragment":case"JSXClosingFragment":return V(ie,G);case"JSXEmptyExpression":return Y(ie,G);case"JSXText":throw new Error("JSXTest should be handled by JSXElement");default:throw new Error("Unknown JSX node type: ".concat(JSON.stringify(U.type),"."))}}var Q=` 
\r	`,ee=new RegExp("(["+Q+"]+)"),te=new RegExp("[^"+Q+"]"),oe=ie=>ie.replace(new RegExp("(?:^"+ee.source+"|"+ee.source+"$)"),"");function W(ie){if(ie.children.length===0)return!0;if(ie.children.length>1)return!1;let G=ie.children[0];return S(G)&&!X(G)}function X(ie){return S(ie)&&(te.test(A(ie))||!/\n/.test(A(ie)))}function ue(ie){return ie.type==="JSXExpressionContainer"&&S(ie.expression)&&ie.expression.value===" "&&!P(ie.expression)}function De(ie){let G=ie.getValue(),z=ie.getParentNode();if(!z||!G||!T(G)||!T(z))return!1;let U=z.children.indexOf(G),le=null;for(let ge=U;ge>0;ge--){let Ae=z.children[ge-1];if(!(Ae.type==="JSXText"&&!X(Ae))){le=Ae;break}}return le&&le.type==="JSXExpressionContainer"&&le.expression.type==="JSXEmptyExpression"&&D(le.expression)}n.exports={hasJsxIgnoreComment:De,printJsx:R}}}),ct=Z({"src/language-js/print/misc.js"(e,n){"use strict";re();var{isNonEmptyArray:t}=Ue(),{builders:{indent:s,join:a,line:r}}=Oe(),{isFlowAnnotationComment:u}=Ke();function i(h){let w=h.getValue();return!w.optional||w.type==="Identifier"&&w===h.getParentNode().key?"":w.type==="OptionalCallExpression"||w.type==="OptionalMemberExpression"&&w.computed?"?.":"?"}function o(h){return h.getValue().definite||h.match(void 0,(w,T)=>T==="id"&&w.type==="VariableDeclarator"&&w.definite)?"!":""}function c(h,w,T){let A=h.getValue();return A.typeArguments?T("typeArguments"):A.typeParameters?T("typeParameters"):""}function v(h,w,T){let A=h.getValue();if(!A.typeAnnotation)return"";let S=h.getParentNode(),B=S.type==="DeclareFunction"&&S.id===A;return u(w.originalText,A.typeAnnotation)?[" /*: ",T("typeAnnotation")," */"]:[B?"":": ",T("typeAnnotation")]}function m(h,w,T){return["::",T("callee")]}function d(h,w,T){let A=h.getValue();return t(A.modifiers)?[a(" ",h.map(T,"modifiers"))," "]:""}function p(h,w,T){return h.type==="EmptyStatement"?";":h.type==="BlockStatement"||T?[" ",w]:s([r,w])}function f(h,w,T){return["...",T("argument"),v(h,w,T)]}n.exports={printOptionalToken:i,printDefiniteToken:o,printFunctionTypeParameters:c,printBindExpressionCallee:m,printTypeScriptModifiers:d,printTypeAnnotation:v,printRestSpread:f,adjustClause:p}}}),Kt=Z({"src/language-js/print/array.js"(e,n){"use strict";re();var{printDanglingComments:t}=et(),{builders:{line:s,softline:a,hardline:r,group:u,indent:i,ifBreak:o,fill:c}}=Oe(),{getLast:v,hasNewline:m}=Ue(),{shouldPrintComma:d,hasComment:p,CommentCheckFlags:f,isNextLineEmpty:h,isNumericLiteral:w,isSignedNumericLiteral:T}=Ke(),{locStart:A}=st(),{printOptionalToken:S,printTypeAnnotation:B}=ct();function I(D,g,F){let l=D.getValue(),E=[],y=l.type==="TupleExpression"?"#[":"[",N="]";if(l.elements.length===0)p(l,f.Dangling)?E.push(u([y,t(D,g),a,N])):E.push(y,N);else{let x=v(l.elements),b=!(x&&x.type==="RestElement"),L=x===null,M=Symbol("array"),j=!g.__inJestEach&&l.elements.length>1&&l.elements.every((q,Y,H)=>{let R=q&&q.type;if(R!=="ArrayExpression"&&R!=="ObjectExpression")return!1;let Q=H[Y+1];if(Q&&R!==Q.type)return!1;let ee=R==="ArrayExpression"?"elements":"properties";return q[ee]&&q[ee].length>1}),$=k(l,g),V=b?L?",":d(g)?$?o(",","",{groupId:M}):o(","):"":"";E.push(u([y,i([a,$?C(D,g,F,V):[P(D,g,"elements",F),V],t(D,g,!0)]),a,N],{shouldBreak:j,id:M}))}return E.push(S(D),B(D,g,F)),E}function k(D,g){return D.elements.length>1&&D.elements.every(F=>F&&(w(F)||T(F)&&!p(F.argument))&&!p(F,f.Trailing|f.Line,l=>!m(g.originalText,A(l),{backwards:!0})))}function P(D,g,F,l){let E=[],y=[];return D.each(N=>{E.push(y,u(l())),y=[",",s],N.getValue()&&h(N.getValue(),g)&&y.push(a)},F),E}function C(D,g,F,l){let E=[];return D.each((y,N,x)=>{let b=N===x.length-1;E.push([F(),b?l:","]),b||E.push(h(y.getValue(),g)?[r,r]:p(x[N+1],f.Leading|f.Line)?r:s)},"elements"),c(E)}n.exports={printArray:I,printArrayItems:P,isConciselyPrintedArray:k}}}),io=Z({"src/language-js/print/call-arguments.js"(e,n){"use strict";re();var{printDanglingComments:t}=et(),{getLast:s,getPenultimate:a}=Ue(),{getFunctionParameters:r,hasComment:u,CommentCheckFlags:i,isFunctionCompositionArgs:o,isJsxNode:c,isLongCurriedCallExpression:v,shouldPrintComma:m,getCallArguments:d,iterateCallArgumentsPath:p,isNextLineEmpty:f,isCallExpression:h,isStringLiteral:w,isObjectProperty:T}=Ke(),{builders:{line:A,hardline:S,softline:B,group:I,indent:k,conditionalGroup:P,ifBreak:C,breakParent:D},utils:{willBreak:g}}=Oe(),{ArgExpansionBailout:F}=zt(),{isConciselyPrintedArray:l}=Kt();function E(j,$,V){let q=j.getValue(),Y=q.type==="ImportExpression",H=d(q);if(H.length===0)return["(",t(j,$,!0),")"];if(b(H))return["(",V(["arguments",0]),", ",V(["arguments",1]),")"];let R=!1,Q=!1,ee=H.length-1,te=[];p(j,(ie,G)=>{let z=ie.getNode(),U=[V()];G===ee||(f(z,$)?(G===0&&(Q=!0),R=!0,U.push(",",S,S)):U.push(",",A)),te.push(U)});let oe=!(Y||q.callee&&q.callee.type==="Import")&&m($,"all")?",":"";function W(){return I(["(",k([A,...te]),oe,A,")"],{shouldBreak:!0})}if(R||j.getParentNode().type!=="Decorator"&&o(H))return W();let X=x(H),ue=N(H,$);if(X||ue){if(X?te.slice(1).some(g):te.slice(0,-1).some(g))return W();let ie=[];try{j.try(()=>{p(j,(G,z)=>{X&&z===0&&(ie=[[V([],{expandFirstArg:!0}),te.length>1?",":"",Q?S:A,Q?S:""],...te.slice(1)]),ue&&z===ee&&(ie=[...te.slice(0,-1),V([],{expandLastArg:!0})])})})}catch(G){if(G instanceof F)return W();throw G}return[te.some(g)?D:"",P([["(",...ie,")"],X?["(",I(ie[0],{shouldBreak:!0}),...ie.slice(1),")"]:["(",...te.slice(0,-1),I(s(ie),{shouldBreak:!0}),")"],W()])]}let De=["(",k([B,...te]),C(oe),B,")"];return v(j)?De:I(De,{shouldBreak:te.some(g)||R})}function y(j){let $=arguments.length>1&&arguments[1]!==void 0?arguments[1]:!1;return j.type==="ObjectExpression"&&(j.properties.length>0||u(j))||j.type==="ArrayExpression"&&(j.elements.length>0||u(j))||j.type==="TSTypeAssertion"&&y(j.expression)||j.type==="TSAsExpression"&&y(j.expression)||j.type==="FunctionExpression"||j.type==="ArrowFunctionExpression"&&(!j.returnType||!j.returnType.typeAnnotation||j.returnType.typeAnnotation.type!=="TSTypeReference"||L(j.body))&&(j.body.type==="BlockStatement"||j.body.type==="ArrowFunctionExpression"&&y(j.body,!0)||j.body.type==="ObjectExpression"||j.body.type==="ArrayExpression"||!$&&(h(j.body)||j.body.type==="ConditionalExpression")||c(j.body))||j.type==="DoExpression"||j.type==="ModuleExpression"}function N(j,$){let V=s(j),q=a(j);return!u(V,i.Leading)&&!u(V,i.Trailing)&&y(V)&&(!q||q.type!==V.type)&&(j.length!==2||q.type!=="ArrowFunctionExpression"||V.type!=="ArrayExpression")&&!(j.length>1&&V.type==="ArrayExpression"&&l(V,$))}function x(j){if(j.length!==2)return!1;let[$,V]=j;return $.type==="ModuleExpression"&&M(V)?!0:!u($)&&($.type==="FunctionExpression"||$.type==="ArrowFunctionExpression"&&$.body.type==="BlockStatement")&&V.type!=="FunctionExpression"&&V.type!=="ArrowFunctionExpression"&&V.type!=="ConditionalExpression"&&!y(V)}function b(j){return j.length===2&&j[0].type==="ArrowFunctionExpression"&&r(j[0]).length===0&&j[0].body.type==="BlockStatement"&&j[1].type==="ArrayExpression"&&!j.some($=>u($))}function L(j){return j.type==="BlockStatement"&&(j.body.some($=>$.type!=="EmptyStatement")||u(j,i.Dangling))}function M(j){return j.type==="ObjectExpression"&&j.properties.length===1&&T(j.properties[0])&&j.properties[0].key.type==="Identifier"&&j.properties[0].key.name==="type"&&w(j.properties[0].value)&&j.properties[0].value.value==="module"}n.exports=E}}),ao=Z({"src/language-js/print/member.js"(e,n){"use strict";re();var{builders:{softline:t,group:s,indent:a,label:r}}=Oe(),{isNumericLiteral:u,isMemberExpression:i,isCallExpression:o}=Ke(),{printOptionalToken:c}=ct();function v(d,p,f){let h=d.getValue(),w=d.getParentNode(),T,A=0;do T=d.getParentNode(A),A++;while(T&&(i(T)||T.type==="TSNonNullExpression"));let S=f("object"),B=m(d,p,f),I=T&&(T.type==="NewExpression"||T.type==="BindExpression"||T.type==="AssignmentExpression"&&T.left.type!=="Identifier")||h.computed||h.object.type==="Identifier"&&h.property.type==="Identifier"&&!i(w)||(w.type==="AssignmentExpression"||w.type==="VariableDeclarator")&&(o(h.object)&&h.object.arguments.length>0||h.object.type==="TSNonNullExpression"&&o(h.object.expression)&&h.object.expression.arguments.length>0||S.label==="member-chain");return r(S.label==="member-chain"?"member-chain":"member",[S,I?B:s(a([t,B]))])}function m(d,p,f){let h=f("property"),w=d.getValue(),T=c(d);return w.computed?!w.property||u(w.property)?[T,"[",h,"]"]:s([T,"[",a([t,h]),t,"]"]):[T,".",h]}n.exports={printMemberExpression:v,printMemberLookup:m}}}),Jm=Z({"src/language-js/print/member-chain.js"(e,n){"use strict";re();var{printComments:t}=et(),{getLast:s,isNextLineEmptyAfterIndex:a,getNextNonSpaceNonCommentCharacterIndex:r}=Ue(),u=jt(),{isCallExpression:i,isMemberExpression:o,isFunctionOrArrowExpression:c,isLongCurriedCallExpression:v,isMemberish:m,isNumericLiteral:d,isSimpleCallArgument:p,hasComment:f,CommentCheckFlags:h,isNextLineEmpty:w}=Ke(),{locEnd:T}=st(),{builders:{join:A,hardline:S,group:B,indent:I,conditionalGroup:k,breakParent:P,label:C},utils:{willBreak:D}}=Oe(),g=io(),{printMemberLookup:F}=ao(),{printOptionalToken:l,printFunctionTypeParameters:E,printBindExpressionCallee:y}=ct();function N(x,b,L){let M=x.getParentNode(),j=!M||M.type==="ExpressionStatement",$=[];function V(de){let{originalText:ae}=b,ve=r(ae,de,T);return ae.charAt(ve)===")"?ve!==!1&&a(ae,ve+1):w(de,b)}function q(de){let ae=de.getValue();i(ae)&&(m(ae.callee)||i(ae.callee))?($.unshift({node:ae,printed:[t(de,[l(de),E(de,b,L),g(de,b,L)],b),V(ae)?S:""]}),de.call(ve=>q(ve),"callee")):m(ae)?($.unshift({node:ae,needsParens:u(de,b),printed:t(de,o(ae)?F(de,b,L):y(de,b,L),b)}),de.call(ve=>q(ve),"object")):ae.type==="TSNonNullExpression"?($.unshift({node:ae,printed:t(de,"!",b)}),de.call(ve=>q(ve),"expression")):$.unshift({node:ae,printed:L()})}let Y=x.getValue();$.unshift({node:Y,printed:[l(x),E(x,b,L),g(x,b,L)]}),Y.callee&&x.call(de=>q(de),"callee");let H=[],R=[$[0]],Q=1;for(;Q<$.length&&($[Q].node.type==="TSNonNullExpression"||i($[Q].node)||o($[Q].node)&&$[Q].node.computed&&d($[Q].node.property));++Q)R.push($[Q]);if(!i($[0].node))for(;Q+1<$.length&&(m($[Q].node)&&m($[Q+1].node));++Q)R.push($[Q]);H.push(R),R=[];let ee=!1;for(;Q<$.length;++Q){if(ee&&m($[Q].node)){if($[Q].node.computed&&d($[Q].node.property)){R.push($[Q]);continue}H.push(R),R=[],ee=!1}(i($[Q].node)||$[Q].node.type==="ImportExpression")&&(ee=!0),R.push($[Q]),f($[Q].node,h.Trailing)&&(H.push(R),R=[],ee=!1)}R.length>0&&H.push(R);function te(de){return/^[A-Z]|^[$_]+$/.test(de)}function oe(de){return de.length<=b.tabWidth}function W(de){let ae=de[1].length>0&&de[1][0].node.computed;if(de[0].length===1){let K=de[0][0].node;return K.type==="ThisExpression"||K.type==="Identifier"&&(te(K.name)||j&&oe(K.name)||ae)}let ve=s(de[0]).node;return o(ve)&&ve.property.type==="Identifier"&&(te(ve.property.name)||ae)}let X=H.length>=2&&!f(H[1][0].node)&&W(H);function ue(de){let ae=de.map(ve=>ve.printed);return de.length>0&&s(de).needsParens?["(",...ae,")"]:ae}function De(de){return de.length===0?"":I(B([S,A(S,de.map(ue))]))}let ie=H.map(ue),G=ie,z=X?3:2,U=H.flat(),le=U.slice(1,-1).some(de=>f(de.node,h.Leading))||U.slice(0,-1).some(de=>f(de.node,h.Trailing))||H[z]&&f(H[z][0].node,h.Leading);if(H.length<=z&&!le)return v(x)?G:B(G);let ge=s(H[X?1:0]).node,Ae=!i(ge)&&V(ge),Ne=[ue(H[0]),X?H.slice(1,2).map(ue):"",Ae?S:"",De(H.slice(X?2:1))],ke=$.map(de=>{let{node:ae}=de;return ae}).filter(i);function ce(){let de=s(s(H)).node,ae=s(ie);return i(de)&&D(ae)&&ke.slice(0,-1).some(ve=>ve.arguments.some(c))}let pe;return le||ke.length>2&&ke.some(de=>!de.arguments.every(ae=>p(ae,0)))||ie.slice(0,-1).some(D)||ce()?pe=B(Ne):pe=[D(G)||Ae?P:"",k([G,Ne])],C("member-chain",pe)}n.exports=N}}),oo=Z({"src/language-js/print/call-expression.js"(e,n){"use strict";re();var{builders:{join:t,group:s}}=Oe(),a=jt(),{getCallArguments:r,hasFlowAnnotationComment:u,isCallExpression:i,isMemberish:o,isStringLiteral:c,isTemplateOnItsOwnLine:v,isTestCall:m,iterateCallArgumentsPath:d}=Ke(),p=Jm(),f=io(),{printOptionalToken:h,printFunctionTypeParameters:w}=ct();function T(S,B,I){let k=S.getValue(),P=S.getParentNode(),C=k.type==="NewExpression",D=k.type==="ImportExpression",g=h(S),F=r(k);if(F.length>0&&(!D&&!C&&A(k,P)||F.length===1&&v(F[0],B.originalText)||!C&&m(k,P))){let y=[];return d(S,()=>{y.push(I())}),[C?"new ":"",I("callee"),g,w(S,B,I),"(",t(", ",y),")"]}let l=(B.parser==="babel"||B.parser==="babel-flow")&&k.callee&&k.callee.type==="Identifier"&&u(k.callee.trailingComments);if(l&&(k.callee.trailingComments[0].printed=!0),!D&&!C&&o(k.callee)&&!S.call(y=>a(y,B),"callee"))return p(S,B,I);let E=[C?"new ":"",D?"import":I("callee"),g,l?"/*:: ".concat(k.callee.trailingComments[0].value.slice(2).trim()," */"):"",w(S,B,I),f(S,B,I)];return D||i(k.callee)?s(E):E}function A(S,B){if(S.callee.type!=="Identifier")return!1;if(S.callee.name==="require")return!0;if(S.callee.name==="define"){let I=r(S);return B.type==="ExpressionStatement"&&(I.length===1||I.length===2&&I[0].type==="ArrayExpression"||I.length===3&&c(I[0])&&I[1].type==="ArrayExpression")}return!1}n.exports={printCallExpression:T}}}),Yt=Z({"src/language-js/print/assignment.js"(e,n){"use strict";re();var{isNonEmptyArray:t,getStringWidth:s}=Ue(),{builders:{line:a,group:r,indent:u,indentIfBreak:i,lineSuffixBoundary:o},utils:{cleanDoc:c,willBreak:v,canBreak:m}}=Oe(),{hasLeadingOwnLineComment:d,isBinaryish:p,isStringLiteral:f,isLiteral:h,isNumericLiteral:w,isCallExpression:T,isMemberExpression:A,getCallArguments:S,rawText:B,hasComment:I,isSignedNumericLiteral:k,isObjectProperty:P}=Ke(),{shouldInlineLogicalExpression:C}=Jn(),{printCallExpression:D}=oo();function g(W,X,ue,De,ie,G){let z=E(W,X,ue,De,G),U=ue(G,{assignmentLayout:z});switch(z){case"break-after-operator":return r([r(De),ie,r(u([a,U]))]);case"never-break-after-operator":return r([r(De),ie," ",U]);case"fluid":{let le=Symbol("assignment");return r([r(De),ie,r(u(a),{id:le}),o,i(U,{groupId:le})])}case"break-lhs":return r([De,ie," ",r(U)]);case"chain":return[r(De),ie,a,U];case"chain-tail":return[r(De),ie,u([a,U])];case"chain-tail-arrow-chain":return[r(De),ie,U];case"only-left":return De}}function F(W,X,ue){let De=W.getValue();return g(W,X,ue,ue("left"),[" ",De.operator],"right")}function l(W,X,ue){return g(W,X,ue,ue("id")," =","init")}function E(W,X,ue,De,ie){let G=W.getValue(),z=G[ie];if(!z)return"only-left";let U=!x(z);if(W.match(x,b,Ne=>!U||Ne.type!=="ExpressionStatement"&&Ne.type!=="VariableDeclaration"))return U?z.type==="ArrowFunctionExpression"&&z.body.type==="ArrowFunctionExpression"?"chain-tail-arrow-chain":"chain-tail":"chain";if(!U&&x(z.right)||d(X.originalText,z))return"break-after-operator";if(z.type==="CallExpression"&&z.callee.name==="require"||X.parser==="json5"||X.parser==="json")return"never-break-after-operator";if(N(G)||L(G)||$(G)||V(G)&&m(De))return"break-lhs";let Ae=ee(G,De,X);return W.call(()=>y(W,X,ue,Ae),ie)?"break-after-operator":Ae||z.type==="TemplateLiteral"||z.type==="TaggedTemplateExpression"||z.type==="BooleanLiteral"||w(z)||z.type==="ClassExpression"?"never-break-after-operator":"fluid"}function y(W,X,ue,De){let ie=W.getValue();if(p(ie)&&!C(ie))return!0;switch(ie.type){case"StringLiteralTypeAnnotation":case"SequenceExpression":return!0;case"ConditionalExpression":{let{test:U}=ie;return p(U)&&!C(U)}case"ClassExpression":return t(ie.decorators)}if(De)return!1;let G=ie,z=[];for(;;)if(G.type==="UnaryExpression")G=G.argument,z.push("argument");else if(G.type==="TSNonNullExpression")G=G.expression,z.push("expression");else break;return!!(f(G)||W.call(()=>H(W,X,ue),...z))}function N(W){if(b(W)){let X=W.left||W.id;return X.type==="ObjectPattern"&&X.properties.length>2&&X.properties.some(ue=>P(ue)&&(!ue.shorthand||ue.value&&ue.value.type==="AssignmentPattern"))}return!1}function x(W){return W.type==="AssignmentExpression"}function b(W){return x(W)||W.type==="VariableDeclarator"}function L(W){let X=M(W);if(t(X)){let ue=W.type==="TSTypeAliasDeclaration"?"constraint":"bound";if(X.length>1&&X.some(De=>De[ue]||De.default))return!0}return!1}function M(W){return j(W)&&W.typeParameters&&W.typeParameters.params?W.typeParameters.params:null}function j(W){return W.type==="TSTypeAliasDeclaration"||W.type==="TypeAlias"}function $(W){if(W.type!=="VariableDeclarator")return!1;let{typeAnnotation:X}=W.id;if(!X||!X.typeAnnotation)return!1;let ue=q(X.typeAnnotation);return t(ue)&&ue.length>1&&ue.some(De=>t(q(De))||De.type==="TSConditionalType")}function V(W){return W.type==="VariableDeclarator"&&W.init&&W.init.type==="ArrowFunctionExpression"}function q(W){return Y(W)&&W.typeParameters&&W.typeParameters.params?W.typeParameters.params:null}function Y(W){return W.type==="TSTypeReference"||W.type==="GenericTypeAnnotation"}function H(W,X,ue){let De=arguments.length>3&&arguments[3]!==void 0?arguments[3]:!1,ie=W.getValue(),G=()=>H(W,X,ue,!0);if(ie.type==="TSNonNullExpression")return W.call(G,"expression");if(T(ie)){if(D(W,X,ue).label==="member-chain")return!1;let U=S(ie);return!(U.length===0||U.length===1&&Q(U[0],X))||te(ie,ue)?!1:W.call(G,"callee")}return A(ie)?W.call(G,"object"):De&&(ie.type==="Identifier"||ie.type==="ThisExpression")}var R=.25;function Q(W,X){let{printWidth:ue}=X;if(I(W))return!1;let De=ue*R;if(W.type==="ThisExpression"||W.type==="Identifier"&&W.name.length<=De||k(W)&&!I(W.argument))return!0;let ie=W.type==="Literal"&&"regex"in W&&W.regex.pattern||W.type==="RegExpLiteral"&&W.pattern;return ie?ie.length<=De:f(W)?B(W).length<=De:W.type==="TemplateLiteral"?W.expressions.length===0&&W.quasis[0].value.raw.length<=De&&!W.quasis[0].value.raw.includes(`
`):h(W)}function ee(W,X,ue){if(!P(W))return!1;X=c(X);let De=3;return typeof X=="string"&&s(X)<ue.tabWidth+De}function te(W,X){let ue=oe(W);if(t(ue)){if(ue.length>1)return!0;if(ue.length===1){let ie=ue[0];if(ie.type==="TSUnionType"||ie.type==="UnionTypeAnnotation"||ie.type==="TSIntersectionType"||ie.type==="IntersectionTypeAnnotation"||ie.type==="TSTypeLiteral"||ie.type==="ObjectTypeAnnotation")return!0}let De=W.typeParameters?"typeParameters":"typeArguments";if(v(X(De)))return!0}return!1}function oe(W){return W.typeParameters&&W.typeParameters.params||W.typeArguments&&W.typeArguments.params}n.exports={printVariableDeclarator:l,printAssignmentExpression:F,printAssignment:g,isArrowFunctionVariableDeclarator:V}}}),Pr=Z({"src/language-js/print/function-parameters.js"(e,n){"use strict";re();var{getNextNonSpaceNonCommentCharacter:t}=Ue(),{printDanglingComments:s}=et(),{builders:{line:a,hardline:r,softline:u,group:i,indent:o,ifBreak:c},utils:{removeLines:v,willBreak:m}}=Oe(),{getFunctionParameters:d,iterateFunctionParametersPath:p,isSimpleType:f,isTestCall:h,isTypeAnnotationAFunction:w,isObjectType:T,isObjectTypePropertyAFunction:A,hasRestParameter:S,shouldPrintComma:B,hasComment:I,isNextLineEmpty:k}=Ke(),{locEnd:P}=st(),{ArgExpansionBailout:C}=zt(),{printFunctionTypeParameters:D}=ct();function g(y,N,x,b,L){let M=y.getValue(),j=d(M),$=L?D(y,x,N):"";if(j.length===0)return[$,"(",s(y,x,!0,ee=>t(x.originalText,ee,P)===")"),")"];let V=y.getParentNode(),q=h(V),Y=F(M),H=[];if(p(y,(ee,te)=>{let oe=te===j.length-1;oe&&M.rest&&H.push("..."),H.push(N()),!oe&&(H.push(","),q||Y?H.push(" "):k(j[te],x)?H.push(r,r):H.push(a))}),b){if(m($)||m(H))throw new C;return i([v($),"(",v(H),")"])}let R=j.every(ee=>!ee.decorators);return Y&&R?[$,"(",...H,")"]:q?[$,"(",...H,")"]:(A(V)||w(V)||V.type==="TypeAlias"||V.type==="UnionTypeAnnotation"||V.type==="TSUnionType"||V.type==="IntersectionTypeAnnotation"||V.type==="FunctionTypeAnnotation"&&V.returnType===M)&&j.length===1&&j[0].name===null&&M.this!==j[0]&&j[0].typeAnnotation&&M.typeParameters===null&&f(j[0].typeAnnotation)&&!M.rest?x.arrowParens==="always"?["(",...H,")"]:H:[$,"(",o([u,...H]),c(!S(M)&&B(x,"all")?",":""),u,")"]}function F(y){if(!y)return!1;let N=d(y);if(N.length!==1)return!1;let[x]=N;return!I(x)&&(x.type==="ObjectPattern"||x.type==="ArrayPattern"||x.type==="Identifier"&&x.typeAnnotation&&(x.typeAnnotation.type==="TypeAnnotation"||x.typeAnnotation.type==="TSTypeAnnotation")&&T(x.typeAnnotation.typeAnnotation)||x.type==="FunctionTypeParam"&&T(x.typeAnnotation)||x.type==="AssignmentPattern"&&(x.left.type==="ObjectPattern"||x.left.type==="ArrayPattern")&&(x.right.type==="Identifier"||x.right.type==="ObjectExpression"&&x.right.properties.length===0||x.right.type==="ArrayExpression"&&x.right.elements.length===0))}function l(y){let N;return y.returnType?(N=y.returnType,N.typeAnnotation&&(N=N.typeAnnotation)):y.typeAnnotation&&(N=y.typeAnnotation),N}function E(y,N){let x=l(y);if(!x)return!1;let b=y.typeParameters&&y.typeParameters.params;if(b){if(b.length>1)return!1;if(b.length===1){let L=b[0];if(L.constraint||L.default)return!1}}return d(y).length===1&&(T(x)||m(N))}n.exports={printFunctionParameters:g,shouldHugFunctionParameters:F,shouldGroupFunctionParameters:E}}}),kr=Z({"src/language-js/print/type-annotation.js"(e,n){"use strict";re();var{printComments:t,printDanglingComments:s}=et(),{isNonEmptyArray:a}=Ue(),{builders:{group:r,join:u,line:i,softline:o,indent:c,align:v,ifBreak:m}}=Oe(),d=jt(),{locStart:p}=st(),{isSimpleType:f,isObjectType:h,hasLeadingOwnLineComment:w,isObjectTypePropertyAFunction:T,shouldPrintComma:A}=Ke(),{printAssignment:S}=Yt(),{printFunctionParameters:B,shouldGroupFunctionParameters:I}=Pr(),{printArrayItems:k}=Kt();function P(x){if(f(x)||h(x))return!0;if(x.type==="UnionTypeAnnotation"||x.type==="TSUnionType"){let b=x.types.filter(M=>M.type==="VoidTypeAnnotation"||M.type==="TSVoidKeyword"||M.type==="NullLiteralTypeAnnotation"||M.type==="TSNullKeyword").length,L=x.types.some(M=>M.type==="ObjectTypeAnnotation"||M.type==="TSTypeLiteral"||M.type==="GenericTypeAnnotation"||M.type==="TSTypeReference");if(x.types.length-1===b&&L)return!0}return!1}function C(x,b,L){let M=b.semi?";":"",j=x.getValue(),$=[];return $.push("opaque type ",L("id"),L("typeParameters")),j.supertype&&$.push(": ",L("supertype")),j.impltype&&$.push(" = ",L("impltype")),$.push(M),$}function D(x,b,L){let M=b.semi?";":"",j=x.getValue(),$=[];j.declare&&$.push("declare "),$.push("type ",L("id"),L("typeParameters"));let V=j.type==="TSTypeAliasDeclaration"?"typeAnnotation":"right";return[S(x,b,L,$," =",V),M]}function g(x,b,L){let M=x.getValue(),j=x.map(L,"types"),$=[],V=!1;for(let q=0;q<j.length;++q)q===0?$.push(j[q]):h(M.types[q-1])&&h(M.types[q])?$.push([" & ",V?c(j[q]):j[q]]):!h(M.types[q-1])&&!h(M.types[q])?$.push(c([" &",i,j[q]])):(q>1&&(V=!0),$.push(" & ",q>1?c(j[q]):j[q]));return r($)}function F(x,b,L){let M=x.getValue(),j=x.getParentNode(),$=j.type!=="TypeParameterInstantiation"&&j.type!=="TSTypeParameterInstantiation"&&j.type!=="GenericTypeAnnotation"&&j.type!=="TSTypeReference"&&j.type!=="TSTypeAssertion"&&j.type!=="TupleTypeAnnotation"&&j.type!=="TSTupleType"&&!(j.type==="FunctionTypeParam"&&!j.name&&x.getParentNode(1).this!==j)&&!((j.type==="TypeAlias"||j.type==="VariableDeclarator"||j.type==="TSTypeAliasDeclaration")&&w(b.originalText,M)),V=P(M),q=x.map(R=>{let Q=L();return V||(Q=v(2,Q)),t(R,Q,b)},"types");if(V)return u(" | ",q);let Y=$&&!w(b.originalText,M),H=[m([Y?i:"","| "]),u([i,"| "],q)];return d(x,b)?r([c(H),o]):j.type==="TupleTypeAnnotation"&&j.types.length>1||j.type==="TSTupleType"&&j.elementTypes.length>1?r([c([m(["(",o]),H]),o,m(")")]):r($?c(H):H)}function l(x,b,L){let M=x.getValue(),j=[],$=x.getParentNode(0),V=x.getParentNode(1),q=x.getParentNode(2),Y=M.type==="TSFunctionType"||!(($.type==="ObjectTypeProperty"||$.type==="ObjectTypeInternalSlot")&&!$.variance&&!$.optional&&p($)===p(M)||$.type==="ObjectTypeCallProperty"||q&&q.type==="DeclareFunction"),H=Y&&($.type==="TypeAnnotation"||$.type==="TSTypeAnnotation"),R=H&&Y&&($.type==="TypeAnnotation"||$.type==="TSTypeAnnotation")&&V.type==="ArrowFunctionExpression";T($)&&(Y=!0,H=!0),R&&j.push("(");let Q=B(x,L,b,!1,!0),ee=M.returnType||M.predicate||M.typeAnnotation?[Y?" => ":": ",L("returnType"),L("predicate"),L("typeAnnotation")]:"",te=I(M,ee);return j.push(te?r(Q):Q),ee&&j.push(ee),R&&j.push(")"),r(j)}function E(x,b,L){let M=x.getValue(),j=M.type==="TSTupleType"?"elementTypes":"types",$=M[j],V=a($),q=V?o:"";return r(["[",c([q,k(x,b,j,L)]),m(V&&A(b,"all")?",":""),s(x,b,!0),q,"]"])}function y(x,b,L){let M=x.getValue(),j=M.type==="OptionalIndexedAccessType"&&M.optional?"?.[":"[";return[L("objectType"),j,L("indexType"),"]"]}function N(x,b,L){let M=x.getValue();return[M.postfix?"":L,b("typeAnnotation"),M.postfix?L:""]}n.exports={printOpaqueType:C,printTypeAlias:D,printIntersectionType:g,printUnionType:F,printFunctionType:l,printTupleType:E,printIndexedAccessType:y,shouldHugType:P,printJSDocType:N}}}),Ir=Z({"src/language-js/print/type-parameters.js"(e,n){"use strict";re();var{printDanglingComments:t}=et(),{builders:{join:s,line:a,hardline:r,softline:u,group:i,indent:o,ifBreak:c}}=Oe(),{isTestCall:v,hasComment:m,CommentCheckFlags:d,isTSXFile:p,shouldPrintComma:f,getFunctionParameters:h,isObjectType:w}=Ke(),{createGroupIdMapper:T}=Ue(),{shouldHugType:A}=kr(),{isArrowFunctionVariableDeclarator:S}=Yt(),B=T("typeParameters");function I(C,D,g,F){let l=C.getValue();if(!l[F])return"";if(!Array.isArray(l[F]))return g(F);let E=C.getNode(2),y=E&&v(E);if(!C.match(L=>!(L[F].length===1&&w(L[F][0])),void 0,(L,M)=>M==="typeAnnotation",L=>L.type==="Identifier",S)&&(y||l[F].length===0||l[F].length===1&&(l[F][0].type==="NullableTypeAnnotation"||A(l[F][0]))))return["<",s(", ",C.map(g,F)),k(C,D),">"];let b=l.type==="TSTypeParameterInstantiation"?"":h(l).length===1&&p(D)&&!l[F][0].constraint&&C.getParentNode().type==="ArrowFunctionExpression"?",":f(D,"all")?c(","):"";return i(["<",o([u,s([",",a],C.map(g,F))]),b,u,">"],{id:B(l)})}function k(C,D){let g=C.getValue();if(!m(g,d.Dangling))return"";let F=!m(g,d.Line),l=t(C,D,F);return F?l:[l,r]}function P(C,D,g){let F=C.getValue(),l=[],E=C.getParentNode();return E.type==="TSMappedType"?(l.push("[",g("name")),F.constraint&&l.push(" in ",g("constraint")),E.nameType&&l.push(" as ",C.callParent(()=>g("nameType"))),l.push("]"),l):(F.variance&&l.push(g("variance")),F.in&&l.push("in "),F.out&&l.push("out "),l.push(g("name")),F.bound&&l.push(": ",g("bound")),F.constraint&&l.push(" extends ",g("constraint")),F.default&&l.push(" = ",g("default")),l)}n.exports={printTypeParameter:P,printTypeParameters:I,getTypeParametersGroupId:B}}}),Qt=Z({"src/language-js/print/property.js"(e,n){"use strict";re();var{printComments:t}=et(),{printString:s,printNumber:a}=Ue(),{isNumericLiteral:r,isSimpleNumber:u,isStringLiteral:i,isStringPropSafeToUnquote:o,rawText:c}=Ke(),{printAssignment:v}=Yt(),m=new WeakMap;function d(f,h,w){let T=f.getNode();if(T.computed)return["[",w("key"),"]"];let A=f.getParentNode(),{key:S}=T;if(T.type==="ClassPrivateProperty"&&S.type==="Identifier")return["#",w("key")];if(h.quoteProps==="consistent"&&!m.has(A)){let B=(A.properties||A.body||A.members).some(I=>!I.computed&&I.key&&i(I.key)&&!o(I,h));m.set(A,B)}if((S.type==="Identifier"||r(S)&&u(a(c(S)))&&String(S.value)===a(c(S))&&!(h.parser==="typescript"||h.parser==="babel-ts"))&&(h.parser==="json"||h.quoteProps==="consistent"&&m.get(A))){let B=s(JSON.stringify(S.type==="Identifier"?S.name:S.value.toString()),h);return f.call(I=>t(I,B,h),"key")}return o(T,h)&&(h.quoteProps==="as-needed"||h.quoteProps==="consistent"&&!m.get(A))?f.call(B=>t(B,/^\d/.test(S.value)?a(S.value):S.value,h),"key"):w("key")}function p(f,h,w){return f.getValue().shorthand?w("value"):v(f,h,w,d(f,h,w),":","value")}n.exports={printProperty:p,printPropertyKey:d}}}),Lr=Z({"src/language-js/print/function.js"(e,n){"use strict";re();var t=Xt(),{printDanglingComments:s,printCommentsSeparately:a}=et(),r=it(),{getNextNonSpaceNonCommentCharacterIndex:u}=Ue(),{builders:{line:i,softline:o,group:c,indent:v,ifBreak:m,hardline:d,join:p,indentIfBreak:f},utils:{removeLines:h,willBreak:w}}=Oe(),{ArgExpansionBailout:T}=zt(),{getFunctionParameters:A,hasLeadingOwnLineComment:S,isFlowAnnotationComment:B,isJsxNode:I,isTemplateOnItsOwnLine:k,shouldPrintComma:P,startsWithNoLookaheadToken:C,isBinaryish:D,isLineComment:g,hasComment:F,getComments:l,CommentCheckFlags:E,isCallLikeExpression:y,isCallExpression:N,getCallArguments:x,hasNakedLeftSide:b,getLeftSide:L}=Ke(),{locEnd:M}=st(),{printFunctionParameters:j,shouldGroupFunctionParameters:$}=Pr(),{printPropertyKey:V}=Qt(),{printFunctionTypeParameters:q}=ct();function Y(z,U,le,ge){let Ae=z.getValue(),Ne=!1;if((Ae.type==="FunctionDeclaration"||Ae.type==="FunctionExpression")&&ge&&ge.expandLastArg){let ae=z.getParentNode();N(ae)&&x(ae).length>1&&(Ne=!0)}let ke=[];Ae.type==="TSDeclareFunction"&&Ae.declare&&ke.push("declare "),Ae.async&&ke.push("async "),Ae.generator?ke.push("function* "):ke.push("function "),Ae.id&&ke.push(U("id"));let ce=j(z,U,le,Ne),pe=X(z,U,le),de=$(Ae,pe);return ke.push(q(z,le,U),c([de?c(ce):ce,pe]),Ae.body?" ":"",U("body")),le.semi&&(Ae.declare||!Ae.body)&&ke.push(";"),ke}function H(z,U,le){let ge=z.getNode(),{kind:Ae}=ge,Ne=ge.value||ge,ke=[];return!Ae||Ae==="init"||Ae==="method"||Ae==="constructor"?Ne.async&&ke.push("async "):(t.ok(Ae==="get"||Ae==="set"),ke.push(Ae," ")),Ne.generator&&ke.push("*"),ke.push(V(z,U,le),ge.optional||ge.key.optional?"?":""),ge===Ne?ke.push(R(z,U,le)):Ne.type==="FunctionExpression"?ke.push(z.call(ce=>R(ce,U,le),"value")):ke.push(le("value")),ke}function R(z,U,le){let ge=z.getNode(),Ae=j(z,le,U),Ne=X(z,le,U),ke=$(ge,Ne),ce=[q(z,U,le),c([ke?c(Ae):Ae,Ne])];return ge.body?ce.push(" ",le("body")):ce.push(U.semi?";":""),ce}function Q(z,U,le,ge){let Ae=z.getValue(),Ne=[];if(Ae.async&&Ne.push("async "),W(z,U))Ne.push(le(["params",0]));else{let ce=ge&&(ge.expandLastArg||ge.expandFirstArg),pe=X(z,le,U);if(ce){if(w(pe))throw new T;pe=c(h(pe))}Ne.push(c([j(z,le,U,ce,!0),pe]))}let ke=s(z,U,!0,ce=>{let pe=u(U.originalText,ce,M);return pe!==!1&&U.originalText.slice(pe,pe+2)==="=>"});return ke&&Ne.push(" ",ke),Ne}function ee(z,U,le,ge,Ae,Ne){let ke=z.getName(),ce=z.getParentNode(),pe=y(ce)&&ke==="callee",de=Boolean(U&&U.assignmentLayout),ae=Ne.body.type!=="BlockStatement"&&Ne.body.type!=="ObjectExpression"&&Ne.body.type!=="SequenceExpression",ve=pe&&ae||U&&U.assignmentLayout==="chain-tail-arrow-chain",K=Symbol("arrow-chain");return Ne.body.type==="SequenceExpression"&&(Ae=c(["(",v([o,Ae]),o,")"])),c([c(v([pe||de?o:"",c(p([" =>",i],le),{shouldBreak:ge})]),{id:K,shouldBreak:ve})," =>",f(ae?v([i,Ae]):[" ",Ae],{groupId:K}),pe?m(o,"",{groupId:K}):""])}function te(z,U,le,ge){let Ae=z.getValue(),Ne=[],ke=[],ce=!1;if(function K(){let he=Q(z,U,le,ge);if(Ne.length===0)Ne.push(he);else{let{leading:ye,trailing:Ce}=a(z,U);Ne.push([ye,he]),ke.unshift(Ce)}ce=ce||Ae.returnType&&A(Ae).length>0||Ae.typeParameters||A(Ae).some(ye=>ye.type!=="Identifier"),Ae.body.type!=="ArrowFunctionExpression"||ge&&ge.expandLastArg?ke.unshift(le("body",ge)):(Ae=Ae.body,z.call(K,"body"))}(),Ne.length>1)return ee(z,ge,Ne,ce,ke,Ae);let pe=Ne;if(pe.push(" =>"),!S(U.originalText,Ae.body)&&(Ae.body.type==="ArrayExpression"||Ae.body.type==="ObjectExpression"||Ae.body.type==="BlockStatement"||I(Ae.body)||k(Ae.body,U.originalText)||Ae.body.type==="ArrowFunctionExpression"||Ae.body.type==="DoExpression"))return c([...pe," ",ke]);if(Ae.body.type==="SequenceExpression")return c([...pe,c([" (",v([o,ke]),o,")"])]);let de=(ge&&ge.expandLastArg||z.getParentNode().type==="JSXExpressionContainer")&&!F(Ae),ae=ge&&ge.expandLastArg&&P(U,"all"),ve=Ae.body.type==="ConditionalExpression"&&!C(Ae.body,!1);return c([...pe,c([v([i,ve?m("","("):"",ke,ve?m("",")"):""]),de?[m(ae?",":""),o]:""])])}function oe(z){let U=A(z);return U.length===1&&!z.typeParameters&&!F(z,E.Dangling)&&U[0].type==="Identifier"&&!U[0].typeAnnotation&&!F(U[0])&&!U[0].optional&&!z.predicate&&!z.returnType}function W(z,U){if(U.arrowParens==="always")return!1;if(U.arrowParens==="avoid"){let le=z.getValue();return oe(le)}return!1}function X(z,U,le){let ge=z.getValue(),Ae=U("returnType");if(ge.returnType&&B(le.originalText,ge.returnType))return[" /*: ",Ae," */"];let Ne=[Ae];return ge.returnType&&ge.returnType.typeAnnotation&&Ne.unshift(": "),ge.predicate&&Ne.push(ge.returnType?" ":": ",U("predicate")),Ne}function ue(z,U,le){let ge=z.getValue(),Ae=U.semi?";":"",Ne=[];ge.argument&&(G(U,ge.argument)?Ne.push([" (",v([d,le("argument")]),d,")"]):D(ge.argument)||ge.argument.type==="SequenceExpression"?Ne.push(c([m(" ("," "),v([o,le("argument")]),o,m(")")])):Ne.push(" ",le("argument")));let ke=l(ge),ce=r(ke),pe=ce&&g(ce);return pe&&Ne.push(Ae),F(ge,E.Dangling)&&Ne.push(" ",s(z,U,!0)),pe||Ne.push(Ae),Ne}function De(z,U,le){return["return",ue(z,U,le)]}function ie(z,U,le){return["throw",ue(z,U,le)]}function G(z,U){if(S(z.originalText,U))return!0;if(b(U)){let le=U,ge;for(;ge=L(le);)if(le=ge,S(z.originalText,le))return!0}return!1}n.exports={printFunction:Y,printArrowFunction:te,printMethod:H,printReturnStatement:De,printThrowStatement:ie,printMethodInternal:R,shouldPrintParamsWithoutParens:W}}}),Un=Z({"src/language-js/print/decorators.js"(e,n){"use strict";re();var{isNonEmptyArray:t,hasNewline:s}=Ue(),{builders:{line:a,hardline:r,join:u,breakParent:i,group:o}}=Oe(),{locStart:c,locEnd:v}=st(),{getParentExportDeclaration:m}=Ke();function d(T,A,S){let B=T.getValue();return o([u(a,T.map(S,"decorators")),h(B,A)?r:a])}function p(T,A,S){return[u(r,T.map(S,"declaration","decorators")),r]}function f(T,A,S){let B=T.getValue(),{decorators:I}=B;if(!t(I)||w(T.getParentNode()))return;let k=B.type==="ClassExpression"||B.type==="ClassDeclaration"||h(B,A);return[m(T)?r:k?i:"",u(a,T.map(S,"decorators")),a]}function h(T,A){return T.decorators.some(S=>s(A.originalText,v(S)))}function w(T){if(T.type!=="ExportDefaultDeclaration"&&T.type!=="ExportNamedDeclaration"&&T.type!=="DeclareExportDeclaration")return!1;let A=T.declaration&&T.declaration.decorators;return t(A)&&c(T,{ignoreDecorators:!0})>c(A[0])}n.exports={printDecorators:f,printClassMemberDecorators:d,printDecoratorsBeforeExport:p,hasDecoratorsBeforeExport:w}}}),Zt=Z({"src/language-js/print/class.js"(e,n){"use strict";re();var{isNonEmptyArray:t,createGroupIdMapper:s}=Ue(),{printComments:a,printDanglingComments:r}=et(),{builders:{join:u,line:i,hardline:o,softline:c,group:v,indent:m,ifBreak:d}}=Oe(),{hasComment:p,CommentCheckFlags:f}=Ke(),{getTypeParametersGroupId:h}=Ir(),{printMethod:w}=Lr(),{printOptionalToken:T,printTypeAnnotation:A,printDefiniteToken:S}=ct(),{printPropertyKey:B}=Qt(),{printAssignment:I}=Yt(),{printClassMemberDecorators:k}=Un();function P(x,b,L){let M=x.getValue(),j=[];M.declare&&j.push("declare "),M.abstract&&j.push("abstract "),j.push("class");let $=M.id&&p(M.id,f.Trailing)||M.typeParameters&&p(M.typeParameters,f.Trailing)||M.superClass&&p(M.superClass)||t(M.extends)||t(M.mixins)||t(M.implements),V=[],q=[];if(M.id&&V.push(" ",L("id")),V.push(L("typeParameters")),M.superClass){let Y=[E(x,b,L),L("superTypeParameters")],H=x.call(R=>["extends ",a(R,Y,b)],"superClass");$?q.push(i,v(H)):q.push(" ",H)}else q.push(l(x,b,L,"extends"));if(q.push(l(x,b,L,"mixins"),l(x,b,L,"implements")),$){let Y;F(M)?Y=[...V,m(q)]:Y=m([...V,q]),j.push(v(Y,{id:C(M)}))}else j.push(...V,...q);return j.push(" ",L("body")),j}var C=s("heritageGroup");function D(x){return d(o,"",{groupId:C(x)})}function g(x){return["superClass","extends","mixins","implements"].filter(b=>Boolean(x[b])).length>1}function F(x){return x.typeParameters&&!p(x.typeParameters,f.Trailing|f.Line)&&!g(x)}function l(x,b,L,M){let j=x.getValue();if(!t(j[M]))return"";let $=r(x,b,!0,V=>{let{marker:q}=V;return q===M});return[F(j)?d(" ",i,{groupId:h(j.typeParameters)}):i,$,$&&o,M,v(m([i,u([",",i],x.map(L,M))]))]}function E(x,b,L){let M=L("superClass");return x.getParentNode().type==="AssignmentExpression"?v(d(["(",m([c,M]),c,")"],M)):M}function y(x,b,L){let M=x.getValue(),j=[];return t(M.decorators)&&j.push(k(x,b,L)),M.accessibility&&j.push(M.accessibility+" "),M.readonly&&j.push("readonly "),M.declare&&j.push("declare "),M.static&&j.push("static "),(M.type==="TSAbstractMethodDefinition"||M.abstract)&&j.push("abstract "),M.override&&j.push("override "),j.push(w(x,b,L)),j}function N(x,b,L){let M=x.getValue(),j=[],$=b.semi?";":"";return t(M.decorators)&&j.push(k(x,b,L)),M.accessibility&&j.push(M.accessibility+" "),M.declare&&j.push("declare "),M.static&&j.push("static "),(M.type==="TSAbstractPropertyDefinition"||M.abstract)&&j.push("abstract "),M.override&&j.push("override "),M.readonly&&j.push("readonly "),M.variance&&j.push(L("variance")),M.type==="ClassAccessorProperty"&&j.push("accessor "),j.push(B(x,b,L),T(x),S(x),A(x,b,L)),[I(x,b,L,j," =","value"),$]}n.exports={printClass:P,printClassMethod:y,printClassProperty:N,printHardlineAfterHeritage:D}}}),lo=Z({"src/language-js/print/interface.js"(e,n){"use strict";re();var{isNonEmptyArray:t}=Ue(),{builders:{join:s,line:a,group:r,indent:u,ifBreak:i}}=Oe(),{hasComment:o,identity:c,CommentCheckFlags:v}=Ke(),{getTypeParametersGroupId:m}=Ir(),{printTypeScriptModifiers:d}=ct();function p(f,h,w){let T=f.getValue(),A=[];T.declare&&A.push("declare "),T.type==="TSInterfaceDeclaration"&&A.push(T.abstract?"abstract ":"",d(f,h,w)),A.push("interface");let S=[],B=[];T.type!=="InterfaceTypeAnnotation"&&S.push(" ",w("id"),w("typeParameters"));let I=T.typeParameters&&!o(T.typeParameters,v.Trailing|v.Line);return t(T.extends)&&B.push(I?i(" ",a,{groupId:m(T.typeParameters)}):a,"extends ",(T.extends.length===1?c:u)(s([",",a],f.map(w,"extends")))),T.id&&o(T.id,v.Trailing)||t(T.extends)?I?A.push(r([...S,u(B)])):A.push(r(u([...S,...B]))):A.push(...S,...B),A.push(" ",w("body")),r(A)}n.exports={printInterface:p}}}),co=Z({"src/language-js/print/module.js"(e,n){"use strict";re();var{isNonEmptyArray:t}=Ue(),{builders:{softline:s,group:a,indent:r,join:u,line:i,ifBreak:o,hardline:c}}=Oe(),{printDanglingComments:v}=et(),{hasComment:m,CommentCheckFlags:d,shouldPrintComma:p,needsHardlineAfterDanglingComment:f,isStringLiteral:h,rawText:w}=Ke(),{locStart:T,hasSameLoc:A}=st(),{hasDecoratorsBeforeExport:S,printDecoratorsBeforeExport:B}=Un();function I(N,x,b){let L=N.getValue(),M=x.semi?";":"",j=[],{importKind:$}=L;return j.push("import"),$&&$!=="value"&&j.push(" ",$),j.push(g(N,x,b),D(N,x,b),l(N,x,b),M),j}function k(N,x,b){let L=N.getValue(),M=[];S(L)&&M.push(B(N,x,b));let{type:j,exportKind:$,declaration:V}=L;return M.push("export"),(L.default||j==="ExportDefaultDeclaration")&&M.push(" default"),m(L,d.Dangling)&&(M.push(" ",v(N,x,!0)),f(L)&&M.push(c)),V?M.push(" ",b("declaration")):M.push($==="type"?" type":"",g(N,x,b),D(N,x,b),l(N,x,b)),C(L,x)&&M.push(";"),M}function P(N,x,b){let L=N.getValue(),M=x.semi?";":"",j=[],{exportKind:$,exported:V}=L;return j.push("export"),$==="type"&&j.push(" type"),j.push(" *"),V&&j.push(" as ",b("exported")),j.push(D(N,x,b),l(N,x,b),M),j}function C(N,x){if(!x.semi)return!1;let{type:b,declaration:L}=N,M=N.default||b==="ExportDefaultDeclaration";if(!L)return!0;let{type:j}=L;return!!(M&&j!=="ClassDeclaration"&&j!=="FunctionDeclaration"&&j!=="TSInterfaceDeclaration"&&j!=="DeclareClass"&&j!=="DeclareFunction"&&j!=="TSDeclareFunction"&&j!=="EnumDeclaration")}function D(N,x,b){let L=N.getValue();if(!L.source)return"";let M=[];return F(L,x)||M.push(" from"),M.push(" ",b("source")),M}function g(N,x,b){let L=N.getValue();if(F(L,x))return"";let M=[" "];if(t(L.specifiers)){let j=[],$=[];N.each(()=>{let V=N.getValue().type;if(V==="ExportNamespaceSpecifier"||V==="ExportDefaultSpecifier"||V==="ImportNamespaceSpecifier"||V==="ImportDefaultSpecifier")j.push(b());else if(V==="ExportSpecifier"||V==="ImportSpecifier")$.push(b());else throw new Error("Unknown specifier type ".concat(JSON.stringify(V)))},"specifiers"),M.push(u(", ",j)),$.length>0&&(j.length>0&&M.push(", "),$.length>1||j.length>0||L.specifiers.some(q=>m(q))?M.push(a(["{",r([x.bracketSpacing?i:s,u([",",i],$)]),o(p(x)?",":""),x.bracketSpacing?i:s,"}"])):M.push(["{",x.bracketSpacing?" ":"",...$,x.bracketSpacing?" ":"","}"]))}else M.push("{}");return M}function F(N,x){let{type:b,importKind:L,source:M,specifiers:j}=N;return b!=="ImportDeclaration"||t(j)||L==="type"?!1:!/{\s*}/.test(x.originalText.slice(T(N),T(M)))}function l(N,x,b){let L=N.getNode();return t(L.assertions)?[" assert {",x.bracketSpacing?" ":"",u(", ",N.map(b,"assertions")),x.bracketSpacing?" ":"","}"]:""}function E(N,x,b){let L=N.getNode(),{type:M}=L,j=[],$=M==="ImportSpecifier"?L.importKind:L.exportKind;$&&$!=="value"&&j.push($," ");let V=M.startsWith("Import"),q=V?"imported":"local",Y=V?"local":"exported",H=L[q],R=L[Y],Q="",ee="";return M==="ExportNamespaceSpecifier"||M==="ImportNamespaceSpecifier"?Q="*":H&&(Q=b(q)),R&&!y(L)&&(ee=b(Y)),j.push(Q,Q&&ee?" as ":"",ee),j}function y(N){if(N.type!=="ImportSpecifier"&&N.type!=="ExportSpecifier")return!1;let{local:x,[N.type==="ImportSpecifier"?"imported":"exported"]:b}=N;if(x.type!==b.type||!A(x,b))return!1;if(h(x))return x.value===b.value&&w(x)===w(b);switch(x.type){case"Identifier":return x.name===b.name;default:return!1}}n.exports={printImportDeclaration:I,printExportDeclaration:k,printExportAllDeclaration:P,printModuleSpecifier:E}}}),zn=Z({"src/language-js/print/object.js"(e,n){"use strict";re();var{printDanglingComments:t}=et(),{builders:{line:s,softline:a,group:r,indent:u,ifBreak:i,hardline:o}}=Oe(),{getLast:c,hasNewlineInRange:v,hasNewline:m,isNonEmptyArray:d}=Ue(),{shouldPrintComma:p,hasComment:f,getComments:h,CommentCheckFlags:w,isNextLineEmpty:T}=Ke(),{locStart:A,locEnd:S}=st(),{printOptionalToken:B,printTypeAnnotation:I}=ct(),{shouldHugFunctionParameters:k}=Pr(),{shouldHugType:P}=kr(),{printHardlineAfterHeritage:C}=Zt();function D(g,F,l){let E=F.semi?";":"",y=g.getValue(),N;y.type==="TSTypeLiteral"?N="members":y.type==="TSInterfaceBody"?N="body":N="properties";let x=y.type==="ObjectTypeAnnotation",b=[N];x&&b.push("indexers","callProperties","internalSlots");let L=b.map(W=>y[W][0]).sort((W,X)=>A(W)-A(X))[0],M=g.getParentNode(0),j=x&&M&&(M.type==="InterfaceDeclaration"||M.type==="DeclareInterface"||M.type==="DeclareClass")&&g.getName()==="body",$=y.type==="TSInterfaceBody"||j||y.type==="ObjectPattern"&&M.type!=="FunctionDeclaration"&&M.type!=="FunctionExpression"&&M.type!=="ArrowFunctionExpression"&&M.type!=="ObjectMethod"&&M.type!=="ClassMethod"&&M.type!=="ClassPrivateMethod"&&M.type!=="AssignmentPattern"&&M.type!=="CatchClause"&&y.properties.some(W=>W.value&&(W.value.type==="ObjectPattern"||W.value.type==="ArrayPattern"))||y.type!=="ObjectPattern"&&L&&v(F.originalText,A(y),A(L)),V=j?";":y.type==="TSInterfaceBody"||y.type==="TSTypeLiteral"?i(E,";"):",",q=y.type==="RecordExpression"?"#{":y.exact?"{|":"{",Y=y.exact?"|}":"}",H=[];for(let W of b)g.each(X=>{let ue=X.getValue();H.push({node:ue,printed:l(),loc:A(ue)})},W);b.length>1&&H.sort((W,X)=>W.loc-X.loc);let R=[],Q=H.map(W=>{let X=[...R,r(W.printed)];return R=[V,s],(W.node.type==="TSPropertySignature"||W.node.type==="TSMethodSignature"||W.node.type==="TSConstructSignatureDeclaration")&&f(W.node,w.PrettierIgnore)&&R.shift(),T(W.node,F)&&R.push(o),X});if(y.inexact){let W;if(f(y,w.Dangling)){let X=f(y,w.Line);W=[t(g,F,!0),X||m(F.originalText,S(c(h(y))))?o:s,"..."]}else W=["..."];Q.push([...R,...W])}let ee=c(y[N]),te=!(y.inexact||ee&&ee.type==="RestElement"||ee&&(ee.type==="TSPropertySignature"||ee.type==="TSCallSignatureDeclaration"||ee.type==="TSMethodSignature"||ee.type==="TSConstructSignatureDeclaration")&&f(ee,w.PrettierIgnore)),oe;if(Q.length===0){if(!f(y,w.Dangling))return[q,Y,I(g,F,l)];oe=r([q,t(g,F),a,Y,B(g),I(g,F,l)])}else oe=[j&&d(y.properties)?C(M):"",q,u([F.bracketSpacing?s:a,...Q]),i(te&&(V!==","||p(F))?V:""),F.bracketSpacing?s:a,Y,B(g),I(g,F,l)];return g.match(W=>W.type==="ObjectPattern"&&!W.decorators,(W,X,ue)=>k(W)&&(X==="params"||X==="parameters"||X==="this"||X==="rest")&&ue===0)||g.match(P,(W,X)=>X==="typeAnnotation",(W,X)=>X==="typeAnnotation",(W,X,ue)=>k(W)&&(X==="params"||X==="parameters"||X==="this"||X==="rest")&&ue===0)||!$&&g.match(W=>W.type==="ObjectPattern",W=>W.type==="AssignmentExpression"||W.type==="VariableDeclarator")?oe:r(oe,{shouldBreak:$})}n.exports={printObject:D}}}),Um=Z({"src/language-js/print/flow.js"(e,n){"use strict";re();var t=Xt(),{printDanglingComments:s}=et(),{printString:a,printNumber:r}=Ue(),{builders:{hardline:u,softline:i,group:o,indent:c}}=Oe(),{getParentExportDeclaration:v,isFunctionNotation:m,isGetterOrSetter:d,rawText:p,shouldPrintComma:f}=Ke(),{locStart:h,locEnd:w}=st(),{printClass:T}=Zt(),{printOpaqueType:A,printTypeAlias:S,printIntersectionType:B,printUnionType:I,printFunctionType:k,printTupleType:P,printIndexedAccessType:C}=kr(),{printInterface:D}=lo(),{printTypeParameter:g,printTypeParameters:F}=Ir(),{printExportDeclaration:l,printExportAllDeclaration:E}=co(),{printArrayItems:y}=Kt(),{printObject:N}=zn(),{printPropertyKey:x}=Qt(),{printOptionalToken:b,printTypeAnnotation:L,printRestSpread:M}=ct();function j(V,q,Y){let H=V.getValue(),R=q.semi?";":"",Q=[];switch(H.type){case"DeclareClass":return $(V,T(V,q,Y));case"DeclareFunction":return $(V,["function ",Y("id"),H.predicate?" ":"",Y("predicate"),R]);case"DeclareModule":return $(V,["module ",Y("id")," ",Y("body")]);case"DeclareModuleExports":return $(V,["module.exports",": ",Y("typeAnnotation"),R]);case"DeclareVariable":return $(V,["var ",Y("id"),R]);case"DeclareOpaqueType":return $(V,A(V,q,Y));case"DeclareInterface":return $(V,D(V,q,Y));case"DeclareTypeAlias":return $(V,S(V,q,Y));case"DeclareExportDeclaration":return $(V,l(V,q,Y));case"DeclareExportAllDeclaration":return $(V,E(V,q,Y));case"OpaqueType":return A(V,q,Y);case"TypeAlias":return S(V,q,Y);case"IntersectionTypeAnnotation":return B(V,q,Y);case"UnionTypeAnnotation":return I(V,q,Y);case"FunctionTypeAnnotation":return k(V,q,Y);case"TupleTypeAnnotation":return P(V,q,Y);case"GenericTypeAnnotation":return[Y("id"),F(V,q,Y,"typeParameters")];case"IndexedAccessType":case"OptionalIndexedAccessType":return C(V,q,Y);case"TypeAnnotation":return Y("typeAnnotation");case"TypeParameter":return g(V,q,Y);case"TypeofTypeAnnotation":return["typeof ",Y("argument")];case"ExistsTypeAnnotation":return"*";case"EmptyTypeAnnotation":return"empty";case"MixedTypeAnnotation":return"mixed";case"ArrayTypeAnnotation":return[Y("elementType"),"[]"];case"BooleanLiteralTypeAnnotation":return String(H.value);case"EnumDeclaration":return["enum ",Y("id")," ",Y("body")];case"EnumBooleanBody":case"EnumNumberBody":case"EnumStringBody":case"EnumSymbolBody":{if(H.type==="EnumSymbolBody"||H.explicitType){let ee=null;switch(H.type){case"EnumBooleanBody":ee="boolean";break;case"EnumNumberBody":ee="number";break;case"EnumStringBody":ee="string";break;case"EnumSymbolBody":ee="symbol";break}Q.push("of ",ee," ")}if(H.members.length===0&&!H.hasUnknownMembers)Q.push(o(["{",s(V,q),i,"}"]));else{let ee=H.members.length>0?[u,y(V,q,"members",Y),H.hasUnknownMembers||f(q)?",":""]:[];Q.push(o(["{",c([...ee,...H.hasUnknownMembers?[u,"..."]:[]]),s(V,q,!0),u,"}"]))}return Q}case"EnumBooleanMember":case"EnumNumberMember":case"EnumStringMember":return[Y("id")," = ",typeof H.init=="object"?Y("init"):String(H.init)];case"EnumDefaultedMember":return Y("id");case"FunctionTypeParam":{let ee=H.name?Y("name"):V.getParentNode().this===H?"this":"";return[ee,b(V),ee?": ":"",Y("typeAnnotation")]}case"InterfaceDeclaration":case"InterfaceTypeAnnotation":return D(V,q,Y);case"ClassImplements":case"InterfaceExtends":return[Y("id"),Y("typeParameters")];case"NullableTypeAnnotation":return["?",Y("typeAnnotation")];case"Variance":{let{kind:ee}=H;return t.ok(ee==="plus"||ee==="minus"),ee==="plus"?"+":"-"}case"ObjectTypeCallProperty":return H.static&&Q.push("static "),Q.push(Y("value")),Q;case"ObjectTypeIndexer":return[H.static?"static ":"",H.variance?Y("variance"):"","[",Y("id"),H.id?": ":"",Y("key"),"]: ",Y("value")];case"ObjectTypeProperty":{let ee="";return H.proto?ee="proto ":H.static&&(ee="static "),[ee,d(H)?H.kind+" ":"",H.variance?Y("variance"):"",x(V,q,Y),b(V),m(H)?"":": ",Y("value")]}case"ObjectTypeAnnotation":return N(V,q,Y);case"ObjectTypeInternalSlot":return[H.static?"static ":"","[[",Y("id"),"]]",b(V),H.method?"":": ",Y("value")];case"ObjectTypeSpreadProperty":return M(V,q,Y);case"QualifiedTypeofIdentifier":case"QualifiedTypeIdentifier":return[Y("qualification"),".",Y("id")];case"StringLiteralTypeAnnotation":return a(p(H),q);case"NumberLiteralTypeAnnotation":t.strictEqual(typeof H.value,"number");case"BigIntLiteralTypeAnnotation":return H.extra?r(H.extra.raw):r(H.raw);case"TypeCastExpression":return["(",Y("expression"),L(V,q,Y),")"];case"TypeParameterDeclaration":case"TypeParameterInstantiation":{let ee=F(V,q,Y,"params");if(q.parser==="flow"){let te=h(H),oe=w(H),W=q.originalText.lastIndexOf("/*",te),X=q.originalText.indexOf("*/",oe);if(W!==-1&&X!==-1){let ue=q.originalText.slice(W+2,X).trim();if(ue.startsWith("::")&&!ue.includes("/*")&&!ue.includes("*/"))return["/*:: ",ee," */"]}}return ee}case"InferredPredicate":return"%checks";case"DeclaredPredicate":return["%checks(",Y("value"),")"];case"AnyTypeAnnotation":return"any";case"BooleanTypeAnnotation":return"boolean";case"BigIntTypeAnnotation":return"bigint";case"NullLiteralTypeAnnotation":return"null";case"NumberTypeAnnotation":return"number";case"SymbolTypeAnnotation":return"symbol";case"StringTypeAnnotation":return"string";case"VoidTypeAnnotation":return"void";case"ThisTypeAnnotation":return"this";case"Node":case"Printable":case"SourceLocation":case"Position":case"Statement":case"Function":case"Pattern":case"Expression":case"Declaration":case"Specifier":case"NamedSpecifier":case"Comment":case"MemberTypeAnnotation":case"Type":throw new Error("unprintable type: "+JSON.stringify(H.type))}}function $(V,q){let Y=v(V);return Y?(t.strictEqual(Y.type,"DeclareExportDeclaration"),q):["declare ",q]}n.exports={printFlow:j}}}),zm=Z({"src/language-js/utils/is-ts-keyword-type.js"(e,n){"use strict";re();function t(s){let{type:a}=s;return a.startsWith("TS")&&a.endsWith("Keyword")}n.exports=t}}),po=Z({"src/language-js/print/ternary.js"(e,n){"use strict";re();var{hasNewlineInRange:t}=Ue(),{isJsxNode:s,getComments:a,isCallExpression:r,isMemberExpression:u}=Ke(),{locStart:i,locEnd:o}=st(),c=It(),{builders:{line:v,softline:m,group:d,indent:p,align:f,ifBreak:h,dedent:w,breakParent:T}}=Oe();function A(P){let C=[P];for(let D=0;D<C.length;D++){let g=C[D];for(let F of["test","consequent","alternate"]){let l=g[F];if(s(l))return!0;l.type==="ConditionalExpression"&&C.push(l)}}return!1}function S(P,C,D){let g=P.getValue(),F=g.type==="ConditionalExpression",l=F?"alternate":"falseType",E=P.getParentNode(),y=F?D("test"):[D("checkType")," ","extends"," ",D("extendsType")];return E.type===g.type&&E[l]===g?f(2,y):y}var B=new Map([["AssignmentExpression","right"],["VariableDeclarator","init"],["ReturnStatement","argument"],["ThrowStatement","argument"],["UnaryExpression","argument"],["YieldExpression","argument"]]);function I(P){let C=P.getValue();if(C.type!=="ConditionalExpression")return!1;let D,g=C;for(let F=0;!D;F++){let l=P.getParentNode(F);if(r(l)&&l.callee===g||u(l)&&l.object===g||l.type==="TSNonNullExpression"&&l.expression===g){g=l;continue}l.type==="NewExpression"&&l.callee===g||l.type==="TSAsExpression"&&l.expression===g?(D=P.getParentNode(F+1),g=l):D=l}return g===C?!1:D[B.get(D.type)]===g}function k(P,C,D){let g=P.getValue(),F=g.type==="ConditionalExpression",l=F?"consequent":"trueType",E=F?"alternate":"falseType",y=F?["test"]:["checkType","extendsType"],N=g[l],x=g[E],b=[],L=!1,M=P.getParentNode(),j=M.type===g.type&&y.some(ue=>M[ue]===g),$=M.type===g.type&&!j,V,q,Y=0;do q=V||g,V=P.getParentNode(Y),Y++;while(V&&V.type===g.type&&y.every(ue=>V[ue]!==q));let H=V||M,R=q;if(F&&(s(g[y[0]])||s(N)||s(x)||A(R))){L=!0,$=!0;let ue=ie=>[h("("),p([m,ie]),m,h(")")],De=ie=>ie.type==="NullLiteral"||ie.type==="Literal"&&ie.value===null||ie.type==="Identifier"&&ie.name==="undefined";b.push(" ? ",De(N)?D(l):ue(D(l))," : ",x.type===g.type||De(x)?D(E):ue(D(E)))}else{let ue=[v,"? ",N.type===g.type?h("","("):"",f(2,D(l)),N.type===g.type?h("",")"):"",v,": ",x.type===g.type?D(E):f(2,D(E))];b.push(M.type!==g.type||M[E]===g||j?ue:C.useTabs?w(p(ue)):f(Math.max(0,C.tabWidth-2),ue))}let ee=[...y.map(ue=>a(g[ue])),a(N),a(x)].flat().some(ue=>c(ue)&&t(C.originalText,i(ue),o(ue))),te=ue=>M===H?d(ue,{shouldBreak:ee}):ee?[ue,T]:ue,oe=!L&&(u(M)||M.type==="NGPipeExpression"&&M.left===g)&&!M.computed,W=I(P),X=te([S(P,C,D),$?b:p(b),F&&oe&&!W?m:""]);return j||W?d([p([m,X]),m]):X}n.exports={printTernary:k}}}),fo=Z({"src/language-js/print/statement.js"(e,n){"use strict";re();var{builders:{hardline:t}}=Oe(),s=jt(),{getLeftSidePathName:a,hasNakedLeftSide:r,isJsxNode:u,isTheOnlyJsxElementInMarkdown:i,hasComment:o,CommentCheckFlags:c,isNextLineEmpty:v}=Ke(),{shouldPrintParamsWithoutParens:m}=Lr();function d(B,I,k,P){let C=B.getValue(),D=[],g=C.type==="ClassBody",F=p(C[P]);return B.each((l,E,y)=>{let N=l.getValue();if(N.type==="EmptyStatement")return;let x=k();!I.semi&&!g&&!i(I,l)&&f(l,I)?o(N,c.Leading)?D.push(k([],{needsSemi:!0})):D.push(";",x):D.push(x),!I.semi&&g&&A(N)&&S(N,y[E+1])&&D.push(";"),N!==F&&(D.push(t),v(N,I)&&D.push(t))},P),D}function p(B){for(let I=B.length-1;I>=0;I--){let k=B[I];if(k.type!=="EmptyStatement")return k}}function f(B,I){return B.getNode().type!=="ExpressionStatement"?!1:B.call(P=>h(P,I),"expression")}function h(B,I){let k=B.getValue();switch(k.type){case"ParenthesizedExpression":case"TypeCastExpression":case"ArrayExpression":case"ArrayPattern":case"TemplateLiteral":case"TemplateElement":case"RegExpLiteral":return!0;case"ArrowFunctionExpression":{if(!m(B,I))return!0;break}case"UnaryExpression":{let{prefix:P,operator:C}=k;if(P&&(C==="+"||C==="-"))return!0;break}case"BindExpression":{if(!k.object)return!0;break}case"Literal":{if(k.regex)return!0;break}default:if(u(k))return!0}return s(B,I)?!0:r(k)?B.call(P=>h(P,I),...a(B,k)):!1}function w(B,I,k){return d(B,I,k,"body")}function T(B,I,k){return d(B,I,k,"consequent")}var A=B=>{let{type:I}=B;return I==="ClassProperty"||I==="PropertyDefinition"||I==="ClassPrivateProperty"||I==="ClassAccessorProperty"};function S(B,I){let k=B.key&&B.key.name;if((k==="static"||k==="get"||k==="set")&&!B.value&&!B.typeAnnotation)return!0;if(!I||I.static||I.accessibility)return!1;if(!I.computed){let P=I.key&&I.key.name;if(P==="in"||P==="instanceof")return!0}if(A(I)&&I.variance&&!I.static&&!I.declare)return!0;switch(I.type){case"ClassProperty":case"PropertyDefinition":case"TSAbstractPropertyDefinition":return I.computed;case"MethodDefinition":case"TSAbstractMethodDefinition":case"ClassMethod":case"ClassPrivateMethod":{if((I.value?I.value.async:I.async)||I.kind==="get"||I.kind==="set")return!1;let C=I.value?I.value.generator:I.generator;return!!(I.computed||C)}case"TSIndexSignature":return!0}return!1}n.exports={printBody:w,printSwitchCaseConsequent:T}}}),Do=Z({"src/language-js/print/block.js"(e,n){"use strict";re();var{printDanglingComments:t}=et(),{isNonEmptyArray:s}=Ue(),{builders:{hardline:a,indent:r}}=Oe(),{hasComment:u,CommentCheckFlags:i,isNextLineEmpty:o}=Ke(),{printHardlineAfterHeritage:c}=Zt(),{printBody:v}=fo();function m(p,f,h){let w=p.getValue(),T=[];if(w.type==="StaticBlock"&&T.push("static "),w.type==="ClassBody"&&s(w.body)){let S=p.getParentNode();T.push(c(S))}T.push("{");let A=d(p,f,h);if(A)T.push(r([a,A]),a);else{let S=p.getParentNode(),B=p.getParentNode(1);S.type==="ArrowFunctionExpression"||S.type==="FunctionExpression"||S.type==="FunctionDeclaration"||S.type==="ObjectMethod"||S.type==="ClassMethod"||S.type==="ClassPrivateMethod"||S.type==="ForStatement"||S.type==="WhileStatement"||S.type==="DoWhileStatement"||S.type==="DoExpression"||S.type==="CatchClause"&&!B.finalizer||S.type==="TSModuleDeclaration"||S.type==="TSDeclareFunction"||w.type==="StaticBlock"||w.type==="ClassBody"||T.push(a)}return T.push("}"),T}function d(p,f,h){let w=p.getValue(),T=s(w.directives),A=w.body.some(I=>I.type!=="EmptyStatement"),S=u(w,i.Dangling);if(!T&&!A&&!S)return"";let B=[];if(T&&p.each((I,k,P)=>{B.push(h()),(k<P.length-1||A||S)&&(B.push(a),o(I.getValue(),f)&&B.push(a))},"directives"),A&&B.push(v(p,f,h)),S&&B.push(t(p,f,!0)),w.type==="Program"){let I=p.getParentNode();(!I||I.type!=="ModuleExpression")&&B.push(a)}return B}n.exports={printBlock:m,printBlockBody:d}}}),Xm=Z({"src/language-js/print/typescript.js"(e,n){"use strict";re();var{printDanglingComments:t}=et(),{hasNewlineInRange:s}=Ue(),{builders:{join:a,line:r,hardline:u,softline:i,group:o,indent:c,conditionalGroup:v,ifBreak:m}}=Oe(),{isLiteral:d,getTypeScriptMappedTypeModifier:p,shouldPrintComma:f,isCallExpression:h,isMemberExpression:w}=Ke(),T=zm(),{locStart:A,locEnd:S}=st(),{printOptionalToken:B,printTypeScriptModifiers:I}=ct(),{printTernary:k}=po(),{printFunctionParameters:P,shouldGroupFunctionParameters:C}=Pr(),{printTemplateLiteral:D}=Lt(),{printArrayItems:g}=Kt(),{printObject:F}=zn(),{printClassProperty:l,printClassMethod:E}=Zt(),{printTypeParameter:y,printTypeParameters:N}=Ir(),{printPropertyKey:x}=Qt(),{printFunction:b,printMethodInternal:L}=Lr(),{printInterface:M}=lo(),{printBlock:j}=Do(),{printTypeAlias:$,printIntersectionType:V,printUnionType:q,printFunctionType:Y,printTupleType:H,printIndexedAccessType:R,printJSDocType:Q}=kr();function ee(te,oe,W){let X=te.getValue();if(!X.type.startsWith("TS"))return;if(T(X))return X.type.slice(2,-7).toLowerCase();let ue=oe.semi?";":"",De=[];switch(X.type){case"TSThisType":return"this";case"TSTypeAssertion":{let ie=!(X.expression.type==="ArrayExpression"||X.expression.type==="ObjectExpression"),G=o(["<",c([i,W("typeAnnotation")]),i,">"]),z=[m("("),c([i,W("expression")]),i,m(")")];return ie?v([[G,W("expression")],[G,o(z,{shouldBreak:!0})],[G,W("expression")]]):o([G,W("expression")])}case"TSDeclareFunction":return b(te,W,oe);case"TSExportAssignment":return["export = ",W("expression"),ue];case"TSModuleBlock":return j(te,oe,W);case"TSInterfaceBody":case"TSTypeLiteral":return F(te,oe,W);case"TSTypeAliasDeclaration":return $(te,oe,W);case"TSQualifiedName":return a(".",[W("left"),W("right")]);case"TSAbstractMethodDefinition":case"TSDeclareMethod":return E(te,oe,W);case"TSAbstractPropertyDefinition":return l(te,oe,W);case"TSInterfaceHeritage":case"TSExpressionWithTypeArguments":return De.push(W("expression")),X.typeParameters&&De.push(W("typeParameters")),De;case"TSTemplateLiteralType":return D(te,W,oe);case"TSNamedTupleMember":return[W("label"),X.optional?"?":"",": ",W("elementType")];case"TSRestType":return["...",W("typeAnnotation")];case"TSOptionalType":return[W("typeAnnotation"),"?"];case"TSInterfaceDeclaration":return M(te,oe,W);case"TSClassImplements":return[W("expression"),W("typeParameters")];case"TSTypeParameterDeclaration":case"TSTypeParameterInstantiation":return N(te,oe,W,"params");case"TSTypeParameter":return y(te,oe,W);case"TSAsExpression":{De.push(W("expression")," as ",W("typeAnnotation"));let ie=te.getParentNode();return h(ie)&&ie.callee===X||w(ie)&&ie.object===X?o([c([i,...De]),i]):De}case"TSArrayType":return[W("elementType"),"[]"];case"TSPropertySignature":return X.readonly&&De.push("readonly "),De.push(x(te,oe,W),B(te)),X.typeAnnotation&&De.push(": ",W("typeAnnotation")),X.initializer&&De.push(" = ",W("initializer")),De;case"TSParameterProperty":return X.accessibility&&De.push(X.accessibility+" "),X.export&&De.push("export "),X.static&&De.push("static "),X.override&&De.push("override "),X.readonly&&De.push("readonly "),De.push(W("parameter")),De;case"TSTypeQuery":return["typeof ",W("exprName"),W("typeParameters")];case"TSIndexSignature":{let ie=te.getParentNode(),G=X.parameters.length>1?m(f(oe)?",":""):"",z=o([c([i,a([", ",i],te.map(W,"parameters"))]),G,i]);return[X.export?"export ":"",X.accessibility?[X.accessibility," "]:"",X.static?"static ":"",X.readonly?"readonly ":"",X.declare?"declare ":"","[",X.parameters?z:"",X.typeAnnotation?"]: ":"]",X.typeAnnotation?W("typeAnnotation"):"",ie.type==="ClassBody"?ue:""]}case"TSTypePredicate":return[X.asserts?"asserts ":"",W("parameterName"),X.typeAnnotation?[" is ",W("typeAnnotation")]:""];case"TSNonNullExpression":return[W("expression"),"!"];case"TSImportType":return[X.isTypeOf?"typeof ":"","import(",W(X.parameter?"parameter":"argument"),")",X.qualifier?[".",W("qualifier")]:"",N(te,oe,W,"typeParameters")];case"TSLiteralType":return W("literal");case"TSIndexedAccessType":return R(te,oe,W);case"TSConstructSignatureDeclaration":case"TSCallSignatureDeclaration":case"TSConstructorType":{if(X.type==="TSConstructorType"&&X.abstract&&De.push("abstract "),X.type!=="TSCallSignatureDeclaration"&&De.push("new "),De.push(o(P(te,W,oe,!1,!0))),X.returnType||X.typeAnnotation){let ie=X.type==="TSConstructorType";De.push(ie?" => ":": ",W("returnType"),W("typeAnnotation"))}return De}case"TSTypeOperator":return[X.operator," ",W("typeAnnotation")];case"TSMappedType":{let ie=s(oe.originalText,A(X),S(X));return o(["{",c([oe.bracketSpacing?r:i,X.readonly?[p(X.readonly,"readonly")," "]:"",I(te,oe,W),W("typeParameter"),X.optional?p(X.optional,"?"):"",X.typeAnnotation?": ":"",W("typeAnnotation"),m(ue)]),t(te,oe,!0),oe.bracketSpacing?r:i,"}"],{shouldBreak:ie})}case"TSMethodSignature":{let ie=X.kind&&X.kind!=="method"?"".concat(X.kind," "):"";De.push(X.accessibility?[X.accessibility," "]:"",ie,X.export?"export ":"",X.static?"static ":"",X.readonly?"readonly ":"",X.abstract?"abstract ":"",X.declare?"declare ":"",X.computed?"[":"",W("key"),X.computed?"]":"",B(te));let G=P(te,W,oe,!1,!0),z=X.returnType?"returnType":"typeAnnotation",U=X[z],le=U?W(z):"",ge=C(X,le);return De.push(ge?o(G):G),U&&De.push(": ",o(le)),o(De)}case"TSNamespaceExportDeclaration":return De.push("export as namespace ",W("id")),oe.semi&&De.push(";"),o(De);case"TSEnumDeclaration":return X.declare&&De.push("declare "),X.modifiers&&De.push(I(te,oe,W)),X.const&&De.push("const "),De.push("enum ",W("id")," "),X.members.length===0?De.push(o(["{",t(te,oe),i,"}"])):De.push(o(["{",c([u,g(te,oe,"members",W),f(oe,"es5")?",":""]),t(te,oe,!0),u,"}"])),De;case"TSEnumMember":return X.computed?De.push("[",W("id"),"]"):De.push(W("id")),X.initializer&&De.push(" = ",W("initializer")),De;case"TSImportEqualsDeclaration":return X.isExport&&De.push("export "),De.push("import "),X.importKind&&X.importKind!=="value"&&De.push(X.importKind," "),De.push(W("id")," = ",W("moduleReference")),oe.semi&&De.push(";"),o(De);case"TSExternalModuleReference":return["require(",W("expression"),")"];case"TSModuleDeclaration":{let ie=te.getParentNode(),G=d(X.id),z=ie.type==="TSModuleDeclaration",U=X.body&&X.body.type==="TSModuleDeclaration";if(z)De.push(".");else{X.declare&&De.push("declare "),De.push(I(te,oe,W));let le=oe.originalText.slice(A(X),A(X.id));X.id.type==="Identifier"&&X.id.name==="global"&&!/namespace|module/.test(le)||De.push(G||/(?:^|\s)module(?:\s|$)/.test(le)?"module ":"namespace ")}return De.push(W("id")),U?De.push(W("body")):X.body?De.push(" ",o(W("body"))):De.push(ue),De}case"TSConditionalType":return k(te,oe,W);case"TSInferType":return["infer"," ",W("typeParameter")];case"TSIntersectionType":return V(te,oe,W);case"TSUnionType":return q(te,oe,W);case"TSFunctionType":return Y(te,oe,W);case"TSTupleType":return H(te,oe,W);case"TSTypeReference":return[W("typeName"),N(te,oe,W,"typeParameters")];case"TSTypeAnnotation":return W("typeAnnotation");case"TSEmptyBodyFunctionExpression":return L(te,oe,W);case"TSJSDocAllType":return"*";case"TSJSDocUnknownType":return"?";case"TSJSDocNullableType":return Q(te,W,"?");case"TSJSDocNonNullableType":return Q(te,W,"!");case"TSInstantiationExpression":return[W("expression"),W("typeParameters")];default:throw new Error("Unknown TypeScript node type: ".concat(JSON.stringify(X.type),"."))}}n.exports={printTypescript:ee}}}),Km=Z({"src/language-js/print/comment.js"(e,n){"use strict";re();var{hasNewline:t}=Ue(),{builders:{join:s,hardline:a},utils:{replaceTextEndOfLine:r}}=Oe(),{isLineComment:u}=Ke(),{locStart:i,locEnd:o}=st(),c=It();function v(p,f){let h=p.getValue();if(u(h))return f.originalText.slice(i(h),o(h)).trimEnd();if(c(h)){if(m(h)){let A=d(h);return h.trailing&&!t(f.originalText,i(h),{backwards:!0})?[a,A]:A}let w=o(h),T=f.originalText.slice(w-3,w)==="*-/";return["/*",r(h.value),T?"*-/":"*/"]}throw new Error("Not a comment: "+JSON.stringify(h))}function m(p){let f="*".concat(p.value,"*").split(`
`);return f.length>1&&f.every(h=>h.trim()[0]==="*")}function d(p){let f=p.value.split(`
`);return["/*",s(a,f.map((h,w)=>w===0?h.trimEnd():" "+(w<f.length-1?h.trim():h.trimStart()))),"*/"]}n.exports={printComment:v}}}),Ym=Z({"src/language-js/print/literal.js"(e,n){"use strict";re();var{printString:t,printNumber:s}=Ue();function a(i,o){let c=i.getNode();switch(c.type){case"RegExpLiteral":return u(c);case"BigIntLiteral":return r(c.bigint||c.extra.raw);case"NumericLiteral":return s(c.extra.raw);case"StringLiteral":return t(c.extra.raw,o);case"NullLiteral":return"null";case"BooleanLiteral":return String(c.value);case"DecimalLiteral":return s(c.value)+"m";case"Literal":{if(c.regex)return u(c.regex);if(c.bigint)return r(c.raw);if(c.decimal)return s(c.decimal)+"m";let{value:v}=c;return typeof v=="number"?s(c.raw):typeof v=="string"?t(c.raw,o):String(v)}}}function r(i){return i.toLowerCase()}function u(i){let{pattern:o,flags:c}=i;return c=[...c].sort().join(""),"/".concat(o,"/").concat(c)}n.exports={printLiteral:a}}}),Qm=Z({"src/language-js/printer-estree.js"(e,n){"use strict";re();var{printDanglingComments:t}=et(),{hasNewline:s}=Ue(),{builders:{join:a,line:r,hardline:u,softline:i,group:o,indent:c},utils:{replaceTextEndOfLine:v}}=Oe(),m=Im(),d=Lm(),{insertPragma:p}=no(),f=uo(),h=jt(),w=so(),{hasFlowShorthandAnnotationComment:T,hasComment:A,CommentCheckFlags:S,isTheOnlyJsxElementInMarkdown:B,isLineComment:I,isNextLineEmpty:k,needsHardlineAfterDanglingComment:P,rawText:C,hasIgnoreComment:D,isCallExpression:g,isMemberExpression:F,markerForIfWithoutBlockAndSameLineComment:l}=Ke(),{locStart:E,locEnd:y}=st(),N=It(),{printHtmlBinding:x,isVueEventBindingExpression:b}=$m(),{printAngular:L}=Hm(),{printJsx:M,hasJsxIgnoreComment:j}=Gm(),{printFlow:$}=Um(),{printTypescript:V}=Xm(),{printOptionalToken:q,printBindExpressionCallee:Y,printTypeAnnotation:H,adjustClause:R,printRestSpread:Q,printDefiniteToken:ee}=ct(),{printImportDeclaration:te,printExportDeclaration:oe,printExportAllDeclaration:W,printModuleSpecifier:X}=co(),{printTernary:ue}=po(),{printTemplateLiteral:De}=Lt(),{printArray:ie}=Kt(),{printObject:G}=zn(),{printClass:z,printClassMethod:U,printClassProperty:le}=Zt(),{printProperty:ge}=Qt(),{printFunction:Ae,printArrowFunction:Ne,printMethod:ke,printReturnStatement:ce,printThrowStatement:pe}=Lr(),{printCallExpression:de}=oo(),{printVariableDeclarator:ae,printAssignmentExpression:ve}=Yt(),{printBinaryishExpression:K}=Jn(),{printSwitchCaseConsequent:he}=fo(),{printMemberExpression:ye}=ao(),{printBlock:Ce,printBlockBody:Ie}=Do(),{printComment:Fe}=Km(),{printLiteral:me}=Ym(),{printDecorators:_}=Un();function J(Be,Pe,Se,Qe){let xe=ne(Be,Pe,Se,Qe);if(!xe)return"";let Xe=Be.getValue(),{type:_e}=Xe;if(_e==="ClassMethod"||_e==="ClassPrivateMethod"||_e==="ClassProperty"||_e==="ClassAccessorProperty"||_e==="PropertyDefinition"||_e==="TSAbstractPropertyDefinition"||_e==="ClassPrivateProperty"||_e==="MethodDefinition"||_e==="TSAbstractMethodDefinition"||_e==="TSDeclareMethod")return xe;let je=[xe],Re=_(Be,Pe,Se),be=Xe.type==="ClassExpression"&&Re;if(Re&&(je=[...Re,xe],!be))return o(je);if(!h(Be,Pe))return Qe&&Qe.needsSemi&&je.unshift(";"),je.length===1&&je[0]===xe?xe:je;if(be&&(je=[c([r,...je])]),je.unshift("("),Qe&&Qe.needsSemi&&je.unshift(";"),T(Xe)){let[qe]=Xe.trailingComments;je.push(" /*",qe.value.trimStart(),"*/"),qe.printed=!0}return be&&je.push(r),je.push(")"),je}function ne(Be,Pe,Se,Qe){let xe=Be.getValue(),Xe=Pe.semi?";":"";if(!xe)return"";if(typeof xe=="string")return xe;for(let je of[me,x,L,M,$,V]){let Re=je(Be,Pe,Se);if(typeof Re<"u")return Re}let _e=[];switch(xe.type){case"JsExpressionRoot":return Se("node");case"JsonRoot":return[Se("node"),u];case"File":return xe.program&&xe.program.interpreter&&_e.push(Se(["program","interpreter"])),_e.push(Se("program")),_e;case"Program":return Ie(Be,Pe,Se);case"EmptyStatement":return"";case"ExpressionStatement":{if(xe.directive)return[Ee(xe.expression,Pe),Xe];if(Pe.parser==="__vue_event_binding"||Pe.parser==="__vue_ts_event_binding"){let Re=Be.getParentNode();if(Re.type==="Program"&&Re.body.length===1&&Re.body[0]===xe)return[Se("expression"),b(xe.expression)?";":""]}let je=t(Be,Pe,!0,Re=>{let{marker:be}=Re;return be===l});return[Se("expression"),B(Pe,Be)?"":Xe,je?[" ",je]:""]}case"ParenthesizedExpression":return!A(xe.expression)&&(xe.expression.type==="ObjectExpression"||xe.expression.type==="ArrayExpression")?["(",Se("expression"),")"]:o(["(",c([i,Se("expression")]),i,")"]);case"AssignmentExpression":return ve(Be,Pe,Se);case"VariableDeclarator":return ae(Be,Pe,Se);case"BinaryExpression":case"LogicalExpression":return K(Be,Pe,Se);case"AssignmentPattern":return[Se("left")," = ",Se("right")];case"OptionalMemberExpression":case"MemberExpression":return ye(Be,Pe,Se);case"MetaProperty":return[Se("meta"),".",Se("property")];case"BindExpression":return xe.object&&_e.push(Se("object")),_e.push(o(c([i,Y(Be,Pe,Se)]))),_e;case"Identifier":return[xe.name,q(Be),ee(Be),H(Be,Pe,Se)];case"V8IntrinsicIdentifier":return["%",xe.name];case"SpreadElement":case"SpreadElementPattern":case"SpreadProperty":case"SpreadPropertyPattern":case"RestElement":return Q(Be,Pe,Se);case"FunctionDeclaration":case"FunctionExpression":return Ae(Be,Se,Pe,Qe);case"ArrowFunctionExpression":return Ne(Be,Pe,Se,Qe);case"YieldExpression":return _e.push("yield"),xe.delegate&&_e.push("*"),xe.argument&&_e.push(" ",Se("argument")),_e;case"AwaitExpression":{if(_e.push("await"),xe.argument){_e.push(" ",Se("argument"));let je=Be.getParentNode();if(g(je)&&je.callee===xe||F(je)&&je.object===xe){_e=[c([i,..._e]),i];let Re=Be.findAncestor(be=>be.type==="AwaitExpression"||be.type==="BlockStatement");if(!Re||Re.type!=="AwaitExpression")return o(_e)}}return _e}case"ExportDefaultDeclaration":case"ExportNamedDeclaration":return oe(Be,Pe,Se);case"ExportAllDeclaration":return W(Be,Pe,Se);case"ImportDeclaration":return te(Be,Pe,Se);case"ImportSpecifier":case"ExportSpecifier":case"ImportNamespaceSpecifier":case"ExportNamespaceSpecifier":case"ImportDefaultSpecifier":case"ExportDefaultSpecifier":return X(Be,Pe,Se);case"ImportAttribute":return[Se("key"),": ",Se("value")];case"Import":return"import";case"BlockStatement":case"StaticBlock":case"ClassBody":return Ce(Be,Pe,Se);case"ThrowStatement":return pe(Be,Pe,Se);case"ReturnStatement":return ce(Be,Pe,Se);case"NewExpression":case"ImportExpression":case"OptionalCallExpression":case"CallExpression":return de(Be,Pe,Se);case"ObjectExpression":case"ObjectPattern":case"RecordExpression":return G(Be,Pe,Se);case"ObjectProperty":case"Property":return xe.method||xe.kind==="get"||xe.kind==="set"?ke(Be,Pe,Se):ge(Be,Pe,Se);case"ObjectMethod":return ke(Be,Pe,Se);case"Decorator":return["@",Se("expression")];case"ArrayExpression":case"ArrayPattern":case"TupleExpression":return ie(Be,Pe,Se);case"SequenceExpression":{let je=Be.getParentNode(0);if(je.type==="ExpressionStatement"||je.type==="ForStatement"){let Re=[];return Be.each((be,Le)=>{Le===0?Re.push(Se()):Re.push(",",c([r,Se()]))},"expressions"),o(Re)}return o(a([",",r],Be.map(Se,"expressions")))}case"ThisExpression":return"this";case"Super":return"super";case"Directive":return[Se("value"),Xe];case"DirectiveLiteral":return Ee(xe,Pe);case"UnaryExpression":return _e.push(xe.operator),/[a-z]$/.test(xe.operator)&&_e.push(" "),A(xe.argument)?_e.push(o(["(",c([i,Se("argument")]),i,")"])):_e.push(Se("argument")),_e;case"UpdateExpression":return _e.push(Se("argument"),xe.operator),xe.prefix&&_e.reverse(),_e;case"ConditionalExpression":return ue(Be,Pe,Se);case"VariableDeclaration":{let je=Be.map(Se,"declarations"),Re=Be.getParentNode(),be=Re.type==="ForStatement"||Re.type==="ForInStatement"||Re.type==="ForOfStatement",Le=xe.declarations.some(se=>se.init),qe;return je.length===1&&!A(xe.declarations[0])?qe=je[0]:je.length>0&&(qe=c(je[0])),_e=[xe.declare?"declare ":"",xe.kind,qe?[" ",qe]:"",c(je.slice(1).map(se=>[",",Le&&!be?u:r,se]))],be&&Re.body!==xe||_e.push(Xe),o(_e)}case"WithStatement":return o(["with (",Se("object"),")",R(xe.body,Se("body"))]);case"IfStatement":{let je=R(xe.consequent,Se("consequent")),Re=o(["if (",o([c([i,Se("test")]),i]),")",je]);if(_e.push(Re),xe.alternate){let be=A(xe.consequent,S.Trailing|S.Line)||P(xe),Le=xe.consequent.type==="BlockStatement"&&!be;_e.push(Le?" ":u),A(xe,S.Dangling)&&_e.push(t(Be,Pe,!0),be?u:" "),_e.push("else",o(R(xe.alternate,Se("alternate"),xe.alternate.type==="IfStatement")))}return _e}case"ForStatement":{let je=R(xe.body,Se("body")),Re=t(Be,Pe,!0),be=Re?[Re,i]:"";return!xe.init&&!xe.test&&!xe.update?[be,o(["for (;;)",je])]:[be,o(["for (",o([c([i,Se("init"),";",r,Se("test"),";",r,Se("update")]),i]),")",je])]}case"WhileStatement":return o(["while (",o([c([i,Se("test")]),i]),")",R(xe.body,Se("body"))]);case"ForInStatement":return o(["for (",Se("left")," in ",Se("right"),")",R(xe.body,Se("body"))]);case"ForOfStatement":return o(["for",xe.await?" await":""," (",Se("left")," of ",Se("right"),")",R(xe.body,Se("body"))]);case"DoWhileStatement":{let je=R(xe.body,Se("body"));return _e=[o(["do",je])],xe.body.type==="BlockStatement"?_e.push(" "):_e.push(u),_e.push("while (",o([c([i,Se("test")]),i]),")",Xe),_e}case"DoExpression":return[xe.async?"async ":"","do ",Se("body")];case"BreakStatement":return _e.push("break"),xe.label&&_e.push(" ",Se("label")),_e.push(Xe),_e;case"ContinueStatement":return _e.push("continue"),xe.label&&_e.push(" ",Se("label")),_e.push(Xe),_e;case"LabeledStatement":return xe.body.type==="EmptyStatement"?[Se("label"),":;"]:[Se("label"),": ",Se("body")];case"TryStatement":return["try ",Se("block"),xe.handler?[" ",Se("handler")]:"",xe.finalizer?[" finally ",Se("finalizer")]:""];case"CatchClause":if(xe.param){let je=A(xe.param,be=>!N(be)||be.leading&&s(Pe.originalText,y(be))||be.trailing&&s(Pe.originalText,E(be),{backwards:!0})),Re=Se("param");return["catch ",je?["(",c([i,Re]),i,") "]:["(",Re,") "],Se("body")]}return["catch ",Se("body")];case"SwitchStatement":return[o(["switch (",c([i,Se("discriminant")]),i,")"])," {",xe.cases.length>0?c([u,a(u,Be.map((je,Re,be)=>{let Le=je.getValue();return[Se(),Re!==be.length-1&&k(Le,Pe)?u:""]},"cases"))]):"",u,"}"];case"SwitchCase":{xe.test?_e.push("case ",Se("test"),":"):_e.push("default:"),A(xe,S.Dangling)&&_e.push(" ",t(Be,Pe,!0));let je=xe.consequent.filter(Re=>Re.type!=="EmptyStatement");if(je.length>0){let Re=he(Be,Pe,Se);_e.push(je.length===1&&je[0].type==="BlockStatement"?[" ",Re]:c([u,Re]))}return _e}case"DebuggerStatement":return["debugger",Xe];case"ClassDeclaration":case"ClassExpression":return z(Be,Pe,Se);case"ClassMethod":case"ClassPrivateMethod":case"MethodDefinition":return U(Be,Pe,Se);case"ClassProperty":case"PropertyDefinition":case"ClassPrivateProperty":case"ClassAccessorProperty":return le(Be,Pe,Se);case"TemplateElement":return v(xe.value.raw);case"TemplateLiteral":return De(Be,Se,Pe);case"TaggedTemplateExpression":return[Se("tag"),Se("typeParameters"),Se("quasi")];case"PrivateIdentifier":return["#",Se("name")];case"PrivateName":return["#",Se("id")];case"InterpreterDirective":return _e.push("#!",xe.value,u),k(xe,Pe)&&_e.push(u),_e;case"TopicReference":return"%";case"ArgumentPlaceholder":return"?";case"ModuleExpression":{_e.push("module {");let je=Se("body");return je&&_e.push(c([u,je]),u),_e.push("}"),_e}default:throw new Error("unknown type: "+JSON.stringify(xe.type))}}function Ee(Be,Pe){let Se=C(Be),Qe=Se.slice(1,-1);if(Qe.includes('"')||Qe.includes("'"))return Se;let xe=Pe.singleQuote?"'":'"';return xe+Qe+xe}function We(Be){return Be.type&&!N(Be)&&!I(Be)&&Be.type!=="EmptyStatement"&&Be.type!=="TemplateElement"&&Be.type!=="Import"&&Be.type!=="TSEmptyBodyFunctionExpression"}n.exports={preprocess:w,print:J,embed:m,insertPragma:p,massageAstNode:d,hasPrettierIgnore(Be){return D(Be)||j(Be)},willPrintOwnComments:f.willPrintOwnComments,canAttachComment:We,printComment:Fe,isBlockComment:N,handleComments:{avoidAstMutation:!0,ownLine:f.handleOwnLineComment,endOfLine:f.handleEndOfLineComment,remaining:f.handleRemainingComment},getCommentChildNodes:f.getCommentChildNodes}}}),Zm=Z({"src/language-js/printer-estree-json.js"(e,n){"use strict";re();var{builders:{hardline:t,indent:s,join:a}}=Oe(),r=so();function u(c,v,m){let d=c.getValue();switch(d.type){case"JsonRoot":return[m("node"),t];case"ArrayExpression":{if(d.elements.length===0)return"[]";let p=c.map(()=>c.getValue()===null?"null":m(),"elements");return["[",s([t,a([",",t],p)]),t,"]"]}case"ObjectExpression":return d.properties.length===0?"{}":["{",s([t,a([",",t],c.map(m,"properties"))]),t,"}"];case"ObjectProperty":return[m("key"),": ",m("value")];case"UnaryExpression":return[d.operator==="+"?"":d.operator,m("argument")];case"NullLiteral":return"null";case"BooleanLiteral":return d.value?"true":"false";case"StringLiteral":case"NumericLiteral":return JSON.stringify(d.value);case"Identifier":{let p=c.getParentNode();return p&&p.type==="ObjectProperty"&&p.key===d?JSON.stringify(d.name):d.name}case"TemplateLiteral":return m(["quasis",0]);case"TemplateElement":return JSON.stringify(d.value.cooked);default:throw new Error("unknown type: "+JSON.stringify(d.type))}}var i=new Set(["start","end","extra","loc","comments","leadingComments","trailingComments","innerComments","errors","range","tokens"]);function o(c,v){let{type:m}=c;if(m==="ObjectProperty"&&c.key.type==="Identifier"){v.key={type:"StringLiteral",value:c.key.name};return}if(m==="UnaryExpression"&&c.operator==="+")return v.argument;if(m==="ArrayExpression"){for(let[d,p]of c.elements.entries())p===null&&v.elements.splice(d,0,{type:"NullLiteral"});return}if(m==="TemplateLiteral")return{type:"StringLiteral",value:c.quasis[0].value.cooked}}o.ignoredProperties=i,n.exports={preprocess:r,print:u,massageAstNode:o}}}),Ot=Z({"src/common/common-options.js"(e,n){"use strict";re();var t="Common";n.exports={bracketSpacing:{since:"0.0.0",category:t,type:"boolean",default:!0,description:"Print spaces between brackets.",oppositeDescription:"Do not print spaces between brackets."},singleQuote:{since:"0.0.0",category:t,type:"boolean",default:!1,description:"Use single quotes instead of double quotes."},proseWrap:{since:"1.8.2",category:t,type:"choice",default:[{since:"1.8.2",value:!0},{since:"1.9.0",value:"preserve"}],description:"How to wrap prose.",choices:[{since:"1.9.0",value:"always",description:"Wrap prose if it exceeds the print width."},{since:"1.9.0",value:"never",description:"Do not wrap prose."},{since:"1.9.0",value:"preserve",description:"Wrap prose as-is."}]},bracketSameLine:{since:"2.4.0",category:t,type:"boolean",default:!1,description:"Put > of opening tags on the last line instead of on a new line."},singleAttributePerLine:{since:"2.6.0",category:t,type:"boolean",default:!1,description:"Enforce single attribute per line in HTML, Vue and JSX."}}}}),ed=Z({"src/language-js/options.js"(e,n){"use strict";re();var t=Ot(),s="JavaScript";n.exports={arrowParens:{since:"1.9.0",category:s,type:"choice",default:[{since:"1.9.0",value:"avoid"},{since:"2.0.0",value:"always"}],description:"Include parentheses around a sole arrow function parameter.",choices:[{value:"always",description:"Always include parens. Example: `(x) => x`"},{value:"avoid",description:"Omit parens when possible. Example: `x => x`"}]},bracketSameLine:t.bracketSameLine,bracketSpacing:t.bracketSpacing,jsxBracketSameLine:{since:"0.17.0",category:s,type:"boolean",description:"Put > on the last line instead of at a new line.",deprecated:"2.4.0"},semi:{since:"1.0.0",category:s,type:"boolean",default:!0,description:"Print semicolons.",oppositeDescription:"Do not print semicolons, except at the beginning of lines which may need them."},singleQuote:t.singleQuote,jsxSingleQuote:{since:"1.15.0",category:s,type:"boolean",default:!1,description:"Use single quotes in JSX."},quoteProps:{since:"1.17.0",category:s,type:"choice",default:"as-needed",description:"Change when properties in objects are quoted.",choices:[{value:"as-needed",description:"Only add quotes around object properties where required."},{value:"consistent",description:"If at least one property in an object requires quotes, quote all properties."},{value:"preserve",description:"Respect the input use of quotes in object properties."}]},trailingComma:{since:"0.0.0",category:s,type:"choice",default:[{since:"0.0.0",value:!1},{since:"0.19.0",value:"none"},{since:"2.0.0",value:"es5"}],description:"Print trailing commas wherever possible when multi-line.",choices:[{value:"es5",description:"Trailing commas where valid in ES5 (objects, arrays, etc.)"},{value:"none",description:"No trailing commas."},{value:"all",description:"Trailing commas wherever possible (including function arguments)."}]},singleAttributePerLine:t.singleAttributePerLine}}}),td=Z({"src/language-js/parse/parsers.js"(){re()}}),Sn=Z({"node_modules/linguist-languages/data/JavaScript.json"(e,n){n.exports={name:"JavaScript",type:"programming",tmScope:"source.js",aceMode:"javascript",codemirrorMode:"javascript",codemirrorMimeType:"text/javascript",color:"#f1e05a",aliases:["js","node"],extensions:[".js","._js",".bones",".cjs",".es",".es6",".frag",".gs",".jake",".javascript",".jsb",".jscad",".jsfl",".jslib",".jsm",".jspre",".jss",".jsx",".mjs",".njs",".pac",".sjs",".ssjs",".xsjs",".xsjslib"],filenames:["Jakefile"],interpreters:["chakra","d8","gjs","js","node","nodejs","qjs","rhino","v8","v8-shell"],languageId:183}}}),rd=Z({"node_modules/linguist-languages/data/TypeScript.json"(e,n){n.exports={name:"TypeScript",type:"programming",color:"#3178c6",aliases:["ts"],interpreters:["deno","ts-node"],extensions:[".ts",".cts",".mts"],tmScope:"source.ts",aceMode:"typescript",codemirrorMode:"javascript",codemirrorMimeType:"application/typescript",languageId:378}}}),nd=Z({"node_modules/linguist-languages/data/TSX.json"(e,n){n.exports={name:"TSX",type:"programming",color:"#3178c6",group:"TypeScript",extensions:[".tsx"],tmScope:"source.tsx",aceMode:"javascript",codemirrorMode:"jsx",codemirrorMimeType:"text/jsx",languageId:94901924}}}),ma=Z({"node_modules/linguist-languages/data/JSON.json"(e,n){n.exports={name:"JSON",type:"data",color:"#292929",tmScope:"source.json",aceMode:"json",codemirrorMode:"javascript",codemirrorMimeType:"application/json",aliases:["geojson","jsonl","topojson"],extensions:[".json",".4DForm",".4DProject",".avsc",".geojson",".gltf",".har",".ice",".JSON-tmLanguage",".jsonl",".mcmeta",".tfstate",".tfstate.backup",".topojson",".webapp",".webmanifest",".yy",".yyp"],filenames:[".arcconfig",".auto-changelog",".c8rc",".htmlhintrc",".imgbotconfig",".nycrc",".tern-config",".tern-project",".watchmanconfig","Pipfile.lock","composer.lock","mcmod.info"],languageId:174}}}),ud=Z({"node_modules/linguist-languages/data/JSON with Comments.json"(e,n){n.exports={name:"JSON with Comments",type:"data",color:"#292929",group:"JSON",tmScope:"source.js",aceMode:"javascript",codemirrorMode:"javascript",codemirrorMimeType:"text/javascript",aliases:["jsonc"],extensions:[".jsonc",".code-snippets",".sublime-build",".sublime-commands",".sublime-completions",".sublime-keymap",".sublime-macro",".sublime-menu",".sublime-mousemap",".sublime-project",".sublime-settings",".sublime-theme",".sublime-workspace",".sublime_metrics",".sublime_session"],filenames:[".babelrc",".devcontainer.json",".eslintrc.json",".jscsrc",".jshintrc",".jslintrc","api-extractor.json","devcontainer.json","jsconfig.json","language-configuration.json","tsconfig.json","tslint.json"],languageId:423}}}),sd=Z({"node_modules/linguist-languages/data/JSON5.json"(e,n){n.exports={name:"JSON5",type:"data",color:"#267CB9",extensions:[".json5"],tmScope:"source.js",aceMode:"javascript",codemirrorMode:"javascript",codemirrorMimeType:"application/json",languageId:175}}}),id=Z({"src/language-js/index.js"(e,n){"use strict";re();var t=Bt(),s=Qm(),a=Zm(),r=ed(),u=td(),i=[t(Sn(),c=>({since:"0.0.0",parsers:["babel","acorn","espree","meriyah","babel-flow","babel-ts","flow","typescript"],vscodeLanguageIds:["javascript","mongo"],interpreters:[...c.interpreters,"zx"],extensions:[...c.extensions.filter(v=>v!==".jsx"),".wxs"]})),t(Sn(),()=>({name:"Flow",since:"0.0.0",parsers:["flow","babel-flow"],vscodeLanguageIds:["javascript"],aliases:[],filenames:[],extensions:[".js.flow"]})),t(Sn(),()=>({name:"JSX",since:"0.0.0",parsers:["babel","babel-flow","babel-ts","flow","typescript","espree","meriyah"],vscodeLanguageIds:["javascriptreact"],aliases:void 0,filenames:void 0,extensions:[".jsx"],group:"JavaScript",interpreters:void 0,tmScope:"source.js.jsx",aceMode:"javascript",codemirrorMode:"jsx",codemirrorMimeType:"text/jsx",color:void 0})),t(rd(),()=>({since:"1.4.0",parsers:["typescript","babel-ts"],vscodeLanguageIds:["typescript"]})),t(nd(),()=>({since:"1.4.0",parsers:["typescript","babel-ts"],vscodeLanguageIds:["typescriptreact"]})),t(ma(),()=>({name:"JSON.stringify",since:"1.13.0",parsers:["json-stringify"],vscodeLanguageIds:["json"],extensions:[".importmap"],filenames:["package.json","package-lock.json","composer.json"]})),t(ma(),c=>({since:"1.5.0",parsers:["json"],vscodeLanguageIds:["json"],extensions:c.extensions.filter(v=>v!==".jsonl")})),t(ud(),c=>({since:"1.5.0",parsers:["json"],vscodeLanguageIds:["jsonc"],filenames:[...c.filenames,".eslintrc",".swcrc"]})),t(sd(),()=>({since:"1.13.0",parsers:["json5"],vscodeLanguageIds:["json5"]}))],o={estree:s,"estree-json":a};n.exports={languages:i,options:r,printers:o,parsers:u}}}),ad=Z({"src/language-css/clean.js"(e,n){"use strict";re();var{isFrontMatterNode:t}=Ue(),s=it(),a=new Set(["raw","raws","sourceIndex","source","before","after","trailingComma"]);function r(i,o,c){if(t(i)&&i.lang==="yaml"&&delete o.value,i.type==="css-comment"&&c.type==="css-root"&&c.nodes.length>0&&((c.nodes[0]===i||t(c.nodes[0])&&c.nodes[1]===i)&&(delete o.text,/^\*\s*@(?:format|prettier)\s*$/.test(i.text))||c.type==="css-root"&&s(c.nodes)===i))return null;if(i.type==="value-root"&&delete o.text,(i.type==="media-query"||i.type==="media-query-list"||i.type==="media-feature-expression")&&delete o.value,i.type==="css-rule"&&delete o.params,i.type==="selector-combinator"&&(o.value=o.value.replace(/\s+/g," ")),i.type==="media-feature"&&(o.value=o.value.replace(/ /g,"")),(i.type==="value-word"&&(i.isColor&&i.isHex||["initial","inherit","unset","revert"].includes(o.value.replace().toLowerCase()))||i.type==="media-feature"||i.type==="selector-root-invalid"||i.type==="selector-pseudo")&&(o.value=o.value.toLowerCase()),i.type==="css-decl"&&(o.prop=o.prop.toLowerCase()),(i.type==="css-atrule"||i.type==="css-import")&&(o.name=o.name.toLowerCase()),i.type==="value-number"&&(o.unit=o.unit.toLowerCase()),(i.type==="media-feature"||i.type==="media-keyword"||i.type==="media-type"||i.type==="media-unknown"||i.type==="media-url"||i.type==="media-value"||i.type==="selector-attribute"||i.type==="selector-string"||i.type==="selector-class"||i.type==="selector-combinator"||i.type==="value-string")&&o.value&&(o.value=u(o.value)),i.type==="selector-attribute"&&(o.attribute=o.attribute.trim(),o.namespace&&typeof o.namespace=="string"&&(o.namespace=o.namespace.trim(),o.namespace.length===0&&(o.namespace=!0)),o.value&&(o.value=o.value.trim().replace(/^["']|["']$/g,""),delete o.quoted)),(i.type==="media-value"||i.type==="media-type"||i.type==="value-number"||i.type==="selector-root-invalid"||i.type==="selector-class"||i.type==="selector-combinator"||i.type==="selector-tag")&&o.value&&(o.value=o.value.replace(/([\d+.Ee-]+)([A-Za-z]*)/g,(v,m,d)=>{let p=Number(m);return Number.isNaN(p)?v:p+d.toLowerCase()})),i.type==="selector-tag"){let v=i.value.toLowerCase();["from","to"].includes(v)&&(o.value=v)}if(i.type==="css-atrule"&&i.name.toLowerCase()==="supports"&&delete o.value,i.type==="selector-unknown"&&delete o.value,i.type==="value-comma_group"){let v=i.groups.findIndex(m=>m.type==="value-number"&&m.unit==="...");v!==-1&&(o.groups[v].unit="",o.groups.splice(v+1,0,{type:"value-word",value:"...",isColor:!1,isHex:!1}))}}r.ignoredProperties=a;function u(i){return i.replace(/'/g,'"').replace(/\\([^\dA-Fa-f])/g,"$1")}n.exports=r}}),Xn=Z({"src/utils/front-matter/print.js"(e,n){"use strict";re();var{builders:{hardline:t,markAsRoot:s}}=Oe();function a(r,u){if(r.lang==="yaml"){let i=r.value.trim(),o=i?u(i,{parser:"yaml"},{stripTrailingHardline:!0}):"";return s([r.startDelimiter,t,o,o?t:"",r.endDelimiter])}}n.exports=a}}),od=Z({"src/language-css/embed.js"(e,n){"use strict";re();var{builders:{hardline:t}}=Oe(),s=Xn();function a(r,u,i){let o=r.getValue();if(o.type==="front-matter"){let c=s(o,i);return c?[c,t]:""}}n.exports=a}}),mo=Z({"src/utils/front-matter/parse.js"(e,n){"use strict";re();var t=new RegExp("^(?<startDelimiter>-{3}|\\+{3})(?<language>[^\\n]*)\\n(?:|(?<value>.*?)\\n)(?<endDelimiter>\\k<startDelimiter>|\\.{3})[^\\S\\n]*(?:\\n|$)","s");function s(a){let r=a.match(t);if(!r)return{content:a};let{startDelimiter:u,language:i,value:o="",endDelimiter:c}=r.groups,v=i.trim()||"yaml";if(u==="+++"&&(v="toml"),v!=="yaml"&&u!==c)return{content:a};let[m]=r;return{frontMatter:{type:"front-matter",lang:v,value:o,startDelimiter:u,endDelimiter:c,raw:m.replace(/\n$/,"")},content:m.replace(/[^\n]/g," ")+a.slice(m.length)}}n.exports=s}}),ld=Z({"src/language-css/pragma.js"(e,n){"use strict";re();var t=no(),s=mo();function a(u){return t.hasPragma(s(u).content)}function r(u){let{frontMatter:i,content:o}=s(u);return(i?i.raw+`

`:"")+t.insertPragma(o)}n.exports={hasPragma:a,insertPragma:r}}}),cd=Z({"src/language-css/utils/index.js"(e,n){"use strict";re();var t=new Set(["red","green","blue","alpha","a","rgb","hue","h","saturation","s","lightness","l","whiteness","w","blackness","b","tint","shade","blend","blenda","contrast","hsl","hsla","hwb","hwba"]);function s(G,z){let U=Array.isArray(z)?z:[z],le=-1,ge;for(;ge=G.getParentNode(++le);)if(U.includes(ge.type))return le;return-1}function a(G,z){let U=s(G,z);return U===-1?null:G.getParentNode(U)}function r(G){var z;let U=a(G,"css-decl");return U==null||(z=U.prop)===null||z===void 0?void 0:z.toLowerCase()}var u=new Set(["initial","inherit","unset","revert"]);function i(G){return u.has(G.toLowerCase())}function o(G,z){let U=a(G,"css-atrule");return(U==null?void 0:U.name)&&U.name.toLowerCase().endsWith("keyframes")&&["from","to"].includes(z.toLowerCase())}function c(G){return G.includes("$")||G.includes("@")||G.includes("#")||G.startsWith("%")||G.startsWith("--")||G.startsWith(":--")||G.includes("(")&&G.includes(")")?G:G.toLowerCase()}function v(G,z){var U;let le=a(G,"value-func");return(le==null||(U=le.value)===null||U===void 0?void 0:U.toLowerCase())===z}function m(G){var z;let U=a(G,"css-rule"),le=U==null||(z=U.raws)===null||z===void 0?void 0:z.selector;return le&&(le.startsWith(":import")||le.startsWith(":export"))}function d(G,z){let U=Array.isArray(z)?z:[z],le=a(G,"css-atrule");return le&&U.includes(le.name.toLowerCase())}function p(G){let z=G.getValue(),U=a(G,"css-atrule");return(U==null?void 0:U.name)==="import"&&z.groups[0].value==="url"&&z.groups.length===2}function f(G){return G.type==="value-func"&&G.value.toLowerCase()==="url"}function h(G,z){var U;let le=(U=G.getParentNode())===null||U===void 0?void 0:U.nodes;return le&&le.indexOf(z)===le.length-1}function w(G){let{selector:z}=G;return z?typeof z=="string"&&/^@.+:.*$/.test(z)||z.value&&/^@.+:.*$/.test(z.value):!1}function T(G){return G.type==="value-word"&&["from","through","end"].includes(G.value)}function A(G){return G.type==="value-word"&&["and","or","not"].includes(G.value)}function S(G){return G.type==="value-word"&&G.value==="in"}function B(G){return G.type==="value-operator"&&G.value==="*"}function I(G){return G.type==="value-operator"&&G.value==="/"}function k(G){return G.type==="value-operator"&&G.value==="+"}function P(G){return G.type==="value-operator"&&G.value==="-"}function C(G){return G.type==="value-operator"&&G.value==="%"}function D(G){return B(G)||I(G)||k(G)||P(G)||C(G)}function g(G){return G.type==="value-word"&&["==","!="].includes(G.value)}function F(G){return G.type==="value-word"&&["<",">","<=",">="].includes(G.value)}function l(G){return G.type==="css-atrule"&&["if","else","for","each","while"].includes(G.name)}function E(G){var z;return((z=G.raws)===null||z===void 0?void 0:z.params)&&/^\(\s*\)$/.test(G.raws.params)}function y(G){return G.name.startsWith("prettier-placeholder")}function N(G){return G.prop.startsWith("@prettier-placeholder")}function x(G,z){return G.value==="$$"&&G.type==="value-func"&&(z==null?void 0:z.type)==="value-word"&&!z.raws.before}function b(G){var z,U;return((z=G.value)===null||z===void 0?void 0:z.type)==="value-root"&&((U=G.value.group)===null||U===void 0?void 0:U.type)==="value-value"&&G.prop.toLowerCase()==="composes"}function L(G){var z,U,le;return((z=G.value)===null||z===void 0||(U=z.group)===null||U===void 0||(le=U.group)===null||le===void 0?void 0:le.type)==="value-paren_group"&&G.value.group.group.open!==null&&G.value.group.group.close!==null}function M(G){var z;return((z=G.raws)===null||z===void 0?void 0:z.before)===""}function j(G){var z,U;return G.type==="value-comma_group"&&((z=G.groups)===null||z===void 0||(U=z[1])===null||U===void 0?void 0:U.type)==="value-colon"}function $(G){var z;return G.type==="value-paren_group"&&((z=G.groups)===null||z===void 0?void 0:z[0])&&j(G.groups[0])}function V(G){var z;let U=G.getValue();if(U.groups.length===0)return!1;let le=G.getParentNode(1);if(!$(U)&&!(le&&$(le)))return!1;let ge=a(G,"css-decl");return!!(ge!=null&&(z=ge.prop)!==null&&z!==void 0&&z.startsWith("$")||$(le)||le.type==="value-func")}function q(G){return G.type==="value-comment"&&G.inline}function Y(G){return G.type==="value-word"&&G.value==="#"}function H(G){return G.type==="value-word"&&G.value==="{"}function R(G){return G.type==="value-word"&&G.value==="}"}function Q(G){return["value-word","value-atword"].includes(G.type)}function ee(G){return(G==null?void 0:G.type)==="value-colon"}function te(G,z){if(!j(z))return!1;let{groups:U}=z,le=U.indexOf(G);return le===-1?!1:ee(U[le+1])}function oe(G){return G.value&&["not","and","or"].includes(G.value.toLowerCase())}function W(G){return G.type!=="value-func"?!1:t.has(G.value.toLowerCase())}function X(G){return/\/\//.test(G.split(/[\n\r]/).pop())}function ue(G){return(G==null?void 0:G.type)==="value-atword"&&G.value.startsWith("prettier-placeholder-")}function De(G,z){var U,le;if(((U=G.open)===null||U===void 0?void 0:U.value)!=="("||((le=G.close)===null||le===void 0?void 0:le.value)!==")"||G.groups.some(ge=>ge.type!=="value-comma_group"))return!1;if(z.type==="value-comma_group"){let ge=z.groups.indexOf(G)-1,Ae=z.groups[ge];if((Ae==null?void 0:Ae.type)==="value-word"&&Ae.value==="with")return!0}return!1}function ie(G){var z,U;return G.type==="value-paren_group"&&((z=G.open)===null||z===void 0?void 0:z.value)==="("&&((U=G.close)===null||U===void 0?void 0:U.value)===")"}n.exports={getAncestorCounter:s,getAncestorNode:a,getPropOfDeclNode:r,maybeToLowerCase:c,insideValueFunctionNode:v,insideICSSRuleNode:m,insideAtRuleNode:d,insideURLFunctionInImportAtRuleNode:p,isKeyframeAtRuleKeywords:o,isWideKeywords:i,isLastNode:h,isSCSSControlDirectiveNode:l,isDetachedRulesetDeclarationNode:w,isRelationalOperatorNode:F,isEqualityOperatorNode:g,isMultiplicationNode:B,isDivisionNode:I,isAdditionNode:k,isSubtractionNode:P,isModuloNode:C,isMathOperatorNode:D,isEachKeywordNode:S,isForKeywordNode:T,isURLFunctionNode:f,isIfElseKeywordNode:A,hasComposesNode:b,hasParensAroundNode:L,hasEmptyRawBefore:M,isDetachedRulesetCallNode:E,isTemplatePlaceholderNode:y,isTemplatePropNode:N,isPostcssSimpleVarNode:x,isKeyValuePairNode:j,isKeyValuePairInParenGroupNode:$,isKeyInValuePairNode:te,isSCSSMapItemNode:V,isInlineValueCommentNode:q,isHashNode:Y,isLeftCurlyBraceNode:H,isRightCurlyBraceNode:R,isWordNode:Q,isColonNode:ee,isMediaAndSupportsKeywords:oe,isColorAdjusterFuncNode:W,lastLineHasInlineComment:X,isAtWordPlaceholderNode:ue,isConfigurationNode:De,isParenGroupNode:ie}}}),pd=Z({"src/utils/line-column-to-index.js"(e,n){"use strict";re(),n.exports=function(t,s){let a=0;for(let r=0;r<t.line-1;++r)a=s.indexOf(`
`,a)+1;return a+t.column}}}),fd=Z({"src/language-css/loc.js"(e,n){"use strict";re();var{skipEverythingButNewLine:t}=Nr(),s=it(),a=pd();function r(p,f){return typeof p.sourceIndex=="number"?p.sourceIndex:p.source?a(p.source.start,f)-1:null}function u(p,f){if(p.type==="css-comment"&&p.inline)return t(f,p.source.startOffset);let h=p.nodes&&s(p.nodes);return h&&p.source&&!p.source.end&&(p=h),p.source&&p.source.end?a(p.source.end,f):null}function i(p,f){p.source&&(p.source.startOffset=r(p,f),p.source.endOffset=u(p,f));for(let h in p){let w=p[h];h==="source"||!w||typeof w!="object"||(w.type==="value-root"||w.type==="value-unknown"?o(w,c(p),w.text||w.value):i(w,f))}}function o(p,f,h){p.source&&(p.source.startOffset=r(p,h)+f,p.source.endOffset=u(p,h)+f);for(let w in p){let T=p[w];w==="source"||!T||typeof T!="object"||o(T,f,h)}}function c(p){let f=p.source.startOffset;return typeof p.prop=="string"&&(f+=p.prop.length),p.type==="css-atrule"&&typeof p.name=="string"&&(f+=1+p.name.length+p.raws.afterName.match(/^\s*:?\s*/)[0].length),p.type!=="css-atrule"&&p.raws&&typeof p.raws.between=="string"&&(f+=p.raws.between.length),f}function v(p){let f="initial",h="initial",w,T=!1,A=[];for(let S=0;S<p.length;S++){let B=p[S];switch(f){case"initial":if(B==="'"){f="single-quotes";continue}if(B==='"'){f="double-quotes";continue}if((B==="u"||B==="U")&&p.slice(S,S+4).toLowerCase()==="url("){f="url",S+=3;continue}if(B==="*"&&p[S-1]==="/"){f="comment-block";continue}if(B==="/"&&p[S-1]==="/"){f="comment-inline",w=S-1;continue}continue;case"single-quotes":if(B==="'"&&p[S-1]!=="\\"&&(f=h,h="initial"),B===`
`||B==="\r")return p;continue;case"double-quotes":if(B==='"'&&p[S-1]!=="\\"&&(f=h,h="initial"),B===`
`||B==="\r")return p;continue;case"url":if(B===")"&&(f="initial"),B===`
`||B==="\r")return p;if(B==="'"){f="single-quotes",h="url";continue}if(B==='"'){f="double-quotes",h="url";continue}continue;case"comment-block":B==="/"&&p[S-1]==="*"&&(f="initial");continue;case"comment-inline":(B==='"'||B==="'"||B==="*")&&(T=!0),(B===`
`||B==="\r")&&(T&&A.push([w,S]),f="initial",T=!1);continue}}for(let[S,B]of A)p=p.slice(0,S)+p.slice(S,B).replace(/["'*]/g," ")+p.slice(B);return p}function m(p){return p.source.startOffset}function d(p){return p.source.endOffset}n.exports={locStart:m,locEnd:d,calculateLoc:i,replaceQuotesInInlineComments:v}}}),Dd=Z({"src/language-css/utils/is-less-parser.js"(e,n){"use strict";re();function t(s){return s.parser==="css"||s.parser==="less"}n.exports=t}}),md=Z({"src/language-css/utils/is-scss.js"(e,n){"use strict";re();function t(s,a){return s==="less"||s==="scss"?s==="scss":/(?:\w\s*:\s*[^:}]+|#){|@import[^\n]+(?:url|,)/.test(a)}n.exports=t}}),dd=Z({"src/language-css/utils/css-units.evaluate.js"(e,n){n.exports={em:"em",rem:"rem",ex:"ex",rex:"rex",cap:"cap",rcap:"rcap",ch:"ch",rch:"rch",ic:"ic",ric:"ric",lh:"lh",rlh:"rlh",vw:"vw",svw:"svw",lvw:"lvw",dvw:"dvw",vh:"vh",svh:"svh",lvh:"lvh",dvh:"dvh",vi:"vi",svi:"svi",lvi:"lvi",dvi:"dvi",vb:"vb",svb:"svb",lvb:"lvb",dvb:"dvb",vmin:"vmin",svmin:"svmin",lvmin:"lvmin",dvmin:"dvmin",vmax:"vmax",svmax:"svmax",lvmax:"lvmax",dvmax:"dvmax",cm:"cm",mm:"mm",q:"Q",in:"in",pt:"pt",pc:"pc",px:"px",deg:"deg",grad:"grad",rad:"rad",turn:"turn",s:"s",ms:"ms",hz:"Hz",khz:"kHz",dpi:"dpi",dpcm:"dpcm",dppx:"dppx",x:"x"}}}),gd=Z({"src/language-css/utils/print-unit.js"(e,n){"use strict";re();var t=dd();function s(a){let r=a.toLowerCase();return Object.prototype.hasOwnProperty.call(t,r)?t[r]:a}n.exports=s}}),yd=Z({"src/language-css/printer-postcss.js"(e,n){"use strict";re();var t=it(),{printNumber:s,printString:a,hasNewline:r,isFrontMatterNode:u,isNextLineEmpty:i,isNonEmptyArray:o}=Ue(),{builders:{join:c,line:v,hardline:m,softline:d,group:p,fill:f,indent:h,dedent:w,ifBreak:T,breakParent:A},utils:{removeLines:S,getDocParts:B}}=Oe(),I=ad(),k=od(),{insertPragma:P}=ld(),{getAncestorNode:C,getPropOfDeclNode:D,maybeToLowerCase:g,insideValueFunctionNode:F,insideICSSRuleNode:l,insideAtRuleNode:E,insideURLFunctionInImportAtRuleNode:y,isKeyframeAtRuleKeywords:N,isWideKeywords:x,isLastNode:b,isSCSSControlDirectiveNode:L,isDetachedRulesetDeclarationNode:M,isRelationalOperatorNode:j,isEqualityOperatorNode:$,isMultiplicationNode:V,isDivisionNode:q,isAdditionNode:Y,isSubtractionNode:H,isMathOperatorNode:R,isEachKeywordNode:Q,isForKeywordNode:ee,isURLFunctionNode:te,isIfElseKeywordNode:oe,hasComposesNode:W,hasParensAroundNode:X,hasEmptyRawBefore:ue,isKeyValuePairNode:De,isKeyInValuePairNode:ie,isDetachedRulesetCallNode:G,isTemplatePlaceholderNode:z,isTemplatePropNode:U,isPostcssSimpleVarNode:le,isSCSSMapItemNode:ge,isInlineValueCommentNode:Ae,isHashNode:Ne,isLeftCurlyBraceNode:ke,isRightCurlyBraceNode:ce,isWordNode:pe,isColonNode:de,isMediaAndSupportsKeywords:ae,isColorAdjusterFuncNode:ve,lastLineHasInlineComment:K,isAtWordPlaceholderNode:he,isConfigurationNode:ye,isParenGroupNode:Ce}=cd(),{locStart:Ie,locEnd:Fe}=fd(),me=Dd(),_=md(),J=gd();function ne(be){return be.trailingComma==="es5"||be.trailingComma==="all"}function Ee(be,Le,qe){let se=be.getValue();if(!se)return"";if(typeof se=="string")return se;switch(se.type){case"front-matter":return[se.raw,m];case"css-root":{let He=We(be,Le,qe),Me=se.raws.after.trim();return[He,Me?" ".concat(Me):"",B(He).length>0?m:""]}case"css-comment":{let He=se.inline||se.raws.inline,Me=Le.originalText.slice(Ie(se),Fe(se));return He?Me.trimEnd():Me}case"css-rule":return[qe("selector"),se.important?" !important":"",se.nodes?[se.selector&&se.selector.type==="selector-unknown"&&K(se.selector.value)?v:" ","{",se.nodes.length>0?h([m,We(be,Le,qe)]):"",m,"}",M(se)?";":""]:";"];case"css-decl":{let He=be.getParentNode(),{between:Me}=se.raws,ze=Me.trim(),nt=ze===":",tt=W(se)?S(qe("value")):qe("value");return!nt&&K(ze)&&(tt=h([m,w(tt)])),[se.raws.before.replace(/[\s;]/g,""),l(be)?se.prop:g(se.prop),ze.startsWith("//")?" ":"",ze,se.extend?"":" ",me(Le)&&se.extend&&se.selector?["extend(",qe("selector"),")"]:"",tt,se.raws.important?se.raws.important.replace(/\s*!\s*important/i," !important"):se.important?" !important":"",se.raws.scssDefault?se.raws.scssDefault.replace(/\s*!default/i," !default"):se.scssDefault?" !default":"",se.raws.scssGlobal?se.raws.scssGlobal.replace(/\s*!global/i," !global"):se.scssGlobal?" !global":"",se.nodes?[" {",h([d,We(be,Le,qe)]),d,"}"]:U(se)&&!He.raws.semicolon&&Le.originalText[Fe(se)-1]!==";"?"":Le.__isHTMLStyleAttribute&&b(be,se)?T(";"):";"]}case"css-atrule":{let He=be.getParentNode(),Me=z(se)&&!He.raws.semicolon&&Le.originalText[Fe(se)-1]!==";";if(me(Le)){if(se.mixin)return[qe("selector"),se.important?" !important":"",Me?"":";"];if(se.function)return[se.name,qe("params"),Me?"":";"];if(se.variable)return["@",se.name,": ",se.value?qe("value"):"",se.raws.between.trim()?se.raws.between.trim()+" ":"",se.nodes?["{",h([se.nodes.length>0?d:"",We(be,Le,qe)]),d,"}"]:"",Me?"":";"]}return["@",G(se)||se.name.endsWith(":")?se.name:g(se.name),se.params?[G(se)?"":z(se)?se.raws.afterName===""?"":se.name.endsWith(":")?" ":/^\s*\n\s*\n/.test(se.raws.afterName)?[m,m]:/^\s*\n/.test(se.raws.afterName)?m:" ":" ",qe("params")]:"",se.selector?h([" ",qe("selector")]):"",se.value?p([" ",qe("value"),L(se)?X(se)?" ":v:""]):se.name==="else"?" ":"",se.nodes?[L(se)?"":se.selector&&!se.selector.nodes&&typeof se.selector.value=="string"&&K(se.selector.value)||!se.selector&&typeof se.params=="string"&&K(se.params)?v:" ","{",h([se.nodes.length>0?d:"",We(be,Le,qe)]),d,"}"]:Me?"":";"]}case"media-query-list":{let He=[];return be.each(Me=>{let ze=Me.getValue();ze.type==="media-query"&&ze.value===""||He.push(qe())},"nodes"),p(h(c(v,He)))}case"media-query":return[c(" ",be.map(qe,"nodes")),b(be,se)?"":","];case"media-type":return je(Xe(se.value,Le));case"media-feature-expression":return se.nodes?["(",...be.map(qe,"nodes"),")"]:se.value;case"media-feature":return g(Xe(se.value.replace(/ +/g," "),Le));case"media-colon":return[se.value," "];case"media-value":return je(Xe(se.value,Le));case"media-keyword":return Xe(se.value,Le);case"media-url":return Xe(se.value.replace(/^url\(\s+/gi,"url(").replace(/\s+\)$/g,")"),Le);case"media-unknown":return se.value;case"selector-root":return p([E(be,"custom-selector")?[C(be,"css-atrule").customSelector,v]:"",c([",",E(be,["extend","custom-selector","nest"])?v:m],be.map(qe,"nodes"))]);case"selector-selector":return p(h(be.map(qe,"nodes")));case"selector-comment":return se.value;case"selector-string":return Xe(se.value,Le);case"selector-tag":{let He=be.getParentNode(),Me=He&&He.nodes.indexOf(se),ze=Me&&He.nodes[Me-1];return[se.namespace?[se.namespace===!0?"":se.namespace.trim(),"|"]:"",ze.type==="selector-nesting"?se.value:je(N(be,se.value)?se.value.toLowerCase():se.value)]}case"selector-id":return["#",se.value];case"selector-class":return[".",je(Xe(se.value,Le))];case"selector-attribute":return["[",se.namespace?[se.namespace===!0?"":se.namespace.trim(),"|"]:"",se.attribute.trim(),se.operator?se.operator:"",se.value?_e(Xe(se.value.trim(),Le),Le):"",se.insensitive?" i":"","]"];case"selector-combinator":{if(se.value==="+"||se.value===">"||se.value==="~"||se.value===">>>"){let ze=be.getParentNode();return[ze.type==="selector-selector"&&ze.nodes[0]===se?"":v,se.value,b(be,se)?"":" "]}let He=se.value.trim().startsWith("(")?v:"",Me=je(Xe(se.value.trim(),Le))||v;return[He,Me]}case"selector-universal":return[se.namespace?[se.namespace===!0?"":se.namespace.trim(),"|"]:"",se.value];case"selector-pseudo":return[g(se.value),o(se.nodes)?["(",c(", ",be.map(qe,"nodes")),")"]:""];case"selector-nesting":return se.value;case"selector-unknown":{let He=C(be,"css-rule");if(He&&He.isSCSSNesterProperty)return je(Xe(g(se.value),Le));let Me=be.getParentNode();if(Me.raws&&Me.raws.selector){let nt=Ie(Me),tt=nt+Me.raws.selector.length;return Le.originalText.slice(nt,tt).trim()}let ze=be.getParentNode(1);if(Me.type==="value-paren_group"&&ze&&ze.type==="value-func"&&ze.value==="selector"){let nt=Fe(Me.open)+1,tt=Ie(Me.close),pt=Le.originalText.slice(nt,tt).trim();return K(pt)?[A,pt]:pt}return se.value}case"value-value":case"value-root":return qe("group");case"value-comment":return Le.originalText.slice(Ie(se),Fe(se));case"value-comma_group":{let He=be.getParentNode(),Me=be.getParentNode(1),ze=D(be),nt=ze&&He.type==="value-value"&&(ze==="grid"||ze.startsWith("grid-template")),tt=C(be,"css-atrule"),pt=tt&&L(tt),O=se.groups.some(ut=>Ae(ut)),fe=be.map(qe,"groups"),Te=[],$e=F(be,"url"),Je=!1,Ze=!1;for(let ut=0;ut<se.groups.length;++ut){Te.push(fe[ut]);let rt=se.groups[ut-1],Ve=se.groups[ut],Ge=se.groups[ut+1],tr=se.groups[ut+2];if($e){(Ge&&Y(Ge)||Y(Ve))&&Te.push(" ");continue}if(E(be,"forward")&&Ve.type==="value-word"&&Ve.value&&rt!==void 0&&rt.type==="value-word"&&rt.value==="as"&&Ge.type==="value-operator"&&Ge.value==="*"||!Ge||Ve.type==="value-word"&&Ve.value.endsWith("-")&&he(Ge))continue;let Eo=Ve.type==="value-string"&&Ve.value.startsWith("#{"),Fo=Je&&Ge.type==="value-string"&&Ge.value.endsWith("}");if(Eo||Fo){Je=!Je;continue}if(Je||de(Ve)||de(Ge)||Ve.type==="value-atword"&&Ve.value===""||Ve.value==="~"||Ve.value&&Ve.value.includes("\\")&&Ge&&Ge.type!=="value-comment"||rt&&rt.value&&rt.value.indexOf("\\")===rt.value.length-1&&Ve.type==="value-operator"&&Ve.value==="/"||Ve.value==="\\"||le(Ve,Ge)||Ne(Ve)||ke(Ve)||ce(Ge)||ke(Ge)&&ue(Ge)||ce(Ve)&&ue(Ge)||Ve.value==="--"&&Ne(Ge))continue;let Qn=R(Ve),Zn=R(Ge);if((Qn&&Ne(Ge)||Zn&&ce(Ve))&&ue(Ge)||!rt&&q(Ve)||F(be,"calc")&&(Y(Ve)||Y(Ge)||H(Ve)||H(Ge))&&ue(Ge))continue;let Ao=(Y(Ve)||H(Ve))&&ut===0&&(Ge.type==="value-number"||Ge.isHex)&&Me&&ve(Me)&&!ue(Ge),eu=tr&&tr.type==="value-func"||tr&&pe(tr)||Ve.type==="value-func"||pe(Ve),tu=Ge.type==="value-func"||pe(Ge)||rt&&rt.type==="value-func"||rt&&pe(rt);if(!(!(V(Ge)||V(Ve))&&!F(be,"calc")&&!Ao&&(q(Ge)&&!eu||q(Ve)&&!tu||Y(Ge)&&!eu||Y(Ve)&&!tu||H(Ge)||H(Ve))&&(ue(Ge)||Qn&&(!rt||rt&&R(rt))))){if(Ae(Ve)){if(He.type==="value-paren_group"){Te.push(w(m));continue}Te.push(m);continue}if(pt&&($(Ge)||j(Ge)||oe(Ge)||Q(Ve)||ee(Ve))){Te.push(" ");continue}if(tt&&tt.name.toLowerCase()==="namespace"){Te.push(" ");continue}if(nt){Ve.source&&Ge.source&&Ve.source.start.line!==Ge.source.start.line?(Te.push(m),Ze=!0):Te.push(" ");continue}if(Zn){Te.push(" ");continue}if(!(Ge&&Ge.value==="...")&&!(he(Ve)&&he(Ge)&&Fe(Ve)===Ie(Ge))){if(he(Ve)&&Ce(Ge)&&Fe(Ve)===Ie(Ge.open)){Te.push(d);continue}if(Ve.value==="with"&&Ce(Ge)){Te.push(" ");continue}Te.push(v)}}}return O&&Te.push(A),Ze&&Te.unshift(m),pt?p(h(Te)):y(be)?p(f(Te)):p(h(f(Te)))}case"value-paren_group":{let He=be.getParentNode();if(He&&te(He)&&(se.groups.length===1||se.groups.length>0&&se.groups[0].type==="value-comma_group"&&se.groups[0].groups.length>0&&se.groups[0].groups[0].type==="value-word"&&se.groups[0].groups[0].value.startsWith("data:")))return[se.open?qe("open"):"",c(",",be.map(qe,"groups")),se.close?qe("close"):""];if(!se.open){let $e=be.map(qe,"groups"),Je=[];for(let Ze=0;Ze<$e.length;Ze++)Ze!==0&&Je.push([",",v]),Je.push($e[Ze]);return p(h(f(Je)))}let Me=ge(be),ze=t(se.groups),nt=ze&&ze.type==="value-comment",tt=ie(se,He),pt=ye(se,He),O=pt||Me&&!tt,fe=pt||tt,Te=p([se.open?qe("open"):"",h([d,c([v],be.map(($e,Je)=>{let Ze=$e.getValue(),ut=Je===se.groups.length-1,rt=[qe(),ut?"":","];if(De(Ze)&&Ze.type==="value-comma_group"&&Ze.groups&&Ze.groups[0].type!=="value-paren_group"&&Ze.groups[2]&&Ze.groups[2].type==="value-paren_group"){let Ve=B(rt[0].contents.contents);return Ve[1]=p(Ve[1]),p(w(rt))}if(!ut&&Ze.type==="value-comma_group"&&o(Ze.groups)){let Ve=t(Ze.groups);Ve.source&&i(Le.originalText,Ve,Fe)&&rt.push(m)}return rt},"groups"))]),T(!nt&&_(Le.parser,Le.originalText)&&Me&&ne(Le)?",":""),d,se.close?qe("close"):""],{shouldBreak:O});return fe?w(Te):Te}case"value-func":return[se.value,E(be,"supports")&&ae(se)?" ":"",qe("group")];case"value-paren":return se.value;case"value-number":return[Re(se.value),J(se.unit)];case"value-operator":return se.value;case"value-word":return se.isColor&&se.isHex||x(se.value)?se.value.toLowerCase():se.value;case"value-colon":{let He=be.getParentNode(),Me=He&&He.groups.indexOf(se),ze=Me&&He.groups[Me-1];return[se.value,ze&&typeof ze.value=="string"&&t(ze.value)==="\\"||F(be,"url")?"":v]}case"value-comma":return[se.value," "];case"value-string":return a(se.raws.quote+se.value+se.raws.quote,Le);case"value-atword":return["@",se.value];case"value-unicode-range":return se.value;case"value-unknown":return se.value;default:throw new Error("Unknown postcss type ".concat(JSON.stringify(se.type)))}}function We(be,Le,qe){let se=[];return be.each((He,Me,ze)=>{let nt=ze[Me-1];if(nt&&nt.type==="css-comment"&&nt.text.trim()==="prettier-ignore"){let tt=He.getValue();se.push(Le.originalText.slice(Ie(tt),Fe(tt)))}else se.push(qe());Me!==ze.length-1&&(ze[Me+1].type==="css-comment"&&!r(Le.originalText,Ie(ze[Me+1]),{backwards:!0})&&!u(ze[Me])||ze[Me+1].type==="css-atrule"&&ze[Me+1].name==="else"&&ze[Me].type!=="css-comment"?se.push(" "):(se.push(Le.__isHTMLStyleAttribute?v:m),i(Le.originalText,He.getValue(),Fe)&&!u(ze[Me])&&se.push(m)))},"nodes"),se}var Be=/(["'])(?:(?!\1)[^\\]|\\.)*\1/gs,Pe=/(?:\d*\.\d+|\d+\.?)(?:[Ee][+-]?\d+)?/g,Se=/[A-Za-z]+/g,Qe=/[$@]?[A-Z_a-z\u0080-\uFFFF][\w\u0080-\uFFFF-]*/g,xe=new RegExp(Be.source+"|(".concat(Qe.source,")?(").concat(Pe.source,")(").concat(Se.source,")?"),"g");function Xe(be,Le){return be.replace(Be,qe=>a(qe,Le))}function _e(be,Le){let qe=Le.singleQuote?"'":'"';return be.includes('"')||be.includes("'")?be:qe+be+qe}function je(be){return be.replace(xe,(Le,qe,se,He,Me)=>!se&&He?Re(He)+g(Me||""):Le)}function Re(be){return s(be).replace(/\.0(?=$|e)/,"")}n.exports={print:Ee,embed:k,insertPragma:P,massageAstNode:I}}}),hd=Z({"src/language-css/options.js"(e,n){"use strict";re();var t=Ot();n.exports={singleQuote:t.singleQuote}}}),vd=Z({"src/language-css/parsers.js"(){re()}}),Cd=Z({"node_modules/linguist-languages/data/CSS.json"(e,n){n.exports={name:"CSS",type:"markup",tmScope:"source.css",aceMode:"css",codemirrorMode:"css",codemirrorMimeType:"text/css",color:"#563d7c",extensions:[".css"],languageId:50}}}),Ed=Z({"node_modules/linguist-languages/data/PostCSS.json"(e,n){n.exports={name:"PostCSS",type:"markup",color:"#dc3a0c",tmScope:"source.postcss",group:"CSS",extensions:[".pcss",".postcss"],aceMode:"text",languageId:262764437}}}),Fd=Z({"node_modules/linguist-languages/data/Less.json"(e,n){n.exports={name:"Less",type:"markup",color:"#1d365d",aliases:["less-css"],extensions:[".less"],tmScope:"source.css.less",aceMode:"less",codemirrorMode:"css",codemirrorMimeType:"text/css",languageId:198}}}),Ad=Z({"node_modules/linguist-languages/data/SCSS.json"(e,n){n.exports={name:"SCSS",type:"markup",color:"#c6538c",tmScope:"source.css.scss",aceMode:"scss",codemirrorMode:"css",codemirrorMimeType:"text/x-scss",extensions:[".scss"],languageId:329}}}),Sd=Z({"src/language-css/index.js"(e,n){"use strict";re();var t=Bt(),s=yd(),a=hd(),r=vd(),u=[t(Cd(),o=>({since:"1.4.0",parsers:["css"],vscodeLanguageIds:["css"],extensions:[...o.extensions,".wxss"]})),t(Ed(),()=>({since:"1.4.0",parsers:["css"],vscodeLanguageIds:["postcss"]})),t(Fd(),()=>({since:"1.4.0",parsers:["less"],vscodeLanguageIds:["less"]})),t(Ad(),()=>({since:"1.4.0",parsers:["scss"],vscodeLanguageIds:["scss"]}))],i={postcss:s};n.exports={languages:u,options:a,printers:i,parsers:r}}}),xd=Z({"src/language-handlebars/loc.js"(e,n){"use strict";re();function t(a){return a.loc.start.offset}function s(a){return a.loc.end.offset}n.exports={locStart:t,locEnd:s}}}),bd=Z({"src/language-handlebars/clean.js"(e,n){"use strict";re();function t(s,a){if(s.type==="TextNode"){let r=s.chars.trim();if(!r)return null;a.chars=r.replace(/[\t\n\f\r ]+/g," ")}s.type==="AttrNode"&&s.name.toLowerCase()==="class"&&delete a.value}t.ignoredProperties=new Set(["loc","selfClosing"]),n.exports=t}}),Td=Z({"vendors/html-void-elements.json"(e,n){n.exports={htmlVoidElements:["area","base","basefont","bgsound","br","col","command","embed","frame","hr","image","img","input","isindex","keygen","link","menuitem","meta","nextid","param","source","track","wbr"]}}}),Bd=Z({"src/language-handlebars/utils.js"(e,n){"use strict";re();var{htmlVoidElements:t}=Td(),s=it();function a(S){let B=S.getValue(),I=S.getParentNode(0);return!!(m(S,["ElementNode"])&&s(I.children)===B||m(S,["Block"])&&s(I.body)===B)}function r(S){return S.toUpperCase()===S}function u(S){return v(S,["ElementNode"])&&typeof S.tag=="string"&&!S.tag.startsWith(":")&&(r(S.tag[0])||S.tag.includes("."))}var i=new Set(t);function o(S){return i.has(S.tag)||u(S)&&S.children.every(B=>c(B))}function c(S){return v(S,["TextNode"])&&!/\S/.test(S.chars)}function v(S,B){return S&&B.includes(S.type)}function m(S,B){let I=S.getParentNode(0);return v(I,B)}function d(S,B){let I=h(S);return v(I,B)}function p(S,B){let I=w(S);return v(I,B)}function f(S,B){var I,k,P,C;let D=S.getValue(),g=(I=S.getParentNode(0))!==null&&I!==void 0?I:{},F=(k=(P=(C=g.children)!==null&&C!==void 0?C:g.body)!==null&&P!==void 0?P:g.parts)!==null&&k!==void 0?k:[],l=F.indexOf(D);return l!==-1&&F[l+B]}function h(S){let B=arguments.length>1&&arguments[1]!==void 0?arguments[1]:1;return f(S,-B)}function w(S){return f(S,1)}function T(S){return v(S,["MustacheCommentStatement"])&&typeof S.value=="string"&&S.value.trim()==="prettier-ignore"}function A(S){let B=S.getValue(),I=h(S,2);return T(B)||T(I)}n.exports={getNextNode:w,getPreviousNode:h,hasPrettierIgnore:A,isLastNodeOfSiblings:a,isNextNodeOfSomeType:p,isNodeOfSomeType:v,isParentOfSomeType:m,isPreviousNodeOfSomeType:d,isVoid:o,isWhitespaceNode:c}}}),Nd=Z({"src/language-handlebars/printer-glimmer.js"(e,n){"use strict";re();var{builders:{dedent:t,fill:s,group:a,hardline:r,ifBreak:u,indent:i,join:o,line:c,softline:v},utils:{getDocParts:m,replaceTextEndOfLine:d}}=Oe(),{getPreferredQuote:p,isNonEmptyArray:f}=Ue(),{locStart:h,locEnd:w}=xd(),T=bd(),{getNextNode:A,getPreviousNode:S,hasPrettierIgnore:B,isLastNodeOfSiblings:I,isNextNodeOfSomeType:k,isNodeOfSomeType:P,isParentOfSomeType:C,isPreviousNodeOfSomeType:D,isVoid:g,isWhitespaceNode:F}=Bd(),l=2;function E(K,he,ye){let Ce=K.getValue();if(!Ce)return"";if(B(K))return he.originalText.slice(h(Ce),w(Ce));let Ie=he.singleQuote?"'":'"';switch(Ce.type){case"Block":case"Program":case"Template":return a(K.map(ye,"body"));case"ElementNode":{let Fe=a(N(K,ye)),me=he.htmlWhitespaceSensitivity==="ignore"&&k(K,["ElementNode"])?v:"";if(g(Ce))return[Fe,me];let _=["</",Ce.tag,">"];return Ce.children.length===0?[Fe,i(_),me]:he.htmlWhitespaceSensitivity==="ignore"?[Fe,i(x(K,he,ye)),r,i(_),me]:[Fe,i(a(x(K,he,ye))),i(_),me]}case"BlockStatement":{let Fe=K.getParentNode(1);return Fe&&Fe.inverse&&Fe.inverse.body.length===1&&Fe.inverse.body[0]===Ce&&Fe.inverse.body[0].path.parts[0]==="if"?[ee(K,ye),ue(K,ye,he),De(K,ye,he)]:[R(K,ye),a([ue(K,ye,he),De(K,ye,he),te(K,ye,he)])]}case"ElementModifierStatement":return a(["{{",pe(K,ye),"}}"]);case"MustacheStatement":return a([L(Ce),pe(K,ye),M(Ce)]);case"SubExpression":return a(["(",ce(K,ye),v,")"]);case"AttrNode":{let Fe=Ce.value.type==="TextNode";if(Fe&&Ce.value.chars===""&&h(Ce.value)===w(Ce.value))return Ce.name;let _=Fe?p(Ce.value.chars,Ie).quote:Ce.value.type==="ConcatStatement"?p(Ce.value.parts.filter(ne=>ne.type==="TextNode").map(ne=>ne.chars).join(""),Ie).quote:"",J=ye("value");return[Ce.name,"=",_,Ce.name==="class"&&_?a(i(J)):J,_]}case"ConcatStatement":return K.map(ye,"parts");case"Hash":return o(c,K.map(ye,"pairs"));case"HashPair":return[Ce.key,"=",ye("value")];case"TextNode":{let Fe=Ce.chars.replace(/{{/g,"\\{{"),me=z(K);if(me){if(me==="class"){let xe=Fe.trim().split(/\s+/).join(" "),Xe=!1,_e=!1;return C(K,["ConcatStatement"])&&(D(K,["MustacheStatement"])&&/^\s/.test(Fe)&&(Xe=!0),k(K,["MustacheStatement"])&&/\s$/.test(Fe)&&xe!==""&&(_e=!0)),[Xe?c:"",xe,_e?c:""]}return d(Fe)}let J=/^[\t\n\f\r ]*$/.test(Fe),ne=!S(K),Ee=!A(K);if(he.htmlWhitespaceSensitivity!=="ignore"){let xe=/^[\t\n\f\r ]*/,Xe=/[\t\n\f\r ]*$/,_e=Ee&&C(K,["Template"]),je=ne&&C(K,["Template"]);if(J){if(je||_e)return"";let se=[c],He=U(Fe);return He&&(se=Ae(He)),I(K)&&(se=se.map(Me=>t(Me))),se}let[Re]=Fe.match(xe),[be]=Fe.match(Xe),Le=[];if(Re){Le=[c];let se=U(Re);se&&(Le=Ae(se)),Fe=Fe.replace(xe,"")}let qe=[];if(be){if(!_e){qe=[c];let se=U(be);se&&(qe=Ae(se)),I(K)&&(qe=qe.map(He=>t(He)))}Fe=Fe.replace(Xe,"")}return[...Le,s(ie(Fe)),...qe]}let We=U(Fe),Be=le(Fe),Pe=ge(Fe);if((ne||Ee)&&J&&C(K,["Block","ElementNode","Template"]))return"";J&&We?(Be=Math.min(We,l),Pe=0):(k(K,["BlockStatement","ElementNode"])&&(Pe=Math.max(Pe,1)),D(K,["BlockStatement","ElementNode"])&&(Be=Math.max(Be,1)));let Se="",Qe="";return Pe===0&&k(K,["MustacheStatement"])&&(Qe=" "),Be===0&&D(K,["MustacheStatement"])&&(Se=" "),ne&&(Be=0,Se=""),Ee&&(Pe=0,Qe=""),Fe=Fe.replace(/^[\t\n\f\r ]+/g,Se).replace(/[\t\n\f\r ]+$/,Qe),[...Ae(Be),s(ie(Fe)),...Ae(Pe)]}case"MustacheCommentStatement":{let Fe=h(Ce),me=w(Ce),_=he.originalText.charAt(Fe+2)==="~",J=he.originalText.charAt(me-3)==="~",ne=Ce.value.includes("}}")?"--":"";return["{{",_?"~":"","!",ne,Ce.value,ne,J?"~":"","}}"]}case"PathExpression":return Ce.original;case"BooleanLiteral":return String(Ce.value);case"CommentStatement":return["<!--",Ce.value,"-->"];case"StringLiteral":{if(ke(K)){let Fe=he.singleQuote?'"':"'";return Ne(Ce.value,Fe)}return Ne(Ce.value,Ie)}case"NumberLiteral":return String(Ce.value);case"UndefinedLiteral":return"undefined";case"NullLiteral":return"null";default:throw new Error("unknown glimmer type: "+JSON.stringify(Ce.type))}}function y(K,he){return h(K)-h(he)}function N(K,he){let ye=K.getValue(),Ce=["attributes","modifiers","comments"].filter(Fe=>f(ye[Fe])),Ie=Ce.flatMap(Fe=>ye[Fe]).sort(y);for(let Fe of Ce)K.each(me=>{let _=Ie.indexOf(me.getValue());Ie.splice(_,1,[c,he()])},Fe);return f(ye.blockParams)&&Ie.push(c,ve(ye)),["<",ye.tag,i(Ie),b(ye)]}function x(K,he,ye){let Ie=K.getValue().children.every(Fe=>F(Fe));return he.htmlWhitespaceSensitivity==="ignore"&&Ie?"":K.map((Fe,me)=>{let _=ye();return me===0&&he.htmlWhitespaceSensitivity==="ignore"?[v,_]:_},"children")}function b(K){return g(K)?u([v,"/>"],[" />",v]):u([v,">"],">")}function L(K){let he=K.escaped===!1?"{{{":"{{",ye=K.strip&&K.strip.open?"~":"";return[he,ye]}function M(K){let he=K.escaped===!1?"}}}":"}}";return[K.strip&&K.strip.close?"~":"",he]}function j(K){let he=L(K),ye=K.openStrip.open?"~":"";return[he,ye,"#"]}function $(K){let he=M(K);return[K.openStrip.close?"~":"",he]}function V(K){let he=L(K),ye=K.closeStrip.open?"~":"";return[he,ye,"/"]}function q(K){let he=M(K);return[K.closeStrip.close?"~":"",he]}function Y(K){let he=L(K),ye=K.inverseStrip.open?"~":"";return[he,ye]}function H(K){let he=M(K);return[K.inverseStrip.close?"~":"",he]}function R(K,he){let ye=K.getValue(),Ce=j(ye),Ie=$(ye),Fe=[de(K,he)],me=ae(K,he);if(me&&Fe.push(c,me),f(ye.program.blockParams)){let _=ve(ye.program);Fe.push(c,_)}return a([Ce,i(Fe),v,Ie])}function Q(K,he){return[he.htmlWhitespaceSensitivity==="ignore"?r:"",Y(K),"else",H(K)]}function ee(K,he){let ye=K.getParentNode(1);return[Y(ye),"else if ",ae(K,he),H(ye)]}function te(K,he,ye){let Ce=K.getValue();return ye.htmlWhitespaceSensitivity==="ignore"?[oe(Ce)?v:r,V(Ce),he("path"),q(Ce)]:[V(Ce),he("path"),q(Ce)]}function oe(K){return P(K,["BlockStatement"])&&K.program.body.every(he=>F(he))}function W(K){return X(K)&&K.inverse.body.length===1&&P(K.inverse.body[0],["BlockStatement"])&&K.inverse.body[0].path.parts[0]==="if"}function X(K){return P(K,["BlockStatement"])&&K.inverse}function ue(K,he,ye){let Ce=K.getValue();if(oe(Ce))return"";let Ie=he("program");return ye.htmlWhitespaceSensitivity==="ignore"?i([r,Ie]):i(Ie)}function De(K,he,ye){let Ce=K.getValue(),Ie=he("inverse"),Fe=ye.htmlWhitespaceSensitivity==="ignore"?[r,Ie]:Ie;return W(Ce)?Fe:X(Ce)?[Q(Ce,ye),i(Fe)]:""}function ie(K){return m(o(c,G(K)))}function G(K){return K.split(/[\t\n\f\r ]+/)}function z(K){for(let he=0;he<2;he++){let ye=K.getParentNode(he);if(ye&&ye.type==="AttrNode")return ye.name.toLowerCase()}}function U(K){return K=typeof K=="string"?K:"",K.split(`
`).length-1}function le(K){K=typeof K=="string"?K:"";let he=(K.match(/^([^\S\n\r]*[\n\r])+/g)||[])[0]||"";return U(he)}function ge(K){K=typeof K=="string"?K:"";let he=(K.match(/([\n\r][^\S\n\r]*)+$/g)||[])[0]||"";return U(he)}function Ae(){let K=arguments.length>0&&arguments[0]!==void 0?arguments[0]:0;return Array.from({length:Math.min(K,l)}).fill(r)}function Ne(K,he){let{quote:ye,regex:Ce}=p(K,he);return[ye,K.replace(Ce,"\\".concat(ye)),ye]}function ke(K){let he=0,ye=K.getParentNode(he);for(;ye&&P(ye,["SubExpression"]);)he++,ye=K.getParentNode(he);return!!(ye&&P(K.getParentNode(he+1),["ConcatStatement"])&&P(K.getParentNode(he+2),["AttrNode"]))}function ce(K,he){let ye=de(K,he),Ce=ae(K,he);return Ce?i([ye,c,a(Ce)]):ye}function pe(K,he){let ye=de(K,he),Ce=ae(K,he);return Ce?[i([ye,c,Ce]),v]:ye}function de(K,he){return he("path")}function ae(K,he){let ye=K.getValue(),Ce=[];if(ye.params.length>0){let Ie=K.map(he,"params");Ce.push(...Ie)}if(ye.hash&&ye.hash.pairs.length>0){let Ie=he("hash");Ce.push(Ie)}return Ce.length===0?"":o(c,Ce)}function ve(K){return["as |",K.blockParams.join(" "),"|"]}n.exports={print:E,massageAstNode:T}}}),wd=Z({"src/language-handlebars/parsers.js"(){re()}}),_d=Z({"node_modules/linguist-languages/data/Handlebars.json"(e,n){n.exports={name:"Handlebars",type:"markup",color:"#f7931e",aliases:["hbs","htmlbars"],extensions:[".handlebars",".hbs"],tmScope:"text.html.handlebars",aceMode:"handlebars",languageId:155}}}),Pd=Z({"src/language-handlebars/index.js"(e,n){"use strict";re();var t=Bt(),s=Nd(),a=wd(),r=[t(_d(),()=>({since:"2.3.0",parsers:["glimmer"],vscodeLanguageIds:["handlebars"]}))],u={glimmer:s};n.exports={languages:r,printers:u,parsers:a}}}),kd=Z({"src/language-graphql/pragma.js"(e,n){"use strict";re();function t(a){return/^\s*#[^\S\n]*@(?:format|prettier)\s*(?:\n|$)/.test(a)}function s(a){return`# @format

`+a}n.exports={hasPragma:t,insertPragma:s}}}),Id=Z({"src/language-graphql/loc.js"(e,n){"use strict";re();function t(a){return typeof a.start=="number"?a.start:a.loc&&a.loc.start}function s(a){return typeof a.end=="number"?a.end:a.loc&&a.loc.end}n.exports={locStart:t,locEnd:s}}}),Ld=Z({"src/language-graphql/printer-graphql.js"(e,n){"use strict";re();var{builders:{join:t,hardline:s,line:a,softline:r,group:u,indent:i,ifBreak:o}}=Oe(),{isNextLineEmpty:c,isNonEmptyArray:v}=Ue(),{insertPragma:m}=kd(),{locStart:d,locEnd:p}=Id();function f(k,P,C){let D=k.getValue();if(!D)return"";if(typeof D=="string")return D;switch(D.kind){case"Document":{let g=[];return k.each((F,l,E)=>{g.push(C()),l!==E.length-1&&(g.push(s),c(P.originalText,F.getValue(),p)&&g.push(s))},"definitions"),[...g,s]}case"OperationDefinition":{let g=P.originalText[d(D)]!=="{",F=Boolean(D.name);return[g?D.operation:"",g&&F?[" ",C("name")]:"",g&&!F&&v(D.variableDefinitions)?" ":"",v(D.variableDefinitions)?u(["(",i([r,t([o("",", "),r],k.map(C,"variableDefinitions"))]),r,")"]):"",h(k,C,D),D.selectionSet?!g&&!F?"":" ":"",C("selectionSet")]}case"FragmentDefinition":return["fragment ",C("name"),v(D.variableDefinitions)?u(["(",i([r,t([o("",", "),r],k.map(C,"variableDefinitions"))]),r,")"]):""," on ",C("typeCondition"),h(k,C,D)," ",C("selectionSet")];case"SelectionSet":return["{",i([s,t(s,w(k,P,C,"selections"))]),s,"}"];case"Field":return u([D.alias?[C("alias"),": "]:"",C("name"),D.arguments.length>0?u(["(",i([r,t([o("",", "),r],w(k,P,C,"arguments"))]),r,")"]):"",h(k,C,D),D.selectionSet?" ":"",C("selectionSet")]);case"Name":return D.value;case"StringValue":{if(D.block){let g=D.value.replace(/"""/g,"\\$&").split(`
`);return g.length===1&&(g[0]=g[0].trim()),g.every(F=>F==="")&&(g.length=0),t(s,['"""',...g,'"""'])}return['"',D.value.replace(/["\\]/g,"\\$&").replace(/\n/g,"\\n"),'"']}case"IntValue":case"FloatValue":case"EnumValue":return D.value;case"BooleanValue":return D.value?"true":"false";case"NullValue":return"null";case"Variable":return["$",C("name")];case"ListValue":return u(["[",i([r,t([o("",", "),r],k.map(C,"values"))]),r,"]"]);case"ObjectValue":return u(["{",P.bracketSpacing&&D.fields.length>0?" ":"",i([r,t([o("",", "),r],k.map(C,"fields"))]),r,o("",P.bracketSpacing&&D.fields.length>0?" ":""),"}"]);case"ObjectField":case"Argument":return[C("name"),": ",C("value")];case"Directive":return["@",C("name"),D.arguments.length>0?u(["(",i([r,t([o("",", "),r],w(k,P,C,"arguments"))]),r,")"]):""];case"NamedType":return C("name");case"VariableDefinition":return[C("variable"),": ",C("type"),D.defaultValue?[" = ",C("defaultValue")]:"",h(k,C,D)];case"ObjectTypeExtension":case"ObjectTypeDefinition":return[C("description"),D.description?s:"",D.kind==="ObjectTypeExtension"?"extend ":"","type ",C("name"),D.interfaces.length>0?[" implements ",...S(k,P,C)]:"",h(k,C,D),D.fields.length>0?[" {",i([s,t(s,w(k,P,C,"fields"))]),s,"}"]:""];case"FieldDefinition":return[C("description"),D.description?s:"",C("name"),D.arguments.length>0?u(["(",i([r,t([o("",", "),r],w(k,P,C,"arguments"))]),r,")"]):"",": ",C("type"),h(k,C,D)];case"DirectiveDefinition":return[C("description"),D.description?s:"","directive ","@",C("name"),D.arguments.length>0?u(["(",i([r,t([o("",", "),r],w(k,P,C,"arguments"))]),r,")"]):"",D.repeatable?" repeatable":""," on ",t(" | ",k.map(C,"locations"))];case"EnumTypeExtension":case"EnumTypeDefinition":return[C("description"),D.description?s:"",D.kind==="EnumTypeExtension"?"extend ":"","enum ",C("name"),h(k,C,D),D.values.length>0?[" {",i([s,t(s,w(k,P,C,"values"))]),s,"}"]:""];case"EnumValueDefinition":return[C("description"),D.description?s:"",C("name"),h(k,C,D)];case"InputValueDefinition":return[C("description"),D.description?D.description.block?s:a:"",C("name"),": ",C("type"),D.defaultValue?[" = ",C("defaultValue")]:"",h(k,C,D)];case"InputObjectTypeExtension":case"InputObjectTypeDefinition":return[C("description"),D.description?s:"",D.kind==="InputObjectTypeExtension"?"extend ":"","input ",C("name"),h(k,C,D),D.fields.length>0?[" {",i([s,t(s,w(k,P,C,"fields"))]),s,"}"]:""];case"SchemaExtension":return["extend schema",h(k,C,D),...D.operationTypes.length>0?[" {",i([s,t(s,w(k,P,C,"operationTypes"))]),s,"}"]:[]];case"SchemaDefinition":return[C("description"),D.description?s:"","schema",h(k,C,D)," {",D.operationTypes.length>0?i([s,t(s,w(k,P,C,"operationTypes"))]):"",s,"}"];case"OperationTypeDefinition":return[C("operation"),": ",C("type")];case"InterfaceTypeExtension":case"InterfaceTypeDefinition":return[C("description"),D.description?s:"",D.kind==="InterfaceTypeExtension"?"extend ":"","interface ",C("name"),D.interfaces.length>0?[" implements ",...S(k,P,C)]:"",h(k,C,D),D.fields.length>0?[" {",i([s,t(s,w(k,P,C,"fields"))]),s,"}"]:""];case"FragmentSpread":return["...",C("name"),h(k,C,D)];case"InlineFragment":return["...",D.typeCondition?[" on ",C("typeCondition")]:"",h(k,C,D)," ",C("selectionSet")];case"UnionTypeExtension":case"UnionTypeDefinition":return u([C("description"),D.description?s:"",u([D.kind==="UnionTypeExtension"?"extend ":"","union ",C("name"),h(k,C,D),D.types.length>0?[" =",o(""," "),i([o([a,"  "]),t([a,"| "],k.map(C,"types"))])]:""])]);case"ScalarTypeExtension":case"ScalarTypeDefinition":return[C("description"),D.description?s:"",D.kind==="ScalarTypeExtension"?"extend ":"","scalar ",C("name"),h(k,C,D)];case"NonNullType":return[C("type"),"!"];case"ListType":return["[",C("type"),"]"];default:throw new Error("unknown graphql type: "+JSON.stringify(D.kind))}}function h(k,P,C){if(C.directives.length===0)return"";let D=t(a,k.map(P,"directives"));return C.kind==="FragmentDefinition"||C.kind==="OperationDefinition"?u([a,D]):[" ",u(i([r,D]))]}function w(k,P,C,D){return k.map((g,F,l)=>{let E=C();return F<l.length-1&&c(P.originalText,g.getValue(),p)?[E,s]:E},D)}function T(k){return k.kind&&k.kind!=="Comment"}function A(k){let P=k.getValue();if(P.kind==="Comment")return"#"+P.value.trimEnd();throw new Error("Not a comment: "+JSON.stringify(P))}function S(k,P,C){let D=k.getNode(),g=[],{interfaces:F}=D,l=k.map(E=>C(E),"interfaces");for(let E=0;E<F.length;E++){let y=F[E];g.push(l[E]);let N=F[E+1];if(N){let x=P.originalText.slice(y.loc.end,N.loc.start),b=x.includes("#"),L=x.replace(/#.*/g,"").trim();g.push(L===","?",":" &",b?a:" ")}}return g}function B(k,P){k.kind==="StringValue"&&k.block&&!k.value.includes(`
`)&&(P.value=P.value.trim())}B.ignoredProperties=new Set(["loc","comments"]);function I(k){var P;let C=k.getValue();return C==null||(P=C.comments)===null||P===void 0?void 0:P.some(D=>D.value.trim()==="prettier-ignore")}n.exports={print:f,massageAstNode:B,hasPrettierIgnore:I,insertPragma:m,printComment:A,canAttachComment:T}}}),jd=Z({"src/language-graphql/options.js"(e,n){"use strict";re();var t=Ot();n.exports={bracketSpacing:t.bracketSpacing}}}),Od=Z({"src/language-graphql/parsers.js"(){re()}}),qd=Z({"node_modules/linguist-languages/data/GraphQL.json"(e,n){n.exports={name:"GraphQL",type:"data",color:"#e10098",extensions:[".graphql",".gql",".graphqls"],tmScope:"source.graphql",aceMode:"text",languageId:139}}}),Md=Z({"src/language-graphql/index.js"(e,n){"use strict";re();var t=Bt(),s=Ld(),a=jd(),r=Od(),u=[t(qd(),()=>({since:"1.5.0",parsers:["graphql"],vscodeLanguageIds:["graphql"]}))],i={graphql:s};n.exports={languages:u,options:a,printers:i,parsers:r}}}),go=Z({"src/language-markdown/loc.js"(e,n){"use strict";re();function t(a){return a.position.start.offset}function s(a){return a.position.end.offset}n.exports={locStart:t,locEnd:s}}}),Rd=Z({"src/language-markdown/constants.evaluate.js"(e,n){n.exports={cjkPattern:"(?:[\\u02ea-\\u02eb\\u1100-\\u11ff\\u2e80-\\u2e99\\u2e9b-\\u2ef3\\u2f00-\\u2fd5\\u2ff0-\\u303f\\u3041-\\u3096\\u3099-\\u309f\\u30a1-\\u30fa\\u30fc-\\u30ff\\u3105-\\u312f\\u3131-\\u318e\\u3190-\\u3191\\u3196-\\u31ba\\u31c0-\\u31e3\\u31f0-\\u321e\\u322a-\\u3247\\u3260-\\u327e\\u328a-\\u32b0\\u32c0-\\u32cb\\u32d0-\\u3370\\u337b-\\u337f\\u33e0-\\u33fe\\u3400-\\u4db5\\u4e00-\\u9fef\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\uf900-\\ufa6d\\ufa70-\\ufad9\\ufe10-\\ufe1f\\ufe30-\\ufe6f\\uff00-\\uffef]|[\\ud840-\\ud868\\ud86a-\\ud86c\\ud86f-\\ud872\\ud874-\\ud879][\\udc00-\\udfff]|\\ud82c[\\udc00-\\udd1e\\udd50-\\udd52\\udd64-\\udd67]|\\ud83c[\\ude00\\ude50-\\ude51]|\\ud869[\\udc00-\\uded6\\udf00-\\udfff]|\\ud86d[\\udc00-\\udf34\\udf40-\\udfff]|\\ud86e[\\udc00-\\udc1d\\udc20-\\udfff]|\\ud873[\\udc00-\\udea1\\udeb0-\\udfff]|\\ud87a[\\udc00-\\udfe0]|\\ud87e[\\udc00-\\ude1d])(?:[\\ufe00-\\ufe0f]|\\udb40[\\udd00-\\uddef])?",kPattern:"[\\u1100-\\u11ff\\u3001-\\u3003\\u3008-\\u3011\\u3013-\\u301f\\u302e-\\u3030\\u3037\\u30fb\\u3131-\\u318e\\u3200-\\u321e\\u3260-\\u327e\\ua960-\\ua97c\\uac00-\\ud7a3\\ud7b0-\\ud7c6\\ud7cb-\\ud7fb\\ufe45-\\ufe46\\uff61-\\uff65\\uffa0-\\uffbe\\uffc2-\\uffc7\\uffca-\\uffcf\\uffd2-\\uffd7\\uffda-\\uffdc]",punctuationPattern:"[\\u0021-\\u002f\\u003a-\\u0040\\u005b-\\u0060\\u007b-\\u007e\\u00a1\\u00a7\\u00ab\\u00b6-\\u00b7\\u00bb\\u00bf\\u037e\\u0387\\u055a-\\u055f\\u0589-\\u058a\\u05be\\u05c0\\u05c3\\u05c6\\u05f3-\\u05f4\\u0609-\\u060a\\u060c-\\u060d\\u061b\\u061e-\\u061f\\u066a-\\u066d\\u06d4\\u0700-\\u070d\\u07f7-\\u07f9\\u0830-\\u083e\\u085e\\u0964-\\u0965\\u0970\\u09fd\\u0a76\\u0af0\\u0c77\\u0c84\\u0df4\\u0e4f\\u0e5a-\\u0e5b\\u0f04-\\u0f12\\u0f14\\u0f3a-\\u0f3d\\u0f85\\u0fd0-\\u0fd4\\u0fd9-\\u0fda\\u104a-\\u104f\\u10fb\\u1360-\\u1368\\u1400\\u166e\\u169b-\\u169c\\u16eb-\\u16ed\\u1735-\\u1736\\u17d4-\\u17d6\\u17d8-\\u17da\\u1800-\\u180a\\u1944-\\u1945\\u1a1e-\\u1a1f\\u1aa0-\\u1aa6\\u1aa8-\\u1aad\\u1b5a-\\u1b60\\u1bfc-\\u1bff\\u1c3b-\\u1c3f\\u1c7e-\\u1c7f\\u1cc0-\\u1cc7\\u1cd3\\u2010-\\u2027\\u2030-\\u2043\\u2045-\\u2051\\u2053-\\u205e\\u207d-\\u207e\\u208d-\\u208e\\u2308-\\u230b\\u2329-\\u232a\\u2768-\\u2775\\u27c5-\\u27c6\\u27e6-\\u27ef\\u2983-\\u2998\\u29d8-\\u29db\\u29fc-\\u29fd\\u2cf9-\\u2cfc\\u2cfe-\\u2cff\\u2d70\\u2e00-\\u2e2e\\u2e30-\\u2e4f\\u3001-\\u3003\\u3008-\\u3011\\u3014-\\u301f\\u3030\\u303d\\u30a0\\u30fb\\ua4fe-\\ua4ff\\ua60d-\\ua60f\\ua673\\ua67e\\ua6f2-\\ua6f7\\ua874-\\ua877\\ua8ce-\\ua8cf\\ua8f8-\\ua8fa\\ua8fc\\ua92e-\\ua92f\\ua95f\\ua9c1-\\ua9cd\\ua9de-\\ua9df\\uaa5c-\\uaa5f\\uaade-\\uaadf\\uaaf0-\\uaaf1\\uabeb\\ufd3e-\\ufd3f\\ufe10-\\ufe19\\ufe30-\\ufe52\\ufe54-\\ufe61\\ufe63\\ufe68\\ufe6a-\\ufe6b\\uff01-\\uff03\\uff05-\\uff0a\\uff0c-\\uff0f\\uff1a-\\uff1b\\uff1f-\\uff20\\uff3b-\\uff3d\\uff3f\\uff5b\\uff5d\\uff5f-\\uff65]|\\ud800[\\udd00-\\udd02\\udf9f\\udfd0]|\\ud801[\\udd6f]|\\ud802[\\udc57\\udd1f\\udd3f\\ude50-\\ude58\\ude7f\\udef0-\\udef6\\udf39-\\udf3f\\udf99-\\udf9c]|\\ud803[\\udf55-\\udf59]|\\ud804[\\udc47-\\udc4d\\udcbb-\\udcbc\\udcbe-\\udcc1\\udd40-\\udd43\\udd74-\\udd75\\uddc5-\\uddc8\\uddcd\\udddb\\udddd-\\udddf\\ude38-\\ude3d\\udea9]|\\ud805[\\udc4b-\\udc4f\\udc5b\\udc5d\\udcc6\\uddc1-\\uddd7\\ude41-\\ude43\\ude60-\\ude6c\\udf3c-\\udf3e]|\\ud806[\\udc3b\\udde2\\ude3f-\\ude46\\ude9a-\\ude9c\\ude9e-\\udea2]|\\ud807[\\udc41-\\udc45\\udc70-\\udc71\\udef7-\\udef8\\udfff]|\\ud809[\\udc70-\\udc74]|\\ud81a[\\ude6e-\\ude6f\\udef5\\udf37-\\udf3b\\udf44]|\\ud81b[\\ude97-\\ude9a\\udfe2]|\\ud82f[\\udc9f]|\\ud836[\\ude87-\\ude8b]|\\ud83a[\\udd5e-\\udd5f]"}}}),Kn=Z({"src/language-markdown/utils.js"(e,n){"use strict";re();var{getLast:t}=Ue(),{locStart:s,locEnd:a}=go(),{cjkPattern:r,kPattern:u,punctuationPattern:i}=Rd(),o=["liquidNode","inlineCode","emphasis","esComment","strong","delete","wikiLink","link","linkReference","image","imageReference","footnote","footnoteReference","sentence","whitespace","word","break","inlineMath"],c=[...o,"tableCell","paragraph","heading"],v=new RegExp(u),m=new RegExp(i);function d(A,S){let B="non-cjk",I="cj-letter",k="k-letter",P="cjk-punctuation",C=[],D=(S.proseWrap==="preserve"?A:A.replace(new RegExp("(".concat(r,`)
(`).concat(r,")"),"g"),"$1$2")).split(/([\t\n ]+)/);for(let[F,l]of D.entries()){if(F%2===1){C.push({type:"whitespace",value:/\n/.test(l)?`
`:" "});continue}if((F===0||F===D.length-1)&&l==="")continue;let E=l.split(new RegExp("(".concat(r,")")));for(let[y,N]of E.entries())if(!((y===0||y===E.length-1)&&N==="")){if(y%2===0){N!==""&&g({type:"word",value:N,kind:B,hasLeadingPunctuation:m.test(N[0]),hasTrailingPunctuation:m.test(t(N))});continue}g(m.test(N)?{type:"word",value:N,kind:P,hasLeadingPunctuation:!0,hasTrailingPunctuation:!0}:{type:"word",value:N,kind:v.test(N)?k:I,hasLeadingPunctuation:!1,hasTrailingPunctuation:!1})}}return C;function g(F){let l=t(C);l&&l.type==="word"&&(l.kind===B&&F.kind===I&&!l.hasTrailingPunctuation||l.kind===I&&F.kind===B&&!F.hasLeadingPunctuation?C.push({type:"whitespace",value:" "}):!E(B,P)&&![l.value,F.value].some(y=>/\u3000/.test(y))&&C.push({type:"whitespace",value:""})),C.push(F);function E(y,N){return l.kind===y&&F.kind===N||l.kind===N&&F.kind===y}}}function p(A,S){let[,B,I,k]=S.slice(A.position.start.offset,A.position.end.offset).match(/^\s*(\d+)(\.|\))(\s*)/);return{numberText:B,marker:I,leadingSpaces:k}}function f(A,S){if(!A.ordered||A.children.length<2)return!1;let B=Number(p(A.children[0],S.originalText).numberText),I=Number(p(A.children[1],S.originalText).numberText);if(B===0&&A.children.length>2){let k=Number(p(A.children[2],S.originalText).numberText);return I===1&&k===1}return I===1}function h(A,S){let{value:B}=A;return A.position.end.offset===S.length&&B.endsWith(`
`)&&S.endsWith(`
`)?B.slice(0,-1):B}function w(A,S){return function B(I,k,P){let C=Object.assign({},S(I,k,P));return C.children&&(C.children=C.children.map((D,g)=>B(D,g,[C,...P]))),C}(A,null,[])}function T(A){if((A==null?void 0:A.type)!=="link"||A.children.length!==1)return!1;let[S]=A.children;return s(A)===s(S)&&a(A)===a(S)}n.exports={mapAst:w,splitText:d,punctuationPattern:i,getFencedCodeBlockValue:h,getOrderedListItemInfo:p,hasGitDiffFriendlyOrderedList:f,INLINE_NODE_TYPES:o,INLINE_NODE_WRAPPER_TYPES:c,isAutolink:T}}}),Vd=Z({"src/language-markdown/embed.js"(e,n){"use strict";re();var{inferParserByLanguage:t,getMaxContinuousCount:s}=Ue(),{builders:{hardline:a,markAsRoot:r},utils:{replaceEndOfLine:u}}=Oe(),i=Xn(),{getFencedCodeBlockValue:o}=Kn();function c(v,m,d,p){let f=v.getValue();if(f.type==="code"&&f.lang!==null){let h=t(f.lang,p);if(h){let w=p.__inJsTemplate?"~":"`",T=w.repeat(Math.max(3,s(f.value,w)+1)),A={parser:h};f.lang==="tsx"&&(A.filepath="dummy.tsx");let S=d(o(f,p.originalText),A,{stripTrailingHardline:!0});return r([T,f.lang,f.meta?" "+f.meta:"",a,u(S),a,T])}}switch(f.type){case"front-matter":return i(f,d);case"importExport":return[d(f.value,{parser:"babel"},{stripTrailingHardline:!0}),a];case"jsx":return d("<$>".concat(f.value,"</$>"),{parser:"__js_expression",rootMarker:"mdx"},{stripTrailingHardline:!0})}return null}n.exports=c}}),yo=Z({"src/language-markdown/pragma.js"(e,n){"use strict";re();var t=mo(),s=["format","prettier"];function a(r){let u="@(".concat(s.join("|"),")"),i=new RegExp(["<!--\\s*".concat(u,"\\s*-->"),"{\\s*\\/\\*\\s*".concat(u,"\\s*\\*\\/\\s*}"),`<!--.*\r?
[\\s\\S]*(^|
)[^\\S
]*`.concat(u,`[^\\S
]*($|
)[\\s\\S]*
.*-->`)].join("|"),"m"),o=r.match(i);return(o==null?void 0:o.index)===0}n.exports={startWithPragma:a,hasPragma:r=>a(t(r).content.trimStart()),insertPragma:r=>{let u=t(r),i="<!-- @".concat(s[0]," -->");return u.frontMatter?"".concat(u.frontMatter.raw,`

`).concat(i,`

`).concat(u.content):"".concat(i,`

`).concat(u.content)}}}}),Wd=Z({"src/language-markdown/print-preprocess.js"(e,n){"use strict";re();var t=it(),{getOrderedListItemInfo:s,mapAst:a,splitText:r}=Kn(),u=/^.$/su;function i(T,A){return T=v(T,A),T=p(T),T=c(T),T=h(T,A),T=w(T,A),T=f(T,A),T=o(T),T=m(T),T}function o(T){return a(T,A=>A.type!=="import"&&A.type!=="export"?A:Object.assign(Object.assign({},A),{},{type:"importExport"}))}function c(T){return a(T,A=>A.type!=="inlineCode"?A:Object.assign(Object.assign({},A),{},{value:A.value.replace(/\s+/g," ")}))}function v(T,A){return a(T,S=>S.type!=="text"||S.value==="*"||S.value==="_"||!u.test(S.value)||S.position.end.offset-S.position.start.offset===S.value.length?S:Object.assign(Object.assign({},S),{},{value:A.originalText.slice(S.position.start.offset,S.position.end.offset)}))}function m(T){return d(T,(A,S)=>A.type==="importExport"&&S.type==="importExport",(A,S)=>({type:"importExport",value:A.value+`

`+S.value,position:{start:A.position.start,end:S.position.end}}))}function d(T,A,S){return a(T,B=>{if(!B.children)return B;let I=B.children.reduce((k,P)=>{let C=t(k);return C&&A(C,P)?k.splice(-1,1,S(C,P)):k.push(P),k},[]);return Object.assign(Object.assign({},B),{},{children:I})})}function p(T){return d(T,(A,S)=>A.type==="text"&&S.type==="text",(A,S)=>({type:"text",value:A.value+S.value,position:{start:A.position.start,end:S.position.end}}))}function f(T,A){return a(T,(S,B,I)=>{let[k]=I;if(S.type!=="text")return S;let{value:P}=S;return k.type==="paragraph"&&(B===0&&(P=P.trimStart()),B===k.children.length-1&&(P=P.trimEnd())),{type:"sentence",position:S.position,children:r(P,A)}})}function h(T,A){return a(T,(S,B,I)=>{if(S.type==="code"){let k=/^\n?(?: {4,}|\t)/.test(A.originalText.slice(S.position.start.offset,S.position.end.offset));if(S.isIndented=k,k)for(let P=0;P<I.length;P++){let C=I[P];if(C.hasIndentedCodeblock)break;C.type==="list"&&(C.hasIndentedCodeblock=!0)}}return S})}function w(T,A){return a(T,(I,k,P)=>{if(I.type==="list"&&I.children.length>0){for(let C=0;C<P.length;C++){let D=P[C];if(D.type==="list"&&!D.isAligned)return I.isAligned=!1,I}I.isAligned=B(I)}return I});function S(I){return I.children.length===0?-1:I.children[0].position.start.column-1}function B(I){if(!I.ordered)return!0;let[k,P]=I.children;if(s(k,A.originalText).leadingSpaces.length>1)return!0;let D=S(k);if(D===-1)return!1;if(I.children.length===1)return D%A.tabWidth===0;let g=S(P);return D!==g?!1:D%A.tabWidth===0?!0:s(P,A.originalText).leadingSpaces.length>1}}n.exports=i}}),$d=Z({"src/language-markdown/clean.js"(e,n){"use strict";re();var{isFrontMatterNode:t}=Ue(),{startWithPragma:s}=yo(),a=new Set(["position","raw"]);function r(u,i,o){if((u.type==="front-matter"||u.type==="code"||u.type==="yaml"||u.type==="import"||u.type==="export"||u.type==="jsx")&&delete i.value,u.type==="list"&&delete i.isAligned,(u.type==="list"||u.type==="listItem")&&(delete i.spread,delete i.loose),u.type==="text"||(u.type==="inlineCode"&&(i.value=u.value.replace(/[\t\n ]+/g," ")),u.type==="wikiLink"&&(i.value=u.value.trim().replace(/[\t\n]+/g," ")),(u.type==="definition"||u.type==="linkReference")&&(i.label=u.label.trim().replace(/[\t\n ]+/g," ").toLowerCase()),(u.type==="definition"||u.type==="link"||u.type==="image")&&u.title&&(i.title=u.title.replace(/\\(["')])/g,"$1")),o&&o.type==="root"&&o.children.length>0&&(o.children[0]===u||t(o.children[0])&&o.children[1]===u)&&u.type==="html"&&s(u.value)))return null}r.ignoredProperties=a,n.exports=r}}),Hd=Z({"src/language-markdown/printer-markdown.js"(e,n){"use strict";re();var{getLast:t,getMinNotPresentContinuousCount:s,getMaxContinuousCount:a,getStringWidth:r,isNonEmptyArray:u}=Ue(),{builders:{breakParent:i,join:o,line:c,literalline:v,markAsRoot:m,hardline:d,softline:p,ifBreak:f,fill:h,align:w,indent:T,group:A,hardlineWithoutBreakParent:S},utils:{normalizeDoc:B,replaceTextEndOfLine:I},printer:{printDocToString:k}}=Oe(),P=Vd(),{insertPragma:C}=yo(),{locStart:D,locEnd:g}=go(),F=Wd(),l=$d(),{getFencedCodeBlockValue:E,hasGitDiffFriendlyOrderedList:y,splitText:N,punctuationPattern:x,INLINE_NODE_TYPES:b,INLINE_NODE_WRAPPER_TYPES:L,isAutolink:M}=Kn(),j=new Set(["importExport"]),$=["heading","tableCell","link","wikiLink"],V=new Set(["listItem","definition","footnoteDefinition"]);function q(ce,pe,de){let ae=ce.getValue();if(le(ce))return N(pe.originalText.slice(ae.position.start.offset,ae.position.end.offset),pe).map(ve=>ve.type==="word"?ve.value:ve.value===""?"":oe(ce,ve.value,pe));switch(ae.type){case"front-matter":return pe.originalText.slice(ae.position.start.offset,ae.position.end.offset);case"root":return ae.children.length===0?"":[B(X(ce,pe,de)),j.has(De(ae).type)?"":d];case"paragraph":return ue(ce,pe,de,{postprocessor:h});case"sentence":return ue(ce,pe,de);case"word":{let ve=ae.value.replace(/\*/g,"\\$&").replace(new RegExp(["(^|".concat(x,")(_+)"),"(_+)(".concat(x,"|$)")].join("|"),"g"),(ye,Ce,Ie,Fe,me)=>(Ie?"".concat(Ce).concat(Ie):"".concat(Fe).concat(me)).replace(/_/g,"\\_")),K=(ye,Ce,Ie)=>ye.type==="sentence"&&Ie===0,he=(ye,Ce,Ie)=>M(ye.children[Ie-1]);return ve!==ae.value&&(ce.match(void 0,K,he)||ce.match(void 0,K,(ye,Ce,Ie)=>ye.type==="emphasis"&&Ie===0,he))&&(ve=ve.replace(/^(\\?[*_])+/,ye=>ye.replace(/\\/g,""))),ve}case"whitespace":{let ve=ce.getParentNode(),K=ve.children.indexOf(ae),he=ve.children[K+1],ye=he&&/^>|^(?:[*+-]|#{1,6}|\d+[).])$/.test(he.value)?"never":pe.proseWrap;return oe(ce,ae.value,{proseWrap:ye})}case"emphasis":{let ve;if(M(ae.children[0]))ve=pe.originalText[ae.position.start.offset];else{let K=ce.getParentNode(),he=K.children.indexOf(ae),ye=K.children[he-1],Ce=K.children[he+1];ve=ye&&ye.type==="sentence"&&ye.children.length>0&&t(ye.children).type==="word"&&!t(ye.children).hasTrailingPunctuation||Ce&&Ce.type==="sentence"&&Ce.children.length>0&&Ce.children[0].type==="word"&&!Ce.children[0].hasLeadingPunctuation||te(ce,"emphasis")?"*":"_"}return[ve,ue(ce,pe,de),ve]}case"strong":return["**",ue(ce,pe,de),"**"];case"delete":return["~~",ue(ce,pe,de),"~~"];case"inlineCode":{let ve=s(ae.value,"`"),K="`".repeat(ve||1),he=ve&&!/^\s/.test(ae.value)?" ":"";return[K,he,ae.value,he,K]}case"wikiLink":{let ve="";return pe.proseWrap==="preserve"?ve=ae.value:ve=ae.value.replace(/[\t\n]+/g," "),["[[",ve,"]]"]}case"link":switch(pe.originalText[ae.position.start.offset]){case"<":{let ve="mailto:",K=ae.url.startsWith(ve)&&pe.originalText.slice(ae.position.start.offset+1,ae.position.start.offset+1+ve.length)!==ve?ae.url.slice(ve.length):ae.url;return["<",K,">"]}case"[":return["[",ue(ce,pe,de),"](",ge(ae.url,")"),Ae(ae.title,pe),")"];default:return pe.originalText.slice(ae.position.start.offset,ae.position.end.offset)}case"image":return["![",ae.alt||"","](",ge(ae.url,")"),Ae(ae.title,pe),")"];case"blockquote":return["> ",w("> ",ue(ce,pe,de))];case"heading":return["#".repeat(ae.depth)+" ",ue(ce,pe,de)];case"code":{if(ae.isIndented){let he=" ".repeat(4);return w(he,[he,...I(ae.value,d)])}let ve=pe.__inJsTemplate?"~":"`",K=ve.repeat(Math.max(3,a(ae.value,ve)+1));return[K,ae.lang||"",ae.meta?" "+ae.meta:"",d,...I(E(ae,pe.originalText),d),d,K]}case"html":{let ve=ce.getParentNode(),K=ve.type==="root"&&t(ve.children)===ae?ae.value.trimEnd():ae.value,he=/^<!--.*-->$/s.test(K);return I(K,he?d:m(v))}case"list":{let ve=R(ae,ce.getParentNode()),K=y(ae,pe);return ue(ce,pe,de,{processor:(he,ye)=>{let Ce=Fe(),Ie=he.getValue();if(Ie.children.length===2&&Ie.children[1].type==="html"&&Ie.children[0].position.start.column!==Ie.children[1].position.start.column)return[Ce,Y(he,pe,de,Ce)];return[Ce,w(" ".repeat(Ce.length),Y(he,pe,de,Ce))];function Fe(){let me=ae.ordered?(ye===0?ae.start:K?1:ae.start+ye)+(ve%2===0?". ":") "):ve%2===0?"- ":"* ";return ae.isAligned||ae.hasIndentedCodeblock?H(me,pe):me}}})}case"thematicBreak":{let ve=ee(ce,"list");return ve===-1?"---":R(ce.getParentNode(ve),ce.getParentNode(ve+1))%2===0?"***":"---"}case"linkReference":return["[",ue(ce,pe,de),"]",ae.referenceType==="full"?["[",ae.identifier,"]"]:ae.referenceType==="collapsed"?"[]":""];case"imageReference":switch(ae.referenceType){case"full":return["![",ae.alt||"","][",ae.identifier,"]"];default:return["![",ae.alt,"]",ae.referenceType==="collapsed"?"[]":""]}case"definition":{let ve=pe.proseWrap==="always"?c:" ";return A(["[",ae.identifier,"]:",T([ve,ge(ae.url),ae.title===null?"":[ve,Ae(ae.title,pe,!1)]])])}case"footnote":return["[^",ue(ce,pe,de),"]"];case"footnoteReference":return["[^",ae.identifier,"]"];case"footnoteDefinition":{let ve=ce.getParentNode().children[ce.getName()+1],K=ae.children.length===1&&ae.children[0].type==="paragraph"&&(pe.proseWrap==="never"||pe.proseWrap==="preserve"&&ae.children[0].position.start.line===ae.children[0].position.end.line);return["[^",ae.identifier,"]: ",K?ue(ce,pe,de):A([w(" ".repeat(4),ue(ce,pe,de,{processor:(he,ye)=>ye===0?A([p,de()]):de()})),ve&&ve.type==="footnoteDefinition"?p:""])]}case"table":return W(ce,pe,de);case"tableCell":return ue(ce,pe,de);case"break":return/\s/.test(pe.originalText[ae.position.start.offset])?["  ",m(v)]:["\\",d];case"liquidNode":return I(ae.value,d);case"importExport":return[ae.value,d];case"esComment":return["{/* ",ae.value," */}"];case"jsx":return ae.value;case"math":return["$$",d,ae.value?[...I(ae.value,d),d]:"","$$"];case"inlineMath":return pe.originalText.slice(D(ae),g(ae));case"tableRow":case"listItem":default:throw new Error("Unknown markdown type ".concat(JSON.stringify(ae.type)))}}function Y(ce,pe,de,ae){let ve=ce.getValue(),K=ve.checked===null?"":ve.checked?"[x] ":"[ ] ";return[K,ue(ce,pe,de,{processor:(he,ye)=>{if(ye===0&&he.getValue().type!=="list")return w(" ".repeat(K.length),de());let Ce=" ".repeat(Ne(pe.tabWidth-ae.length,0,3));return[Ce,w(Ce,de())]}})]}function H(ce,pe){let de=ae();return ce+" ".repeat(de>=4?0:de);function ae(){let ve=ce.length%pe.tabWidth;return ve===0?0:pe.tabWidth-ve}}function R(ce,pe){return Q(ce,pe,de=>de.ordered===ce.ordered)}function Q(ce,pe,de){let ae=-1;for(let ve of pe.children)if(ve.type===ce.type&&de(ve)?ae++:ae=-1,ve===ce)return ae}function ee(ce,pe){let de=Array.isArray(pe)?pe:[pe],ae=-1,ve;for(;ve=ce.getParentNode(++ae);)if(de.includes(ve.type))return ae;return-1}function te(ce,pe){let de=ee(ce,pe);return de===-1?null:ce.getParentNode(de)}function oe(ce,pe,de){if(de.proseWrap==="preserve"&&pe===`
`)return d;let ae=de.proseWrap==="always"&&!te(ce,$);return pe!==""?ae?c:" ":ae?p:""}function W(ce,pe,de){let ae=ce.getValue(),ve=[],K=ce.map(me=>me.map((_,J)=>{let ne=k(de(),pe).formatted,Ee=r(ne);return ve[J]=Math.max(ve[J]||3,Ee),{text:ne,width:Ee}},"children"),"children"),he=Ce(!1);if(pe.proseWrap!=="never")return[i,he];let ye=Ce(!0);return[i,A(f(ye,he))];function Ce(me){let _=[Fe(K[0],me),Ie(me)];return K.length>1&&_.push(o(S,K.slice(1).map(J=>Fe(J,me)))),o(S,_)}function Ie(me){let _=ve.map((J,ne)=>{let Ee=ae.align[ne],We=Ee==="center"||Ee==="left"?":":"-",Be=Ee==="center"||Ee==="right"?":":"-",Pe=me?"-":"-".repeat(J-2);return"".concat(We).concat(Pe).concat(Be)});return"| ".concat(_.join(" | ")," |")}function Fe(me,_){let J=me.map((ne,Ee)=>{let{text:We,width:Be}=ne;if(_)return We;let Pe=ve[Ee]-Be,Se=ae.align[Ee],Qe=0;Se==="right"?Qe=Pe:Se==="center"&&(Qe=Math.floor(Pe/2));let xe=Pe-Qe;return"".concat(" ".repeat(Qe)).concat(We).concat(" ".repeat(xe))});return"| ".concat(J.join(" | ")," |")}}function X(ce,pe,de){let ae=[],ve=null,{children:K}=ce.getValue();for(let[he,ye]of K.entries())switch(ie(ye)){case"start":ve===null&&(ve={index:he,offset:ye.position.end.offset});break;case"end":ve!==null&&(ae.push({start:ve,end:{index:he,offset:ye.position.start.offset}}),ve=null);break;default:break}return ue(ce,pe,de,{processor:(he,ye)=>{if(ae.length>0){let Ce=ae[0];if(ye===Ce.start.index)return[K[Ce.start.index].value,pe.originalText.slice(Ce.start.offset,Ce.end.offset),K[Ce.end.index].value];if(Ce.start.index<ye&&ye<Ce.end.index)return!1;if(ye===Ce.end.index)return ae.shift(),!1}return de()}})}function ue(ce,pe,de){let ae=arguments.length>3&&arguments[3]!==void 0?arguments[3]:{},{postprocessor:ve}=ae,K=ae.processor||(()=>de()),he=ce.getValue(),ye=[],Ce;return ce.each((Ie,Fe)=>{let me=Ie.getValue(),_=K(Ie,Fe);if(_!==!1){let J={parts:ye,prevNode:Ce,parentNode:he,options:pe};G(me,J)&&(ye.push(d),Ce&&j.has(Ce.type)||(z(me,J)||U(me,J))&&ye.push(d),U(me,J)&&ye.push(d)),ye.push(_),Ce=me}},"children"),ve?ve(ye):ye}function De(ce){let pe=ce;for(;u(pe.children);)pe=t(pe.children);return pe}function ie(ce){let pe;if(ce.type==="html")pe=ce.value.match(/^<!--\s*prettier-ignore(?:-(start|end))?\s*-->$/);else{let de;ce.type==="esComment"?de=ce:ce.type==="paragraph"&&ce.children.length===1&&ce.children[0].type==="esComment"&&(de=ce.children[0]),de&&(pe=de.value.match(/^prettier-ignore(?:-(start|end))?$/))}return pe?pe[1]||"next":!1}function G(ce,pe){let de=pe.parts.length===0,ae=b.includes(ce.type),ve=ce.type==="html"&&L.includes(pe.parentNode.type);return!de&&!ae&&!ve}function z(ce,pe){var de,ae,ve;let he=(pe.prevNode&&pe.prevNode.type)===ce.type&&V.has(ce.type),ye=pe.parentNode.type==="listItem"&&!pe.parentNode.loose,Ce=((de=pe.prevNode)===null||de===void 0?void 0:de.type)==="listItem"&&pe.prevNode.loose,Ie=ie(pe.prevNode)==="next",Fe=ce.type==="html"&&((ae=pe.prevNode)===null||ae===void 0?void 0:ae.type)==="html"&&pe.prevNode.position.end.line+1===ce.position.start.line,me=ce.type==="html"&&pe.parentNode.type==="listItem"&&((ve=pe.prevNode)===null||ve===void 0?void 0:ve.type)==="paragraph"&&pe.prevNode.position.end.line+1===ce.position.start.line;return Ce||!(he||ye||Ie||Fe||me)}function U(ce,pe){let de=pe.prevNode&&pe.prevNode.type==="list",ae=ce.type==="code"&&ce.isIndented;return de&&ae}function le(ce){let pe=te(ce,["linkReference","imageReference"]);return pe&&(pe.type!=="linkReference"||pe.referenceType!=="full")}function ge(ce){let pe=arguments.length>1&&arguments[1]!==void 0?arguments[1]:[],de=[" ",...Array.isArray(pe)?pe:[pe]];return new RegExp(de.map(ae=>"\\".concat(ae)).join("|")).test(ce)?"<".concat(ce,">"):ce}function Ae(ce,pe){let de=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!0;if(!ce)return"";if(de)return" "+Ae(ce,pe,!1);if(ce=ce.replace(/\\(["')])/g,"$1"),ce.includes('"')&&ce.includes("'")&&!ce.includes(")"))return"(".concat(ce,")");let ae=ce.split("'").length-1,ve=ce.split('"').length-1,K=ae>ve?'"':ve>ae||pe.singleQuote?"'":'"';return ce=ce.replace(/\\/,"\\\\"),ce=ce.replace(new RegExp("(".concat(K,")"),"g"),"\\$1"),"".concat(K).concat(ce).concat(K)}function Ne(ce,pe,de){return ce<pe?pe:ce>de?de:ce}function ke(ce){let pe=Number(ce.getName());if(pe===0)return!1;let de=ce.getParentNode().children[pe-1];return ie(de)==="next"}n.exports={preprocess:F,print:q,embed:P,massageAstNode:l,hasPrettierIgnore:ke,insertPragma:C}}}),Gd=Z({"src/language-markdown/options.js"(e,n){"use strict";re();var t=Ot();n.exports={proseWrap:t.proseWrap,singleQuote:t.singleQuote}}}),Jd=Z({"src/language-markdown/parsers.js"(){re()}}),da=Z({"node_modules/linguist-languages/data/Markdown.json"(e,n){n.exports={name:"Markdown",type:"prose",color:"#083fa1",aliases:["pandoc"],aceMode:"markdown",codemirrorMode:"gfm",codemirrorMimeType:"text/x-gfm",wrap:!0,extensions:[".md",".livemd",".markdown",".mdown",".mdwn",".mdx",".mkd",".mkdn",".mkdown",".ronn",".scd",".workbook"],filenames:["contents.lr"],tmScope:"source.gfm",languageId:222}}}),Ud=Z({"src/language-markdown/index.js"(e,n){"use strict";re();var t=Bt(),s=Hd(),a=Gd(),r=Jd(),u=[t(da(),o=>({since:"1.8.0",parsers:["markdown"],vscodeLanguageIds:["markdown"],filenames:[...o.filenames,"README"],extensions:o.extensions.filter(c=>c!==".mdx")})),t(da(),()=>({name:"MDX",since:"1.15.0",parsers:["mdx"],vscodeLanguageIds:["mdx"],filenames:[],extensions:[".mdx"]}))],i={mdast:s};n.exports={languages:u,options:a,printers:i,parsers:r}}}),zd=Z({"src/language-html/clean.js"(e,n){"use strict";re();var{isFrontMatterNode:t}=Ue(),s=new Set(["sourceSpan","startSourceSpan","endSourceSpan","nameSpan","valueSpan"]);function a(r,u){if(r.type==="text"||r.type==="comment"||t(r)||r.type==="yaml"||r.type==="toml")return null;r.type==="attribute"&&delete u.value,r.type==="docType"&&delete u.value}a.ignoredProperties=s,n.exports=a}}),Xd=Z({"src/language-html/constants.evaluate.js"(e,n){n.exports={CSS_DISPLAY_TAGS:{area:"none",base:"none",basefont:"none",datalist:"none",head:"none",link:"none",meta:"none",noembed:"none",noframes:"none",param:"block",rp:"none",script:"block",source:"block",style:"none",template:"inline",track:"block",title:"none",html:"block",body:"block",address:"block",blockquote:"block",center:"block",div:"block",figure:"block",figcaption:"block",footer:"block",form:"block",header:"block",hr:"block",legend:"block",listing:"block",main:"block",p:"block",plaintext:"block",pre:"block",xmp:"block",slot:"contents",ruby:"ruby",rt:"ruby-text",article:"block",aside:"block",h1:"block",h2:"block",h3:"block",h4:"block",h5:"block",h6:"block",hgroup:"block",nav:"block",section:"block",dir:"block",dd:"block",dl:"block",dt:"block",ol:"block",ul:"block",li:"list-item",table:"table",caption:"table-caption",colgroup:"table-column-group",col:"table-column",thead:"table-header-group",tbody:"table-row-group",tfoot:"table-footer-group",tr:"table-row",td:"table-cell",th:"table-cell",fieldset:"block",button:"inline-block",details:"block",summary:"block",dialog:"block",meter:"inline-block",progress:"inline-block",object:"inline-block",video:"inline-block",audio:"inline-block",select:"inline-block",option:"block",optgroup:"block"},CSS_DISPLAY_DEFAULT:"inline",CSS_WHITE_SPACE_TAGS:{listing:"pre",plaintext:"pre",pre:"pre",xmp:"pre",nobr:"nowrap",table:"initial",textarea:"pre-wrap"},CSS_WHITE_SPACE_DEFAULT:"normal"}}}),Kd=Z({"src/language-html/utils/is-unknown-namespace.js"(e,n){"use strict";re();function t(s){return s.type==="element"&&!s.hasExplicitNamespace&&!["html","svg"].includes(s.namespace)}n.exports=t}}),qt=Z({"src/language-html/utils/index.js"(e,n){"use strict";re();var{inferParserByLanguage:t,isFrontMatterNode:s}=Ue(),{builders:{line:a,hardline:r,join:u},utils:{getDocParts:i,replaceTextEndOfLine:o}}=Oe(),{CSS_DISPLAY_TAGS:c,CSS_DISPLAY_DEFAULT:v,CSS_WHITE_SPACE_TAGS:m,CSS_WHITE_SPACE_DEFAULT:d}=Xd(),p=Kd(),f=new Set(["	",`
`,"\f","\r"," "]),h=_=>_.replace(/^[\t\n\f\r ]+/,""),w=_=>_.replace(/[\t\n\f\r ]+$/,""),T=_=>h(w(_)),A=_=>_.replace(/^[\t\f\r ]*\n/g,""),S=_=>A(w(_)),B=_=>_.split(/[\t\n\f\r ]+/),I=_=>_.match(/^[\t\n\f\r ]*/)[0],k=_=>{let[,J,ne,Ee]=_.match(/^([\t\n\f\r ]*)(.*?)([\t\n\f\r ]*)$/s);return{leadingWhitespace:J,trailingWhitespace:Ee,text:ne}},P=_=>/[\t\n\f\r ]/.test(_);function C(_,J){return!!(_.type==="ieConditionalComment"&&_.lastChild&&!_.lastChild.isSelfClosing&&!_.lastChild.endSourceSpan||_.type==="ieConditionalComment"&&!_.complete||le(_)&&_.children.some(ne=>ne.type!=="text"&&ne.type!=="interpolation")||ye(_,J)&&!l(_)&&_.type!=="interpolation")}function D(_){return _.type==="attribute"||!_.parent||!_.prev?!1:g(_.prev)}function g(_){return _.type==="comment"&&_.value.trim()==="prettier-ignore"}function F(_){return _.type==="text"||_.type==="comment"}function l(_){return _.type==="element"&&(_.fullName==="script"||_.fullName==="style"||_.fullName==="svg:style"||p(_)&&(_.name==="script"||_.name==="style"))}function E(_){return _.children&&!l(_)}function y(_){return l(_)||_.type==="interpolation"||N(_)}function N(_){return ke(_).startsWith("pre")}function x(_,J){let ne=Ee();if(ne&&!_.prev&&_.parent&&_.parent.tagDefinition&&_.parent.tagDefinition.ignoreFirstLf)return _.type==="interpolation";return ne;function Ee(){return s(_)?!1:(_.type==="text"||_.type==="interpolation")&&_.prev&&(_.prev.type==="text"||_.prev.type==="interpolation")?!0:!_.parent||_.parent.cssDisplay==="none"?!1:le(_.parent)?!0:!(!_.prev&&(_.parent.type==="root"||le(_)&&_.parent||l(_.parent)||K(_.parent,J)||!De(_.parent.cssDisplay))||_.prev&&!z(_.prev.cssDisplay))}}function b(_,J){return s(_)?!1:(_.type==="text"||_.type==="interpolation")&&_.next&&(_.next.type==="text"||_.next.type==="interpolation")?!0:!_.parent||_.parent.cssDisplay==="none"?!1:le(_.parent)?!0:!(!_.next&&(_.parent.type==="root"||le(_)&&_.parent||l(_.parent)||K(_.parent,J)||!ie(_.parent.cssDisplay))||_.next&&!G(_.next.cssDisplay))}function L(_){return U(_.cssDisplay)&&!l(_)}function M(_){return s(_)||_.next&&_.sourceSpan.end&&_.sourceSpan.end.line+1<_.next.sourceSpan.start.line}function j(_){return $(_)||_.type==="element"&&_.children.length>0&&(["body","script","style"].includes(_.name)||_.children.some(J=>te(J)))||_.firstChild&&_.firstChild===_.lastChild&&_.firstChild.type!=="text"&&H(_.firstChild)&&(!_.lastChild.isTrailingSpaceSensitive||R(_.lastChild))}function $(_){return _.type==="element"&&_.children.length>0&&(["html","head","ul","ol","select"].includes(_.name)||_.cssDisplay.startsWith("table")&&_.cssDisplay!=="table-cell")}function V(_){return Q(_)||_.prev&&q(_.prev)||Y(_)}function q(_){return Q(_)||_.type==="element"&&_.fullName==="br"||Y(_)}function Y(_){return H(_)&&R(_)}function H(_){return _.hasLeadingSpaces&&(_.prev?_.prev.sourceSpan.end.line<_.sourceSpan.start.line:_.parent.type==="root"||_.parent.startSourceSpan.end.line<_.sourceSpan.start.line)}function R(_){return _.hasTrailingSpaces&&(_.next?_.next.sourceSpan.start.line>_.sourceSpan.end.line:_.parent.type==="root"||_.parent.endSourceSpan&&_.parent.endSourceSpan.start.line>_.sourceSpan.end.line)}function Q(_){switch(_.type){case"ieConditionalComment":case"comment":case"directive":return!0;case"element":return["script","select"].includes(_.name)}return!1}function ee(_){return _.lastChild?ee(_.lastChild):_}function te(_){return _.children&&_.children.some(J=>J.type!=="text")}function oe(_){let{type:J,lang:ne}=_.attrMap;if(J==="module"||J==="text/javascript"||J==="text/babel"||J==="application/javascript"||ne==="jsx")return"babel";if(J==="application/x-typescript"||ne==="ts"||ne==="tsx")return"typescript";if(J==="text/markdown")return"markdown";if(J==="text/html")return"html";if(J&&(J.endsWith("json")||J.endsWith("importmap"))||J==="speculationrules")return"json";if(J==="text/x-handlebars-template")return"glimmer"}function W(_,J){let{lang:ne}=_.attrMap;if(!ne||ne==="postcss"||ne==="css")return"css";if(ne==="scss")return"scss";if(ne==="less")return"less";if(ne==="stylus")return t("stylus",J)}function X(_,J){if(_.name==="script"&&!_.attrMap.src)return!_.attrMap.lang&&!_.attrMap.type?"babel":oe(_);if(_.name==="style")return W(_,J);if(J&&ye(_,J))return oe(_)||!("src"in _.attrMap)&&t(_.attrMap.lang,J)}function ue(_){return _==="block"||_==="list-item"||_.startsWith("table")}function De(_){return!ue(_)&&_!=="inline-block"}function ie(_){return!ue(_)&&_!=="inline-block"}function G(_){return!ue(_)}function z(_){return!ue(_)}function U(_){return!ue(_)&&_!=="inline-block"}function le(_){return ke(_).startsWith("pre")}function ge(_,J){let ne=0;for(let Ee=_.stack.length-1;Ee>=0;Ee--){let We=_.stack[Ee];We&&typeof We=="object"&&!Array.isArray(We)&&J(We)&&ne++}return ne}function Ae(_,J){let ne=_;for(;ne;){if(J(ne))return!0;ne=ne.parent}return!1}function Ne(_,J){if(_.prev&&_.prev.type==="comment"){let Ee=_.prev.value.match(/^\s*display:\s*([a-z]+)\s*$/);if(Ee)return Ee[1]}let ne=!1;if(_.type==="element"&&_.namespace==="svg")if(Ae(_,Ee=>Ee.fullName==="svg:foreignObject"))ne=!0;else return _.name==="svg"?"inline-block":"block";switch(J.htmlWhitespaceSensitivity){case"strict":return"inline";case"ignore":return"block";default:return J.parser==="vue"&&_.parent&&_.parent.type==="root"?"block":_.type==="element"&&(!_.namespace||ne||p(_))&&c[_.name]||v}}function ke(_){return _.type==="element"&&(!_.namespace||p(_))&&m[_.name]||d}function ce(_){let J=Number.POSITIVE_INFINITY;for(let ne of _.split(`
`)){if(ne.length===0)continue;if(!f.has(ne[0]))return 0;let Ee=I(ne).length;ne.length!==Ee&&Ee<J&&(J=Ee)}return J===Number.POSITIVE_INFINITY?0:J}function pe(_){let J=arguments.length>1&&arguments[1]!==void 0?arguments[1]:ce(_);return J===0?_:_.split(`
`).map(ne=>ne.slice(J)).join(`
`)}function de(_,J){let ne=0;for(let Ee=0;Ee<_.length;Ee++)_[Ee]===J&&ne++;return ne}function ae(_){return _.replace(/&apos;/g,"'").replace(/&quot;/g,'"')}var ve=new Set(["template","style","script"]);function K(_,J){return he(_,J)&&!ve.has(_.fullName)}function he(_,J){return J.parser==="vue"&&_.type==="element"&&_.parent.type==="root"&&_.fullName.toLowerCase()!=="html"}function ye(_,J){return he(_,J)&&(K(_,J)||_.attrMap.lang&&_.attrMap.lang!=="html")}function Ce(_){let J=_.fullName;return J.charAt(0)==="#"||J==="slot-scope"||J==="v-slot"||J.startsWith("v-slot:")}function Ie(_,J){let ne=_.parent;if(!he(ne,J))return!1;let Ee=ne.fullName,We=_.fullName;return Ee==="script"&&We==="setup"||Ee==="style"&&We==="vars"}function Fe(_){let J=arguments.length>1&&arguments[1]!==void 0?arguments[1]:_.value;return _.parent.isWhitespaceSensitive?_.parent.isIndentationSensitive?o(J):o(pe(S(J)),r):i(u(a,B(J)))}function me(_,J){return he(_,J)&&_.name==="script"}n.exports={htmlTrim:T,htmlTrimPreserveIndentation:S,hasHtmlWhitespace:P,getLeadingAndTrailingHtmlWhitespace:k,canHaveInterpolation:E,countChars:de,countParents:ge,dedentString:pe,forceBreakChildren:$,forceBreakContent:j,forceNextEmptyLine:M,getLastDescendant:ee,getNodeCssStyleDisplay:Ne,getNodeCssStyleWhiteSpace:ke,hasPrettierIgnore:D,inferScriptParser:X,isVueCustomBlock:K,isVueNonHtmlBlock:ye,isVueScriptTag:me,isVueSlotAttribute:Ce,isVueSfcBindingsAttribute:Ie,isVueSfcBlock:he,isDanglingSpaceSensitiveNode:L,isIndentationSensitiveNode:N,isLeadingSpaceSensitiveNode:x,isPreLikeNode:le,isScriptLikeTag:l,isTextLikeNode:F,isTrailingSpaceSensitiveNode:b,isWhitespaceSensitiveNode:y,isUnknownNamespace:p,preferHardlineAsLeadingSpaces:V,preferHardlineAsTrailingSpaces:q,shouldPreserveContent:C,unescapeQuoteEntities:ae,getTextValueParts:Fe}}}),Yd=Z({"node_modules/angular-html-parser/lib/compiler/src/chars.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0}),e.$EOF=0,e.$BSPACE=8,e.$TAB=9,e.$LF=10,e.$VTAB=11,e.$FF=12,e.$CR=13,e.$SPACE=32,e.$BANG=33,e.$DQ=34,e.$HASH=35,e.$$=36,e.$PERCENT=37,e.$AMPERSAND=38,e.$SQ=39,e.$LPAREN=40,e.$RPAREN=41,e.$STAR=42,e.$PLUS=43,e.$COMMA=44,e.$MINUS=45,e.$PERIOD=46,e.$SLASH=47,e.$COLON=58,e.$SEMICOLON=59,e.$LT=60,e.$EQ=61,e.$GT=62,e.$QUESTION=63,e.$0=48,e.$7=55,e.$9=57,e.$A=65,e.$E=69,e.$F=70,e.$X=88,e.$Z=90,e.$LBRACKET=91,e.$BACKSLASH=92,e.$RBRACKET=93,e.$CARET=94,e.$_=95,e.$a=97,e.$b=98,e.$e=101,e.$f=102,e.$n=110,e.$r=114,e.$t=116,e.$u=117,e.$v=118,e.$x=120,e.$z=122,e.$LBRACE=123,e.$BAR=124,e.$RBRACE=125,e.$NBSP=160,e.$PIPE=124,e.$TILDA=126,e.$AT=64,e.$BT=96;function n(i){return i>=e.$TAB&&i<=e.$SPACE||i==e.$NBSP}e.isWhitespace=n;function t(i){return e.$0<=i&&i<=e.$9}e.isDigit=t;function s(i){return i>=e.$a&&i<=e.$z||i>=e.$A&&i<=e.$Z}e.isAsciiLetter=s;function a(i){return i>=e.$a&&i<=e.$f||i>=e.$A&&i<=e.$F||t(i)}e.isAsciiHexDigit=a;function r(i){return i===e.$LF||i===e.$CR}e.isNewLine=r;function u(i){return e.$0<=i&&i<=e.$7}e.isOctalDigit=u}}),Qd=Z({"node_modules/angular-html-parser/lib/compiler/src/aot/static_symbol.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=class{constructor(s,a,r){this.filePath=s,this.name=a,this.members=r}assertNoMembers(){if(this.members.length)throw new Error("Illegal state: symbol without members expected, but got ".concat(JSON.stringify(this),"."))}};e.StaticSymbol=n;var t=class{constructor(){this.cache=new Map}get(s,a,r){r=r||[];let u=r.length?".".concat(r.join(".")):"",i='"'.concat(s,'".').concat(a).concat(u),o=this.cache.get(i);return o||(o=new n(s,a,r),this.cache.set(i,o)),o}};e.StaticSymbolCache=t}}),Zd=Z({"node_modules/angular-html-parser/lib/compiler/src/util.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=/-+([a-z0-9])/g;function t(l){return l.replace(n,function(){for(var E=arguments.length,y=new Array(E),N=0;N<E;N++)y[N]=arguments[N];return y[1].toUpperCase()})}e.dashCaseToCamelCase=t;function s(l,E){return r(l,":",E)}e.splitAtColon=s;function a(l,E){return r(l,".",E)}e.splitAtPeriod=a;function r(l,E,y){let N=l.indexOf(E);return N==-1?y:[l.slice(0,N).trim(),l.slice(N+1).trim()]}function u(l,E,y){return Array.isArray(l)?E.visitArray(l,y):A(l)?E.visitStringMap(l,y):l==null||typeof l=="string"||typeof l=="number"||typeof l=="boolean"?E.visitPrimitive(l,y):E.visitOther(l,y)}e.visitValue=u;function i(l){return l!=null}e.isDefined=i;function o(l){return l===void 0?null:l}e.noUndefined=o;var c=class{visitArray(l,E){return l.map(y=>u(y,this,E))}visitStringMap(l,E){let y={};return Object.keys(l).forEach(N=>{y[N]=u(l[N],this,E)}),y}visitPrimitive(l,E){return l}visitOther(l,E){return l}};e.ValueTransformer=c,e.SyncAsync={assertSync:l=>{if(k(l))throw new Error("Illegal state: value cannot be a promise");return l},then:(l,E)=>k(l)?l.then(E):E(l),all:l=>l.some(k)?Promise.all(l):l};function v(l){throw new Error("Internal Error: ".concat(l))}e.error=v;function m(l,E){let y=Error(l);return y[d]=!0,E&&(y[p]=E),y}e.syntaxError=m;var d="ngSyntaxError",p="ngParseErrors";function f(l){return l[d]}e.isSyntaxError=f;function h(l){return l[p]||[]}e.getParseErrors=h;function w(l){return l.replace(/([.*+?^=!:${}()|[\]\/\\])/g,"\\$1")}e.escapeRegExp=w;var T=Object.getPrototypeOf({});function A(l){return typeof l=="object"&&l!==null&&Object.getPrototypeOf(l)===T}function S(l){let E="";for(let y=0;y<l.length;y++){let N=l.charCodeAt(y);if(N>=55296&&N<=56319&&l.length>y+1){let x=l.charCodeAt(y+1);x>=56320&&x<=57343&&(y++,N=(N-55296<<10)+x-56320+65536)}N<=127?E+=String.fromCharCode(N):N<=2047?E+=String.fromCharCode(N>>6&31|192,N&63|128):N<=65535?E+=String.fromCharCode(N>>12|224,N>>6&63|128,N&63|128):N<=2097151&&(E+=String.fromCharCode(N>>18&7|240,N>>12&63|128,N>>6&63|128,N&63|128))}return E}e.utf8Encode=S;function B(l){if(typeof l=="string")return l;if(l instanceof Array)return"["+l.map(B).join(", ")+"]";if(l==null)return""+l;if(l.overriddenName)return"".concat(l.overriddenName);if(l.name)return"".concat(l.name);if(!l.toString)return"object";let E=l.toString();if(E==null)return""+E;let y=E.indexOf(`
`);return y===-1?E:E.substring(0,y)}e.stringify=B;function I(l){return typeof l=="function"&&l.hasOwnProperty("__forward_ref__")?l():l}e.resolveForwardRef=I;function k(l){return!!l&&typeof l.then=="function"}e.isPromise=k;var P=class{constructor(l){this.full=l;let E=l.split(".");this.major=E[0],this.minor=E[1],this.patch=E.slice(2).join(".")}};e.Version=P;var C=typeof window<"u"&&window,D=typeof self<"u"&&typeof WorkerGlobalScope<"u"&&self instanceof WorkerGlobalScope&&self,g=typeof globalThis<"u"&&globalThis,F=g||C||D;e.global=F}}),eg=Z({"node_modules/angular-html-parser/lib/compiler/src/compile_metadata.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=Qd(),t=Zd(),s=/^(?:(?:\[([^\]]+)\])|(?:\(([^\)]+)\)))|(\@[-\w]+)$/;function a(y){return y.replace(/\W/g,"_")}e.sanitizeIdentifier=a;var r=0;function u(y){if(!y||!y.reference)return null;let N=y.reference;if(N instanceof n.StaticSymbol)return N.name;if(N.__anonymousType)return N.__anonymousType;let x=t.stringify(N);return x.indexOf("(")>=0?(x="anonymous_".concat(r++),N.__anonymousType=x):x=a(x),x}e.identifierName=u;function i(y){let N=y.reference;return N instanceof n.StaticSymbol?N.filePath:"./".concat(t.stringify(N))}e.identifierModuleUrl=i;function o(y,N){return"View_".concat(u({reference:y}),"_").concat(N)}e.viewClassName=o;function c(y){return"RenderType_".concat(u({reference:y}))}e.rendererTypeName=c;function v(y){return"HostView_".concat(u({reference:y}))}e.hostViewClassName=v;function m(y){return"".concat(u({reference:y}),"NgFactory")}e.componentFactoryName=m;var d;(function(y){y[y.Pipe=0]="Pipe",y[y.Directive=1]="Directive",y[y.NgModule=2]="NgModule",y[y.Injectable=3]="Injectable"})(d=e.CompileSummaryKind||(e.CompileSummaryKind={}));function p(y){return y.value!=null?a(y.value):u(y.identifier)}e.tokenName=p;function f(y){return y.identifier!=null?y.identifier.reference:y.value}e.tokenReference=f;var h=class{constructor(){let{moduleUrl:y,styles:N,styleUrls:x}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};this.moduleUrl=y||null,this.styles=k(N),this.styleUrls=k(x)}};e.CompileStylesheetMetadata=h;var w=class{constructor(y){let{encapsulation:N,template:x,templateUrl:b,htmlAst:L,styles:M,styleUrls:j,externalStylesheets:$,animations:V,ngContentSelectors:q,interpolation:Y,isInline:H,preserveWhitespaces:R}=y;if(this.encapsulation=N,this.template=x,this.templateUrl=b,this.htmlAst=L,this.styles=k(M),this.styleUrls=k(j),this.externalStylesheets=k($),this.animations=V?C(V):[],this.ngContentSelectors=q||[],Y&&Y.length!=2)throw new Error("'interpolation' should have a start and an end symbol.");this.interpolation=Y,this.isInline=H,this.preserveWhitespaces=R}toSummary(){return{ngContentSelectors:this.ngContentSelectors,encapsulation:this.encapsulation,styles:this.styles,animations:this.animations}}};e.CompileTemplateMetadata=w;var T=class{static create(y){let{isHost:N,type:x,isComponent:b,selector:L,exportAs:M,changeDetection:j,inputs:$,outputs:V,host:q,providers:Y,viewProviders:H,queries:R,guards:Q,viewQueries:ee,entryComponents:te,template:oe,componentViewType:W,rendererType:X,componentFactory:ue}=y,De={},ie={},G={};q!=null&&Object.keys(q).forEach(le=>{let ge=q[le],Ae=le.match(s);Ae===null?G[le]=ge:Ae[1]!=null?ie[Ae[1]]=ge:Ae[2]!=null&&(De[Ae[2]]=ge)});let z={};$!=null&&$.forEach(le=>{let ge=t.splitAtColon(le,[le,le]);z[ge[0]]=ge[1]});let U={};return V!=null&&V.forEach(le=>{let ge=t.splitAtColon(le,[le,le]);U[ge[0]]=ge[1]}),new T({isHost:N,type:x,isComponent:!!b,selector:L,exportAs:M,changeDetection:j,inputs:z,outputs:U,hostListeners:De,hostProperties:ie,hostAttributes:G,providers:Y,viewProviders:H,queries:R,guards:Q,viewQueries:ee,entryComponents:te,template:oe,componentViewType:W,rendererType:X,componentFactory:ue})}constructor(y){let{isHost:N,type:x,isComponent:b,selector:L,exportAs:M,changeDetection:j,inputs:$,outputs:V,hostListeners:q,hostProperties:Y,hostAttributes:H,providers:R,viewProviders:Q,queries:ee,guards:te,viewQueries:oe,entryComponents:W,template:X,componentViewType:ue,rendererType:De,componentFactory:ie}=y;this.isHost=!!N,this.type=x,this.isComponent=b,this.selector=L,this.exportAs=M,this.changeDetection=j,this.inputs=$,this.outputs=V,this.hostListeners=q,this.hostProperties=Y,this.hostAttributes=H,this.providers=k(R),this.viewProviders=k(Q),this.queries=k(ee),this.guards=te,this.viewQueries=k(oe),this.entryComponents=k(W),this.template=X,this.componentViewType=ue,this.rendererType=De,this.componentFactory=ie}toSummary(){return{summaryKind:d.Directive,type:this.type,isComponent:this.isComponent,selector:this.selector,exportAs:this.exportAs,inputs:this.inputs,outputs:this.outputs,hostListeners:this.hostListeners,hostProperties:this.hostProperties,hostAttributes:this.hostAttributes,providers:this.providers,viewProviders:this.viewProviders,queries:this.queries,guards:this.guards,viewQueries:this.viewQueries,entryComponents:this.entryComponents,changeDetection:this.changeDetection,template:this.template&&this.template.toSummary(),componentViewType:this.componentViewType,rendererType:this.rendererType,componentFactory:this.componentFactory}}};e.CompileDirectiveMetadata=T;var A=class{constructor(y){let{type:N,name:x,pure:b}=y;this.type=N,this.name=x,this.pure=!!b}toSummary(){return{summaryKind:d.Pipe,type:this.type,name:this.name,pure:this.pure}}};e.CompilePipeMetadata=A;var S=class{};e.CompileShallowModuleMetadata=S;var B=class{constructor(y){let{type:N,providers:x,declaredDirectives:b,exportedDirectives:L,declaredPipes:M,exportedPipes:j,entryComponents:$,bootstrapComponents:V,importedModules:q,exportedModules:Y,schemas:H,transitiveModule:R,id:Q}=y;this.type=N||null,this.declaredDirectives=k(b),this.exportedDirectives=k(L),this.declaredPipes=k(M),this.exportedPipes=k(j),this.providers=k(x),this.entryComponents=k($),this.bootstrapComponents=k(V),this.importedModules=k(q),this.exportedModules=k(Y),this.schemas=k(H),this.id=Q||null,this.transitiveModule=R||null}toSummary(){let y=this.transitiveModule;return{summaryKind:d.NgModule,type:this.type,entryComponents:y.entryComponents,providers:y.providers,modules:y.modules,exportedDirectives:y.exportedDirectives,exportedPipes:y.exportedPipes}}};e.CompileNgModuleMetadata=B;var I=class{constructor(){this.directivesSet=new Set,this.directives=[],this.exportedDirectivesSet=new Set,this.exportedDirectives=[],this.pipesSet=new Set,this.pipes=[],this.exportedPipesSet=new Set,this.exportedPipes=[],this.modulesSet=new Set,this.modules=[],this.entryComponentsSet=new Set,this.entryComponents=[],this.providers=[]}addProvider(y,N){this.providers.push({provider:y,module:N})}addDirective(y){this.directivesSet.has(y.reference)||(this.directivesSet.add(y.reference),this.directives.push(y))}addExportedDirective(y){this.exportedDirectivesSet.has(y.reference)||(this.exportedDirectivesSet.add(y.reference),this.exportedDirectives.push(y))}addPipe(y){this.pipesSet.has(y.reference)||(this.pipesSet.add(y.reference),this.pipes.push(y))}addExportedPipe(y){this.exportedPipesSet.has(y.reference)||(this.exportedPipesSet.add(y.reference),this.exportedPipes.push(y))}addModule(y){this.modulesSet.has(y.reference)||(this.modulesSet.add(y.reference),this.modules.push(y))}addEntryComponent(y){this.entryComponentsSet.has(y.componentType)||(this.entryComponentsSet.add(y.componentType),this.entryComponents.push(y))}};e.TransitiveCompileNgModuleMetadata=I;function k(y){return y||[]}var P=class{constructor(y,N){let{useClass:x,useValue:b,useExisting:L,useFactory:M,deps:j,multi:$}=N;this.token=y,this.useClass=x||null,this.useValue=b,this.useExisting=L,this.useFactory=M||null,this.dependencies=j||null,this.multi=!!$}};e.ProviderMeta=P;function C(y){return y.reduce((N,x)=>{let b=Array.isArray(x)?C(x):x;return N.concat(b)},[])}e.flatten=C;function D(y){return y.replace(/(\w+:\/\/[\w:-]+)?(\/+)?/,"ng:///")}function g(y,N,x){let b;return x.isInline?N.type.reference instanceof n.StaticSymbol?b="".concat(N.type.reference.filePath,".").concat(N.type.reference.name,".html"):b="".concat(u(y),"/").concat(u(N.type),".html"):b=x.templateUrl,N.type.reference instanceof n.StaticSymbol?b:D(b)}e.templateSourceUrl=g;function F(y,N){let x=y.moduleUrl.split(/\/\\/g),b=x[x.length-1];return D("css/".concat(N).concat(b,".ngstyle.js"))}e.sharedStylesheetJitUrl=F;function l(y){return D("".concat(u(y.type),"/module.ngfactory.js"))}e.ngModuleJitUrl=l;function E(y,N){return D("".concat(u(y),"/").concat(u(N.type),".ngfactory.js"))}e.templateJitUrl=E}}),tg=Z({"node_modules/angular-html-parser/lib/compiler/src/parse_util.js"(e){"use strict";re(),Object.defineProperty(e,"__esModule",{value:!0});var n=Yd(),t=eg(),s=class{constructor(v,m,d,p){this.file=v,this.offset=m,this.line=d,this.col=p}toString(){return this.offset!=null?"".concat(this.file.url,"@").concat(this.line,":").concat(this.col):this.file.url}moveBy(v){let m=this.file.content,d=m.length,p=this.offset,f=this.line,h=this.col;for(;p>0&&v<0;)if(p--,v++,m.charCodeAt(p)==n.$LF){f--;let T=m.substr(0,p-1).lastIndexOf(String.fromCharCode(n.$LF));h=T>0?p-T:p}else h--;for(;p<d&&v>0;){let w=m.charCodeAt(p);p++,v--,w==n.$LF?(f++,h=0):h++}return new s(this.file,p,f,h)}getContext(v,m){let d=this.file.content,p=this.offset;if(p!=null){p>d.length-1&&(p=d.length-1);let f=p,h=0,w=0;for(;h<v&&p>0&&(p--,h++,!(d[p]==`
`&&++w==m)););for(h=0,w=0;h<v&&f<d.length-1&&(f++,h++,!(d[f]==`
`&&++w==m)););return{before:d.substring(p,this.offset),after:d.substring(this.offset,f+1)}}return null}};e.ParseLocation=s;var a=class{constructor(v,m){this.content=v,this.url=m}};e.ParseSourceFile=a;var r=class{constructor(v,m){let d=arguments.length>2&&arguments[2]!==void 0?arguments[2]:null;this.start=v,this.end=m,this.details=d}toString(){return this.start.file.content.substring(this.start.offset,this.end.offset)}};e.ParseSourceSpan=r,e.EMPTY_PARSE_LOCATION=new s(new a("",""),0,0,0),e.EMPTY_SOURCE_SPAN=new r(e.EMPTY_PARSE_LOCATION,e.EMPTY_PARSE_LOCATION);var u;(function(v){v[v.WARNING=0]="WARNING",v[v.ERROR=1]="ERROR"})(u=e.ParseErrorLevel||(e.ParseErrorLevel={}));var i=class{constructor(v,m){let d=arguments.length>2&&arguments[2]!==void 0?arguments[2]:u.ERROR;this.span=v,this.msg=m,this.level=d}contextualMessage(){let v=this.span.start.getContext(100,3);return v?"".concat(this.msg,' ("').concat(v.before,"[").concat(u[this.level]," ->]").concat(v.after,'")'):this.msg}toString(){let v=this.span.details?", ".concat(this.span.details):"";return"".concat(this.contextualMessage(),": ").concat(this.span.start).concat(v)}};e.ParseError=i;function o(v,m){let d=t.identifierModuleUrl(m),p=d!=null?"in ".concat(v," ").concat(t.identifierName(m)," in ").concat(d):"in ".concat(v," ").concat(t.identifierName(m)),f=new a("",p);return new r(new s(f,-1,-1,-1),new s(f,-1,-1,-1))}e.typeSourceSpan=o;function c(v,m,d){let p="in ".concat(v," ").concat(m," in ").concat(d),f=new a("",p);return new r(new s(f,-1,-1,-1),new s(f,-1,-1,-1))}e.r3JitTypeSourceSpan=c}}),rg=Z({"src/language-html/print-preprocess.js"(e,n){"use strict";re();var{ParseSourceSpan:t}=tg(),{htmlTrim:s,getLeadingAndTrailingHtmlWhitespace:a,hasHtmlWhitespace:r,canHaveInterpolation:u,getNodeCssStyleDisplay:i,isDanglingSpaceSensitiveNode:o,isIndentationSensitiveNode:c,isLeadingSpaceSensitiveNode:v,isTrailingSpaceSensitiveNode:m,isWhitespaceSensitiveNode:d,isVueScriptTag:p}=qt(),f=[w,T,S,I,k,D,P,C,g,B,F];function h(l,E){for(let y of f)y(l,E);return l}function w(l){l.walk(E=>{if(E.type==="element"&&E.tagDefinition.ignoreFirstLf&&E.children.length>0&&E.children[0].type==="text"&&E.children[0].value[0]===`
`){let y=E.children[0];y.value.length===1?E.removeChild(y):y.value=y.value.slice(1)}})}function T(l){let E=y=>y.type==="element"&&y.prev&&y.prev.type==="ieConditionalStartComment"&&y.prev.sourceSpan.end.offset===y.startSourceSpan.start.offset&&y.firstChild&&y.firstChild.type==="ieConditionalEndComment"&&y.firstChild.sourceSpan.start.offset===y.startSourceSpan.end.offset;l.walk(y=>{if(y.children)for(let N=0;N<y.children.length;N++){let x=y.children[N];if(!E(x))continue;let b=x.prev,L=x.firstChild;y.removeChild(b),N--;let M=new t(b.sourceSpan.start,L.sourceSpan.end),j=new t(M.start,x.sourceSpan.end);x.condition=b.condition,x.sourceSpan=j,x.startSourceSpan=M,x.removeChild(L)}})}function A(l,E,y){l.walk(N=>{if(N.children)for(let x=0;x<N.children.length;x++){let b=N.children[x];if(b.type!=="text"&&!E(b))continue;b.type!=="text"&&(b.type="text",b.value=y(b));let L=b.prev;!L||L.type!=="text"||(L.value+=b.value,L.sourceSpan=new t(L.sourceSpan.start,b.sourceSpan.end),N.removeChild(b),x--)}})}function S(l){return A(l,E=>E.type==="cdata",E=>"<![CDATA[".concat(E.value,"]]>"))}function B(l){let E=y=>y.type==="element"&&y.attrs.length===0&&y.children.length===1&&y.firstChild.type==="text"&&!r(y.children[0].value)&&!y.firstChild.hasLeadingSpaces&&!y.firstChild.hasTrailingSpaces&&y.isLeadingSpaceSensitive&&!y.hasLeadingSpaces&&y.isTrailingSpaceSensitive&&!y.hasTrailingSpaces&&y.prev&&y.prev.type==="text"&&y.next&&y.next.type==="text";l.walk(y=>{if(y.children)for(let N=0;N<y.children.length;N++){let x=y.children[N];if(!E(x))continue;let b=x.prev,L=x.next;b.value+="<".concat(x.rawName,">")+x.firstChild.value+"</".concat(x.rawName,">")+L.value,b.sourceSpan=new t(b.sourceSpan.start,L.sourceSpan.end),b.isTrailingSpaceSensitive=L.isTrailingSpaceSensitive,b.hasTrailingSpaces=L.hasTrailingSpaces,y.removeChild(x),N--,y.removeChild(L)}})}function I(l,E){if(E.parser==="html")return;let y=/{{(.+?)}}/s;l.walk(N=>{if(!!u(N))for(let x of N.children){if(x.type!=="text")continue;let b=x.sourceSpan.start,L=null,M=x.value.split(y);for(let j=0;j<M.length;j++,b=L){let $=M[j];if(j%2===0){L=b.moveBy($.length),$.length>0&&N.insertChildBefore(x,{type:"text",value:$,sourceSpan:new t(b,L)});continue}L=b.moveBy($.length+4),N.insertChildBefore(x,{type:"interpolation",sourceSpan:new t(b,L),children:$.length===0?[]:[{type:"text",value:$,sourceSpan:new t(b.moveBy(2),L.moveBy(-2))}]})}N.removeChild(x)}})}function k(l){l.walk(E=>{if(!E.children)return;if(E.children.length===0||E.children.length===1&&E.children[0].type==="text"&&s(E.children[0].value).length===0){E.hasDanglingSpaces=E.children.length>0,E.children=[];return}let y=d(E),N=c(E);if(!y)for(let x=0;x<E.children.length;x++){let b=E.children[x];if(b.type!=="text")continue;let{leadingWhitespace:L,text:M,trailingWhitespace:j}=a(b.value),$=b.prev,V=b.next;M?(b.value=M,b.sourceSpan=new t(b.sourceSpan.start.moveBy(L.length),b.sourceSpan.end.moveBy(-j.length)),L&&($&&($.hasTrailingSpaces=!0),b.hasLeadingSpaces=!0),j&&(b.hasTrailingSpaces=!0,V&&(V.hasLeadingSpaces=!0))):(E.removeChild(b),x--,(L||j)&&($&&($.hasTrailingSpaces=!0),V&&(V.hasLeadingSpaces=!0)))}E.isWhitespaceSensitive=y,E.isIndentationSensitive=N})}function P(l){l.walk(E=>{E.isSelfClosing=!E.children||E.type==="element"&&(E.tagDefinition.isVoid||E.startSourceSpan===E.endSourceSpan)})}function C(l,E){l.walk(y=>{y.type==="element"&&(y.hasHtmComponentClosingTag=y.endSourceSpan&&/^<\s*\/\s*\/\s*>$/.test(E.originalText.slice(y.endSourceSpan.start.offset,y.endSourceSpan.end.offset)))})}function D(l,E){l.walk(y=>{y.cssDisplay=i(y,E)})}function g(l,E){l.walk(y=>{let{children:N}=y;if(!!N){if(N.length===0){y.isDanglingSpaceSensitive=o(y);return}for(let x of N)x.isLeadingSpaceSensitive=v(x,E),x.isTrailingSpaceSensitive=m(x,E);for(let x=0;x<N.length;x++){let b=N[x];b.isLeadingSpaceSensitive=(x===0||b.prev.isTrailingSpaceSensitive)&&b.isLeadingSpaceSensitive,b.isTrailingSpaceSensitive=(x===N.length-1||b.next.isLeadingSpaceSensitive)&&b.isTrailingSpaceSensitive}}})}function F(l,E){if(E.parser==="vue"){let y=l.children.find(x=>p(x,E));if(!y)return;let{lang:N}=y.attrMap;(N==="ts"||N==="typescript")&&(E.__should_parse_vue_template_with_ts=!0)}}n.exports=h}}),ng=Z({"src/language-html/pragma.js"(e,n){"use strict";re();function t(a){return/^\s*<!--\s*@(?:format|prettier)\s*-->/.test(a)}function s(a){return`<!-- @format -->

`+a.replace(/^\s*\n/,"")}n.exports={hasPragma:t,insertPragma:s}}}),Yn=Z({"src/language-html/loc.js"(e,n){"use strict";re();function t(a){return a.sourceSpan.start.offset}function s(a){return a.sourceSpan.end.offset}n.exports={locStart:t,locEnd:s}}}),er=Z({"src/language-html/print/tag.js"(e,n){"use strict";re();var t=Xt(),{isNonEmptyArray:s}=Ue(),{builders:{indent:a,join:r,line:u,softline:i,hardline:o},utils:{replaceTextEndOfLine:c}}=Oe(),{locStart:v,locEnd:m}=Yn(),{isTextLikeNode:d,getLastDescendant:p,isPreLikeNode:f,hasPrettierIgnore:h,shouldPreserveContent:w,isVueSfcBlock:T}=qt();function A(q,Y){return[q.isSelfClosing?"":S(q,Y),B(q,Y)]}function S(q,Y){return q.lastChild&&l(q.lastChild)?"":[I(q,Y),P(q,Y)]}function B(q,Y){return(q.next?g(q.next):F(q.parent))?"":[C(q,Y),k(q,Y)]}function I(q,Y){return F(q)?C(q.lastChild,Y):""}function k(q,Y){return l(q)?P(q.parent,Y):E(q)?$(q.next):""}function P(q,Y){if(t(!q.isSelfClosing),D(q,Y))return"";switch(q.type){case"ieConditionalComment":return"<!";case"element":if(q.hasHtmComponentClosingTag)return"<//";default:return"</".concat(q.rawName)}}function C(q,Y){if(D(q,Y))return"";switch(q.type){case"ieConditionalComment":case"ieConditionalEndComment":return"[endif]-->";case"ieConditionalStartComment":return"]><!-->";case"interpolation":return"}}";case"element":if(q.isSelfClosing)return"/>";default:return">"}}function D(q,Y){return!q.isSelfClosing&&!q.endSourceSpan&&(h(q)||w(q.parent,Y))}function g(q){return q.prev&&q.prev.type!=="docType"&&!d(q.prev)&&q.isLeadingSpaceSensitive&&!q.hasLeadingSpaces}function F(q){return q.lastChild&&q.lastChild.isTrailingSpaceSensitive&&!q.lastChild.hasTrailingSpaces&&!d(p(q.lastChild))&&!f(q)}function l(q){return!q.next&&!q.hasTrailingSpaces&&q.isTrailingSpaceSensitive&&d(p(q))}function E(q){return q.next&&!d(q.next)&&d(q)&&q.isTrailingSpaceSensitive&&!q.hasTrailingSpaces}function y(q){let Y=q.trim().match(/^prettier-ignore-attribute(?:\s+(.+))?$/s);return Y?Y[1]?Y[1].split(/\s+/):!0:!1}function N(q){return!q.prev&&q.isLeadingSpaceSensitive&&!q.hasLeadingSpaces}function x(q,Y,H){let R=q.getValue();if(!s(R.attrs))return R.isSelfClosing?" ":"";let Q=R.prev&&R.prev.type==="comment"&&y(R.prev.value),ee=typeof Q=="boolean"?()=>Q:Array.isArray(Q)?De=>Q.includes(De.rawName):()=>!1,te=q.map(De=>{let ie=De.getValue();return ee(ie)?c(Y.originalText.slice(v(ie),m(ie))):H()},"attrs"),oe=R.type==="element"&&R.fullName==="script"&&R.attrs.length===1&&R.attrs[0].fullName==="src"&&R.children.length===0,X=Y.singleAttributePerLine&&R.attrs.length>1&&!T(R,Y)?o:u,ue=[a([oe?" ":u,r(X,te)])];return R.firstChild&&N(R.firstChild)||R.isSelfClosing&&F(R.parent)||oe?ue.push(R.isSelfClosing?" ":""):ue.push(Y.bracketSameLine?R.isSelfClosing?" ":"":R.isSelfClosing?u:i),ue}function b(q){return q.firstChild&&N(q.firstChild)?"":V(q)}function L(q,Y,H){let R=q.getValue();return[M(R,Y),x(q,Y,H),R.isSelfClosing?"":b(R)]}function M(q,Y){return q.prev&&E(q.prev)?"":[j(q,Y),$(q)]}function j(q,Y){return N(q)?V(q.parent):g(q)?C(q.prev,Y):""}function $(q){switch(q.type){case"ieConditionalComment":case"ieConditionalStartComment":return"<!--[if ".concat(q.condition);case"ieConditionalEndComment":return"<!--<!";case"interpolation":return"{{";case"docType":return"<!DOCTYPE";case"element":if(q.condition)return"<!--[if ".concat(q.condition,"]><!--><").concat(q.rawName);default:return"<".concat(q.rawName)}}function V(q){switch(t(!q.isSelfClosing),q.type){case"ieConditionalComment":return"]>";case"element":if(q.condition)return"><!--<![endif]-->";default:return">"}}n.exports={printClosingTag:A,printClosingTagStart:S,printClosingTagStartMarker:P,printClosingTagEndMarker:C,printClosingTagSuffix:k,printClosingTagEnd:B,needsToBorrowLastChildClosingTagEndMarker:F,needsToBorrowParentClosingTagStartMarker:l,needsToBorrowPrevClosingTagEndMarker:g,printOpeningTag:L,printOpeningTagStart:M,printOpeningTagPrefix:j,printOpeningTagStartMarker:$,printOpeningTagEndMarker:V,needsToBorrowNextOpeningTagStartMarker:E,needsToBorrowParentOpeningTagEndMarker:N}}}),ug=Z({"node_modules/parse-srcset/src/parse-srcset.js"(e,n){re(),function(t,s){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (s),
                    __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
                        (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
                __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):0}(e,function(){return function(t,s){var a=s&&s.logger||console;function r(P){return P===" "||P==="	"||P===`
`||P==="\f"||P==="\r"}function u(P){var C,D=P.exec(t.substring(S));if(D)return C=D[0],S+=C.length,C}for(var i=t.length,o=/^[ \t\n\r\u000c]+/,c=/^[, \t\n\r\u000c]+/,v=/^[^ \t\n\r\u000c]+/,m=/[,]+$/,d=/^\d+$/,p=/^-?(?:[0-9]+|[0-9]*\.[0-9]+)(?:[eE][+-]?[0-9]+)?$/,f,h,w,T,A,S=0,B=[];;){if(u(c),S>=i)return B;f=u(v),h=[],f.slice(-1)===","?(f=f.replace(m,""),k()):I()}function I(){for(u(o),w="",T="in descriptor";;){if(A=t.charAt(S),T==="in descriptor")if(r(A))w&&(h.push(w),w="",T="after descriptor");else if(A===","){S+=1,w&&h.push(w),k();return}else if(A==="(")w=w+A,T="in parens";else if(A===""){w&&h.push(w),k();return}else w=w+A;else if(T==="in parens")if(A===")")w=w+A,T="in descriptor";else if(A===""){h.push(w),k();return}else w=w+A;else if(T==="after descriptor"&&!r(A))if(A===""){k();return}else T="in descriptor",S-=1;S+=1}}function k(){var P=!1,C,D,g,F,l={},E,y,N,x,b;for(F=0;F<h.length;F++)E=h[F],y=E[E.length-1],N=E.substring(0,E.length-1),x=parseInt(N,10),b=parseFloat(N),d.test(N)&&y==="w"?((C||D)&&(P=!0),x===0?P=!0:C=x):p.test(N)&&y==="x"?((C||D||g)&&(P=!0),b<0?P=!0:D=b):d.test(N)&&y==="h"?((g||D)&&(P=!0),x===0?P=!0:g=x):P=!0;P?a&&a.error&&a.error("Invalid srcset descriptor found in '"+t+"' at '"+E+"'."):(l.url=f,C&&(l.w=C),D&&(l.d=D),g&&(l.h=g),B.push(l))}}})}}),sg=Z({"src/language-html/syntax-attribute.js"(e,n){"use strict";re();var t=ug(),{builders:{ifBreak:s,join:a,line:r}}=Oe();function u(o){let c=t(o,{logger:{error(I){throw new Error(I)}}}),v=c.some(I=>{let{w:k}=I;return k}),m=c.some(I=>{let{h:k}=I;return k}),d=c.some(I=>{let{d:k}=I;return k});if(v+m+d>1)throw new Error("Mixed descriptor in srcset is not supported");let p=v?"w":m?"h":"d",f=v?"w":m?"h":"x",h=I=>Math.max(...I),w=c.map(I=>I.url),T=h(w.map(I=>I.length)),A=c.map(I=>I[p]).map(I=>I?I.toString():""),S=A.map(I=>{let k=I.indexOf(".");return k===-1?I.length:k}),B=h(S);return a([",",r],w.map((I,k)=>{let P=[I],C=A[k];if(C){let D=T-I.length+1,g=B-S[k],F=" ".repeat(D+g);P.push(s(F," "),C+f)}return P}))}function i(o){return o.trim().split(/\s+/).join(" ")}n.exports={printImgSrcset:u,printClassNames:i}}}),ig=Z({"src/language-html/syntax-vue.js"(e,n){"use strict";re();var{builders:{group:t}}=Oe();function s(i,o){let{left:c,operator:v,right:m}=a(i);return[t(o("function _(".concat(c,") {}"),{parser:"babel",__isVueForBindingLeft:!0}))," ",v," ",o(m,{parser:"__js_expression"},{stripTrailingHardline:!0})]}function a(i){let o=/(.*?)\s+(in|of)\s+(.*)/s,c=/,([^,\]}]*)(?:,([^,\]}]*))?$/,v=/^\(|\)$/g,m=i.match(o);if(!m)return;let d={};if(d.for=m[3].trim(),!d.for)return;let p=m[1].trim().replace(v,""),f=p.match(c);f?(d.alias=p.replace(c,""),d.iterator1=f[1].trim(),f[2]&&(d.iterator2=f[2].trim())):d.alias=p;let h=[d.alias,d.iterator1,d.iterator2];if(!h.some((w,T)=>!w&&(T===0||h.slice(T+1).some(Boolean))))return{left:h.filter(Boolean).join(","),operator:m[2],right:d.for}}function r(i,o){return o("function _(".concat(i,") {}"),{parser:"babel",__isVueBindings:!0})}function u(i){let o=/^(?:[\w$]+|\([^)]*\))\s*=>|^function\s*\(/,c=/^[$A-Z_a-z][\w$]*(?:\.[$A-Z_a-z][\w$]*|\['[^']*']|\["[^"]*"]|\[\d+]|\[[$A-Z_a-z][\w$]*])*$/,v=i.trim();return o.test(v)||c.test(v)}n.exports={isVueEventBindingExpression:u,printVueFor:s,printVueBindings:r}}}),ho=Z({"src/language-html/get-node-content.js"(e,n){"use strict";re();var{needsToBorrowParentClosingTagStartMarker:t,printClosingTagStartMarker:s,needsToBorrowLastChildClosingTagEndMarker:a,printClosingTagEndMarker:r,needsToBorrowParentOpeningTagEndMarker:u,printOpeningTagEndMarker:i}=er();function o(c,v){let m=c.startSourceSpan.end.offset;c.firstChild&&u(c.firstChild)&&(m-=i(c).length);let d=c.endSourceSpan.start.offset;return c.lastChild&&t(c.lastChild)?d+=s(c,v).length:a(c)&&(d-=r(c.lastChild,v).length),v.originalText.slice(m,d)}n.exports=o}}),ag=Z({"src/language-html/embed.js"(e,n){"use strict";re();var{builders:{breakParent:t,group:s,hardline:a,indent:r,line:u,fill:i,softline:o},utils:{mapDoc:c,replaceTextEndOfLine:v}}=Oe(),m=Xn(),{printClosingTag:d,printClosingTagSuffix:p,needsToBorrowPrevClosingTagEndMarker:f,printOpeningTagPrefix:h,printOpeningTag:w}=er(),{printImgSrcset:T,printClassNames:A}=sg(),{printVueFor:S,printVueBindings:B,isVueEventBindingExpression:I}=ig(),{isScriptLikeTag:k,isVueNonHtmlBlock:P,inferScriptParser:C,htmlTrimPreserveIndentation:D,dedentString:g,unescapeQuoteEntities:F,isVueSlotAttribute:l,isVueSfcBindingsAttribute:E,getTextValueParts:y}=qt(),N=ho();function x(L,M,j){let $=te=>new RegExp(te.join("|")).test(L.fullName),V=()=>F(L.value),q=!1,Y=(te,oe)=>{let W=te.type==="NGRoot"?te.node.type==="NGMicrosyntax"&&te.node.body.length===1&&te.node.body[0].type==="NGMicrosyntaxExpression"?te.node.body[0].expression:te.node:te.type==="JsExpressionRoot"?te.node:te;W&&(W.type==="ObjectExpression"||W.type==="ArrayExpression"||oe.parser==="__vue_expression"&&(W.type==="TemplateLiteral"||W.type==="StringLiteral"))&&(q=!0)},H=te=>s(te),R=function(te){let oe=arguments.length>1&&arguments[1]!==void 0?arguments[1]:!0;return s([r([o,te]),oe?o:""])},Q=te=>q?H(te):R(te),ee=(te,oe)=>M(te,Object.assign({__onHtmlBindingRoot:Y,__embeddedInHtml:!0},oe));if(L.fullName==="srcset"&&(L.parent.fullName==="img"||L.parent.fullName==="source"))return R(T(V()));if(L.fullName==="class"&&!j.parentParser){let te=V();if(!te.includes("{{"))return A(te)}if(L.fullName==="style"&&!j.parentParser){let te=V();if(!te.includes("{{"))return R(ee(te,{parser:"css",__isHTMLStyleAttribute:!0}))}if(j.parser==="vue"){if(L.fullName==="v-for")return S(V(),ee);if(l(L)||E(L,j))return B(V(),ee);let te=["^@","^v-on:"],oe=["^:","^v-bind:"],W=["^v-"];if($(te)){let X=V(),ue=I(X)?"__js_expression":j.__should_parse_vue_template_with_ts?"__vue_ts_event_binding":"__vue_event_binding";return Q(ee(X,{parser:ue}))}if($(oe))return Q(ee(V(),{parser:"__vue_expression"}));if($(W))return Q(ee(V(),{parser:"__js_expression"}))}if(j.parser==="angular"){let te=(G,z)=>ee(G,Object.assign(Object.assign({},z),{},{trailingComma:"none"})),oe=["^\\*"],W=["^\\(.+\\)$","^on-"],X=["^\\[.+\\]$","^bind(on)?-","^ng-(if|show|hide|class|style)$"],ue=["^i18n(-.+)?$"];if($(W))return Q(te(V(),{parser:"__ng_action"}));if($(X))return Q(te(V(),{parser:"__ng_binding"}));if($(ue)){let G=V().trim();return R(i(y(L,G)),!G.includes("@@"))}if($(oe))return Q(te(V(),{parser:"__ng_directive"}));let De=/{{(.+?)}}/s,ie=V();if(De.test(ie)){let G=[];for(let[z,U]of ie.split(De).entries())if(z%2===0)G.push(v(U));else try{G.push(s(["{{",r([u,te(U,{parser:"__ng_interpolation",__isInHtmlInterpolation:!0})]),u,"}}"]))}catch{G.push("{{",v(U),"}}")}return s(G)}}return null}function b(L,M,j,$){let V=L.getValue();switch(V.type){case"element":{if(k(V)||V.type==="interpolation")return;if(!V.isSelfClosing&&P(V,$)){let q=C(V,$);if(!q)return;let Y=N(V,$),H=/^\s*$/.test(Y),R="";return H||(R=j(D(Y),{parser:q,__embeddedInHtml:!0},{stripTrailingHardline:!0}),H=R===""),[h(V,$),s(w(L,$,M)),H?"":a,R,H?"":a,d(V,$),p(V,$)]}break}case"text":{if(k(V.parent)){let q=C(V.parent,$);if(q){let Y=q==="markdown"?g(V.value.replace(/^[^\S\n]*\n/,"")):V.value,H={parser:q,__embeddedInHtml:!0};if($.parser==="html"&&q==="babel"){let R="script",{attrMap:Q}=V.parent;Q&&(Q.type==="module"||Q.type==="text/babel"&&Q["data-type"]==="module")&&(R="module"),H.__babelSourceType=R}return[t,h(V,$),j(Y,H,{stripTrailingHardline:!0}),p(V,$)]}}else if(V.parent.type==="interpolation"){let q={__isInHtmlInterpolation:!0,__embeddedInHtml:!0};return $.parser==="angular"?(q.parser="__ng_interpolation",q.trailingComma="none"):$.parser==="vue"?q.parser=$.__should_parse_vue_template_with_ts?"__vue_ts_expression":"__vue_expression":q.parser="__js_expression",[r([u,j(V.value,q,{stripTrailingHardline:!0})]),V.parent.next&&f(V.parent.next)?" ":u]}break}case"attribute":{if(!V.value)break;if(/^PRETTIER_HTML_PLACEHOLDER_\d+_\d+_IN_JS$/.test($.originalText.slice(V.valueSpan.start.offset,V.valueSpan.end.offset)))return[V.rawName,"=",V.value];if($.parser==="lwc"&&/^{.*}$/s.test($.originalText.slice(V.valueSpan.start.offset,V.valueSpan.end.offset)))return[V.rawName,"=",V.value];let q=x(V,(Y,H)=>j(Y,Object.assign({__isInHtmlAttribute:!0,__embeddedInHtml:!0},H),{stripTrailingHardline:!0}),$);if(q)return[V.rawName,'="',s(c(q,Y=>typeof Y=="string"?Y.replace(/"/g,"&quot;"):Y)),'"'];break}case"front-matter":return m(V,j)}}n.exports=b}}),vo=Z({"src/language-html/print/children.js"(e,n){"use strict";re();var{builders:{breakParent:t,group:s,ifBreak:a,line:r,softline:u,hardline:i},utils:{replaceTextEndOfLine:o}}=Oe(),{locStart:c,locEnd:v}=Yn(),{forceBreakChildren:m,forceNextEmptyLine:d,isTextLikeNode:p,hasPrettierIgnore:f,preferHardlineAsLeadingSpaces:h}=qt(),{printOpeningTagPrefix:w,needsToBorrowNextOpeningTagStartMarker:T,printOpeningTagStartMarker:A,needsToBorrowPrevClosingTagEndMarker:S,printClosingTagEndMarker:B,printClosingTagSuffix:I,needsToBorrowParentClosingTagStartMarker:k}=er();function P(g,F,l){let E=g.getValue();return f(E)?[w(E,F),...o(F.originalText.slice(c(E)+(E.prev&&T(E.prev)?A(E).length:0),v(E)-(E.next&&S(E.next)?B(E,F).length:0))),I(E,F)]:l()}function C(g,F){return p(g)&&p(F)?g.isTrailingSpaceSensitive?g.hasTrailingSpaces?h(F)?i:r:"":h(F)?i:u:T(g)&&(f(F)||F.firstChild||F.isSelfClosing||F.type==="element"&&F.attrs.length>0)||g.type==="element"&&g.isSelfClosing&&S(F)?"":!F.isLeadingSpaceSensitive||h(F)||S(F)&&g.lastChild&&k(g.lastChild)&&g.lastChild.lastChild&&k(g.lastChild.lastChild)?i:F.hasLeadingSpaces?r:u}function D(g,F,l){let E=g.getValue();if(m(E))return[t,...g.map(N=>{let x=N.getValue(),b=x.prev?C(x.prev,x):"";return[b?[b,d(x.prev)?i:""]:"",P(N,F,l)]},"children")];let y=E.children.map(()=>Symbol(""));return g.map((N,x)=>{let b=N.getValue();if(p(b)){if(b.prev&&p(b.prev)){let Y=C(b.prev,b);if(Y)return d(b.prev)?[i,i,P(N,F,l)]:[Y,P(N,F,l)]}return P(N,F,l)}let L=[],M=[],j=[],$=[],V=b.prev?C(b.prev,b):"",q=b.next?C(b,b.next):"";return V&&(d(b.prev)?L.push(i,i):V===i?L.push(i):p(b.prev)?M.push(V):M.push(a("",u,{groupId:y[x-1]}))),q&&(d(b)?p(b.next)&&$.push(i,i):q===i?p(b.next)&&$.push(i):j.push(q)),[...L,s([...M,s([P(N,F,l),...j],{id:y[x]})]),...$]},"children")}n.exports={printChildren:D}}}),og=Z({"src/language-html/print/element.js"(e,n){"use strict";re();var{builders:{breakParent:t,dedentToRoot:s,group:a,ifBreak:r,indentIfBreak:u,indent:i,line:o,softline:c},utils:{replaceTextEndOfLine:v}}=Oe(),m=ho(),{shouldPreserveContent:d,isScriptLikeTag:p,isVueCustomBlock:f,countParents:h,forceBreakContent:w}=qt(),{printOpeningTagPrefix:T,printOpeningTag:A,printClosingTagSuffix:S,printClosingTag:B,needsToBorrowPrevClosingTagEndMarker:I,needsToBorrowLastChildClosingTagEndMarker:k}=er(),{printChildren:P}=vo();function C(D,g,F){let l=D.getValue();if(d(l,g))return[T(l,g),a(A(D,g,F)),...v(m(l,g)),...B(l,g),S(l,g)];let E=l.children.length===1&&l.firstChild.type==="interpolation"&&l.firstChild.isLeadingSpaceSensitive&&!l.firstChild.hasLeadingSpaces&&l.lastChild.isTrailingSpaceSensitive&&!l.lastChild.hasTrailingSpaces,y=Symbol("element-attr-group-id"),N=M=>a([a(A(D,g,F),{id:y}),M,B(l,g)]),x=M=>E?u(M,{groupId:y}):(p(l)||f(l,g))&&l.parent.type==="root"&&g.parser==="vue"&&!g.vueIndentScriptAndStyle?M:i(M),b=()=>E?r(c,"",{groupId:y}):l.firstChild.hasLeadingSpaces&&l.firstChild.isLeadingSpaceSensitive?o:l.firstChild.type==="text"&&l.isWhitespaceSensitive&&l.isIndentationSensitive?s(c):c,L=()=>(l.next?I(l.next):k(l.parent))?l.lastChild.hasTrailingSpaces&&l.lastChild.isTrailingSpaceSensitive?" ":"":E?r(c,"",{groupId:y}):l.lastChild.hasTrailingSpaces&&l.lastChild.isTrailingSpaceSensitive?o:(l.lastChild.type==="comment"||l.lastChild.type==="text"&&l.isWhitespaceSensitive&&l.isIndentationSensitive)&&new RegExp("\\n[\\t ]{".concat(g.tabWidth*h(D,j=>j.parent&&j.parent.type!=="root"),"}$")).test(l.lastChild.value)?"":c;return l.children.length===0?N(l.hasDanglingSpaces&&l.isDanglingSpaceSensitive?o:""):N([w(l)?t:"",x([b(),P(D,g,F)]),L()])}n.exports={printElement:C}}}),lg=Z({"src/language-html/printer-html.js"(e,n){"use strict";re();var{builders:{fill:t,group:s,hardline:a,literalline:r},utils:{cleanDoc:u,getDocParts:i,isConcat:o,replaceTextEndOfLine:c}}=Oe(),v=zd(),{countChars:m,unescapeQuoteEntities:d,getTextValueParts:p}=qt(),f=rg(),{insertPragma:h}=ng(),{locStart:w,locEnd:T}=Yn(),A=ag(),{printClosingTagSuffix:S,printClosingTagEnd:B,printOpeningTagPrefix:I,printOpeningTagStart:k}=er(),{printElement:P}=og(),{printChildren:C}=vo();function D(g,F,l){let E=g.getValue();switch(E.type){case"front-matter":return c(E.raw);case"root":return F.__onHtmlRoot&&F.__onHtmlRoot(E),[s(C(g,F,l)),a];case"element":case"ieConditionalComment":return P(g,F,l);case"ieConditionalStartComment":case"ieConditionalEndComment":return[k(E),B(E)];case"interpolation":return[k(E,F),...g.map(l,"children"),B(E,F)];case"text":{if(E.parent.type==="interpolation"){let N=/\n[^\S\n]*$/,x=N.test(E.value),b=x?E.value.replace(N,""):E.value;return[...c(b),x?a:""]}let y=u([I(E,F),...p(E),S(E,F)]);return o(y)||y.type==="fill"?t(i(y)):y}case"docType":return[s([k(E,F)," ",E.value.replace(/^html\b/i,"html").replace(/\s+/g," ")]),B(E,F)];case"comment":return[I(E,F),...c(F.originalText.slice(w(E),T(E)),r),S(E,F)];case"attribute":{if(E.value===null)return E.rawName;let y=d(E.value),N=m(y,"'"),x=m(y,'"'),b=N<x?"'":'"';return[E.rawName,"=",b,...c(b==='"'?y.replace(/"/g,"&quot;"):y.replace(/'/g,"&apos;")),b]}default:throw new Error("Unexpected node type ".concat(E.type))}}n.exports={preprocess:f,print:D,insertPragma:h,massageAstNode:v,embed:A}}}),cg=Z({"src/language-html/options.js"(e,n){"use strict";re();var t=Ot(),s="HTML";n.exports={bracketSameLine:t.bracketSameLine,htmlWhitespaceSensitivity:{since:"1.15.0",category:s,type:"choice",default:"css",description:"How to handle whitespaces in HTML.",choices:[{value:"css",description:"Respect the default value of CSS display property."},{value:"strict",description:"Whitespaces are considered sensitive."},{value:"ignore",description:"Whitespaces are considered insensitive."}]},singleAttributePerLine:t.singleAttributePerLine,vueIndentScriptAndStyle:{since:"1.19.0",category:s,type:"boolean",default:!1,description:"Indent script and style tags in Vue files."}}}}),pg=Z({"src/language-html/parsers.js"(){re()}}),xn=Z({"node_modules/linguist-languages/data/HTML.json"(e,n){n.exports={name:"HTML",type:"markup",tmScope:"text.html.basic",aceMode:"html",codemirrorMode:"htmlmixed",codemirrorMimeType:"text/html",color:"#e34c26",aliases:["xhtml"],extensions:[".html",".hta",".htm",".html.hl",".inc",".xht",".xhtml"],languageId:146}}}),fg=Z({"node_modules/linguist-languages/data/Vue.json"(e,n){n.exports={name:"Vue",type:"markup",color:"#41b883",extensions:[".vue"],tmScope:"text.html.vue",aceMode:"html",languageId:391}}}),Dg=Z({"src/language-html/index.js"(e,n){"use strict";re();var t=Bt(),s=lg(),a=cg(),r=pg(),u=[t(xn(),()=>({name:"Angular",since:"1.15.0",parsers:["angular"],vscodeLanguageIds:["html"],extensions:[".component.html"],filenames:[]})),t(xn(),o=>({since:"1.15.0",parsers:["html"],vscodeLanguageIds:["html"],extensions:[...o.extensions,".mjml"]})),t(xn(),()=>({name:"Lightning Web Components",since:"1.17.0",parsers:["lwc"],vscodeLanguageIds:["html"],extensions:[],filenames:[]})),t(fg(),()=>({since:"1.10.0",parsers:["vue"],vscodeLanguageIds:["vue"]}))],i={html:s};n.exports={languages:u,printers:i,options:a,parsers:r}}}),mg=Z({"src/language-yaml/pragma.js"(e,n){"use strict";re();function t(r){return/^\s*@(?:prettier|format)\s*$/.test(r)}function s(r){return/^\s*#[^\S\n]*@(?:prettier|format)\s*?(?:\n|$)/.test(r)}function a(r){return`# @format

`.concat(r)}n.exports={isPragma:t,hasPragma:s,insertPragma:a}}}),dg=Z({"src/language-yaml/loc.js"(e,n){"use strict";re();function t(a){return a.position.start.offset}function s(a){return a.position.end.offset}n.exports={locStart:t,locEnd:s}}}),gg=Z({"src/language-yaml/embed.js"(e,n){"use strict";re();function t(s,a,r,u){if(s.getValue().type==="root"&&u.filepath&&/(?:[/\\]|^)\.(?:prettier|stylelint)rc$/.test(u.filepath))return r(u.originalText,Object.assign(Object.assign({},u),{},{parser:"json"}))}n.exports=t}}),Mt=Z({"src/language-yaml/utils.js"(e,n){"use strict";re();var{getLast:t,isNonEmptyArray:s}=Ue();function a(C,D){let g=0,F=C.stack.length-1;for(let l=0;l<F;l++){let E=C.stack[l];r(E)&&D(E)&&g++}return g}function r(C,D){return C&&typeof C.type=="string"&&(!D||D.includes(C.type))}function u(C,D,g){return D("children"in C?Object.assign(Object.assign({},C),{},{children:C.children.map(F=>u(F,D,C))}):C,g)}function i(C,D,g){Object.defineProperty(C,D,{get:g,enumerable:!1})}function o(C,D){let g=0,F=D.length;for(let l=C.position.end.offset-1;l<F;l++){let E=D[l];if(E===`
`&&g++,g===1&&/\S/.test(E))return!1;if(g===2)return!0}return!1}function c(C){switch(C.getValue().type){case"tag":case"anchor":case"comment":return!1}let g=C.stack.length;for(let F=1;F<g;F++){let l=C.stack[F],E=C.stack[F-1];if(Array.isArray(E)&&typeof l=="number"&&l!==E.length-1)return!1}return!0}function v(C){return s(C.children)?v(t(C.children)):C}function m(C){return C.value.trim()==="prettier-ignore"}function d(C){let D=C.getValue();if(D.type==="documentBody"){let g=C.getParentNode();return S(g.head)&&m(t(g.head.endComments))}return h(D)&&m(t(D.leadingComments))}function p(C){return!s(C.children)&&!f(C)}function f(C){return h(C)||w(C)||T(C)||A(C)||S(C)}function h(C){return s(C==null?void 0:C.leadingComments)}function w(C){return s(C==null?void 0:C.middleComments)}function T(C){return C==null?void 0:C.indicatorComment}function A(C){return C==null?void 0:C.trailingComment}function S(C){return s(C==null?void 0:C.endComments)}function B(C){let D=[],g;for(let F of C.split(/( +)/))F!==" "?g===" "?D.push(F):D.push((D.pop()||"")+F):g===void 0&&D.unshift(""),g=F;return g===" "&&D.push((D.pop()||"")+" "),D[0]===""&&(D.shift(),D.unshift(" "+(D.shift()||""))),D}function I(C,D,g){let F=D.split(`
`).map((l,E,y)=>E===0&&E===y.length-1?l:E!==0&&E!==y.length-1?l.trim():E===0?l.trimEnd():l.trimStart());return g.proseWrap==="preserve"?F.map(l=>l.length===0?[]:[l]):F.map(l=>l.length===0?[]:B(l)).reduce((l,E,y)=>y!==0&&F[y-1].length>0&&E.length>0&&!(C==="quoteDouble"&&t(t(l)).endsWith("\\"))?[...l.slice(0,-1),[...t(l),...E]]:[...l,E],[]).map(l=>g.proseWrap==="never"?[l.join(" ")]:l)}function k(C,D){let{parentIndent:g,isLastDescendant:F,options:l}=D,E=C.position.start.line===C.position.end.line?"":l.originalText.slice(C.position.start.offset,C.position.end.offset).match(/^[^\n]*\n(.*)$/s)[1],y;if(C.indent===null){let b=E.match(/^(?<leadingSpace> *)[^\n\r ]/m);y=b?b.groups.leadingSpace.length:Number.POSITIVE_INFINITY}else y=C.indent-1+g;let N=E.split(`
`).map(b=>b.slice(y));if(l.proseWrap==="preserve"||C.type==="blockLiteral")return x(N.map(b=>b.length===0?[]:[b]));return x(N.map(b=>b.length===0?[]:B(b)).reduce((b,L,M)=>M!==0&&N[M-1].length>0&&L.length>0&&!/^\s/.test(L[0])&&!/^\s|\s$/.test(t(b))?[...b.slice(0,-1),[...t(b),...L]]:[...b,L],[]).map(b=>b.reduce((L,M)=>L.length>0&&/\s$/.test(t(L))?[...L.slice(0,-1),t(L)+" "+M]:[...L,M],[])).map(b=>l.proseWrap==="never"?[b.join(" ")]:b));function x(b){if(C.chomping==="keep")return t(b).length===0?b.slice(0,-1):b;let L=0;for(let M=b.length-1;M>=0&&b[M].length===0;M--)L++;return L===0?b:L>=2&&!F?b.slice(0,-(L-1)):b.slice(0,-L)}}function P(C){if(!C)return!0;switch(C.type){case"plain":case"quoteDouble":case"quoteSingle":case"alias":case"flowMapping":case"flowSequence":return!0;default:return!1}}n.exports={getLast:t,getAncestorCount:a,isNode:r,isEmptyNode:p,isInlineNode:P,mapNode:u,defineShortcut:i,isNextLineEmpty:o,isLastDescendantNode:c,getBlockValueLineContents:k,getFlowScalarLineContents:I,getLastDescendantNode:v,hasPrettierIgnore:d,hasLeadingComments:h,hasMiddleComments:w,hasIndicatorComment:T,hasTrailingComment:A,hasEndComments:S}}}),yg=Z({"src/language-yaml/print-preprocess.js"(e,n){"use strict";re();var{defineShortcut:t,mapNode:s}=Mt();function a(u){return s(u,r)}function r(u){switch(u.type){case"document":t(u,"head",()=>u.children[0]),t(u,"body",()=>u.children[1]);break;case"documentBody":case"sequenceItem":case"flowSequenceItem":case"mappingKey":case"mappingValue":t(u,"content",()=>u.children[0]);break;case"mappingItem":case"flowMappingItem":t(u,"key",()=>u.children[0]),t(u,"value",()=>u.children[1]);break}return u}n.exports=a}}),jr=Z({"src/language-yaml/print/misc.js"(e,n){"use strict";re();var{builders:{softline:t,align:s}}=Oe(),{hasEndComments:a,isNextLineEmpty:r,isNode:u}=Mt(),i=new WeakMap;function o(m,d){let p=m.getValue(),f=m.stack[0],h;return i.has(f)?h=i.get(f):(h=new Set,i.set(f,h)),!h.has(p.position.end.line)&&(h.add(p.position.end.line),r(p,d)&&!c(m.getParentNode()))?t:""}function c(m){return a(m)&&!u(m,["documentHead","documentBody","flowMapping","flowSequence"])}function v(m,d){return s(" ".repeat(m),d)}n.exports={alignWithSpaces:v,shouldPrintEndComments:c,printNextEmptyLine:o}}}),hg=Z({"src/language-yaml/print/flow-mapping-sequence.js"(e,n){"use strict";re();var{builders:{ifBreak:t,line:s,softline:a,hardline:r,join:u}}=Oe(),{isEmptyNode:i,getLast:o,hasEndComments:c}=Mt(),{printNextEmptyLine:v,alignWithSpaces:m}=jr();function d(f,h,w){let T=f.getValue(),A=T.type==="flowMapping",S=A?"{":"[",B=A?"}":"]",I=a;A&&T.children.length>0&&w.bracketSpacing&&(I=s);let k=o(T.children),P=k&&k.type==="flowMappingItem"&&i(k.key)&&i(k.value);return[S,m(w.tabWidth,[I,p(f,h,w),w.trailingComma==="none"?"":t(","),c(T)?[r,u(r,f.map(h,"endComments"))]:""]),P?"":I,B]}function p(f,h,w){let T=f.getValue();return f.map((S,B)=>[h(),B===T.children.length-1?"":[",",s,T.children[B].position.start.line!==T.children[B+1].position.start.line?v(S,w.originalText):""]],"children")}n.exports={printFlowMapping:d,printFlowSequence:d}}}),vg=Z({"src/language-yaml/print/mapping-item.js"(e,n){"use strict";re();var{builders:{conditionalGroup:t,group:s,hardline:a,ifBreak:r,join:u,line:i}}=Oe(),{hasLeadingComments:o,hasMiddleComments:c,hasTrailingComment:v,hasEndComments:m,isNode:d,isEmptyNode:p,isInlineNode:f}=Mt(),{alignWithSpaces:h}=jr();function w(B,I,k,P,C){let{key:D,value:g}=B,F=p(D),l=p(g);if(F&&l)return": ";let E=P("key"),y=A(B)?" ":"";if(l)return B.type==="flowMappingItem"&&I.type==="flowMapping"?E:B.type==="mappingItem"&&T(D.content,C)&&!v(D.content)&&(!I.tag||I.tag.value!=="tag:yaml.org,2002:set")?[E,y,":"]:["? ",h(2,E)];let N=P("value");if(F)return[": ",h(2,N)];if(o(g)||!f(D.content))return["? ",h(2,E),a,u("",k.map(P,"value","leadingComments").map($=>[$,a])),": ",h(2,N)];if(S(D.content)&&!o(D.content)&&!c(D.content)&&!v(D.content)&&!m(D)&&!o(g.content)&&!c(g.content)&&!m(g)&&T(g.content,C))return[E,y,": ",N];let x=Symbol("mappingKey"),b=s([r("? "),s(h(2,E),{id:x})]),L=[a,": ",h(2,N)],M=[y,":"];o(g.content)||m(g)&&g.content&&!d(g.content,["mapping","sequence"])||I.type==="mapping"&&v(D.content)&&f(g.content)||d(g.content,["mapping","sequence"])&&g.content.tag===null&&g.content.anchor===null?M.push(a):g.content&&M.push(i),M.push(N);let j=h(C.tabWidth,M);return T(D.content,C)&&!o(D.content)&&!c(D.content)&&!m(D)?t([[E,j]]):t([[b,r(L,j,{groupId:x})]])}function T(B,I){if(!B)return!0;switch(B.type){case"plain":case"quoteSingle":case"quoteDouble":break;case"alias":return!0;default:return!1}if(I.proseWrap==="preserve")return B.position.start.line===B.position.end.line;if(/\\$/m.test(I.originalText.slice(B.position.start.offset,B.position.end.offset)))return!1;switch(I.proseWrap){case"never":return!B.value.includes(`
`);case"always":return!/[\n ]/.test(B.value);default:return!1}}function A(B){return B.key.content&&B.key.content.type==="alias"}function S(B){if(!B)return!0;switch(B.type){case"plain":case"quoteDouble":case"quoteSingle":return B.position.start.line===B.position.end.line;case"alias":return!0;default:return!1}}n.exports=w}}),Cg=Z({"src/language-yaml/print/block.js"(e,n){"use strict";re();var{builders:{dedent:t,dedentToRoot:s,fill:a,hardline:r,join:u,line:i,literalline:o,markAsRoot:c},utils:{getDocParts:v}}=Oe(),{getAncestorCount:m,getBlockValueLineContents:d,hasIndicatorComment:p,isLastDescendantNode:f,isNode:h}=Mt(),{alignWithSpaces:w}=jr();function T(A,S,B){let I=A.getValue(),k=m(A,F=>h(F,["sequence","mapping"])),P=f(A),C=[I.type==="blockFolded"?">":"|"];I.indent!==null&&C.push(I.indent.toString()),I.chomping!=="clip"&&C.push(I.chomping==="keep"?"+":"-"),p(I)&&C.push(" ",S("indicatorComment"));let D=d(I,{parentIndent:k,isLastDescendant:P,options:B}),g=[];for(let[F,l]of D.entries())F===0&&g.push(r),g.push(a(v(u(i,l)))),F!==D.length-1?g.push(l.length===0?r:c(o)):I.chomping==="keep"&&P&&g.push(s(l.length===0?r:o));return I.indent===null?C.push(t(w(B.tabWidth,g))):C.push(s(w(I.indent-1+k,g))),C}n.exports=T}}),Eg=Z({"src/language-yaml/printer-yaml.js"(e,n){"use strict";re();var{builders:{breakParent:t,fill:s,group:a,hardline:r,join:u,line:i,lineSuffix:o,literalline:c},utils:{getDocParts:v,replaceTextEndOfLine:m}}=Oe(),{isPreviousLineEmpty:d}=Ue(),{insertPragma:p,isPragma:f}=mg(),{locStart:h}=dg(),w=gg(),{getFlowScalarLineContents:T,getLastDescendantNode:A,hasLeadingComments:S,hasMiddleComments:B,hasTrailingComment:I,hasEndComments:k,hasPrettierIgnore:P,isLastDescendantNode:C,isNode:D,isInlineNode:g}=Mt(),F=yg(),{alignWithSpaces:l,printNextEmptyLine:E,shouldPrintEndComments:y}=jr(),{printFlowMapping:N,printFlowSequence:x}=hg(),b=vg(),L=Cg();function M(R,Q,ee){let te=R.getValue(),oe=[];te.type!=="mappingValue"&&S(te)&&oe.push([u(r,R.map(ee,"leadingComments")),r]);let{tag:W,anchor:X}=te;W&&oe.push(ee("tag")),W&&X&&oe.push(" "),X&&oe.push(ee("anchor"));let ue="";D(te,["mapping","sequence","comment","directive","mappingItem","sequenceItem"])&&!C(R)&&(ue=E(R,Q.originalText)),(W||X)&&(D(te,["sequence","mapping"])&&!B(te)?oe.push(r):oe.push(" ")),B(te)&&oe.push([te.middleComments.length===1?"":r,u(r,R.map(ee,"middleComments")),r]);let De=R.getParentNode();return P(R)?oe.push(m(Q.originalText.slice(te.position.start.offset,te.position.end.offset).trimEnd(),c)):oe.push(a(j(te,De,R,Q,ee))),I(te)&&!D(te,["document","documentHead"])&&oe.push(o([te.type==="mappingValue"&&!te.content?"":" ",De.type==="mappingKey"&&R.getParentNode(2).type==="mapping"&&g(te)?"":t,ee("trailingComment")])),y(te)&&oe.push(l(te.type==="sequenceItem"?2:0,[r,u(r,R.map(ie=>[d(Q.originalText,ie.getValue(),h)?r:"",ee()],"endComments"))])),oe.push(ue),oe}function j(R,Q,ee,te,oe){switch(R.type){case"root":{let{children:W}=R,X=[];ee.each((De,ie)=>{let G=W[ie],z=W[ie+1];ie!==0&&X.push(r),X.push(oe()),V(G,z)?(X.push(r,"..."),I(G)&&X.push(" ",oe("trailingComment"))):z&&!I(z.head)&&X.push(r,"---")},"children");let ue=A(R);return(!D(ue,["blockLiteral","blockFolded"])||ue.chomping!=="keep")&&X.push(r),X}case"document":{let W=Q.children[ee.getName()+1],X=[];return q(R,W,Q,te)==="head"&&((R.head.children.length>0||R.head.endComments.length>0)&&X.push(oe("head")),I(R.head)?X.push(["---"," ",oe(["head","trailingComment"])]):X.push("---")),$(R)&&X.push(oe("body")),u(r,X)}case"documentHead":return u(r,[...ee.map(oe,"children"),...ee.map(oe,"endComments")]);case"documentBody":{let{children:W,endComments:X}=R,ue="";if(W.length>0&&X.length>0){let De=A(R);D(De,["blockFolded","blockLiteral"])?De.chomping!=="keep"&&(ue=[r,r]):ue=r}return[u(r,ee.map(oe,"children")),ue,u(r,ee.map(oe,"endComments"))]}case"directive":return["%",u(" ",[R.name,...R.parameters])];case"comment":return["#",R.value];case"alias":return["*",R.value];case"tag":return te.originalText.slice(R.position.start.offset,R.position.end.offset);case"anchor":return["&",R.value];case"plain":return Y(R.type,te.originalText.slice(R.position.start.offset,R.position.end.offset),te);case"quoteDouble":case"quoteSingle":{let W="'",X='"',ue=te.originalText.slice(R.position.start.offset+1,R.position.end.offset-1);if(R.type==="quoteSingle"&&ue.includes("\\")||R.type==="quoteDouble"&&/\\[^"]/.test(ue)){let ie=R.type==="quoteDouble"?X:W;return[ie,Y(R.type,ue,te),ie]}if(ue.includes(X))return[W,Y(R.type,R.type==="quoteDouble"?ue.replace(/\\"/g,X).replace(/'/g,W.repeat(2)):ue,te),W];if(ue.includes(W))return[X,Y(R.type,R.type==="quoteSingle"?ue.replace(/''/g,W):ue,te),X];let De=te.singleQuote?W:X;return[De,Y(R.type,ue,te),De]}case"blockFolded":case"blockLiteral":return L(ee,oe,te);case"mapping":case"sequence":return u(r,ee.map(oe,"children"));case"sequenceItem":return["- ",l(2,R.content?oe("content"):"")];case"mappingKey":case"mappingValue":return R.content?oe("content"):"";case"mappingItem":case"flowMappingItem":return b(R,Q,ee,oe,te);case"flowMapping":return N(ee,oe,te);case"flowSequence":return x(ee,oe,te);case"flowSequenceItem":return oe("content");default:throw new Error("Unexpected node type ".concat(R.type))}}function $(R){return R.body.children.length>0||k(R.body)}function V(R,Q){return I(R)||Q&&(Q.head.children.length>0||k(Q.head))}function q(R,Q,ee,te){return ee.children[0]===R&&/---(?:\s|$)/.test(te.originalText.slice(h(R),h(R)+4))||R.head.children.length>0||k(R.head)||I(R.head)?"head":V(R,Q)?!1:Q?"root":!1}function Y(R,Q,ee){let te=T(R,Q,ee);return u(r,te.map(oe=>s(v(u(i,oe)))))}function H(R,Q){if(D(Q))switch(delete Q.position,Q.type){case"comment":if(f(Q.value))return null;break;case"quoteDouble":case"quoteSingle":Q.type="quote";break}}n.exports={preprocess:F,embed:w,print:M,massageAstNode:H,insertPragma:p}}}),Fg=Z({"src/language-yaml/options.js"(e,n){"use strict";re();var t=Ot();n.exports={bracketSpacing:t.bracketSpacing,singleQuote:t.singleQuote,proseWrap:t.proseWrap}}}),Ag=Z({"src/language-yaml/parsers.js"(){re()}}),Sg=Z({"node_modules/linguist-languages/data/YAML.json"(e,n){n.exports={name:"YAML",type:"data",color:"#cb171e",tmScope:"source.yaml",aliases:["yml"],extensions:[".yml",".mir",".reek",".rviz",".sublime-syntax",".syntax",".yaml",".yaml-tmlanguage",".yaml.sed",".yml.mysql"],filenames:[".clang-format",".clang-tidy",".gemrc","CITATION.cff","glide.lock","yarn.lock"],aceMode:"yaml",codemirrorMode:"yaml",codemirrorMimeType:"text/x-yaml",languageId:407}}}),xg=Z({"src/language-yaml/index.js"(e,n){"use strict";re();var t=Bt(),s=Eg(),a=Fg(),r=Ag(),u=[t(Sg(),i=>({since:"1.14.0",parsers:["yaml"],vscodeLanguageIds:["yaml","ansible","home-assistant"],filenames:[...i.filenames.filter(o=>o!=="yarn.lock"),".prettierrc",".stylelintrc"]}))];n.exports={languages:u,printers:{yaml:s},options:a,parsers:r}}}),bg=Z({"src/languages.js"(e,n){"use strict";re(),n.exports=[id(),Sd(),Pd(),Md(),Ud(),Dg(),xg()]}});re();var{version:Tg}=ya(),kt=Sm(),{getSupportInfo:Bg}=Mn(),Ng=xm(),wg=bg(),_g=Oe();function bt(e){let n=arguments.length>1&&arguments[1]!==void 0?arguments[1]:1;return function(){for(var t=arguments.length,s=new Array(t),a=0;a<t;a++)s[a]=arguments[a];let r=s[n]||{},u=r.plugins||[];return s[n]=Object.assign(Object.assign({},r),{},{plugins:[...wg,...Array.isArray(u)?u:Object.values(u)]}),e(...s)}}var bn=bt(kt.formatWithCursor);Co.exports={formatWithCursor:bn,format(e,n){return bn(e,n).formatted},check(e,n){let{formatted:t}=bn(e,n);return t===e},doc:_g,getSupportInfo:bt(Bg,0),version:Tg,util:Ng,__debug:{parse:bt(kt.parse),formatAST:bt(kt.formatAST),formatDoc:bt(kt.formatDoc),printToDoc:bt(kt.printToDoc),printDocToString:bt(kt.printDocToString)}}});return Pg();});

            /***/ }),

        /***/ 5666:
        /***/ ((module) => {

            /**
             * Copyright (c) 2014-present, Facebook, Inc.
             *
             * This source code is licensed under the MIT license found in the
             * LICENSE file in the root directory of this source tree.
             */

            var runtime = (function (exports) {
                "use strict";

                var Op = Object.prototype;
                var hasOwn = Op.hasOwnProperty;
                var undefined; // More compressible than void 0.
                var $Symbol = typeof Symbol === "function" ? Symbol : {};
                var iteratorSymbol = $Symbol.iterator || "@@iterator";
                var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
                var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

                function define(obj, key, value) {
                    Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: true,
                        configurable: true,
                        writable: true
                    });
                    return obj[key];
                }
                try {
                    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
                    define({}, "");
                } catch (err) {
                    define = function(obj, key, value) {
                        return obj[key] = value;
                    };
                }

                function wrap(innerFn, outerFn, self, tryLocsList) {
                    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
                    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
                    var generator = Object.create(protoGenerator.prototype);
                    var context = new Context(tryLocsList || []);

                    // The ._invoke method unifies the implementations of the .next,
                    // .throw, and .return methods.
                    generator._invoke = makeInvokeMethod(innerFn, self, context);

                    return generator;
                }
                exports.wrap = wrap;

                // Try/catch helper to minimize deoptimizations. Returns a completion
                // record like context.tryEntries[i].completion. This interface could
                // have been (and was previously) designed to take a closure to be
                // invoked without arguments, but in all the cases we care about we
                // already have an existing method we want to call, so there's no need
                // to create a new function object. We can even get away with assuming
                // the method takes exactly one argument, since that happens to be true
                // in every case, so we don't have to touch the arguments object. The
                // only additional allocation required is the completion record, which
                // has a stable shape and so hopefully should be cheap to allocate.
                function tryCatch(fn, obj, arg) {
                    try {
                        return { type: "normal", arg: fn.call(obj, arg) };
                    } catch (err) {
                        return { type: "throw", arg: err };
                    }
                }

                var GenStateSuspendedStart = "suspendedStart";
                var GenStateSuspendedYield = "suspendedYield";
                var GenStateExecuting = "executing";
                var GenStateCompleted = "completed";

                // Returning this object from the innerFn has the same effect as
                // breaking out of the dispatch switch statement.
                var ContinueSentinel = {};

                // Dummy constructor functions that we use as the .constructor and
                // .constructor.prototype properties for functions that return Generator
                // objects. For full spec compliance, you may wish to configure your
                // minifier not to mangle the names of these two functions.
                function Generator() {}
                function GeneratorFunction() {}
                function GeneratorFunctionPrototype() {}

                // This is a polyfill for %IteratorPrototype% for environments that
                // don't natively support it.
                var IteratorPrototype = {};
                define(IteratorPrototype, iteratorSymbol, function () {
                    return this;
                });

                var getProto = Object.getPrototypeOf;
                var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
                if (NativeIteratorPrototype &&
                    NativeIteratorPrototype !== Op &&
                    hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
                    // This environment has a native %IteratorPrototype%; use it instead
                    // of the polyfill.
                    IteratorPrototype = NativeIteratorPrototype;
                }

                var Gp = GeneratorFunctionPrototype.prototype =
                    Generator.prototype = Object.create(IteratorPrototype);
                GeneratorFunction.prototype = GeneratorFunctionPrototype;
                define(Gp, "constructor", GeneratorFunctionPrototype);
                define(GeneratorFunctionPrototype, "constructor", GeneratorFunction);
                GeneratorFunction.displayName = define(
                    GeneratorFunctionPrototype,
                    toStringTagSymbol,
                    "GeneratorFunction"
                );

                // Helper for defining the .next, .throw, and .return methods of the
                // Iterator interface in terms of a single ._invoke method.
                function defineIteratorMethods(prototype) {
                    ["next", "throw", "return"].forEach(function(method) {
                        define(prototype, method, function(arg) {
                            return this._invoke(method, arg);
                        });
                    });
                }

                exports.isGeneratorFunction = function(genFun) {
                    var ctor = typeof genFun === "function" && genFun.constructor;
                    return ctor
                        ? ctor === GeneratorFunction ||
                        // For the native GeneratorFunction constructor, the best we can
                        // do is to check its .name property.
                        (ctor.displayName || ctor.name) === "GeneratorFunction"
                        : false;
                };

                exports.mark = function(genFun) {
                    if (Object.setPrototypeOf) {
                        Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
                    } else {
                        genFun.__proto__ = GeneratorFunctionPrototype;
                        define(genFun, toStringTagSymbol, "GeneratorFunction");
                    }
                    genFun.prototype = Object.create(Gp);
                    return genFun;
                };

                // Within the body of any async function, `await x` is transformed to
                // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
                // `hasOwn.call(value, "__await")` to determine if the yielded value is
                // meant to be awaited.
                exports.awrap = function(arg) {
                    return { __await: arg };
                };

                function AsyncIterator(generator, PromiseImpl) {
                    function invoke(method, arg, resolve, reject) {
                        var record = tryCatch(generator[method], generator, arg);
                        if (record.type === "throw") {
                            reject(record.arg);
                        } else {
                            var result = record.arg;
                            var value = result.value;
                            if (value &&
                                typeof value === "object" &&
                                hasOwn.call(value, "__await")) {
                                return PromiseImpl.resolve(value.__await).then(function(value) {
                                    invoke("next", value, resolve, reject);
                                }, function(err) {
                                    invoke("throw", err, resolve, reject);
                                });
                            }

                            return PromiseImpl.resolve(value).then(function(unwrapped) {
                                // When a yielded Promise is resolved, its final value becomes
                                // the .value of the Promise<{value,done}> result for the
                                // current iteration.
                                result.value = unwrapped;
                                resolve(result);
                            }, function(error) {
                                // If a rejected Promise was yielded, throw the rejection back
                                // into the async generator function so it can be handled there.
                                return invoke("throw", error, resolve, reject);
                            });
                        }
                    }

                    var previousPromise;

                    function enqueue(method, arg) {
                        function callInvokeWithMethodAndArg() {
                            return new PromiseImpl(function(resolve, reject) {
                                invoke(method, arg, resolve, reject);
                            });
                        }

                        return previousPromise =
                            // If enqueue has been called before, then we want to wait until
                            // all previous Promises have been resolved before calling invoke,
                            // so that results are always delivered in the correct order. If
                            // enqueue has not been called before, then it is important to
                            // call invoke immediately, without waiting on a callback to fire,
                            // so that the async generator function has the opportunity to do
                            // any necessary setup in a predictable way. This predictability
                            // is why the Promise constructor synchronously invokes its
                            // executor callback, and why async functions synchronously
                            // execute code before the first await. Since we implement simple
                            // async functions in terms of async generators, it is especially
                            // important to get this right, even though it requires care.
                            previousPromise ? previousPromise.then(
                                callInvokeWithMethodAndArg,
                                // Avoid propagating failures to Promises returned by later
                                // invocations of the iterator.
                                callInvokeWithMethodAndArg
                            ) : callInvokeWithMethodAndArg();
                    }

                    // Define the unified helper method that is used to implement .next,
                    // .throw, and .return (see defineIteratorMethods).
                    this._invoke = enqueue;
                }

                defineIteratorMethods(AsyncIterator.prototype);
                define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
                    return this;
                });
                exports.AsyncIterator = AsyncIterator;

                // Note that simple async functions are implemented on top of
                // AsyncIterator objects; they just return a Promise for the value of
                // the final result produced by the iterator.
                exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
                    if (PromiseImpl === void 0) PromiseImpl = Promise;

                    var iter = new AsyncIterator(
                        wrap(innerFn, outerFn, self, tryLocsList),
                        PromiseImpl
                    );

                    return exports.isGeneratorFunction(outerFn)
                        ? iter // If outerFn is a generator, return the full iterator.
                        : iter.next().then(function(result) {
                            return result.done ? result.value : iter.next();
                        });
                };

                function makeInvokeMethod(innerFn, self, context) {
                    var state = GenStateSuspendedStart;

                    return function invoke(method, arg) {
                        if (state === GenStateExecuting) {
                            throw new Error("Generator is already running");
                        }

                        if (state === GenStateCompleted) {
                            if (method === "throw") {
                                throw arg;
                            }

                            // Be forgiving, per 25.3.3.3.3 of the spec:
                            // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
                            return doneResult();
                        }

                        context.method = method;
                        context.arg = arg;

                        while (true) {
                            var delegate = context.delegate;
                            if (delegate) {
                                var delegateResult = maybeInvokeDelegate(delegate, context);
                                if (delegateResult) {
                                    if (delegateResult === ContinueSentinel) continue;
                                    return delegateResult;
                                }
                            }

                            if (context.method === "next") {
                                // Setting context._sent for legacy support of Babel's
                                // function.sent implementation.
                                context.sent = context._sent = context.arg;

                            } else if (context.method === "throw") {
                                if (state === GenStateSuspendedStart) {
                                    state = GenStateCompleted;
                                    throw context.arg;
                                }

                                context.dispatchException(context.arg);

                            } else if (context.method === "return") {
                                context.abrupt("return", context.arg);
                            }

                            state = GenStateExecuting;

                            var record = tryCatch(innerFn, self, context);
                            if (record.type === "normal") {
                                // If an exception is thrown from innerFn, we leave state ===
                                // GenStateExecuting and loop back for another invocation.
                                state = context.done
                                    ? GenStateCompleted
                                    : GenStateSuspendedYield;

                                if (record.arg === ContinueSentinel) {
                                    continue;
                                }

                                return {
                                    value: record.arg,
                                    done: context.done
                                };

                            } else if (record.type === "throw") {
                                state = GenStateCompleted;
                                // Dispatch the exception by looping back around to the
                                // context.dispatchException(context.arg) call above.
                                context.method = "throw";
                                context.arg = record.arg;
                            }
                        }
                    };
                }

                // Call delegate.iterator[context.method](context.arg) and handle the
                // result, either by returning a { value, done } result from the
                // delegate iterator, or by modifying context.method and context.arg,
                // setting context.delegate to null, and returning the ContinueSentinel.
                function maybeInvokeDelegate(delegate, context) {
                    var method = delegate.iterator[context.method];
                    if (method === undefined) {
                        // A .throw or .return when the delegate iterator has no .throw
                        // method always terminates the yield* loop.
                        context.delegate = null;

                        if (context.method === "throw") {
                            // Note: ["return"] must be used for ES3 parsing compatibility.
                            if (delegate.iterator["return"]) {
                                // If the delegate iterator has a return method, give it a
                                // chance to clean up.
                                context.method = "return";
                                context.arg = undefined;
                                maybeInvokeDelegate(delegate, context);

                                if (context.method === "throw") {
                                    // If maybeInvokeDelegate(context) changed context.method from
                                    // "return" to "throw", let that override the TypeError below.
                                    return ContinueSentinel;
                                }
                            }

                            context.method = "throw";
                            context.arg = new TypeError(
                                "The iterator does not provide a 'throw' method");
                        }

                        return ContinueSentinel;
                    }

                    var record = tryCatch(method, delegate.iterator, context.arg);

                    if (record.type === "throw") {
                        context.method = "throw";
                        context.arg = record.arg;
                        context.delegate = null;
                        return ContinueSentinel;
                    }

                    var info = record.arg;

                    if (! info) {
                        context.method = "throw";
                        context.arg = new TypeError("iterator result is not an object");
                        context.delegate = null;
                        return ContinueSentinel;
                    }

                    if (info.done) {
                        // Assign the result of the finished delegate to the temporary
                        // variable specified by delegate.resultName (see delegateYield).
                        context[delegate.resultName] = info.value;

                        // Resume execution at the desired location (see delegateYield).
                        context.next = delegate.nextLoc;

                        // If context.method was "throw" but the delegate handled the
                        // exception, let the outer generator proceed normally. If
                        // context.method was "next", forget context.arg since it has been
                        // "consumed" by the delegate iterator. If context.method was
                        // "return", allow the original .return call to continue in the
                        // outer generator.
                        if (context.method !== "return") {
                            context.method = "next";
                            context.arg = undefined;
                        }

                    } else {
                        // Re-yield the result returned by the delegate method.
                        return info;
                    }

                    // The delegate iterator is finished, so forget it and continue with
                    // the outer generator.
                    context.delegate = null;
                    return ContinueSentinel;
                }

                // Define Generator.prototype.{next,throw,return} in terms of the
                // unified ._invoke helper method.
                defineIteratorMethods(Gp);

                define(Gp, toStringTagSymbol, "Generator");

                // A Generator should always return itself as the iterator object when the
                // @@iterator function is called on it. Some browsers' implementations of the
                // iterator prototype chain incorrectly implement this, causing the Generator
                // object to not be returned from this call. This ensures that doesn't happen.
                // See https://github.com/facebook/regenerator/issues/274 for more details.
                define(Gp, iteratorSymbol, function() {
                    return this;
                });

                define(Gp, "toString", function() {
                    return "[object Generator]";
                });

                function pushTryEntry(locs) {
                    var entry = { tryLoc: locs[0] };

                    if (1 in locs) {
                        entry.catchLoc = locs[1];
                    }

                    if (2 in locs) {
                        entry.finallyLoc = locs[2];
                        entry.afterLoc = locs[3];
                    }

                    this.tryEntries.push(entry);
                }

                function resetTryEntry(entry) {
                    var record = entry.completion || {};
                    record.type = "normal";
                    delete record.arg;
                    entry.completion = record;
                }

                function Context(tryLocsList) {
                    // The root entry object (effectively a try statement without a catch
                    // or a finally block) gives us a place to store values thrown from
                    // locations where there is no enclosing try statement.
                    this.tryEntries = [{ tryLoc: "root" }];
                    tryLocsList.forEach(pushTryEntry, this);
                    this.reset(true);
                }

                exports.keys = function(object) {
                    var keys = [];
                    for (var key in object) {
                        keys.push(key);
                    }
                    keys.reverse();

                    // Rather than returning an object with a next method, we keep
                    // things simple and return the next function itself.
                    return function next() {
                        while (keys.length) {
                            var key = keys.pop();
                            if (key in object) {
                                next.value = key;
                                next.done = false;
                                return next;
                            }
                        }

                        // To avoid creating an additional object, we just hang the .value
                        // and .done properties off the next function object itself. This
                        // also ensures that the minifier will not anonymize the function.
                        next.done = true;
                        return next;
                    };
                };

                function values(iterable) {
                    if (iterable) {
                        var iteratorMethod = iterable[iteratorSymbol];
                        if (iteratorMethod) {
                            return iteratorMethod.call(iterable);
                        }

                        if (typeof iterable.next === "function") {
                            return iterable;
                        }

                        if (!isNaN(iterable.length)) {
                            var i = -1, next = function next() {
                                while (++i < iterable.length) {
                                    if (hasOwn.call(iterable, i)) {
                                        next.value = iterable[i];
                                        next.done = false;
                                        return next;
                                    }
                                }

                                next.value = undefined;
                                next.done = true;

                                return next;
                            };

                            return next.next = next;
                        }
                    }

                    // Return an iterator with no values.
                    return { next: doneResult };
                }
                exports.values = values;

                function doneResult() {
                    return { value: undefined, done: true };
                }

                Context.prototype = {
                    constructor: Context,

                    reset: function(skipTempReset) {
                        this.prev = 0;
                        this.next = 0;
                        // Resetting context._sent for legacy support of Babel's
                        // function.sent implementation.
                        this.sent = this._sent = undefined;
                        this.done = false;
                        this.delegate = null;

                        this.method = "next";
                        this.arg = undefined;

                        this.tryEntries.forEach(resetTryEntry);

                        if (!skipTempReset) {
                            for (var name in this) {
                                // Not sure about the optimal order of these conditions:
                                if (name.charAt(0) === "t" &&
                                    hasOwn.call(this, name) &&
                                    !isNaN(+name.slice(1))) {
                                    this[name] = undefined;
                                }
                            }
                        }
                    },

                    stop: function() {
                        this.done = true;

                        var rootEntry = this.tryEntries[0];
                        var rootRecord = rootEntry.completion;
                        if (rootRecord.type === "throw") {
                            throw rootRecord.arg;
                        }

                        return this.rval;
                    },

                    dispatchException: function(exception) {
                        if (this.done) {
                            throw exception;
                        }

                        var context = this;
                        function handle(loc, caught) {
                            record.type = "throw";
                            record.arg = exception;
                            context.next = loc;

                            if (caught) {
                                // If the dispatched exception was caught by a catch block,
                                // then let that catch block handle the exception normally.
                                context.method = "next";
                                context.arg = undefined;
                            }

                            return !! caught;
                        }

                        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                            var entry = this.tryEntries[i];
                            var record = entry.completion;

                            if (entry.tryLoc === "root") {
                                // Exception thrown outside of any try block that could handle
                                // it, so set the completion value of the entire function to
                                // throw the exception.
                                return handle("end");
                            }

                            if (entry.tryLoc <= this.prev) {
                                var hasCatch = hasOwn.call(entry, "catchLoc");
                                var hasFinally = hasOwn.call(entry, "finallyLoc");

                                if (hasCatch && hasFinally) {
                                    if (this.prev < entry.catchLoc) {
                                        return handle(entry.catchLoc, true);
                                    } else if (this.prev < entry.finallyLoc) {
                                        return handle(entry.finallyLoc);
                                    }

                                } else if (hasCatch) {
                                    if (this.prev < entry.catchLoc) {
                                        return handle(entry.catchLoc, true);
                                    }

                                } else if (hasFinally) {
                                    if (this.prev < entry.finallyLoc) {
                                        return handle(entry.finallyLoc);
                                    }

                                } else {
                                    throw new Error("try statement without catch or finally");
                                }
                            }
                        }
                    },

                    abrupt: function(type, arg) {
                        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                            var entry = this.tryEntries[i];
                            if (entry.tryLoc <= this.prev &&
                                hasOwn.call(entry, "finallyLoc") &&
                                this.prev < entry.finallyLoc) {
                                var finallyEntry = entry;
                                break;
                            }
                        }

                        if (finallyEntry &&
                            (type === "break" ||
                                type === "continue") &&
                            finallyEntry.tryLoc <= arg &&
                            arg <= finallyEntry.finallyLoc) {
                            // Ignore the finally entry if control is not jumping to a
                            // location outside the try/catch block.
                            finallyEntry = null;
                        }

                        var record = finallyEntry ? finallyEntry.completion : {};
                        record.type = type;
                        record.arg = arg;

                        if (finallyEntry) {
                            this.method = "next";
                            this.next = finallyEntry.finallyLoc;
                            return ContinueSentinel;
                        }

                        return this.complete(record);
                    },

                    complete: function(record, afterLoc) {
                        if (record.type === "throw") {
                            throw record.arg;
                        }

                        if (record.type === "break" ||
                            record.type === "continue") {
                            this.next = record.arg;
                        } else if (record.type === "return") {
                            this.rval = this.arg = record.arg;
                            this.method = "return";
                            this.next = "end";
                        } else if (record.type === "normal" && afterLoc) {
                            this.next = afterLoc;
                        }

                        return ContinueSentinel;
                    },

                    finish: function(finallyLoc) {
                        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                            var entry = this.tryEntries[i];
                            if (entry.finallyLoc === finallyLoc) {
                                this.complete(entry.completion, entry.afterLoc);
                                resetTryEntry(entry);
                                return ContinueSentinel;
                            }
                        }
                    },

                    "catch": function(tryLoc) {
                        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                            var entry = this.tryEntries[i];
                            if (entry.tryLoc === tryLoc) {
                                var record = entry.completion;
                                if (record.type === "throw") {
                                    var thrown = record.arg;
                                    resetTryEntry(entry);
                                }
                                return thrown;
                            }
                        }

                        // The context.catch method must only be called with a location
                        // argument that corresponds to a known catch block.
                        throw new Error("illegal catch attempt");
                    },

                    delegateYield: function(iterable, resultName, nextLoc) {
                        this.delegate = {
                            iterator: values(iterable),
                            resultName: resultName,
                            nextLoc: nextLoc
                        };

                        if (this.method === "next") {
                            // Deliberately forget the last sent value so that we don't
                            // accidentally pass it on to the delegate.
                            this.arg = undefined;
                        }

                        return ContinueSentinel;
                    }
                };

                // Regardless of whether this script is executing as a CommonJS module
                // or not, return the runtime object so that we can declare the variable
                // regeneratorRuntime in the outer scope, which allows this module to be
                // injected easily by `bin/regenerator --include-runtime script.js`.
                return exports;

            }(
                // If this script is executing as a CommonJS module, use module.exports
                // as the regeneratorRuntime namespace. Otherwise create a new empty
                // object. Either way, the resulting object will be used to initialize
                // the regeneratorRuntime variable at the top of this file.
                true ? module.exports : 0
            ));

            try {
                regeneratorRuntime = runtime;
            } catch (accidentalStrictMode) {
                // This module should not be running in strict mode, so the above
                // assignment should always work unless something is misconfigured. Just
                // in case runtime.js accidentally runs in strict mode, in modern engines
                // we can explicitly access globalThis. In older engines we can escape
                // strict mode using a global Function call. This could conceivably fail
                // if a Content Security Policy forbids using Function, but in that case
                // the proper solution is to fix the accidental strict mode problem. If
                // you've misconfigured your bundler to force strict mode and applied a
                // CSP to forbid Function, and you're not willing to fix either of those
                // problems, please detail your unique predicament in a GitHub issue.
                if (typeof globalThis === "object") {
                    globalThis.regeneratorRuntime = runtime;
                } else {
                    Function("r", "regeneratorRuntime = r")(runtime);
                }
            }


            /***/ }),

        /***/ 7551:
        /***/ (function(module, exports, __webpack_require__) {

            /* module decorator */ module = __webpack_require__.nmd(module);
            /* provided dependency */ var __webpack_provided_window_dot_jQuery = __webpack_require__(5825);
            var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// Rivets.js
// version: 0.9.6
// author: Michael Richards
// license: MIT
            (function() {
                var Rivets, bindMethod, jQuery, unbindMethod, _ref,
                    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
                    __slice = [].slice,
                    __hasProp = {}.hasOwnProperty,
                    __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
                    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

                Rivets = {
                    options: ['prefix', 'templateDelimiters', 'rootInterface', 'preloadData', 'handler', 'executeFunctions'],
                    extensions: ['binders', 'formatters', 'components', 'adapters'],
                    "public": {
                        binders: {},
                        components: {},
                        formatters: {},
                        adapters: {},
                        prefix: 'rv',
                        templateDelimiters: ['{', '}'],
                        rootInterface: '.',
                        preloadData: true,
                        executeFunctions: false,
                        iterationAlias: function(modelName) {
                            return '%' + modelName + '%';
                        },
                        handler: function(context, ev, binding) {
                            return this.call(context, ev, binding.view.models);
                        },
                        configure: function(options) {
                            var descriptor, key, option, value;
                            if (options == null) {
                                options = {};
                            }
                            for (option in options) {
                                value = options[option];
                                if (option === 'binders' || option === 'components' || option === 'formatters' || option === 'adapters') {
                                    for (key in value) {
                                        descriptor = value[key];
                                        Rivets[option][key] = descriptor;
                                    }
                                } else {
                                    Rivets["public"][option] = value;
                                }
                            }
                        },
                        bind: function(el, models, options) {
                            var view;
                            if (models == null) {
                                models = {};
                            }
                            if (options == null) {
                                options = {};
                            }
                            view = new Rivets.View(el, models, options);
                            view.bind();
                            return view;
                        },
                        init: function(component, el, data) {
                            var scope, template, view;
                            if (data == null) {
                                data = {};
                            }
                            if (el == null) {
                                el = document.createElement('div');
                            }
                            component = Rivets["public"].components[component];
                            template = component.template.call(this, el);
                            if (template instanceof HTMLElement) {
                                while (el.firstChild) {
                                    el.removeChild(el.firstChild);
                                }
                                el.appendChild(template);
                            } else {
                                el.innerHTML = template;
                            }
                            scope = component.initialize.call(this, el, data);
                            view = new Rivets.View(el, scope);
                            view.bind();
                            return view;
                        }
                    }
                };

                if (__webpack_provided_window_dot_jQuery || window['$']) {
                    jQuery = __webpack_provided_window_dot_jQuery || window['$'];
                    _ref = 'on' in jQuery.prototype ? ['on', 'off'] : ['bind', 'unbind'], bindMethod = _ref[0], unbindMethod = _ref[1];
                    Rivets.Util = {
                        bindEvent: function(el, event, handler) {
                            return jQuery(el)[bindMethod](event, handler);
                        },
                        unbindEvent: function(el, event, handler) {
                            return jQuery(el)[unbindMethod](event, handler);
                        },
                        getInputValue: function(el) {
                            var $el;
                            $el = jQuery(el);
                            if ($el.attr('type') === 'checkbox') {
                                return $el.is(':checked');
                            } else {
                                return $el.val();
                            }
                        }
                    };
                } else {
                    Rivets.Util = {
                        bindEvent: (function() {
                            if ('addEventListener' in window) {
                                return function(el, event, handler) {
                                    return el.addEventListener(event, handler, false);
                                };
                            }
                            return function(el, event, handler) {
                                return el.attachEvent('on' + event, handler);
                            };
                        })(),
                        unbindEvent: (function() {
                            if ('removeEventListener' in window) {
                                return function(el, event, handler) {
                                    return el.removeEventListener(event, handler, false);
                                };
                            }
                            return function(el, event, handler) {
                                return el.detachEvent('on' + event, handler);
                            };
                        })(),
                        getInputValue: function(el) {
                            var o, _i, _len, _results;
                            if (el.type === 'checkbox') {
                                return el.checked;
                            } else if (el.type === 'select-multiple') {
                                _results = [];
                                for (_i = 0, _len = el.length; _i < _len; _i++) {
                                    o = el[_i];
                                    if (o.selected) {
                                        _results.push(o.value);
                                    }
                                }
                                return _results;
                            } else {
                                return el.value;
                            }
                        }
                    };
                }

                Rivets.TypeParser = (function() {
                    function TypeParser() {}

                    TypeParser.types = {
                        primitive: 0,
                        keypath: 1
                    };

                    TypeParser.parse = function(string) {
                        if (/^'.*'$|^".*"$/.test(string)) {
                            return {
                                type: this.types.primitive,
                                value: string.slice(1, -1)
                            };
                        } else if (string === 'true') {
                            return {
                                type: this.types.primitive,
                                value: true
                            };
                        } else if (string === 'false') {
                            return {
                                type: this.types.primitive,
                                value: false
                            };
                        } else if (string === 'null') {
                            return {
                                type: this.types.primitive,
                                value: null
                            };
                        } else if (string === 'undefined') {
                            return {
                                type: this.types.primitive,
                                value: void 0
                            };
                        } else if (string === '') {
                            return {
                                type: this.types.primitive,
                                value: void 0
                            };
                        } else if (isNaN(Number(string)) === false) {
                            return {
                                type: this.types.primitive,
                                value: Number(string)
                            };
                        } else {
                            return {
                                type: this.types.keypath,
                                value: string
                            };
                        }
                    };

                    return TypeParser;

                })();

                Rivets.TextTemplateParser = (function() {
                    function TextTemplateParser() {}

                    TextTemplateParser.types = {
                        text: 0,
                        binding: 1
                    };

                    TextTemplateParser.parse = function(template, delimiters) {
                        var index, lastIndex, lastToken, length, substring, tokens, value;
                        tokens = [];
                        length = template.length;
                        index = 0;
                        lastIndex = 0;
                        while (lastIndex < length) {
                            index = template.indexOf(delimiters[0], lastIndex);
                            if (index < 0) {
                                tokens.push({
                                    type: this.types.text,
                                    value: template.slice(lastIndex)
                                });
                                break;
                            } else {
                                if (index > 0 && lastIndex < index) {
                                    tokens.push({
                                        type: this.types.text,
                                        value: template.slice(lastIndex, index)
                                    });
                                }
                                lastIndex = index + delimiters[0].length;
                                index = template.indexOf(delimiters[1], lastIndex);
                                if (index < 0) {
                                    substring = template.slice(lastIndex - delimiters[1].length);
                                    lastToken = tokens[tokens.length - 1];
                                    if ((lastToken != null ? lastToken.type : void 0) === this.types.text) {
                                        lastToken.value += substring;
                                    } else {
                                        tokens.push({
                                            type: this.types.text,
                                            value: substring
                                        });
                                    }
                                    break;
                                }
                                value = template.slice(lastIndex, index).trim();
                                tokens.push({
                                    type: this.types.binding,
                                    value: value
                                });
                                lastIndex = index + delimiters[1].length;
                            }
                        }
                        return tokens;
                    };

                    return TextTemplateParser;

                })();

                Rivets.View = (function() {
                    function View(els, models, options) {
                        var k, option, v, _base, _i, _j, _len, _len1, _ref1, _ref2, _ref3, _ref4, _ref5;
                        this.els = els;
                        this.models = models;
                        if (options == null) {
                            options = {};
                        }
                        this.update = __bind(this.update, this);
                        this.publish = __bind(this.publish, this);
                        this.sync = __bind(this.sync, this);
                        this.unbind = __bind(this.unbind, this);
                        this.bind = __bind(this.bind, this);
                        this.select = __bind(this.select, this);
                        this.traverse = __bind(this.traverse, this);
                        this.build = __bind(this.build, this);
                        this.buildBinding = __bind(this.buildBinding, this);
                        this.bindingRegExp = __bind(this.bindingRegExp, this);
                        this.options = __bind(this.options, this);
                        if (!(this.els.jquery || this.els instanceof Array)) {
                            this.els = [this.els];
                        }
                        _ref1 = Rivets.extensions;
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            option = _ref1[_i];
                            this[option] = {};
                            if (options[option]) {
                                _ref2 = options[option];
                                for (k in _ref2) {
                                    v = _ref2[k];
                                    this[option][k] = v;
                                }
                            }
                            _ref3 = Rivets["public"][option];
                            for (k in _ref3) {
                                v = _ref3[k];
                                if ((_base = this[option])[k] == null) {
                                    _base[k] = v;
                                }
                            }
                        }
                        _ref4 = Rivets.options;
                        for (_j = 0, _len1 = _ref4.length; _j < _len1; _j++) {
                            option = _ref4[_j];
                            this[option] = (_ref5 = options[option]) != null ? _ref5 : Rivets["public"][option];
                        }
                        this.build();
                    }

                    View.prototype.options = function() {
                        var option, options, _i, _len, _ref1;
                        options = {};
                        _ref1 = Rivets.extensions.concat(Rivets.options);
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            option = _ref1[_i];
                            options[option] = this[option];
                        }
                        return options;
                    };

                    View.prototype.bindingRegExp = function() {
                        return new RegExp("^" + this.prefix + "-");
                    };

                    View.prototype.buildBinding = function(binding, node, type, declaration) {
                        var context, ctx, dependencies, keypath, options, pipe, pipes;
                        options = {};
                        pipes = (function() {
                            var _i, _len, _ref1, _results;
                            _ref1 = declaration.match(/((?:'[^']*')*(?:(?:[^\|']*(?:'[^']*')+[^\|']*)+|[^\|]+))|^$/g);
                            _results = [];
                            for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                                pipe = _ref1[_i];
                                _results.push(pipe.trim());
                            }
                            return _results;
                        })();
                        context = (function() {
                            var _i, _len, _ref1, _results;
                            _ref1 = pipes.shift().split('<');
                            _results = [];
                            for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                                ctx = _ref1[_i];
                                _results.push(ctx.trim());
                            }
                            return _results;
                        })();
                        keypath = context.shift();
                        options.formatters = pipes;
                        if (dependencies = context.shift()) {
                            options.dependencies = dependencies.split(/\s+/);
                        }
                        return this.bindings.push(new Rivets[binding](this, node, type, keypath, options));
                    };

                    View.prototype.build = function() {
                        var el, parse, _i, _len, _ref1;
                        this.bindings = [];
                        parse = (function(_this) {
                            return function(node) {
                                var block, childNode, delimiters, n, parser, text, token, tokens, _i, _j, _len, _len1, _ref1;
                                if (node.nodeType === 3) {
                                    parser = Rivets.TextTemplateParser;
                                    if (delimiters = _this.templateDelimiters) {
                                        if ((tokens = parser.parse(node.data, delimiters)).length) {
                                            if (!(tokens.length === 1 && tokens[0].type === parser.types.text)) {
                                                for (_i = 0, _len = tokens.length; _i < _len; _i++) {
                                                    token = tokens[_i];
                                                    text = document.createTextNode(token.value);
                                                    node.parentNode.insertBefore(text, node);
                                                    if (token.type === 1) {
                                                        _this.buildBinding('TextBinding', text, null, token.value);
                                                    }
                                                }
                                                node.parentNode.removeChild(node);
                                            }
                                        }
                                    }
                                } else if (node.nodeType === 1) {
                                    block = _this.traverse(node);
                                }
                                if (!block) {
                                    _ref1 = (function() {
                                        var _k, _len1, _ref1, _results;
                                        _ref1 = node.childNodes;
                                        _results = [];
                                        for (_k = 0, _len1 = _ref1.length; _k < _len1; _k++) {
                                            n = _ref1[_k];
                                            _results.push(n);
                                        }
                                        return _results;
                                    })();
                                    for (_j = 0, _len1 = _ref1.length; _j < _len1; _j++) {
                                        childNode = _ref1[_j];
                                        parse(childNode);
                                    }
                                }
                            };
                        })(this);
                        _ref1 = this.els;
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            el = _ref1[_i];
                            parse(el);
                        }
                        this.bindings.sort(function(a, b) {
                            var _ref2, _ref3;
                            return (((_ref2 = b.binder) != null ? _ref2.priority : void 0) || 0) - (((_ref3 = a.binder) != null ? _ref3.priority : void 0) || 0);
                        });
                    };

                    View.prototype.traverse = function(node) {
                        var attribute, attributes, binder, bindingRegExp, block, identifier, regexp, type, value, _i, _j, _len, _len1, _ref1, _ref2, _ref3;
                        bindingRegExp = this.bindingRegExp();
                        block = node.nodeName === 'SCRIPT' || node.nodeName === 'STYLE';
                        _ref1 = node.attributes;
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            attribute = _ref1[_i];
                            if (bindingRegExp.test(attribute.name)) {
                                type = attribute.name.replace(bindingRegExp, '');
                                if (!(binder = this.binders[type])) {
                                    _ref2 = this.binders;
                                    for (identifier in _ref2) {
                                        value = _ref2[identifier];
                                        if (identifier !== '*' && identifier.indexOf('*') !== -1) {
                                            regexp = new RegExp("^" + (identifier.replace(/\*/g, '.+')) + "$");
                                            if (regexp.test(type)) {
                                                binder = value;
                                            }
                                        }
                                    }
                                }
                                binder || (binder = this.binders['*']);
                                if (binder.block) {
                                    block = true;
                                    attributes = [attribute];
                                }
                            }
                        }
                        _ref3 = attributes || node.attributes;
                        for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
                            attribute = _ref3[_j];
                            if (bindingRegExp.test(attribute.name)) {
                                type = attribute.name.replace(bindingRegExp, '');
                                this.buildBinding('Binding', node, type, attribute.value);
                            }
                        }
                        if (!block) {
                            type = node.nodeName.toLowerCase();
                            if (this.components[type] && !node._bound) {
                                this.bindings.push(new Rivets.ComponentBinding(this, node, type));
                                block = true;
                            }
                        }
                        return block;
                    };

                    View.prototype.select = function(fn) {
                        var binding, _i, _len, _ref1, _results;
                        _ref1 = this.bindings;
                        _results = [];
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            binding = _ref1[_i];
                            if (fn(binding)) {
                                _results.push(binding);
                            }
                        }
                        return _results;
                    };

                    View.prototype.bind = function() {
                        var binding, _i, _len, _ref1;
                        _ref1 = this.bindings;
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            binding = _ref1[_i];
                            binding.bind();
                        }
                    };

                    View.prototype.unbind = function() {
                        var binding, _i, _len, _ref1;
                        _ref1 = this.bindings;
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            binding = _ref1[_i];
                            binding.unbind();
                        }
                    };

                    View.prototype.sync = function() {
                        var binding, _i, _len, _ref1;
                        _ref1 = this.bindings;
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            binding = _ref1[_i];
                            if (typeof binding.sync === "function") {
                                binding.sync();
                            }
                        }
                    };

                    View.prototype.publish = function() {
                        var binding, _i, _len, _ref1;
                        _ref1 = this.select(function(b) {
                            var _ref1;
                            return (_ref1 = b.binder) != null ? _ref1.publishes : void 0;
                        });
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            binding = _ref1[_i];
                            binding.publish();
                        }
                    };

                    View.prototype.update = function(models) {
                        var binding, key, model, _i, _len, _ref1;
                        if (models == null) {
                            models = {};
                        }
                        for (key in models) {
                            model = models[key];
                            this.models[key] = model;
                        }
                        _ref1 = this.bindings;
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            binding = _ref1[_i];
                            if (typeof binding.update === "function") {
                                binding.update(models);
                            }
                        }
                    };

                    return View;

                })();

                Rivets.Binding = (function() {
                    function Binding(view, el, type, keypath, options) {
                        this.view = view;
                        this.el = el;
                        this.type = type;
                        this.keypath = keypath;
                        this.options = options != null ? options : {};
                        this.getValue = __bind(this.getValue, this);
                        this.update = __bind(this.update, this);
                        this.unbind = __bind(this.unbind, this);
                        this.bind = __bind(this.bind, this);
                        this.publish = __bind(this.publish, this);
                        this.sync = __bind(this.sync, this);
                        this.set = __bind(this.set, this);
                        this.eventHandler = __bind(this.eventHandler, this);
                        this.formattedValue = __bind(this.formattedValue, this);
                        this.parseFormatterArguments = __bind(this.parseFormatterArguments, this);
                        this.parseTarget = __bind(this.parseTarget, this);
                        this.observe = __bind(this.observe, this);
                        this.setBinder = __bind(this.setBinder, this);
                        this.formatters = this.options.formatters || [];
                        this.dependencies = [];
                        this.formatterObservers = {};
                        this.model = void 0;
                        this.setBinder();
                    }

                    Binding.prototype.setBinder = function() {
                        var identifier, regexp, value, _ref1;
                        if (!(this.binder = this.view.binders[this.type])) {
                            _ref1 = this.view.binders;
                            for (identifier in _ref1) {
                                value = _ref1[identifier];
                                if (identifier !== '*' && identifier.indexOf('*') !== -1) {
                                    regexp = new RegExp("^" + (identifier.replace(/\*/g, '.+')) + "$");
                                    if (regexp.test(this.type)) {
                                        this.binder = value;
                                        this.args = new RegExp("^" + (identifier.replace(/\*/g, '(.+)')) + "$").exec(this.type);
                                        this.args.shift();
                                    }
                                }
                            }
                        }
                        this.binder || (this.binder = this.view.binders['*']);
                        if (this.binder instanceof Function) {
                            return this.binder = {
                                routine: this.binder
                            };
                        }
                    };

                    Binding.prototype.observe = function(obj, keypath, callback) {
                        return Rivets.sightglass(obj, keypath, callback, {
                            root: this.view.rootInterface,
                            adapters: this.view.adapters
                        });
                    };

                    Binding.prototype.parseTarget = function() {
                        var token;
                        token = Rivets.TypeParser.parse(this.keypath);
                        if (token.type === Rivets.TypeParser.types.primitive) {
                            return this.value = token.value;
                        } else {
                            this.observer = this.observe(this.view.models, this.keypath, this.sync);
                            return this.model = this.observer.target;
                        }
                    };

                    Binding.prototype.parseFormatterArguments = function(args, formatterIndex) {
                        var ai, arg, observer, processedArgs, _base, _i, _len;
                        args = (function() {
                            var _i, _len, _results;
                            _results = [];
                            for (_i = 0, _len = args.length; _i < _len; _i++) {
                                arg = args[_i];
                                _results.push(Rivets.TypeParser.parse(arg));
                            }
                            return _results;
                        })();
                        processedArgs = [];
                        for (ai = _i = 0, _len = args.length; _i < _len; ai = ++_i) {
                            arg = args[ai];
                            processedArgs.push(arg.type === Rivets.TypeParser.types.primitive ? arg.value : ((_base = this.formatterObservers)[formatterIndex] || (_base[formatterIndex] = {}), !(observer = this.formatterObservers[formatterIndex][ai]) ? (observer = this.observe(this.view.models, arg.value, this.sync), this.formatterObservers[formatterIndex][ai] = observer) : void 0, observer.value()));
                        }
                        return processedArgs;
                    };

                    Binding.prototype.formattedValue = function(value) {
                        var args, fi, formatter, id, processedArgs, _i, _len, _ref1, _ref2;
                        _ref1 = this.formatters;
                        for (fi = _i = 0, _len = _ref1.length; _i < _len; fi = ++_i) {
                            formatter = _ref1[fi];
                            args = formatter.match(/[^\s']+|'([^']|'[^\s])*'|"([^"]|"[^\s])*"/g);
                            id = args.shift();
                            formatter = this.view.formatters[id];
                            processedArgs = this.parseFormatterArguments(args, fi);
                            if ((formatter != null ? formatter.read : void 0) instanceof Function) {
                                value = (_ref2 = formatter.read).call.apply(_ref2, [this.model, value].concat(__slice.call(processedArgs)));
                            } else if (formatter instanceof Function) {
                                value = formatter.call.apply(formatter, [this.model, value].concat(__slice.call(processedArgs)));
                            }
                        }
                        return value;
                    };

                    Binding.prototype.eventHandler = function(fn) {
                        var binding, handler;
                        handler = (binding = this).view.handler;
                        return function(ev) {
                            return handler.call(fn, this, ev, binding);
                        };
                    };

                    Binding.prototype.set = function(value) {
                        var _ref1;
                        value = value instanceof Function && !this.binder["function"] && Rivets["public"].executeFunctions ? this.formattedValue(value.call(this.model)) : this.formattedValue(value);
                        return (_ref1 = this.binder.routine) != null ? _ref1.call(this, this.el, value) : void 0;
                    };

                    Binding.prototype.sync = function() {
                        var dependency, observer;
                        return this.set((function() {
                            var _i, _j, _len, _len1, _ref1, _ref2, _ref3;
                            if (this.observer) {
                                if (this.model !== this.observer.target) {
                                    _ref1 = this.dependencies;
                                    for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                                        observer = _ref1[_i];
                                        observer.unobserve();
                                    }
                                    this.dependencies = [];
                                    if (((this.model = this.observer.target) != null) && ((_ref2 = this.options.dependencies) != null ? _ref2.length : void 0)) {
                                        _ref3 = this.options.dependencies;
                                        for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
                                            dependency = _ref3[_j];
                                            observer = this.observe(this.model, dependency, this.sync);
                                            this.dependencies.push(observer);
                                        }
                                    }
                                }
                                return this.observer.value();
                            } else {
                                return this.value;
                            }
                        }).call(this));
                    };

                    Binding.prototype.publish = function() {
                        var args, fi, fiReversed, formatter, id, lastformatterIndex, processedArgs, value, _i, _len, _ref1, _ref2, _ref3;
                        if (this.observer) {
                            value = this.getValue(this.el);
                            lastformatterIndex = this.formatters.length - 1;
                            _ref1 = this.formatters.slice(0).reverse();
                            for (fiReversed = _i = 0, _len = _ref1.length; _i < _len; fiReversed = ++_i) {
                                formatter = _ref1[fiReversed];
                                fi = lastformatterIndex - fiReversed;
                                args = formatter.split(/\s+/);
                                id = args.shift();
                                processedArgs = this.parseFormatterArguments(args, fi);
                                if ((_ref2 = this.view.formatters[id]) != null ? _ref2.publish : void 0) {
                                    value = (_ref3 = this.view.formatters[id]).publish.apply(_ref3, [value].concat(__slice.call(processedArgs)));
                                }
                            }
                            return this.observer.setValue(value);
                        }
                    };

                    Binding.prototype.bind = function() {
                        var dependency, observer, _i, _len, _ref1, _ref2, _ref3;
                        this.parseTarget();
                        if ((_ref1 = this.binder.bind) != null) {
                            _ref1.call(this, this.el);
                        }
                        if ((this.model != null) && ((_ref2 = this.options.dependencies) != null ? _ref2.length : void 0)) {
                            _ref3 = this.options.dependencies;
                            for (_i = 0, _len = _ref3.length; _i < _len; _i++) {
                                dependency = _ref3[_i];
                                observer = this.observe(this.model, dependency, this.sync);
                                this.dependencies.push(observer);
                            }
                        }
                        if (this.view.preloadData) {
                            return this.sync();
                        }
                    };

                    Binding.prototype.unbind = function() {
                        var ai, args, fi, observer, _i, _len, _ref1, _ref2, _ref3, _ref4;
                        if ((_ref1 = this.binder.unbind) != null) {
                            _ref1.call(this, this.el);
                        }
                        if ((_ref2 = this.observer) != null) {
                            _ref2.unobserve();
                        }
                        _ref3 = this.dependencies;
                        for (_i = 0, _len = _ref3.length; _i < _len; _i++) {
                            observer = _ref3[_i];
                            observer.unobserve();
                        }
                        this.dependencies = [];
                        _ref4 = this.formatterObservers;
                        for (fi in _ref4) {
                            args = _ref4[fi];
                            for (ai in args) {
                                observer = args[ai];
                                observer.unobserve();
                            }
                        }
                        return this.formatterObservers = {};
                    };

                    Binding.prototype.update = function(models) {
                        var _ref1, _ref2;
                        if (models == null) {
                            models = {};
                        }
                        this.model = (_ref1 = this.observer) != null ? _ref1.target : void 0;
                        return (_ref2 = this.binder.update) != null ? _ref2.call(this, models) : void 0;
                    };

                    Binding.prototype.getValue = function(el) {
                        if (this.binder && (this.binder.getValue != null)) {
                            return this.binder.getValue.call(this, el);
                        } else {
                            return Rivets.Util.getInputValue(el);
                        }
                    };

                    return Binding;

                })();

                Rivets.ComponentBinding = (function(_super) {
                    __extends(ComponentBinding, _super);

                    function ComponentBinding(view, el, type) {
                        var attribute, bindingRegExp, propertyName, token, _i, _len, _ref1, _ref2;
                        this.view = view;
                        this.el = el;
                        this.type = type;
                        this.unbind = __bind(this.unbind, this);
                        this.bind = __bind(this.bind, this);
                        this.locals = __bind(this.locals, this);
                        this.component = this.view.components[this.type];
                        this["static"] = {};
                        this.observers = {};
                        this.upstreamObservers = {};
                        bindingRegExp = view.bindingRegExp();
                        _ref1 = this.el.attributes || [];
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            attribute = _ref1[_i];
                            if (!bindingRegExp.test(attribute.name)) {
                                propertyName = this.camelCase(attribute.name);
                                token = Rivets.TypeParser.parse(attribute.value);
                                if (__indexOf.call((_ref2 = this.component["static"]) != null ? _ref2 : [], propertyName) >= 0) {
                                    this["static"][propertyName] = attribute.value;
                                } else if (token.type === Rivets.TypeParser.types.primitive) {
                                    this["static"][propertyName] = token.value;
                                } else {
                                    this.observers[propertyName] = attribute.value;
                                }
                            }
                        }
                    }

                    ComponentBinding.prototype.sync = function() {};

                    ComponentBinding.prototype.update = function() {};

                    ComponentBinding.prototype.publish = function() {};

                    ComponentBinding.prototype.locals = function() {
                        var key, observer, result, value, _ref1, _ref2;
                        result = {};
                        _ref1 = this["static"];
                        for (key in _ref1) {
                            value = _ref1[key];
                            result[key] = value;
                        }
                        _ref2 = this.observers;
                        for (key in _ref2) {
                            observer = _ref2[key];
                            result[key] = observer.value();
                        }
                        return result;
                    };

                    ComponentBinding.prototype.camelCase = function(string) {
                        return string.replace(/-([a-z])/g, function(grouped) {
                            return grouped[1].toUpperCase();
                        });
                    };

                    ComponentBinding.prototype.bind = function() {
                        var k, key, keypath, observer, option, options, scope, v, _base, _i, _j, _len, _len1, _ref1, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7;
                        if (!this.bound) {
                            _ref1 = this.observers;
                            for (key in _ref1) {
                                keypath = _ref1[key];
                                this.observers[key] = this.observe(this.view.models, keypath, ((function(_this) {
                                    return function(key) {
                                        return function() {
                                            return _this.componentView.models[key] = _this.observers[key].value();
                                        };
                                    };
                                })(this)).call(this, key));
                            }
                            this.bound = true;
                        }
                        if (this.componentView != null) {
                            this.componentView.bind();
                        } else {
                            this.el.innerHTML = this.component.template.call(this);
                            scope = this.component.initialize.call(this, this.el, this.locals());
                            this.el._bound = true;
                            options = {};
                            _ref2 = Rivets.extensions;
                            for (_i = 0, _len = _ref2.length; _i < _len; _i++) {
                                option = _ref2[_i];
                                options[option] = {};
                                if (this.component[option]) {
                                    _ref3 = this.component[option];
                                    for (k in _ref3) {
                                        v = _ref3[k];
                                        options[option][k] = v;
                                    }
                                }
                                _ref4 = this.view[option];
                                for (k in _ref4) {
                                    v = _ref4[k];
                                    if ((_base = options[option])[k] == null) {
                                        _base[k] = v;
                                    }
                                }
                            }
                            _ref5 = Rivets.options;
                            for (_j = 0, _len1 = _ref5.length; _j < _len1; _j++) {
                                option = _ref5[_j];
                                options[option] = (_ref6 = this.component[option]) != null ? _ref6 : this.view[option];
                            }
                            this.componentView = new Rivets.View(Array.prototype.slice.call(this.el.childNodes), scope, options);
                            this.componentView.bind();
                            _ref7 = this.observers;
                            for (key in _ref7) {
                                observer = _ref7[key];
                                this.upstreamObservers[key] = this.observe(this.componentView.models, key, ((function(_this) {
                                    return function(key, observer) {
                                        return function() {
                                            return observer.setValue(_this.componentView.models[key]);
                                        };
                                    };
                                })(this)).call(this, key, observer));
                            }
                        }
                    };

                    ComponentBinding.prototype.unbind = function() {
                        var key, observer, _ref1, _ref2, _ref3;
                        _ref1 = this.upstreamObservers;
                        for (key in _ref1) {
                            observer = _ref1[key];
                            observer.unobserve();
                        }
                        _ref2 = this.observers;
                        for (key in _ref2) {
                            observer = _ref2[key];
                            observer.unobserve();
                        }
                        return (_ref3 = this.componentView) != null ? _ref3.unbind.call(this) : void 0;
                    };

                    return ComponentBinding;

                })(Rivets.Binding);

                Rivets.TextBinding = (function(_super) {
                    __extends(TextBinding, _super);

                    function TextBinding(view, el, type, keypath, options) {
                        this.view = view;
                        this.el = el;
                        this.type = type;
                        this.keypath = keypath;
                        this.options = options != null ? options : {};
                        this.sync = __bind(this.sync, this);
                        this.formatters = this.options.formatters || [];
                        this.dependencies = [];
                        this.formatterObservers = {};
                    }

                    TextBinding.prototype.binder = {
                        routine: function(node, value) {
                            return node.data = value != null ? value : '';
                        }
                    };

                    TextBinding.prototype.sync = function() {
                        return TextBinding.__super__.sync.apply(this, arguments);
                    };

                    return TextBinding;

                })(Rivets.Binding);

                Rivets["public"].binders.text = function(el, value) {
                    if (el.textContent != null) {
                        return el.textContent = value != null ? value : '';
                    } else {
                        return el.innerText = value != null ? value : '';
                    }
                };

                Rivets["public"].binders.html = function(el, value) {
                    return el.innerHTML = value != null ? value : '';
                };

                Rivets["public"].binders.show = function(el, value) {
                    return el.style.display = value ? '' : 'none';
                };

                Rivets["public"].binders.hide = function(el, value) {
                    return el.style.display = value ? 'none' : '';
                };

                Rivets["public"].binders.enabled = function(el, value) {
                    return el.disabled = !value;
                };

                Rivets["public"].binders.disabled = function(el, value) {
                    return el.disabled = !!value;
                };

                Rivets["public"].binders.checked = {
                    publishes: true,
                    priority: 2000,
                    bind: function(el) {
                        return Rivets.Util.bindEvent(el, 'change', this.publish);
                    },
                    unbind: function(el) {
                        return Rivets.Util.unbindEvent(el, 'change', this.publish);
                    },
                    routine: function(el, value) {
                        var _ref1;
                        if (el.type === 'radio') {
                            return el.checked = ((_ref1 = el.value) != null ? _ref1.toString() : void 0) === (value != null ? value.toString() : void 0);
                        } else {
                            return el.checked = !!value;
                        }
                    }
                };

                Rivets["public"].binders.unchecked = {
                    publishes: true,
                    priority: 2000,
                    bind: function(el) {
                        return Rivets.Util.bindEvent(el, 'change', this.publish);
                    },
                    unbind: function(el) {
                        return Rivets.Util.unbindEvent(el, 'change', this.publish);
                    },
                    routine: function(el, value) {
                        var _ref1;
                        if (el.type === 'radio') {
                            return el.checked = ((_ref1 = el.value) != null ? _ref1.toString() : void 0) !== (value != null ? value.toString() : void 0);
                        } else {
                            return el.checked = !value;
                        }
                    }
                };

                Rivets["public"].binders.value = {
                    publishes: true,
                    priority: 3000,
                    bind: function(el) {
                        if (!(el.tagName === 'INPUT' && el.type === 'radio')) {
                            this.event = el.tagName === 'SELECT' ? 'change' : 'input';
                            return Rivets.Util.bindEvent(el, this.event, this.publish);
                        }
                    },
                    unbind: function(el) {
                        if (!(el.tagName === 'INPUT' && el.type === 'radio')) {
                            return Rivets.Util.unbindEvent(el, this.event, this.publish);
                        }
                    },
                    routine: function(el, value) {
                        var o, _i, _len, _ref1, _ref2, _ref3, _results;
                        if (el.tagName === 'INPUT' && el.type === 'radio') {
                            return el.setAttribute('value', value);
                        } else if (__webpack_provided_window_dot_jQuery != null) {
                            el = jQuery(el);
                            if ((value != null ? value.toString() : void 0) !== ((_ref1 = el.val()) != null ? _ref1.toString() : void 0)) {
                                return el.val(value != null ? value : '');
                            }
                        } else {
                            if (el.type === 'select-multiple') {
                                if (value != null) {
                                    _results = [];
                                    for (_i = 0, _len = el.length; _i < _len; _i++) {
                                        o = el[_i];
                                        _results.push(o.selected = (_ref2 = o.value, __indexOf.call(value, _ref2) >= 0));
                                    }
                                    return _results;
                                }
                            } else if ((value != null ? value.toString() : void 0) !== ((_ref3 = el.value) != null ? _ref3.toString() : void 0)) {
                                return el.value = value != null ? value : '';
                            }
                        }
                    }
                };

                Rivets["public"].binders["if"] = {
                    block: true,
                    priority: 4000,
                    bind: function(el) {
                        var attr, declaration;
                        if (this.marker == null) {
                            attr = [this.view.prefix, this.type].join('-').replace('--', '-');
                            declaration = el.getAttribute(attr);
                            this.marker = document.createComment(" rivets: " + this.type + " " + declaration + " ");
                            this.bound = false;
                            el.removeAttribute(attr);
                            el.parentNode.insertBefore(this.marker, el);
                            return el.parentNode.removeChild(el);
                        }
                    },
                    unbind: function() {
                        if (this.nested) {
                            this.nested.unbind();
                            return this.bound = false;
                        }
                    },
                    routine: function(el, value) {
                        var key, model, models, _ref1;
                        if (!!value === !this.bound) {
                            if (value) {
                                models = {};
                                _ref1 = this.view.models;
                                for (key in _ref1) {
                                    model = _ref1[key];
                                    models[key] = model;
                                }
                                (this.nested || (this.nested = new Rivets.View(el, models, this.view.options()))).bind();
                                this.marker.parentNode.insertBefore(el, this.marker.nextSibling);
                                return this.bound = true;
                            } else {
                                el.parentNode.removeChild(el);
                                this.nested.unbind();
                                return this.bound = false;
                            }
                        }
                    },
                    update: function(models) {
                        var _ref1;
                        return (_ref1 = this.nested) != null ? _ref1.update(models) : void 0;
                    }
                };

                Rivets["public"].binders.unless = {
                    block: true,
                    priority: 4000,
                    bind: function(el) {
                        return Rivets["public"].binders["if"].bind.call(this, el);
                    },
                    unbind: function() {
                        return Rivets["public"].binders["if"].unbind.call(this);
                    },
                    routine: function(el, value) {
                        return Rivets["public"].binders["if"].routine.call(this, el, !value);
                    },
                    update: function(models) {
                        return Rivets["public"].binders["if"].update.call(this, models);
                    }
                };

                Rivets["public"].binders['on-*'] = {
                    "function": true,
                    priority: 1000,
                    unbind: function(el) {
                        if (this.handler) {
                            return Rivets.Util.unbindEvent(el, this.args[0], this.handler);
                        }
                    },
                    routine: function(el, value) {
                        if (this.handler) {
                            Rivets.Util.unbindEvent(el, this.args[0], this.handler);
                        }
                        return Rivets.Util.bindEvent(el, this.args[0], this.handler = this.eventHandler(value));
                    }
                };

                Rivets["public"].binders['each-*'] = {
                    block: true,
                    priority: 4000,
                    bind: function(el) {
                        var attr, view, _i, _len, _ref1;
                        if (this.marker == null) {
                            attr = [this.view.prefix, this.type].join('-').replace('--', '-');
                            this.marker = document.createComment(" rivets: " + this.type + " ");
                            this.iterated = [];
                            el.removeAttribute(attr);
                            el.parentNode.insertBefore(this.marker, el);
                            el.parentNode.removeChild(el);
                        } else {
                            _ref1 = this.iterated;
                            for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                                view = _ref1[_i];
                                view.bind();
                            }
                        }
                    },
                    unbind: function(el) {
                        var view, _i, _len, _ref1;
                        if (this.iterated != null) {
                            _ref1 = this.iterated;
                            for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                                view = _ref1[_i];
                                view.unbind();
                            }
                        }
                    },
                    routine: function(el, collection) {
                        var binding, data, i, index, key, model, modelName, options, previous, template, view, _i, _j, _k, _len, _len1, _len2, _ref1, _ref2, _ref3;
                        modelName = this.args[0];
                        collection = collection || [];
                        if (this.iterated.length > collection.length) {
                            _ref1 = Array(this.iterated.length - collection.length);
                            for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                                i = _ref1[_i];
                                view = this.iterated.pop();
                                view.unbind();
                                this.marker.parentNode.removeChild(view.els[0]);
                            }
                        }
                        for (index = _j = 0, _len1 = collection.length; _j < _len1; index = ++_j) {
                            model = collection[index];
                            data = {
                                index: index
                            };
                            data[Rivets["public"].iterationAlias(modelName)] = index;
                            data[modelName] = model;
                            if (this.iterated[index] == null) {
                                _ref2 = this.view.models;
                                for (key in _ref2) {
                                    model = _ref2[key];
                                    if (data[key] == null) {
                                        data[key] = model;
                                    }
                                }
                                previous = this.iterated.length ? this.iterated[this.iterated.length - 1].els[0] : this.marker;
                                options = this.view.options();
                                options.preloadData = true;
                                template = el.cloneNode(true);
                                view = new Rivets.View(template, data, options);
                                view.bind();
                                this.iterated.push(view);
                                this.marker.parentNode.insertBefore(template, previous.nextSibling);
                            } else if (this.iterated[index].models[modelName] !== model) {
                                this.iterated[index].update(data);
                            }
                        }
                        if (el.nodeName === 'OPTION') {
                            _ref3 = this.view.bindings;
                            for (_k = 0, _len2 = _ref3.length; _k < _len2; _k++) {
                                binding = _ref3[_k];
                                if (binding.el === this.marker.parentNode && binding.type === 'value') {
                                    binding.sync();
                                }
                            }
                        }
                    },
                    update: function(models) {
                        var data, key, model, view, _i, _len, _ref1;
                        data = {};
                        for (key in models) {
                            model = models[key];
                            if (key !== this.args[0]) {
                                data[key] = model;
                            }
                        }
                        _ref1 = this.iterated;
                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                            view = _ref1[_i];
                            view.update(data);
                        }
                    }
                };

                Rivets["public"].binders['class-*'] = function(el, value) {
                    var elClass;
                    elClass = " " + el.className + " ";
                    if (!value === (elClass.indexOf(" " + this.args[0] + " ") !== -1)) {
                        return el.className = value ? "" + el.className + " " + this.args[0] : elClass.replace(" " + this.args[0] + " ", ' ').trim();
                    }
                };

                Rivets["public"].binders['*'] = function(el, value) {
                    if (value != null) {
                        return el.setAttribute(this.type, value);
                    } else {
                        return el.removeAttribute(this.type);
                    }
                };

                Rivets["public"].formatters['call'] = function() {
                    var args, value;
                    value = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
                    return value.call.apply(value, [this].concat(__slice.call(args)));
                };

                Rivets["public"].adapters['.'] = {
                    id: '_rv',
                    counter: 0,
                    weakmap: {},
                    weakReference: function(obj) {
                        var id, _base, _name;
                        if (!obj.hasOwnProperty(this.id)) {
                            id = this.counter++;
                            Object.defineProperty(obj, this.id, {
                                value: id
                            });
                        }
                        return (_base = this.weakmap)[_name = obj[this.id]] || (_base[_name] = {
                            callbacks: {}
                        });
                    },
                    cleanupWeakReference: function(ref, id) {
                        if (!Object.keys(ref.callbacks).length) {
                            if (!(ref.pointers && Object.keys(ref.pointers).length)) {
                                return delete this.weakmap[id];
                            }
                        }
                    },
                    stubFunction: function(obj, fn) {
                        var map, original, weakmap;
                        original = obj[fn];
                        map = this.weakReference(obj);
                        weakmap = this.weakmap;
                        return obj[fn] = function() {
                            var callback, k, r, response, _i, _len, _ref1, _ref2, _ref3, _ref4;
                            response = original.apply(obj, arguments);
                            _ref1 = map.pointers;
                            for (r in _ref1) {
                                k = _ref1[r];
                                _ref4 = (_ref2 = (_ref3 = weakmap[r]) != null ? _ref3.callbacks[k] : void 0) != null ? _ref2 : [];
                                for (_i = 0, _len = _ref4.length; _i < _len; _i++) {
                                    callback = _ref4[_i];
                                    callback();
                                }
                            }
                            return response;
                        };
                    },
                    observeMutations: function(obj, ref, keypath) {
                        var fn, functions, map, _base, _i, _len;
                        if (Array.isArray(obj)) {
                            map = this.weakReference(obj);
                            if (map.pointers == null) {
                                map.pointers = {};
                                functions = ['push', 'pop', 'shift', 'unshift', 'sort', 'reverse', 'splice'];
                                for (_i = 0, _len = functions.length; _i < _len; _i++) {
                                    fn = functions[_i];
                                    this.stubFunction(obj, fn);
                                }
                            }
                            if ((_base = map.pointers)[ref] == null) {
                                _base[ref] = [];
                            }
                            if (__indexOf.call(map.pointers[ref], keypath) < 0) {
                                return map.pointers[ref].push(keypath);
                            }
                        }
                    },
                    unobserveMutations: function(obj, ref, keypath) {
                        var idx, map, pointers;
                        if (Array.isArray(obj) && (obj[this.id] != null)) {
                            if (map = this.weakmap[obj[this.id]]) {
                                if (pointers = map.pointers[ref]) {
                                    if ((idx = pointers.indexOf(keypath)) >= 0) {
                                        pointers.splice(idx, 1);
                                    }
                                    if (!pointers.length) {
                                        delete map.pointers[ref];
                                    }
                                    return this.cleanupWeakReference(map, obj[this.id]);
                                }
                            }
                        }
                    },
                    observe: function(obj, keypath, callback) {
                        var callbacks, desc, value;
                        callbacks = this.weakReference(obj).callbacks;
                        if (callbacks[keypath] == null) {
                            callbacks[keypath] = [];
                            desc = Object.getOwnPropertyDescriptor(obj, keypath);
                            if (!((desc != null ? desc.get : void 0) || (desc != null ? desc.set : void 0))) {
                                value = obj[keypath];
                                Object.defineProperty(obj, keypath, {
                                    enumerable: true,
                                    get: function() {
                                        return value;
                                    },
                                    set: (function(_this) {
                                        return function(newValue) {
                                            var cb, map, _i, _len, _ref1;
                                            if (newValue !== value) {
                                                _this.unobserveMutations(value, obj[_this.id], keypath);
                                                value = newValue;
                                                if (map = _this.weakmap[obj[_this.id]]) {
                                                    callbacks = map.callbacks;
                                                    if (callbacks[keypath]) {
                                                        _ref1 = callbacks[keypath].slice();
                                                        for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
                                                            cb = _ref1[_i];
                                                            if (__indexOf.call(callbacks[keypath], cb) >= 0) {
                                                                cb();
                                                            }
                                                        }
                                                    }
                                                    return _this.observeMutations(newValue, obj[_this.id], keypath);
                                                }
                                            }
                                        };
                                    })(this)
                                });
                            }
                        }
                        if (__indexOf.call(callbacks[keypath], callback) < 0) {
                            callbacks[keypath].push(callback);
                        }
                        return this.observeMutations(obj[keypath], obj[this.id], keypath);
                    },
                    unobserve: function(obj, keypath, callback) {
                        var callbacks, idx, map;
                        if (map = this.weakmap[obj[this.id]]) {
                            if (callbacks = map.callbacks[keypath]) {
                                if ((idx = callbacks.indexOf(callback)) >= 0) {
                                    callbacks.splice(idx, 1);
                                    if (!callbacks.length) {
                                        delete map.callbacks[keypath];
                                        this.unobserveMutations(obj[keypath], obj[this.id], keypath);
                                    }
                                }
                                return this.cleanupWeakReference(map, obj[this.id]);
                            }
                        }
                    },
                    get: function(obj, keypath) {
                        return obj[keypath];
                    },
                    set: function(obj, keypath, value) {
                        return obj[keypath] = value;
                    }
                };

                Rivets.factory = function(sightglass) {
                    Rivets.sightglass = sightglass;
                    Rivets["public"]._ = Rivets;
                    return Rivets["public"];
                };

                if (typeof ( true && module !== null ? module.exports : void 0) === 'object') {
                    module.exports = Rivets.factory(__webpack_require__(2206));
                } else if (true) {
                    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(2206)], __WEBPACK_AMD_DEFINE_RESULT__ = (function(sightglass) {
                        return this.rivets = Rivets.factory(sightglass);
                    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
                } else {}

            }).call(this);


            /***/ }),

        /***/ 3184:
        /***/ (function(__unused_webpack_module, exports, __webpack_require__) {

            /* provided dependency */ var jQuery = __webpack_require__(5825);
            /* provided dependency */ var rivets = __webpack_require__(7551);
            (function() {
                var $document, Cart, CartJS, FORMAT_MONEY_WARNING, Item, processing, queue,
                    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
                    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

                Cart = (function() {
                    function Cart() {
                        this.update = __bind(this.update, this);
                    }

                    Cart.prototype.update = function(cart) {
                        var item, key, value;
                        for (key in cart) {
                            value = cart[key];
                            if (key !== 'items') {
                                this[key] = value;
                            }
                        }
                        return this.items = (function() {
                            var _i, _len, _ref, _results;
                            _ref = cart.items;
                            _results = [];
                            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                                item = _ref[_i];
                                _results.push(new Item(item));
                            }
                            return _results;
                        })();
                    };

                    return Cart;

                })();

                Item = (function() {
                    function Item(item) {
                        this.propertyArray = __bind(this.propertyArray, this);
                        this.update = __bind(this.update, this);
                        this.update(item);
                    }

                    Item.prototype.update = function(item) {
                        var key, value;
                        for (key in item) {
                            value = item[key];
                            if (key !== 'properties') {
                                this[key] = value;
                            }
                        }
                        return this.properties = CartJS.Utils.extend({}, item.properties);
                    };

                    Item.prototype.propertyArray = function() {
                        var name, value, _ref, _results;
                        _ref = this.properties;
                        _results = [];
                        for (name in _ref) {
                            value = _ref[name];
                            _results.push({
                                name: name,
                                value: value
                            });
                        }
                        return _results;
                    };

                    return Item;

                })();

                CartJS = {
                    settings: {
                        debug: false,
                        dataAPI: true,
                        requestBodyClass: null,
                        rivetsModels: {},
                        currency: null,
                        moneyFormat: null,
                        moneyWithCurrencyFormat: null,
                        weightUnit: 'g',
                        weightPrecision: 0
                    },
                    cart: new Cart()
                };

                CartJS.init = function(cart, settings) {
                    if (settings == null) {
                        settings = {};
                    }
                    CartJS.configure(settings);
                    CartJS.Utils.log('Initialising CartJS.');
                    CartJS.cart.update(cart);
                    if (CartJS.settings.dataAPI) {
                        CartJS.Utils.log('"dataAPI" setting is true, initialising Data API.');
                        CartJS.Data.init();
                    }
                    if (CartJS.settings.requestBodyClass) {
                        CartJS.Utils.log('"requestBodyClass" set, adding event listeners.');
                        jQuery(document).on('cart.requestStarted', function() {
                            return jQuery('body').addClass(CartJS.settings.requestBodyClass);
                        });
                        jQuery(document).on('cart.requestComplete', function() {
                            return jQuery('body').removeClass(CartJS.settings.requestBodyClass);
                        });
                    }
                    CartJS.Rivets.init();
                    return jQuery(document).trigger('cart.ready', [CartJS.cart]);
                };

                CartJS.configure = function(settings) {
                    if (settings == null) {
                        settings = {};
                    }
                    return CartJS.Utils.extend(CartJS.settings, settings);
                };

                if (window.console == null) {
                    window.console = {};
                    window.console.log = function() {};
                }

                FORMAT_MONEY_WARNING = 'A money formatting filter was used, but Shopify.formatMoney is not available. See the note "Dependency when formatting monetary values" on this page: https://cartjs.org/pages/guide#getting-started-setup.';

                CartJS.Utils = {
                    log: function() {
                        return CartJS.Utils.console(console.log, arguments);
                    },
                    warn: function() {
                        return CartJS.Utils.console(console.warn, arguments);
                    },
                    error: function() {
                        return CartJS.Utils.console(console.error, arguments);
                    },
                    console: function(method, args) {
                        if (CartJS.settings.debug && (typeof console !== "undefined" && console !== null)) {
                            args = Array.prototype.slice.call(args);
                            args.unshift('[CartJS]:');
                            return method.apply(console, args);
                        }
                    },
                    wrapKeys: function(obj, type, override, skip) {
                        var key, mappedKey, value, wrapped;
                        if (type == null) {
                            type = 'properties';
                        }
                        if (skip == null) {
                            skip = [];
                        }
                        wrapped = {};
                        for (key in obj) {
                            value = obj[key];
                            mappedKey = __indexOf.call(skip, key) >= 0 ? key : "" + type + "[" + key + "]";
                            wrapped[mappedKey] = override != null ? override : value;
                        }
                        return wrapped;
                    },
                    unwrapKeys: function(obj, type, override) {
                        var key, unwrapped, unwrappedKey, value;
                        if (type == null) {
                            type = 'properties';
                        }
                        unwrapped = {};
                        for (key in obj) {
                            value = obj[key];
                            unwrappedKey = key.replace("" + type + "[", "").replace("]", "");
                            unwrapped[unwrappedKey] = override != null ? override : value;
                        }
                        return unwrapped;
                    },
                    extend: function(object, properties) {
                        var key, val;
                        for (key in properties) {
                            val = properties[key];
                            object[key] = val;
                        }
                        return object;
                    },
                    clone: function(object) {
                        var key, newInstance;
                        if ((object == null) || typeof object !== 'object') {
                            return object;
                        }
                        newInstance = new object.constructor();
                        for (key in object) {
                            newInstance[key] = clone(object[key]);
                        }
                        return newInstance;
                    },
                    "delete": function(object, key) {
                        var val;
                        val = object[key];
                        delete object[key];
                        return val;
                    },
                    isArray: Array.isArray || function(value) {
                        return {}.toString.call(value) === '[object Array]';
                    },
                    ensureArray: function(value) {
                        if (CartJS.Utils.isArray(value)) {
                            return value;
                        }
                        if (value != null) {
                            return [value];
                        } else {
                            return [];
                        }
                    },
                    formatMoney: function(value, format, formatName, currency) {
                        var _ref, _ref1;
                        if (currency == null) {
                            currency = '';
                        }
                        if (!currency) {
                            currency = CartJS.settings.currency;
                        }
                        if ((window.Currency != null) && currency !== CartJS.settings.currency) {
                            value = Currency.convert(value, CartJS.settings.currency, currency);
                            if ((((_ref = window.Currency) != null ? _ref.moneyFormats : void 0) != null) && (currency in window.Currency.moneyFormats)) {
                                format = window.Currency.moneyFormats[currency][formatName];
                            }
                        }
                        if (((_ref1 = window.Shopify) != null ? _ref1.formatMoney : void 0) != null) {
                            return Shopify.formatMoney(value, format);
                        } else {
                            CartJS.Utils.warn(FORMAT_MONEY_WARNING);
                            return value;
                        }
                    },
                    getSizedImageUrl: function(src, size) {
                        var _ref, _ref1;
                        if (((_ref = window.Shopify) != null ? (_ref1 = _ref.Image) != null ? _ref1.getSizedImageUrl : void 0 : void 0) != null) {
                            if (src) {
                                return Shopify.Image.getSizedImageUrl(src, size);
                            } else {
                                return Shopify.Image.getSizedImageUrl('https://cdn.shopify.com/s/images/admin/no-image-.gif', size).replace('-_', '-');
                            }
                        } else {
                            if (src) {
                                return src;
                            } else {
                                return 'https://cdn.shopify.com/s/images/admin/no-image-large.gif';
                            }
                        }
                    }
                };

                queue = [];

                processing = false;

                CartJS.Queue = {
                    add: function(url, data, options) {
                        var request;
                        if (options == null) {
                            options = {};
                        }
                        request = {
                            url: url,
                            data: data,
                            type: options.type || 'POST',
                            dataType: options.dataType || 'json',
                            cache: !!options.cache,
                            success: CartJS.Utils.ensureArray(options.success),
                            error: CartJS.Utils.ensureArray(options.error),
                            complete: CartJS.Utils.ensureArray(options.complete)
                        };
                        if (options.updateCart) {
                            request.success.push(CartJS.cart.update);
                        }
                        queue.push(request);
                        if (processing) {
                            return;
                        }
                        jQuery(document).trigger('cart.requestStarted', [CartJS.cart]);
                        return CartJS.Queue.process();
                    },
                    process: function() {
                        var params;
                        if (!queue.length) {
                            processing = false;
                            jQuery(document).trigger('cart.requestComplete', [CartJS.cart]);
                            return;
                        }
                        processing = true;
                        params = queue.shift();
                        params.complete = CartJS.Queue.process;
                        return jQuery.ajax(params);
                    }
                };

                CartJS.Core = {
                    getCart: function(options) {
                        if (options == null) {
                            options = {};
                        }
                        options.type = 'GET';
                        options.updateCart = true;
                        return CartJS.Queue.add('/cart.js', {
                            v: new Date().getTime()
                        }, options);
                    },
                    addItem: function(id, quantity, properties, options) {
                        var data;
                        if (quantity == null) {
                            quantity = 1;
                        }
                        if (properties == null) {
                            properties = {};
                        }
                        if (options == null) {
                            options = {};
                        }
                        const isPreorder = $('body').hasClass('template-product') && $('.sticky__inner').hasClass('sticky__inner--preorder');

                         if (isPreorder) {
                             properties.note = "pre-order";
                         }

                        data = CartJS.Utils.wrapKeys(properties, null, null, ['selling_plan']);
                        data.id = id;
                        data.quantity = quantity;
                        CartJS.Queue.add('/cart/add.js', data, options);
                        return CartJS.Core.getCart();
                    },
                    addItems: function(items, options) {
                        var data;
                        if (options == null) {
                            options = {};
                        }
                        data = {
                            items: items
                        };
                        CartJS.Queue.add('/cart/add.js', data, options);
                        return CartJS.Core.getCart();
                    },
                    updateItem: function(line, quantity, properties, options) {
                        var data;
                        if (properties == null) {
                            properties = {};
                        }
                        if (options == null) {
                            options = {};
                        }
                        data = CartJS.Utils.wrapKeys(properties, null, null, ['selling_plan']);
                        data.line = line;
                        if (quantity != null) {
                            data.quantity = quantity;
                        }
                        options.updateCart = true;
                        return CartJS.Queue.add('/cart/change.js', data, options);
                    },
                    removeItem: function(line, options) {
                        if (options == null) {
                            options = {};
                        }
                        return CartJS.Core.updateItem(line, 0, {}, options);
                    },
                    updateItemById: function(id, quantity, properties, options) {
                        var data;
                        if (properties == null) {
                            properties = {};
                        }
                        if (options == null) {
                            options = {};
                        }
                        data = CartJS.Utils.wrapKeys(properties, null, null, ['selling_plan']);
                        data.id = id;
                        if (quantity != null) {
                            data.quantity = quantity;
                        }
                        options.updateCart = true;
                        return CartJS.Queue.add('/cart/change.js', data, options);
                    },
                    updateItemQuantitiesById: function(updates, options) {
                        if (updates == null) {
                            updates = {};
                        }
                        if (options == null) {
                            options = {};
                        }
                        options.updateCart = true;
                        return CartJS.Queue.add('/cart/update.js', {
                            updates: updates
                        }, options);
                    },
                    removeItemById: function(id, options) {
                        var data;
                        if (options == null) {
                            options = {};
                        }
                        data = {
                            id: id,
                            quantity: 0
                        };
                        options.updateCart = true;
                        return CartJS.Queue.add('/cart/change.js', data, options);
                    },
                    clear: function(options) {
                        if (options == null) {
                            options = {};
                        }
                        options.updateCart = true;
                        return CartJS.Queue.add('/cart/clear.js', {}, options);
                    },
                    getAttribute: function(attributeName, defaultValue) {
                        if (attributeName in CartJS.cart.attributes) {
                            return CartJS.cart.attributes[attributeName];
                        } else {
                            return defaultValue;
                        }
                    },
                    setAttribute: function(attributeName, value, options) {
                        var attributes;
                        if (options == null) {
                            options = {};
                        }
                        attributes = {};
                        attributes[attributeName] = value;
                        return CartJS.Core.setAttributes(attributes, options);
                    },
                    getAttributes: function() {
                        return CartJS.cart.attributes;
                    },
                    setAttributes: function(attributes, options) {
                        if (attributes == null) {
                            attributes = {};
                        }
                        if (options == null) {
                            options = {};
                        }
                        options.updateCart = true;
                        return CartJS.Queue.add('/cart/update.js', CartJS.Utils.wrapKeys(attributes, 'attributes'), options);
                    },
                    clearAttributes: function(options) {
                        if (options == null) {
                            options = {};
                        }
                        options.updateCart = true;
                        return CartJS.Queue.add('/cart/update.js', CartJS.Utils.wrapKeys(CartJS.Core.getAttributes(), 'attributes', ''), options);
                    },
                    getNote: function() {
                        return CartJS.cart.note;
                    },
                    setNote: function(note, options) {
                        if (options == null) {
                            options = {};
                        }
                        options.updateCart = true;
                        return CartJS.Queue.add('/cart/update.js', {
                            note: note
                        }, options);
                    }
                };

                $document = null;

                CartJS.Data = {
                    init: function() {
                        $document = jQuery(document);
                        CartJS.Data.setEventListeners('on');
                        return CartJS.Data.render(null, CartJS.cart);
                    },
                    destroy: function() {
                        return CartJS.Data.setEventListeners('off');
                    },
                    setEventListeners: function(method) {
                        $document[method]('click', '[data-cart-add]', CartJS.Data.add);
                        $document[method]('click', '[data-cart-remove]', CartJS.Data.remove);
                        $document[method]('click', '[data-cart-remove-id]', CartJS.Data.removeById);
                        $document[method]('click', '[data-cart-update]', CartJS.Data.update);
                        $document[method]('click', '[data-cart-update-id]', CartJS.Data.updateById);
                        $document[method]('click', '[data-cart-clear]', CartJS.Data.clear);
                        $document[method]('change', '[data-cart-toggle]', CartJS.Data.toggle);
                        $document[method]('change', '[data-cart-toggle-attribute]', CartJS.Data.toggleAttribute);
                        $document[method]('submit', '[data-cart-submit]', CartJS.Data.submit);
                        return $document[method]('cart.requestComplete', CartJS.Data.render);
                    },
                    add: function(e) {
                        var $this, properties;
                        e.preventDefault();
                        $this = jQuery(this);
                        properties = {};
                        properties.selling_plan = $this.attr('data-cart-selling-plan');
                        return CartJS.Core.addItem($this.attr('data-cart-add'), $this.attr('data-cart-quantity'), properties);
                    },
                    remove: function(e) {
                        var $this;
                        e.preventDefault();
                        $this = jQuery(this);
                        return CartJS.Core.removeItem($this.attr('data-cart-remove'));
                    },
                    removeById: function(e) {
                        var $this;
                        e.preventDefault();
                        $this = jQuery(this);
                        return CartJS.Core.removeItemById($this.attr('data-cart-remove-id'));
                    },
                    update: function(e) {
                        var $this, properties;
                        e.preventDefault();
                        $this = jQuery(this);
                        properties = {};
                        properties.selling_plan = $this.attr('data-cart-selling-plan');
                        return CartJS.Core.updateItem($this.attr('data-cart-update'), $this.attr('data-cart-quantity'), properties);
                    },
                    updateById: function(e) {
                        var $this, properties;
                        e.preventDefault();
                        $this = jQuery(this);
                        properties = {};
                        properties.selling_plan = $this.attr('data-cart-selling-plan');
                        return CartJS.Core.updateItemById($this.attr('data-cart-update-id'), $this.attr('data-cart-quantity'), properties);
                    },
                    clear: function(e) {
                        e.preventDefault();
                        return CartJS.Core.clear();
                    },
                    toggle: function(e) {
                        var $input, id;
                        $input = jQuery(this);
                        id = $input.attr('data-cart-toggle');
                        if ($input.is(':checked')) {
                            return CartJS.Core.addItem(id);
                        } else {
                            return CartJS.Core.removeItemById(id);
                        }
                    },
                    toggleAttribute: function(e) {
                        var $input, attribute;
                        $input = jQuery(this);
                        attribute = $input.attr('data-cart-toggle-attribute');
                        return CartJS.Core.setAttribute(attribute, $input.is(':checked') ? 'Yes' : '');
                    },
                    submit: function(e) {
                        var dataArray, id, properties, quantity;
                        e.preventDefault();
                        dataArray = jQuery(this).serializeArray();
                        id = void 0;
                        quantity = void 0;
                        properties = {};
                        jQuery.each(dataArray, function(i, item) {
                            if (item.name === 'id') {
                                return id = item.value;
                            } else if (item.name === 'quantity') {
                                return quantity = item.value;
                            } else if (item.name === 'selling_plan') {
                                return properties.selling_plan = item.value;
                            } else if (item.name.match(/^properties\[[\w-_ ]*\]$/)) {
                                return properties[item.name] = item.value;
                            }
                        });
                        return CartJS.Core.addItem(id, quantity, CartJS.Utils.unwrapKeys(properties));
                    },
                    render: function(e, cart) {
                        var context;
                        context = {
                            'item_count': cart.item_count,
                            'total_price': cart.total_price,
                            'total_price_money': CartJS.Utils.formatMoney(cart.total_price, CartJS.settings.moneyFormat, 'money_format', (typeof Currency !== "undefined" && Currency !== null ? Currency.currentCurrency : void 0) != null ? Currency.currentCurrency : void 0),
                            'total_price_money_with_currency': CartJS.Utils.formatMoney(cart.total_price, CartJS.settings.moneyWithCurrencyFormat, 'money_with_currency_format', (typeof Currency !== "undefined" && Currency !== null ? Currency.currentCurrency : void 0) != null ? Currency.currentCurrency : void 0)
                        };
                        return jQuery('[data-cart-render]').each(function() {
                            var $this;
                            $this = jQuery(this);
                            return $this.html(context[$this.attr('data-cart-render')]);
                        });
                    }
                };

                if (typeof rivets !== "undefined" && rivets !== null) {
                    CartJS.Rivets = {
                        model: null,
                        boundViews: [],
                        init: function() {
                            return CartJS.Rivets.bindViews();
                        },
                        destroy: function() {
                            return CartJS.Rivets.unbindViews();
                        },
                        bindViews: function() {
                            CartJS.Utils.log('Rivets.js is present, binding views.');
                            CartJS.Rivets.unbindViews();
                            CartJS.Rivets.model = CartJS.Utils.extend({
                                cart: CartJS.cart
                            }, CartJS.settings.rivetsModels);
                            if (window.Currency != null) {
                                CartJS.Rivets.model.Currency = window.Currency;
                            }
                            return jQuery('[data-cart-view]').each(function() {
                                var view;
                                view = rivets.bind(jQuery(this), CartJS.Rivets.model);
                                return CartJS.Rivets.boundViews.push(view);
                            });
                        },
                        unbindViews: function() {
                            var view, _i, _len, _ref;
                            _ref = CartJS.Rivets.boundViews;
                            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                                view = _ref[_i];
                                view.unbind();
                            }
                            return CartJS.Rivets.boundViews = [];
                        }
                    };
                    rivets.formatters.eq = function(a, b) {
                        return a === b;
                    };
                    rivets.formatters.includes = function(a, b) {
                        return a.indexOf(b) >= 0;
                    };
                    rivets.formatters.match = function(a, regexp, flags) {
                        return a.match(new RegExp(regexp, flags));
                    };
                    rivets.formatters.lt = function(a, b) {
                        return a < b;
                    };
                    rivets.formatters.gt = function(a, b) {
                        return a > b;
                    };
                    rivets.formatters.not = function(a) {
                        return !a;
                    };
                    rivets.formatters.empty = function(a) {
                        return !a.length;
                    };
                    rivets.formatters.plus = function(a, b) {
                        return parseInt(a) + parseInt(b);
                    };
                    rivets.formatters.minus = function(a, b) {
                        return parseInt(a) - parseInt(b);
                    };
                    rivets.formatters.times = function(a, b) {
                        return a * b;
                    };
                    rivets.formatters.divided_by = function(a, b) {
                        return a / b;
                    };
                    rivets.formatters.modulo = function(a, b) {
                        return a % b;
                    };
                    rivets.formatters.prepend = function(a, b) {
                        return b + a;
                    };
                    rivets.formatters.append = function(a, b) {
                        return a + b;
                    };
                    rivets.formatters.slice = function(value, start, end) {
                        return value.slice(start, end);
                    };
                    rivets.formatters.pluralize = function(input, singular, plural) {
                        if (plural == null) {
                            plural = singular + 's';
                        }
                        if (CartJS.Utils.isArray(input)) {
                            input = input.length;
                        }
                        if (input === 1) {
                            return singular;
                        } else {
                            return plural;
                        }
                    };
                    rivets.formatters.array_element = function(array, index) {
                        return array[index];
                    };
                    rivets.formatters.array_first = function(array) {
                        return array[0];
                    };
                    rivets.formatters.array_last = function(array) {
                        return array[array.length - 1];
                    };
                    rivets.formatters.money = function(value, currency) {
                        return CartJS.Utils.formatMoney(value, CartJS.settings.moneyFormat, 'money_format', currency);
                    };
                    rivets.formatters.money_with_currency = function(value, currency) {
                        return CartJS.Utils.formatMoney(value, CartJS.settings.moneyWithCurrencyFormat, 'money_with_currency_format', currency);
                    };
                    rivets.formatters.weight = function(grams) {
                        switch (CartJS.settings.weightUnit) {
                            case 'kg':
                                return (grams / 1000).toFixed(CartJS.settings.weightPrecision);
                            case 'oz':
                                return (grams * 0.035274).toFixed(CartJS.settings.weightPrecision);
                            case 'lb':
                                return (grams * 0.00220462).toFixed(CartJS.settings.weightPrecision);
                            default:
                                return grams.toFixed(CartJS.settings.weightPrecision);
                        }
                    };
                    rivets.formatters.weight_with_unit = function(grams) {
                        return rivets.formatters.weight(grams) + CartJS.settings.weightUnit;
                    };
                    rivets.formatters.product_image_size = function(src, size) {
                        return CartJS.Utils.getSizedImageUrl(src, size);
                    };
                    rivets.formatters.moneyWithCurrency = rivets.formatters.money_with_currency;
                    rivets.formatters.weightWithUnit = rivets.formatters.weight_with_unit;
                    rivets.formatters.productImageSize = rivets.formatters.product_image_size;
                } else {
                    CartJS.Rivets = {
                        init: function() {},
                        destroy: function() {}
                    };
                }

                CartJS.factory = function(exports) {
                    exports.init = CartJS.init;
                    exports.configure = CartJS.configure;
                    exports.cart = CartJS.cart;
                    exports.settings = CartJS.settings;
                    exports.getCart = CartJS.Core.getCart;
                    exports.addItem = CartJS.Core.addItem;
                    exports.addItems = CartJS.Core.addItems;
                    exports.updateItem = CartJS.Core.updateItem;
                    exports.updateItemById = CartJS.Core.updateItemById;
                    exports.updateItemQuantitiesById = CartJS.Core.updateItemQuantitiesById;
                    exports.removeItem = CartJS.Core.removeItem;
                    exports.removeItemById = CartJS.Core.removeItemById;
                    exports.clear = CartJS.Core.clear;
                    exports.getAttribute = CartJS.Core.getAttribute;
                    exports.setAttribute = CartJS.Core.setAttribute;
                    exports.getAttributes = CartJS.Core.getAttributes;
                    exports.setAttributes = CartJS.Core.setAttributes;
                    exports.clearAttributes = CartJS.Core.clearAttributes;
                    exports.getNote = CartJS.Core.getNote;
                    exports.setNote = CartJS.Core.setNote;
                    return exports.render = CartJS.Data.render;
                };

                if (true) {
                    CartJS.factory(exports);
                } else {}

            }).call(this);


            /***/ }),

        /***/ 2206:
        /***/ (function(module, exports) {

            var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;(function() {
                // Public sightglass interface.
                function sightglass(obj, keypath, callback, options) {
                    return new Observer(obj, keypath, callback, options)
                }

                // Batteries not included.
                sightglass.adapters = {}

                // Constructs a new keypath observer and kicks things off.
                function Observer(obj, keypath, callback, options) {
                    this.options = options || {}
                    this.options.adapters = this.options.adapters || {}
                    this.obj = obj
                    this.keypath = keypath
                    this.callback = callback
                    this.objectPath = []
                    this.update = this.update.bind(this)
                    this.parse()

                    if (isObject(this.target = this.realize())) {
                        this.set(true, this.key, this.target, this.callback)
                    }
                }

                // Tokenizes the provided keypath string into interface + path tokens for the
                // observer to work with.
                Observer.tokenize = function(keypath, interfaces, root) {
                    var tokens = []
                    var current = {i: root, path: ''}
                    var index, chr

                    for (index = 0; index < keypath.length; index++) {
                        chr = keypath.charAt(index)

                        if (!!~interfaces.indexOf(chr)) {
                            tokens.push(current)
                            current = {i: chr, path: ''}
                        } else {
                            current.path += chr
                        }
                    }

                    tokens.push(current)
                    return tokens
                }

                // Parses the keypath using the interfaces defined on the view. Sets variables
                // for the tokenized keypath as well as the end key.
                Observer.prototype.parse = function() {
                    var interfaces = this.interfaces()
                    var root, path

                    if (!interfaces.length) {
                        error('Must define at least one adapter interface.')
                    }

                    if (!!~interfaces.indexOf(this.keypath[0])) {
                        root = this.keypath[0]
                        path = this.keypath.substr(1)
                    } else {
                        if (typeof (root = this.options.root || sightglass.root) === 'undefined') {
                            error('Must define a default root adapter.')
                        }

                        path = this.keypath
                    }

                    this.tokens = Observer.tokenize(path, interfaces, root)
                    this.key = this.tokens.pop()
                }

                // Realizes the full keypath, attaching observers for every key and correcting
                // old observers to any changed objects in the keypath.
                Observer.prototype.realize = function() {
                    var current = this.obj
                    var unreached = false
                    var prev

                    this.tokens.forEach(function(token, index) {
                        if (isObject(current)) {
                            if (typeof this.objectPath[index] !== 'undefined') {
                                if (current !== (prev = this.objectPath[index])) {
                                    this.set(false, token, prev, this.update)
                                    this.set(true, token, current, this.update)
                                    this.objectPath[index] = current
                                }
                            } else {
                                this.set(true, token, current, this.update)
                                this.objectPath[index] = current
                            }

                            current = this.get(token, current)
                        } else {
                            if (unreached === false) {
                                unreached = index
                            }

                            if (prev = this.objectPath[index]) {
                                this.set(false, token, prev, this.update)
                            }
                        }
                    }, this)

                    if (unreached !== false) {
                        this.objectPath.splice(unreached)
                    }

                    return current
                }

                // Updates the keypath. This is called when any intermediary key is changed.
                Observer.prototype.update = function() {
                    var next, oldValue

                    if ((next = this.realize()) !== this.target) {
                        if (isObject(this.target)) {
                            this.set(false, this.key, this.target, this.callback)
                        }

                        if (isObject(next)) {
                            this.set(true, this.key, next, this.callback)
                        }

                        oldValue = this.value()
                        this.target = next

                        // Always call callback if value is a function. If not a function, call callback only if value changed
                        if (this.value() instanceof Function || this.value() !== oldValue) this.callback()
                    }
                }

                // Reads the current end value of the observed keypath. Returns undefined if
                // the full keypath is unreachable.
                Observer.prototype.value = function() {
                    if (isObject(this.target)) {
                        return this.get(this.key, this.target)
                    }
                }

                // Sets the current end value of the observed keypath. Calling setValue when
                // the full keypath is unreachable is a no-op.
                Observer.prototype.setValue = function(value) {
                    if (isObject(this.target)) {
                        this.adapter(this.key).set(this.target, this.key.path, value)
                    }
                }

                // Gets the provided key on an object.
                Observer.prototype.get = function(key, obj) {
                    return this.adapter(key).get(obj, key.path)
                }

                // Observes or unobserves a callback on the object using the provided key.
                Observer.prototype.set = function(active, key, obj, callback) {
                    var action = active ? 'observe' : 'unobserve'
                    this.adapter(key)[action](obj, key.path, callback)
                }

                // Returns an array of all unique adapter interfaces available.
                Observer.prototype.interfaces = function() {
                    var interfaces = Object.keys(this.options.adapters)

                    Object.keys(sightglass.adapters).forEach(function(i) {
                        if (!~interfaces.indexOf(i)) {
                            interfaces.push(i)
                        }
                    })

                    return interfaces
                }

                // Convenience function to grab the adapter for a specific key.
                Observer.prototype.adapter = function(key) {
                    return this.options.adapters[key.i] ||
                        sightglass.adapters[key.i]
                }

                // Unobserves the entire keypath.
                Observer.prototype.unobserve = function() {
                    var obj

                    this.tokens.forEach(function(token, index) {
                        if (obj = this.objectPath[index]) {
                            this.set(false, token, obj, this.update)
                        }
                    }, this)

                    if (isObject(this.target)) {
                        this.set(false, this.key, this.target, this.callback)
                    }
                }

                // Check if a value is an object than can be observed.
                function isObject(obj) {
                    return typeof obj === 'object' && obj !== null
                }

                // Error thrower.
                function error(message) {
                    throw new Error('[sightglass] ' + message)
                }

                // Export module for Node and the browser.
                if ( true && module.exports) {
                    module.exports = sightglass
                } else if (true) {
                    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function() {
                        return this.sightglass = sightglass
                    }).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
                    __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
                } else {}
            }).call(this);


            /***/ }),

        /***/ 7061:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

            var _typeof = (__webpack_require__(8698)["default"]);

            function _regeneratorRuntime() {
                "use strict";
                /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */

                module.exports = _regeneratorRuntime = function _regeneratorRuntime() {
                    return exports;
                }, module.exports.__esModule = true, module.exports["default"] = module.exports;
                var exports = {},
                    Op = Object.prototype,
                    hasOwn = Op.hasOwnProperty,
                    $Symbol = "function" == typeof Symbol ? Symbol : {},
                    iteratorSymbol = $Symbol.iterator || "@@iterator",
                    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
                    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

                function define(obj, key, value) {
                    return Object.defineProperty(obj, key, {
                        value: value,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }), obj[key];
                }

                try {
                    define({}, "");
                } catch (err) {
                    define = function define(obj, key, value) {
                        return obj[key] = value;
                    };
                }

                function wrap(innerFn, outerFn, self, tryLocsList) {
                    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
                        generator = Object.create(protoGenerator.prototype),
                        context = new Context(tryLocsList || []);
                    return generator._invoke = function (innerFn, self, context) {
                        var state = "suspendedStart";
                        return function (method, arg) {
                            if ("executing" === state) throw new Error("Generator is already running");

                            if ("completed" === state) {
                                if ("throw" === method) throw arg;
                                return doneResult();
                            }

                            for (context.method = method, context.arg = arg;;) {
                                var delegate = context.delegate;

                                if (delegate) {
                                    var delegateResult = maybeInvokeDelegate(delegate, context);

                                    if (delegateResult) {
                                        if (delegateResult === ContinueSentinel) continue;
                                        return delegateResult;
                                    }
                                }

                                if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
                                    if ("suspendedStart" === state) throw state = "completed", context.arg;
                                    context.dispatchException(context.arg);
                                } else "return" === context.method && context.abrupt("return", context.arg);
                                state = "executing";
                                var record = tryCatch(innerFn, self, context);

                                if ("normal" === record.type) {
                                    if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
                                    return {
                                        value: record.arg,
                                        done: context.done
                                    };
                                }

                                "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
                            }
                        };
                    }(innerFn, self, context), generator;
                }

                function tryCatch(fn, obj, arg) {
                    try {
                        return {
                            type: "normal",
                            arg: fn.call(obj, arg)
                        };
                    } catch (err) {
                        return {
                            type: "throw",
                            arg: err
                        };
                    }
                }

                exports.wrap = wrap;
                var ContinueSentinel = {};

                function Generator() {}

                function GeneratorFunction() {}

                function GeneratorFunctionPrototype() {}

                var IteratorPrototype = {};
                define(IteratorPrototype, iteratorSymbol, function () {
                    return this;
                });
                var getProto = Object.getPrototypeOf,
                    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
                NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
                var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);

                function defineIteratorMethods(prototype) {
                    ["next", "throw", "return"].forEach(function (method) {
                        define(prototype, method, function (arg) {
                            return this._invoke(method, arg);
                        });
                    });
                }

                function AsyncIterator(generator, PromiseImpl) {
                    function invoke(method, arg, resolve, reject) {
                        var record = tryCatch(generator[method], generator, arg);

                        if ("throw" !== record.type) {
                            var result = record.arg,
                                value = result.value;
                            return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
                                invoke("next", value, resolve, reject);
                            }, function (err) {
                                invoke("throw", err, resolve, reject);
                            }) : PromiseImpl.resolve(value).then(function (unwrapped) {
                                result.value = unwrapped, resolve(result);
                            }, function (error) {
                                return invoke("throw", error, resolve, reject);
                            });
                        }

                        reject(record.arg);
                    }

                    var previousPromise;

                    this._invoke = function (method, arg) {
                        function callInvokeWithMethodAndArg() {
                            return new PromiseImpl(function (resolve, reject) {
                                invoke(method, arg, resolve, reject);
                            });
                        }

                        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
                    };
                }

                function maybeInvokeDelegate(delegate, context) {
                    var method = delegate.iterator[context.method];

                    if (undefined === method) {
                        if (context.delegate = null, "throw" === context.method) {
                            if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel;
                            context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method");
                        }

                        return ContinueSentinel;
                    }

                    var record = tryCatch(method, delegate.iterator, context.arg);
                    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
                    var info = record.arg;
                    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
                }

                function pushTryEntry(locs) {
                    var entry = {
                        tryLoc: locs[0]
                    };
                    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
                }

                function resetTryEntry(entry) {
                    var record = entry.completion || {};
                    record.type = "normal", delete record.arg, entry.completion = record;
                }

                function Context(tryLocsList) {
                    this.tryEntries = [{
                        tryLoc: "root"
                    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
                }

                function values(iterable) {
                    if (iterable) {
                        var iteratorMethod = iterable[iteratorSymbol];
                        if (iteratorMethod) return iteratorMethod.call(iterable);
                        if ("function" == typeof iterable.next) return iterable;

                        if (!isNaN(iterable.length)) {
                            var i = -1,
                                next = function next() {
                                    for (; ++i < iterable.length;) {
                                        if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
                                    }

                                    return next.value = undefined, next.done = !0, next;
                                };

                            return next.next = next;
                        }
                    }

                    return {
                        next: doneResult
                    };
                }

                function doneResult() {
                    return {
                        value: undefined,
                        done: !0
                    };
                }

                return GeneratorFunction.prototype = GeneratorFunctionPrototype, define(Gp, "constructor", GeneratorFunctionPrototype), define(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
                    var ctor = "function" == typeof genFun && genFun.constructor;
                    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
                }, exports.mark = function (genFun) {
                    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
                }, exports.awrap = function (arg) {
                    return {
                        __await: arg
                    };
                }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
                    return this;
                }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
                    void 0 === PromiseImpl && (PromiseImpl = Promise);
                    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
                    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
                        return result.done ? result.value : iter.next();
                    });
                }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
                    return this;
                }), define(Gp, "toString", function () {
                    return "[object Generator]";
                }), exports.keys = function (object) {
                    var keys = [];

                    for (var key in object) {
                        keys.push(key);
                    }

                    return keys.reverse(), function next() {
                        for (; keys.length;) {
                            var key = keys.pop();
                            if (key in object) return next.value = key, next.done = !1, next;
                        }

                        return next.done = !0, next;
                    };
                }, exports.values = values, Context.prototype = {
                    constructor: Context,
                    reset: function reset(skipTempReset) {
                        if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) {
                            "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
                        }
                    },
                    stop: function stop() {
                        this.done = !0;
                        var rootRecord = this.tryEntries[0].completion;
                        if ("throw" === rootRecord.type) throw rootRecord.arg;
                        return this.rval;
                    },
                    dispatchException: function dispatchException(exception) {
                        if (this.done) throw exception;
                        var context = this;

                        function handle(loc, caught) {
                            return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
                        }

                        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                            var entry = this.tryEntries[i],
                                record = entry.completion;
                            if ("root" === entry.tryLoc) return handle("end");

                            if (entry.tryLoc <= this.prev) {
                                var hasCatch = hasOwn.call(entry, "catchLoc"),
                                    hasFinally = hasOwn.call(entry, "finallyLoc");

                                if (hasCatch && hasFinally) {
                                    if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                                    if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                                } else if (hasCatch) {
                                    if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
                                } else {
                                    if (!hasFinally) throw new Error("try statement without catch or finally");
                                    if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                                }
                            }
                        }
                    },
                    abrupt: function abrupt(type, arg) {
                        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                            var entry = this.tryEntries[i];

                            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                                var finallyEntry = entry;
                                break;
                            }
                        }

                        finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
                        var record = finallyEntry ? finallyEntry.completion : {};
                        return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
                    },
                    complete: function complete(record, afterLoc) {
                        if ("throw" === record.type) throw record.arg;
                        return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
                    },
                    finish: function finish(finallyLoc) {
                        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                            var entry = this.tryEntries[i];
                            if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
                        }
                    },
                    "catch": function _catch(tryLoc) {
                        for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                            var entry = this.tryEntries[i];

                            if (entry.tryLoc === tryLoc) {
                                var record = entry.completion;

                                if ("throw" === record.type) {
                                    var thrown = record.arg;
                                    resetTryEntry(entry);
                                }

                                return thrown;
                            }
                        }

                        throw new Error("illegal catch attempt");
                    },
                    delegateYield: function delegateYield(iterable, resultName, nextLoc) {
                        return this.delegate = {
                            iterator: values(iterable),
                            resultName: resultName,
                            nextLoc: nextLoc
                        }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
                    }
                }, exports;
            }

            module.exports = _regeneratorRuntime, module.exports.__esModule = true, module.exports["default"] = module.exports;

            /***/ }),

        /***/ 8698:
        /***/ ((module) => {

            function _typeof(obj) {
                "@babel/helpers - typeof";

                return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
                    return typeof obj;
                } : function (obj) {
                    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
                }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
            }

            module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

            /***/ }),

        /***/ 4687:
        /***/ ((module, __unused_webpack_exports, __webpack_require__) => {

// TODO(Babel 8): Remove this file.

            var runtime = __webpack_require__(7061)();
            module.exports = runtime;

// Copied from https://github.com/facebook/regenerator/blob/main/packages/runtime/runtime.js#L736=
            try {
                regeneratorRuntime = runtime;
            } catch (accidentalStrictMode) {
                if (typeof globalThis === "object") {
                    globalThis.regeneratorRuntime = runtime;
                } else {
                    Function("r", "regeneratorRuntime = r")(runtime);
                }
            }


            /***/ })

        /******/ 	});
    /************************************************************************/
    /******/ 	// The module cache
    /******/ 	var __webpack_module_cache__ = {};
    /******/
    /******/ 	// The require function
    /******/ 	function __webpack_require__(moduleId) {
        /******/ 		// Check if module is in cache
        /******/ 		var cachedModule = __webpack_module_cache__[moduleId];
        /******/ 		if (cachedModule !== undefined) {
            /******/ 			return cachedModule.exports;
            /******/ 		}
        /******/ 		// Create a new module (and put it into the cache)
        /******/ 		var module = __webpack_module_cache__[moduleId] = {
            /******/ 			id: moduleId,
            /******/ 			loaded: false,
            /******/ 			exports: {}
            /******/ 		};
        /******/
        /******/ 		// Execute the module function
        /******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ 		// Flag the module as loaded
        /******/ 		module.loaded = true;
        /******/
        /******/ 		// Return the exports of the module
        /******/ 		return module.exports;
        /******/ 	}
    /******/
    /************************************************************************/
    /******/ 	/* webpack/runtime/compat get default export */
    /******/ 	(() => {
        /******/ 		// getDefaultExport function for compatibility with non-harmony modules
        /******/ 		__webpack_require__.n = (module) => {
            /******/ 			var getter = module && module.__esModule ?
                /******/ 				() => (module['default']) :
                /******/ 				() => (module);
            /******/ 			__webpack_require__.d(getter, { a: getter });
            /******/ 			return getter;
            /******/ 		};
        /******/ 	})();
    /******/
    /******/ 	/* webpack/runtime/define property getters */
    /******/ 	(() => {
        /******/ 		// define getter functions for harmony exports
        /******/ 		__webpack_require__.d = (exports, definition) => {
            /******/ 			for(var key in definition) {
                /******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
                    /******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
                    /******/ 				}
                /******/ 			}
            /******/ 		};
        /******/ 	})();
    /******/
    /******/ 	/* webpack/runtime/global */
    /******/ 	(() => {
        /******/ 		__webpack_require__.g = (function() {
            /******/ 			if (typeof globalThis === 'object') return globalThis;
            /******/ 			try {
                /******/ 				return this || new Function('return this')();
                /******/ 			} catch (e) {
                /******/ 				if (typeof window === 'object') return window;
                /******/ 			}
            /******/ 		})();
        /******/ 	})();
    /******/
    /******/ 	/* webpack/runtime/hasOwnProperty shorthand */
    /******/ 	(() => {
        /******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
        /******/ 	})();
    /******/
    /******/ 	/* webpack/runtime/node module decorator */
    /******/ 	(() => {
        /******/ 		__webpack_require__.nmd = (module) => {
            /******/ 			module.paths = [];
            /******/ 			if (!module.children) module.children = [];
            /******/ 			return module;
            /******/ 		};
        /******/ 	})();
    /******/
    /************************************************************************/
    var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
    (() => {
        "use strict";


        __webpack_require__(1983);

        var _global = _interopRequireDefault(__webpack_require__(115));

        function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

        if (_global["default"]._babelPolyfill && typeof console !== "undefined" && console.warn) {
            console.warn("@babel/polyfill is loaded more than once on this page. This is probably not desirable/intended " + "and may have consequences if different versions of the polyfills are applied sequentially. " + "If you do need to load the polyfill more than once, use @babel/polyfill/noConflict " + "instead to bypass the warning.");
        }

        _global["default"]._babelPolyfill = true;
    })();

// This entry need to be wrapped in an IIFE because it need to be in strict mode.
    (() => {
        "use strict";

// EXTERNAL MODULE: ./src/scripts/common/cart.js
        var cart = __webpack_require__(9589);
// EXTERNAL MODULE: ./node_modules/prettier/standalone.js
        var standalone = __webpack_require__(3945);
        ;// CONCATENATED MODULE: ./node_modules/ssr-window/ssr-window.esm.js
        /**
         * SSR Window 3.0.0
         * Better handling for window object in SSR environment
         * https://github.com/nolimits4web/ssr-window
         *
         * Copyright 2020, Vladimir Kharlampidi
         *
         * Licensed under MIT
         *
         * Released on: November 9, 2020
         */
        /* eslint-disable no-param-reassign */
        function isObject(obj) {
            return (obj !== null &&
                typeof obj === 'object' &&
                'constructor' in obj &&
                obj.constructor === Object);
        }
        function extend(target, src) {
            if (target === void 0) { target = {}; }
            if (src === void 0) { src = {}; }
            Object.keys(src).forEach(function (key) {
                if (typeof target[key] === 'undefined')
                    target[key] = src[key];
                else if (isObject(src[key]) &&
                    isObject(target[key]) &&
                    Object.keys(src[key]).length > 0) {
                    extend(target[key], src[key]);
                }
            });
        }

        var ssrDocument = {
            body: {},
            addEventListener: function () { },
            removeEventListener: function () { },
            activeElement: {
                blur: function () { },
                nodeName: '',
            },
            querySelector: function () {
                return null;
            },
            querySelectorAll: function () {
                return [];
            },
            getElementById: function () {
                return null;
            },
            createEvent: function () {
                return {
                    initEvent: function () { },
                };
            },
            createElement: function () {
                return {
                    children: [],
                    childNodes: [],
                    style: {},
                    setAttribute: function () { },
                    getElementsByTagName: function () {
                        return [];
                    },
                };
            },
            createElementNS: function () {
                return {};
            },
            importNode: function () {
                return null;
            },
            location: {
                hash: '',
                host: '',
                hostname: '',
                href: '',
                origin: '',
                pathname: '',
                protocol: '',
                search: '',
            },
        };
        function getDocument() {
            var doc = typeof document !== 'undefined' ? document : {};
            extend(doc, ssrDocument);
            return doc;
        }

        var ssrWindow = {
            document: ssrDocument,
            navigator: {
                userAgent: '',
            },
            location: {
                hash: '',
                host: '',
                hostname: '',
                href: '',
                origin: '',
                pathname: '',
                protocol: '',
                search: '',
            },
            history: {
                replaceState: function () { },
                pushState: function () { },
                go: function () { },
                back: function () { },
            },
            CustomEvent: function CustomEvent() {
                return this;
            },
            addEventListener: function () { },
            removeEventListener: function () { },
            getComputedStyle: function () {
                return {
                    getPropertyValue: function () {
                        return '';
                    },
                };
            },
            Image: function () { },
            Date: function () { },
            screen: {},
            setTimeout: function () { },
            clearTimeout: function () { },
            matchMedia: function () {
                return {};
            },
            requestAnimationFrame: function (callback) {
                if (typeof setTimeout === 'undefined') {
                    callback();
                    return null;
                }
                return setTimeout(callback, 0);
            },
            cancelAnimationFrame: function (id) {
                if (typeof setTimeout === 'undefined') {
                    return;
                }
                clearTimeout(id);
            },
        };
        function ssr_window_esm_getWindow() {
            var win = typeof window !== 'undefined' ? window : {};
            extend(win, ssrWindow);
            return win;
        }



        ;// CONCATENATED MODULE: ./node_modules/dom7/dom7.esm.js
        /**
         * Dom7 3.0.0
         * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
         * https://framework7.io/docs/dom7.html
         *
         * Copyright 2020, Vladimir Kharlampidi
         *
         * Licensed under MIT
         *
         * Released on: November 9, 2020
         */


        function _inheritsLoose(subClass, superClass) {
            subClass.prototype = Object.create(superClass.prototype);
            subClass.prototype.constructor = subClass;
            subClass.__proto__ = superClass;
        }

        function _getPrototypeOf(o) {
            _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
                return o.__proto__ || Object.getPrototypeOf(o);
            };
            return _getPrototypeOf(o);
        }

        function _setPrototypeOf(o, p) {
            _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
                o.__proto__ = p;
                return o;
            };

            return _setPrototypeOf(o, p);
        }

        function _isNativeReflectConstruct() {
            if (typeof Reflect === "undefined" || !Reflect.construct) return false;
            if (Reflect.construct.sham) return false;
            if (typeof Proxy === "function") return true;

            try {
                Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
                return true;
            } catch (e) {
                return false;
            }
        }

        function _construct(Parent, args, Class) {
            if (_isNativeReflectConstruct()) {
                _construct = Reflect.construct;
            } else {
                _construct = function _construct(Parent, args, Class) {
                    var a = [null];
                    a.push.apply(a, args);
                    var Constructor = Function.bind.apply(Parent, a);
                    var instance = new Constructor();
                    if (Class) _setPrototypeOf(instance, Class.prototype);
                    return instance;
                };
            }

            return _construct.apply(null, arguments);
        }

        function _isNativeFunction(fn) {
            return Function.toString.call(fn).indexOf("[native code]") !== -1;
        }

        function _wrapNativeSuper(Class) {
            var _cache = typeof Map === "function" ? new Map() : undefined;

            _wrapNativeSuper = function _wrapNativeSuper(Class) {
                if (Class === null || !_isNativeFunction(Class)) return Class;

                if (typeof Class !== "function") {
                    throw new TypeError("Super expression must either be null or a function");
                }

                if (typeof _cache !== "undefined") {
                    if (_cache.has(Class)) return _cache.get(Class);

                    _cache.set(Class, Wrapper);
                }

                function Wrapper() {
                    return _construct(Class, arguments, _getPrototypeOf(this).constructor);
                }

                Wrapper.prototype = Object.create(Class.prototype, {
                    constructor: {
                        value: Wrapper,
                        enumerable: false,
                        writable: true,
                        configurable: true
                    }
                });
                return _setPrototypeOf(Wrapper, Class);
            };

            return _wrapNativeSuper(Class);
        }

        function _assertThisInitialized(self) {
            if (self === void 0) {
                throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            }

            return self;
        }

        /* eslint-disable no-proto */
        function makeReactive(obj) {
            var proto = obj.__proto__;
            Object.defineProperty(obj, '__proto__', {
                get: function get() {
                    return proto;
                },
                set: function set(value) {
                    proto.__proto__ = value;
                }
            });
        }

        var Dom7 = /*#__PURE__*/function (_Array) {
            _inheritsLoose(Dom7, _Array);

            function Dom7(items) {
                var _this;

                _this = _Array.call.apply(_Array, [this].concat(items)) || this;
                makeReactive(_assertThisInitialized(_this));
                return _this;
            }

            return Dom7;
        }( /*#__PURE__*/_wrapNativeSuper(Array));

        function arrayFlat(arr) {
            if (arr === void 0) {
                arr = [];
            }

            var res = [];
            arr.forEach(function (el) {
                if (Array.isArray(el)) {
                    res.push.apply(res, arrayFlat(el));
                } else {
                    res.push(el);
                }
            });
            return res;
        }
        function arrayFilter(arr, callback) {
            return Array.prototype.filter.call(arr, callback);
        }
        function arrayUnique(arr) {
            var uniqueArray = [];

            for (var i = 0; i < arr.length; i += 1) {
                if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
            }

            return uniqueArray;
        }
        function toCamelCase(string) {
            return string.toLowerCase().replace(/-(.)/g, function (match, group) {
                return group.toUpperCase();
            });
        }

        function qsa(selector, context) {
            if (typeof selector !== 'string') {
                return [selector];
            }

            var a = [];
            var res = context.querySelectorAll(selector);

            for (var i = 0; i < res.length; i += 1) {
                a.push(res[i]);
            }

            return a;
        }

        function $(selector, context) {
            var window = ssr_window_esm_getWindow();
            var document = getDocument();
            var arr = [];

            if (!context && selector instanceof Dom7) {
                return selector;
            }

            if (!selector) {
                return new Dom7(arr);
            }

            if (typeof selector === 'string') {
                var html = selector.trim();

                if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
                    var toCreate = 'div';
                    if (html.indexOf('<li') === 0) toCreate = 'ul';
                    if (html.indexOf('<tr') === 0) toCreate = 'tbody';
                    if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
                    if (html.indexOf('<tbody') === 0) toCreate = 'table';
                    if (html.indexOf('<option') === 0) toCreate = 'select';
                    var tempParent = document.createElement(toCreate);
                    tempParent.innerHTML = html;

                    for (var i = 0; i < tempParent.childNodes.length; i += 1) {
                        arr.push(tempParent.childNodes[i]);
                    }
                } else {
                    arr = qsa(selector.trim(), context || document);
                } // arr = qsa(selector, document);

            } else if (selector.nodeType || selector === window || selector === document) {
                arr.push(selector);
            } else if (Array.isArray(selector)) {
                if (selector instanceof Dom7) return selector;
                arr = selector;
            }

            return new Dom7(arrayUnique(arr));
        }

        $.fn = Dom7.prototype;

        function addClass() {
            for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
                classes[_key] = arguments[_key];
            }

            var classNames = arrayFlat(classes.map(function (c) {
                return c.split(' ');
            }));
            this.forEach(function (el) {
                var _el$classList;

                (_el$classList = el.classList).add.apply(_el$classList, classNames);
            });
            return this;
        }

        function removeClass() {
            for (var _len2 = arguments.length, classes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                classes[_key2] = arguments[_key2];
            }

            var classNames = arrayFlat(classes.map(function (c) {
                return c.split(' ');
            }));
            this.forEach(function (el) {
                var _el$classList2;

                (_el$classList2 = el.classList).remove.apply(_el$classList2, classNames);
            });
            return this;
        }

        function toggleClass() {
            for (var _len3 = arguments.length, classes = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                classes[_key3] = arguments[_key3];
            }

            var classNames = arrayFlat(classes.map(function (c) {
                return c.split(' ');
            }));
            this.forEach(function (el) {
                classNames.forEach(function (className) {
                    el.classList.toggle(className);
                });
            });
        }

        function hasClass() {
            for (var _len4 = arguments.length, classes = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
                classes[_key4] = arguments[_key4];
            }

            var classNames = arrayFlat(classes.map(function (c) {
                return c.split(' ');
            }));
            return arrayFilter(this, function (el) {
                return classNames.filter(function (className) {
                    return el.classList.contains(className);
                }).length > 0;
            }).length > 0;
        }

        function attr(attrs, value) {
            if (arguments.length === 1 && typeof attrs === 'string') {
                // Get attr
                if (this[0]) return this[0].getAttribute(attrs);
                return undefined;
            } // Set attrs


            for (var i = 0; i < this.length; i += 1) {
                if (arguments.length === 2) {
                    // String
                    this[i].setAttribute(attrs, value);
                } else {
                    // Object
                    for (var attrName in attrs) {
                        this[i][attrName] = attrs[attrName];
                        this[i].setAttribute(attrName, attrs[attrName]);
                    }
                }
            }

            return this;
        }

        function removeAttr(attr) {
            for (var i = 0; i < this.length; i += 1) {
                this[i].removeAttribute(attr);
            }

            return this;
        }

        function prop(props, value) {
            if (arguments.length === 1 && typeof props === 'string') {
                // Get prop
                if (this[0]) return this[0][props];
            } else {
                // Set props
                for (var i = 0; i < this.length; i += 1) {
                    if (arguments.length === 2) {
                        // String
                        this[i][props] = value;
                    } else {
                        // Object
                        for (var propName in props) {
                            this[i][propName] = props[propName];
                        }
                    }
                }

                return this;
            }

            return this;
        }

        function data(key, value) {
            var el;

            if (typeof value === 'undefined') {
                el = this[0];
                if (!el) return undefined; // Get value

                if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) {
                    return el.dom7ElementDataStorage[key];
                }

                var dataKey = el.getAttribute("data-" + key);

                if (dataKey) {
                    return dataKey;
                }

                return undefined;
            } // Set value


            for (var i = 0; i < this.length; i += 1) {
                el = this[i];
                if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
                el.dom7ElementDataStorage[key] = value;
            }

            return this;
        }

        function removeData(key) {
            for (var i = 0; i < this.length; i += 1) {
                var el = this[i];

                if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
                    el.dom7ElementDataStorage[key] = null;
                    delete el.dom7ElementDataStorage[key];
                }
            }
        }

        function dataset() {
            var el = this[0];
            if (!el) return undefined;
            var dataset = {}; // eslint-disable-line

            if (el.dataset) {
                for (var dataKey in el.dataset) {
                    dataset[dataKey] = el.dataset[dataKey];
                }
            } else {
                for (var i = 0; i < el.attributes.length; i += 1) {
                    var _attr = el.attributes[i];

                    if (_attr.name.indexOf('data-') >= 0) {
                        dataset[toCamelCase(_attr.name.split('data-')[1])] = _attr.value;
                    }
                }
            }

            for (var key in dataset) {
                if (dataset[key] === 'false') dataset[key] = false;else if (dataset[key] === 'true') dataset[key] = true;else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
            }

            return dataset;
        }

        function val(value) {
            if (typeof value === 'undefined') {
                // get value
                var el = this[0];
                if (!el) return undefined;

                if (el.multiple && el.nodeName.toLowerCase() === 'select') {
                    var values = [];

                    for (var i = 0; i < el.selectedOptions.length; i += 1) {
                        values.push(el.selectedOptions[i].value);
                    }

                    return values;
                }

                return el.value;
            } // set value


            for (var _i = 0; _i < this.length; _i += 1) {
                var _el = this[_i];

                if (Array.isArray(value) && _el.multiple && _el.nodeName.toLowerCase() === 'select') {
                    for (var j = 0; j < _el.options.length; j += 1) {
                        _el.options[j].selected = value.indexOf(_el.options[j].value) >= 0;
                    }
                } else {
                    _el.value = value;
                }
            }

            return this;
        }

        function value(value) {
            return this.val(value);
        }

        function transform(transform) {
            for (var i = 0; i < this.length; i += 1) {
                this[i].style.transform = transform;
            }

            return this;
        }

        function transition(duration) {
            for (var i = 0; i < this.length; i += 1) {
                this[i].style.transitionDuration = typeof duration !== 'string' ? duration + "ms" : duration;
            }

            return this;
        }

        function on() {
            for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
                args[_key5] = arguments[_key5];
            }

            var eventType = args[0],
                targetSelector = args[1],
                listener = args[2],
                capture = args[3];

            if (typeof args[1] === 'function') {
                eventType = args[0];
                listener = args[1];
                capture = args[2];
                targetSelector = undefined;
            }

            if (!capture) capture = false;

            function handleLiveEvent(e) {
                var target = e.target;
                if (!target) return;
                var eventData = e.target.dom7EventData || [];

                if (eventData.indexOf(e) < 0) {
                    eventData.unshift(e);
                }

                if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
                    var _parents = $(target).parents(); // eslint-disable-line


                    for (var k = 0; k < _parents.length; k += 1) {
                        if ($(_parents[k]).is(targetSelector)) listener.apply(_parents[k], eventData);
                    }
                }
            }

            function handleEvent(e) {
                var eventData = e && e.target ? e.target.dom7EventData || [] : [];

                if (eventData.indexOf(e) < 0) {
                    eventData.unshift(e);
                }

                listener.apply(this, eventData);
            }

            var events = eventType.split(' ');
            var j;

            for (var i = 0; i < this.length; i += 1) {
                var el = this[i];

                if (!targetSelector) {
                    for (j = 0; j < events.length; j += 1) {
                        var event = events[j];
                        if (!el.dom7Listeners) el.dom7Listeners = {};
                        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
                        el.dom7Listeners[event].push({
                            listener: listener,
                            proxyListener: handleEvent
                        });
                        el.addEventListener(event, handleEvent, capture);
                    }
                } else {
                    // Live events
                    for (j = 0; j < events.length; j += 1) {
                        var _event = events[j];
                        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
                        if (!el.dom7LiveListeners[_event]) el.dom7LiveListeners[_event] = [];

                        el.dom7LiveListeners[_event].push({
                            listener: listener,
                            proxyListener: handleLiveEvent
                        });

                        el.addEventListener(_event, handleLiveEvent, capture);
                    }
                }
            }

            return this;
        }

        function off() {
            for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
                args[_key6] = arguments[_key6];
            }

            var eventType = args[0],
                targetSelector = args[1],
                listener = args[2],
                capture = args[3];

            if (typeof args[1] === 'function') {
                eventType = args[0];
                listener = args[1];
                capture = args[2];
                targetSelector = undefined;
            }

            if (!capture) capture = false;
            var events = eventType.split(' ');

            for (var i = 0; i < events.length; i += 1) {
                var event = events[i];

                for (var j = 0; j < this.length; j += 1) {
                    var el = this[j];
                    var handlers = void 0;

                    if (!targetSelector && el.dom7Listeners) {
                        handlers = el.dom7Listeners[event];
                    } else if (targetSelector && el.dom7LiveListeners) {
                        handlers = el.dom7LiveListeners[event];
                    }

                    if (handlers && handlers.length) {
                        for (var k = handlers.length - 1; k >= 0; k -= 1) {
                            var handler = handlers[k];

                            if (listener && handler.listener === listener) {
                                el.removeEventListener(event, handler.proxyListener, capture);
                                handlers.splice(k, 1);
                            } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                                el.removeEventListener(event, handler.proxyListener, capture);
                                handlers.splice(k, 1);
                            } else if (!listener) {
                                el.removeEventListener(event, handler.proxyListener, capture);
                                handlers.splice(k, 1);
                            }
                        }
                    }
                }
            }

            return this;
        }

        function once() {
            var dom = this;

            for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
                args[_key7] = arguments[_key7];
            }

            var eventName = args[0],
                targetSelector = args[1],
                listener = args[2],
                capture = args[3];

            if (typeof args[1] === 'function') {
                eventName = args[0];
                listener = args[1];
                capture = args[2];
                targetSelector = undefined;
            }

            function onceHandler() {
                for (var _len8 = arguments.length, eventArgs = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++) {
                    eventArgs[_key8] = arguments[_key8];
                }

                listener.apply(this, eventArgs);
                dom.off(eventName, targetSelector, onceHandler, capture);

                if (onceHandler.dom7proxy) {
                    delete onceHandler.dom7proxy;
                }
            }

            onceHandler.dom7proxy = listener;
            return dom.on(eventName, targetSelector, onceHandler, capture);
        }

        function trigger() {
            var window = ssr_window_esm_getWindow();

            for (var _len9 = arguments.length, args = new Array(_len9), _key9 = 0; _key9 < _len9; _key9++) {
                args[_key9] = arguments[_key9];
            }

            var events = args[0].split(' ');
            var eventData = args[1];

            for (var i = 0; i < events.length; i += 1) {
                var event = events[i];

                for (var j = 0; j < this.length; j += 1) {
                    var el = this[j];

                    if (window.CustomEvent) {
                        var evt = new window.CustomEvent(event, {
                            detail: eventData,
                            bubbles: true,
                            cancelable: true
                        });
                        el.dom7EventData = args.filter(function (data, dataIndex) {
                            return dataIndex > 0;
                        });
                        el.dispatchEvent(evt);
                        el.dom7EventData = [];
                        delete el.dom7EventData;
                    }
                }
            }

            return this;
        }

        function transitionEnd(callback) {
            var dom = this;

            function fireCallBack(e) {
                if (e.target !== this) return;
                callback.call(this, e);
                dom.off('transitionend', fireCallBack);
            }

            if (callback) {
                dom.on('transitionend', fireCallBack);
            }

            return this;
        }

        function animationEnd(callback) {
            var dom = this;

            function fireCallBack(e) {
                if (e.target !== this) return;
                callback.call(this, e);
                dom.off('animationend', fireCallBack);
            }

            if (callback) {
                dom.on('animationend', fireCallBack);
            }

            return this;
        }

        function width() {
            var window = getWindow();

            if (this[0] === window) {
                return window.innerWidth;
            }

            if (this.length > 0) {
                return parseFloat(this.css('width'));
            }

            return null;
        }

        function dom7_esm_outerWidth(includeMargins) {
            if (this.length > 0) {
                if (includeMargins) {
                    var _styles = this.styles();

                    return this[0].offsetWidth + parseFloat(_styles.getPropertyValue('margin-right')) + parseFloat(_styles.getPropertyValue('margin-left'));
                }

                return this[0].offsetWidth;
            }

            return null;
        }

        function height() {
            var window = getWindow();

            if (this[0] === window) {
                return window.innerHeight;
            }

            if (this.length > 0) {
                return parseFloat(this.css('height'));
            }

            return null;
        }

        function dom7_esm_outerHeight(includeMargins) {
            if (this.length > 0) {
                if (includeMargins) {
                    var _styles2 = this.styles();

                    return this[0].offsetHeight + parseFloat(_styles2.getPropertyValue('margin-top')) + parseFloat(_styles2.getPropertyValue('margin-bottom'));
                }

                return this[0].offsetHeight;
            }

            return null;
        }

        function offset() {
            if (this.length > 0) {
                var window = ssr_window_esm_getWindow();
                var document = getDocument();
                var el = this[0];
                var box = el.getBoundingClientRect();
                var body = document.body;
                var clientTop = el.clientTop || body.clientTop || 0;
                var clientLeft = el.clientLeft || body.clientLeft || 0;
                var scrollTop = el === window ? window.scrollY : el.scrollTop;
                var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
                return {
                    top: box.top + scrollTop - clientTop,
                    left: box.left + scrollLeft - clientLeft
                };
            }

            return null;
        }

        function hide() {
            for (var i = 0; i < this.length; i += 1) {
                this[i].style.display = 'none';
            }

            return this;
        }

        function show() {
            var window = getWindow();

            for (var i = 0; i < this.length; i += 1) {
                var el = this[i];

                if (el.style.display === 'none') {
                    el.style.display = '';
                }

                if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') {
                    // Still not visible
                    el.style.display = 'block';
                }
            }

            return this;
        }

        function styles() {
            var window = ssr_window_esm_getWindow();
            if (this[0]) return window.getComputedStyle(this[0], null);
            return {};
        }

        function css(props, value) {
            var window = ssr_window_esm_getWindow();
            var i;

            if (arguments.length === 1) {
                if (typeof props === 'string') {
                    // .css('width')
                    if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
                } else {
                    // .css({ width: '100px' })
                    for (i = 0; i < this.length; i += 1) {
                        for (var _prop in props) {
                            this[i].style[_prop] = props[_prop];
                        }
                    }

                    return this;
                }
            }

            if (arguments.length === 2 && typeof props === 'string') {
                // .css('width', '100px')
                for (i = 0; i < this.length; i += 1) {
                    this[i].style[props] = value;
                }

                return this;
            }

            return this;
        }

        function each(callback) {
            if (!callback) return this;
            this.forEach(function (el, index) {
                callback.apply(el, [el, index]);
            });
            return this;
        }

        function filter(callback) {
            var result = arrayFilter(this, callback);
            return $(result);
        }

        function html(html) {
            if (typeof html === 'undefined') {
                return this[0] ? this[0].innerHTML : null;
            }

            for (var i = 0; i < this.length; i += 1) {
                this[i].innerHTML = html;
            }

            return this;
        }

        function dom7_esm_text(text) {
            if (typeof text === 'undefined') {
                return this[0] ? this[0].textContent.trim() : null;
            }

            for (var i = 0; i < this.length; i += 1) {
                this[i].textContent = text;
            }

            return this;
        }

        function is(selector) {
            var window = ssr_window_esm_getWindow();
            var document = getDocument();
            var el = this[0];
            var compareWith;
            var i;
            if (!el || typeof selector === 'undefined') return false;

            if (typeof selector === 'string') {
                if (el.matches) return el.matches(selector);
                if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
                if (el.msMatchesSelector) return el.msMatchesSelector(selector);
                compareWith = $(selector);

                for (i = 0; i < compareWith.length; i += 1) {
                    if (compareWith[i] === el) return true;
                }

                return false;
            }

            if (selector === document) {
                return el === document;
            }

            if (selector === window) {
                return el === window;
            }

            if (selector.nodeType || selector instanceof Dom7) {
                compareWith = selector.nodeType ? [selector] : selector;

                for (i = 0; i < compareWith.length; i += 1) {
                    if (compareWith[i] === el) return true;
                }

                return false;
            }

            return false;
        }

        function index() {
            var child = this[0];
            var i;

            if (child) {
                i = 0; // eslint-disable-next-line

                while ((child = child.previousSibling) !== null) {
                    if (child.nodeType === 1) i += 1;
                }

                return i;
            }

            return undefined;
        }

        function eq(index) {
            if (typeof index === 'undefined') return this;
            var length = this.length;

            if (index > length - 1) {
                return $([]);
            }

            if (index < 0) {
                var returnIndex = length + index;
                if (returnIndex < 0) return $([]);
                return $([this[returnIndex]]);
            }

            return $([this[index]]);
        }

        function append() {
            var newChild;
            var document = getDocument();

            for (var k = 0; k < arguments.length; k += 1) {
                newChild = k < 0 || arguments.length <= k ? undefined : arguments[k];

                for (var i = 0; i < this.length; i += 1) {
                    if (typeof newChild === 'string') {
                        var tempDiv = document.createElement('div');
                        tempDiv.innerHTML = newChild;

                        while (tempDiv.firstChild) {
                            this[i].appendChild(tempDiv.firstChild);
                        }
                    } else if (newChild instanceof Dom7) {
                        for (var j = 0; j < newChild.length; j += 1) {
                            this[i].appendChild(newChild[j]);
                        }
                    } else {
                        this[i].appendChild(newChild);
                    }
                }
            }

            return this;
        }

        function appendTo(parent) {
            $(parent).append(this);
            return this;
        }

        function prepend(newChild) {
            var document = getDocument();
            var i;
            var j;

            for (i = 0; i < this.length; i += 1) {
                if (typeof newChild === 'string') {
                    var tempDiv = document.createElement('div');
                    tempDiv.innerHTML = newChild;

                    for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
                        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
                    }
                } else if (newChild instanceof Dom7) {
                    for (j = 0; j < newChild.length; j += 1) {
                        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
                    }
                } else {
                    this[i].insertBefore(newChild, this[i].childNodes[0]);
                }
            }

            return this;
        }

        function prependTo(parent) {
            $(parent).prepend(this);
            return this;
        }

        function insertBefore(selector) {
            var before = $(selector);

            for (var i = 0; i < this.length; i += 1) {
                if (before.length === 1) {
                    before[0].parentNode.insertBefore(this[i], before[0]);
                } else if (before.length > 1) {
                    for (var j = 0; j < before.length; j += 1) {
                        before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
                    }
                }
            }
        }

        function insertAfter(selector) {
            var after = $(selector);

            for (var i = 0; i < this.length; i += 1) {
                if (after.length === 1) {
                    after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
                } else if (after.length > 1) {
                    for (var j = 0; j < after.length; j += 1) {
                        after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
                    }
                }
            }
        }

        function next(selector) {
            if (this.length > 0) {
                if (selector) {
                    if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
                        return $([this[0].nextElementSibling]);
                    }

                    return $([]);
                }

                if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
                return $([]);
            }

            return $([]);
        }

        function nextAll(selector) {
            var nextEls = [];
            var el = this[0];
            if (!el) return $([]);

            while (el.nextElementSibling) {
                var _next = el.nextElementSibling; // eslint-disable-line

                if (selector) {
                    if ($(_next).is(selector)) nextEls.push(_next);
                } else nextEls.push(_next);

                el = _next;
            }

            return $(nextEls);
        }

        function prev(selector) {
            if (this.length > 0) {
                var el = this[0];

                if (selector) {
                    if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
                        return $([el.previousElementSibling]);
                    }

                    return $([]);
                }

                if (el.previousElementSibling) return $([el.previousElementSibling]);
                return $([]);
            }

            return $([]);
        }

        function prevAll(selector) {
            var prevEls = [];
            var el = this[0];
            if (!el) return $([]);

            while (el.previousElementSibling) {
                var _prev = el.previousElementSibling; // eslint-disable-line

                if (selector) {
                    if ($(_prev).is(selector)) prevEls.push(_prev);
                } else prevEls.push(_prev);

                el = _prev;
            }

            return $(prevEls);
        }

        function siblings(selector) {
            return this.nextAll(selector).add(this.prevAll(selector));
        }

        function dom7_esm_parent(selector) {
            var parents = []; // eslint-disable-line

            for (var i = 0; i < this.length; i += 1) {
                if (this[i].parentNode !== null) {
                    if (selector) {
                        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
                    } else {
                        parents.push(this[i].parentNode);
                    }
                }
            }

            return $(parents);
        }

        function parents(selector) {
            var parents = []; // eslint-disable-line

            for (var i = 0; i < this.length; i += 1) {
                var _parent = this[i].parentNode; // eslint-disable-line

                while (_parent) {
                    if (selector) {
                        if ($(_parent).is(selector)) parents.push(_parent);
                    } else {
                        parents.push(_parent);
                    }

                    _parent = _parent.parentNode;
                }
            }

            return $(parents);
        }

        function closest(selector) {
            var closest = this; // eslint-disable-line

            if (typeof selector === 'undefined') {
                return $([]);
            }

            if (!closest.is(selector)) {
                closest = closest.parents(selector).eq(0);
            }

            return closest;
        }

        function find(selector) {
            var foundElements = [];

            for (var i = 0; i < this.length; i += 1) {
                var found = this[i].querySelectorAll(selector);

                for (var j = 0; j < found.length; j += 1) {
                    foundElements.push(found[j]);
                }
            }

            return $(foundElements);
        }

        function children(selector) {
            var children = []; // eslint-disable-line

            for (var i = 0; i < this.length; i += 1) {
                var childNodes = this[i].children;

                for (var j = 0; j < childNodes.length; j += 1) {
                    if (!selector || $(childNodes[j]).is(selector)) {
                        children.push(childNodes[j]);
                    }
                }
            }

            return $(children);
        }

        function remove() {
            for (var i = 0; i < this.length; i += 1) {
                if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
            }

            return this;
        }

        function detach() {
            return this.remove();
        }

        function add() {
            var dom = this;
            var i;
            var j;

            for (var _len10 = arguments.length, els = new Array(_len10), _key10 = 0; _key10 < _len10; _key10++) {
                els[_key10] = arguments[_key10];
            }

            for (i = 0; i < els.length; i += 1) {
                var toAdd = $(els[i]);

                for (j = 0; j < toAdd.length; j += 1) {
                    dom.push(toAdd[j]);
                }
            }

            return dom;
        }

        function empty() {
            for (var i = 0; i < this.length; i += 1) {
                var el = this[i];

                if (el.nodeType === 1) {
                    for (var j = 0; j < el.childNodes.length; j += 1) {
                        if (el.childNodes[j].parentNode) {
                            el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
                        }
                    }

                    el.textContent = '';
                }
            }

            return this;
        }

        function scrollTo() {
            var window = getWindow();

            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            var left = args[0],
                top = args[1],
                duration = args[2],
                easing = args[3],
                callback = args[4];

            if (args.length === 4 && typeof easing === 'function') {
                callback = easing;
                left = args[0];
                top = args[1];
                duration = args[2];
                callback = args[3];
                easing = args[4];
            }

            if (typeof easing === 'undefined') easing = 'swing';
            return this.each(function animate() {
                var el = this;
                var currentTop;
                var currentLeft;
                var maxTop;
                var maxLeft;
                var newTop;
                var newLeft;
                var scrollTop; // eslint-disable-line

                var scrollLeft; // eslint-disable-line

                var animateTop = top > 0 || top === 0;
                var animateLeft = left > 0 || left === 0;

                if (typeof easing === 'undefined') {
                    easing = 'swing';
                }

                if (animateTop) {
                    currentTop = el.scrollTop;

                    if (!duration) {
                        el.scrollTop = top;
                    }
                }

                if (animateLeft) {
                    currentLeft = el.scrollLeft;

                    if (!duration) {
                        el.scrollLeft = left;
                    }
                }

                if (!duration) return;

                if (animateTop) {
                    maxTop = el.scrollHeight - el.offsetHeight;
                    newTop = Math.max(Math.min(top, maxTop), 0);
                }

                if (animateLeft) {
                    maxLeft = el.scrollWidth - el.offsetWidth;
                    newLeft = Math.max(Math.min(left, maxLeft), 0);
                }

                var startTime = null;
                if (animateTop && newTop === currentTop) animateTop = false;
                if (animateLeft && newLeft === currentLeft) animateLeft = false;

                function render(time) {
                    if (time === void 0) {
                        time = new Date().getTime();
                    }

                    if (startTime === null) {
                        startTime = time;
                    }

                    var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
                    var easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
                    var done;
                    if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
                    if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);

                    if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                        el.scrollTop = newTop;
                        done = true;
                    }

                    if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                        el.scrollTop = newTop;
                        done = true;
                    }

                    if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                        el.scrollLeft = newLeft;
                        done = true;
                    }

                    if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                        el.scrollLeft = newLeft;
                        done = true;
                    }

                    if (done) {
                        if (callback) callback();
                        return;
                    }

                    if (animateTop) el.scrollTop = scrollTop;
                    if (animateLeft) el.scrollLeft = scrollLeft;
                    window.requestAnimationFrame(render);
                }

                window.requestAnimationFrame(render);
            });
        } // scrollTop(top, duration, easing, callback) {


        function scrollTop() {
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            var top = args[0],
                duration = args[1],
                easing = args[2],
                callback = args[3];

            if (args.length === 3 && typeof easing === 'function') {
                top = args[0];
                duration = args[1];
                callback = args[2];
                easing = args[3];
            }

            var dom = this;

            if (typeof top === 'undefined') {
                if (dom.length > 0) return dom[0].scrollTop;
                return null;
            }

            return dom.scrollTo(undefined, top, duration, easing, callback);
        }

        function scrollLeft() {
            for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
                args[_key3] = arguments[_key3];
            }

            var left = args[0],
                duration = args[1],
                easing = args[2],
                callback = args[3];

            if (args.length === 3 && typeof easing === 'function') {
                left = args[0];
                duration = args[1];
                callback = args[2];
                easing = args[3];
            }

            var dom = this;

            if (typeof left === 'undefined') {
                if (dom.length > 0) return dom[0].scrollLeft;
                return null;
            }

            return dom.scrollTo(left, undefined, duration, easing, callback);
        }

        function animate(initialProps, initialParams) {
            var window = getWindow();
            var els = this;
            var a = {
                props: Object.assign({}, initialProps),
                params: Object.assign({
                    duration: 300,
                    easing: 'swing' // or 'linear'

                    /* Callbacks
      begin(elements)
      complete(elements)
      progress(elements, complete, remaining, start, tweenValue)
      */

                }, initialParams),
                elements: els,
                animating: false,
                que: [],
                easingProgress: function easingProgress(easing, progress) {
                    if (easing === 'swing') {
                        return 0.5 - Math.cos(progress * Math.PI) / 2;
                    }

                    if (typeof easing === 'function') {
                        return easing(progress);
                    }

                    return progress;
                },
                stop: function stop() {
                    if (a.frameId) {
                        window.cancelAnimationFrame(a.frameId);
                    }

                    a.animating = false;
                    a.elements.each(function (el) {
                        var element = el;
                        delete element.dom7AnimateInstance;
                    });
                    a.que = [];
                },
                done: function done(complete) {
                    a.animating = false;
                    a.elements.each(function (el) {
                        var element = el;
                        delete element.dom7AnimateInstance;
                    });
                    if (complete) complete(els);

                    if (a.que.length > 0) {
                        var que = a.que.shift();
                        a.animate(que[0], que[1]);
                    }
                },
                animate: function animate(props, params) {
                    if (a.animating) {
                        a.que.push([props, params]);
                        return a;
                    }

                    var elements = []; // Define & Cache Initials & Units

                    a.elements.each(function (el, index) {
                        var initialFullValue;
                        var initialValue;
                        var unit;
                        var finalValue;
                        var finalFullValue;
                        if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                        elements[index] = {
                            container: el
                        };
                        Object.keys(props).forEach(function (prop) {
                            initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                            initialValue = parseFloat(initialFullValue);
                            unit = initialFullValue.replace(initialValue, '');
                            finalValue = parseFloat(props[prop]);
                            finalFullValue = props[prop] + unit;
                            elements[index][prop] = {
                                initialFullValue: initialFullValue,
                                initialValue: initialValue,
                                unit: unit,
                                finalValue: finalValue,
                                finalFullValue: finalFullValue,
                                currentValue: initialValue
                            };
                        });
                    });
                    var startTime = null;
                    var time;
                    var elementsDone = 0;
                    var propsDone = 0;
                    var done;
                    var began = false;
                    a.animating = true;

                    function render() {
                        time = new Date().getTime();
                        var progress;
                        var easeProgress; // let el;

                        if (!began) {
                            began = true;
                            if (params.begin) params.begin(els);
                        }

                        if (startTime === null) {
                            startTime = time;
                        }

                        if (params.progress) {
                            // eslint-disable-next-line
                            params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                        }

                        elements.forEach(function (element) {
                            var el = element;
                            if (done || el.done) return;
                            Object.keys(props).forEach(function (prop) {
                                if (done || el.done) return;
                                progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                                easeProgress = a.easingProgress(params.easing, progress);
                                var _el$prop = el[prop],
                                    initialValue = _el$prop.initialValue,
                                    finalValue = _el$prop.finalValue,
                                    unit = _el$prop.unit;
                                el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                                var currentValue = el[prop].currentValue;

                                if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                                    el.container.style[prop] = finalValue + unit;
                                    propsDone += 1;

                                    if (propsDone === Object.keys(props).length) {
                                        el.done = true;
                                        elementsDone += 1;
                                    }

                                    if (elementsDone === elements.length) {
                                        done = true;
                                    }
                                }

                                if (done) {
                                    a.done(params.complete);
                                    return;
                                }

                                el.container.style[prop] = currentValue + unit;
                            });
                        });
                        if (done) return; // Then call

                        a.frameId = window.requestAnimationFrame(render);
                    }

                    a.frameId = window.requestAnimationFrame(render);
                    return a;
                }
            };

            if (a.elements.length === 0) {
                return els;
            }

            var animateInstance;

            for (var i = 0; i < a.elements.length; i += 1) {
                if (a.elements[i].dom7AnimateInstance) {
                    animateInstance = a.elements[i].dom7AnimateInstance;
                } else a.elements[i].dom7AnimateInstance = a;
            }

            if (!animateInstance) {
                animateInstance = a;
            }

            if (initialProps === 'stop') {
                animateInstance.stop();
            } else {
                animateInstance.animate(a.props, a.params);
            }

            return els;
        }

        function stop() {
            var els = this;

            for (var i = 0; i < els.length; i += 1) {
                if (els[i].dom7AnimateInstance) {
                    els[i].dom7AnimateInstance.stop();
                }
            }
        }

        var noTrigger = 'resize scroll'.split(' ');

        function shortcut(name) {
            function eventHandler() {
                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                if (typeof args[0] === 'undefined') {
                    for (var i = 0; i < this.length; i += 1) {
                        if (noTrigger.indexOf(name) < 0) {
                            if (name in this[i]) this[i][name]();else {
                                $(this[i]).trigger(name);
                            }
                        }
                    }

                    return this;
                }

                return this.on.apply(this, [name].concat(args));
            }

            return eventHandler;
        }

        var click = shortcut('click');
        var dom7_esm_blur = shortcut('blur');
        var dom7_esm_focus = shortcut('focus');
        var focusin = shortcut('focusin');
        var focusout = shortcut('focusout');
        var keyup = shortcut('keyup');
        var keydown = shortcut('keydown');
        var keypress = shortcut('keypress');
        var dom7_esm_submit = shortcut('submit');
        var change = shortcut('change');
        var mousedown = shortcut('mousedown');
        var mousemove = shortcut('mousemove');
        var mouseup = shortcut('mouseup');
        var mouseenter = shortcut('mouseenter');
        var mouseleave = shortcut('mouseleave');
        var mouseout = shortcut('mouseout');
        var mouseover = shortcut('mouseover');
        var touchstart = shortcut('touchstart');
        var touchend = shortcut('touchend');
        var touchmove = shortcut('touchmove');
        var resize = shortcut('resize');
        var dom7_esm_scroll = shortcut('scroll');

        /* harmony default export */ const dom7_esm = ((/* unused pure expression or super */ null && ($)));


        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/utils/dom.js

        var Methods = {
            addClass: addClass,
            removeClass: removeClass,
            hasClass: hasClass,
            toggleClass: toggleClass,
            attr: attr,
            removeAttr: removeAttr,
            transform: transform,
            transition: transition,
            on: on,
            off: off,
            trigger: trigger,
            transitionEnd: transitionEnd,
            outerWidth: dom7_esm_outerWidth,
            outerHeight: dom7_esm_outerHeight,
            styles: styles,
            offset: offset,
            css: css,
            each: each,
            html: html,
            text: dom7_esm_text,
            is: is,
            index: index,
            eq: eq,
            append: append,
            prepend: prepend,
            next: next,
            nextAll: nextAll,
            prev: prev,
            prevAll: prevAll,
            parent: dom7_esm_parent,
            parents: parents,
            closest: closest,
            find: find,
            children: children,
            filter: filter,
            remove: remove
        };
        Object.keys(Methods).forEach(function (methodName) {
            Object.defineProperty($.fn, methodName, {
                value: Methods[methodName],
                writable: true
            });
        });
        /* harmony default export */ const dom = ($);
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/utils/utils.js


        function deleteProps(obj) {
            var object = obj;
            Object.keys(object).forEach(function (key) {
                try {
                    object[key] = null;
                } catch (e) {// no getter for object
                }

                try {
                    delete object[key];
                } catch (e) {// something got wrong
                }
            });
        }

        function nextTick(callback, delay) {
            if (delay === void 0) {
                delay = 0;
            }

            return setTimeout(callback, delay);
        }

        function now() {
            return Date.now();
        }

        function utils_getComputedStyle(el) {
            var window = ssr_window_esm_getWindow();
            var style;

            if (window.getComputedStyle) {
                style = window.getComputedStyle(el, null);
            }

            if (!style && el.currentStyle) {
                style = el.currentStyle;
            }

            if (!style) {
                style = el.style;
            }

            return style;
        }

        function getTranslate(el, axis) {
            if (axis === void 0) {
                axis = 'x';
            }

            var window = ssr_window_esm_getWindow();
            var matrix;
            var curTransform;
            var transformMatrix;
            var curStyle = utils_getComputedStyle(el, null);

            if (window.WebKitCSSMatrix) {
                curTransform = curStyle.transform || curStyle.webkitTransform;

                if (curTransform.split(',').length > 6) {
                    curTransform = curTransform.split(', ').map(function (a) {
                        return a.replace(',', '.');
                    }).join(', ');
                } // Some old versions of Webkit choke when 'none' is passed; pass
                // empty string instead in this case


                transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
            } else {
                transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
                matrix = transformMatrix.toString().split(',');
            }

            if (axis === 'x') {
                // Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
                else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
                else curTransform = parseFloat(matrix[4]);
            }

            if (axis === 'y') {
                // Latest Chrome and webkits Fix
                if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
                else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
                else curTransform = parseFloat(matrix[5]);
            }

            return curTransform || 0;
        }

        function utils_isObject(o) {
            return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
        }

        function isNode(node) {
            // eslint-disable-next-line
            if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
                return node instanceof HTMLElement;
            }

            return node && (node.nodeType === 1 || node.nodeType === 11);
        }

        function utils_extend() {
            var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
            var noExtend = ['__proto__', 'constructor', 'prototype'];

            for (var i = 1; i < arguments.length; i += 1) {
                var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];

                if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
                    var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
                        return noExtend.indexOf(key) < 0;
                    });

                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
                        var nextKey = keysArray[nextIndex];
                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

                        if (desc !== undefined && desc.enumerable) {
                            if (utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
                                if (nextSource[nextKey].__swiper__) {
                                    to[nextKey] = nextSource[nextKey];
                                } else {
                                    utils_extend(to[nextKey], nextSource[nextKey]);
                                }
                            } else if (!utils_isObject(to[nextKey]) && utils_isObject(nextSource[nextKey])) {
                                to[nextKey] = {};

                                if (nextSource[nextKey].__swiper__) {
                                    to[nextKey] = nextSource[nextKey];
                                } else {
                                    utils_extend(to[nextKey], nextSource[nextKey]);
                                }
                            } else {
                                to[nextKey] = nextSource[nextKey];
                            }
                        }
                    }
                }
            }

            return to;
        }

        function bindModuleMethods(instance, obj) {
            Object.keys(obj).forEach(function (key) {
                if (utils_isObject(obj[key])) {
                    Object.keys(obj[key]).forEach(function (subKey) {
                        if (typeof obj[key][subKey] === 'function') {
                            obj[key][subKey] = obj[key][subKey].bind(instance);
                        }
                    });
                }

                instance[key] = obj[key];
            });
        }

        function classesToSelector(classes) {
            if (classes === void 0) {
                classes = '';
            }

            return "." + classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
                .replace(/ /g, '.');
        }

        function createElementIfNotDefined($container, params, createElements, checkProps) {
            var document = getDocument();

            if (createElements) {
                Object.keys(checkProps).forEach(function (key) {
                    if (!params[key] && params.auto === true) {
                        var element = document.createElement('div');
                        element.className = checkProps[key];
                        $container.append(element);
                        params[key] = element;
                    }
                });
            }

            return params;
        }


        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/utils/get-support.js

        var support;

        function calcSupport() {
            var window = ssr_window_esm_getWindow();
            var document = getDocument();
            return {
                touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
                pointerEvents: !!window.PointerEvent && 'maxTouchPoints' in window.navigator && window.navigator.maxTouchPoints >= 0,
                observer: function checkObserver() {
                    return 'MutationObserver' in window || 'WebkitMutationObserver' in window;
                }(),
                passiveListener: function checkPassiveListener() {
                    var supportsPassive = false;

                    try {
                        var opts = Object.defineProperty({}, 'passive', {
                            // eslint-disable-next-line
                            get: function get() {
                                supportsPassive = true;
                            }
                        });
                        window.addEventListener('testPassiveListener', null, opts);
                    } catch (e) {// No support
                    }

                    return supportsPassive;
                }(),
                gestures: function checkGestures() {
                    return 'ongesturestart' in window;
                }()
            };
        }

        function getSupport() {
            if (!support) {
                support = calcSupport();
            }

            return support;
        }


        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/utils/get-device.js


        var device;

        function calcDevice(_temp) {
            var _ref = _temp === void 0 ? {} : _temp,
                userAgent = _ref.userAgent;

            var support = getSupport();
            var window = ssr_window_esm_getWindow();
            var platform = window.navigator.platform;
            var ua = userAgent || window.navigator.userAgent;
            var device = {
                ios: false,
                android: false
            };
            var screenWidth = window.screen.width;
            var screenHeight = window.screen.height;
            var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

            var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
            var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
            var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
            var windows = platform === 'Win32';
            var macos = platform === 'MacIntel'; // iPadOs 13 fix

            var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

            if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + "x" + screenHeight) >= 0) {
                ipad = ua.match(/(Version)\/([\d.]+)/);
                if (!ipad) ipad = [0, 1, '13_0_0'];
                macos = false;
            } // Android


            if (android && !windows) {
                device.os = 'android';
                device.android = true;
            }

            if (ipad || iphone || ipod) {
                device.os = 'ios';
                device.ios = true;
            } // Export object


            return device;
        }

        function getDevice(overrides) {
            if (overrides === void 0) {
                overrides = {};
            }

            if (!device) {
                device = calcDevice(overrides);
            }

            return device;
        }


        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/utils/get-browser.js

        var browser;

        function calcBrowser() {
            var window = ssr_window_esm_getWindow();

            function isSafari() {
                var ua = window.navigator.userAgent.toLowerCase();
                return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
            }

            return {
                isEdge: !!window.navigator.userAgent.match(/Edge/g),
                isSafari: isSafari(),
                isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
            };
        }

        function getBrowser() {
            if (!browser) {
                browser = calcBrowser();
            }

            return browser;
        }


        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/modules/resize/resize.js



        var supportsResizeObserver = function supportsResizeObserver() {
            var window = ssr_window_esm_getWindow();
            return typeof window.ResizeObserver !== 'undefined';
        };

        /* harmony default export */ const resize_resize = ({
            name: 'resize',
            create: function create() {
                var swiper = this;
                utils_extend(swiper, {
                    resize: {
                        observer: null,
                        createObserver: function createObserver() {
                            if (!swiper || swiper.destroyed || !swiper.initialized) return;
                            swiper.resize.observer = new ResizeObserver(function (entries) {
                                var width = swiper.width,
                                    height = swiper.height;
                                var newWidth = width;
                                var newHeight = height;
                                entries.forEach(function (_ref) {
                                    var contentBoxSize = _ref.contentBoxSize,
                                        contentRect = _ref.contentRect,
                                        target = _ref.target;
                                    if (target && target !== swiper.el) return;
                                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                                });

                                if (newWidth !== width || newHeight !== height) {
                                    swiper.resize.resizeHandler();
                                }
                            });
                            swiper.resize.observer.observe(swiper.el);
                        },
                        removeObserver: function removeObserver() {
                            if (swiper.resize.observer && swiper.resize.observer.unobserve && swiper.el) {
                                swiper.resize.observer.unobserve(swiper.el);
                                swiper.resize.observer = null;
                            }
                        },
                        resizeHandler: function resizeHandler() {
                            if (!swiper || swiper.destroyed || !swiper.initialized) return;
                            swiper.emit('beforeResize');
                            swiper.emit('resize');
                        },
                        orientationChangeHandler: function orientationChangeHandler() {
                            if (!swiper || swiper.destroyed || !swiper.initialized) return;
                            swiper.emit('orientationchange');
                        }
                    }
                });
            },
            on: {
                init: function init(swiper) {
                    var window = ssr_window_esm_getWindow();

                    if (swiper.params.resizeObserver && supportsResizeObserver()) {
                        swiper.resize.createObserver();
                        return;
                    } // Emit resize


                    window.addEventListener('resize', swiper.resize.resizeHandler); // Emit orientationchange

                    window.addEventListener('orientationchange', swiper.resize.orientationChangeHandler);
                },
                destroy: function destroy(swiper) {
                    var window = ssr_window_esm_getWindow();
                    swiper.resize.removeObserver();
                    window.removeEventListener('resize', swiper.resize.resizeHandler);
                    window.removeEventListener('orientationchange', swiper.resize.orientationChangeHandler);
                }
            }
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/modules/observer/observer.js
        function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



        var Observer = {
            attach: function attach(target, options) {
                if (options === void 0) {
                    options = {};
                }

                var window = ssr_window_esm_getWindow();
                var swiper = this;
                var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
                var observer = new ObserverFunc(function (mutations) {
                    // The observerUpdate event should only be triggered
                    // once despite the number of mutations.  Additional
                    // triggers are redundant and are very costly
                    if (mutations.length === 1) {
                        swiper.emit('observerUpdate', mutations[0]);
                        return;
                    }

                    var observerUpdate = function observerUpdate() {
                        swiper.emit('observerUpdate', mutations[0]);
                    };

                    if (window.requestAnimationFrame) {
                        window.requestAnimationFrame(observerUpdate);
                    } else {
                        window.setTimeout(observerUpdate, 0);
                    }
                });
                observer.observe(target, {
                    attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
                    childList: typeof options.childList === 'undefined' ? true : options.childList,
                    characterData: typeof options.characterData === 'undefined' ? true : options.characterData
                });
                swiper.observer.observers.push(observer);
            },
            init: function init() {
                var swiper = this;
                if (!swiper.support.observer || !swiper.params.observer) return;

                if (swiper.params.observeParents) {
                    var containerParents = swiper.$el.parents();

                    for (var i = 0; i < containerParents.length; i += 1) {
                        swiper.observer.attach(containerParents[i]);
                    }
                } // Observe container


                swiper.observer.attach(swiper.$el[0], {
                    childList: swiper.params.observeSlideChildren
                }); // Observe wrapper

                swiper.observer.attach(swiper.$wrapperEl[0], {
                    attributes: false
                });
            },
            destroy: function destroy() {
                var swiper = this;
                swiper.observer.observers.forEach(function (observer) {
                    observer.disconnect();
                });
                swiper.observer.observers = [];
            }
        };
        /* harmony default export */ const observer = ({
            name: 'observer',
            params: {
                observer: false,
                observeParents: false,
                observeSlideChildren: false
            },
            create: function create() {
                var swiper = this;
                bindModuleMethods(swiper, {
                    observer: _extends({}, Observer, {
                        observers: []
                    })
                });
            },
            on: {
                init: function init(swiper) {
                    swiper.observer.init();
                },
                destroy: function destroy(swiper) {
                    swiper.observer.destroy();
                }
            }
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/modular.js

        /* harmony default export */ const modular = ({
            useParams: function useParams(instanceParams) {
                var instance = this;
                if (!instance.modules) return;
                Object.keys(instance.modules).forEach(function (moduleName) {
                    var module = instance.modules[moduleName]; // Extend params

                    if (module.params) {
                        utils_extend(instanceParams, module.params);
                    }
                });
            },
            useModules: function useModules(modulesParams) {
                if (modulesParams === void 0) {
                    modulesParams = {};
                }

                var instance = this;
                if (!instance.modules) return;
                Object.keys(instance.modules).forEach(function (moduleName) {
                    var module = instance.modules[moduleName];
                    var moduleParams = modulesParams[moduleName] || {}; // Add event listeners

                    if (module.on && instance.on) {
                        Object.keys(module.on).forEach(function (moduleEventName) {
                            instance.on(moduleEventName, module.on[moduleEventName]);
                        });
                    } // Module create callback


                    if (module.create) {
                        module.create.bind(instance)(moduleParams);
                    }
                });
            }
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events-emitter.js
        /* eslint-disable no-underscore-dangle */
        /* harmony default export */ const events_emitter = ({
            on: function on(events, handler, priority) {
                var self = this;
                if (typeof handler !== 'function') return self;
                var method = priority ? 'unshift' : 'push';
                events.split(' ').forEach(function (event) {
                    if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
                    self.eventsListeners[event][method](handler);
                });
                return self;
            },
            once: function once(events, handler, priority) {
                var self = this;
                if (typeof handler !== 'function') return self;

                function onceHandler() {
                    self.off(events, onceHandler);

                    if (onceHandler.__emitterProxy) {
                        delete onceHandler.__emitterProxy;
                    }

                    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                        args[_key] = arguments[_key];
                    }

                    handler.apply(self, args);
                }

                onceHandler.__emitterProxy = handler;
                return self.on(events, onceHandler, priority);
            },
            onAny: function onAny(handler, priority) {
                var self = this;
                if (typeof handler !== 'function') return self;
                var method = priority ? 'unshift' : 'push';

                if (self.eventsAnyListeners.indexOf(handler) < 0) {
                    self.eventsAnyListeners[method](handler);
                }

                return self;
            },
            offAny: function offAny(handler) {
                var self = this;
                if (!self.eventsAnyListeners) return self;
                var index = self.eventsAnyListeners.indexOf(handler);

                if (index >= 0) {
                    self.eventsAnyListeners.splice(index, 1);
                }

                return self;
            },
            off: function off(events, handler) {
                var self = this;
                if (!self.eventsListeners) return self;
                events.split(' ').forEach(function (event) {
                    if (typeof handler === 'undefined') {
                        self.eventsListeners[event] = [];
                    } else if (self.eventsListeners[event]) {
                        self.eventsListeners[event].forEach(function (eventHandler, index) {
                            if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
                                self.eventsListeners[event].splice(index, 1);
                            }
                        });
                    }
                });
                return self;
            },
            emit: function emit() {
                var self = this;
                if (!self.eventsListeners) return self;
                var events;
                var data;
                var context;

                for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                    args[_key2] = arguments[_key2];
                }

                if (typeof args[0] === 'string' || Array.isArray(args[0])) {
                    events = args[0];
                    data = args.slice(1, args.length);
                    context = self;
                } else {
                    events = args[0].events;
                    data = args[0].data;
                    context = args[0].context || self;
                }

                data.unshift(context);
                var eventsArray = Array.isArray(events) ? events : events.split(' ');
                eventsArray.forEach(function (event) {
                    if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
                        self.eventsAnyListeners.forEach(function (eventHandler) {
                            eventHandler.apply(context, [event].concat(data));
                        });
                    }

                    if (self.eventsListeners && self.eventsListeners[event]) {
                        self.eventsListeners[event].forEach(function (eventHandler) {
                            eventHandler.apply(context, data);
                        });
                    }
                });
                return self;
            }
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateSize.js

        function updateSize() {
            var swiper = this;
            var width;
            var height;
            var $el = swiper.$el;

            if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
                width = swiper.params.width;
            } else {
                width = $el[0].clientWidth;
            }

            if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
                height = swiper.params.height;
            } else {
                height = $el[0].clientHeight;
            }

            if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
                return;
            } // Subtract paddings


            width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
            height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
            if (Number.isNaN(width)) width = 0;
            if (Number.isNaN(height)) height = 0;
            utils_extend(swiper, {
                width: width,
                height: height,
                size: swiper.isHorizontal() ? width : height
            });
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateSlides.js

        function updateSlides() {
            var swiper = this;

            function getDirectionLabel(property) {
                if (swiper.isHorizontal()) {
                    return property;
                } // prettier-ignore


                return {
                    'width': 'height',
                    'margin-top': 'margin-left',
                    'margin-bottom ': 'margin-right',
                    'margin-left': 'margin-top',
                    'margin-right': 'margin-bottom',
                    'padding-left': 'padding-top',
                    'padding-right': 'padding-bottom',
                    'marginRight': 'marginBottom'
                }[property];
            }

            function getDirectionPropertyValue(node, label) {
                return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
            }

            var params = swiper.params;
            var $wrapperEl = swiper.$wrapperEl,
                swiperSize = swiper.size,
                rtl = swiper.rtlTranslate,
                wrongRTL = swiper.wrongRTL;
            var isVirtual = swiper.virtual && params.virtual.enabled;
            var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
            var slides = $wrapperEl.children("." + swiper.params.slideClass);
            var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
            var snapGrid = [];
            var slidesGrid = [];
            var slidesSizesGrid = [];
            var offsetBefore = params.slidesOffsetBefore;

            if (typeof offsetBefore === 'function') {
                offsetBefore = params.slidesOffsetBefore.call(swiper);
            }

            var offsetAfter = params.slidesOffsetAfter;

            if (typeof offsetAfter === 'function') {
                offsetAfter = params.slidesOffsetAfter.call(swiper);
            }

            var previousSnapGridLength = swiper.snapGrid.length;
            var previousSlidesGridLength = swiper.slidesGrid.length;
            var spaceBetween = params.spaceBetween;
            var slidePosition = -offsetBefore;
            var prevSlideSize = 0;
            var index = 0;

            if (typeof swiperSize === 'undefined') {
                return;
            }

            if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
                spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
            }

            swiper.virtualSize = -spaceBetween; // reset margins

            if (rtl) slides.css({
                marginLeft: '',
                marginBottom: '',
                marginTop: ''
            });else slides.css({
                marginRight: '',
                marginBottom: '',
                marginTop: ''
            });
            var slidesNumberEvenToRows;

            if (params.slidesPerColumn > 1) {
                if (Math.floor(slidesLength / params.slidesPerColumn) === slidesLength / swiper.params.slidesPerColumn) {
                    slidesNumberEvenToRows = slidesLength;
                } else {
                    slidesNumberEvenToRows = Math.ceil(slidesLength / params.slidesPerColumn) * params.slidesPerColumn;
                }

                if (params.slidesPerView !== 'auto' && params.slidesPerColumnFill === 'row') {
                    slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, params.slidesPerView * params.slidesPerColumn);
                }
            } // Calc slides


            var slideSize;
            var slidesPerColumn = params.slidesPerColumn;
            var slidesPerRow = slidesNumberEvenToRows / slidesPerColumn;
            var numFullColumns = Math.floor(slidesLength / params.slidesPerColumn);

            for (var i = 0; i < slidesLength; i += 1) {
                slideSize = 0;
                var slide = slides.eq(i);

                if (params.slidesPerColumn > 1) {
                    // Set slides order
                    var newSlideOrderIndex = void 0;
                    var column = void 0;
                    var row = void 0;

                    if (params.slidesPerColumnFill === 'row' && params.slidesPerGroup > 1) {
                        var groupIndex = Math.floor(i / (params.slidesPerGroup * params.slidesPerColumn));
                        var slideIndexInGroup = i - params.slidesPerColumn * params.slidesPerGroup * groupIndex;
                        var columnsInGroup = groupIndex === 0 ? params.slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * slidesPerColumn * params.slidesPerGroup) / slidesPerColumn), params.slidesPerGroup);
                        row = Math.floor(slideIndexInGroup / columnsInGroup);
                        column = slideIndexInGroup - row * columnsInGroup + groupIndex * params.slidesPerGroup;
                        newSlideOrderIndex = column + row * slidesNumberEvenToRows / slidesPerColumn;
                        slide.css({
                            '-webkit-box-ordinal-group': newSlideOrderIndex,
                            '-moz-box-ordinal-group': newSlideOrderIndex,
                            '-ms-flex-order': newSlideOrderIndex,
                            '-webkit-order': newSlideOrderIndex,
                            order: newSlideOrderIndex
                        });
                    } else if (params.slidesPerColumnFill === 'column') {
                        column = Math.floor(i / slidesPerColumn);
                        row = i - column * slidesPerColumn;

                        if (column > numFullColumns || column === numFullColumns && row === slidesPerColumn - 1) {
                            row += 1;

                            if (row >= slidesPerColumn) {
                                row = 0;
                                column += 1;
                            }
                        }
                    } else {
                        row = Math.floor(i / slidesPerRow);
                        column = i - row * slidesPerRow;
                    }

                    slide.css(getDirectionLabel('margin-top'), row !== 0 ? params.spaceBetween && params.spaceBetween + "px" : '');
                }

                if (slide.css('display') === 'none') continue; // eslint-disable-line

                if (params.slidesPerView === 'auto') {
                    var slideStyles = getComputedStyle(slide[0]);
                    var currentTransform = slide[0].style.transform;
                    var currentWebKitTransform = slide[0].style.webkitTransform;

                    if (currentTransform) {
                        slide[0].style.transform = 'none';
                    }

                    if (currentWebKitTransform) {
                        slide[0].style.webkitTransform = 'none';
                    }

                    if (params.roundLengths) {
                        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
                    } else {
                        // eslint-disable-next-line
                        var width = getDirectionPropertyValue(slideStyles, 'width');
                        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                        var boxSizing = slideStyles.getPropertyValue('box-sizing');

                        if (boxSizing && boxSizing === 'border-box') {
                            slideSize = width + marginLeft + marginRight;
                        } else {
                            var _slide$ = slide[0],
                                clientWidth = _slide$.clientWidth,
                                offsetWidth = _slide$.offsetWidth;
                            slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                        }
                    }

                    if (currentTransform) {
                        slide[0].style.transform = currentTransform;
                    }

                    if (currentWebKitTransform) {
                        slide[0].style.webkitTransform = currentWebKitTransform;
                    }

                    if (params.roundLengths) slideSize = Math.floor(slideSize);
                } else {
                    slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
                    if (params.roundLengths) slideSize = Math.floor(slideSize);

                    if (slides[i]) {
                        slides[i].style[getDirectionLabel('width')] = slideSize + "px";
                    }
                }

                if (slides[i]) {
                    slides[i].swiperSlideSize = slideSize;
                }

                slidesSizesGrid.push(slideSize);

                if (params.centeredSlides) {
                    slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
                    if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
                    if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
                    if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
                    if (params.roundLengths) slidePosition = Math.floor(slidePosition);
                    if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
                    slidesGrid.push(slidePosition);
                } else {
                    if (params.roundLengths) slidePosition = Math.floor(slidePosition);
                    if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
                    slidesGrid.push(slidePosition);
                    slidePosition = slidePosition + slideSize + spaceBetween;
                }

                swiper.virtualSize += slideSize + spaceBetween;
                prevSlideSize = slideSize;
                index += 1;
            }

            swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
            var newSlidesGrid;

            if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
                $wrapperEl.css({
                    width: swiper.virtualSize + params.spaceBetween + "px"
                });
            }

            if (params.setWrapperSize) {
                var _$wrapperEl$css;

                $wrapperEl.css((_$wrapperEl$css = {}, _$wrapperEl$css[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css));
            }

            if (params.slidesPerColumn > 1) {
                var _$wrapperEl$css2;

                swiper.virtualSize = (slideSize + params.spaceBetween) * slidesNumberEvenToRows;
                swiper.virtualSize = Math.ceil(swiper.virtualSize / params.slidesPerColumn) - params.spaceBetween;
                $wrapperEl.css((_$wrapperEl$css2 = {}, _$wrapperEl$css2[getDirectionLabel('width')] = swiper.virtualSize + params.spaceBetween + "px", _$wrapperEl$css2));

                if (params.centeredSlides) {
                    newSlidesGrid = [];

                    for (var _i = 0; _i < snapGrid.length; _i += 1) {
                        var slidesGridItem = snapGrid[_i];
                        if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                        if (snapGrid[_i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
                    }

                    snapGrid = newSlidesGrid;
                }
            } // Remove last grid elements depending on width


            if (!params.centeredSlides) {
                newSlidesGrid = [];

                for (var _i2 = 0; _i2 < snapGrid.length; _i2 += 1) {
                    var _slidesGridItem = snapGrid[_i2];
                    if (params.roundLengths) _slidesGridItem = Math.floor(_slidesGridItem);

                    if (snapGrid[_i2] <= swiper.virtualSize - swiperSize) {
                        newSlidesGrid.push(_slidesGridItem);
                    }
                }

                snapGrid = newSlidesGrid;

                if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
                    snapGrid.push(swiper.virtualSize - swiperSize);
                }
            }

            if (snapGrid.length === 0) snapGrid = [0];

            if (params.spaceBetween !== 0) {
                var _slides$filter$css;

                var key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
                slides.filter(function (_, slideIndex) {
                    if (!params.cssMode) return true;

                    if (slideIndex === slides.length - 1) {
                        return false;
                    }

                    return true;
                }).css((_slides$filter$css = {}, _slides$filter$css[key] = spaceBetween + "px", _slides$filter$css));
            }

            if (params.centeredSlides && params.centeredSlidesBounds) {
                var allSlidesSize = 0;
                slidesSizesGrid.forEach(function (slideSizeValue) {
                    allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
                });
                allSlidesSize -= params.spaceBetween;
                var maxSnap = allSlidesSize - swiperSize;
                snapGrid = snapGrid.map(function (snap) {
                    if (snap < 0) return -offsetBefore;
                    if (snap > maxSnap) return maxSnap + offsetAfter;
                    return snap;
                });
            }

            if (params.centerInsufficientSlides) {
                var _allSlidesSize = 0;
                slidesSizesGrid.forEach(function (slideSizeValue) {
                    _allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
                });
                _allSlidesSize -= params.spaceBetween;

                if (_allSlidesSize < swiperSize) {
                    var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
                    snapGrid.forEach(function (snap, snapIndex) {
                        snapGrid[snapIndex] = snap - allSlidesOffset;
                    });
                    slidesGrid.forEach(function (snap, snapIndex) {
                        slidesGrid[snapIndex] = snap + allSlidesOffset;
                    });
                }
            }

            utils_extend(swiper, {
                slides: slides,
                snapGrid: snapGrid,
                slidesGrid: slidesGrid,
                slidesSizesGrid: slidesSizesGrid
            });

            if (slidesLength !== previousSlidesLength) {
                swiper.emit('slidesLengthChange');
            }

            if (snapGrid.length !== previousSnapGridLength) {
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                swiper.emit('snapGridLengthChange');
            }

            if (slidesGrid.length !== previousSlidesGridLength) {
                swiper.emit('slidesGridLengthChange');
            }

            if (params.watchSlidesProgress || params.watchSlidesVisibility) {
                swiper.updateSlidesOffset();
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateAutoHeight.js
        function updateAutoHeight(speed) {
            var swiper = this;
            var activeSlides = [];
            var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            var newHeight = 0;
            var i;

            if (typeof speed === 'number') {
                swiper.setTransition(speed);
            } else if (speed === true) {
                swiper.setTransition(swiper.params.speed);
            }

            var getSlideByIndex = function getSlideByIndex(index) {
                if (isVirtual) {
                    return swiper.slides.filter(function (el) {
                        return parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index;
                    })[0];
                }

                return swiper.slides.eq(index)[0];
            }; // Find slides currently in view


            if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
                if (swiper.params.centeredSlides) {
                    swiper.visibleSlides.each(function (slide) {
                        activeSlides.push(slide);
                    });
                } else {
                    for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
                        var index = swiper.activeIndex + i;
                        if (index > swiper.slides.length && !isVirtual) break;
                        activeSlides.push(getSlideByIndex(index));
                    }
                }
            } else {
                activeSlides.push(getSlideByIndex(swiper.activeIndex));
            } // Find new height from highest slide in view


            for (i = 0; i < activeSlides.length; i += 1) {
                if (typeof activeSlides[i] !== 'undefined') {
                    var height = activeSlides[i].offsetHeight;
                    newHeight = height > newHeight ? height : newHeight;
                }
            } // Update Height


            if (newHeight) swiper.$wrapperEl.css('height', newHeight + "px");
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateSlidesOffset.js
        function updateSlidesOffset() {
            var swiper = this;
            var slides = swiper.slides;

            for (var i = 0; i < slides.length; i += 1) {
                slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateSlidesProgress.js

        function updateSlidesProgress(translate) {
            if (translate === void 0) {
                translate = this && this.translate || 0;
            }

            var swiper = this;
            var params = swiper.params;
            var slides = swiper.slides,
                rtl = swiper.rtlTranslate;
            if (slides.length === 0) return;
            if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
            var offsetCenter = -translate;
            if (rtl) offsetCenter = translate; // Visible Slides

            slides.removeClass(params.slideVisibleClass);
            swiper.visibleSlidesIndexes = [];
            swiper.visibleSlides = [];

            for (var i = 0; i < slides.length; i += 1) {
                var slide = slides[i];
                var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slide.swiperSlideOffset) / (slide.swiperSlideSize + params.spaceBetween);

                if (params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) {
                    var slideBefore = -(offsetCenter - slide.swiperSlideOffset);
                    var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
                    var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

                    if (isVisible) {
                        swiper.visibleSlides.push(slide);
                        swiper.visibleSlidesIndexes.push(i);
                        slides.eq(i).addClass(params.slideVisibleClass);
                    }
                }

                slide.progress = rtl ? -slideProgress : slideProgress;
            }

            swiper.visibleSlides = dom(swiper.visibleSlides);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateProgress.js

        function updateProgress(translate) {
            var swiper = this;

            if (typeof translate === 'undefined') {
                var multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

                translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
            }

            var params = swiper.params;
            var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
            var progress = swiper.progress,
                isBeginning = swiper.isBeginning,
                isEnd = swiper.isEnd;
            var wasBeginning = isBeginning;
            var wasEnd = isEnd;

            if (translatesDiff === 0) {
                progress = 0;
                isBeginning = true;
                isEnd = true;
            } else {
                progress = (translate - swiper.minTranslate()) / translatesDiff;
                isBeginning = progress <= 0;
                isEnd = progress >= 1;
            }

            utils_extend(swiper, {
                progress: progress,
                isBeginning: isBeginning,
                isEnd: isEnd
            });
            if (params.watchSlidesProgress || params.watchSlidesVisibility || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

            if (isBeginning && !wasBeginning) {
                swiper.emit('reachBeginning toEdge');
            }

            if (isEnd && !wasEnd) {
                swiper.emit('reachEnd toEdge');
            }

            if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
                swiper.emit('fromEdge');
            }

            swiper.emit('progress', progress);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateSlidesClasses.js
        function updateSlidesClasses() {
            var swiper = this;
            var slides = swiper.slides,
                params = swiper.params,
                $wrapperEl = swiper.$wrapperEl,
                activeIndex = swiper.activeIndex,
                realIndex = swiper.realIndex;
            var isVirtual = swiper.virtual && params.virtual.enabled;
            slides.removeClass(params.slideActiveClass + " " + params.slideNextClass + " " + params.slidePrevClass + " " + params.slideDuplicateActiveClass + " " + params.slideDuplicateNextClass + " " + params.slideDuplicatePrevClass);
            var activeSlide;

            if (isVirtual) {
                activeSlide = swiper.$wrapperEl.find("." + params.slideClass + "[data-swiper-slide-index=\"" + activeIndex + "\"]");
            } else {
                activeSlide = slides.eq(activeIndex);
            } // Active classes


            activeSlide.addClass(params.slideActiveClass);

            if (params.loop) {
                // Duplicate to all looped slides
                if (activeSlide.hasClass(params.slideDuplicateClass)) {
                    $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
                } else {
                    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + realIndex + "\"]").addClass(params.slideDuplicateActiveClass);
                }
            } // Next Slide


            var nextSlide = activeSlide.nextAll("." + params.slideClass).eq(0).addClass(params.slideNextClass);

            if (params.loop && nextSlide.length === 0) {
                nextSlide = slides.eq(0);
                nextSlide.addClass(params.slideNextClass);
            } // Prev Slide


            var prevSlide = activeSlide.prevAll("." + params.slideClass).eq(0).addClass(params.slidePrevClass);

            if (params.loop && prevSlide.length === 0) {
                prevSlide = slides.eq(-1);
                prevSlide.addClass(params.slidePrevClass);
            }

            if (params.loop) {
                // Duplicate to all looped slides
                if (nextSlide.hasClass(params.slideDuplicateClass)) {
                    $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
                } else {
                    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + nextSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicateNextClass);
                }

                if (prevSlide.hasClass(params.slideDuplicateClass)) {
                    $wrapperEl.children("." + params.slideClass + ":not(." + params.slideDuplicateClass + ")[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
                } else {
                    $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + "[data-swiper-slide-index=\"" + prevSlide.attr('data-swiper-slide-index') + "\"]").addClass(params.slideDuplicatePrevClass);
                }
            }

            swiper.emitSlidesClasses();
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateActiveIndex.js

        function updateActiveIndex(newActiveIndex) {
            var swiper = this;
            var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
            var slidesGrid = swiper.slidesGrid,
                snapGrid = swiper.snapGrid,
                params = swiper.params,
                previousIndex = swiper.activeIndex,
                previousRealIndex = swiper.realIndex,
                previousSnapIndex = swiper.snapIndex;
            var activeIndex = newActiveIndex;
            var snapIndex;

            if (typeof activeIndex === 'undefined') {
                for (var i = 0; i < slidesGrid.length; i += 1) {
                    if (typeof slidesGrid[i + 1] !== 'undefined') {
                        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
                            activeIndex = i;
                        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
                            activeIndex = i + 1;
                        }
                    } else if (translate >= slidesGrid[i]) {
                        activeIndex = i;
                    }
                } // Normalize slideIndex


                if (params.normalizeSlideIndex) {
                    if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
                }
            }

            if (snapGrid.indexOf(translate) >= 0) {
                snapIndex = snapGrid.indexOf(translate);
            } else {
                var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
                snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
            }

            if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

            if (activeIndex === previousIndex) {
                if (snapIndex !== previousSnapIndex) {
                    swiper.snapIndex = snapIndex;
                    swiper.emit('snapIndexChange');
                }

                return;
            } // Get real index


            var realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
            utils_extend(swiper, {
                snapIndex: snapIndex,
                realIndex: realIndex,
                previousIndex: previousIndex,
                activeIndex: activeIndex
            });
            swiper.emit('activeIndexChange');
            swiper.emit('snapIndexChange');

            if (previousRealIndex !== realIndex) {
                swiper.emit('realIndexChange');
            }

            if (swiper.initialized || swiper.params.runCallbacksOnInit) {
                swiper.emit('slideChange');
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/updateClickedSlide.js

        function updateClickedSlide(e) {
            var swiper = this;
            var params = swiper.params;
            var slide = dom(e.target).closest("." + params.slideClass)[0];
            var slideFound = false;
            var slideIndex;

            if (slide) {
                for (var i = 0; i < swiper.slides.length; i += 1) {
                    if (swiper.slides[i] === slide) {
                        slideFound = true;
                        slideIndex = i;
                        break;
                    }
                }
            }

            if (slide && slideFound) {
                swiper.clickedSlide = slide;

                if (swiper.virtual && swiper.params.virtual.enabled) {
                    swiper.clickedIndex = parseInt(dom(slide).attr('data-swiper-slide-index'), 10);
                } else {
                    swiper.clickedIndex = slideIndex;
                }
            } else {
                swiper.clickedSlide = undefined;
                swiper.clickedIndex = undefined;
                return;
            }

            if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
                swiper.slideToClickedSlide();
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/update/index.js









        /* harmony default export */ const update = ({
            updateSize: updateSize,
            updateSlides: updateSlides,
            updateAutoHeight: updateAutoHeight,
            updateSlidesOffset: updateSlidesOffset,
            updateSlidesProgress: updateSlidesProgress,
            updateProgress: updateProgress,
            updateSlidesClasses: updateSlidesClasses,
            updateActiveIndex: updateActiveIndex,
            updateClickedSlide: updateClickedSlide
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/getTranslate.js

        function getSwiperTranslate(axis) {
            if (axis === void 0) {
                axis = this.isHorizontal() ? 'x' : 'y';
            }

            var swiper = this;
            var params = swiper.params,
                rtl = swiper.rtlTranslate,
                translate = swiper.translate,
                $wrapperEl = swiper.$wrapperEl;

            if (params.virtualTranslate) {
                return rtl ? -translate : translate;
            }

            if (params.cssMode) {
                return translate;
            }

            var currentTranslate = getTranslate($wrapperEl[0], axis);
            if (rtl) currentTranslate = -currentTranslate;
            return currentTranslate || 0;
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/setTranslate.js
        function setTranslate(translate, byController) {
            var swiper = this;
            var rtl = swiper.rtlTranslate,
                params = swiper.params,
                $wrapperEl = swiper.$wrapperEl,
                wrapperEl = swiper.wrapperEl,
                progress = swiper.progress;
            var x = 0;
            var y = 0;
            var z = 0;

            if (swiper.isHorizontal()) {
                x = rtl ? -translate : translate;
            } else {
                y = translate;
            }

            if (params.roundLengths) {
                x = Math.floor(x);
                y = Math.floor(y);
            }

            if (params.cssMode) {
                wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
            } else if (!params.virtualTranslate) {
                $wrapperEl.transform("translate3d(" + x + "px, " + y + "px, " + z + "px)");
            }

            swiper.previousTranslate = swiper.translate;
            swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

            var newProgress;
            var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

            if (translatesDiff === 0) {
                newProgress = 0;
            } else {
                newProgress = (translate - swiper.minTranslate()) / translatesDiff;
            }

            if (newProgress !== progress) {
                swiper.updateProgress(translate);
            }

            swiper.emit('setTranslate', swiper.translate, byController);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/minTranslate.js
        function minTranslate() {
            return -this.snapGrid[0];
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/maxTranslate.js
        function maxTranslate() {
            return -this.snapGrid[this.snapGrid.length - 1];
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/translateTo.js
        function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
            if (translate === void 0) {
                translate = 0;
            }

            if (speed === void 0) {
                speed = this.params.speed;
            }

            if (runCallbacks === void 0) {
                runCallbacks = true;
            }

            if (translateBounds === void 0) {
                translateBounds = true;
            }

            var swiper = this;
            var params = swiper.params,
                wrapperEl = swiper.wrapperEl;

            if (swiper.animating && params.preventInteractionOnTransition) {
                return false;
            }

            var minTranslate = swiper.minTranslate();
            var maxTranslate = swiper.maxTranslate();
            var newTranslate;
            if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

            swiper.updateProgress(newTranslate);

            if (params.cssMode) {
                var isH = swiper.isHorizontal();

                if (speed === 0) {
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
                } else {
                    // eslint-disable-next-line
                    if (wrapperEl.scrollTo) {
                        var _wrapperEl$scrollTo;

                        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = -newTranslate, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
                    } else {
                        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
                    }
                }

                return true;
            }

            if (speed === 0) {
                swiper.setTransition(0);
                swiper.setTranslate(newTranslate);

                if (runCallbacks) {
                    swiper.emit('beforeTransitionStart', speed, internal);
                    swiper.emit('transitionEnd');
                }
            } else {
                swiper.setTransition(speed);
                swiper.setTranslate(newTranslate);

                if (runCallbacks) {
                    swiper.emit('beforeTransitionStart', speed, internal);
                    swiper.emit('transitionStart');
                }

                if (!swiper.animating) {
                    swiper.animating = true;

                    if (!swiper.onTranslateToWrapperTransitionEnd) {
                        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                            if (!swiper || swiper.destroyed) return;
                            if (e.target !== this) return;
                            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                            swiper.onTranslateToWrapperTransitionEnd = null;
                            delete swiper.onTranslateToWrapperTransitionEnd;

                            if (runCallbacks) {
                                swiper.emit('transitionEnd');
                            }
                        };
                    }

                    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                }
            }

            return true;
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/translate/index.js





        /* harmony default export */ const translate = ({
            getTranslate: getSwiperTranslate,
            setTranslate: setTranslate,
            minTranslate: minTranslate,
            maxTranslate: maxTranslate,
            translateTo: translateTo
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/transition/setTransition.js
        function setTransition(duration, byController) {
            var swiper = this;

            if (!swiper.params.cssMode) {
                swiper.$wrapperEl.transition(duration);
            }

            swiper.emit('setTransition', duration, byController);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/transition/transitionStart.js
        function transitionStart(runCallbacks, direction) {
            if (runCallbacks === void 0) {
                runCallbacks = true;
            }

            var swiper = this;
            var activeIndex = swiper.activeIndex,
                params = swiper.params,
                previousIndex = swiper.previousIndex;
            if (params.cssMode) return;

            if (params.autoHeight) {
                swiper.updateAutoHeight();
            }

            var dir = direction;

            if (!dir) {
                if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
            }

            swiper.emit('transitionStart');

            if (runCallbacks && activeIndex !== previousIndex) {
                if (dir === 'reset') {
                    swiper.emit('slideResetTransitionStart');
                    return;
                }

                swiper.emit('slideChangeTransitionStart');

                if (dir === 'next') {
                    swiper.emit('slideNextTransitionStart');
                } else {
                    swiper.emit('slidePrevTransitionStart');
                }
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/transition/transitionEnd.js
        function transitionEnd_transitionEnd(runCallbacks, direction) {
            if (runCallbacks === void 0) {
                runCallbacks = true;
            }

            var swiper = this;
            var activeIndex = swiper.activeIndex,
                previousIndex = swiper.previousIndex,
                params = swiper.params;
            swiper.animating = false;
            if (params.cssMode) return;
            swiper.setTransition(0);
            var dir = direction;

            if (!dir) {
                if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
            }

            swiper.emit('transitionEnd');

            if (runCallbacks && activeIndex !== previousIndex) {
                if (dir === 'reset') {
                    swiper.emit('slideResetTransitionEnd');
                    return;
                }

                swiper.emit('slideChangeTransitionEnd');

                if (dir === 'next') {
                    swiper.emit('slideNextTransitionEnd');
                } else {
                    swiper.emit('slidePrevTransitionEnd');
                }
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/transition/index.js



        /* harmony default export */ const core_transition = ({
            setTransition: setTransition,
            transitionStart: transitionStart,
            transitionEnd: transitionEnd_transitionEnd
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideTo.js
        function slideTo(index, speed, runCallbacks, internal, initial) {
            if (index === void 0) {
                index = 0;
            }

            if (speed === void 0) {
                speed = this.params.speed;
            }

            if (runCallbacks === void 0) {
                runCallbacks = true;
            }

            if (typeof index !== 'number' && typeof index !== 'string') {
                throw new Error("The 'index' argument cannot have type other than 'number' or 'string'. [" + typeof index + "] given.");
            }

            if (typeof index === 'string') {
                /**
                 * The `index` argument converted from `string` to `number`.
                 * @type {number}
                 */
                var indexAsNumber = parseInt(index, 10);
                /**
                 * Determines whether the `index` argument is a valid `number`
                 * after being converted from the `string` type.
                 * @type {boolean}
                 */

                var isValidNumber = isFinite(indexAsNumber);

                if (!isValidNumber) {
                    throw new Error("The passed-in 'index' (string) couldn't be converted to 'number'. [" + index + "] given.");
                } // Knowing that the converted `index` is a valid number,
                // we can update the original argument's value.


                index = indexAsNumber;
            }

            var swiper = this;
            var slideIndex = index;
            if (slideIndex < 0) slideIndex = 0;
            var params = swiper.params,
                snapGrid = swiper.snapGrid,
                slidesGrid = swiper.slidesGrid,
                previousIndex = swiper.previousIndex,
                activeIndex = swiper.activeIndex,
                rtl = swiper.rtlTranslate,
                wrapperEl = swiper.wrapperEl,
                enabled = swiper.enabled;

            if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
                return false;
            }

            var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
            var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
            if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

            if ((activeIndex || params.initialSlide || 0) === (previousIndex || 0) && runCallbacks) {
                swiper.emit('beforeSlideChangeStart');
            }

            var translate = -snapGrid[snapIndex]; // Update progress

            swiper.updateProgress(translate); // Normalize slideIndex

            if (params.normalizeSlideIndex) {
                for (var i = 0; i < slidesGrid.length; i += 1) {
                    var normalizedTranslate = -Math.floor(translate * 100);
                    var normalizedGird = Math.floor(slidesGrid[i] * 100);
                    var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

                    if (typeof slidesGrid[i + 1] !== 'undefined') {
                        if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGird) / 2) {
                            slideIndex = i;
                        } else if (normalizedTranslate >= normalizedGird && normalizedTranslate < normalizedGridNext) {
                            slideIndex = i + 1;
                        }
                    } else if (normalizedTranslate >= normalizedGird) {
                        slideIndex = i;
                    }
                }
            } // Directions locks


            if (swiper.initialized && slideIndex !== activeIndex) {
                if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
                    return false;
                }

                if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
                    if ((activeIndex || 0) !== slideIndex) return false;
                }
            }

            var direction;
            if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

            if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
                swiper.updateActiveIndex(slideIndex); // Update Height

                if (params.autoHeight) {
                    swiper.updateAutoHeight();
                }

                swiper.updateSlidesClasses();

                if (params.effect !== 'slide') {
                    swiper.setTranslate(translate);
                }

                if (direction !== 'reset') {
                    swiper.transitionStart(runCallbacks, direction);
                    swiper.transitionEnd(runCallbacks, direction);
                }

                return false;
            }

            if (params.cssMode) {
                var isH = swiper.isHorizontal();
                var t = -translate;

                if (rtl) {
                    t = wrapperEl.scrollWidth - wrapperEl.offsetWidth - t;
                }

                if (speed === 0) {
                    wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                } else {
                    // eslint-disable-next-line
                    if (wrapperEl.scrollTo) {
                        var _wrapperEl$scrollTo;

                        wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _wrapperEl$scrollTo[isH ? 'left' : 'top'] = t, _wrapperEl$scrollTo.behavior = 'smooth', _wrapperEl$scrollTo));
                    } else {
                        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
                    }
                }

                return true;
            }

            if (speed === 0) {
                swiper.setTransition(0);
                swiper.setTranslate(translate);
                swiper.updateActiveIndex(slideIndex);
                swiper.updateSlidesClasses();
                swiper.emit('beforeTransitionStart', speed, internal);
                swiper.transitionStart(runCallbacks, direction);
                swiper.transitionEnd(runCallbacks, direction);
            } else {
                swiper.setTransition(speed);
                swiper.setTranslate(translate);
                swiper.updateActiveIndex(slideIndex);
                swiper.updateSlidesClasses();
                swiper.emit('beforeTransitionStart', speed, internal);
                swiper.transitionStart(runCallbacks, direction);

                if (!swiper.animating) {
                    swiper.animating = true;

                    if (!swiper.onSlideToWrapperTransitionEnd) {
                        swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
                            if (!swiper || swiper.destroyed) return;
                            if (e.target !== this) return;
                            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
                            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
                            swiper.onSlideToWrapperTransitionEnd = null;
                            delete swiper.onSlideToWrapperTransitionEnd;
                            swiper.transitionEnd(runCallbacks, direction);
                        };
                    }

                    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
                    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
                }
            }

            return true;
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideToLoop.js
        function slideToLoop(index, speed, runCallbacks, internal) {
            if (index === void 0) {
                index = 0;
            }

            if (speed === void 0) {
                speed = this.params.speed;
            }

            if (runCallbacks === void 0) {
                runCallbacks = true;
            }

            var swiper = this;
            var newIndex = index;

            if (swiper.params.loop) {
                newIndex += swiper.loopedSlides;
            }

            return swiper.slideTo(newIndex, speed, runCallbacks, internal);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideNext.js
        /* eslint no-unused-vars: "off" */
        function slideNext(speed, runCallbacks, internal) {
            if (speed === void 0) {
                speed = this.params.speed;
            }

            if (runCallbacks === void 0) {
                runCallbacks = true;
            }

            var swiper = this;
            var params = swiper.params,
                animating = swiper.animating,
                enabled = swiper.enabled;
            if (!enabled) return swiper;
            var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup;

            if (params.loop) {
                if (animating && params.loopPreventsSlide) return false;
                swiper.loopFix(); // eslint-disable-next-line

                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
            }

            return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slidePrev.js
        /* eslint no-unused-vars: "off" */
        function slidePrev(speed, runCallbacks, internal) {
            if (speed === void 0) {
                speed = this.params.speed;
            }

            if (runCallbacks === void 0) {
                runCallbacks = true;
            }

            var swiper = this;
            var params = swiper.params,
                animating = swiper.animating,
                snapGrid = swiper.snapGrid,
                slidesGrid = swiper.slidesGrid,
                rtlTranslate = swiper.rtlTranslate,
                enabled = swiper.enabled;
            if (!enabled) return swiper;

            if (params.loop) {
                if (animating && params.loopPreventsSlide) return false;
                swiper.loopFix(); // eslint-disable-next-line

                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
            }

            var translate = rtlTranslate ? swiper.translate : -swiper.translate;

            function normalize(val) {
                if (val < 0) return -Math.floor(Math.abs(val));
                return Math.floor(val);
            }

            var normalizedTranslate = normalize(translate);
            var normalizedSnapGrid = snapGrid.map(function (val) {
                return normalize(val);
            });
            var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

            if (typeof prevSnap === 'undefined' && params.cssMode) {
                snapGrid.forEach(function (snap) {
                    if (!prevSnap && normalizedTranslate >= snap) prevSnap = snap;
                });
            }

            var prevIndex;

            if (typeof prevSnap !== 'undefined') {
                prevIndex = slidesGrid.indexOf(prevSnap);
                if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
            }

            return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideReset.js
        /* eslint no-unused-vars: "off" */
        function slideReset(speed, runCallbacks, internal) {
            if (speed === void 0) {
                speed = this.params.speed;
            }

            if (runCallbacks === void 0) {
                runCallbacks = true;
            }

            var swiper = this;
            return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideToClosest.js
        /* eslint no-unused-vars: "off" */
        function slideToClosest(speed, runCallbacks, internal, threshold) {
            if (speed === void 0) {
                speed = this.params.speed;
            }

            if (runCallbacks === void 0) {
                runCallbacks = true;
            }

            if (threshold === void 0) {
                threshold = 0.5;
            }

            var swiper = this;
            var index = swiper.activeIndex;
            var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
            var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
            var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

            if (translate >= swiper.snapGrid[snapIndex]) {
                // The current translate is on or after the current snap index, so the choice
                // is between the current index and the one after it.
                var currentSnap = swiper.snapGrid[snapIndex];
                var nextSnap = swiper.snapGrid[snapIndex + 1];

                if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
                    index += swiper.params.slidesPerGroup;
                }
            } else {
                // The current translate is before the current snap index, so the choice
                // is between the current index and the one before it.
                var prevSnap = swiper.snapGrid[snapIndex - 1];
                var _currentSnap = swiper.snapGrid[snapIndex];

                if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
                    index -= swiper.params.slidesPerGroup;
                }
            }

            index = Math.max(index, 0);
            index = Math.min(index, swiper.slidesGrid.length - 1);
            return swiper.slideTo(index, speed, runCallbacks, internal);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/slideToClickedSlide.js


        function slideToClickedSlide() {
            var swiper = this;
            var params = swiper.params,
                $wrapperEl = swiper.$wrapperEl;
            var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
            var slideToIndex = swiper.clickedIndex;
            var realIndex;

            if (params.loop) {
                if (swiper.animating) return;
                realIndex = parseInt(dom(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

                if (params.centeredSlides) {
                    if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                        swiper.loopFix();
                        slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
                        nextTick(function () {
                            swiper.slideTo(slideToIndex);
                        });
                    } else {
                        swiper.slideTo(slideToIndex);
                    }
                } else if (slideToIndex > swiper.slides.length - slidesPerView) {
                    swiper.loopFix();
                    slideToIndex = $wrapperEl.children("." + params.slideClass + "[data-swiper-slide-index=\"" + realIndex + "\"]:not(." + params.slideDuplicateClass + ")").eq(0).index();
                    nextTick(function () {
                        swiper.slideTo(slideToIndex);
                    });
                } else {
                    swiper.slideTo(slideToIndex);
                }
            } else {
                swiper.slideTo(slideToIndex);
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/slide/index.js







        /* harmony default export */ const slide = ({
            slideTo: slideTo,
            slideToLoop: slideToLoop,
            slideNext: slideNext,
            slidePrev: slidePrev,
            slideReset: slideReset,
            slideToClosest: slideToClosest,
            slideToClickedSlide: slideToClickedSlide
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/loop/loopCreate.js


        function loopCreate() {
            var swiper = this;
            var document = getDocument();
            var params = swiper.params,
                $wrapperEl = swiper.$wrapperEl; // Remove duplicated slides

            $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass).remove();
            var slides = $wrapperEl.children("." + params.slideClass);

            if (params.loopFillGroupWithBlank) {
                var blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

                if (blankSlidesNum !== params.slidesPerGroup) {
                    for (var i = 0; i < blankSlidesNum; i += 1) {
                        var blankNode = dom(document.createElement('div')).addClass(params.slideClass + " " + params.slideBlankClass);
                        $wrapperEl.append(blankNode);
                    }

                    slides = $wrapperEl.children("." + params.slideClass);
                }
            }

            if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
            swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
            swiper.loopedSlides += params.loopAdditionalSlides;

            if (swiper.loopedSlides > slides.length) {
                swiper.loopedSlides = slides.length;
            }

            var prependSlides = [];
            var appendSlides = [];
            slides.each(function (el, index) {
                var slide = dom(el);

                if (index < swiper.loopedSlides) {
                    appendSlides.push(el);
                }

                if (index < slides.length && index >= slides.length - swiper.loopedSlides) {
                    prependSlides.push(el);
                }

                slide.attr('data-swiper-slide-index', index);
            });

            for (var _i = 0; _i < appendSlides.length; _i += 1) {
                $wrapperEl.append(dom(appendSlides[_i].cloneNode(true)).addClass(params.slideDuplicateClass));
            }

            for (var _i2 = prependSlides.length - 1; _i2 >= 0; _i2 -= 1) {
                $wrapperEl.prepend(dom(prependSlides[_i2].cloneNode(true)).addClass(params.slideDuplicateClass));
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/loop/loopFix.js
        function loopFix() {
            var swiper = this;
            swiper.emit('beforeLoopFix');
            var activeIndex = swiper.activeIndex,
                slides = swiper.slides,
                loopedSlides = swiper.loopedSlides,
                allowSlidePrev = swiper.allowSlidePrev,
                allowSlideNext = swiper.allowSlideNext,
                snapGrid = swiper.snapGrid,
                rtl = swiper.rtlTranslate;
            var newIndex;
            swiper.allowSlidePrev = true;
            swiper.allowSlideNext = true;
            var snapTranslate = -snapGrid[activeIndex];
            var diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

            if (activeIndex < loopedSlides) {
                newIndex = slides.length - loopedSlides * 3 + activeIndex;
                newIndex += loopedSlides;
                var slideChanged = swiper.slideTo(newIndex, 0, false, true);

                if (slideChanged && diff !== 0) {
                    swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
                }
            } else if (activeIndex >= slides.length - loopedSlides) {
                // Fix For Positive Oversliding
                newIndex = -slides.length + activeIndex + loopedSlides;
                newIndex += loopedSlides;

                var _slideChanged = swiper.slideTo(newIndex, 0, false, true);

                if (_slideChanged && diff !== 0) {
                    swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
                }
            }

            swiper.allowSlidePrev = allowSlidePrev;
            swiper.allowSlideNext = allowSlideNext;
            swiper.emit('loopFix');
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/loop/loopDestroy.js
        function loopDestroy() {
            var swiper = this;
            var $wrapperEl = swiper.$wrapperEl,
                params = swiper.params,
                slides = swiper.slides;
            $wrapperEl.children("." + params.slideClass + "." + params.slideDuplicateClass + ",." + params.slideClass + "." + params.slideBlankClass).remove();
            slides.removeAttr('data-swiper-slide-index');
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/loop/index.js



        /* harmony default export */ const loop = ({
            loopCreate: loopCreate,
            loopFix: loopFix,
            loopDestroy: loopDestroy
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/grab-cursor/setGrabCursor.js
        function setGrabCursor(moving) {
            var swiper = this;
            if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
            var el = swiper.el;
            el.style.cursor = 'move';
            el.style.cursor = moving ? '-webkit-grabbing' : '-webkit-grab';
            el.style.cursor = moving ? '-moz-grabbin' : '-moz-grab';
            el.style.cursor = moving ? 'grabbing' : 'grab';
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/grab-cursor/unsetGrabCursor.js
        function unsetGrabCursor() {
            var swiper = this;

            if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
                return;
            }

            swiper.el.style.cursor = '';
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/grab-cursor/index.js


        /* harmony default export */ const grab_cursor = ({
            setGrabCursor: setGrabCursor,
            unsetGrabCursor: unsetGrabCursor
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/appendSlide.js
        function appendSlide(slides) {
            var swiper = this;
            var $wrapperEl = swiper.$wrapperEl,
                params = swiper.params;

            if (params.loop) {
                swiper.loopDestroy();
            }

            if (typeof slides === 'object' && 'length' in slides) {
                for (var i = 0; i < slides.length; i += 1) {
                    if (slides[i]) $wrapperEl.append(slides[i]);
                }
            } else {
                $wrapperEl.append(slides);
            }

            if (params.loop) {
                swiper.loopCreate();
            }

            if (!(params.observer && swiper.support.observer)) {
                swiper.update();
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/prependSlide.js
        function prependSlide(slides) {
            var swiper = this;
            var params = swiper.params,
                $wrapperEl = swiper.$wrapperEl,
                activeIndex = swiper.activeIndex;

            if (params.loop) {
                swiper.loopDestroy();
            }

            var newActiveIndex = activeIndex + 1;

            if (typeof slides === 'object' && 'length' in slides) {
                for (var i = 0; i < slides.length; i += 1) {
                    if (slides[i]) $wrapperEl.prepend(slides[i]);
                }

                newActiveIndex = activeIndex + slides.length;
            } else {
                $wrapperEl.prepend(slides);
            }

            if (params.loop) {
                swiper.loopCreate();
            }

            if (!(params.observer && swiper.support.observer)) {
                swiper.update();
            }

            swiper.slideTo(newActiveIndex, 0, false);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/addSlide.js
        function addSlide(index, slides) {
            var swiper = this;
            var $wrapperEl = swiper.$wrapperEl,
                params = swiper.params,
                activeIndex = swiper.activeIndex;
            var activeIndexBuffer = activeIndex;

            if (params.loop) {
                activeIndexBuffer -= swiper.loopedSlides;
                swiper.loopDestroy();
                swiper.slides = $wrapperEl.children("." + params.slideClass);
            }

            var baseLength = swiper.slides.length;

            if (index <= 0) {
                swiper.prependSlide(slides);
                return;
            }

            if (index >= baseLength) {
                swiper.appendSlide(slides);
                return;
            }

            var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
            var slidesBuffer = [];

            for (var i = baseLength - 1; i >= index; i -= 1) {
                var currentSlide = swiper.slides.eq(i);
                currentSlide.remove();
                slidesBuffer.unshift(currentSlide);
            }

            if (typeof slides === 'object' && 'length' in slides) {
                for (var _i = 0; _i < slides.length; _i += 1) {
                    if (slides[_i]) $wrapperEl.append(slides[_i]);
                }

                newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
            } else {
                $wrapperEl.append(slides);
            }

            for (var _i2 = 0; _i2 < slidesBuffer.length; _i2 += 1) {
                $wrapperEl.append(slidesBuffer[_i2]);
            }

            if (params.loop) {
                swiper.loopCreate();
            }

            if (!(params.observer && swiper.support.observer)) {
                swiper.update();
            }

            if (params.loop) {
                swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
            } else {
                swiper.slideTo(newActiveIndex, 0, false);
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/removeSlide.js
        function removeSlide(slidesIndexes) {
            var swiper = this;
            var params = swiper.params,
                $wrapperEl = swiper.$wrapperEl,
                activeIndex = swiper.activeIndex;
            var activeIndexBuffer = activeIndex;

            if (params.loop) {
                activeIndexBuffer -= swiper.loopedSlides;
                swiper.loopDestroy();
                swiper.slides = $wrapperEl.children("." + params.slideClass);
            }

            var newActiveIndex = activeIndexBuffer;
            var indexToRemove;

            if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
                for (var i = 0; i < slidesIndexes.length; i += 1) {
                    indexToRemove = slidesIndexes[i];
                    if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
                    if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
                }

                newActiveIndex = Math.max(newActiveIndex, 0);
            } else {
                indexToRemove = slidesIndexes;
                if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
                if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
                newActiveIndex = Math.max(newActiveIndex, 0);
            }

            if (params.loop) {
                swiper.loopCreate();
            }

            if (!(params.observer && swiper.support.observer)) {
                swiper.update();
            }

            if (params.loop) {
                swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
            } else {
                swiper.slideTo(newActiveIndex, 0, false);
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/removeAllSlides.js
        function removeAllSlides() {
            var swiper = this;
            var slidesIndexes = [];

            for (var i = 0; i < swiper.slides.length; i += 1) {
                slidesIndexes.push(i);
            }

            swiper.removeSlide(slidesIndexes);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/manipulation/index.js





        /* harmony default export */ const manipulation = ({
            appendSlide: appendSlide,
            prependSlide: prependSlide,
            addSlide: addSlide,
            removeSlide: removeSlide,
            removeAllSlides: removeAllSlides
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onTouchStart.js


        // Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd

        function closestElement(selector, base) {
            if (base === void 0) {
                base = this;
            }

            function __closestFrom(el) {
                if (!el || el === getDocument() || el === ssr_window_esm_getWindow()) return null;
                if (el.assignedSlot) el = el.assignedSlot;
                var found = el.closest(selector);
                return found || __closestFrom(el.getRootNode().host);
            }

            return __closestFrom(base);
        }

        function onTouchStart(event) {
            var swiper = this;
            var document = getDocument();
            var window = ssr_window_esm_getWindow();
            var data = swiper.touchEventsData;
            var params = swiper.params,
                touches = swiper.touches,
                enabled = swiper.enabled;
            if (!enabled) return;

            if (swiper.animating && params.preventInteractionOnTransition) {
                return;
            }

            var e = event;
            if (e.originalEvent) e = e.originalEvent;
            var $targetEl = dom(e.target);

            if (params.touchEventsTarget === 'wrapper') {
                if (!$targetEl.closest(swiper.wrapperEl).length) return;
            }

            data.isTouchEvent = e.type === 'touchstart';
            if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
            if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
            if (data.isTouched && data.isMoved) return; // change target el for shadow root component

            var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';

            if (swipingClassHasValue && e.target && e.target.shadowRoot && event.path && event.path[0]) {
                $targetEl = dom(event.path[0]);
            }

            var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : "." + params.noSwipingClass;
            var isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

            if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, e.target) : $targetEl.closest(noSwipingSelector)[0])) {
                swiper.allowClick = true;
                return;
            }

            if (params.swipeHandler) {
                if (!$targetEl.closest(params.swipeHandler)[0]) return;
            }

            touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
            touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
            var startX = touches.currentX;
            var startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

            var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
            var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

            if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
                if (edgeSwipeDetection === 'prevent') {
                    event.preventDefault();
                } else {
                    return;
                }
            }

            utils_extend(data, {
                isTouched: true,
                isMoved: false,
                allowTouchCallbacks: true,
                isScrolling: undefined,
                startMoving: undefined
            });
            touches.startX = startX;
            touches.startY = startY;
            data.touchStartTime = now();
            swiper.allowClick = true;
            swiper.updateSize();
            swiper.swipeDirection = undefined;
            if (params.threshold > 0) data.allowThresholdMove = false;

            if (e.type !== 'touchstart') {
                var preventDefault = true;
                if ($targetEl.is(data.focusableElements)) preventDefault = false;

                if (document.activeElement && dom(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
                    document.activeElement.blur();
                }

                var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

                if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
                    e.preventDefault();
                }
            }

            swiper.emit('touchStart', e);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onTouchMove.js



        function onTouchMove(event) {
            var document = getDocument();
            var swiper = this;
            var data = swiper.touchEventsData;
            var params = swiper.params,
                touches = swiper.touches,
                rtl = swiper.rtlTranslate,
                enabled = swiper.enabled;
            if (!enabled) return;
            var e = event;
            if (e.originalEvent) e = e.originalEvent;

            if (!data.isTouched) {
                if (data.startMoving && data.isScrolling) {
                    swiper.emit('touchMoveOpposite', e);
                }

                return;
            }

            if (data.isTouchEvent && e.type !== 'touchmove') return;
            var targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
            var pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
            var pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

            if (e.preventedByNestedSwiper) {
                touches.startX = pageX;
                touches.startY = pageY;
                return;
            }

            if (!swiper.allowTouchMove) {
                // isMoved = true;
                swiper.allowClick = false;

                if (data.isTouched) {
                    utils_extend(touches, {
                        startX: pageX,
                        startY: pageY,
                        currentX: pageX,
                        currentY: pageY
                    });
                    data.touchStartTime = now();
                }

                return;
            }

            if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
                if (swiper.isVertical()) {
                    // Vertical
                    if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                        data.isTouched = false;
                        data.isMoved = false;
                        return;
                    }
                } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
                    return;
                }
            }

            if (data.isTouchEvent && document.activeElement) {
                if (e.target === document.activeElement && dom(e.target).is(data.focusableElements)) {
                    data.isMoved = true;
                    swiper.allowClick = false;
                    return;
                }
            }

            if (data.allowTouchCallbacks) {
                swiper.emit('touchMove', e);
            }

            if (e.targetTouches && e.targetTouches.length > 1) return;
            touches.currentX = pageX;
            touches.currentY = pageY;
            var diffX = touches.currentX - touches.startX;
            var diffY = touches.currentY - touches.startY;
            if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;

            if (typeof data.isScrolling === 'undefined') {
                var touchAngle;

                if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
                    data.isScrolling = false;
                } else {
                    // eslint-disable-next-line
                    if (diffX * diffX + diffY * diffY >= 25) {
                        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
                        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
                    }
                }
            }

            if (data.isScrolling) {
                swiper.emit('touchMoveOpposite', e);
            }

            if (typeof data.startMoving === 'undefined') {
                if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
                    data.startMoving = true;
                }
            }

            if (data.isScrolling) {
                data.isTouched = false;
                return;
            }

            if (!data.startMoving) {
                return;
            }

            swiper.allowClick = false;

            if (!params.cssMode && e.cancelable) {
                e.preventDefault();
            }

            if (params.touchMoveStopPropagation && !params.nested) {
                e.stopPropagation();
            }

            if (!data.isMoved) {
                if (params.loop) {
                    swiper.loopFix();
                }

                data.startTranslate = swiper.getTranslate();
                swiper.setTransition(0);

                if (swiper.animating) {
                    swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
                }

                data.allowMomentumBounce = false; // Grab Cursor

                if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
                    swiper.setGrabCursor(true);
                }

                swiper.emit('sliderFirstMove', e);
            }

            swiper.emit('sliderMove', e);
            data.isMoved = true;
            var diff = swiper.isHorizontal() ? diffX : diffY;
            touches.diff = diff;
            diff *= params.touchRatio;
            if (rtl) diff = -diff;
            swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
            data.currentTranslate = diff + data.startTranslate;
            var disableParentSwiper = true;
            var resistanceRatio = params.resistanceRatio;

            if (params.touchReleaseOnEdges) {
                resistanceRatio = 0;
            }

            if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
                disableParentSwiper = false;
                if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
            } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
                disableParentSwiper = false;
                if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
            }

            if (disableParentSwiper) {
                e.preventedByNestedSwiper = true;
            } // Directions locks


            if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
                data.currentTranslate = data.startTranslate;
            }

            if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
                data.currentTranslate = data.startTranslate;
            }

            if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
                data.currentTranslate = data.startTranslate;
            } // Threshold


            if (params.threshold > 0) {
                if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
                    if (!data.allowThresholdMove) {
                        data.allowThresholdMove = true;
                        touches.startX = touches.currentX;
                        touches.startY = touches.currentY;
                        data.currentTranslate = data.startTranslate;
                        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                        return;
                    }
                } else {
                    data.currentTranslate = data.startTranslate;
                    return;
                }
            }

            if (!params.followFinger || params.cssMode) return; // Update active index in free mode

            if (params.freeMode || params.watchSlidesProgress || params.watchSlidesVisibility) {
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            }

            if (params.freeMode) {
                // Velocity
                if (data.velocities.length === 0) {
                    data.velocities.push({
                        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
                        time: data.touchStartTime
                    });
                }

                data.velocities.push({
                    position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
                    time: now()
                });
            } // Update progress


            swiper.updateProgress(data.currentTranslate); // Update translate

            swiper.setTranslate(data.currentTranslate);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onTouchEnd.js

        function onTouchEnd(event) {
            var swiper = this;
            var data = swiper.touchEventsData;
            var params = swiper.params,
                touches = swiper.touches,
                rtl = swiper.rtlTranslate,
                $wrapperEl = swiper.$wrapperEl,
                slidesGrid = swiper.slidesGrid,
                snapGrid = swiper.snapGrid,
                enabled = swiper.enabled;
            if (!enabled) return;
            var e = event;
            if (e.originalEvent) e = e.originalEvent;

            if (data.allowTouchCallbacks) {
                swiper.emit('touchEnd', e);
            }

            data.allowTouchCallbacks = false;

            if (!data.isTouched) {
                if (data.isMoved && params.grabCursor) {
                    swiper.setGrabCursor(false);
                }

                data.isMoved = false;
                data.startMoving = false;
                return;
            } // Return Grab Cursor


            if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
                swiper.setGrabCursor(false);
            } // Time diff


            var touchEndTime = now();
            var timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

            if (swiper.allowClick) {
                swiper.updateClickedSlide(e);
                swiper.emit('tap click', e);

                if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
                    swiper.emit('doubleTap doubleClick', e);
                }
            }

            data.lastClickTime = now();
            nextTick(function () {
                if (!swiper.destroyed) swiper.allowClick = true;
            });

            if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
                data.isTouched = false;
                data.isMoved = false;
                data.startMoving = false;
                return;
            }

            data.isTouched = false;
            data.isMoved = false;
            data.startMoving = false;
            var currentPos;

            if (params.followFinger) {
                currentPos = rtl ? swiper.translate : -swiper.translate;
            } else {
                currentPos = -data.currentTranslate;
            }

            if (params.cssMode) {
                return;
            }

            if (params.freeMode) {
                if (currentPos < -swiper.minTranslate()) {
                    swiper.slideTo(swiper.activeIndex);
                    return;
                }

                if (currentPos > -swiper.maxTranslate()) {
                    if (swiper.slides.length < snapGrid.length) {
                        swiper.slideTo(snapGrid.length - 1);
                    } else {
                        swiper.slideTo(swiper.slides.length - 1);
                    }

                    return;
                }

                if (params.freeModeMomentum) {
                    if (data.velocities.length > 1) {
                        var lastMoveEvent = data.velocities.pop();
                        var velocityEvent = data.velocities.pop();
                        var distance = lastMoveEvent.position - velocityEvent.position;
                        var time = lastMoveEvent.time - velocityEvent.time;
                        swiper.velocity = distance / time;
                        swiper.velocity /= 2;

                        if (Math.abs(swiper.velocity) < params.freeModeMinimumVelocity) {
                            swiper.velocity = 0;
                        } // this implies that the user stopped moving a finger then released.
                        // There would be no events with distance zero, so the last event is stale.


                        if (time > 150 || now() - lastMoveEvent.time > 300) {
                            swiper.velocity = 0;
                        }
                    } else {
                        swiper.velocity = 0;
                    }

                    swiper.velocity *= params.freeModeMomentumVelocityRatio;
                    data.velocities.length = 0;
                    var momentumDuration = 1000 * params.freeModeMomentumRatio;
                    var momentumDistance = swiper.velocity * momentumDuration;
                    var newPosition = swiper.translate + momentumDistance;
                    if (rtl) newPosition = -newPosition;
                    var doBounce = false;
                    var afterBouncePosition;
                    var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeModeMomentumBounceRatio;
                    var needsLoopFix;

                    if (newPosition < swiper.maxTranslate()) {
                        if (params.freeModeMomentumBounce) {
                            if (newPosition + swiper.maxTranslate() < -bounceAmount) {
                                newPosition = swiper.maxTranslate() - bounceAmount;
                            }

                            afterBouncePosition = swiper.maxTranslate();
                            doBounce = true;
                            data.allowMomentumBounce = true;
                        } else {
                            newPosition = swiper.maxTranslate();
                        }

                        if (params.loop && params.centeredSlides) needsLoopFix = true;
                    } else if (newPosition > swiper.minTranslate()) {
                        if (params.freeModeMomentumBounce) {
                            if (newPosition - swiper.minTranslate() > bounceAmount) {
                                newPosition = swiper.minTranslate() + bounceAmount;
                            }

                            afterBouncePosition = swiper.minTranslate();
                            doBounce = true;
                            data.allowMomentumBounce = true;
                        } else {
                            newPosition = swiper.minTranslate();
                        }

                        if (params.loop && params.centeredSlides) needsLoopFix = true;
                    } else if (params.freeModeSticky) {
                        var nextSlide;

                        for (var j = 0; j < snapGrid.length; j += 1) {
                            if (snapGrid[j] > -newPosition) {
                                nextSlide = j;
                                break;
                            }
                        }

                        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
                            newPosition = snapGrid[nextSlide];
                        } else {
                            newPosition = snapGrid[nextSlide - 1];
                        }

                        newPosition = -newPosition;
                    }

                    if (needsLoopFix) {
                        swiper.once('transitionEnd', function () {
                            swiper.loopFix();
                        });
                    } // Fix duration


                    if (swiper.velocity !== 0) {
                        if (rtl) {
                            momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                        } else {
                            momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                        }

                        if (params.freeModeSticky) {
                            // If freeModeSticky is active and the user ends a swipe with a slow-velocity
                            // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                            // It's easy to see this when simulating touch with mouse events. To fix this,
                            // limit single-slide swipes to the default slide duration. This also has the
                            // nice side effect of matching slide speed if the user stopped moving before
                            // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                            // For faster swipes, also apply limits (albeit higher ones).
                            var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                            var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

                            if (moveDistance < currentSlideSize) {
                                momentumDuration = params.speed;
                            } else if (moveDistance < 2 * currentSlideSize) {
                                momentumDuration = params.speed * 1.5;
                            } else {
                                momentumDuration = params.speed * 2.5;
                            }
                        }
                    } else if (params.freeModeSticky) {
                        swiper.slideToClosest();
                        return;
                    }

                    if (params.freeModeMomentumBounce && doBounce) {
                        swiper.updateProgress(afterBouncePosition);
                        swiper.setTransition(momentumDuration);
                        swiper.setTranslate(newPosition);
                        swiper.transitionStart(true, swiper.swipeDirection);
                        swiper.animating = true;
                        $wrapperEl.transitionEnd(function () {
                            if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                            swiper.emit('momentumBounce');
                            swiper.setTransition(params.speed);
                            setTimeout(function () {
                                swiper.setTranslate(afterBouncePosition);
                                $wrapperEl.transitionEnd(function () {
                                    if (!swiper || swiper.destroyed) return;
                                    swiper.transitionEnd();
                                });
                            }, 0);
                        });
                    } else if (swiper.velocity) {
                        swiper.updateProgress(newPosition);
                        swiper.setTransition(momentumDuration);
                        swiper.setTranslate(newPosition);
                        swiper.transitionStart(true, swiper.swipeDirection);

                        if (!swiper.animating) {
                            swiper.animating = true;
                            $wrapperEl.transitionEnd(function () {
                                if (!swiper || swiper.destroyed) return;
                                swiper.transitionEnd();
                            });
                        }
                    } else {
                        swiper.emit('_freeModeNoMomentumRelease');
                        swiper.updateProgress(newPosition);
                    }

                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                } else if (params.freeModeSticky) {
                    swiper.slideToClosest();
                    return;
                } else if (params.freeMode) {
                    swiper.emit('_freeModeNoMomentumRelease');
                }

                if (!params.freeModeMomentum || timeDiff >= params.longSwipesMs) {
                    swiper.updateProgress();
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                }

                return;
            } // Find current slide


            var stopIndex = 0;
            var groupSize = swiper.slidesSizesGrid[0];

            for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
                var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

                if (typeof slidesGrid[i + _increment] !== 'undefined') {
                    if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
                        stopIndex = i;
                        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
                    }
                } else if (currentPos >= slidesGrid[i]) {
                    stopIndex = i;
                    groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
                }
            } // Find current slide size


            var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
            var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

            if (timeDiff > params.longSwipesMs) {
                // Long touches
                if (!params.longSwipes) {
                    swiper.slideTo(swiper.activeIndex);
                    return;
                }

                if (swiper.swipeDirection === 'next') {
                    if (ratio >= params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
                }

                if (swiper.swipeDirection === 'prev') {
                    if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);else swiper.slideTo(stopIndex);
                }
            } else {
                // Short swipes
                if (!params.shortSwipes) {
                    swiper.slideTo(swiper.activeIndex);
                    return;
                }

                var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

                if (!isNavButtonTarget) {
                    if (swiper.swipeDirection === 'next') {
                        swiper.slideTo(stopIndex + increment);
                    }

                    if (swiper.swipeDirection === 'prev') {
                        swiper.slideTo(stopIndex);
                    }
                } else if (e.target === swiper.navigation.nextEl) {
                    swiper.slideTo(stopIndex + increment);
                } else {
                    swiper.slideTo(stopIndex);
                }
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onResize.js
        function onResize() {
            var swiper = this;
            var params = swiper.params,
                el = swiper.el;
            if (el && el.offsetWidth === 0) return; // Breakpoints

            if (params.breakpoints) {
                swiper.setBreakpoint();
            } // Save locks


            var allowSlideNext = swiper.allowSlideNext,
                allowSlidePrev = swiper.allowSlidePrev,
                snapGrid = swiper.snapGrid; // Disable locks on resize

            swiper.allowSlideNext = true;
            swiper.allowSlidePrev = true;
            swiper.updateSize();
            swiper.updateSlides();
            swiper.updateSlidesClasses();

            if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
                swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            } else {
                swiper.slideTo(swiper.activeIndex, 0, false, true);
            }

            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
                swiper.autoplay.run();
            } // Return locks after resize


            swiper.allowSlidePrev = allowSlidePrev;
            swiper.allowSlideNext = allowSlideNext;

            if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
                swiper.checkOverflow();
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onClick.js
        function onClick(e) {
            var swiper = this;
            if (!swiper.enabled) return;

            if (!swiper.allowClick) {
                if (swiper.params.preventClicks) e.preventDefault();

                if (swiper.params.preventClicksPropagation && swiper.animating) {
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/onScroll.js
        function onScroll() {
            var swiper = this;
            var wrapperEl = swiper.wrapperEl,
                rtlTranslate = swiper.rtlTranslate,
                enabled = swiper.enabled;
            if (!enabled) return;
            swiper.previousTranslate = swiper.translate;

            if (swiper.isHorizontal()) {
                if (rtlTranslate) {
                    swiper.translate = wrapperEl.scrollWidth - wrapperEl.offsetWidth - wrapperEl.scrollLeft;
                } else {
                    swiper.translate = -wrapperEl.scrollLeft;
                }
            } else {
                swiper.translate = -wrapperEl.scrollTop;
            } // eslint-disable-next-line


            if (swiper.translate === -0) swiper.translate = 0;
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
            var newProgress;
            var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

            if (translatesDiff === 0) {
                newProgress = 0;
            } else {
                newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
            }

            if (newProgress !== swiper.progress) {
                swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
            }

            swiper.emit('setTranslate', swiper.translate, false);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/events/index.js







        var dummyEventAttached = false;

        function dummyEventListener() {}

        function attachEvents() {
            var swiper = this;
            var document = getDocument();
            var params = swiper.params,
                touchEvents = swiper.touchEvents,
                el = swiper.el,
                wrapperEl = swiper.wrapperEl,
                device = swiper.device,
                support = swiper.support;
            swiper.onTouchStart = onTouchStart.bind(swiper);
            swiper.onTouchMove = onTouchMove.bind(swiper);
            swiper.onTouchEnd = onTouchEnd.bind(swiper);

            if (params.cssMode) {
                swiper.onScroll = onScroll.bind(swiper);
            }

            swiper.onClick = onClick.bind(swiper);
            var capture = !!params.nested; // Touch Events

            if (!support.touch && support.pointerEvents) {
                el.addEventListener(touchEvents.start, swiper.onTouchStart, false);
                document.addEventListener(touchEvents.move, swiper.onTouchMove, capture);
                document.addEventListener(touchEvents.end, swiper.onTouchEnd, false);
            } else {
                if (support.touch) {
                    var passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
                        passive: true,
                        capture: false
                    } : false;
                    el.addEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
                    el.addEventListener(touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
                        passive: false,
                        capture: capture
                    } : capture);
                    el.addEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

                    if (touchEvents.cancel) {
                        el.addEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
                    }

                    if (!dummyEventAttached) {
                        document.addEventListener('touchstart', dummyEventListener);
                        dummyEventAttached = true;
                    }
                }

                if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
                    el.addEventListener('mousedown', swiper.onTouchStart, false);
                    document.addEventListener('mousemove', swiper.onTouchMove, capture);
                    document.addEventListener('mouseup', swiper.onTouchEnd, false);
                }
            } // Prevent Links Clicks


            if (params.preventClicks || params.preventClicksPropagation) {
                el.addEventListener('click', swiper.onClick, true);
            }

            if (params.cssMode) {
                wrapperEl.addEventListener('scroll', swiper.onScroll);
            } // Resize handler


            if (params.updateOnWindowResize) {
                swiper.on(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
            } else {
                swiper.on('observerUpdate', onResize, true);
            }
        }

        function detachEvents() {
            var swiper = this;
            var document = getDocument();
            var params = swiper.params,
                touchEvents = swiper.touchEvents,
                el = swiper.el,
                wrapperEl = swiper.wrapperEl,
                device = swiper.device,
                support = swiper.support;
            var capture = !!params.nested; // Touch Events

            if (!support.touch && support.pointerEvents) {
                el.removeEventListener(touchEvents.start, swiper.onTouchStart, false);
                document.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
                document.removeEventListener(touchEvents.end, swiper.onTouchEnd, false);
            } else {
                if (support.touch) {
                    var passiveListener = touchEvents.start === 'onTouchStart' && support.passiveListener && params.passiveListeners ? {
                        passive: true,
                        capture: false
                    } : false;
                    el.removeEventListener(touchEvents.start, swiper.onTouchStart, passiveListener);
                    el.removeEventListener(touchEvents.move, swiper.onTouchMove, capture);
                    el.removeEventListener(touchEvents.end, swiper.onTouchEnd, passiveListener);

                    if (touchEvents.cancel) {
                        el.removeEventListener(touchEvents.cancel, swiper.onTouchEnd, passiveListener);
                    }
                }

                if (params.simulateTouch && !device.ios && !device.android || params.simulateTouch && !support.touch && device.ios) {
                    el.removeEventListener('mousedown', swiper.onTouchStart, false);
                    document.removeEventListener('mousemove', swiper.onTouchMove, capture);
                    document.removeEventListener('mouseup', swiper.onTouchEnd, false);
                }
            } // Prevent Links Clicks


            if (params.preventClicks || params.preventClicksPropagation) {
                el.removeEventListener('click', swiper.onClick, true);
            }

            if (params.cssMode) {
                wrapperEl.removeEventListener('scroll', swiper.onScroll);
            } // Resize handler


            swiper.off(device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize);
        }

        /* harmony default export */ const events = ({
            attachEvents: attachEvents,
            detachEvents: detachEvents
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/breakpoints/setBreakpoint.js

        function setBreakpoint() {
            var swiper = this;
            var activeIndex = swiper.activeIndex,
                initialized = swiper.initialized,
                _swiper$loopedSlides = swiper.loopedSlides,
                loopedSlides = _swiper$loopedSlides === void 0 ? 0 : _swiper$loopedSlides,
                params = swiper.params,
                $el = swiper.$el;
            var breakpoints = params.breakpoints;
            if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

            var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
            if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
            var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;

            if (breakpointOnlyParams) {
                ['slidesPerView', 'spaceBetween', 'slidesPerGroup', 'slidesPerGroupSkip', 'slidesPerColumn'].forEach(function (param) {
                    var paramValue = breakpointOnlyParams[param];
                    if (typeof paramValue === 'undefined') return;

                    if (param === 'slidesPerView' && (paramValue === 'AUTO' || paramValue === 'auto')) {
                        breakpointOnlyParams[param] = 'auto';
                    } else if (param === 'slidesPerView') {
                        breakpointOnlyParams[param] = parseFloat(paramValue);
                    } else {
                        breakpointOnlyParams[param] = parseInt(paramValue, 10);
                    }
                });
            }

            var breakpointParams = breakpointOnlyParams || swiper.originalParams;
            var wasMultiRow = params.slidesPerColumn > 1;
            var isMultiRow = breakpointParams.slidesPerColumn > 1;
            var wasEnabled = params.enabled;

            if (wasMultiRow && !isMultiRow) {
                $el.removeClass(params.containerModifierClass + "multirow " + params.containerModifierClass + "multirow-column");
                swiper.emitContainerClasses();
            } else if (!wasMultiRow && isMultiRow) {
                $el.addClass(params.containerModifierClass + "multirow");

                if (breakpointParams.slidesPerColumnFill && breakpointParams.slidesPerColumnFill === 'column' || !breakpointParams.slidesPerColumnFill && params.slidesPerColumnFill === 'column') {
                    $el.addClass(params.containerModifierClass + "multirow-column");
                }

                swiper.emitContainerClasses();
            }

            var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
            var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

            if (directionChanged && initialized) {
                swiper.changeDirection();
            }

            utils_extend(swiper.params, breakpointParams);
            var isEnabled = swiper.params.enabled;
            utils_extend(swiper, {
                allowTouchMove: swiper.params.allowTouchMove,
                allowSlideNext: swiper.params.allowSlideNext,
                allowSlidePrev: swiper.params.allowSlidePrev
            });

            if (wasEnabled && !isEnabled) {
                swiper.disable();
            } else if (!wasEnabled && isEnabled) {
                swiper.enable();
            }

            swiper.currentBreakpoint = breakpoint;
            swiper.emit('_beforeBreakpoint', breakpointParams);

            if (needsReLoop && initialized) {
                swiper.loopDestroy();
                swiper.loopCreate();
                swiper.updateSlides();
                swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
            }

            swiper.emit('breakpoint', breakpointParams);
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/breakpoints/getBreakpoint.js

        function getBreakpoint(breakpoints, base, containerEl) {
            if (base === void 0) {
                base = 'window';
            }

            if (!breakpoints || base === 'container' && !containerEl) return undefined;
            var breakpoint = false;
            var window = ssr_window_esm_getWindow();
            var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
            var points = Object.keys(breakpoints).map(function (point) {
                if (typeof point === 'string' && point.indexOf('@') === 0) {
                    var minRatio = parseFloat(point.substr(1));
                    var value = currentHeight * minRatio;
                    return {
                        value: value,
                        point: point
                    };
                }

                return {
                    value: point,
                    point: point
                };
            });
            points.sort(function (a, b) {
                return parseInt(a.value, 10) - parseInt(b.value, 10);
            });

            for (var i = 0; i < points.length; i += 1) {
                var _points$i = points[i],
                    point = _points$i.point,
                    value = _points$i.value;

                if (base === 'window') {
                    if (window.matchMedia("(min-width: " + value + "px)").matches) {
                        breakpoint = point;
                    }
                } else if (value <= containerEl.clientWidth) {
                    breakpoint = point;
                }
            }

            return breakpoint || 'max';
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/breakpoints/index.js


        /* harmony default export */ const breakpoints = ({
            setBreakpoint: setBreakpoint,
            getBreakpoint: getBreakpoint
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/classes/addClasses.js
        function prepareClasses(entries, prefix) {
            var resultClasses = [];
            entries.forEach(function (item) {
                if (typeof item === 'object') {
                    Object.keys(item).forEach(function (classNames) {
                        if (item[classNames]) {
                            resultClasses.push(prefix + classNames);
                        }
                    });
                } else if (typeof item === 'string') {
                    resultClasses.push(prefix + item);
                }
            });
            return resultClasses;
        }

        function addClasses() {
            var swiper = this;
            var classNames = swiper.classNames,
                params = swiper.params,
                rtl = swiper.rtl,
                $el = swiper.$el,
                device = swiper.device,
                support = swiper.support; // prettier-ignore

            var suffixes = prepareClasses(['initialized', params.direction, {
                'pointer-events': support.pointerEvents && !support.touch
            }, {
                'free-mode': params.freeMode
            }, {
                'autoheight': params.autoHeight
            }, {
                'rtl': rtl
            }, {
                'multirow': params.slidesPerColumn > 1
            }, {
                'multirow-column': params.slidesPerColumn > 1 && params.slidesPerColumnFill === 'column'
            }, {
                'android': device.android
            }, {
                'ios': device.ios
            }, {
                'css-mode': params.cssMode
            }], params.containerModifierClass);
            classNames.push.apply(classNames, suffixes);
            $el.addClass([].concat(classNames).join(' '));
            swiper.emitContainerClasses();
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/classes/removeClasses.js
        function removeClasses() {
            var swiper = this;
            var $el = swiper.$el,
                classNames = swiper.classNames;
            $el.removeClass(classNames.join(' '));
            swiper.emitContainerClasses();
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/classes/index.js


        /* harmony default export */ const classes = ({
            addClasses: addClasses,
            removeClasses: removeClasses
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/images/loadImage.js


        function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
            var window = ssr_window_esm_getWindow();
            var image;

            function onReady() {
                if (callback) callback();
            }

            var isPicture = dom(imageEl).parent('picture')[0];

            if (!isPicture && (!imageEl.complete || !checkForComplete)) {
                if (src) {
                    image = new window.Image();
                    image.onload = onReady;
                    image.onerror = onReady;

                    if (sizes) {
                        image.sizes = sizes;
                    }

                    if (srcset) {
                        image.srcset = srcset;
                    }

                    if (src) {
                        image.src = src;
                    }
                } else {
                    onReady();
                }
            } else {
                // image already loaded...
                onReady();
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/images/preloadImages.js
        function preloadImages() {
            var swiper = this;
            swiper.imagesToLoad = swiper.$el.find('img');

            function onReady() {
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
                if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

                if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
                    if (swiper.params.updateOnImagesReady) swiper.update();
                    swiper.emit('imagesReady');
                }
            }

            for (var i = 0; i < swiper.imagesToLoad.length; i += 1) {
                var imageEl = swiper.imagesToLoad[i];
                swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
            }
        }
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/images/index.js


        /* harmony default export */ const core_images = ({
            loadImage: loadImage,
            preloadImages: preloadImages
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/check-overflow/index.js
        function checkOverflow() {
            var swiper = this;
            var params = swiper.params;
            var wasLocked = swiper.isLocked;
            var lastSlidePosition = swiper.slides.length > 0 && params.slidesOffsetBefore + params.spaceBetween * (swiper.slides.length - 1) + swiper.slides[0].offsetWidth * swiper.slides.length;

            if (params.slidesOffsetBefore && params.slidesOffsetAfter && lastSlidePosition) {
                swiper.isLocked = lastSlidePosition <= swiper.size;
            } else {
                swiper.isLocked = swiper.snapGrid.length === 1;
            }

            swiper.allowSlideNext = !swiper.isLocked;
            swiper.allowSlidePrev = !swiper.isLocked; // events

            if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');

            if (wasLocked && wasLocked !== swiper.isLocked) {
                swiper.isEnd = false;
                if (swiper.navigation) swiper.navigation.update();
            }
        }

        /* harmony default export */ const check_overflow = ({
            checkOverflow: checkOverflow
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/defaults.js
        /* harmony default export */ const defaults = ({
            init: true,
            direction: 'horizontal',
            touchEventsTarget: 'container',
            initialSlide: 0,
            speed: 300,
            cssMode: false,
            updateOnWindowResize: true,
            resizeObserver: false,
            nested: false,
            createElements: false,
            enabled: true,
            focusableElements: 'input, select, option, textarea, button, video, label',
            // Overrides
            width: null,
            height: null,
            //
            preventInteractionOnTransition: false,
            // ssr
            userAgent: null,
            url: null,
            // To support iOS's swipe-to-go-back gesture (when being used in-app).
            edgeSwipeDetection: false,
            edgeSwipeThreshold: 20,
            // Free mode
            freeMode: false,
            freeModeMomentum: true,
            freeModeMomentumRatio: 1,
            freeModeMomentumBounce: true,
            freeModeMomentumBounceRatio: 1,
            freeModeMomentumVelocityRatio: 1,
            freeModeSticky: false,
            freeModeMinimumVelocity: 0.02,
            // Autoheight
            autoHeight: false,
            // Set wrapper width
            setWrapperSize: false,
            // Virtual Translate
            virtualTranslate: false,
            // Effects
            effect: 'slide',
            // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
            // Breakpoints
            breakpoints: undefined,
            breakpointsBase: 'window',
            // Slides grid
            spaceBetween: 0,
            slidesPerView: 1,
            slidesPerColumn: 1,
            slidesPerColumnFill: 'column',
            slidesPerGroup: 1,
            slidesPerGroupSkip: 0,
            centeredSlides: false,
            centeredSlidesBounds: false,
            slidesOffsetBefore: 0,
            // in px
            slidesOffsetAfter: 0,
            // in px
            normalizeSlideIndex: true,
            centerInsufficientSlides: false,
            // Disable swiper and hide navigation when container not overflow
            watchOverflow: false,
            // Round length
            roundLengths: false,
            // Touches
            touchRatio: 1,
            touchAngle: 45,
            simulateTouch: true,
            shortSwipes: true,
            longSwipes: true,
            longSwipesRatio: 0.5,
            longSwipesMs: 300,
            followFinger: true,
            allowTouchMove: true,
            threshold: 0,
            touchMoveStopPropagation: false,
            touchStartPreventDefault: true,
            touchStartForcePreventDefault: false,
            touchReleaseOnEdges: false,
            // Unique Navigation Elements
            uniqueNavElements: true,
            // Resistance
            resistance: true,
            resistanceRatio: 0.85,
            // Progress
            watchSlidesProgress: false,
            watchSlidesVisibility: false,
            // Cursor
            grabCursor: false,
            // Clicks
            preventClicks: true,
            preventClicksPropagation: true,
            slideToClickedSlide: false,
            // Images
            preloadImages: true,
            updateOnImagesReady: true,
            // loop
            loop: false,
            loopAdditionalSlides: 0,
            loopedSlides: null,
            loopFillGroupWithBlank: false,
            loopPreventsSlide: true,
            // Swiping/no swiping
            allowSlidePrev: true,
            allowSlideNext: true,
            swipeHandler: null,
            // '.swipe-handler',
            noSwiping: true,
            noSwipingClass: 'swiper-no-swiping',
            noSwipingSelector: null,
            // Passive Listeners
            passiveListeners: true,
            // NS
            containerModifierClass: 'swiper-container-',
            // NEW
            slideClass: 'swiper-slide',
            slideBlankClass: 'swiper-slide-invisible-blank',
            slideActiveClass: 'swiper-slide-active',
            slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
            slideVisibleClass: 'swiper-slide-visible',
            slideDuplicateClass: 'swiper-slide-duplicate',
            slideNextClass: 'swiper-slide-next',
            slideDuplicateNextClass: 'swiper-slide-duplicate-next',
            slidePrevClass: 'swiper-slide-prev',
            slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
            wrapperClass: 'swiper-wrapper',
            // Callbacks
            runCallbacksOnInit: true,
            // Internals
            _emitClasses: false
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/core/core-class.js
        function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

        function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

        /* eslint no-param-reassign: "off" */























        var prototypes = {
            modular: modular,
            eventsEmitter: events_emitter,
            update: update,
            translate: translate,
            transition: core_transition,
            slide: slide,
            loop: loop,
            grabCursor: grab_cursor,
            manipulation: manipulation,
            events: events,
            breakpoints: breakpoints,
            checkOverflow: check_overflow,
            classes: classes,
            images: core_images
        };
        var extendedDefaults = {};

        var core_class_Swiper = /*#__PURE__*/function () {
            function Swiper() {
                var el;
                var params;

                for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                    args[_key] = arguments[_key];
                }

                if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
                    params = args[0];
                } else {
                    el = args[0];
                    params = args[1];
                }

                if (!params) params = {};
                params = utils_extend({}, params);
                if (el && !params.el) params.el = el;

                if (params.el && dom(params.el).length > 1) {
                    var swipers = [];
                    dom(params.el).each(function (containerEl) {
                        var newParams = utils_extend({}, params, {
                            el: containerEl
                        });
                        swipers.push(new Swiper(newParams));
                    });
                    return swipers;
                } // Swiper Instance


                var swiper = this;
                swiper.__swiper__ = true;
                swiper.support = getSupport();
                swiper.device = getDevice({
                    userAgent: params.userAgent
                });
                swiper.browser = getBrowser();
                swiper.eventsListeners = {};
                swiper.eventsAnyListeners = [];

                if (typeof swiper.modules === 'undefined') {
                    swiper.modules = {};
                }

                Object.keys(swiper.modules).forEach(function (moduleName) {
                    var module = swiper.modules[moduleName];

                    if (module.params) {
                        var moduleParamName = Object.keys(module.params)[0];
                        var moduleParams = module.params[moduleParamName];
                        if (typeof moduleParams !== 'object' || moduleParams === null) return;

                        if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
                            params[moduleParamName] = {
                                auto: true
                            };
                        }

                        if (!(moduleParamName in params && 'enabled' in moduleParams)) return;

                        if (params[moduleParamName] === true) {
                            params[moduleParamName] = {
                                enabled: true
                            };
                        }

                        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
                            params[moduleParamName].enabled = true;
                        }

                        if (!params[moduleParamName]) params[moduleParamName] = {
                            enabled: false
                        };
                    }
                }); // Extend defaults with modules params

                var swiperParams = utils_extend({}, defaults);
                swiper.useParams(swiperParams); // Extend defaults with passed params

                swiper.params = utils_extend({}, swiperParams, extendedDefaults, params);
                swiper.originalParams = utils_extend({}, swiper.params);
                swiper.passedParams = utils_extend({}, params); // add event listeners

                if (swiper.params && swiper.params.on) {
                    Object.keys(swiper.params.on).forEach(function (eventName) {
                        swiper.on(eventName, swiper.params.on[eventName]);
                    });
                }

                if (swiper.params && swiper.params.onAny) {
                    swiper.onAny(swiper.params.onAny);
                } // Save Dom lib


                swiper.$ = dom; // Extend Swiper

                utils_extend(swiper, {
                    enabled: swiper.params.enabled,
                    el: el,
                    // Classes
                    classNames: [],
                    // Slides
                    slides: dom(),
                    slidesGrid: [],
                    snapGrid: [],
                    slidesSizesGrid: [],
                    // isDirection
                    isHorizontal: function isHorizontal() {
                        return swiper.params.direction === 'horizontal';
                    },
                    isVertical: function isVertical() {
                        return swiper.params.direction === 'vertical';
                    },
                    // Indexes
                    activeIndex: 0,
                    realIndex: 0,
                    //
                    isBeginning: true,
                    isEnd: false,
                    // Props
                    translate: 0,
                    previousTranslate: 0,
                    progress: 0,
                    velocity: 0,
                    animating: false,
                    // Locks
                    allowSlideNext: swiper.params.allowSlideNext,
                    allowSlidePrev: swiper.params.allowSlidePrev,
                    // Touch Events
                    touchEvents: function touchEvents() {
                        var touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
                        var desktop = ['mousedown', 'mousemove', 'mouseup'];

                        if (swiper.support.pointerEvents) {
                            desktop = ['pointerdown', 'pointermove', 'pointerup'];
                        }

                        swiper.touchEventsTouch = {
                            start: touch[0],
                            move: touch[1],
                            end: touch[2],
                            cancel: touch[3]
                        };
                        swiper.touchEventsDesktop = {
                            start: desktop[0],
                            move: desktop[1],
                            end: desktop[2]
                        };
                        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
                    }(),
                    touchEventsData: {
                        isTouched: undefined,
                        isMoved: undefined,
                        allowTouchCallbacks: undefined,
                        touchStartTime: undefined,
                        isScrolling: undefined,
                        currentTranslate: undefined,
                        startTranslate: undefined,
                        allowThresholdMove: undefined,
                        // Form elements to match
                        focusableElements: swiper.params.focusableElements,
                        // Last click time
                        lastClickTime: now(),
                        clickTimeout: undefined,
                        // Velocities
                        velocities: [],
                        allowMomentumBounce: undefined,
                        isTouchEvent: undefined,
                        startMoving: undefined
                    },
                    // Clicks
                    allowClick: true,
                    // Touches
                    allowTouchMove: swiper.params.allowTouchMove,
                    touches: {
                        startX: 0,
                        startY: 0,
                        currentX: 0,
                        currentY: 0,
                        diff: 0
                    },
                    // Images
                    imagesToLoad: [],
                    imagesLoaded: 0
                }); // Install Modules

                swiper.useModules();
                swiper.emit('_swiper'); // Init

                if (swiper.params.init) {
                    swiper.init();
                } // Return app instance


                return swiper;
            }

            var _proto = Swiper.prototype;

            _proto.enable = function enable() {
                var swiper = this;
                if (swiper.enabled) return;
                swiper.enabled = true;

                if (swiper.params.grabCursor) {
                    swiper.setGrabCursor();
                }

                swiper.emit('enable');
            };

            _proto.disable = function disable() {
                var swiper = this;
                if (!swiper.enabled) return;
                swiper.enabled = false;

                if (swiper.params.grabCursor) {
                    swiper.unsetGrabCursor();
                }

                swiper.emit('disable');
            };

            _proto.setProgress = function setProgress(progress, speed) {
                var swiper = this;
                progress = Math.min(Math.max(progress, 0), 1);
                var min = swiper.minTranslate();
                var max = swiper.maxTranslate();
                var current = (max - min) * progress + min;
                swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            };

            _proto.emitContainerClasses = function emitContainerClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var classes = swiper.el.className.split(' ').filter(function (className) {
                    return className.indexOf('swiper-container') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
                });
                swiper.emit('_containerClasses', classes.join(' '));
            };

            _proto.getSlideClasses = function getSlideClasses(slideEl) {
                var swiper = this;
                return slideEl.className.split(' ').filter(function (className) {
                    return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
                }).join(' ');
            };

            _proto.emitSlidesClasses = function emitSlidesClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var updates = [];
                swiper.slides.each(function (slideEl) {
                    var classNames = swiper.getSlideClasses(slideEl);
                    updates.push({
                        slideEl: slideEl,
                        classNames: classNames
                    });
                    swiper.emit('_slideClass', slideEl, classNames);
                });
                swiper.emit('_slideClasses', updates);
            };

            _proto.slidesPerViewDynamic = function slidesPerViewDynamic() {
                var swiper = this;
                var params = swiper.params,
                    slides = swiper.slides,
                    slidesGrid = swiper.slidesGrid,
                    swiperSize = swiper.size,
                    activeIndex = swiper.activeIndex;
                var spv = 1;

                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex].swiperSlideSize;
                    var breakLoop;

                    for (var i = activeIndex + 1; i < slides.length; i += 1) {
                        if (slides[i] && !breakLoop) {
                            slideSize += slides[i].swiperSlideSize;
                            spv += 1;
                            if (slideSize > swiperSize) breakLoop = true;
                        }
                    }

                    for (var _i = activeIndex - 1; _i >= 0; _i -= 1) {
                        if (slides[_i] && !breakLoop) {
                            slideSize += slides[_i].swiperSlideSize;
                            spv += 1;
                            if (slideSize > swiperSize) breakLoop = true;
                        }
                    }
                } else {
                    for (var _i2 = activeIndex + 1; _i2 < slides.length; _i2 += 1) {
                        if (slidesGrid[_i2] - slidesGrid[activeIndex] < swiperSize) {
                            spv += 1;
                        }
                    }
                }

                return spv;
            };

            _proto.update = function update() {
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid,
                    params = swiper.params; // Breakpoints

                if (params.breakpoints) {
                    swiper.setBreakpoint();
                }

                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();

                function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                }

                var translated;

                if (swiper.params.freeMode) {
                    setTranslate();

                    if (swiper.params.autoHeight) {
                        swiper.updateAutoHeight();
                    }
                } else {
                    if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
                        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
                    } else {
                        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    }

                    if (!translated) {
                        setTranslate();
                    }
                }

                if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
                    swiper.checkOverflow();
                }

                swiper.emit('update');
            };

            _proto.changeDirection = function changeDirection(newDirection, needUpdate) {
                if (needUpdate === void 0) {
                    needUpdate = true;
                }

                var swiper = this;
                var currentDirection = swiper.params.direction;

                if (!newDirection) {
                    // eslint-disable-next-line
                    newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
                }

                if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
                    return swiper;
                }

                swiper.$el.removeClass("" + swiper.params.containerModifierClass + currentDirection).addClass("" + swiper.params.containerModifierClass + newDirection);
                swiper.emitContainerClasses();
                swiper.params.direction = newDirection;
                swiper.slides.each(function (slideEl) {
                    if (newDirection === 'vertical') {
                        slideEl.style.width = '';
                    } else {
                        slideEl.style.height = '';
                    }
                });
                swiper.emit('changeDirection');
                if (needUpdate) swiper.update();
                return swiper;
            };

            _proto.mount = function mount(el) {
                var swiper = this;
                if (swiper.mounted) return true; // Find el

                var $el = dom(el || swiper.params.el);
                el = $el[0];

                if (!el) {
                    return false;
                }

                el.swiper = swiper;

                var getWrapperSelector = function getWrapperSelector() {
                    return "." + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
                };

                var getWrapper = function getWrapper() {
                    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                        var res = dom(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

                        res.children = function (options) {
                            return $el.children(options);
                        };

                        return res;
                    }

                    return $el.children(getWrapperSelector());
                }; // Find Wrapper


                var $wrapperEl = getWrapper();

                if ($wrapperEl.length === 0 && swiper.params.createElements) {
                    var document = getDocument();
                    var wrapper = document.createElement('div');
                    $wrapperEl = dom(wrapper);
                    wrapper.className = swiper.params.wrapperClass;
                    $el.append(wrapper);
                    $el.children("." + swiper.params.slideClass).each(function (slideEl) {
                        $wrapperEl.append(slideEl);
                    });
                }

                utils_extend(swiper, {
                    $el: $el,
                    el: el,
                    $wrapperEl: $wrapperEl,
                    wrapperEl: $wrapperEl[0],
                    mounted: true,
                    // RTL
                    rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
                    rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
                    wrongRTL: $wrapperEl.css('display') === '-webkit-box'
                });
                return true;
            };

            _proto.init = function init(el) {
                var swiper = this;
                if (swiper.initialized) return swiper;
                var mounted = swiper.mount(el);
                if (mounted === false) return swiper;
                swiper.emit('beforeInit'); // Set breakpoint

                if (swiper.params.breakpoints) {
                    swiper.setBreakpoint();
                } // Add Classes


                swiper.addClasses(); // Create loop

                if (swiper.params.loop) {
                    swiper.loopCreate();
                } // Update size


                swiper.updateSize(); // Update slides

                swiper.updateSlides();

                if (swiper.params.watchOverflow) {
                    swiper.checkOverflow();
                } // Set Grab Cursor


                if (swiper.params.grabCursor && swiper.enabled) {
                    swiper.setGrabCursor();
                }

                if (swiper.params.preloadImages) {
                    swiper.preloadImages();
                } // Slide To Initial Slide


                if (swiper.params.loop) {
                    swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
                } else {
                    swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
                } // Attach events


                swiper.attachEvents(); // Init Flag

                swiper.initialized = true; // Emit

                swiper.emit('init');
                swiper.emit('afterInit');
                return swiper;
            };

            _proto.destroy = function destroy(deleteInstance, cleanStyles) {
                if (deleteInstance === void 0) {
                    deleteInstance = true;
                }

                if (cleanStyles === void 0) {
                    cleanStyles = true;
                }

                var swiper = this;
                var params = swiper.params,
                    $el = swiper.$el,
                    $wrapperEl = swiper.$wrapperEl,
                    slides = swiper.slides;

                if (typeof swiper.params === 'undefined' || swiper.destroyed) {
                    return null;
                }

                swiper.emit('beforeDestroy'); // Init Flag

                swiper.initialized = false; // Detach events

                swiper.detachEvents(); // Destroy loop

                if (params.loop) {
                    swiper.loopDestroy();
                } // Cleanup styles


                if (cleanStyles) {
                    swiper.removeClasses();
                    $el.removeAttr('style');
                    $wrapperEl.removeAttr('style');

                    if (slides && slides.length) {
                        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
                    }
                }

                swiper.emit('destroy'); // Detach emitter events

                Object.keys(swiper.eventsListeners).forEach(function (eventName) {
                    swiper.off(eventName);
                });

                if (deleteInstance !== false) {
                    swiper.$el[0].swiper = null;
                    deleteProps(swiper);
                }

                swiper.destroyed = true;
                return null;
            };

            Swiper.extendDefaults = function extendDefaults(newDefaults) {
                utils_extend(extendedDefaults, newDefaults);
            };

            Swiper.installModule = function installModule(module) {
                if (!Swiper.prototype.modules) Swiper.prototype.modules = {};
                var name = module.name || Object.keys(Swiper.prototype.modules).length + "_" + now();
                Swiper.prototype.modules[name] = module;
            };

            Swiper.use = function use(module) {
                if (Array.isArray(module)) {
                    module.forEach(function (m) {
                        return Swiper.installModule(m);
                    });
                    return Swiper;
                }

                Swiper.installModule(module);
                return Swiper;
            };

            _createClass(Swiper, null, [{
                key: "extendedDefaults",
                get: function get() {
                    return extendedDefaults;
                }
            }, {
                key: "defaults",
                get: function get() {
                    return defaults;
                }
            }]);

            return Swiper;
        }();

        Object.keys(prototypes).forEach(function (prototypeGroup) {
            Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
                core_class_Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
            });
        });
        core_class_Swiper.use([resize_resize, observer]);
        /* harmony default export */ const core_class = (core_class_Swiper);
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/navigation/navigation.js
        function navigation_extends() { navigation_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return navigation_extends.apply(this, arguments); }



        var Navigation = {
            toggleEl: function toggleEl($el, disabled) {
                $el[disabled ? 'addClass' : 'removeClass'](this.params.navigation.disabledClass);
                if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
            },
            update: function update() {
                // Update Navigation Buttons
                var swiper = this;
                var params = swiper.params.navigation;
                var toggleEl = swiper.navigation.toggleEl;
                if (swiper.params.loop) return;
                var _swiper$navigation = swiper.navigation,
                    $nextEl = _swiper$navigation.$nextEl,
                    $prevEl = _swiper$navigation.$prevEl;

                if ($prevEl && $prevEl.length > 0) {
                    if (swiper.isBeginning) {
                        toggleEl($prevEl, true);
                    } else {
                        toggleEl($prevEl, false);
                    }

                    if (swiper.params.watchOverflow && swiper.enabled) {
                        $prevEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
                    }
                }

                if ($nextEl && $nextEl.length > 0) {
                    if (swiper.isEnd) {
                        toggleEl($nextEl, true);
                    } else {
                        toggleEl($nextEl, false);
                    }

                    if (swiper.params.watchOverflow && swiper.enabled) {
                        $nextEl[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
                    }
                }
            },
            onPrevClick: function onPrevClick(e) {
                var swiper = this;
                e.preventDefault();
                if (swiper.isBeginning && !swiper.params.loop) return;
                swiper.slidePrev();
            },
            onNextClick: function onNextClick(e) {
                var swiper = this;
                e.preventDefault();
                if (swiper.isEnd && !swiper.params.loop) return;
                swiper.slideNext();
            },
            init: function init() {
                var swiper = this;
                var params = swiper.params.navigation;
                swiper.params.navigation = createElementIfNotDefined(swiper.$el, swiper.params.navigation, swiper.params.createElements, {
                    nextEl: 'swiper-button-next',
                    prevEl: 'swiper-button-prev'
                });
                if (!(params.nextEl || params.prevEl)) return;
                var $nextEl;
                var $prevEl;

                if (params.nextEl) {
                    $nextEl = dom(params.nextEl);

                    if (swiper.params.uniqueNavElements && typeof params.nextEl === 'string' && $nextEl.length > 1 && swiper.$el.find(params.nextEl).length === 1) {
                        $nextEl = swiper.$el.find(params.nextEl);
                    }
                }

                if (params.prevEl) {
                    $prevEl = dom(params.prevEl);

                    if (swiper.params.uniqueNavElements && typeof params.prevEl === 'string' && $prevEl.length > 1 && swiper.$el.find(params.prevEl).length === 1) {
                        $prevEl = swiper.$el.find(params.prevEl);
                    }
                }

                if ($nextEl && $nextEl.length > 0) {
                    $nextEl.on('click', swiper.navigation.onNextClick);
                }

                if ($prevEl && $prevEl.length > 0) {
                    $prevEl.on('click', swiper.navigation.onPrevClick);
                }

                utils_extend(swiper.navigation, {
                    $nextEl: $nextEl,
                    nextEl: $nextEl && $nextEl[0],
                    $prevEl: $prevEl,
                    prevEl: $prevEl && $prevEl[0]
                });

                if (!swiper.enabled) {
                    if ($nextEl) $nextEl.addClass(params.lockClass);
                    if ($prevEl) $prevEl.addClass(params.lockClass);
                }
            },
            destroy: function destroy() {
                var swiper = this;
                var _swiper$navigation2 = swiper.navigation,
                    $nextEl = _swiper$navigation2.$nextEl,
                    $prevEl = _swiper$navigation2.$prevEl;

                if ($nextEl && $nextEl.length) {
                    $nextEl.off('click', swiper.navigation.onNextClick);
                    $nextEl.removeClass(swiper.params.navigation.disabledClass);
                }

                if ($prevEl && $prevEl.length) {
                    $prevEl.off('click', swiper.navigation.onPrevClick);
                    $prevEl.removeClass(swiper.params.navigation.disabledClass);
                }
            }
        };
        /* harmony default export */ const navigation = ({
            name: 'navigation',
            params: {
                navigation: {
                    nextEl: null,
                    prevEl: null,
                    hideOnClick: false,
                    disabledClass: 'swiper-button-disabled',
                    hiddenClass: 'swiper-button-hidden',
                    lockClass: 'swiper-button-lock'
                }
            },
            create: function create() {
                var swiper = this;
                bindModuleMethods(swiper, {
                    navigation: navigation_extends({}, Navigation)
                });
            },
            on: {
                init: function init(swiper) {
                    swiper.navigation.init();
                    swiper.navigation.update();
                },
                toEdge: function toEdge(swiper) {
                    swiper.navigation.update();
                },
                fromEdge: function fromEdge(swiper) {
                    swiper.navigation.update();
                },
                destroy: function destroy(swiper) {
                    swiper.navigation.destroy();
                },
                'enable disable': function enableDisable(swiper) {
                    var _swiper$navigation3 = swiper.navigation,
                        $nextEl = _swiper$navigation3.$nextEl,
                        $prevEl = _swiper$navigation3.$prevEl;

                    if ($nextEl) {
                        $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
                    }

                    if ($prevEl) {
                        $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
                    }
                },
                click: function click(swiper, e) {
                    var _swiper$navigation4 = swiper.navigation,
                        $nextEl = _swiper$navigation4.$nextEl,
                        $prevEl = _swiper$navigation4.$prevEl;
                    var targetEl = e.target;

                    if (swiper.params.navigation.hideOnClick && !dom(targetEl).is($prevEl) && !dom(targetEl).is($nextEl)) {
                        if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
                        var isHidden;

                        if ($nextEl) {
                            isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
                        } else if ($prevEl) {
                            isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
                        }

                        if (isHidden === true) {
                            swiper.emit('navigationShow');
                        } else {
                            swiper.emit('navigationHide');
                        }

                        if ($nextEl) {
                            $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
                        }

                        if ($prevEl) {
                            $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
                        }
                    }
                }
            }
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/pagination/pagination.js
        function pagination_extends() { pagination_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return pagination_extends.apply(this, arguments); }



        var Pagination = {
            update: function update() {
                // Render || Update Pagination bullets/items
                var swiper = this;
                var rtl = swiper.rtl;
                var params = swiper.params.pagination;
                if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
                var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
                var $el = swiper.pagination.$el; // Current/Total

                var current;
                var total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

                if (swiper.params.loop) {
                    current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

                    if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
                        current -= slidesLength - swiper.loopedSlides * 2;
                    }

                    if (current > total - 1) current -= total;
                    if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
                } else if (typeof swiper.snapIndex !== 'undefined') {
                    current = swiper.snapIndex;
                } else {
                    current = swiper.activeIndex || 0;
                } // Types


                if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
                    var bullets = swiper.pagination.bullets;
                    var firstIndex;
                    var lastIndex;
                    var midIndex;

                    if (params.dynamicBullets) {
                        swiper.pagination.bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                        $el.css(swiper.isHorizontal() ? 'width' : 'height', swiper.pagination.bulletSize * (params.dynamicMainBullets + 4) + "px");

                        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                            swiper.pagination.dynamicBulletIndex += current - swiper.previousIndex;

                            if (swiper.pagination.dynamicBulletIndex > params.dynamicMainBullets - 1) {
                                swiper.pagination.dynamicBulletIndex = params.dynamicMainBullets - 1;
                            } else if (swiper.pagination.dynamicBulletIndex < 0) {
                                swiper.pagination.dynamicBulletIndex = 0;
                            }
                        }

                        firstIndex = current - swiper.pagination.dynamicBulletIndex;
                        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                        midIndex = (lastIndex + firstIndex) / 2;
                    }

                    bullets.removeClass(params.bulletActiveClass + " " + params.bulletActiveClass + "-next " + params.bulletActiveClass + "-next-next " + params.bulletActiveClass + "-prev " + params.bulletActiveClass + "-prev-prev " + params.bulletActiveClass + "-main");

                    if ($el.length > 1) {
                        bullets.each(function (bullet) {
                            var $bullet = dom(bullet);
                            var bulletIndex = $bullet.index();

                            if (bulletIndex === current) {
                                $bullet.addClass(params.bulletActiveClass);
                            }

                            if (params.dynamicBullets) {
                                if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
                                    $bullet.addClass(params.bulletActiveClass + "-main");
                                }

                                if (bulletIndex === firstIndex) {
                                    $bullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                                }

                                if (bulletIndex === lastIndex) {
                                    $bullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                                }
                            }
                        });
                    } else {
                        var $bullet = bullets.eq(current);
                        var bulletIndex = $bullet.index();
                        $bullet.addClass(params.bulletActiveClass);

                        if (params.dynamicBullets) {
                            var $firstDisplayedBullet = bullets.eq(firstIndex);
                            var $lastDisplayedBullet = bullets.eq(lastIndex);

                            for (var i = firstIndex; i <= lastIndex; i += 1) {
                                bullets.eq(i).addClass(params.bulletActiveClass + "-main");
                            }

                            if (swiper.params.loop) {
                                if (bulletIndex >= bullets.length - params.dynamicMainBullets) {
                                    for (var _i = params.dynamicMainBullets; _i >= 0; _i -= 1) {
                                        bullets.eq(bullets.length - _i).addClass(params.bulletActiveClass + "-main");
                                    }

                                    bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(params.bulletActiveClass + "-prev");
                                } else {
                                    $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                                    $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                                }
                            } else {
                                $firstDisplayedBullet.prev().addClass(params.bulletActiveClass + "-prev").prev().addClass(params.bulletActiveClass + "-prev-prev");
                                $lastDisplayedBullet.next().addClass(params.bulletActiveClass + "-next").next().addClass(params.bulletActiveClass + "-next-next");
                            }
                        }
                    }

                    if (params.dynamicBullets) {
                        var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                        var bulletsOffset = (swiper.pagination.bulletSize * dynamicBulletsLength - swiper.pagination.bulletSize) / 2 - midIndex * swiper.pagination.bulletSize;
                        var offsetProp = rtl ? 'right' : 'left';
                        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', bulletsOffset + "px");
                    }
                }

                if (params.type === 'fraction') {
                    $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
                    $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
                }

                if (params.type === 'progressbar') {
                    var progressbarDirection;

                    if (params.progressbarOpposite) {
                        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
                    } else {
                        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
                    }

                    var scale = (current + 1) / total;
                    var scaleX = 1;
                    var scaleY = 1;

                    if (progressbarDirection === 'horizontal') {
                        scaleX = scale;
                    } else {
                        scaleY = scale;
                    }

                    $el.find(classesToSelector(params.progressbarFillClass)).transform("translate3d(0,0,0) scaleX(" + scaleX + ") scaleY(" + scaleY + ")").transition(swiper.params.speed);
                }

                if (params.type === 'custom' && params.renderCustom) {
                    $el.html(params.renderCustom(swiper, current + 1, total));
                    swiper.emit('paginationRender', $el[0]);
                } else {
                    swiper.emit('paginationUpdate', $el[0]);
                }

                if (swiper.params.watchOverflow && swiper.enabled) {
                    $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
                }
            },
            render: function render() {
                // Render Container
                var swiper = this;
                var params = swiper.params.pagination;
                if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
                var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
                var $el = swiper.pagination.$el;
                var paginationHTML = '';

                if (params.type === 'bullets') {
                    var numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

                    if (swiper.params.freeMode && !swiper.params.loop && numberOfBullets > slidesLength) {
                        numberOfBullets = slidesLength;
                    }

                    for (var i = 0; i < numberOfBullets; i += 1) {
                        if (params.renderBullet) {
                            paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
                        } else {
                            paginationHTML += "<" + params.bulletElement + " class=\"" + params.bulletClass + "\"></" + params.bulletElement + ">";
                        }
                    }

                    $el.html(paginationHTML);
                    swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
                }

                if (params.type === 'fraction') {
                    if (params.renderFraction) {
                        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
                    } else {
                        paginationHTML = "<span class=\"" + params.currentClass + "\"></span>" + ' / ' + ("<span class=\"" + params.totalClass + "\"></span>");
                    }

                    $el.html(paginationHTML);
                }

                if (params.type === 'progressbar') {
                    if (params.renderProgressbar) {
                        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
                    } else {
                        paginationHTML = "<span class=\"" + params.progressbarFillClass + "\"></span>";
                    }

                    $el.html(paginationHTML);
                }

                if (params.type !== 'custom') {
                    swiper.emit('paginationRender', swiper.pagination.$el[0]);
                }
            },
            init: function init() {
                var swiper = this;
                swiper.params.pagination = createElementIfNotDefined(swiper.$el, swiper.params.pagination, swiper.params.createElements, {
                    el: 'swiper-pagination'
                });
                var params = swiper.params.pagination;
                if (!params.el) return;
                var $el = dom(params.el);
                if ($el.length === 0) return;

                if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
                    $el = swiper.$el.find(params.el);
                }

                if (params.type === 'bullets' && params.clickable) {
                    $el.addClass(params.clickableClass);
                }

                $el.addClass(params.modifierClass + params.type);

                if (params.type === 'bullets' && params.dynamicBullets) {
                    $el.addClass("" + params.modifierClass + params.type + "-dynamic");
                    swiper.pagination.dynamicBulletIndex = 0;

                    if (params.dynamicMainBullets < 1) {
                        params.dynamicMainBullets = 1;
                    }
                }

                if (params.type === 'progressbar' && params.progressbarOpposite) {
                    $el.addClass(params.progressbarOppositeClass);
                }

                if (params.clickable) {
                    $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
                        e.preventDefault();
                        var index = dom(this).index() * swiper.params.slidesPerGroup;
                        if (swiper.params.loop) index += swiper.loopedSlides;
                        swiper.slideTo(index);
                    });
                }

                utils_extend(swiper.pagination, {
                    $el: $el,
                    el: $el[0]
                });

                if (!swiper.enabled) {
                    $el.addClass(params.lockClass);
                }
            },
            destroy: function destroy() {
                var swiper = this;
                var params = swiper.params.pagination;
                if (!params.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0) return;
                var $el = swiper.pagination.$el;
                $el.removeClass(params.hiddenClass);
                $el.removeClass(params.modifierClass + params.type);
                if (swiper.pagination.bullets) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

                if (params.clickable) {
                    $el.off('click', classesToSelector(params.bulletClass));
                }
            }
        };
        /* harmony default export */ const pagination = ({
            name: 'pagination',
            params: {
                pagination: {
                    el: null,
                    bulletElement: 'span',
                    clickable: false,
                    hideOnClick: false,
                    renderBullet: null,
                    renderProgressbar: null,
                    renderFraction: null,
                    renderCustom: null,
                    progressbarOpposite: false,
                    type: 'bullets',
                    // 'bullets' or 'progressbar' or 'fraction' or 'custom'
                    dynamicBullets: false,
                    dynamicMainBullets: 1,
                    formatFractionCurrent: function formatFractionCurrent(number) {
                        return number;
                    },
                    formatFractionTotal: function formatFractionTotal(number) {
                        return number;
                    },
                    bulletClass: 'swiper-pagination-bullet',
                    bulletActiveClass: 'swiper-pagination-bullet-active',
                    modifierClass: 'swiper-pagination-',
                    // NEW
                    currentClass: 'swiper-pagination-current',
                    totalClass: 'swiper-pagination-total',
                    hiddenClass: 'swiper-pagination-hidden',
                    progressbarFillClass: 'swiper-pagination-progressbar-fill',
                    progressbarOppositeClass: 'swiper-pagination-progressbar-opposite',
                    clickableClass: 'swiper-pagination-clickable',
                    // NEW
                    lockClass: 'swiper-pagination-lock'
                }
            },
            create: function create() {
                var swiper = this;
                bindModuleMethods(swiper, {
                    pagination: pagination_extends({
                        dynamicBulletIndex: 0
                    }, Pagination)
                });
            },
            on: {
                init: function init(swiper) {
                    swiper.pagination.init();
                    swiper.pagination.render();
                    swiper.pagination.update();
                },
                activeIndexChange: function activeIndexChange(swiper) {
                    if (swiper.params.loop) {
                        swiper.pagination.update();
                    } else if (typeof swiper.snapIndex === 'undefined') {
                        swiper.pagination.update();
                    }
                },
                snapIndexChange: function snapIndexChange(swiper) {
                    if (!swiper.params.loop) {
                        swiper.pagination.update();
                    }
                },
                slidesLengthChange: function slidesLengthChange(swiper) {
                    if (swiper.params.loop) {
                        swiper.pagination.render();
                        swiper.pagination.update();
                    }
                },
                snapGridLengthChange: function snapGridLengthChange(swiper) {
                    if (!swiper.params.loop) {
                        swiper.pagination.render();
                        swiper.pagination.update();
                    }
                },
                destroy: function destroy(swiper) {
                    swiper.pagination.destroy();
                },
                'enable disable': function enableDisable(swiper) {
                    var $el = swiper.pagination.$el;

                    if ($el) {
                        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
                    }
                },
                click: function click(swiper, e) {
                    var targetEl = e.target;

                    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && swiper.pagination.$el.length > 0 && !dom(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
                        if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
                        var isHidden = swiper.pagination.$el.hasClass(swiper.params.pagination.hiddenClass);

                        if (isHidden === true) {
                            swiper.emit('paginationShow');
                        } else {
                            swiper.emit('paginationHide');
                        }

                        swiper.pagination.$el.toggleClass(swiper.params.pagination.hiddenClass);
                    }
                }
            }
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/scrollbar/scrollbar.js
        function scrollbar_extends() { scrollbar_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return scrollbar_extends.apply(this, arguments); }




        var Scrollbar = {
            setTranslate: function setTranslate() {
                var swiper = this;
                if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
                var scrollbar = swiper.scrollbar,
                    rtl = swiper.rtlTranslate,
                    progress = swiper.progress;
                var dragSize = scrollbar.dragSize,
                    trackSize = scrollbar.trackSize,
                    $dragEl = scrollbar.$dragEl,
                    $el = scrollbar.$el;
                var params = swiper.params.scrollbar;
                var newSize = dragSize;
                var newPos = (trackSize - dragSize) * progress;

                if (rtl) {
                    newPos = -newPos;

                    if (newPos > 0) {
                        newSize = dragSize - newPos;
                        newPos = 0;
                    } else if (-newPos + dragSize > trackSize) {
                        newSize = trackSize + newPos;
                    }
                } else if (newPos < 0) {
                    newSize = dragSize + newPos;
                    newPos = 0;
                } else if (newPos + dragSize > trackSize) {
                    newSize = trackSize - newPos;
                }

                if (swiper.isHorizontal()) {
                    $dragEl.transform("translate3d(" + newPos + "px, 0, 0)");
                    $dragEl[0].style.width = newSize + "px";
                } else {
                    $dragEl.transform("translate3d(0px, " + newPos + "px, 0)");
                    $dragEl[0].style.height = newSize + "px";
                }

                if (params.hide) {
                    clearTimeout(swiper.scrollbar.timeout);
                    $el[0].style.opacity = 1;
                    swiper.scrollbar.timeout = setTimeout(function () {
                        $el[0].style.opacity = 0;
                        $el.transition(400);
                    }, 1000);
                }
            },
            setTransition: function setTransition(duration) {
                var swiper = this;
                if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
                swiper.scrollbar.$dragEl.transition(duration);
            },
            updateSize: function updateSize() {
                var swiper = this;
                if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
                var scrollbar = swiper.scrollbar;
                var $dragEl = scrollbar.$dragEl,
                    $el = scrollbar.$el;
                $dragEl[0].style.width = '';
                $dragEl[0].style.height = '';
                var trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
                var divider = swiper.size / swiper.virtualSize;
                var moveDivider = divider * (trackSize / swiper.size);
                var dragSize;

                if (swiper.params.scrollbar.dragSize === 'auto') {
                    dragSize = trackSize * divider;
                } else {
                    dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
                }

                if (swiper.isHorizontal()) {
                    $dragEl[0].style.width = dragSize + "px";
                } else {
                    $dragEl[0].style.height = dragSize + "px";
                }

                if (divider >= 1) {
                    $el[0].style.display = 'none';
                } else {
                    $el[0].style.display = '';
                }

                if (swiper.params.scrollbar.hide) {
                    $el[0].style.opacity = 0;
                }

                utils_extend(scrollbar, {
                    trackSize: trackSize,
                    divider: divider,
                    moveDivider: moveDivider,
                    dragSize: dragSize
                });

                if (swiper.params.watchOverflow && swiper.enabled) {
                    scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
                }
            },
            getPointerPosition: function getPointerPosition(e) {
                var swiper = this;

                if (swiper.isHorizontal()) {
                    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
                }

                return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
            },
            setDragPosition: function setDragPosition(e) {
                var swiper = this;
                var scrollbar = swiper.scrollbar,
                    rtl = swiper.rtlTranslate;
                var $el = scrollbar.$el,
                    dragSize = scrollbar.dragSize,
                    trackSize = scrollbar.trackSize,
                    dragStartPos = scrollbar.dragStartPos;
                var positionRatio;
                positionRatio = (scrollbar.getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
                positionRatio = Math.max(Math.min(positionRatio, 1), 0);

                if (rtl) {
                    positionRatio = 1 - positionRatio;
                }

                var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
                swiper.updateProgress(position);
                swiper.setTranslate(position);
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            },
            onDragStart: function onDragStart(e) {
                var swiper = this;
                var params = swiper.params.scrollbar;
                var scrollbar = swiper.scrollbar,
                    $wrapperEl = swiper.$wrapperEl;
                var $el = scrollbar.$el,
                    $dragEl = scrollbar.$dragEl;
                swiper.scrollbar.isTouched = true;
                swiper.scrollbar.dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? scrollbar.getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
                e.preventDefault();
                e.stopPropagation();
                $wrapperEl.transition(100);
                $dragEl.transition(100);
                scrollbar.setDragPosition(e);
                clearTimeout(swiper.scrollbar.dragTimeout);
                $el.transition(0);

                if (params.hide) {
                    $el.css('opacity', 1);
                }

                if (swiper.params.cssMode) {
                    swiper.$wrapperEl.css('scroll-snap-type', 'none');
                }

                swiper.emit('scrollbarDragStart', e);
            },
            onDragMove: function onDragMove(e) {
                var swiper = this;
                var scrollbar = swiper.scrollbar,
                    $wrapperEl = swiper.$wrapperEl;
                var $el = scrollbar.$el,
                    $dragEl = scrollbar.$dragEl;
                if (!swiper.scrollbar.isTouched) return;
                if (e.preventDefault) e.preventDefault();else e.returnValue = false;
                scrollbar.setDragPosition(e);
                $wrapperEl.transition(0);
                $el.transition(0);
                $dragEl.transition(0);
                swiper.emit('scrollbarDragMove', e);
            },
            onDragEnd: function onDragEnd(e) {
                var swiper = this;
                var params = swiper.params.scrollbar;
                var scrollbar = swiper.scrollbar,
                    $wrapperEl = swiper.$wrapperEl;
                var $el = scrollbar.$el;
                if (!swiper.scrollbar.isTouched) return;
                swiper.scrollbar.isTouched = false;

                if (swiper.params.cssMode) {
                    swiper.$wrapperEl.css('scroll-snap-type', '');
                    $wrapperEl.transition('');
                }

                if (params.hide) {
                    clearTimeout(swiper.scrollbar.dragTimeout);
                    swiper.scrollbar.dragTimeout = nextTick(function () {
                        $el.css('opacity', 0);
                        $el.transition(400);
                    }, 1000);
                }

                swiper.emit('scrollbarDragEnd', e);

                if (params.snapOnRelease) {
                    swiper.slideToClosest();
                }
            },
            enableDraggable: function enableDraggable() {
                var swiper = this;
                if (!swiper.params.scrollbar.el) return;
                var document = getDocument();
                var scrollbar = swiper.scrollbar,
                    touchEventsTouch = swiper.touchEventsTouch,
                    touchEventsDesktop = swiper.touchEventsDesktop,
                    params = swiper.params,
                    support = swiper.support;
                var $el = scrollbar.$el;
                var target = $el[0];
                var activeListener = support.passiveListener && params.passiveListeners ? {
                    passive: false,
                    capture: false
                } : false;
                var passiveListener = support.passiveListener && params.passiveListeners ? {
                    passive: true,
                    capture: false
                } : false;
                if (!target) return;

                if (!support.touch) {
                    target.addEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
                    document.addEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
                    document.addEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
                } else {
                    target.addEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
                    target.addEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
                    target.addEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
                }
            },
            disableDraggable: function disableDraggable() {
                var swiper = this;
                if (!swiper.params.scrollbar.el) return;
                var document = getDocument();
                var scrollbar = swiper.scrollbar,
                    touchEventsTouch = swiper.touchEventsTouch,
                    touchEventsDesktop = swiper.touchEventsDesktop,
                    params = swiper.params,
                    support = swiper.support;
                var $el = scrollbar.$el;
                var target = $el[0];
                var activeListener = support.passiveListener && params.passiveListeners ? {
                    passive: false,
                    capture: false
                } : false;
                var passiveListener = support.passiveListener && params.passiveListeners ? {
                    passive: true,
                    capture: false
                } : false;
                if (!target) return;

                if (!support.touch) {
                    target.removeEventListener(touchEventsDesktop.start, swiper.scrollbar.onDragStart, activeListener);
                    document.removeEventListener(touchEventsDesktop.move, swiper.scrollbar.onDragMove, activeListener);
                    document.removeEventListener(touchEventsDesktop.end, swiper.scrollbar.onDragEnd, passiveListener);
                } else {
                    target.removeEventListener(touchEventsTouch.start, swiper.scrollbar.onDragStart, activeListener);
                    target.removeEventListener(touchEventsTouch.move, swiper.scrollbar.onDragMove, activeListener);
                    target.removeEventListener(touchEventsTouch.end, swiper.scrollbar.onDragEnd, passiveListener);
                }
            },
            init: function init() {
                var swiper = this;
                var scrollbar = swiper.scrollbar,
                    $swiperEl = swiper.$el;
                swiper.params.scrollbar = createElementIfNotDefined($swiperEl, swiper.params.scrollbar, swiper.params.createElements, {
                    el: 'swiper-scrollbar'
                });
                var params = swiper.params.scrollbar;
                if (!params.el) return;
                var $el = dom(params.el);

                if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
                    $el = $swiperEl.find(params.el);
                }

                var $dragEl = $el.find("." + swiper.params.scrollbar.dragClass);

                if ($dragEl.length === 0) {
                    $dragEl = dom("<div class=\"" + swiper.params.scrollbar.dragClass + "\"></div>");
                    $el.append($dragEl);
                }

                utils_extend(scrollbar, {
                    $el: $el,
                    el: $el[0],
                    $dragEl: $dragEl,
                    dragEl: $dragEl[0]
                });

                if (params.draggable) {
                    scrollbar.enableDraggable();
                }

                if ($el) {
                    $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
                }
            },
            destroy: function destroy() {
                var swiper = this;
                swiper.scrollbar.disableDraggable();
            }
        };
        /* harmony default export */ const scrollbar = ({
            name: 'scrollbar',
            params: {
                scrollbar: {
                    el: null,
                    dragSize: 'auto',
                    hide: false,
                    draggable: false,
                    snapOnRelease: true,
                    lockClass: 'swiper-scrollbar-lock',
                    dragClass: 'swiper-scrollbar-drag'
                }
            },
            create: function create() {
                var swiper = this;
                bindModuleMethods(swiper, {
                    scrollbar: scrollbar_extends({
                        isTouched: false,
                        timeout: null,
                        dragTimeout: null
                    }, Scrollbar)
                });
            },
            on: {
                init: function init(swiper) {
                    swiper.scrollbar.init();
                    swiper.scrollbar.updateSize();
                    swiper.scrollbar.setTranslate();
                },
                update: function update(swiper) {
                    swiper.scrollbar.updateSize();
                },
                resize: function resize(swiper) {
                    swiper.scrollbar.updateSize();
                },
                observerUpdate: function observerUpdate(swiper) {
                    swiper.scrollbar.updateSize();
                },
                setTranslate: function setTranslate(swiper) {
                    swiper.scrollbar.setTranslate();
                },
                setTransition: function setTransition(swiper, duration) {
                    swiper.scrollbar.setTransition(duration);
                },
                'enable disable': function enableDisable(swiper) {
                    var $el = swiper.scrollbar.$el;

                    if ($el) {
                        $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
                    }
                },
                destroy: function destroy(swiper) {
                    swiper.scrollbar.destroy();
                }
            }
        });
        ;// CONCATENATED MODULE: ./node_modules/swiper/esm/components/autoplay/autoplay.js
        function autoplay_extends() { autoplay_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return autoplay_extends.apply(this, arguments); }

        /* eslint no-underscore-dangle: "off" */


        var Autoplay = {
            run: function run() {
                var swiper = this;
                var $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
                var delay = swiper.params.autoplay.delay;

                if ($activeSlideEl.attr('data-swiper-autoplay')) {
                    delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
                }

                clearTimeout(swiper.autoplay.timeout);
                swiper.autoplay.timeout = nextTick(function () {
                    var autoplayResult;

                    if (swiper.params.autoplay.reverseDirection) {
                        if (swiper.params.loop) {
                            swiper.loopFix();
                            autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                            swiper.emit('autoplay');
                        } else if (!swiper.isBeginning) {
                            autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                            swiper.emit('autoplay');
                        } else if (!swiper.params.autoplay.stopOnLastSlide) {
                            autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                            swiper.emit('autoplay');
                        } else {
                            swiper.autoplay.stop();
                        }
                    } else if (swiper.params.loop) {
                        swiper.loopFix();
                        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                        swiper.emit('autoplay');
                    } else if (!swiper.isEnd) {
                        autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                        swiper.emit('autoplay');
                    } else if (!swiper.params.autoplay.stopOnLastSlide) {
                        autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                        swiper.emit('autoplay');
                    } else {
                        swiper.autoplay.stop();
                    }

                    if (swiper.params.cssMode && swiper.autoplay.running) swiper.autoplay.run();else if (autoplayResult === false) {
                        swiper.autoplay.run();
                    }
                }, delay);
            },
            start: function start() {
                var swiper = this;
                if (typeof swiper.autoplay.timeout !== 'undefined') return false;
                if (swiper.autoplay.running) return false;
                swiper.autoplay.running = true;
                swiper.emit('autoplayStart');
                swiper.autoplay.run();
                return true;
            },
            stop: function stop() {
                var swiper = this;
                if (!swiper.autoplay.running) return false;
                if (typeof swiper.autoplay.timeout === 'undefined') return false;

                if (swiper.autoplay.timeout) {
                    clearTimeout(swiper.autoplay.timeout);
                    swiper.autoplay.timeout = undefined;
                }

                swiper.autoplay.running = false;
                swiper.emit('autoplayStop');
                return true;
            },
            pause: function pause(speed) {
                var swiper = this;
                if (!swiper.autoplay.running) return;
                if (swiper.autoplay.paused) return;
                if (swiper.autoplay.timeout) clearTimeout(swiper.autoplay.timeout);
                swiper.autoplay.paused = true;

                if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
                    swiper.autoplay.paused = false;
                    swiper.autoplay.run();
                } else {
                    ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
                        swiper.$wrapperEl[0].addEventListener(event, swiper.autoplay.onTransitionEnd);
                    });
                }
            },
            onVisibilityChange: function onVisibilityChange() {
                var swiper = this;
                var document = getDocument();

                if (document.visibilityState === 'hidden' && swiper.autoplay.running) {
                    swiper.autoplay.pause();
                }

                if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
                    swiper.autoplay.run();
                    swiper.autoplay.paused = false;
                }
            },
            onTransitionEnd: function onTransitionEnd(e) {
                var swiper = this;
                if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
                if (e.target !== swiper.$wrapperEl[0]) return;
                ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
                    swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
                });
                swiper.autoplay.paused = false;

                if (!swiper.autoplay.running) {
                    swiper.autoplay.stop();
                } else {
                    swiper.autoplay.run();
                }
            },
            onMouseEnter: function onMouseEnter() {
                var swiper = this;

                if (swiper.params.autoplay.disableOnInteraction) {
                    swiper.autoplay.stop();
                } else {
                    swiper.autoplay.pause();
                }

                ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
                    swiper.$wrapperEl[0].removeEventListener(event, swiper.autoplay.onTransitionEnd);
                });
            },
            onMouseLeave: function onMouseLeave() {
                var swiper = this;

                if (swiper.params.autoplay.disableOnInteraction) {
                    return;
                }

                swiper.autoplay.paused = false;
                swiper.autoplay.run();
            },
            attachMouseEvents: function attachMouseEvents() {
                var swiper = this;

                if (swiper.params.autoplay.pauseOnMouseEnter) {
                    swiper.$el.on('mouseenter', swiper.autoplay.onMouseEnter);
                    swiper.$el.on('mouseleave', swiper.autoplay.onMouseLeave);
                }
            },
            detachMouseEvents: function detachMouseEvents() {
                var swiper = this;
                swiper.$el.off('mouseenter', swiper.autoplay.onMouseEnter);
                swiper.$el.off('mouseleave', swiper.autoplay.onMouseLeave);
            }
        };
        /* harmony default export */ const autoplay = ({
            name: 'autoplay',
            params: {
                autoplay: {
                    enabled: false,
                    delay: 3000,
                    waitForTransition: true,
                    disableOnInteraction: true,
                    stopOnLastSlide: false,
                    reverseDirection: false,
                    pauseOnMouseEnter: false
                }
            },
            create: function create() {
                var swiper = this;
                bindModuleMethods(swiper, {
                    autoplay: autoplay_extends({}, Autoplay, {
                        running: false,
                        paused: false
                    })
                });
            },
            on: {
                init: function init(swiper) {
                    if (swiper.params.autoplay.enabled) {
                        swiper.autoplay.start();
                        var document = getDocument();
                        document.addEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
                        swiper.autoplay.attachMouseEvents();
                    }
                },
                beforeTransitionStart: function beforeTransitionStart(swiper, speed, internal) {
                    if (swiper.autoplay.running) {
                        if (internal || !swiper.params.autoplay.disableOnInteraction) {
                            swiper.autoplay.pause(speed);
                        } else {
                            swiper.autoplay.stop();
                        }
                    }
                },
                sliderFirstMove: function sliderFirstMove(swiper) {
                    if (swiper.autoplay.running) {
                        if (swiper.params.autoplay.disableOnInteraction) {
                            swiper.autoplay.stop();
                        } else {
                            swiper.autoplay.pause();
                        }
                    }
                },
                touchEnd: function touchEnd(swiper) {
                    if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) {
                        swiper.autoplay.run();
                    }
                },
                destroy: function destroy(swiper) {
                    swiper.autoplay.detachMouseEvents();

                    if (swiper.autoplay.running) {
                        swiper.autoplay.stop();
                    }

                    var document = getDocument();
                    document.removeEventListener('visibilitychange', swiper.autoplay.onVisibilityChange);
                }
            }
        });
        ;// CONCATENATED MODULE: ./src/scripts/common/slider.js



        core_class.use([navigation, pagination, scrollbar, autoplay]);
        var swiperSection = new core_class('.card-swiper', {
            freeMode: false,
            pagination: {
                el: '.swiper-pagination',
                type: 'progressbar',
                draggable: true
            },
            slidesPerView: 1.07,
            spaceBetween: 10,
            breakpoints: {
                320: {
                    slidesPerView: 1.1,
                    spaceBetween: 0
                },
                423: {
                    slidesPerView: 1.2,
                    spaceBetween: 0
                },
                530: {
                    slidesPerView: 1.5,
                    spaceBetween: 0
                },
                768: {
                    slidesPerView: 1.8,
                    spaceBetween: 0
                }
            }
        });
        var speedRunSwiper;

        if (document.querySelector('.run-swiper')) {
            speedRunSwiper = Number(document.querySelector('.run-swiper').dataset.speed);
        }

        var runSwiper = new core_class('.run-swiper', {
            loop: true,
            allowTouchMove: false,
            autoplay: {
                delay: 1,
                disableOnInteraction: false
            },
            slidesPerView: 'auto',
            speed: speedRunSwiper,
            grabCursor: true,
            mousewheelControl: true,
            keyboardControl: true
        });
        var carouselSwiper = new core_class('.carousel-section', {
            freeMode: false,
            slidesPerView: 2,
            speed: 700,
            initialSlide: 1.3,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            },
            //pagination: {
            //  el: '.swiper-pagination',
            //  type: 'progressbar',
            //  draggable: true,
            //},
            breakpoints: {
                320: {
                    slidesPerView: 1.1
                },
                340: {
                    slidesPerView: 1.13
                },
                350: {
                    slidesPerView: 1.23
                },
                400: {
                    slidesPerView: 1.3
                },
                590: {
                    slidesPerView: 1.8
                },
                700: {
                    slidesPerView: 2.3
                },
                768: {
                    slidesPerView: 1.2
                },
                850: {
                    slidesPerView: 1.35
                },
                980: {
                    slidesPerView: 1.6
                },
                1025: {
                    slidesPerView: 1.2
                },
                1100: {
                    slidesPerView: 1.3
                },
                1200: {
                    slidesPerView: 1.45
                },
                1366: {
                    slidesPerView: 1.65
                },
                1441: {
                    slidesPerView: 1.72
                },
                1550: {
                    slidesPerView: 1.75
                },
                // 1400: {
                //   slidesPerView: 1.3,
                // },
                1729: {
                    slidesPerView: 1.5
                },
                1900: {
                    slidesPerView: 1.6
                },
                2020: {
                    slidesPerView: 1.75
                },
                2300: {
                    slidesPerView: 1.85
                },
                2480: {
                    slidesPerView: 2.1
                },
                2700: {
                    slidesPerView: 2.15
                },
                2850: {
                    slidesPerView: 2.3
                }
            },
            centeredSlides: true
        });
        var collabsSwiper = new core_class('.collabs-container', {
            freeMode: false,
            spaceBetween: 20,
            slidesPerView: 1.8,
            autoHeight: true,
            allowTouchMove: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true
            },
            breakpoints: {
                320: {
                    slidesPerView: 1.1,
                    spaceBetween: 5
                },
                376: {
                    slidesPerView: 1.2
                },
                768: {
                    slidesPerView: 1.8
                },
                1366: {
                    slidesPerView: 3
                },
                1400: {
                    slidesPerView: 3
                },
                1920: {
                    slidesPerView: 3
                }
            }
        }); // const swiperScrollBar = document.querySelector('.swiper-scrollbar-collabs');
// collabsSwiper.on('touchStart', function () {
//   swiperScrollBar.classList.add('swiper-scrollbar-collabs_active');
// });
// collabsSwiper.on('touchEnd', function () {
//   setTimeout(() => {
//     swiperScrollBar.classList.remove('swiper-scrollbar-collabs_active');
//   }, 350);
// });

        var swiperSocial = new core_class('.social-container', {
            freeMode: false,
            spaceBetween: 47
        });
        var templateIndex = document.querySelector('.template-index');
        var templateProduct = document.querySelector('.template-product');

        if (templateIndex || templateProduct) {
            var createSocialSlider = function createSocialSlider() {
                setTimeout(function () {
                    var container = document.querySelector('#insta-feed');
                    container.classList.add('social-container');
                    container && container.firstElementChild &&
                    container.firstElementChild.classList.add('swiper-wrapper');
                    document.querySelectorAll('.slide-page').forEach(function (item) {
                        item.classList.add('swiper-slide');
                        item.classList.remove('slide-page');
                        item.removeAttribute('data-slide-page');
                        item.style.removeProperty('display');
                    });
                    var swiperSocial = new core_class('.social-container', {
                        freeMode: false,
                        spaceBetween: 30,
                        breakpoints: {
                            320: {
                                spaceBetween: 0,
                                slidesPerView: 1.05
                            },
                            450: {
                                slidesPerView: 1.3,
                                spaceBetween: 0
                            },
                            550: {
                                slidesPerView: 1.6,
                                spaceBetween: 0
                            },
                            738: {
                                spaceBetween: 0,
                                slidesPerView: 2
                            },
                            1024: {
                                slidesPerView: 2.5,
                                spaceBetween: 0
                            },
                            1366: {
                                slidesPerView: 3.5,
                                spaceBetween: 0
                            },
                            1920: {
                                slidesPerView: 3.5,
                                spaceBetween: 0
                            }
                        }
                    });
                }, 2000);
            };

            window.addEventListener('DOMContentLoaded', createSocialSlider);
            window.addEventListener('resize', createSocialSlider);
        }

        if (document.body.className.includes('template-page.collabs')) {
            var _collabsSwiper = new core_class('.block-swiper', {
                slidesPerView: 1,
                spaceBetween: 10,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                }
            });
        }

        if (document.body.className.includes('template-page.our-stores')) {
            var storesSwiper = new core_class('.stores-swiper', {
                freeMode: false,
                centeredSlides: true,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'bullets',
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                clickable: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1.2
                    },
                    423: {
                        slidesPerView: 1.35
                    },
                    530: {
                        slidesPerView: 1.5
                    },
                    768: {
                        slidesPerView: 1.8
                    },
                    941: {
                        slidesPerView: 2.25
                    },
                    1025: {
                        slidesPerView: 1.66
                    },
                    1195: {
                        slidesPerView: 2
                    },
                    1366: {
                        slidesPerView: 1.65
                    },
                    1580: {
                        slidesPerView: 1.8
                    },
                    1760: {
                        slidesPerView: 2
                    },
                    1900: {
                        slidesPerView: 2.2
                    }
                }
            });
        }
// EXTERNAL MODULE: ./src/scripts/common/select.js
        var common_select = __webpack_require__(2443);
// EXTERNAL MODULE: ./src/scripts/common/hamburger.js
        var hamburger = __webpack_require__(7334);
// EXTERNAL MODULE: ./src/scripts/common/header.js
        var header = __webpack_require__(9574);
// EXTERNAL MODULE: ./src/scripts/common/footer.js
        var footer = __webpack_require__(5405);
// EXTERNAL MODULE: ./src/scripts/common/about-us.js
        var about_us = __webpack_require__(3452);
// EXTERNAL MODULE: ./src/scripts/common/product.js
        var product = __webpack_require__(6042);
// EXTERNAL MODULE: ./src/scripts/common/tabs.js
        var tabs = __webpack_require__(100);
// EXTERNAL MODULE: ./src/scripts/common/validate.js
        var validate = __webpack_require__(7502);
// EXTERNAL MODULE: ./src/scripts/common/account.js
        var account = __webpack_require__(7736);
// EXTERNAL MODULE: ./src/scripts/common/blog.js
        var blog = __webpack_require__(4128);
// EXTERNAL MODULE: ./src/scripts/common/blog-article.js
        var blog_article = __webpack_require__(8682);
// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
        var jquery = __webpack_require__(9755);
        ;// CONCATENATED MODULE: ./src/scripts/common/get-product.js
        function removeActivePopup(mass) {
            mass.forEach(function (item) {
                item.classList.remove('active');
            });
        }

        function getProduct(handle) {
            var fURL = window.location.href;
            let currencySubUrl =
                (window.Shopify.currency.active === 'EUR' ? 'en-eu' : window.Shopify.currency.active === 'USD' ? 'en-america' : window.Shopify.currency.active === 'GBP'  ? '' : '').concat('/products/');
            // if (!$('body').hasClass('template-collection')) {
            //     currencySubUrl = '';
            // }
            console.log('currencySubUrl', currencySubUrl);
            fetch(currencySubUrl.concat(handle, "?view=popup")).then(function (res) {
                return res.text();
            }).then(function (html) {
                var productPopup = document.querySelector('.product__cart');
                productPopup.innerHTML = html;
                var x, i, j, l, ll, selElmnt, a, b, c;
                var deleteSelect = false; // x = document.getElementsByClassName('custom-select');

                x = document.querySelectorAll('.product__cart .custom-select');
                l = x.length;

                for (i = 0; i < l; i++) {
                    selElmnt = x[i].getElementsByTagName('select')[0];
                    var firstElem = selElmnt.firstElementChild;
                    var arrDataAttr = [];

                    while (firstElem) {
                        if (firstElem.getAttribute('value')) {
                            arrDataAttr.push(firstElem.getAttribute('value'));
                            firstElem = firstElem.nextElementSibling;
                        } else if (firstElem.dataset.handle) {
                            arrDataAttr.push(firstElem.dataset.handle);
                            firstElem = firstElem.nextElementSibling;
                        } else {
                            arrDataAttr.push(firstElem.dataset.tag);
                            firstElem = firstElem.nextElementSibling;
                        }
                    }

                    var attr = x[i].classList[1];
                    var innHTML = void 0;

                    if (attr.indexOf('-') && !attr.includes('sort-select')) {
                        innHTML = attr.substr(attr.indexOf('-') + 1);
                    } else if (!attr.indexOf('-') && !attr.includes('sort-select')) {
                        innHTML = attr;
                    } else {
                        innHTML = 'Sort by';
                    }

                    ll = selElmnt.length;
                    a = document.createElement('DIV');
                    a.setAttribute('class', 'select-selected'); // a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;

                    a.innerHTML = 'Variant';
                    x[i].appendChild(a);
                    b = document.createElement('DIV');
                    b.setAttribute('class', 'select-items select-hide');

                    for (j = 0; j < ll; j++) {
                        // if (selElmnt.options[j].innerText == 'Default Title') deleteSelect = true;
                        var inputRadio = document.createElement('input');
                        inputRadio.setAttribute('class', 'custom-radio');
                        inputRadio.setAttribute('type', 'radio');
                        inputRadio.setAttribute('name', attr);
                        var label = document.createElement('label');
                        label.setAttribute('class', 'label-text');
                        c = document.createElement('DIV');
                        c.setAttribute('class', 'select__item');
                        c.setAttribute('data-handle', arrDataAttr[j]);
                        label.innerHTML = selElmnt.options[j].innerText;
                        c.appendChild(inputRadio);
                        c.appendChild(label);
                        c.addEventListener('click', function (e) {
                            var y, i, k, s, h, sl, yl;
                            var element = this.firstElementChild.nextElementSibling.innerHTML;
                            s = this.parentNode.parentNode.getElementsByTagName('select')[0];
                            sl = s.length;
                            h = this.parentNode.previousSibling;

                            for (i = 0; i < sl; i++) {
                                if (s.options[i].innerHTML.replace('-', ' ') == element) {
                                    s.selectedIndex = i;
                                    y = this.parentNode.getElementsByClassName('same-as-selected');
                                    yl = y.length;

                                    for (k = 0; k < yl; k++) {
                                        y[k].classList.remove('same-as-selected');
                                    }

                                    this.setAttribute('class', 'select__item same-as-selected');
                                    break;
                                }
                            }

                            h.click();
                        });
                        b.appendChild(c);
                    }

                    x[i].appendChild(b);
                    a.addEventListener('click', function (e) {
                        e.stopPropagation();
                        closeAllSelect(this);
                        this.nextSibling.classList.toggle('select-hide');
                        this.classList.toggle('select-arrow-active');
                    });
                }

                function closeAllSelect(elmnt) {
                    var x,
                        y,
                        i,
                        xl,
                        yl,
                        arrNo = [];
                    x = document.getElementsByClassName('select-items');
                    y = document.getElementsByClassName('select-selected');
                    xl = x.length;
                    yl = y.length;

                    for (i = 0; i < yl; i++) {
                        if (elmnt == y[i]) {
                            arrNo.push(i);
                        } else {
                            y[i].classList.remove('select-arrow-active');
                        }
                    }

                    for (i = 0; i < xl; i++) {
                        if (arrNo.indexOf(i)) {
                            x[i].classList.add('select-hide');
                        }
                    }
                } // close popup


                document.querySelector('.product__cart-close').addEventListener('click', function () {
                    $('.product-cart-uniq').removeClass('product__cart_active');
                }); // logic select

                var selectSMain = document.querySelector('#mainSelect');
                var selectSelected = document.querySelectorAll('.product__cart .select-selected');
                var selectSubMain = document.querySelectorAll('.selectSubMain');
                var variantPricePopup = document.querySelectorAll('.product__cart .variant_price_popup');
                var variantPrice = document.querySelectorAll('.product__cart .variant_price');
                var buttonBuyClick = document.querySelector('.quick-button');
                var buttonCollectionCheckoutClick = document.querySelector('.product__cart .quick-add-checkout');
                var warning = document.querySelector('.warning');
                var optionSizeSelect = [];
                var sentens;
                var options = document.querySelectorAll('.cart-option');
                options.forEach(function (select) {
                    if (select.selected) {
                        optionSizeSelect.push(select.value);
                    }
                });
                sentens = optionSizeSelect.join(' / ');
                activeSelect();
                selectSelected.forEach(function (element, index) {
                    element.addEventListener('click', function () {
                        var eventChange = new Event('change');
                        selectSubMain[index].dispatchEvent(eventChange);
                    });
                });

                function activeSelect() {
                    Array.from(selectSMain.options).forEach(function (element, index) {
                        if (sentens === element.dataset.value) {
                            element.selected = true;
                            removeActivePopup(variantPrice);
                            removeActivePopup(variantPricePopup);
                            variantPrice[index].classList.add('active');
                            variantPricePopup[index].classList.add('active');

                            if (element.disabled) {
                                buttonBuyClick.classList.add('disabled');
                                buttonBuyClick.setAttribute('disabled', 'disabled');
                                buttonCollectionCheckoutClick.classList.add('disabled');
                                buttonCollectionCheckoutClick.setAttribute('disabled', 'disabled');
                            } else {
                                buttonBuyClick.classList.remove('disabled');
                                buttonBuyClick.removeAttribute('disabled', 'disabled');
                                buttonCollectionCheckoutClick.classList.remove('disabled');
                                buttonCollectionCheckoutClick.removeAttribute('disabled', 'disabled');
                            }
                        }
                    });
                } // add goods


                buttonBuyClick.addEventListener('click', function () {
                    document.querySelector('.ajax-cart').classList.add('is-open');
                    productPopup.classList.remove('product__cart_active');
                });

                if (buttonCollectionCheckoutClick) {
                    buttonCollectionCheckoutClick.addEventListener("click", function () {
                        location.pathname = "/checkout";
                    });
                } // on mouseover


                var buttonWrapper = document.querySelector('.button__wrapper');
                buttonWrapper.addEventListener('mouseover', function () {
                    if (buttonWrapper.firstElementChild.classList.contains('disabled')) {
                        buttonWrapper.firstElementChild.classList.remove('undis');
                        warning.classList.add('warning_show');
                    } else {
                        buttonWrapper.firstElementChild.classList.add('undis');
                    }
                });
                buttonWrapper.addEventListener('mouseout', function () {
                    warning.classList.remove('warning_show');
                });
                selectSubMain.forEach(function (select, index) {
                    optionSizeSelect[index] = select.value;
                    sentens = optionSizeSelect.join(' / ');
                    select.addEventListener('change', function (event) {
                        optionSizeSelect[index] = event.target.value;
                        sentens = optionSizeSelect.join(' / ');
                        activeSelect();
                    });
                });
                var productCartImage = document.querySelector('.product__cart .swiper-wrapper');

                if (productCartImage.firstElementChild.nextElementSibling) {
                    if (window.innerWidth > 1024) {
                        document.querySelector('.product__cart-images').addEventListener('mouseover', function () {
                            document.querySelector('.swiper-slide-first').classList.add('hide');
                            document.querySelector('.swiper-slide-second').classList.add('show');
                        });
                        document.querySelector('.product__cart-images').addEventListener('mouseout', function () {
                            document.querySelector('.swiper-slide-first').classList.remove('hide');
                            document.querySelector('.swiper-slide-second').classList.remove('show');
                        });
                    }
                } // exit cart


                function exitCart() {
                    document.querySelector('.product__cart-close').addEventListener('click', function () {
                        $('.product__cart').removeClass('product__cart_active');
                        document.body.classList.remove('overlay');
                    });
                } // clickAddButton();


                exitCart();
                var swiperCollection;

                function collectionSwiper() {
                    if (window.innerWidth <= 1024) {
                        swiperCollection = new Swiper('.product-swiper', {
                            spaceBetween: 10,
                            slidesPerView: 1,
                            allowTouchMove: true,
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true
                            }
                        });
                    } else {
                        if (swiperCollection != undefined) {
                            swiperCollection.forEach(function (item) {
                                item.destroy(true, true);
                            });
                            document.querySelectorAll('.swiper-wrapper').forEach(function (item) {
                                item.removeAttribute('style');
                            });
                            setTimeout(function () {
                                document.querySelectorAll('.swiper-slide').forEach(function (slide) {
                                    slide.removeAttribute('style');
                                });
                            }, 0);
                        }
                    }
                }

                collectionSwiper();
                window.addEventListener('resize', collectionSwiper);
                window.addEventListener('orientationchange', collectionSwiper);
                var swiperCart;

                function cartSwiper() {
                    if (window.innerWidth <= 1024) {
                        swiperCart = new Swiper('.cart-container', {
                            spaceBetween: 10,
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true
                            }
                        });
                    } else {
                        if (swiperCart != undefined) {
                            swiperCart.destroy(true, true);
                        }
                    }
                }

                cartSwiper();
                window.addEventListener('resize', cartSwiper);
                window.addEventListener('orientationchange', cartSwiper);
                document.addEventListener('click', closeAllSelect); // select first option

                var selects = document.querySelectorAll('.product__cart .select-selected');

                if (selects) {
                    selects.forEach(function (item) {
                        item.innerHTML = item.nextElementSibling.firstElementChild.firstElementChild.nextElementSibling.innerHTML;
                        item.nextElementSibling.firstElementChild.firstElementChild.checked = true;
                    });
                } // click
                // document.querySelector('.product__cart .select-selected').innerHTML = 'Variant';


                document.querySelectorAll('.select__item').forEach(function (item) {
                    item.addEventListener('click', function () {
                        item.firstElementChild.checked = true;
                        item.parentElement.previousElementSibling.innerHTML = item.firstElementChild.nextElementSibling.innerHTML;
                    });
                });
                var currency = document.querySelector('[data-price]').dataset.price.substr(0, 1);
                var plusButton = document.querySelector('[data-plus-quantity]');
                var minusButton = document.querySelector('[data-minus-quantity]');
                plusButton.addEventListener('click', plusQuantity);
                minusButton.addEventListener('click', minusQuantity);
                var priceProduct = document.querySelectorAll('[data-price-product]');
                var quantityInput = document.querySelector('.input-quantity');

                function plusQuantity() {
                    console.log(quantityInput.value);
                    quantityInput.value++;
                    calcTotalPrice(quantityInput.value);
                }

                function minusQuantity() {
                    quantityInput.value <= 1 ? quantityInput.value = 1 : quantityInput.value--;
                    calcTotalPrice(quantityInput.value);
                }

                quantityInput.addEventListener('change', function () {
                    calcTotalPrice(quantityInput.value);
                });

                function calcTotalPrice(quantity) {
                    priceProduct.forEach(function (element) {
                        element.textContent = element.textContent = Shopify.formatMoney(element.dataset.priceProduct * quantity || element.dataset.priceProduct);
                        var currencyValue = Math.ceil(element.textContent.substr(1));
                        element.textContent = "".concat(currency).concat(currencyValue);
                    });
                }
            });
        }

        function clickAddBag() {
            var buttons = document.querySelectorAll('.collection-add-to-bag');
            buttons.forEach(function (element) {
                element.addEventListener('click', function () {
                    getProduct(element.parentElement.parentElement.dataset.id);
                    $('.product-cart-uniq').addClass('product__cart_active');
                    document.body.classList.add('overlay');
                });
            });
        }

        window.addEventListener('DOMContentLoaded', clickAddBag);

        $('.collection-add-to-bag').on('click', function () {
            const element = this;
                getProduct(element.parentElement.parentElement.dataset.id);
                $('.product-cart-uniq').addClass('product__cart_active');
                document.body.classList.add('overlay');
        });

        ;// CONCATENATED MODULE: ./src/scripts/common/filter.js
        /* provided dependency */ var filter_$ = __webpack_require__(5825);
// const { type, support } = require("jquery");



        // imgChange

        if (document.body.className.includes('template-collection')) {
            var changeImg = function changeImg() {
                document.querySelectorAll('.product-item').forEach(function (item) {
                    item.addEventListener('mouseover', function () {
                        if (item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.nextElementSibling) {
                            if (window.innerWidth > 1024) {
                                item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.add('swiper-slide-hide');
                                item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.classList.add('swiper-slide-show');
                            }
                        }
                    });
                    item.addEventListener('mouseout', function () {
                        if (item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.nextElementSibling) {
                            if (window.innerWidth > 1024) {
                                item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.classList.remove('swiper-slide-show');
                                item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.remove('swiper-slide-hide');
                            }
                        }
                    });
                });
            };

            var checkedInnerHTML = function checkedInnerHTML(item) {
                item.firstElementChild.checked = true;
                var label = item.firstElementChild.nextElementSibling;
                console.log('item', item, label.innerHTML.includes('('));

                if (label.innerHTML.includes('(')) {
                    console.log('item', label);
                    console.log('in if', label.innerHTML.substr(0, label.innerHTML.indexOf('(') - 1));
                    item.parentElement.previousElementSibling.innerHTML = label.innerHTML.substr(0, label.innerHTML.indexOf('(') - 1);
                } else {
                    console.log('else');
                    item.parentElement.previousElementSibling.innerHTML = label.innerHTML;
                }
            };

            var clickItem = function clickItem() {
                document.querySelectorAll('.select__item').forEach(function (item) {
                    item.addEventListener('click', function () {
                        checkedInnerHTML(item);

                        if (item.parentElement.parentElement.className.includes('sort-select')) {
                            sort(item);
                        } else if (!item.parentElement.parentElement.className.includes('select-cart')) {
                            filter_filter();
                        }
                    });
                });
            };

            var showData = function showData(data) {
                filter_$('.product-col__wrapper').html(filter_$('.product-col__wrapper', data.responseText).html());
                filter_$('.product-col__wrapper').removeClass('product-col__wrapper_new');
                filter_$('.wrapper-goods').html(filter_$('.wrapper-goods', data.responseText).html());
            };

            var createElementFilters = function createElementFilters() {
                var arrUrl = [];
                var filterItems = document.querySelector('.filter__items-wrapper');
                filterItems.innerHTML = ''; // content

                setTimeout(function () {
                    document.querySelectorAll('.custom-radio').forEach(function (item) {
                        if (!item.parentElement.parentElement.parentElement.className.includes('select-cart')) {
                            if (item.checked) {
                                if (item.getAttribute('name') != 'sort-select') {
                                    // creaete element sub filter
                                    arrUrl.push(item.parentElement.dataset.handle); // create item

                                    var filterItem = document.createElement('div');
                                    filterItem.classList.add('filter__item');
                                    filterItem.setAttribute('data-handle', item.parentElement.dataset.handle); // content

                                    var filterContent = document.createElement('div');
                                    filterContent.classList.add('filter__item-content');
                                    filterContent.innerHTML = item.nextElementSibling.innerHTML.substr(0, item.nextElementSibling.innerHTML.indexOf('(')); //exit

                                    var filterExit = document.createElement('div');
                                    filterExit.classList.add('filter__item-exit');
                                    filterExit.innerHTML = '&times;'; // add content and exit in item

                                    filterItem.appendChild(filterContent);
                                    filterItem.appendChild(filterExit); // add in main wrapper

                                    filterItems.appendChild(filterItem);
                                }
                            }
                        }
                    });
                }, 0);
                setTimeout(function () {
                    deleteFilter();
                }, 150);
            };

            var clearSort = function clearSort() {
                var inputs = document.getElementsByTagName('input');

                for (var i = 0; i < inputs.length; i++) {
                    if (inputs[i].getAttribute('name') == 'sort-select' && inputs[i].checked) {
                        inputs[i].checked = false;
                        inputs[i].parentElement.classList.remove('same-as-selected');
                        inputs[i].parentElement.parentElement.previousElementSibling.innerHTML = 'Sort by';
                    }
                }
            };

            var filter_filter = function filter(arrayLink) {
                // clear sort
                clearSort();
                arrMainUrl = []; // filter button

                createElementFilters();
                var url;

                if (objHandle.url) {
                    url = objHandle.url + '/';
                } else {
                    url = window.location.pathname + '/';
                    objHandle.url = window.location.pathname;
                }

                if (arrayLink) {
                    if (arrayLink.length > 0) {
                        arrayLink.forEach(function (link) {
                            arrMainUrl.push(link);
                        });
                    }
                } else {
                    document.querySelectorAll('.custom-radio').forEach(function (item) {
                        if (!item.parentElement.parentElement.parentElement.className.includes('select-cart')) {
                            if (item.checked) {
                                if (item.getAttribute('name') != 'sort-select') {
                                    arrMainUrl.push(item.parentElement.dataset.handle);
                                }
                            }
                        }
                    });
                }

                for (var i = 0; i < arrMainUrl.length; i++) {
                    if (arrMainUrl.length > 1 && i != arrMainUrl.length - 1) url += arrMainUrl[i] + '+';else if (arrMainUrl.length > 1 && i == arrMainUrl.length - 1) url += arrMainUrl[i];else url += arrMainUrl[i];
                }

                filter_$.ajax({
                    type: 'GET',
                    url: url,
                    data: {},
                    complete: function complete(data) {
                        var wrapper = document.querySelector('.product-col__wrapper');
                        wrapper.classList.add('product-col__wrapper_new');
                        history.pushState({
                            page: url
                        }, url, url);
                        setTimeout(function () {
                            reloadFunction(data);
                            changeImg(); // generate wrapper

                            if (document.querySelectorAll('.product-item').length % 2 == 0) {
                                wrapper.classList.add('two');
                            }

                            clickAddBag();
                        }, 300);
                        deleteFilterOnCart();
                    }
                });
            };

            // sort
            var sort = function sort(item) {
                sortSelect.classList.toggle('active');
                item.parentElement.style.left = '0px';
                var url = "".concat(window.location.pathname, "?sort_by=").concat(item.dataset.handle);
                checkedInnerHTML(item);
                filter_$.ajax({
                    type: 'GET',
                    data: {},
                    url: url,
                    complete: function complete(data) {
                        var wrapper = document.querySelector('.product-col__wrapper');
                        wrapper.classList.add('product-col__wrapper_new');
                        history.pushState({
                            page: url
                        }, url, url);
                        setTimeout(function () {
                            reloadFunction(data);
                            clickAddBag();

                        }, 600);
                    }
                });
            };

            var deleteFilter = function deleteFilter() {
                var arrUrl = [];
                clearSort();
                document.querySelectorAll('.filter__item-exit').forEach(function (item) {
                    item.addEventListener('click', function () {
                        item.parentElement.remove(); // clear filter in dropDown

                        document.querySelectorAll('.same-as-selected').forEach(function (selectItems) {
                            if (selectItems.dataset.handle == item.parentNode.dataset.handle) {
                                selectItems.classList.remove('same-as-selected');
                                selectItems.firstElementChild.checked = false;
                                var name = selectItems.firstElementChild.getAttribute('name');

                                if (name.includes('-')) {
                                    selectItems.parentElement.previousElementSibling.innerHTML = name.substr(name.indexOf('-') + 1);
                                } else {
                                    selectItems.parentElement.previousElementSibling.innerHTML = name;
                                }
                            }
                        });
                        document.querySelectorAll('.filter__item').forEach(function (item) {
                            arrUrl.push(item.dataset.handle);
                        }); // generate url

                        var url = window.location.pathname.substr(0, window.location.pathname.indexOf('/', 13));

                        for (var i = 0; i < arrUrl.length; i++) {
                            if (arrUrl[i] == item.parentElement.dataset.handle) {
                                arrUrl.splice(i, 1);
                            }
                        } // let url = objHandle.url;


                        if (arrUrl[0] == arrUrl[1] && arrUrl[1] != undefined) {
                            arrUrl.length = arrUrl.length - 1;
                        }

                        if (arrUrl.length != 0) {
                            url += '/';

                            for (var _i = 0; _i < arrUrl.length; _i++) {
                                if (arrUrl.length > 1 && _i != arrUrl.length - 1) url += arrUrl[_i] + '+';else if (arrUrl.length > 1 && _i == arrUrl.length - 1) url += arrUrl[_i];else url += arrUrl[_i];
                            }
                        } else {
                            url = window.location.pathname.substr(0, window.location.pathname.indexOf('/', 13));
                        }

                        arrUrl;
                        filter_$.ajax({
                            type: 'GET',
                            url: url,
                            data: {},
                            complete: function complete(data) {
                                var wrapper = document.querySelector('.product-col__wrapper');
                                wrapper.classList.add('product-col__wrapper_new');
                                history.pushState({
                                    page: url
                                }, url, url);
                                setTimeout(function () {
                                    reloadFunction(data);
                                    changeImg();
                                    clickAddBag();

                                }, 600); // deleteFilter();

                                objHandle.url = url;
                                document.querySelectorAll('.sort-select .select__item').forEach(function (item) {
                                    item.classList.remove('same-as-selected');
                                    item.firstElementChild.checked = false;
                                });
                                document.querySelector('.sort-select .select-selected').innerHTML = 'Sort By';
                                setTimeout(function () {
                                    if (document.querySelectorAll('.product-item').length % 3 == 0) {
                                        document.querySelector('.product-col__wrapper').classList.remove('two');
                                    }
                                }, 601);
                            }
                        });
                    });
                });
            }; // check icon sort


            var reloadFunction = function reloadFunction(data) {
                showData(data);
                deleteFilterOnCart();
                createSwiperCart();
                addContentOnPage();
                countGoodsOnPage();
            }; // window.addEventListener('DOMContentLoaded', deleteFilter);


            var deleteFilterOnCart = function deleteFilterOnCart() {
                document.querySelectorAll('.filter-').forEach(function (item) {
                    item.remove();
                });
                document.querySelectorAll('.filter-featured-').forEach(function (item) {
                    item.remove();
                });
            };

            // mobile filter //
            // open
            var openFilter = function openFilter() {
                document.querySelector('.filter__mobile').addEventListener('click', function () {
                    document.body.classList.add('overlay');
                    document.querySelector('.filter__cart').classList.add('filter__cart_active');
                });
            };

            //close
            var closeFilter = function closeFilter() {
                document.querySelector('.filter__cart-header__right').addEventListener('click', function () {
                    document.querySelector('.filter__cart').classList.remove('filter__cart_active');
                    document.body.classList.remove('overlay');
                    var filterCartItemShow = document.querySelector('.filter__cart-item_show');
                    if (filterCartItemShow) filterCartItemShow.classList.remove('filter__cart-item_show');
                });
            };

            //close subcart
            var closeSubCart = function closeSubCart() {
                document.querySelectorAll('.filter__cart-exit').forEach(function (exit) {
                    exit.addEventListener('click', function () {
                        exit.parentElement.classList.remove('filter__cart-item_show');
                    });
                });
            };

            // open subCart
            var openSubCart = function openSubCart() {
                document.querySelectorAll('.filter__cart-cat').forEach(function (item) {
                    item.addEventListener('click', function () {
                        document.querySelectorAll('.filter__cart-item').forEach(function (subCat) {
                            if (item.dataset.category == subCat.dataset.category) subCat.classList.add('filter__cart-item_show');
                        });
                    });
                });
            };

            // check body
            var checkBody = function checkBody() {
                document.body.addEventListener('click', function (e) {
                    if (e.target.classList.contains('template-collection') || e.target.classList.contains('template-product')) {
                        $('.product__cart').removeClass('product__cart_active'); // close all

                        document.querySelector('.filter__cart ').classList.remove('filter__cart_active');
                        var filterCartItemShow = document.querySelector('.filter__cart-item_show');
                        if (filterCartItemShow) filterCartItemShow.classList.remove('filter__cart-item_show');
                        document.body.classList.remove('overlay');
                        $('.product__cart').removeClass('product__cart_active');
                        document.querySelector('.ajax-cart').classList.remove('is-open');
                    }
                });
            };

            var clickMobileFilter = function clickMobileFilter() {
                // clicl subcat
                var filterMobileItem = document.querySelectorAll('.filter-mobile-item');
                filterMobileItem.forEach(function (item) {
                    item.addEventListener('click', function () {
                        // delete old class
                        filterMobileItem.forEach(function (check) {
                            if (check.dataset.category == item.dataset.category) check.classList.remove('filter-mobile-item_active');
                        }); // add class for sub cat

                        item.classList.add('filter-mobile-item_active');
                        item.firstElementChild.checked = true;
                    });
                });
            };

            var generateLinkFilterMobile = function generateLinkFilterMobile() {
                var sortSelect = document.querySelector('.sort-desktop').nextElementSibling.nextElementSibling;

                if (window.innerWidth <= 350) {
                    sortSelect.style.left = '0px';
                }

                document.querySelector('.show-product').addEventListener('click', function () {
                    var arrLink = [];
                    document.querySelector('.filter__cart').classList.remove('filter__cart_active');
                    document.body.classList.remove('overlay');
                    var filterCartItemShow = document.querySelector('.filter__cart-item_show');
                    if (filterCartItemShow) filterCartItemShow.classList.remove('filter__cart-item_show'); // push link

                    document.querySelectorAll('.filter-mobile-item').forEach(function (item) {
                        if (item.firstElementChild.checked) {
                            arrLink.push(item.dataset.handle);
                        }
                    }); // clear fitler

                    setTimeout(function () {
                        document.querySelectorAll('.filter-mobile-item_active').forEach(function (item) {
                            item.classList.remove('filter-mobile-item_active');
                            item.firstElementChild.checked = false;
                        });
                    }, 1000); // create url

                    if (window.innerWidth <= 767) {
                        sortSelect = '-105px';
                    }

                    filter_filter(arrLink);
                });
            };

            // generate swiper cart
            var createSwiperCart = function createSwiperCart() {
                var swiperCollection;

                function collectionSwiper() {
                    if (window.innerWidth <= 1024) {
                        swiperCollection = new Swiper('.product-swiper', {
                            slidesPerView: 1,
                            allowTouchMove: true,
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true
                            }
                        });
                        swiperCollection.forEach(function (swiperItem) {
                            swiperItem.on('slideChange', function () {
                                var pagination = swiperItem.el.querySelectorAll('.swiper-pagination-bullet');
                                var sliders = swiperItem.el.querySelectorAll('.swiper-slide');
                                setTimeout(function () {
                                    for (var i = 0; i < sliders.length; i++) {
                                        if (sliders[i].classList.contains('swiper-slide-active')) {
                                            pagination.forEach(function (item) {
                                                item.classList.remove('swiper-pagination-bullet-active');
                                            });
                                            pagination[i].classList.add('swiper-pagination-bullet-active');
                                        }
                                    }
                                }, 0);
                            });
                        });
                    } else {
                        if (swiperCollection != undefined) {
                            if (swiperCollection.length > 1) {
                                swiperCollection.forEach(function (item) {
                                    item.destroy(true, true);
                                });
                            } else {
                                swiperCollection.destroy(true, true);
                            }

                            document.querySelectorAll('.swiper-wrapper').forEach(function (item) {
                                item.removeAttribute('style');
                            });
                            setTimeout(function () {
                                document.querySelectorAll('.swiper-slide').forEach(function (slide) {
                                    slide.removeAttribute('style');
                                });
                            }, 0);
                        }
                    }
                }

                collectionSwiper();
                var swiperCart;

                function cartSwiper() {
                    if (window.innerWidth <= 1024) {
                        swiperCart = new Swiper('.cart-container', {
                            // spaceBetween: 10,
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true
                            }
                        });
                    } else {
                        if (swiperCart != undefined) {
                            swiperCart.destroy(true, true);
                        }
                    }
                }

                cartSwiper();
                window.addEventListener('DOMContentLoaded', function () {
                    collectionSwiper();
                    cartSwiper();
                });
                window.addEventListener('resize', function () {
                    setTimeout(function () {
                        collectionSwiper();
                    }, 100);
                    setTimeout(function () {
                        cartSwiper();
                    }, 100);
                });
                window.addEventListener('orientationchange', function () {
                    collectionSwiper();
                    cartSwiper();
                });
            };

            var countTop = function countTop() {
                var header = document.querySelector('.header');
                var filter = document.querySelector('.filter');
                var productColWrapper = document.querySelector('.product-col__wrapper');

                if (window.pageYOffset > 520) {
                    header.classList.remove('active');
                    filter.classList.add('filter__fixed');

                    if (window.innerWidth > 767) {
                        productColWrapper.style.paddingTop = "".concat(filter.offsetHeight + 110, "px");
                        header.classList.add('scroll');
                    } else {
                        productColWrapper.style.paddingTop = "".concat(filter.offsetHeight + 70, "px");
                    }
                } else {
                    header.classList.remove('scroll');
                    filter.classList.remove('filter__fixed');
                    productColWrapper.removeAttribute('style');
                }
            };

            var countGoods = function countGoods() {
                var productColWrapper = document.querySelector('.product-col__wrapper');
                if (document.querySelectorAll('.product-item').length % 3 == 0) productColWrapper.classList.remove('three');else productColWrapper.classList.add('two');
            };

            // PAGINATION**************************
            // paginate
            var addContentOnPage = function addContentOnPage() {
                // product wrapper class
                var productsWrapper = document.querySelector('.product-col__wrapper');
                var tot, cur;
                var dataTotalPages = document.querySelector('[data-total-pages]');
                var dataCurrentPage = document.querySelector('[data-current-page]');
                if (dataTotalPages) tot = dataTotalPages.getAttribute('value');
                if (dataCurrentPage) cur = dataCurrentPage.getAttribute('value') - 1;

                if (cur >= tot) {
                    productsWrapper.classList.add('hideMore');
                } else {
                    productsWrapper.classList.remove('hideMore');
                }

                if (!cur && !tot) productsWrapper.classList.add('hideMore');
                filter_$('.js-load-more').on('click', function () {
                    var productColWrapper = document.querySelector('.product-col__wrapper');
                    var $this = filter_$(this),
                        totalPages = parseInt(filter_$('[data-total-pages]').val()),
                        currentPage = parseInt(filter_$('[data-current-page]').val());
                    $this.attr('disabled', true);
                    $this.find('[load-more-text]').addClass('hide');
                    $this.find('[loader]').removeClass('hide');
                    var nextUrl = filter_$('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
                    filter_$('[data-current-page]').val(currentPage);
                    filter_$.ajax({
                        url: nextUrl,
                        type: 'GET',
                        dataType: 'html',
                        success: function success(responseHTML) {
                            filter_$('.product-col__wrapper').append(filter_$(responseHTML).find('.product-col__wrapper').html());
                            history.pushState({
                                page: nextUrl
                            }, nextUrl, nextUrl);
                            var hiddenBlocks = document.querySelectorAll('.hidden-block');
                            var buttons = document.querySelectorAll('.load-more_wrap');
                            var displayed = document.querySelectorAll('.displayed');
                            var filterCountProduct = document.querySelectorAll('.filter__count-goods');

                            for (var index = 0; index < hiddenBlocks.length - 1; index++) {
                                hiddenBlocks[index].remove();
                            }

                            for (var _index = 0; _index < buttons.length - 1; _index++) {
                                buttons[_index].remove();
                            }

                            for (var _index2 = 0; _index2 < displayed.length - 1; _index2++) {
                                displayed[_index2].remove();
                            }

                            for (var _index3 = 0; _index3 < filterCountProduct.length - 1; _index3++) {
                                filterCountProduct[_index3].remove();
                            }
                        },
                        complete: function complete() {
                            addContentOnPage();

                            if (currentPage >= totalPages) {
                                $this.attr('disabled', false);
                                $this.find('[load-more-text]').removeClass('hide');
                                $this.find('[loader]').addClass('hide');
                                var loadMore = document.querySelector('.load-more_wrap');
                                loadMore.classList.add('load-more_wrap_hidden');
                                document.querySelector('.hidden-block').classList.add('hidden-block_hidden');
                            }

                            countGoodsOnPage();
                            createSwiperCart();
                            clickAddBag();

                            changeImg();
                            deleteFilterOnCart(); // check product

                            if (document.querySelectorAll('.product-item').length % 3 == 0) {
                                productColWrapper.classList.remove('two');
                            }
                        }
                    });
                });
            };

            // count products
            var countGoodsOnPage = function countGoodsOnPage() {
                document.querySelectorAll('.goods-count').forEach(function (item) {
                    item.innerHTML = +document.querySelectorAll('.product-item').length;
                });
                document.querySelector('.progress__inner') && (document.querySelector('.progress__inner').style.width = "".concat(100 / (+document.querySelector('.goods-general').innerHTML / +document.querySelector('.goods-count').innerHTML), "%"));
            };

            window.addEventListener('DOMContentLoaded', changeImg);
            window.addEventListener('resize', changeImg); // normal inner

            var arrUrl = (/* unused pure expression or super */ null && ([]));
            document.querySelectorAll('.select__item').forEach(function (item) {
                item.firstElementChild.nextElementSibling.innerHTML = item.firstElementChild.nextElementSibling.innerHTML.replace('-', ' ');
            }); // filter work

            var objHandle = {
                url: ''
            };
            window.addEventListener('DOMContentLoaded', function () {
                objHandle.url = window.location.pathname;
            });
            clickItem();
            var arrMainUrl = [];
            window.addEventListener('DOMContentLoaded', function () {
                document.querySelectorAll('.select__item').forEach(function (item) {
                    if (window.location.pathname.includes(item.dataset.handle)) {
                        item.classList.add('same-as-selected');
                        checkedInnerHTML(item);
                    }
                });
            });
            var sortSelect = document.querySelector('.sort-select .select-selected');
            sortSelect.addEventListener('click', function (e) {
                this.classList.toggle('active');
            });
            document.body.addEventListener('click', function (e) {
                if (!e.target.classList.contains('sort-select') || e.target.classList.contains('sort-select')) {
                    sortSelect.classList.toggle('active');
                }
            });
            window.addEventListener('DOMContentLoaded', createElementFilters);
            window.addEventListener('DOMContentLoaded', deleteFilterOnCart);
            openFilter();
            closeFilter();
            closeSubCart();
            openSubCart();
            checkBody();
            clickMobileFilter(); // generate link filter mobile

            window.addEventListener('resize', function () {
                var sortSelect = document.querySelector('.sort-desktop').nextElementSibling.nextElementSibling;

                if (window.innerWidth <= 350) {
                    sortSelect.style.left = '0px';
                }

                if (window.innerWidth <= 767 && window.innerWidth > 350) {
                    sortSelect.style.left = '-105px';
                }
            });
            generateLinkFilterMobile();
            createSwiperCart();
            window.addEventListener('DOMContentLoaded', countTop);
            window.addEventListener('scroll', countTop);
            window.addEventListener('DOMContentLoaded', countGoods);
            addContentOnPage();
            window.addEventListener('DOMContentLoaded', function () {
                var totalPages = parseInt(filter_$('[data-total-pages]').val());
                var currentPage = parseInt(filter_$('[data-current-page]').val());

                if (currentPage > totalPages) {
                    var loadMore = document.querySelector('.load-more_wrap');
                    if (loadMore) loadMore.classList.add('load-more_wrap_hidden');
                }
            });
            window.addEventListener('DOMContentLoaded', countGoodsOnPage);
            window.addEventListener('DOMContentLoaded', function () {
                var url;

                if (window.location.href.includes('page=')) {
                    if (window.location.pathname.indexOf('/', 13) && window.location.pathname.includes(':')) {
                        url = window.location.pathname.substr(0, window.location.pathname.indexOf('/', 13));
                    } else {
                        url = window.location.pathname;
                    }
                }

                if (url) {
                    filter_$.ajax({
                        type: 'GET',
                        data: {},
                        url: url,
                        complete: function complete(data) {
                            var wrapper = document.querySelector('.product-col__wrapper');
                            wrapper.classList.add('product-col__wrapper_new');
                            history.pushState({
                                page: url
                            }, url, url);
                            setTimeout(function () {
                                showData(data);
                                filter_$;
                                deleteFilterOnCart();
                                changeImg();
                                createSwiperCart();
                                addContentOnPage();
                                countGoodsOnPage(); // filter item

                                document.querySelectorAll('.filter__item').forEach(function (item) {
                                    item.remove();
                                }); // active filter

                                document.querySelectorAll('.same-as-selected').forEach(function (item) {
                                    item.classList.remove('same-as-selected');
                                    item.firstElementChild.checked = false;
                                }); // clear handle

                                objHandle.url = '';
                                clickAddBag();

                            }, 300);
                            deleteFilterOnCart();
                        }
                    });
                }
            });
        }
        ;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
        function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
            try {
                var info = gen[key](arg);
                var value = info.value;
            } catch (error) {
                reject(error);
                return;
            }

            if (info.done) {
                resolve(value);
            } else {
                Promise.resolve(value).then(_next, _throw);
            }
        }

        function _asyncToGenerator(fn) {
            return function () {
                var self = this,
                    args = arguments;
                return new Promise(function (resolve, reject) {
                    var gen = fn.apply(self, args);

                    function _next(value) {
                        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
                    }

                    function _throw(err) {
                        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
                    }

                    _next(undefined);
                });
            };
        }
// EXTERNAL MODULE: ./node_modules/@babel/runtime/regenerator/index.js
        var regenerator = __webpack_require__(4687);
        var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
        ;// CONCATENATED MODULE: ./src/scripts/common/search.js


        var searchForms = document.querySelectorAll('form[action="/search"]'),
            searchPopup = document.querySelector('.search-popup'),
            searchInput = searchPopup.querySelector('input[name="q"]'),
            triggerClose = document.querySelectorAll('.trigger-close, .search-popup__overlay'),
            fragment = document.createDocumentFragment(),
            htmlWrapper = document.createElement('div'),
            triggerSearchPopup = document.querySelectorAll('.trigger-search-popup');

        if (triggerSearchPopup) {
            triggerSearchPopup.forEach(function (trigger) {
                trigger.addEventListener('click', function () {
                    searchPopup.classList.add('is-open');
                    setTimeout(function () {
                        searchInput.focus();
                    }, 100);
                });
            });
        }

        if (triggerClose) {
            triggerClose.forEach(function (trigger) {
                trigger.addEventListener('click', function (e) {
                    searchPopup.classList.remove('is-open');
                    searchInput.value = '';
                });
            });
        }

        function getSearchResults(_x, _x2) {
            return _getSearchResults.apply(this, arguments);
        }

        function _getSearchResults() {
            _getSearchResults = _asyncToGenerator( /*#__PURE__*/regenerator_default().mark(function _callee(form, term) {
                var data, html, searchUrl, searchLink;
                return regenerator_default().wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                if (!(term !== '')) {
                                    _context.next = 15;
                                    break;
                                }

                                _context.next = 3;
                                return fetch("/search/suggest?q=".concat(term, "&resources[type]=collection,product,article,page&resources[options][unavailable_products]=hide&resources[options][fields]=title,product_type,variants.title&section_id=search-data"));

                            case 3:
                                data = _context.sent;
                                _context.next = 6;
                                return data.text();

                            case 6:
                                html = _context.sent;
                                searchUrl = "/search?type=product&options[unavailable_products]=show&options[prefix]=last&q=".concat(term);
                                htmlWrapper.className = 'search-results-wrapper';
                                htmlWrapper.innerHTML = '';
                                htmlWrapper.innerHTML = html;
                                fragment.appendChild(htmlWrapper);
                                form.appendChild(fragment);
                                searchLink = document.querySelector('.search-results__all a');
                                searchLink && searchLink.setAttribute('href', searchUrl);

                            case 15:
                            case "end":
                                return _context.stop();
                        }
                    }
                }, _callee);
            }));
            return _getSearchResults.apply(this, arguments);
        }

        searchForms.forEach(function (form) {
            var input = form.querySelector('input[name="q"]');
            // input.addEventListener('change', function () {
            //     getJsonSearch && getJsonSearch(form, input.value);
            // });
            input.addEventListener('keyup', function () {
                getSearchResults(form, input.value);
            });
            input.addEventListener('focus', function () {
                var searchResult = form.querySelector('.search-results');
                if (searchResult && input.value !== '') searchResult.classList.remove('hide');
            });
        });
        document.body.addEventListener('click', function (e) {
            var searchResult = document.querySelector('.search-results');
            if (!e.target.classList.contains('search-input') || !e.target.classList.contains('search-results__all')) searchResult ? searchResult.classList.add('hide') : null;
        });
// EXTERNAL MODULE: ./src/scripts/common/scripts-section.js
        var scripts_section = __webpack_require__(6540);
// EXTERNAL MODULE: ./src/scripts/common/collection-banner.js
        var collection_banner = __webpack_require__(1266);
// EXTERNAL MODULE: ./src/scripts/common/out-stores/our-stores.js
        var our_stores = __webpack_require__(7964);
        ;// CONCATENATED MODULE: ./src/scripts/common/search/search-page.js
        /* provided dependency */ var search_page_$ = __webpack_require__(5825);


        if (document.body.classList.contains('template-search')) {
            var exitAll = function exitAll() {
                var searchResult = document.querySelector('.search-results');
                if (searchResult) searchResult.classList.add('hide');
                document.body.classList.remove('overlay');
                exit.classList.remove('exit-form_show');
                productCart.classList.remove('product__cart_active');
                ajaxCart.classList.remove('is-open');
            }; // click input


            var search_page_countGoodsOnPage = function countGoodsOnPage() {
                document.querySelector('.progress__inner').style.width = "".concat(100 / (+goodsGeneral.innerHTML / +document.querySelectorAll('.product-item').length), "%");
            };

            var search_page_createSwiperCart = function createSwiperCart() {
                var swiperCollection;

                function collectionSwiper() {
                    if (window.innerWidth <= 1024) {
                        swiperCollection = new Swiper('.product-swiper', {
                            slidesPerView: 1,
                            allowTouchMove: true,
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true
                            }
                        });
                    } else {
                        if (swiperCollection != undefined) {
                            swiperCollection.forEach(function (item) {
                                item.destroy(true, true);
                            });
                            document.querySelectorAll('.swiper-wrapper').forEach(function (item) {
                                item.removeAttribute('style');
                            });
                            setTimeout(function () {
                                document.querySelectorAll('.swiper-slide').forEach(function (slide) {
                                    slide.removeAttribute('style');
                                });
                            }, 0);
                        }
                    }
                }

                collectionSwiper();
                var swiperCart;

                function cartSwiper() {
                    if (window.innerWidth <= 1024) {
                        swiperCart = new Swiper('.cart-container', {
                            // spaceBetween: 10,
                            slidesPerView: 1,
                            slidesPerGroup: 1,
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'bullets',
                                clickable: true
                            }
                        });
                    } else {
                        if (swiperCart != undefined) {
                            swiperCart.destroy(true, true);
                        }
                    }
                }

                cartSwiper();
                window.addEventListener('DOMContentLoaded', function () {
                    collectionSwiper();
                    cartSwiper();
                });
                window.addEventListener('resize', function () {
                    setTimeout(function () {
                        collectionSwiper();
                    }, 100);
                    setTimeout(function () {
                        cartSwiper();
                    }, 100);
                });
                window.addEventListener('orientationchange', function () {
                    collectionSwiper();
                    cartSwiper();
                });
            };

            var search_page_changeImg = function changeImg() {
                document.querySelectorAll('.product-item').forEach(function (item) {
                    item.addEventListener('mouseover', function () {
                        if (item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.nextElementSibling) {
                            if (window.innerWidth > 1024) {
                                item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.add('swiper-slide-hide');
                                item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.classList.add('swiper-slide-show');
                            }
                        }
                    });
                    item.addEventListener('mouseout', function () {
                        if (item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.nextElementSibling) {
                            if (window.innerWidth > 1024) {
                                item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.nextElementSibling.classList.remove('swiper-slide-show');
                                item.firstElementChild.firstElementChild.firstElementChild.firstElementChild.classList.remove('swiper-slide-hide');
                            }
                        }
                    });
                });
            };

            var search_page_addContentOnPage = function addContentOnPage() {
                // product wrapper class
                var productsWrapper = document.querySelector('.product-col__wrapper');
                var tot, cur;
                var dataTotalPages = document.querySelector('[data-total-pages]');
                var dataCurrentPage = document.querySelector('[data-current-page]');
                if (dataTotalPages) tot = dataTotalPages.getAttribute('value');
                if (dataCurrentPage) cur = dataCurrentPage.getAttribute('value') - 1;

                if (cur >= tot) {
                    productsWrapper.classList.add('hideMore');
                } else {
                    productsWrapper.classList.remove('hideMore');
                }

                if (!cur && !tot) productsWrapper.classList.add('hideMore');
                search_page_$('.js-load-more').on('click', function () {
                    var $this = search_page_$(this),
                        totalPages = parseInt(search_page_$('[data-total-pages]').val()),
                        currentPage = parseInt(search_page_$('[data-current-page]').val());
                    $this.attr('disabled', true);
                    $this.find('[load-more-text]').addClass('hide');
                    $this.find('[loader]').removeClass('hide');
                    var nextUrl = search_page_$('[data-next-url]').val().replace(/page=[0-9]+/, 'page=' + currentPage);
                    search_page_$('[data-current-page]').val(currentPage);
                    search_page_$.ajax({
                        url: nextUrl,
                        type: 'GET',
                        dataType: 'html',
                        success: function success(responseHTML) {
                            search_page_$('.product-col__wrapper').append(search_page_$(responseHTML).find('.product-col__wrapper').html());
                            history.pushState({
                                page: nextUrl
                            }, nextUrl, nextUrl);
                            var hiddenBlocks = document.querySelectorAll('.hidden-block');
                            var buttons = document.querySelectorAll('.load-more_wrap');
                            var displayed = document.querySelectorAll('.displayed');
                            var filterCountProduct = document.querySelectorAll('.filter__count-goods');

                            for (var index = 0; index < hiddenBlocks.length - 1; index++) {
                                hiddenBlocks[index].remove();
                            }

                            for (var _index = 0; _index < buttons.length - 1; _index++) {
                                buttons[_index].remove();
                            }

                            for (var _index2 = 0; _index2 < displayed.length - 1; _index2++) {
                                displayed[_index2].remove();
                            }

                            for (var _index3 = 0; _index3 < filterCountProduct.length - 1; _index3++) {
                                filterCountProduct[_index3].remove();
                            }
                        },
                        complete: function complete() {
                            var totalPages = document.querySelector('[data-total-pages]').getAttribute('value');
                            var currentPage = document.querySelector('[data-current-page]').getAttribute('value');
                            addContentOnPage();
                            console.log('total page', totalPages);
                            console.log('current page', currentPage);

                            if (currentPage >= totalPages + 1) {
                                $this.attr('disabled', false);
                                $this.find('[load-more-text]').removeClass('hide');
                                $this.find('[loader]').addClass('hide');
                                var loadMore = document.querySelector('.load-more_wrap');
                                loadMore.classList.add('load-more_wrap_hidden');
                                document.querySelector('.hidden-block').classList.add('hidden-block_hidden');
                            }

                            search_page_countGoodsOnPage();
                            clickAddBag();

                            search_page_changeImg();
                            checkWrapper();
                            search_page_createSwiperCart();
                            checkEmptyFilter();
                        }
                    });
                });
            };

            var checkWrapper = function checkWrapper() {
                var elementCount = document.querySelectorAll('.product-item').length;
                var goodsGeneral = document.querySelector('.goods-general');
                var onPageCount = document.querySelector('.goods-count');
                onPageCount.innerHTML = elementCount;
                goodsGeneral.innerHTML = goodsGeneral.innerHTML;
                var elementWrapper = document.querySelector('.product-col__wrapper');
                if (elementCount % 3 == 0) elementWrapper.classList.remove('two');else elementWrapper.classList.add('two'); // check wrapper

                if (elementCount < goodsGeneral.innerHTML) {
                    elementWrapper.classList.remove('hideMore');
                }
            };

            var checkEmptyFilter = function checkEmptyFilter() {
                document.querySelectorAll('.filter-').forEach(function (item) {
                    item.remove();
                });
                document.querySelectorAll('.filter-featured-').forEach(function (item) {
                    item.remove();
                });
            };

            var checkUrl = function checkUrl() {
                var url;

                if (window.location.href.includes('page=')) {
                    var indexPage = window.location.href.indexOf('page=');
                    var indexEnd = window.location.href.indexOf('&', indexPage);
                    url = window.location.href.substr(0, indexPage) + window.location.href.substr(indexEnd + 1);
                    search_page_$.ajax({
                        type: 'GET',
                        url: url,
                        data: {},
                        complete: function complete(data) {
                            history.pushState({
                                page: url
                            }, url, url);
                            search_page_$('.product-col__wrapper').html(search_page_$('.product-col__wrapper', data.responseText).html());
                            search_page_$('.product-col__wrapper').removeClass('product-col__wrapper_new');
                            search_page_$('.wrapper-goods').html(search_page_$('.wrapper-goods', data.responseText).html());
                            search_page_countGoodsOnPage();
                            checkWrapper();
                            checkEmptyFilter();
                            search_page_addContentOnPage();
                            clickAddBag();

                        }
                    });
                }
            };

            var goodsGeneral = document.querySelector('.count-goods');
            var onPageCount = document.querySelector('.goods-count');
            var search_page_searchInput = document.querySelector('.search-input');
            var exit = document.querySelector('.exit-form');
            var productCart = document.querySelector('.product__cart');
            var ajaxCart = document.querySelector('.ajax-cart');
            search_page_searchInput.addEventListener('click', function () {
                document.body.classList.add('overlay');
                exit.classList.add('exit-form_show');
            });
            exit.addEventListener('click', exitAll);
            document.body.addEventListener('click', function (e) {
                console.log('e', e.target);

                if (e.target.classList.contains('template-search')) {
                    exitAll();
                }
            });
            document.querySelector('.goods-general').innerHTML = goodsGeneral.innerHTML;
            search_page_createSwiperCart();
            window.addEventListener('DOMContentLoaded', search_page_changeImg);
            window.addEventListener('resize', search_page_changeImg);
            search_page_addContentOnPage();
            document.addEventListener('DOMContentLoaded', function () {
                search_page_countGoodsOnPage();
                checkWrapper();
                checkEmptyFilter();
                checkUrl();
            });
        }
// EXTERNAL MODULE: ./src/scripts/common/generic/generic.js
        var generic = __webpack_require__(1523);
// EXTERNAL MODULE: ./src/scripts/common/collections-list/collections-list.js
        var collections_list = __webpack_require__(6153);
        ;// CONCATENATED MODULE: ./src/scripts/common/404-page/page-error.js


        if (document.body.classList.contains('template-404')) {
            var checkMobile = function checkMobile() {
                if (window.innerWidth <= 425) banner.classList.add('error-mobile');else banner.classList.remove('error-mobile');
            };

            var banner = document.querySelector('.error');
            window.addEventListener('resize', checkMobile);
            window.addEventListener('orientalchange', checkMobile);
            document.addEventListener('DOMContentLoaded', checkMobile);
        }
        ;// CONCATENATED MODULE: ./src/scripts/custom.js












        // collection page


        // import './common/product-cart.js'
// scripts



        // search

        // generic

        // collections list

        // 404 page


        ;// CONCATENATED MODULE: ./node_modules/swiper/swiper-bundle.css
// extracted by mini-css-extract-plugin

// EXTERNAL MODULE: ./node_modules/lazysizes/lazysizes.js
        var lazysizes = __webpack_require__(7090);
// EXTERNAL MODULE: ./node_modules/lazysizes/plugins/parent-fit/ls.parent-fit.js
        var ls_parent_fit = __webpack_require__(1770);
// EXTERNAL MODULE: ./node_modules/lazysizes/plugins/rias/ls.rias.js
        var ls_rias = __webpack_require__(1035);
        ;// CONCATENATED MODULE: ./src/index.js






    })();

    /******/ })()
;
